import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  ObjectId: { input: any; output: any; }
  StringFloatInt: { input: any; output: any; }
};

export type AddNewAssemblyTagNameInput = {
  isNewlyAdded?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedFor: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
};

export type AddPartsToAssemblyInput = {
  /** Object Id for Assembly to add Parts to */
  assemblyId: Scalars['ID']['input'];
  /** Object Ids of parts to link to assembly */
  partIds: Array<Scalars['ID']['input']>;
  /** Object Id for the structure this assembly belongs to */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddRemoveStructuresToFromUserGroupsInput = {
  structureIds: Array<Scalars['ID']['input']>;
  userGroupIds: Array<Scalars['ID']['input']>;
};

export type AddRemoveUsersToFromUserGroupInput = {
  userGroupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type AddUpdateCuboidInput = {
  cuboidClassId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  position: Array<Scalars['Float']['input']>;
  rotation: Array<Scalars['Float']['input']>;
  scale: Array<Scalars['Float']['input']>;
  structureId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

export type AddUpdateSplitCuboidOnPartInput = {
  /** Object Id of part to add cuboid to */
  partId: Scalars['ID']['input'];
  /** Object Id for the cuboid to update */
  splitCuboid: SplitCuboidInput;
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddUpdateSplitCuboidOnPartNotification = {
  __typename?: 'AddUpdateSplitCuboidOnPartNotification';
  /** Object Id of part to add cuboid to */
  partId: Scalars['ID']['output'];
  /** Split Cuboid to add or update */
  splitCuboid: SplitCuboid;
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['output'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export type AlarmLevelRecommendation = {
  __typename?: 'AlarmLevelRecommendation';
  /** Any supplementary comments about the recommendation for this assembly from initial analysis by the reviewer */
  additionalComments?: Maybe<Scalars['String']['output']>;
  /** Recommended alarm level after analysis stage, valid values: see alarm levels enum */
  alarmLevel: AlarmLevels;
  /** Any supplementary comments about the recommendation for this assembly that is only relevant to the internal team */
  internalTeamComments?: Maybe<Scalars['String']['output']>;
  /**
   * User id of the user in charge of analysis/review/finalization of this assembly,
   * equivalent to user_id in Auth0 user profile and sub claim in the jwt
   */
  recommendationByUser?: Maybe<User>;
  /** User name of the user in charge of analysis/review/finalization of this assembly, */
  recommendationByUserName?: Maybe<Scalars['String']['output']>;
  /** Comment about the recommendation for this assembly from initial analysis from a standardised set of supporting comments */
  supportingComment?: Maybe<Scalars['String']['output']>;
  /** Whether the alarm level was manually updated for subjective reasons to override the alarm level that was automatically calculated based on governing value */
  wasAnalysisAlarmLevelManuallySet?: Maybe<Scalars['Boolean']['output']>;
};

export type AlarmLevelRecommendationInput = {
  additionalComments?: InputMaybe<Scalars['String']['input']>;
  alarmLevel: AlarmLevels;
  internalTeamComments?: InputMaybe<Scalars['String']['input']>;
  supportingComment?: InputMaybe<Scalars['String']['input']>;
};

export type AlarmLevelSummaryInput = {
  platformId?: InputMaybe<Scalars['ID']['input']>;
  structureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AlarmLevelSummaryResult = {
  __typename?: 'AlarmLevelSummaryResult';
  _id: Scalars['ID']['output'];
  structureId: Scalars['ID']['output'];
  structureName: Scalars['String']['output'];
  total: Array<TypeAndCount>;
};

export enum AlarmLevels {
  BorderlineLevel_1Or_2 = 'BORDERLINE_LEVEL_1_OR_2',
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2',
  Level_3 = 'LEVEL_3',
  None = 'NONE'
}

export type AllCommentsInput = {
  collectionName: Scalars['String']['input'];
  referenceId: Scalars['ID']['input'];
  structureId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AllStructuresByRegion = {
  __typename?: 'AllStructuresByRegion';
  defectArea: Array<DefectArea>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  structures: Array<StructureWithDefects>;
};

export type Analysed = {
  __typename?: 'Analysed';
  /** User who analysed this Part */
  analysedBy: Scalars['ID']['output'];
  /** Last time this Part was analysed */
  updatedAt: Scalars['String']['output'];
};

export type Analytics = {
  __typename?: 'Analytics';
  /** Date this analytics record was created */
  createdAt: Scalars['String']['output'];
  /** Analytics data stored as JSON */
  data: Scalars['JSON']['output'];
  /** Display configuration metadata for graphs or views */
  displayConfig?: Maybe<Scalars['JSON']['output']>;
  /** Unique Analytics ID */
  id: Scalars['ID']['output'];
  /** Structures that this analytics data relates to */
  structureIds: Array<Scalars['ID']['output']>;
  /** Type of analytics data */
  type: Scalars['String']['output'];
  /** Date this analytics record was last updated */
  updatedAt: Scalars['String']['output'];
};

export type AnalyticsFiltersInput = {
  structureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: Array<Scalars['String']['input']>;
};

export type Annotation = {
  __typename?: 'Annotation';
  /** Integer ID of this Annotation in point cloud */
  annotationId: Scalars['Float']['output'];
  /** Unique Annotation ID */
  id: Scalars['ID']['output'];
  /** Location that this Annotation belongs to */
  location: Location;
  locationId?: Maybe<Scalars['ID']['output']>;
  /** Overlap info related to part Annotation */
  overlapInfo?: Maybe<OverlapInfo>;
  /** Part that this Annotation belongs to */
  part?: Maybe<Part>;
  partId?: Maybe<Scalars['ID']['output']>;
  processingReferences?: Maybe<ProcessingReferences>;
  /** Structure that this Annotation belongs to */
  structure: Structure;
  structureId?: Maybe<Scalars['ID']['output']>;
  /** Assembly template that this Annotation is linked to */
  templateId: Template;
};

export type AnomalyCount = {
  __typename?: 'AnomalyCount';
  count?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type AreaAndType = {
  __typename?: 'AreaAndType';
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type AssembliesFilterInput = {
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedPaintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedWorkpackIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

/** An Assembly of Parts that facilitates some operation in the Structure. */
export type Assembly = {
  __typename?: 'Assembly';
  /**
   * Total surface area of the assembly in sq ft.
   * TODO: this should be deprecated, included in the templateFieldData
   */
  area?: Maybe<Scalars['Float']['output']>;
  /** Visibility Box of this Assembly */
  box?: Maybe<Box>;
  /**
   * Relative resource path to the cad model of the assembly.
   * Relative to structure.assemblyCadModelsBasePath
   */
  cadModelPath?: Maybe<Scalars['String']['output']>;
  /**
   * An alternative for focal point to define the camera position and point to look at (focal point) to view this assembly.
   * When a user selects an assembly the camera pose will be set to this value (position and look at point).
   */
  cameraPose?: Maybe<AssemblyCameraPose>;
  /**
   * Maximum corrosion level across all parts belonging to this assembly,
   * this aggregate value is stored here for convenience as it is a frequently queried value when filtering assemblies,
   * valid values: HEAVY, MODERATE, LIGHT, CLEAN
   * TODO: this should be deprecated, included in the templateFieldData
   */
  corrosionLevel?: Maybe<Scalars['String']['output']>;
  /** Date this Assembly was created */
  createdAt: Scalars['String']['output'];
  /**
   * Deck detail of assembly. A single assembly can be a part of multiple decks.
   * decks would contain the deckId in which this assembly exist and area that assembly occupied on that deck.
   */
  decks?: Maybe<Array<Maybe<DecksDetails>>>;
  /** Files attached to assembly */
  files?: Maybe<Array<File>>;
  /**
   * This is used to help a user focus on a selected assembly as they navigate around the spatial viewer.
   * When a user selects an assembly the camera will look at this point.
   * This is superseded if cameraPose it defined.
   */
  focalPoint?: Maybe<Vector3>;
  /** Unique Assembly ID */
  id: Scalars['ID']['output'];
  /** Integer ID of this Assembly in point cloud data */
  integerId?: Maybe<Scalars['Float']['output']>;
  /**
   * If the assembly is newly added by the admin than this flag would
   * be set to true.
   *
   * This  boolean can be used to differentiate between the predefined
   * assembly from newly added assembly
   */
  isNewlyAdded?: Maybe<Scalars['Boolean']['output']>;
  /** A boolean for whether the assembly is contextualized or not. This will be true if assembly is made manually */
  isUncontextualized?: Maybe<Scalars['Boolean']['output']>;
  /** Auth0 ID of the user who last updated this assembly */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Tagname that is fixed via some process, e.g. Fabric line fixing or manual by Linears */
  originalTagname?: Maybe<Scalars['String']['output']>;
  /**
   * Pipe specification related to this assembly, used for calculating the effect of corrosion on this assembly and
   * Abyss' subsequent recommendation
   * TODO: this should be deprecated, included in the templateFieldData
   */
  pipeSpec?: Maybe<PipeSpec>;
  /**
   * Abyss' recommendations for this particular assembly,
   * currently just one recommendation object per assembly because "structure" currently means scan/deployment,
   * and there would only be one recommendation per scan/deployment
   */
  recommendation?: Maybe<Recommendation>;
  /**
   * All the viewpoints that can see any portion of this assembly,
   * calculated from viewpoints that can see parts belonging to this assembly, stored here for convenience
   */
  seenByViewpoints?: Maybe<Array<SeenByViewpoint>>;
  /**
   * Service that this piece of equipment provides, for oil & gas this the content of an assembly
   * e.g. fuel gas, sewage water. This helps priorities assemblies for analysis and reporting
   * TODO: this should be deprecated, included in the templateFieldData
   */
  service?: Maybe<Service>;
  /** Identifier for the Structure that this Assembly belongs to */
  structure: Structure;
  /**
   * Super category of the assembly
   * TODO: this should be deprecated, included in the templateFieldData
   */
  superCategory?: Maybe<Scalars['String']['output']>;
  /** User readable identifier for the Assembly */
  tagName: Scalars['String']['output'];
  /** Template related to this assembly for dynamic data */
  template: Template;
  /** Data values from template for this assembly */
  templateFieldData?: Maybe<Scalars['JSON']['output']>;
  /** Date this Assembly was last updated */
  updatedAt: Scalars['String']['output'];
};

export type AssemblyCameraPose = {
  __typename?: 'AssemblyCameraPose';
  lookAt: Vector3;
  position: Vector3;
};

export type AssemblyImageCaptionInput = {
  assemblyAttachmentId: Scalars['String']['input'];
  assemblyId: Scalars['ID']['input'];
  caption: Scalars['String']['input'];
  lastModifiedFor: Scalars['String']['input'];
};

export type AssemblyPaintRegion = {
  __typename?: 'AssemblyPaintRegion';
  /** Assembly that this Paint Block belongs to */
  assembly?: Maybe<Assembly>;
  assemblyId?: Maybe<Scalars['ID']['output']>;
  /** Date this Paint Block was created */
  createdAt: Scalars['String']['output'];
  /** Deck that this Paint Region belongs to */
  deck?: Maybe<Deck>;
  deckId?: Maybe<Scalars['ID']['output']>;
  /** Unique Paint Block ID */
  id: Scalars['ID']['output'];
  /** Paint Region that this paint block data belongs to */
  paintRegion?: Maybe<PaintRegion>;
  paintRegionId?: Maybe<Scalars['ID']['output']>;
  /** POI type based count maintaining key-value pairs as JSON */
  poiTypeCount?: Maybe<Scalars['JSON']['output']>;
  /** Date when remediation is planned or completed */
  remediationAt?: Maybe<Scalars['String']['output']>;
  /** Risk remediation score configuration */
  riskRemediationScore?: Maybe<RiskRemediationScore>;
  /** Status of the Assembly Paint Region */
  status?: Maybe<PaintRegionStatus>;
  /** Identifier for the Structure that this Paint Block belongs to */
  structure?: Maybe<Structure>;
  structureId?: Maybe<Scalars['ID']['output']>;
  /** Template related to this paint block for dynamic data */
  template?: Maybe<Template>;
  /** Data values from template for this paint block */
  templateData?: Maybe<Array<TemplateData>>;
  templateFieldData?: Maybe<Scalars['JSON']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
  /** Date this Paint Block was last updated */
  updatedAt: Scalars['String']['output'];
};

export type AssemblySummary = {
  __typename?: 'AssemblySummary';
  data?: Maybe<Scalars['JSON']['output']>;
  displayConfig?: Maybe<Array<DisplaySettings>>;
  displayType: DisplayType;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  rowOrder: Scalars['Int']['output'];
};

export type AssemblyTagNameAdded = {
  __typename?: 'AssemblyTagNameAdded';
  id: Scalars['ID']['output'];
  isNewlyAdded: Scalars['Boolean']['output'];
  structureId: Scalars['ID']['output'];
  tagName: Scalars['String']['output'];
};

export type AssemblyTemplateField = TemplateField & {
  __typename?: 'AssemblyTemplateField';
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: Maybe<LogicEvaluationRule>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Dependent field keys */
  dependencyMapping?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: Maybe<Scalars['String']['output']>;
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  /** Identify if field should be shown in the query tab */
  displayInQuery?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be displayed in report */
  displayInReports?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be visible in review */
  displayInReview?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the risk assessment tab */
  displayInRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the equipment table */
  displayInTable?: Maybe<Scalars['Boolean']['output']>;
  /** Unit to display the actual value in */
  displayUnit?: Maybe<UnitsEnum>;
  /** Roles that the user needs to have to edit template data */
  editRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  /** Specifies if field allows editing or not */
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if a risk field can be exported */
  isExportable?: Maybe<Scalars['Boolean']['output']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Should not be shown in the UI. Used for identifying risk assessment filters */
  isRiskAssessment?: Maybe<Scalars['Boolean']['output']>;
  /** Key to identify field in the risk fields */
  key?: Maybe<Scalars['String']['output']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: Maybe<LogicEvaluationRule>;
  /** Name of this Template Field */
  name: Scalars['String']['output'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['output']>;
  /** Details of valid options for this Template Field value */
  optionsData?: Maybe<Array<OptionData>>;
  /** Type of permission that a user have to read the template */
  permission?: Maybe<Scalars['String']['output']>;
  /** Identify fixed decimal place */
  roundToDecimal?: Maybe<Scalars['Int']['output']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: Maybe<Scalars['Boolean']['output']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: Maybe<UnitsEnum>;
};

export type AssemblyTemplateFieldDataInput = {
  tagName: Scalars['String']['input'];
  templateFieldData: Array<TemplateFieldDataValues>;
};

export type AssemblyUpdatedEventResult = {
  __typename?: 'AssemblyUpdatedEventResult';
  id: Scalars['String']['output'];
  structureId: Scalars['String']['output'];
  templateFieldData?: Maybe<Array<Scalars['JSON']['output']>>;
  templateId: Scalars['String']['output'];
};

export type AssessmentDetailOptionFieldSchema = {
  __typename?: 'AssessmentDetailOptionFieldSchema';
  editRoles: Array<Maybe<Scalars['String']['output']>>;
  /** Unique human-readable key. It should be same as field key in template */
  fieldKey: Scalars['String']['output'];
  /** Unique Assessment Detail Field */
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  /** Name associated for the Assessment Detail option field */
  name: Scalars['String']['output'];
  /** Type associated with the Equipment option field */
  type: OptionFieldTypeEnum;
};

export type AssessmentDetails = {
  __typename?: 'AssessmentDetails';
  /** Unique Assessment Detail Section ID */
  id: Scalars['ID']['output'];
  /** Is this Assessment Detail Section visible */
  isVisible: Scalars['Boolean']['output'];
  /** Name of this Assessment Detail Section */
  name: Scalars['String']['output'];
  /** Valid options for this Assessment Details Section */
  options: Array<AssessmentDetailOptionFieldSchema>;
  /** Order of the Assessment Details Section */
  position: Scalars['Int']['output'];
  /** Type of this Assessment Detail Section */
  type: Scalars['String']['output'];
};

export type AssessmentDetailsInput = {
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type AssignRemoveRoleToFromUsersInput = {
  roleId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type Auth0UserRoles = {
  __typename?: 'Auth0UserRoles';
  auth0Id?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
};

export type BenchmarkDownloadInput = {
  size: Scalars['Int']['input'];
};

export type BenchmarkDownloadOutput = {
  __typename?: 'BenchmarkDownloadOutput';
  data: Scalars['String']['output'];
};

export type BenchmarkUploadInput = {
  data: Scalars['String']['input'];
};

/** Benchmark provides API to upload and download data for network benchmark. */
export type BenchmarkUploadOutput = {
  __typename?: 'BenchmarkUploadOutput';
  size: Scalars['Int']['output'];
};

export type Blister = {
  __typename?: 'Blister';
  /** Angle of the defect from the camera location (in degrees) */
  angle?: Maybe<Scalars['Float']['output']>;
  /**
   * Borders that make up the polygon where the blister was measured from
   * - specifically for display within a spherical image viewpoint
   */
  borders: Array<Maybe<PolarPoint>>;
  /**
   * 3d Borders consisting of one or more polygons of the area where the blister was
   * measured from in 3d space. Multiple polygons may be returned, for example when
   * the blister surface is obstructed by a separate pipe in the foreground of the
   * depth image
   */
  borders3d: Array<Polygon3d>;
  /** Blister center (texture coordinates, see convertImagePointsToPolarPoints) */
  centerPoint: PolarPoint;
  /** Defect Id */
  defectId?: Maybe<Scalars['Int']['output']>;
  /** Degree of rusting */
  degreeOfRusting?: Maybe<Scalars['Int']['output']>;
  /** Distance of the defect from the camera location (in meters) */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Estimated height of the blister (in millimetres) */
  estimatedHeight: Scalars['Float']['output'];
  /**
   * Radius used for fitting, this is a larger area around the blister so that
   * there is more flat surface for us to figure out the actual surface of the
   * object, currently defaults to a ratio of 1.33x blister radius (in millimetres)
   */
  fittingRadius: Scalars['Float']['output'];
  /** Height type */
  heightType?: Maybe<BlisterHeightType>;
  /** Flag to indicate if the System height type is manually overridden */
  isManuallyOverridden?: Maybe<Scalars['Boolean']['output']>;
  /** Manually set height of the blister (in millimetres) */
  manualSetHeight?: Maybe<Scalars['Float']['output']>;
  /** Maximum height of the blister (in millimetres) */
  maxHeight?: Maybe<Scalars['Float']['output']>;
  /** PDR height of the blister (in millimetres) */
  pdrHeight?: Maybe<Scalars['Float']['output']>;
  /** Radius calculated based on centerPoint and radiusPoint (in millimetres) */
  radius: Scalars['Float']['output'];
  /** Radius of a blister is measured from blister center to this point (texture coordinates) */
  radiusPoint: PolarPoint;
  /**  Residual corrosion allowance */
  residualCorrosionAllowance?: Maybe<ValueAndPercentage>;
  /** Residual thickness */
  residualThickness?: Maybe<ValueAndPercentage>;
  /** SC Category of Blister */
  scCategory?: Maybe<Scalars['String']['output']>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
  /** Verified maximum blister height */
  verifiedMaxHeight?: Maybe<Scalars['String']['output']>;
  /** Verified Residual Thickness */
  verifiedResidualThickness?: Maybe<Scalars['String']['output']>;
  /** Wall loss */
  wallLoss?: Maybe<ValueAndPercentage>;
};

export type BlisterHeightMeasurement = {
  __typename?: 'BlisterHeightMeasurement';
  /** Blister height measurements */
  blister: BlisterHeightMeasurementResult;
  /** Signed URL of Location depth image used to calculate line distance */
  id: Scalars['String']['output'];
  /** Blister height measurements API status */
  status: MeasurementStatus;
};

export type BlisterHeightMeasurementResult = {
  __typename?: 'BlisterHeightMeasurementResult';
  blisterProfilePlotPoints: Array<BlisterProfilePlotPoint>;
  borders3d: Array<Polygon3d>;
  centerPoint3d: Vector3;
  fittedSurfacePoints: Array<Point>;
  /** The max difference from the estimated height in metres */
  maxHeight: Scalars['Float']['output'];
};

export enum BlisterHeightType {
  BlisterTool = 'BLISTER_TOOL',
  Manual = 'MANUAL',
  Pdr = 'PDR',
  Uncertain = 'UNCERTAIN'
}

export type BlisterInput = {
  /** Angle of the defect from the camera location (in degrees) */
  angle?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Borders that make up the polygon where the blister was measured from
   * - specifically for display within a spherical image viewpoint
   */
  borders: Array<InputMaybe<PolarPointInput>>;
  /**
   * 3d Borders consisting of one or more polygons of the area where the blister was
   * measured from in 3d space. Multiple polygons may be returned, for example when
   * the blister surface is obstructed by a separate pipe in the foreground of the
   * depth image
   */
  borders3d: Array<Polygon3dInput>;
  /** Blister center */
  centerPoint: PolarPointInput;
  /** Defect Id */
  defectId?: InputMaybe<Scalars['Int']['input']>;
  /** Degree of rusting */
  degreeOfRusting?: InputMaybe<Scalars['Int']['input']>;
  /** Distance of the defect from the camera location (in meters) */
  distance?: InputMaybe<Scalars['Float']['input']>;
  /** Estimated height of the blister (in millimetres) */
  estimatedHeight?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Radius used for fitting, this is a larger area around the blister so that
   * there is more flat surface for us to figure out the actual surface of the
   * object, currently defaults to a ratio of 1.33x blister radius (in millimetres)
   */
  fittingRadius: Scalars['Float']['input'];
  /** Height type */
  heightType?: InputMaybe<BlisterHeightType>;
  /** Flag to indicate if the System height type is manually overridden */
  isManuallyOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Manually set height of the blister (in millimetres) */
  manualSetHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum height of the blister (in millimetres) */
  maxHeight?: InputMaybe<Scalars['Float']['input']>;
  /** PDR height of the blister (in millimetres) */
  pdrHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Radius calculated based on centerPoint and radiusPoint (in millimetres) */
  radius: Scalars['Float']['input'];
  /** Radius of a blister is measured from blister center to this point */
  radiusPoint: PolarPointInput;
  /**  Residual corrosion allowance */
  residualCorrosionAllowance?: InputMaybe<ValueAndPercentageInput>;
  /** Residual thickness */
  residualThickness?: InputMaybe<ValueAndPercentageInput>;
  /** SC Category of Blister */
  scCategory?: InputMaybe<Scalars['String']['input']>;
  /** URL */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Verified maximum blister height */
  verifiedMaxHeight?: InputMaybe<Scalars['String']['input']>;
  /** Verified Residual Thickness */
  verifiedResidualThickness?: InputMaybe<Scalars['String']['input']>;
  /** Wall loss */
  wallLoss?: InputMaybe<ValueAndPercentageInput>;
};

export type BlisterMeasurementInput = {
  centerPoint: ImagePointInput;
  edgePoint: ImagePointInput;
};

export type BlisterProfilePlotPoint = {
  __typename?: 'BlisterProfilePlotPoint';
  /** Distance from the estimated height in metres */
  height: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

export type BoundingBoxInput = {
  max: CenterPoint;
  min: CenterPoint;
};

export type Box = {
  __typename?: 'Box';
  /** Max Vector3 point of this Box */
  max: Vector3;
  /** Min Vector3 point of this Box */
  min: Vector3;
};

export type BulkCreateForAssembliesInput = {
  clearPreviousComments?: InputMaybe<Scalars['Boolean']['input']>;
  collectionName: Scalars['String']['input'];
  comments: Array<CommentFieldsInput>;
  excludedAssemblyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  referenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  selectedFilters?: InputMaybe<Array<InputMaybe<RiskAssessmentSelectedFiltersInput>>>;
  structureId: Scalars['ID']['input'];
  updateAllAssemblies: Scalars['Boolean']['input'];
};

export type BulkCreateOrUpdateCommentsForAssemblies = {
  __typename?: 'BulkCreateOrUpdateCommentsForAssemblies';
  insertedCount: Scalars['Float']['output'];
  modifiedCount: Scalars['Float']['output'];
  upsertedCount: Scalars['Float']['output'];
};

export type BulkLineFixingInput = {
  csv: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type BulkLineFixingResult = {
  __typename?: 'BulkLineFixingResult';
  message: Scalars['String']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type BulkPipeSpecUploadInput = {
  csv: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  validateOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkPipeSpecUploadResponse = {
  __typename?: 'BulkPipeSpecUploadResponse';
  message: Scalars['String']['output'];
  onlyValidated: Scalars['Boolean']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type BulkServiceGroupsResponse = {
  __typename?: 'BulkServiceGroupsResponse';
  message: Scalars['String']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type BulkUpdateReviewActionInput = {
  accessibility?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  action: Scalars['String']['input'];
  componentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deckRelativeHeight?: InputMaybe<Array<InputMaybe<RangeInput>>>;
  excludePoisWithWorkpack?: InputMaybe<Scalars['Boolean']['input']>;
  includeManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionPriorityTemplateFieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isGoverning?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isManuallyCreated?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isVerified?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  mediaAttachment?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  paintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paintRegionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  pointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedPoiFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId: Scalars['ID']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
  unAssignedPoi?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  workpackIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type BulkUpdateReviewActionResponse = {
  __typename?: 'BulkUpdateReviewActionResponse';
  count?: Maybe<Scalars['Int']['output']>;
};

export type BulkUploadPoisInput = {
  csv: Scalars['String']['input'];
  poiType: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type BulkUploadServiceGroupsInput = {
  csv: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  validateOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CalculatedToActualPofInput = {
  actualValue: Scalars['String']['input'];
  calculatedValue: Scalars['Float']['input'];
};

export enum CalculationType {
  Base = 'BASE',
  Breasting = 'BREASTING',
  FenderPanelFacing = 'FENDER_PANEL_FACING',
  FenderPanelFraming = 'FENDER_PANEL_FRAMING',
  Loading = 'LOADING',
  Mooring = 'MOORING',
  RubberFender = 'RUBBER_FENDER'
}

export type Calculations = {
  __typename?: 'Calculations';
  cof: Scalars['Float']['output'];
  pof: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  transitionPeriod: Scalars['Float']['output'];
};

export type CardInsights = {
  __typename?: 'CardInsights';
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['StringFloatInt']['output'];
  visible?: Maybe<Scalars['Boolean']['output']>;
};

export type CenterPoint = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

/**
 * Client of Abyss Solutions.
 *
 * Clients own the Structures whose conditions are being assessed using automated ML technologies by Abyss Solutions.
 */
export type Client = {
  __typename?: 'Client';
  /**
   * Configuration at a customer level, this will be the
   * default configuration for all structures for this customer
   */
  config?: Maybe<Config>;
  /** Date this Client was created */
  createdAt: Scalars['String']['output'];
  /** Unique Client ID */
  id: Scalars['ID']['output'];
  /** Relative file path to logo for Client */
  logoPath?: Maybe<Scalars['String']['output']>;
  /** Client company name */
  name: Scalars['String']['output'];
  /** Date this Client was last updated */
  updatedAt: Scalars['String']['output'];
};

export enum ColumnKeysEnum {
  All = 'ALL',
  Blister = 'BLISTER',
  Cml = 'CML',
  Component = 'COMPONENT',
  Cui = 'CUI',
  Cups = 'CUPS',
  Deadleg = 'DEADLEG',
  Hotbolting = 'HOTBOLTING',
  NoScanCoverage = 'NO_SCAN_COVERAGE',
  Other = 'OTHER',
  PaintDamage = 'PAINT_DAMAGE',
  PaintRecommendation = 'PAINT_RECOMMENDATION',
  Pdl = 'PDL',
  Pit = 'PIT',
  Subsea = 'SUBSEA'
}

export type Comment = {
  __typename?: 'Comment';
  /** Name of MongoDB Collection where Reference Document resides */
  collectionName: Scalars['String']['output'];
  /** Date this Comment was created */
  createdAt: Scalars['String']['output'];
  /** Auth0 ID of user who created this Comment */
  createdBy: Scalars['String']['output'];
  /** Details of User who created this Comment */
  createdByDetails: CreatedByDetails;
  /** Details of User who created this comment */
  createdByUser: User;
  /** Date this Comment was deleted - for soft delete */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Unique Comment ID */
  id: Scalars['ID']['output'];
  /** Check if this Comment has been edited */
  isEdited: Scalars['Boolean']['output'];
  /** To identtify with which field this comments is linked */
  key?: Maybe<Scalars['String']['output']>;
  /** Status of the linked zone */
  status?: Maybe<ZoneStatus>;
  /** Structure that this Comment belongs to  */
  structureId: Scalars['ObjectId']['output'];
  /** Text content of the Comment */
  text: Scalars['String']['output'];
  /** Title content of the Comment */
  title?: Maybe<Scalars['String']['output']>;
  /** Type of comment belongs to i.e COF, POF etc */
  type?: Maybe<Scalars['String']['output']>;
  /** Date this Comment was last updated */
  updatedAt: Scalars['String']['output'];
};

export type CommentFieldsInput = {
  key: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ComplexPrismVolume = {
  __typename?: 'ComplexPrismVolume';
  /** Optional exclusion volumes */
  exclusions?: Maybe<Array<PrismVolume>>;
  /** Main volume defines inclusion volume */
  inclusion: PrismVolume;
};

export type ComplexPrismVolumeInput = {
  /** Optional exclusion volumes */
  exclusions?: InputMaybe<Array<PrismVolumeInput>>;
  /** Main volume defines inclusion volume */
  inclusion: PrismVolumeInput;
};

export type ConditionNode = {
  __typename?: 'ConditionNode';
  /** For GROUP nodes, the child conditions */
  conditions?: Maybe<Array<ConditionNode>>;
  /** For SIMPLE nodes, the field to check */
  inputVariable?: Maybe<Scalars['String']['output']>;
  /** For GROUP nodes, the logical operator to combine child conditions */
  logicOperator?: Maybe<LogicOperator>;
  /** Type of this node (SIMPLE for leaf nodes, GROUP for logical group nodes) */
  nodeType: ConditionNodeType;
  /** For SIMPLE nodes, the comparison operator */
  operator?: Maybe<ConditionOperator>;
  /** For SIMPLE nodes, the value to compare against */
  value?: Maybe<Scalars['String']['output']>;
};

export enum ConditionNodeType {
  Group = 'GROUP',
  Simple = 'SIMPLE'
}

export enum ConditionOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotEqual = 'NOT_EQUAL'
}

export type ConditionalValueMapping = {
  __typename?: 'ConditionalValueMapping';
  /** Logic operator to combine conditions (defaults to AND) */
  combineOperator?: Maybe<LogicOperator>;
  /** Complex condition tree that evaluates to true or false */
  conditionTree: ConditionNode;
  /** Value to be returned if conditions are met */
  value: Scalars['String']['output'];
};

export type Config = {
  __typename?: 'Config';
  features?: Maybe<Features>;
  /** Default measurement units, i.e. IMPERIAL or METRIC */
  measurementUnit?: Maybe<MeasurementUnitEnum>;
};

export type Configurations = {
  __typename?: 'Configurations';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ConfigurationsInput = {
  id: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Auth0 Connection */
export type ConnectionAuth0 = {
  __typename?: 'ConnectionAuth0';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Corrosion = {
  __typename?: 'Corrosion';
  /** Primary category of corrosion detected */
  primaryCategory?: Maybe<Scalars['String']['output']>;
};

export enum CorrosionLevel {
  Clean = 'CLEAN',
  CoatingBreakdown = 'COATING_BREAKDOWN',
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Moderate = 'MODERATE'
}

export type CorrosivityCategoryItem = {
  __typename?: 'CorrosivityCategoryItem';
  /** Name for the corrosivity category */
  name: Scalars['String']['output'];
  /** Value for the corrosivity category */
  values: Scalars['JSON']['output'];
};

export type Count = {
  __typename?: 'Count';
  count: Scalars['Int']['output'];
};

export type Counter = {
  __typename?: 'Counter';
  /** Count of the groupBy column */
  count: Scalars['Int']['output'];
  /** Group by an arbitrary column like poi.type */
  groupBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Structure that this Counter belongs to */
  structureId: Scalars['ObjectId']['output'];
};

export type CoverageMetrics = {
  __typename?: 'CoverageMetrics';
  /** Coverage area metric */
  area?: Maybe<Scalars['Float']['output']>;
  /** Coverage mean metric */
  mean?: Maybe<Scalars['Float']['output']>;
  /** Coverage slice metric */
  slice?: Maybe<CoverageSlice>;
};

export type CoverageSlice = {
  __typename?: 'CoverageSlice';
  count: Array<Scalars['Int']['output']>;
  mean: Array<Scalars['Float']['output']>;
  start: Scalars['Float']['output'];
  step: Scalars['Float']['output'];
};

export type CreateAssemblyInput = {
  /** Identifier for the Structure that this Assembly belongs to */
  structureId: Scalars['ID']['input'];
  /** User readable identifier for the Assembly */
  tagName: Scalars['String']['input'];
  /** Data values from template for this assembly */
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateCommentInput = {
  collectionName: Scalars['String']['input'];
  referenceId: Scalars['ID']['input'];
  structureId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type CreatePointOfInterestInput = {
  /** Accessibility of this POI */
  accessibility?: InputMaybe<PoiAccessibilityEnum>;
  /** Assembly relation for this POI */
  assemblyId: Scalars['ID']['input'];
  /** What assembly template this POI belongs to. Used in combined deployment */
  assemblyTemplateId: Scalars['ID']['input'];
  /** User who created this Point of interest */
  assignee?: InputMaybe<Scalars['String']['input']>;
  /** Blister metadata for this POI (if type is BLISTER) */
  blister?: InputMaybe<BlisterInput>;
  /** Camera location for this POI */
  cameraLocation?: InputMaybe<Vector3Input>;
  /** Center point for this POI */
  centerPoint3d?: InputMaybe<Vector3Input>;
  /** Comment for this POI */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Cuboids of volume of interest */
  cuboids?: InputMaybe<Array<CuboidInput>>;
  /** Due date of rectification for this Point of interest */
  dueDate?: InputMaybe<Scalars['String']['input']>;
  /** POI is created by a source other than the viewer or imported from a file */
  isManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Line measurements for this POI. */
  lineMeasurement?: InputMaybe<PoiLineMeasurementInput>;
  /** Linked POIs to the cuboid */
  linkedPointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Location relation for this POI */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Metadata for this POI */
  meta?: InputMaybe<Scalars['JSON']['input']>;
  /** Name for this POI */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Paint region relation for this POI */
  paintRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** Part relation for this POI */
  partId?: InputMaybe<Scalars['ID']['input']>;
  /** Priority of this Point of interest */
  priority?: InputMaybe<PoiPriority>;
  /** Current status of this Point of interest */
  status?: InputMaybe<PoiStatus>;
  /** Structure relation for this POI */
  structureId: Scalars['ID']['input'];
  /** Teams that this POI is shared with */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Data values associated with Template for this POI */
  templateData?: InputMaybe<Array<TemplateDataInput>>;
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
  /** Template related to this POI for dynamic data */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Type for this POI */
  type: Scalars['String']['input'];
  /** Unlinked POIs to the cuboid */
  unlinkedPointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Height of the POI relative to the viewpoint it was created from */
  viewpointRelativeHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Visibility for this POI */
  visibility?: InputMaybe<VisibilityEnum>;
  /** Workpack id of this poi */
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  /** Workpack number of POI */
  workpackNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRegionInput = {
  name: Scalars['String']['input'];
};

export type CreateRiskAssessmentDetailsInput = {
  /** TODO: deprecated */
  age?: InputMaybe<Scalars['Int']['input']>;
  /** TODO: deprecated */
  berthingCalculation?: InputMaybe<Scalars['Int']['input']>;
  /** TODO: deprecated */
  corrosionCategory?: InputMaybe<Scalars['String']['input']>;
  /** TODO: deprecated */
  hoursAtBerth?: InputMaybe<Scalars['Int']['input']>;
  /** TODO: deprecated */
  mooringAnalysis?: InputMaybe<Scalars['Int']['input']>;
  /** TODO: deprecated */
  percentDraftCondition?: InputMaybe<Scalars['Float']['input']>;
  /** TODO: deprecated */
  percentOfHours?: InputMaybe<Scalars['Float']['input']>;
  /** TODO: deprecated */
  shipsAtBerth?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the structure that will be updated */
  structureId: Scalars['ID']['input'];
  /** Data values associated with Template for this structure */
  templateData: Array<TemplateDataInput>;
  /** Template related to this structure for dynamic data */
  templateId: Scalars['ID']['input'];
};

export type CreateStructureInput = {
  deploymentLevel: StructureDeploymentLevel;
  features: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  status: StructureStatus;
  type: StructureTypes;
  userGroupIds: Array<Scalars['ID']['input']>;
};

export type CreateSupervoxelClass = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type CreateUserGroupInput = {
  name: Scalars['String']['input'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateWorkflowStageInput = {
  orderInWorkflow: Scalars['Int']['input'];
  stageType?: InputMaybe<StageType>;
  structureId: Scalars['ID']['input'];
  workflowStageName: Scalars['String']['input'];
};

export type CreateWorkpackInput = {
  name: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type CreateWorkpackItemInput = {
  meta?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  partId?: InputMaybe<Scalars['String']['input']>;
  view: WorkpackItemViewInput;
  workpackId: Scalars['ID']['input'];
};

export type CreatedByDetails = {
  __typename?: 'CreatedByDetails';
  name: Scalars['String']['output'];
  profilePicture: Scalars['String']['output'];
};

/** Cuboid represents a labelled 3d-volume (rectangular box). */
export type Cuboid = {
  __typename?: 'Cuboid';
  /** Assembly that this Cuboid belongs to */
  assemblyId?: Maybe<Scalars['ID']['output']>;
  /** CuboidClass assigned to this cuboid - Structure.cudoidClass */
  cuboidClassId?: Maybe<Scalars['ID']['output']>;
  /** Unique role ID */
  id: Scalars['ID']['output'];
  /** Integer ID of this cuboid */
  integerId?: Maybe<Scalars['Float']['output']>;
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['output']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Three.js Euler conventions. */
  rotation: Array<Scalars['Float']['output']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['output']>;
  /** Structure that this cuboid belongs to */
  structureId: Scalars['ObjectId']['output'];
  /** Zone this cuboid was created in */
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export type CuboidInput = {
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['input']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Abyss conventions. */
  rotation: Array<Scalars['Float']['input']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['input']>;
};

/** Currently logged in user. */
export type CurrentUser = {
  __typename?: 'CurrentUser';
  /** Auth0 Connection name used to authenticate logged in user */
  connection: Scalars['String']['output'];
  /** User Groups which logged in user belongs to */
  groups: Array<Scalars['String']['output']>;
  /** Auth0 ID of the logged in user */
  id: Scalars['ID']['output'];
  /** Auth0 Roles which logged in user has */
  roles: Array<UserRolesEnum>;
};

export type DamageClass = {
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type DamageClassCountType = {
  __typename?: 'DamageClassCountType';
  count?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

/**
 * Deck is a floor level on the Structure.
 *
 * A Structure can have multiple Decks on which day-to-day operations take place.
 */
export type Deck = {
  __typename?: 'Deck';
  /** Absolute height of deck from 0m */
  cadFloorHeight?: Maybe<Scalars['Float']['output']>;
  /** Transform matrix from platform grid coordinate system to 2D pixels on deck map */
  cadTransform: Array<Scalars['Float']['output']>;
  /** Date this Deck was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Defect Area for the structure */
  defectArea?: Maybe<Scalars['JSON']['output']>;
  /** [min, max] height range for spatial heatmap slider */
  heightRange: Array<Scalars['Float']['output']>;
  /** Increment step for spatial heatmap slider */
  heightStep?: Maybe<Scalars['Int']['output']>;
  /** Unique Deck ID */
  id: Scalars['ID']['output'];
  /** [width, height] dimensions of deck plan image */
  imageDimensions: Array<Scalars['Int']['output']>;
  /** User readable name */
  name: Scalars['String']['output'];
  /** URL for deck plan image file */
  resourcePath: Scalars['String']['output'];
  /** URL for voxel SQLite db file */
  spatialHeatmapPath?: Maybe<Scalars['String']['output']>;
  /** Structure that the deck belongs to */
  structure: Structure;
  /** Date this Deck was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type DeckAreaSummary = {
  __typename?: 'DeckAreaSummary';
  deckId: Scalars['ID']['output'];
  totalArea: Scalars['Float']['output'];
};

export type DeckInfoInput = {
  voxelDataUri: Scalars['String']['input'];
};

export type DeckWithDefects = {
  __typename?: 'DeckWithDefects';
  defectArea: Array<DefectArea>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DecksDetails = {
  __typename?: 'DecksDetails';
  area?: Maybe<Scalars['Float']['output']>;
  deckId: Deck;
};

export type DecksDetailsInput = {
  area: Scalars['Float']['input'];
  deckId: Scalars['ID']['input'];
};

export type Defect = {
  __typename?: 'Defect';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DefectArea = {
  __typename?: 'DefectArea';
  area: Scalars['Float']['output'];
  key: Scalars['String']['output'];
};

export type DefectCalculationsInput = {
  /** Structure ID to calculate analytics for */
  structureId: Scalars['ID']['input'];
};

export type DefectCalculationsResult = {
  __typename?: 'DefectCalculationsResult';
  /** Coating analytics data */
  coating: Analytics;
  /** Corrosion analytics data */
  corrosion: Analytics;
};

export type DefectColorMeta = {
  __typename?: 'DefectColorMeta';
  key: Scalars['String']['output'];
  value: Array<DefectColorMetaValue>;
};

export type DefectColorMetaValue = {
  __typename?: 'DefectColorMetaValue';
  colour: Scalars['String']['output'];
  name: Scalars['String']['output'];
  octreeIndex: Scalars['Int']['output'];
};

export type DefectLegend = {
  __typename?: 'DefectLegend';
  color: Scalars['String']['output'];
  groupKey: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  legendText?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  octreeKey: OctreeKey;
  octreeValue: Scalars['Int']['output'];
};

export type DefectLegendInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  groupKey?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  legendText?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  octreeKey?: InputMaybe<OctreeKey>;
  octreeValue?: InputMaybe<Scalars['Int']['input']>;
};

export type DefectMetrics = {
  __typename?: 'DefectMetrics';
  /** Coverage metrics of defect */
  coverage: CoverageMetrics;
  /** Type of defect */
  defectType: Scalars['String']['output'];
};

export type DefectsAreaByStructuresResult = {
  __typename?: 'DefectsAreaByStructuresResult';
  structureId: Scalars['ID']['output'];
  structureName: Scalars['String']['output'];
  totalArea: Array<AreaAndType>;
};

export type DeleteCuboidInput = {
  id: Scalars['ID']['input'];
};

export type DeleteFilesInput = {
  collectionName: Scalars['String']['input'];
  fileIds: Array<Scalars['ID']['input']>;
  referenceId: Scalars['ID']['input'];
};

export type DeleteFilesPayload = {
  __typename?: 'DeleteFilesPayload';
  deletedFiles: Array<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
};

export type DeletePointOfInterestInput = {
  /** Unique ID for POI to delete */
  pointOfInterestId: Scalars['ID']['input'];
};

export type DeleteUserGroupInput = {
  userGroupId: Scalars['ID']['input'];
};

export type DeleteWorkflowStageInput = {
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
  workflowStageId: Scalars['ID']['input'];
};

export type DeleteWorkpackInput = {
  workpackId: Scalars['ID']['input'];
};

export type DeleteWorkpackItemInput = {
  workpackId: Scalars['ID']['input'];
  workpackItemId: Scalars['ID']['input'];
};

export enum DifficultyLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type DisplayColor = {
  __typename?: 'DisplayColor';
  /** One of the value from options */
  key: Scalars['String']['output'];
  /** Define color for that option */
  value: Scalars['String']['output'];
};

export type DisplayColorInput = {
  /** One of the value from options */
  key: Scalars['String']['input'];
  /** Define color for that option */
  value: Scalars['String']['input'];
};

export type DisplayConfig = {
  __typename?: 'DisplayConfig';
  /** Define the color for options */
  color?: Maybe<Array<Maybe<DisplayColor>>>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Defines Input Adorment for the text field */
  inputAdorment?: Maybe<InputAdormentType>;
  /** Is this Template Field can be sorted when used in table */
  isSortable: Scalars['Boolean']['output'];
  /** Sorting type based on the data that this field contian i.e number or string */
  sortType: SortTypeEnum;
  /** Used to define Number of rows to be rendered in Text Area field */
  textAreaRows?: Maybe<Scalars['Float']['output']>;
  /** Formatting of the text when displayed */
  textFormat?: Maybe<TextFormatEnum>;
  /** Type or Style of the Table Cell */
  type: TableCellStyleEnum;
};

export type DisplayConfigInput = {
  /** Define the color for options */
  color?: InputMaybe<Array<InputMaybe<DisplayColorInput>>>;
  /** Unique ID */
  id: Scalars['ID']['input'];
  /** Defines Input Adorment for the text field */
  inputAdorment?: InputMaybe<InputAdormentInput>;
  /** Is this Template Field can be sorted when used in table */
  isSortable: Scalars['Boolean']['input'];
  /** Sorting type based on the data that this field contian i.e number or string */
  sortType: SortTypeEnum;
  /** Used to define Number of rows to be rendered in Text Area field */
  textAreaRows?: InputMaybe<Scalars['Float']['input']>;
  /** Formatting of the text when displayed */
  textFormat?: InputMaybe<TextFormatEnum>;
  /** Type or Style of the Table Cell */
  type: TableCellStyleEnum;
};

export type DisplaySettingInput = {
  color: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
};

export type DisplaySettings = {
  __typename?: 'DisplaySettings';
  color: Scalars['String']['output'];
  fieldValue: Scalars['String']['output'];
};

export enum DisplayType {
  CircularBar = 'CIRCULAR_BAR',
  Counter = 'COUNTER',
  DeckImages = 'DECK_IMAGES',
  StackedBar = 'STACKED_BAR'
}

export type DynamicBlockCalculationInput = {
  bbox: BoundingBoxInput;
  structureId: Scalars['ID']['input'];
};

export type DynamicSpatialHeatmapInput = {
  /** Extents to aggregate within */
  bbox: BoundingBoxInput;
  /** Offset to apply to Z values in request to match Z values in DB */
  cadFloorHeight: Scalars['Float']['input'];
  /** Used to find URI of heatmaps DB (same as in spatial heatmap call) */
  deckInfo: DeckInfoInput;
  /** Optional list of part IDs (integer IDs) to filter by */
  parts?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EditFields = {
  isEditable: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  roles: Array<InputMaybe<Scalars['String']['input']>>;
};

export type EditRolesInput = {
  editRoles: Array<InputMaybe<EditFields>>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type EnvironmentalClassificationItem = {
  __typename?: 'EnvironmentalClassificationItem';
  /** Name for the environmental classification */
  name: Scalars['String']['output'];
  /** Value for the environmental classification */
  values: Scalars['JSON']['output'];
};

export type EnvironmentalExposureItem = {
  __typename?: 'EnvironmentalExposureItem';
  /** Code for the environmental exposure */
  code: Scalars['String']['output'];
  /** Name for the environmental exposure */
  name: Scalars['String']['output'];
  /** Time to visibility for the environmental exposure */
  timeToVisibility: Scalars['Int']['output'];
};

export enum EqiupmentCardFieldTypeEnum {
  AlarmLevel = 'ALARM_LEVEL',
  DamageClass = 'DAMAGE_CLASS',
  PercentageIndicator = 'PERCENTAGE_INDICATOR',
  ScCategory = 'SC_CATEGORY',
  SimpleText = 'SIMPLE_TEXT',
  TextWithTitle = 'TEXT_WITH_TITLE'
}

export type Equation = {
  __typename?: 'Equation';
  /** The root expression node of the equation */
  expression?: Maybe<Expression>;
  /** Unique identifier/key for the equation */
  key: Scalars['String']['output'];
  /** Name for the equation */
  name?: Maybe<Scalars['String']['output']>;
  /** Value to return in case of no calculations */
  value?: Maybe<Scalars['String']['output']>;
  /** List of variables used in the equation */
  variables?: Maybe<Array<Variable>>;
};

export type Equipment = {
  __typename?: 'Equipment';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EquipmentCardField = {
  __typename?: 'EquipmentCardField';
  /** Key of the template field from templateFieldData */
  fieldKey?: Maybe<Scalars['String']['output']>;
  /** Unique Equipment Card Field ID */
  id: Scalars['ID']['output'];
  /** Location where this card should be shown in the application */
  location: EquipmentCardLocationEnum;
  /** Name of this Equipment Card Field */
  name: Scalars['String']['output'];
  /** Position of this Equipment Card Field */
  position: EquipmentCardPositionEnum;
  /** Type of this Equipment Card Field */
  type: EqiupmentCardFieldTypeEnum;
};

export enum EquipmentCardLocationEnum {
  Default = 'DEFAULT',
  EsSheet = 'ES_SHEET',
  MiViewer = 'MI_VIEWER'
}

export enum EquipmentCardPositionEnum {
  BottomMiddle = 'BOTTOM_MIDDLE',
  BottomRight = 'BOTTOM_RIGHT',
  Subtitle = 'SUBTITLE',
  TopMiddle = 'TOP_MIDDLE',
  TopRight = 'TOP_RIGHT'
}

export type EquipmentClasses = {
  __typename?: 'EquipmentClasses';
  classes: Array<Equipment>;
  name: Scalars['String']['output'];
};

export type EquipmentDetailField = {
  __typename?: 'EquipmentDetailField';
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  /** Unique human-readable key. It should be same as field key in template */
  fieldKey: Scalars['String']['output'];
  /** Unique Equipment Field ID */
  id: Scalars['ID']['output'];
  /** Should not be shown in the UI. Used for identifying certian fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Equipment Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Equipment Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Name of this Equipment Field */
  name: Scalars['String']['output'];
  /** Valid options for this Equipment Field value */
  options: Array<EquipmentDetailOptionField>;
  /** Should the Equipment template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Sub-Type of this Equipment  Field */
  subType?: Maybe<EquipmentDetailSubTypeEnum>;
  /** Type of this Equipment Field */
  type: EquipmentDetailTypeEnum;
};

export type EquipmentDetailOptionField = {
  __typename?: 'EquipmentDetailOptionField';
  /** Unique human-readable key. It should be same as field key in template */
  fieldKey?: Maybe<Scalars['String']['output']>;
  /** Unique Equipment Option Field */
  id: Scalars['ID']['output'];
  /** Name associated for the Equipment option field */
  name: Scalars['String']['output'];
  /** Type associated with the Equipment option field */
  type: OptionFieldTypeEnum;
};

export enum EquipmentDetailSubTypeEnum {
  DefectConsolidatedDegreeOfRusting = 'DEFECT_CONSOLIDATED_DEGREE_OF_RUSTING',
  DefectCorrosion = 'DEFECT_CORROSION',
  DefectDegreeOfRusting = 'DEFECT_DEGREE_OF_RUSTING',
  DefectSubstrateCondition = 'DEFECT_SUBSTRATE_CONDITION'
}

export enum EquipmentDetailTypeEnum {
  DefectConsolidatedDegree = 'DEFECT_CONSOLIDATED_DEGREE',
  DefectCorrosionArea = 'DEFECT_CORROSION_AREA',
  DefectCorrosionRatio = 'DEFECT_CORROSION_RATIO',
  DefectMaxSeverity = 'DEFECT_MAX_SEVERITY',
  TemplateList = 'TEMPLATE_LIST'
}

export enum EsSheetStatus {
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export type EvaluateTemplateFieldLogicRuleInput = {
  context: Scalars['JSON']['input'];
  fieldKey: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  templateType: TemplateTypeEnum;
};

export type EvaluateTemplateFieldLogicRuleResult = {
  __typename?: 'EvaluateTemplateFieldLogicRuleResult';
  result: Scalars['String']['output'];
};

export type Expression = {
  __typename?: 'Expression';
  /** Child expressions for operations (e.g. operands for binary operations) */
  args?: Maybe<Array<Maybe<Expression>>>;
  /** Mathematical operator (+, -, *, /, etc.), used when type is 'OPERATION' */
  operator?: Maybe<MathOperator>;
  /** The type of expression */
  type: ExpressionType;
  /** Numeric value, used when type is 'NUMBER' */
  value?: Maybe<Scalars['Float']['output']>;
  /** Variable name, used when type is 'VARIABLE' */
  variable?: Maybe<Scalars['String']['output']>;
};

export enum ExpressionType {
  Number = 'NUMBER',
  Operation = 'OPERATION',
  Variable = 'VARIABLE'
}

export type FailedUserInfo = {
  __typename?: 'FailedUserInfo';
  email: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
};

/** Abyss fabric Features */
export type Features = {
  __typename?: 'Features';
  blisterHeights?: Maybe<Scalars['Boolean']['output']>;
};

export type FeaturesInput = {
  deckPlan?: InputMaybe<Array<Scalars['String']['input']>>;
  idms?: InputMaybe<Array<Scalars['String']['input']>>;
  insights?: InputMaybe<Array<Scalars['String']['input']>>;
  reports?: InputMaybe<Array<Scalars['String']['input']>>;
  riskAssessment?: InputMaybe<Array<Scalars['String']['input']>>;
  viewer?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type File = {
  __typename?: 'File';
  caption?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  imageType?: Maybe<ImageType>;
  name: FileNameTypes;
  resourcePath: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type: FileTypes;
  uploadStatus?: Maybe<FileUploadStatus>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type FileAttributes = {
  imageType?: InputMaybe<ImageType>;
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  uuid: Scalars['String']['input'];
};

export type FileCreateInput = {
  fileName: Scalars['String']['input'];
  name: FileNameTypes;
  resourcePath: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  type: FileTypes;
  uploadStatus: FileUploadStatus;
};

export type FileInput = {
  fileName: Scalars['String']['input'];
  imageType?: InputMaybe<ImageType>;
  name: FileNameTypes;
  resourcePath: Scalars['String']['input'];
  type: FileTypes;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export enum FileNameTypes {
  DeckImage = 'DECK_IMAGE',
  IsometricDrawing = 'ISOMETRIC_DRAWING',
  PoiAttachments = 'POI_ATTACHMENTS',
  PoiScreenshot = 'POI_SCREENSHOT',
  UserAttachments = 'USER_ATTACHMENTS'
}

export enum FileTypes {
  Jpeg = 'JPEG',
  Mp4 = 'MP4',
  Pdf = 'PDF',
  Png = 'PNG'
}

export type FileUpdates = {
  fileId: Scalars['String']['input'];
  uploadStatus: FileUploadStatus;
};

export enum FileUploadStatus {
  Failed = 'FAILED',
  Inprogress = 'INPROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type FileWithStatus = {
  __typename?: 'FileWithStatus';
  file: File;
  selectedStatus: Scalars['Boolean']['output'];
};

export type FilterForStructures = {
  name?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterForUserGroups = {
  name?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterForUsers = {
  connection?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excludeRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeTeamId?: InputMaybe<Scalars['ID']['input']>;
  excludeUserGroupId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<UserStatusEnum>;
};

export type FilterForUsersByUserGroup = {
  q?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type FilteredOptions = {
  __typename?: 'FilteredOptions';
  /** Filtered options for this Template */
  options: Array<Scalars['String']['output']>;
};

export type FiltersForPreRegisteredUsers = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type FiltersForStructureByUserGroup = {
  name?: InputMaybe<Scalars['String']['input']>;
  userGroupId: Scalars['ID']['input'];
};

export type FiltersForUsersCount = {
  connection?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type FiltersInput = {
  id: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

/** Float (number) metadata */
export type FloatMeta = {
  __typename?: 'FloatMeta';
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type GenerateCropFromRectilinearInput = {
  /** X Y Z Position of the clicked point */
  centerPoint?: InputMaybe<CenterPoint>;
  /** Location information from the image */
  image: Image;
  /** Output image height */
  outputHeight: Scalars['Float']['input'];
  /** Output Vertical Field Of View */
  outputVerticalFov: Scalars['Float']['input'];
  /** Output image width */
  outputWidth: Scalars['Float']['input'];
};

export type GenerateImageInput = {
  /** Rotation of camera angle */
  bearing: Scalars['Float']['input'];
  /** Elevation of camera angle */
  elevation: Scalars['Float']['input'];
  /** Image name */
  imageName: Scalars['String']['input'];
  /** Image URL to download from */
  imageUrl: Scalars['String']['input'];
  /** Id of Location */
  locationId: Scalars['String']['input'];
  /** Output image height */
  outputHeight: Scalars['Float']['input'];
  /** Output image width */
  outputWidth: Scalars['Float']['input'];
  /** Vertical field of view (degrees) */
  verticalFovDegrees: Scalars['Float']['input'];
};

export type GenerateImageResult = {
  __typename?: 'GenerateImageResult';
  /** Base64 encoded string of image data */
  imageData: Scalars['String']['output'];
};

export type GeneratedPresignedUrl = {
  __typename?: 'GeneratedPresignedURL';
  id: Scalars['String']['output'];
  resourcePath: Scalars['String']['output'];
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type GoverningValueBlister = {
  __typename?: 'GoverningValueBlister';
  /** Estimated value of thickness of pipe wall that has been lost to corrosion based on blister height (in millimeters) */
  estimatedWallLoss: Scalars['Float']['output'];
  /** Calculated wall loss as a percentage of nominal pipe wall thickness (in %) */
  estimatedWallLossPercentage: Scalars['Float']['output'];
  /** Recorded height of the blister (in millimeters) */
  height: Scalars['Float']['output'];
  /** Remaining allowance for corrosion based on estimated thickness loss and pipe spec (in millimeters) */
  residualCorrosionAllowance: Scalars['Float']['output'];
  /** Calculated residual corrosion allowance as a percentage of nominal corrosion allowance (in %) */
  residualCorrosionAllowancePercentage: Scalars['Float']['output'];
  /** Calculated residual thickness based on wall loss and pipe spec (in millimeters) */
  residualThickness: Scalars['Float']['output'];
  /** Calculated residual thickness as a percentage of nominal thickness (in %) */
  residualThicknessPercentage: Scalars['Float']['output'];
};

export type GoverningValueInput = {
  estimatedWallLoss: Scalars['Float']['input'];
  estimatedWallLossPercentage: Scalars['Float']['input'];
  height: Scalars['Float']['input'];
  residualCorrosionAllowance: Scalars['Float']['input'];
  residualCorrosionAllowancePercentage: Scalars['Float']['input'];
  residualThickness: Scalars['Float']['input'];
  residualThicknessPercentage: Scalars['Float']['input'];
};

export type GoverningValueRecommendation = {
  __typename?: 'GoverningValueRecommendation';
  blister?: Maybe<PointOfInterest>;
  calculations?: Maybe<GoverningValueBlister>;
  manuallyUpdated?: Maybe<Scalars['Boolean']['output']>;
  pointOfInterest?: Maybe<PointOfInterest>;
};

export type GoverningValueRecommendationInput = {
  blisterId: Scalars['ID']['input'];
  calculations: GoverningValueInput;
};

export type GroupSection = {
  __typename?: 'GroupSection';
  /** Unique human-readable keys to be displayed in Review Panel. It should be same as field key in template */
  fieldKeys: Array<Maybe<Scalars['String']['output']>>;
  /** Unique Assessment Detail Field */
  id: Scalars['ID']['output'];
  /** Unique identifier for the section */
  sectionKey: Scalars['String']['output'];
  /** Name of the section */
  title: Scalars['String']['output'];
};

export type GroupSectionInput = {
  /** Unique human-readable keys to be displayed in Review Panel. It should be same as field key in template */
  fieldKeys: Array<InputMaybe<Scalars['String']['input']>>;
  /** Unique Group Section ID */
  id: Scalars['ID']['input'];
  /** Unique identifier for the section */
  sectionKey: Scalars['String']['input'];
  /** Name of the section */
  title: Scalars['String']['input'];
};

export type GroupedReports = {
  __typename?: 'GroupedReports';
  count: Scalars['Int']['output'];
  groupId: Scalars['ID']['output'];
  groupName: Scalars['String']['output'];
};

export type GroupsByPartIdsInput = {
  partIds: Array<Scalars['String']['input']>;
  structureId: Scalars['String']['input'];
};

/**
 * History Document
 *
 * A history document is a detailed snapshot of a MongoDB document from another MongoDB collection at a particular point in time.
 */
export type History = {
  __typename?: 'History';
  /** Name of MongoDB Collection where Reference Document resides */
  collectionName: Scalars['String']['output'];
  /** Date this History was created */
  createdAt: Scalars['String']['output'];
  /** User who created this History */
  createdBy: Scalars['String']['output'];
  /** Auth0 Name and Profile Picture of the user associated to createdBy from auth0 fetched at request time. */
  createdByDetails?: Maybe<CreatedByDetails>;
  /** Name of the user associated to createdBy from auth0 fetched at request time. createdBy must be present to use this */
  createdByName: Scalars['String']['output'];
  /** Full Document capture at the time of History */
  document: Scalars['JSON']['output'];
  /** Name of Event that triggered creation of History */
  eventName: Scalars['String']['output'];
  /** Unique History ID */
  id: Scalars['ID']['output'];
  /** Structure that this History event belongs to  */
  structureId?: Maybe<Scalars['ID']['output']>;
};

export type IdmsTask = {
  __typename?: 'IdmsTask';
  /** Task Start Date */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Unique Task ID */
  id: Scalars['ID']['output'];
  /** Task Number */
  idmsTaskNumber: Scalars['String']['output'];
  /** Line Number of Task */
  lineNumber: Scalars['String']['output'];
  /** Recommendations for this task */
  recommendations: Array<TaskRecommendation>;
  /** Task Status */
  status?: Maybe<Scalars['String']['output']>;
  /** Task Status Updated At */
  statusUpdatedAt?: Maybe<Scalars['String']['output']>;
  /** Structure ID to which this Task belongs to */
  structureId: Scalars['ObjectId']['output'];
  /** Task Due Date */
  taskDueDate?: Maybe<Scalars['String']['output']>;
};

export type IdmsTasksWithCount = {
  __typename?: 'IdmsTasksWithCount';
  count: Scalars['Int']['output'];
  tasks: Array<IdmsTask>;
};

export type IdmsUpload = {
  __typename?: 'IdmsUpload';
  /** Date this File was created */
  createdAt: Scalars['String']['output'];
  /** User who created this File */
  createdBy: User;
  /** File path where file is present */
  filePath: Scalars['String']['output'];
  /** Unique File ID */
  id: Scalars['ID']['output'];
  /** File name */
  name: Scalars['String']['output'];
  /** Structure to which this file belongs to */
  structure: Structure;
  /** Template Type of File */
  templateType: IdmsUploadsTypeEnum;
  /** Date this File was last updated */
  updatedAt: Scalars['String']['output'];
};

export type IdmsUploadMutationInput = {
  /** File to be uploaded in base64 format */
  file: Scalars['String']['input'];
  name: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  templateType: IdmsUploadsTypeEnum;
};

export enum IdmsUploadsTypeEnum {
  AfInspectionPriority = 'AF_INSPECTION_PRIORITY',
  ApmLineMetadata = 'APM_LINE_METADATA',
  ApmRecommendation = 'APM_RECOMMENDATION',
  ApmRecommendationStatus = 'APM_RECOMMENDATION_STATUS',
  ApmTaskNumber = 'APM_TASK_NUMBER',
  ApmTaskStatus = 'APM_TASK_STATUS',
  ApmWorkOrder = 'APM_WORK_ORDER',
  UpdateEquipments = 'UPDATE_EQUIPMENTS',
  WorkOrderStatus = 'WORK_ORDER_STATUS'
}

export type Image = {
  /** Image Sensor */
  imageSensor: ImageSensorInput;
  /** Pose of the camera */
  pose: Pose;
  /** path to the Location image */
  url: Scalars['String']['input'];
};

export type ImagePointInput = {
  /** Position along the x axis of the image with a value between 0 and 1 */
  x: Scalars['Float']['input'];
  /** Position along the y axis of the image with a value between 0 and 1 */
  y: Scalars['Float']['input'];
};

/**
 * Image Sensor data of a Structure that has been inspected.
 *
 * An inspection takes place on the Location that has a certain image sensor in some cases such as Drones
 */
export type ImageSensor = {
  __typename?: 'ImageSensor';
  /** Calibration coordinates X */
  cx: Scalars['Float']['output'];
  /** Calibration coordinates Y */
  cy: Scalars['Float']['output'];
  /** Sensor Image Focal Length */
  focalLength: Scalars['Float']['output'];
  /** Sensor Image Height */
  height: Scalars['Int']['output'];
  /** Unique role ID */
  id: Scalars['ID']['output'];
  /** Sensor Name */
  name: Scalars['String']['output'];
  /** Structure that this Location data belongs to */
  structure: Structure;
  /** Sensor Image Width */
  width: Scalars['Int']['output'];
};

export type ImageSensorInput = {
  /** Calibration coordinates X */
  cx: Scalars['Float']['input'];
  /** Calibration coordinates Y */
  cy: Scalars['Float']['input'];
  /** Sensor Image Focal Length */
  focalLength: Scalars['Float']['input'];
  /** Sensor Image Height */
  height: Scalars['Int']['input'];
  /** Sensor Image Width */
  width: Scalars['Int']['input'];
};

export enum ImageType {
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  WhiteBgPdf = 'WHITE_BG_PDF'
}

export enum InputAdormentIconTypeEnum {
  MeasurementTool = 'MEASUREMENT_TOOL',
  Reload = 'RELOAD'
}

export type InputAdormentInput = {
  /** If the Icon Path is present, we will fetch icons from the path. */
  iconPath?: InputMaybe<Scalars['String']['input']>;
  /** If the Icon Path is undefined, fallback to use static map on frontend. */
  iconType?: InputMaybe<InputAdormentIconTypeEnum>;
  /** Position of the Input Adorment */
  position?: InputMaybe<InputAdormentPositionEnum>;
};

export enum InputAdormentPositionEnum {
  End = 'END',
  Start = 'START'
}

export type InputAdormentType = {
  __typename?: 'InputAdormentType';
  /** If the Icon Path is present, we will fetch icons from the path. */
  iconPath?: Maybe<Scalars['String']['output']>;
  /** If the Icon Path is undefined, fallback to use static map on frontend. */
  iconType?: Maybe<InputAdormentIconTypeEnum>;
  /** Position of the Input Adorment */
  position?: Maybe<InputAdormentPositionEnum>;
};

export type InputGroupByWorkpackId = {
  pointOfInterestIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputPointOfInterestTemplateField = {
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: InputMaybe<Scalars['String']['input']>;
  /** Table configuration */
  displayConfig?: InputMaybe<DisplayConfigInput>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be displayed in report */
  displayInReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be visible in review */
  displayInReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Template Field ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable Measurement Tool */
  isMeasurementToolEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['input'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['input'];
  /** Key to identify field in template data */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Name of this Template Field */
  name: Scalars['String']['input'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['input']>;
  /** Details of valid options for this Template Field value */
  optionsData?: InputMaybe<Array<OptionDataInput>>;
  /** Type of permission that a user have to read the template */
  permission?: InputMaybe<Scalars['String']['input']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['input'];
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: InputMaybe<UnitsEnum>;
};

export type InputUpdateFileForPointOfInterest = {
  /** File id which status needs to be updated */
  fileId: Scalars['ID']['input'];
  /** POI for which to attach files */
  pointOfInterestId: Scalars['ID']['input'];
  /** Upload status */
  uploadStatus: FileUploadStatus;
};

/** Integer (number) metadata */
export type IntMeta = {
  __typename?: 'IntMeta';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type InviteUsersInput = {
  clientId: Scalars['String']['input'];
  connection: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']>;
  groups: Array<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
};

export type LabelAnnotation = {
  __typename?: 'LabelAnnotation';
  /** Unique Label Annotation ID */
  id: Scalars['ID']['output'];
  /** LabelClass this label-annotation belongs (structures.labelClass) */
  labelClassId: Scalars['ObjectId']['output'];
  /** Octree id the label-annotation belongs to */
  octreeId: Scalars['Int']['output'];
  /** Structure that this Label Annotation belongs to */
  structureId: Scalars['ObjectId']['output'];
};

export type LabelClass = {
  __typename?: 'LabelClass';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LineMeasurement = {
  __typename?: 'LineMeasurement';
  /** Signed URL of Location depth image used to calculate line distance */
  id: Scalars['String']['output'];
  /** Location document ID */
  image_id: Scalars['String']['output'];
  /** Line measurements */
  line: LineMeasurementResult;
  /** Measurements API status */
  status: MeasurementStatus;
};

export type LineMeasurementResult = {
  __typename?: 'LineMeasurementResult';
  /** Distance between line endpoints */
  distance: Array<Array<Scalars['Float']['output']>>;
  points2D: Array<Array<Scalars['Float']['output']>>;
  points3D: Array<Array<Scalars['Float']['output']>>;
};

/**
 * Location data of a Structure that has been inspected.
 *
 * An inspection takes place on the Location that involves data capture of a Structure in the form of spherical (panoramic) images or LIDAR scans.
 * This Location data of the Structure is then used to assess the conditions of Parts that compose the Structure and identify any defects on these Parts, such as corrosion.
 */
export type Location = {
  __typename?: 'Location';
  /** User who last analysed this Location */
  analysedBy?: Maybe<Scalars['String']['output']>;
  /** Resource path for angle calculation */
  angleResourcePath?: Maybe<Scalars['String']['output']>;
  /** Default resource path used as base path for layers */
  baseResourcePath?: Maybe<Scalars['String']['output']>;
  /** Date this Location was created */
  createdAt: Scalars['String']['output'];
  /** Deck that this Location data belongs to */
  deck: Deck;
  /** Position of Location on Deck plan */
  deckPlan?: Maybe<LocationDeckPlan>;
  /** URL for the Location depth map */
  depthResource?: Maybe<Scalars['String']['output']>;
  /** Relative path to the location depth map */
  depthResourcePath?: Maybe<Scalars['String']['output']>;
  /** Distance from asset */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Unique Location ID */
  id: Scalars['ID']['output'];
  /** Image Sensor that was use for this location */
  imageSensor?: Maybe<ImageSensor>;
  /** Image layers that can be toggled */
  layers?: Maybe<Array<Maybe<LocationLayer>>>;
  /** User readable identifier for the Location */
  name: Scalars['String']['output'];
  /** Paint Region that this Location data belongs to */
  paintRegion?: Maybe<PaintRegion>;
  /** Camera pose of Location in grid coordinate system */
  pose?: Maybe<LocationPose>;
  /** URL for the Location scan data */
  resource?: Maybe<Scalars['String']['output']>;
  /** Relative path to the location scan data */
  resourcePath?: Maybe<Scalars['String']['output']>;
  /** Scan key used to identify the image and deck eg. LD/LDW0250 */
  scanKey?: Maybe<Scalars['String']['output']>;
  /** Size of the images used to build the resource path in layers */
  size?: Maybe<Scalars['String']['output']>;
  /** Structure that this Location data belongs to */
  structure: Structure;
  /** Date this Location was last updated */
  updatedAt: Scalars['String']['output'];
  /** User who last updated this Location */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Video resource path */
  videoResourcePath?: Maybe<Scalars['String']['output']>;
  /** Video timestamp */
  videoTimestamp?: Maybe<Scalars['Float']['output']>;
};

export type LocationDeckPlan = {
  __typename?: 'LocationDeckPlan';
  /** [x,y] coordinates of Location on Deck plan */
  coordinates: Array<Scalars['Float']['output']>;
  /** Id of Location on Deck plan */
  id: Scalars['ID']['output'];
};

export type LocationLayer = {
  __typename?: 'LocationLayer';
  /** Name To Be Displayed */
  displayName: Scalars['String']['output'];
  /** File Extension eg. jpg, png, svg */
  fileExt?: Maybe<Scalars['String']['output']>;
  /** Type used in the url eg. rgb or bv (blister-vision) */
  type: Scalars['String']['output'];
};

export type LocationPose = {
  __typename?: 'LocationPose';
  /** Pitch angle (in radians) */
  pitch: Scalars['Float']['output'];
  /** Roll angle (in radians) */
  roll: Scalars['Float']['output'];
  /** X-axis */
  x: Scalars['Float']['output'];
  /** Y-axis */
  y: Scalars['Float']['output'];
  /** Yaw angle (in radians) */
  yaw: Scalars['Float']['output'];
  /** Yaw offset angle (in radians). Aligns spherical image with scan point cloud (depends on camera type) */
  yawOffset: Scalars['Float']['output'];
  /** Z-axis */
  z: Scalars['Float']['output'];
};

export type LocationsForAssemblyInput = {
  deckId: Scalars['ID']['input'];
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  structureId: Scalars['ID']['input'];
};

export type LogicEvaluationRule = {
  __typename?: 'LogicEvaluationRule';
  /** Array of conditional value mappings */
  conditionalMappings: Array<ConditionalValueMapping>;
  /** Default value to return if no conditions match */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** Description of what this rule evaluates */
  description?: Maybe<Scalars['String']['output']>;
  /** Strategy for evaluating the conditional mappings */
  evaluationStrategy: LogicEvaluationStrategy;
  /** List of variables used in the Rule */
  variables: Array<Variable>;
};

export enum LogicEvaluationStrategy {
  AllMatch = 'ALL_MATCH',
  AnyMatch = 'ANY_MATCH',
  FirstMatch = 'FIRST_MATCH'
}

export enum LogicOperator {
  And = 'AND',
  Or = 'OR'
}

/** Login Types */
export enum LoginTypeEnum {
  Email = 'EMAIL',
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

export type MarkLocationAnalysedInput = {
  isAnalysed: Scalars['Boolean']['input'];
  locationId: Scalars['ID']['input'];
};

export type MarkViewPointAsAnalysedFromCurrentAssemblyInput = {
  assemblyId: Scalars['ID']['input'];
  lastModifiedFor: Scalars['String']['input'];
  viewpointId: Scalars['ID']['input'];
};

export type MarkerLabelConfig = {
  __typename?: 'MarkerLabelConfig';
  /** List of fields to display in the marker label */
  fields: Array<MarkerLabelField>;
  /** Optional header field for the marker label */
  headerField?: Maybe<MarkerLabelField>;
  /** Flag to hide name in marker label */
  hideName?: Maybe<Scalars['Boolean']['output']>;
  /** Type of marker label configuration (compact by default) */
  type: MarkerLabelConfigTypeEnum;
};

export type MarkerLabelConfigInput = {
  /** List of fields to display in the marker label */
  fields: Array<MarkerLabelFieldInput>;
  /** Optional header field for the marker label */
  headerField?: InputMaybe<MarkerLabelFieldInput>;
  /** Flag to hide name in marker label */
  hideName?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of marker label configuration (compact by default) */
  type?: InputMaybe<MarkerLabelConfigTypeEnum>;
};

export enum MarkerLabelConfigTypeEnum {
  Compact = 'COMPACT',
  Detailed = 'DETAILED'
}

export type MarkerLabelField = {
  __typename?: 'MarkerLabelField';
  /** Field key */
  key: Scalars['String']['output'];
  /** Type of marker label field */
  type?: Maybe<MarkerLabelFieldTypeEnum>;
};

export type MarkerLabelFieldInput = {
  /** Field key */
  key: Scalars['String']['input'];
  /** Type of marker label field */
  type?: InputMaybe<MarkerLabelFieldTypeEnum>;
};

export enum MarkerLabelFieldTypeEnum {
  Blister = 'BLISTER',
  PointOfInterest = 'POINT_OF_INTEREST',
  TemplateField = 'TEMPLATE_FIELD'
}

export type MaterialType = {
  __typename?: 'MaterialType';
  /** Category representing the material's resistance to corrosion */
  corrosivityCategory?: Maybe<Array<CorrosivityCategoryItem>>;
  /** Classification that quantifies material performance across different thickness ranges */
  environmentalClassification?: Maybe<Array<EnvironmentalClassificationItem>>;
  /** Envionmental Exposure for the material */
  environmentalExposure?: Maybe<Array<EnvironmentalExposureItem>>;
  /** Different thickness ranges of the material */
  thickness?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Identifying type of material */
  type: Scalars['String']['output'];
};

export enum MathOperator {
  Add = 'ADD',
  Cosine = 'COSINE',
  Divide = 'DIVIDE',
  Logarithm = 'LOGARITHM',
  Multiply = 'MULTIPLY',
  Power = 'POWER',
  Sine = 'SINE',
  SquareRoot = 'SQUARE_ROOT',
  Subtract = 'SUBTRACT'
}

export type MeasurementStatus = {
  __typename?: 'MeasurementStatus';
  /** Location depth image cache status */
  cacheStatus: Scalars['String']['output'];
  /** Blister measurement fitting radius */
  fittingRadius?: Maybe<Scalars['Float']['output']>;
  /** Blister measurement target radius */
  targetRadius?: Maybe<Scalars['Float']['output']>;
  /** Blister measurement window size */
  windowSize: Array<Scalars['Int']['output']>;
};

export enum MeasurementUnitEnum {
  /** US Imperial units of measurement */
  Imperial = 'IMPERIAL',
  /** Metric units of measurement */
  Metric = 'METRIC'
}

export type MechanicalIntegrityServicesResponse = {
  __typename?: 'MechanicalIntegrityServicesResponse';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Meta is used for storing data with dynamic keys */
export type Meta = DefectColorMeta | FloatMeta | IntMeta | StringArrayMeta | StringMeta;

export type MiServicesInput = {
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

export type MiServicesPoiTemplateInput = {
  structureId: Scalars['ID']['input'];
  templateIds: Array<Scalars['ID']['input']>;
};

export type ModeInput = {
  defects: Array<Scalars['String']['input']>;
  heightRange: Array<Scalars['Int']['input']>;
  includeValues?: InputMaybe<Array<Scalars['Int']['input']>>;
  modes: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Group POI into a single workpack group */
  GroupPointOfInterestsByWorkpackId?: Maybe<Array<Maybe<PointOfInterest>>>;
  /** Remove POI from Workpack */
  RemoveWorkpackIdFromPointOfInterests?: Maybe<Array<Maybe<PointOfInterest>>>;
  addAndRemoveFiles?: Maybe<Scalars['Boolean']['output']>;
  addAssemblyImageCaption?: Maybe<Scalars['String']['output']>;
  /** Option to add Assessment Details Fields to the template */
  addAssessmentDetailsFields?: Maybe<Template>;
  /** Handle Edit Roles for Template Fields */
  addEditRolesToTemplateField?: Maybe<Template>;
  /** Option to add MI Services fields to the template */
  addMiServicesFields?: Maybe<Template>;
  /** Option to add MI Services overhaul fields to the template */
  addMiServicesOverhaulFields?: Maybe<Template>;
  /** Option to add MI Services overhaul fields to the blister and pit template */
  addMiServicesOverhaulFieldsToPoiTemplates?: Maybe<Array<Maybe<PointOfInterestTemplate>>>;
  addNewAssemblyTagName?: Maybe<Assembly>;
  addPartsToAssembly: Array<Part>;
  /** Add report configuration for structure */
  addReportConfiguration?: Maybe<Structure>;
  /** Adds or Updates the Split Cuboid on the Part */
  addUpdateCuboid?: Maybe<Cuboid>;
  /** Adds or Updates the Split Cuboid on the Part */
  addUpdateSplitCuboidOnPart: AddUpdateSplitCuboidOnPartNotification;
  addUserGroupsToStructure?: Maybe<StructuresAndGroups>;
  addUsersToTeam: Team;
  addUsersToUserGroup?: Maybe<UserGroup>;
  /** Calculate area and POI risk scores for assembly paint regions */
  areaAndPoiRiskScoreCalculation: Scalars['JSON']['output'];
  assignRoleToUsers: Role;
  benchmarkDownload?: Maybe<BenchmarkDownloadOutput>;
  benchmarkUpload?: Maybe<BenchmarkUploadOutput>;
  blockOrUnblockUser: User;
  bulkCreateCommentsForAssemblies?: Maybe<BulkCreateOrUpdateCommentsForAssemblies>;
  bulkLineFixing: BulkLineFixingResult;
  bulkPipeSpecUpload: BulkPipeSpecUploadResponse;
  /** Bulk Update Review Action */
  bulkUpdateReviewAction?: Maybe<BulkUpdateReviewActionResponse>;
  bulkUploadPois: Array<PointOfInterest>;
  bulkUploadServiceGroups: BulkServiceGroupsResponse;
  /** Calculate defect calculations (coating and corrosion) */
  calculateDefectCalculations: DefectCalculationsResult;
  /** Calculate risk remediation analytics for dashboard */
  calculateRiskRemediationAnalytics: Analytics;
  /** Clones an existing POITemplate with a different structureId */
  clonePointOfInterestTemplate?: Maybe<Array<Maybe<PointOfInterestTemplate>>>;
  /** Clones an existing POITemplate with a different structureId */
  cloneQuerySummary?: Maybe<Template>;
  /** Clones an existing POITemplate with a different structureId */
  cloneTemplateFields?: Maybe<Template>;
  createAnnotation?: Maybe<Annotation>;
  createAssembly?: Maybe<Template>;
  createBulkReports: Array<Maybe<Report>>;
  createComment: Comment;
  createNewReport: Report;
  /** Create a new POI */
  createPointOfInterest?: Maybe<PointOfInterest>;
  /** Creates a new POITemplate */
  createPointOfInterestTemplate?: Maybe<PointOfInterestTemplate>;
  createPreRegisteredUsers: UserInvite;
  createRegion?: Maybe<Region>;
  /** Creates risk assessment details */
  createRiskAssessmentDetails?: Maybe<Structure>;
  /** Creates a new structure */
  createStructure?: Maybe<Structure>;
  createSupervoxelClass?: Maybe<SupervoxelClass>;
  createTeam: Team;
  /** Create a new Template */
  createTemplate?: Maybe<Template>;
  createUserGroup?: Maybe<UserGroup>;
  /** Create a new workflow stage */
  createWorkflowStage?: Maybe<Structure>;
  createWorkpack?: Maybe<Workpack>;
  createWorkpackItem?: Maybe<WorkpackItem>;
  deleteAssemblyFromReport: Report;
  deleteComment: Comment;
  /** Removes the Split Cuboid on the Part */
  deleteCuboid?: Maybe<Scalars['ID']['output']>;
  deleteDraftReport: Report;
  deleteFiles: DeleteFilesPayload;
  /** Delete an existing POI */
  deletePointOfInterest?: Maybe<PointOfInterest>;
  deletePointOfInterestFromReport: Report;
  /** Deletes a POI Template */
  deletePointOfInterestTemplate?: Maybe<PointOfInterestTemplate>;
  deletePreRegisteredUser?: Maybe<PreRegisteredUser>;
  deleteReport: Scalars['Boolean']['output'];
  deleteTeam: Scalars['ID']['output'];
  /** Delete an existing Template */
  deleteTemplate?: Maybe<Template>;
  deleteUserGroup?: Maybe<UserGroup>;
  /** Delete workflow stage */
  deleteWorkflowStage?: Maybe<Structure>;
  deleteWorkpack?: Maybe<Workpack>;
  deleteWorkpackItem?: Maybe<WorkpackItem>;
  evaluateAllAssembliesForStructure?: Maybe<Structure>;
  /** Evaluate all POIs for a structure */
  evaluateAllPOIsForStructure?: Maybe<Structure>;
  evaluateTemplateFieldLogicRule?: Maybe<EvaluateTemplateFieldLogicRuleResult>;
  generatePoiPdf: PdfGenerationResult;
  idmsFileUpload?: Maybe<IdmsUpload>;
  inviteUsers: UserInvite;
  markLocationAnalysed?: Maybe<Location>;
  markViewPointAsAnalysedFromCurrentAssembly?: Maybe<Assembly>;
  nominateGoverningPointOfInterest?: Maybe<Scalars['String']['output']>;
  /** Perform Mechanical Integrity Services */
  performMechanicalIntegrityServices?: Maybe<MechanicalIntegrityServicesResponse>;
  /** Add Caption To Poi Image */
  poiImageCaption?: Maybe<Scalars['String']['output']>;
  preSignedUrlToUploadFiles: Array<GeneratedPresignedUrl>;
  /** Recalculate risk remediation analytics for dashboard */
  recalculateRiskRemediationAnalytics: RecalculateRiskRemediationAnalyticsResult;
  /** Remove attachments from a POI */
  removeAttachmentsFromPoi?: Maybe<PointOfInterest>;
  removeRoleFromUsers: Role;
  /** Removes the Split Cuboid on the Part */
  removeSplitCuboidOnPart: RemoveSplitCuboidOnPartNotification;
  removeUserGroupsFromStructure?: Maybe<StructuresAndGroups>;
  removeUsersFromTeam: Team;
  removeUsersFromUserGroup?: Maybe<UserGroup>;
  resetPassword: Scalars['String']['output'];
  revertBulkLineFixing: BulkLineFixingResult;
  /** Rollback to a previous version of a document */
  rollbackVersion: Version;
  /** Save screenshot of a POI */
  savePointOfInterestScreenshot?: Maybe<PointOfInterest>;
  setAlarmLevel?: Maybe<AlarmLevelRecommendation>;
  setHiddenForParts: Array<Scalars['String']['output']>;
  setReviewedForParts: Array<Scalars['String']['output']>;
  splitPart: Part;
  updateAssembliesProbabilityOfFailureRiskFactors?: Maybe<Array<Maybe<Assembly>>>;
  updateAssembly?: Maybe<Assembly>;
  /** Create or Update Blister POI Recommendation for Assembly (unique by Assembly ID / Blister POI name pair) */
  updateAssemblyBlisters: PointOfInterest;
  /** Override calculation method for a POI */
  updateCalculationMethod?: Maybe<PointOfInterest>;
  updateComment: Comment;
  updateCuiPriority?: Maybe<Assembly>;
  updateEsSheetStatus: Structure;
  updateFilesStatus?: Maybe<Scalars['Boolean']['output']>;
  updateGoverningValue?: Maybe<Assembly>;
  /** Bulk update Paint Region ID for POIs */
  updatePaintRegionId?: Maybe<Array<Maybe<PointOfInterest>>>;
  updatePaintRegionStatus: PaintRegion;
  /** Update an existing POI */
  updatePointOfInterest?: Maybe<PointOfInterest>;
  /** Update file upload status of specific file */
  updatePointOfInterestFile: PointOfInterest;
  /** Update Point of Interest Image */
  updatePointOfInterestImageType?: Maybe<PointOfInterest>;
  /** Update Point of Interest Location */
  updatePointOfInterestLocation?: Maybe<PointOfInterest>;
  /** Updates an exists POITemplate */
  updatePointOfInterestTemplate?: Maybe<PointOfInterestTemplate>;
  /** Update existing POIs visibility */
  updatePointOfInterestVisibility: Array<PointOfInterest>;
  /** Update POI status */
  updatePointOfInterestsStatus?: Maybe<Scalars['String']['output']>;
  /** Update Remediation Score Configuration */
  updateRemediationScoreConfig?: Maybe<Template>;
  updateReport: Report;
  updateReportByPointOfInterests: Report;
  updateReportPointOfInterestImages: Report;
  updateReportStatus: Report;
  /** Update Risk Assement In Template Field Data And Calculate Transition Period As Well */
  updateRiskAssessmentTemplateFieldDataAndTransitionPeriod?: Maybe<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriod>;
  updateRiskAssessmentTemplateFieldDataForAssemblies?: Maybe<Array<Maybe<Assembly>>>;
  updateScCategory?: Maybe<Assembly>;
  updateSingleTemplateFieldData?: Maybe<Assembly>;
  /** Updates an existing Structure */
  updateStructure?: Maybe<Structure>;
  updateSupervoxels: Array<SuperVoxels>;
  /** Update a Template */
  updateTemplate?: Maybe<Template>;
  /** UpdateTemplateFieldData mutation is used by ES-Sheet in v1 to directly populate features in v2 */
  updateTemplateFieldData?: Maybe<UpdatedTemplateFieldDataResult>;
  updateUserColumnPreferences?: Maybe<User>;
  updateUserGroup?: Maybe<UserGroup>;
  /** Create or update auth0 user profile info in mongo */
  updateUserInfo?: Maybe<User>;
  updateUserPreferences?: Maybe<User>;
  /** Bulk update of WalllossFactor and its Calculations */
  updateWallLossFactor?: Maybe<Scalars['String']['output']>;
  /** Update workflow status of the structure */
  updateWorkflowStage?: Maybe<Structure>;
  updateWorkflowStatus?: Maybe<Array<Maybe<Zone>>>;
  updateWorkflowTimeAndState?: Maybe<Zone>;
  updateWorkpack?: Maybe<Workpack>;
  updateWorkpackItem?: Maybe<WorkpackItem>;
  updateWorkpackStatus?: Maybe<Workpack>;
  updateZoneStatus: ZoneUpdate;
  /** Upload attachments to a POI */
  uploadAttachmentsToPoi: Array<GeneratedPresignedUrl>;
  /** Upload cover image for structure */
  uploadCoverImage?: Maybe<Structure>;
  uploadEsSheet: Scalars['String']['output'];
  validateEsSheet: Scalars['String']['output'];
  /** Verify a POI */
  verifyPointOfInterest?: Maybe<PointOfInterest>;
};


export type MutationGroupPointOfInterestsByWorkpackIdArgs = {
  input?: InputMaybe<InputGroupByWorkpackId>;
};


export type MutationRemoveWorkpackIdFromPointOfInterestsArgs = {
  input?: InputMaybe<InputGroupByWorkpackId>;
};


export type MutationAddAndRemoveFilesArgs = {
  input: UpdateFilesInput;
};


export type MutationAddAssemblyImageCaptionArgs = {
  input?: InputMaybe<AssemblyImageCaptionInput>;
};


export type MutationAddAssessmentDetailsFieldsArgs = {
  input?: InputMaybe<AssessmentDetailsInput>;
};


export type MutationAddEditRolesToTemplateFieldArgs = {
  input?: InputMaybe<EditRolesInput>;
};


export type MutationAddMiServicesFieldsArgs = {
  input?: InputMaybe<MiServicesInput>;
};


export type MutationAddMiServicesOverhaulFieldsArgs = {
  input?: InputMaybe<MiServicesInput>;
};


export type MutationAddMiServicesOverhaulFieldsToPoiTemplatesArgs = {
  input?: InputMaybe<MiServicesPoiTemplateInput>;
};


export type MutationAddNewAssemblyTagNameArgs = {
  input?: InputMaybe<AddNewAssemblyTagNameInput>;
};


export type MutationAddPartsToAssemblyArgs = {
  input?: InputMaybe<AddPartsToAssemblyInput>;
};


export type MutationAddReportConfigurationArgs = {
  structureId: Scalars['ID']['input'];
};


export type MutationAddUpdateCuboidArgs = {
  input?: InputMaybe<AddUpdateCuboidInput>;
};


export type MutationAddUpdateSplitCuboidOnPartArgs = {
  input?: InputMaybe<AddUpdateSplitCuboidOnPartInput>;
};


export type MutationAddUserGroupsToStructureArgs = {
  input?: InputMaybe<AddRemoveStructuresToFromUserGroupsInput>;
};


export type MutationAddUsersToTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationAddUsersToUserGroupArgs = {
  input?: InputMaybe<AddRemoveUsersToFromUserGroupInput>;
};


export type MutationAreaAndPoiRiskScoreCalculationArgs = {
  structureId: Scalars['ID']['input'];
};


export type MutationAssignRoleToUsersArgs = {
  input?: InputMaybe<AssignRemoveRoleToFromUsersInput>;
};


export type MutationBenchmarkDownloadArgs = {
  input?: InputMaybe<BenchmarkDownloadInput>;
};


export type MutationBenchmarkUploadArgs = {
  input?: InputMaybe<BenchmarkUploadInput>;
};


export type MutationBlockOrUnblockUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationBulkCreateCommentsForAssembliesArgs = {
  input?: InputMaybe<BulkCreateForAssembliesInput>;
};


export type MutationBulkLineFixingArgs = {
  input: BulkLineFixingInput;
};


export type MutationBulkPipeSpecUploadArgs = {
  input: BulkPipeSpecUploadInput;
};


export type MutationBulkUpdateReviewActionArgs = {
  input?: InputMaybe<BulkUpdateReviewActionInput>;
};


export type MutationBulkUploadPoisArgs = {
  input: BulkUploadPoisInput;
};


export type MutationBulkUploadServiceGroupsArgs = {
  input: BulkUploadServiceGroupsInput;
};


export type MutationCalculateDefectCalculationsArgs = {
  input: DefectCalculationsInput;
};


export type MutationCalculateRiskRemediationAnalyticsArgs = {
  input: RiskRemediationAnalyticsInput;
};


export type MutationClonePointOfInterestTemplateArgs = {
  input?: InputMaybe<PoiTemplateCloneInput>;
};


export type MutationCloneQuerySummaryArgs = {
  input?: InputMaybe<QuerySummaryCloneInput>;
};


export type MutationCloneTemplateFieldsArgs = {
  input?: InputMaybe<TemplateFieldsCloneInput>;
};


export type MutationCreateAnnotationArgs = {
  imageId: Scalars['String']['input'];
};


export type MutationCreateAssemblyArgs = {
  input?: InputMaybe<CreateAssemblyInput>;
};


export type MutationCreateBulkReportsArgs = {
  input?: InputMaybe<CreateNewReportInput>;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateNewReportArgs = {
  input?: InputMaybe<CreateNewReportInput>;
};


export type MutationCreatePointOfInterestArgs = {
  input?: InputMaybe<CreatePointOfInterestInput>;
};


export type MutationCreatePointOfInterestTemplateArgs = {
  input?: InputMaybe<PointOfInterestTemplateInput>;
};


export type MutationCreatePreRegisteredUsersArgs = {
  input?: InputMaybe<PreRegisteredUserInput>;
};


export type MutationCreateRegionArgs = {
  input?: InputMaybe<CreateRegionInput>;
};


export type MutationCreateRiskAssessmentDetailsArgs = {
  input?: InputMaybe<CreateRiskAssessmentDetailsInput>;
};


export type MutationCreateStructureArgs = {
  input: CreateStructureInput;
};


export type MutationCreateSupervoxelClassArgs = {
  input?: InputMaybe<CreateSupervoxelClass>;
};


export type MutationCreateTeamArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateTemplateArgs = {
  input?: InputMaybe<TemplateInput>;
};


export type MutationCreateUserGroupArgs = {
  input?: InputMaybe<CreateUserGroupInput>;
};


export type MutationCreateWorkflowStageArgs = {
  input?: InputMaybe<CreateWorkflowStageInput>;
};


export type MutationCreateWorkpackArgs = {
  input?: InputMaybe<CreateWorkpackInput>;
};


export type MutationCreateWorkpackItemArgs = {
  input?: InputMaybe<CreateWorkpackItemInput>;
};


export type MutationDeleteAssemblyFromReportArgs = {
  input?: InputMaybe<DeleteAssemblyFromReportInput>;
};


export type MutationDeleteCommentArgs = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteCuboidArgs = {
  input?: InputMaybe<DeleteCuboidInput>;
};


export type MutationDeleteDraftReportArgs = {
  input?: InputMaybe<DeleteDraftReportInput>;
};


export type MutationDeleteFilesArgs = {
  input: DeleteFilesInput;
};


export type MutationDeletePointOfInterestArgs = {
  input?: InputMaybe<DeletePointOfInterestInput>;
};


export type MutationDeletePointOfInterestFromReportArgs = {
  input?: InputMaybe<DeletePointOfInterestFromReportInput>;
};


export type MutationDeletePointOfInterestTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationDeletePreRegisteredUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteReportArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type MutationDeleteTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationDeleteUserGroupArgs = {
  input?: InputMaybe<DeleteUserGroupInput>;
};


export type MutationDeleteWorkflowStageArgs = {
  input?: InputMaybe<DeleteWorkflowStageInput>;
};


export type MutationDeleteWorkpackArgs = {
  input?: InputMaybe<DeleteWorkpackInput>;
};


export type MutationDeleteWorkpackItemArgs = {
  input?: InputMaybe<DeleteWorkpackItemInput>;
};


export type MutationEvaluateAllAssembliesForStructureArgs = {
  structureId: Scalars['String']['input'];
};


export type MutationEvaluateAllPoIsForStructureArgs = {
  structureId: Scalars['String']['input'];
};


export type MutationEvaluateTemplateFieldLogicRuleArgs = {
  input: EvaluateTemplateFieldLogicRuleInput;
};


export type MutationGeneratePoiPdfArgs = {
  reportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationIdmsFileUploadArgs = {
  input: IdmsUploadMutationInput;
};


export type MutationInviteUsersArgs = {
  input?: InputMaybe<InviteUsersInput>;
};


export type MutationMarkLocationAnalysedArgs = {
  input?: InputMaybe<MarkLocationAnalysedInput>;
};


export type MutationMarkViewPointAsAnalysedFromCurrentAssemblyArgs = {
  input?: InputMaybe<MarkViewPointAsAnalysedFromCurrentAssemblyInput>;
};


export type MutationNominateGoverningPointOfInterestArgs = {
  input?: InputMaybe<NominateGoverningPointOfInterestInput>;
};


export type MutationPerformMechanicalIntegrityServicesArgs = {
  input?: InputMaybe<PerformMechanicalIntegrityServicesInput>;
};


export type MutationPoiImageCaptionArgs = {
  input?: InputMaybe<PoiImageCaptionInput>;
};


export type MutationPreSignedUrlToUploadFilesArgs = {
  input: UploadFileInput;
};


export type MutationRecalculateRiskRemediationAnalyticsArgs = {
  input: RecalculateRiskRemediationAnalyticsInput;
};


export type MutationRemoveAttachmentsFromPoiArgs = {
  input?: InputMaybe<RemoveAttachmentsInput>;
};


export type MutationRemoveRoleFromUsersArgs = {
  input?: InputMaybe<AssignRemoveRoleToFromUsersInput>;
};


export type MutationRemoveSplitCuboidOnPartArgs = {
  input?: InputMaybe<RemoveSplitCuboidOnPartInput>;
};


export type MutationRemoveUserGroupsFromStructureArgs = {
  input?: InputMaybe<AddRemoveStructuresToFromUserGroupsInput>;
};


export type MutationRemoveUsersFromTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationRemoveUsersFromUserGroupArgs = {
  input?: InputMaybe<AddRemoveUsersToFromUserGroupInput>;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRevertBulkLineFixingArgs = {
  input: RevertBulkLineFixingInput;
};


export type MutationRollbackVersionArgs = {
  input?: InputMaybe<RollbackVersionInput>;
};


export type MutationSavePointOfInterestScreenshotArgs = {
  input?: InputMaybe<SavePointOfInterestScreenshotInput>;
};


export type MutationSetAlarmLevelArgs = {
  input?: InputMaybe<SetAlarmLevelInput>;
};


export type MutationSetHiddenForPartsArgs = {
  input?: InputMaybe<UpdatePartsHiddenFlagInput>;
};


export type MutationSetReviewedForPartsArgs = {
  input?: InputMaybe<UpdatePartsReviewedFlagInput>;
};


export type MutationSplitPartArgs = {
  input?: InputMaybe<SplitPartInput>;
};


export type MutationUpdateAssembliesProbabilityOfFailureRiskFactorsArgs = {
  input?: InputMaybe<UpdateTemplateFieldDataPofInput>;
};


export type MutationUpdateAssemblyArgs = {
  input?: InputMaybe<UpdateAssemblyInput>;
};


export type MutationUpdateAssemblyBlistersArgs = {
  input?: InputMaybe<CreatePointOfInterestInput>;
};


export type MutationUpdateCalculationMethodArgs = {
  input?: InputMaybe<UpdateCalculationMethodInput>;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCuiPriorityArgs = {
  input?: InputMaybe<UpdateCuiPriorityInput>;
};


export type MutationUpdateEsSheetStatusArgs = {
  status: EsSheetStatus;
  structureId: Scalars['String']['input'];
};


export type MutationUpdateFilesStatusArgs = {
  input: UpdateFilesStatusInput;
};


export type MutationUpdateGoverningValueArgs = {
  input?: InputMaybe<UpdateGoverningValueInput>;
};


export type MutationUpdatePaintRegionIdArgs = {
  input?: InputMaybe<UpdatePaintRegionIdInput>;
};


export type MutationUpdatePaintRegionStatusArgs = {
  input?: InputMaybe<UpdatePaintRegionStatusInput>;
};


export type MutationUpdatePointOfInterestArgs = {
  input?: InputMaybe<UpdatePointOfInterestInput>;
};


export type MutationUpdatePointOfInterestFileArgs = {
  input?: InputMaybe<InputUpdateFileForPointOfInterest>;
};


export type MutationUpdatePointOfInterestImageTypeArgs = {
  input: UpdatePointOfInterestImageTypeInput;
};


export type MutationUpdatePointOfInterestLocationArgs = {
  input: UpdatePointOfInterestLocationInput;
};


export type MutationUpdatePointOfInterestTemplateArgs = {
  input?: InputMaybe<UpdatePointOfInterestTemplateInput>;
};


export type MutationUpdatePointOfInterestVisibilityArgs = {
  filters?: InputMaybe<PointOfInterestInput>;
  input?: InputMaybe<UpdatePointOfInterestVisibilityInput>;
};


export type MutationUpdatePointOfInterestsStatusArgs = {
  input: UpdatePointOfInterestsStatusInput;
};


export type MutationUpdateRemediationScoreConfigArgs = {
  input?: InputMaybe<UpdateRemediationScoreConfigInput>;
};


export type MutationUpdateReportArgs = {
  input?: InputMaybe<UpdateReportInput>;
};


export type MutationUpdateReportByPointOfInterestsArgs = {
  input?: InputMaybe<UpdateReportByPointOfInterestsInput>;
};


export type MutationUpdateReportPointOfInterestImagesArgs = {
  input?: InputMaybe<UpdateReportPointOfInterestImagesInput>;
};


export type MutationUpdateReportStatusArgs = {
  input?: InputMaybe<UpdateReportStatusInput>;
};


export type MutationUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodArgs = {
  input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput;
};


export type MutationUpdateRiskAssessmentTemplateFieldDataForAssembliesArgs = {
  input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput;
};


export type MutationUpdateScCategoryArgs = {
  input: UpdateScCategoryInput;
};


export type MutationUpdateSingleTemplateFieldDataArgs = {
  input?: InputMaybe<UpdateSingleTemplateFieldDataInput>;
};


export type MutationUpdateStructureArgs = {
  input?: InputMaybe<UpdateStructureInput>;
};


export type MutationUpdateSupervoxelsArgs = {
  input?: InputMaybe<UpdateSupervoxel>;
};


export type MutationUpdateTemplateArgs = {
  input?: InputMaybe<TemplateInput>;
};


export type MutationUpdateTemplateFieldDataArgs = {
  input?: InputMaybe<UpdateTemplateFieldDataInput>;
};


export type MutationUpdateUserColumnPreferencesArgs = {
  input?: InputMaybe<UpdateUserColumnPreferencesInput>;
};


export type MutationUpdateUserGroupArgs = {
  input?: InputMaybe<UpdateUserGroupInput>;
};


export type MutationUpdateUserInfoArgs = {
  input?: InputMaybe<UpdateUserInfoInput>;
};


export type MutationUpdateUserPreferencesArgs = {
  input?: InputMaybe<UpdateUserPreferencesInput>;
};


export type MutationUpdateWallLossFactorArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
  wallLossFactor?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateWorkflowStageArgs = {
  input?: InputMaybe<UpdateWorkflowStageInput>;
};


export type MutationUpdateWorkflowStatusArgs = {
  input?: InputMaybe<UpdateWorkflowStatusInput>;
};


export type MutationUpdateWorkflowTimeAndStateArgs = {
  input?: InputMaybe<UpdateWorkflowTimeAndStateInput>;
};


export type MutationUpdateWorkpackArgs = {
  input?: InputMaybe<UpdateWorkpackInput>;
};


export type MutationUpdateWorkpackItemArgs = {
  input?: InputMaybe<UpdateWorkpackItemInput>;
};


export type MutationUpdateWorkpackStatusArgs = {
  status: WorkpackStatus;
  workpackId: Scalars['ID']['input'];
};


export type MutationUpdateZoneStatusArgs = {
  input?: InputMaybe<UpdateZoneStatusInput>;
};


export type MutationUploadAttachmentsToPoiArgs = {
  input?: InputMaybe<UploadAttachmentsInput>;
};


export type MutationUploadCoverImageArgs = {
  input: UploadImageInput;
};


export type MutationUploadEsSheetArgs = {
  input: UploadEsSheetInput;
};


export type MutationValidateEsSheetArgs = {
  headers: Array<Scalars['String']['input']>;
};


export type MutationVerifyPointOfInterestArgs = {
  input?: InputMaybe<VerifyPointOfInterestInput>;
};

export type NameAndArea = {
  __typename?: 'NameAndArea';
  deckIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  name: Scalars['String']['output'];
  paintRegionIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  totalArea?: Maybe<Array<Maybe<AreaAndType>>>;
};

/** Paint region defects grouped by paint region group */
export type NameAndAreaByGroup = {
  __typename?: 'NameAndAreaByGroup';
  name: Scalars['String']['output'];
  paintRegionId: Scalars['ID']['output'];
  totalArea?: Maybe<Array<Maybe<AreaAndType>>>;
  totalCountByPoiType?: Maybe<Array<Maybe<AreaAndType>>>;
};

export type NeighbouringImagesOptions = {
  __typename?: 'NeighbouringImagesOptions';
  defaultMeanDistance?: Maybe<Scalars['Float']['output']>;
  isEnabledByDefault?: Maybe<Scalars['Boolean']['output']>;
  maxImagesToShow?: Maybe<Scalars['Int']['output']>;
  showFrames?: Maybe<Scalars['Boolean']['output']>;
  showImages?: Maybe<Scalars['Boolean']['output']>;
};

export type NominateGoverningPointOfInterestInput = {
  lastModifiedFor: Scalars['String']['input'];
  pointOfInterestId: Scalars['ID']['input'];
};

export type NominationCalculations = {
  __typename?: 'NominationCalculations';
  alarmLevel: Scalars['String']['output'];
  governingValue?: Maybe<GoverningValueBlister>;
};

export type NominationCalculationsInput = {
  assemblyId: Scalars['ID']['input'];
  blisterId: Scalars['ID']['input'];
};

export enum OctreeKey {
  Corrosion = 'CORROSION',
  Defect = 'DEFECT',
  Degree = 'DEGREE',
  DegreeOfRusting = 'DEGREE_OF_RUSTING'
}

export type OptionData = {
  __typename?: 'OptionData';
  max?: Maybe<Scalars['Float']['output']>;
  maxIncluded?: Maybe<Scalars['Boolean']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  minIncluded?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OptionDataInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  maxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum OptionFieldTypeEnum {
  CircularProgressBar = 'CIRCULAR_PROGRESS_BAR',
  SimpleText = 'SIMPLE_TEXT'
}

export type Overlap = {
  __typename?: 'Overlap';
  annotationId: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  /** Number of voxels that overlap with the reference annotation */
  voxelCount: Scalars['Int']['output'];
};

export type OverlapInfo = {
  __typename?: 'OverlapInfo';
  overlaps: Array<Overlap>;
};

export type PageInfo = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['Int']['input']>;
};

export type PaintBlockFiltersInput = {
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  excludeAlreadyPlannedBlocks?: InputMaybe<Scalars['Boolean']['input']>;
  paintRegionGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  structureIds: Array<Scalars['ID']['input']>;
};

export type PaintBlocksCorrodedArea = {
  __typename?: 'PaintBlocksCorrodedArea';
  defectsByDeck: Array<NameAndArea>;
  defectsByPaintBlock: Array<NameAndArea>;
  structureIds: Array<Scalars['ID']['output']>;
};

/** Response type for paint region defects by group with pagination */
export type PaintBlocksCorrodedAreaByGroup = {
  __typename?: 'PaintBlocksCorrodedAreaByGroup';
  defectsByPaintBlock: Array<NameAndAreaByGroup>;
  structureId: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

/**
 * A Paint Region is a region of space on a Deck of the Structure.
 *
 * Each deck is made up of different Paint Regions that can be actioned upon by human workers.
 */
export type PaintRegion = {
  __typename?: 'PaintRegion';
  /** Date this Paint Region was created */
  createdAt: Scalars['String']['output'];
  /** Deck that this Paint Region belongs to */
  deck: Deck;
  defectMetrics: Array<DefectMetrics>;
  /** User uploaded files to the paint region */
  files?: Maybe<Array<File>>;
  /** Unique Paint Region ID */
  id: Scalars['ID']['output'];
  linkedPoiIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** User readable identifier for the Paint Region */
  name: Scalars['String']['output'];
  /** Paint region group (e.g. Original, 5m, 10m block) */
  paintRegionGroup?: Maybe<PaintRegionGroup>;
  /** Paint region group id (e.g. Original, 5m, 10m block) */
  paintRegionGroupId?: Maybe<Scalars['ID']['output']>;
  polygons: Array<PaintRegionPolygons>;
  /** Date this Paint Region was remediated */
  remediationDate?: Maybe<Scalars['String']['output']>;
  /** Status of the Paint Region */
  status?: Maybe<PaintRegionStatus>;
  /** Date this Paint Region was last updated */
  updatedAt: Scalars['String']['output'];
  /** 3d-volume of paint region */
  volume?: Maybe<ComplexPrismVolume>;
};

/** Generic paint region group collection */
export type PaintRegionGroup = {
  __typename?: 'PaintRegionGroup';
  /** Grid size for voxel grid type */
  gridSize?: Maybe<Scalars['Int']['output']>;
  /** Unique Paint Region Group ID */
  id: Scalars['ID']['output'];
  /** Whether this is the default paint region group */
  isDefault: Scalars['Boolean']['output'];
  /** Name of the paint region group */
  name: Scalars['String']['output'];
  /** Structure that this Paint Region Group belongs to */
  structure: Structure;
  /** Type of the paint region group */
  type: PaintRegionGroupTypeEnum;
};

export type PaintRegionGroupFiltersInput = {
  structureId: Scalars['ID']['input'];
};

/** Types of paint region groups */
export enum PaintRegionGroupTypeEnum {
  PaintRegion = 'PAINT_REGION',
  VoxelGrid = 'VOXEL_GRID'
}

export type PaintRegionPolygons = {
  __typename?: 'PaintRegionPolygons';
  area: Scalars['Float']['output'];
  points: Array<Array<Scalars['Float']['output']>>;
  /** Type of this PaintRegion polygon; i.e. plan */
  type?: Maybe<Scalars['String']['output']>;
};

export enum PaintRegionStatus {
  InspectionPending = 'INSPECTION_PENDING',
  InProgress = 'IN_PROGRESS',
  NoWorkRequired = 'NO_WORK_REQUIRED',
  Remediated = 'REMEDIATED',
  Scheduled = 'SCHEDULED'
}

export type PaintRegionVolumeInput = {
  /** Integer id of paint region */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** 3d-volume of paint region */
  volume?: InputMaybe<ComplexPrismVolumeInput>;
};

export type PaintRegionVolumesInput = {
  /** All paint region volumes for the structure */
  regions?: InputMaybe<Array<InputMaybe<PaintRegionVolumeInput>>>;
};

/** An individual Part of the Structure. */
export type Part = {
  __typename?: 'Part';
  /** Assembly that this Part belongs to */
  assembly?: Maybe<Assembly>;
  assemblyId?: Maybe<Scalars['ID']['output']>;
  /** Class (grouping) of this Part */
  class: Scalars['String']['output'];
  /** Corrosion detected on the entire part */
  corrosion?: Maybe<Corrosion>;
  /** Date this Part was created */
  createdAt: Scalars['String']['output'];
  /** Parts this part grouped with for graph assisted tagging */
  groupedPartIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** Unique Part ID */
  id: Scalars['ID']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  /** Part is hidden if it is not relevant to this structure */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** User marks if a Part is reviewed */
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  /** Unstructured metadata about this Part */
  meta: Array<Meta>;
  /** All the viewpoints that can see any portion of this part */
  seenByViewpoints?: Maybe<Array<SeenByViewpoint>>;
  /** Split Cuboids define split points from this Part in data processing */
  splitCuboids?: Maybe<Array<SplitCuboid>>;
  /** Identifier for the Structure that this  belongs to */
  structure: Structure;
  template: Template;
  /** Date this Part was last updated */
  updatedAt: Scalars['String']['output'];
  /** User who last updated this Part */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PartGroup = {
  __typename?: 'PartGroup';
  /** Part Ids part of this group */
  groupedParts: Array<Scalars['String']['output']>;
  /** Unique Zone ID */
  id: Scalars['ID']['output'];
  /** Structure of this Zone */
  structure: Structure;
};

export type PartHiddenFlagUpdatedNotification = {
  __typename?: 'PartHiddenFlagUpdatedNotification';
  assemblyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['String']['output'];
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type PartLegend = {
  __typename?: 'PartLegend';
  color: Scalars['String']['output'];
  legendText?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type PartReviewFlagUpdatedNotification = {
  __typename?: 'PartReviewFlagUpdatedNotification';
  assemblyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  structureId: Scalars['ID']['output'];
  userId: Scalars['String']['output'];
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type PartSplitNotification = {
  __typename?: 'PartSplitNotification';
  assemblyName?: Maybe<Scalars['String']['output']>;
  newPartId: Scalars['ID']['output'];
  originalPartId: Scalars['ID']['output'];
  structureId?: Maybe<Scalars['ID']['output']>;
  updatedAnnotationIds: Array<Scalars['ID']['output']>;
  updatedAnnotations: Array<Annotation>;
  userId: Scalars['String']['output'];
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type PartsAddedToAssemblyNotification = {
  __typename?: 'PartsAddedToAssemblyNotification';
  assemblyId?: Maybe<Scalars['ID']['output']>;
  assemblyName?: Maybe<Scalars['String']['output']>;
  isReviewed?: Maybe<Scalars['Boolean']['output']>;
  partId: Scalars['ID']['output'];
  structureId?: Maybe<Scalars['ID']['output']>;
  userId: Scalars['String']['output'];
  zoneId?: Maybe<Scalars['String']['output']>;
};

export enum PausedBy {
  System = 'SYSTEM',
  User = 'USER'
}

export type PdfGenerationResult = {
  __typename?: 'PdfGenerationResult';
  base64Data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  downloadUrl?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  error?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success: Scalars['Boolean']['output'];
};

export type PerformMechanicalIntegrityServicesInput = {
  /** Add MI fields flag */
  addMIFields?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Assembly IDs */
  assemblyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Force update flag */
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Blister height type */
  heightType?: InputMaybe<BlisterHeightType>;
  /** Initialize flag */
  initialize?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bulk update flag */
  isBulkUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason for the last update */
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  /** Unique Point of Interest IDs */
  pointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Reset overridden flag */
  resetOverridden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
};

export type Permission = {
  __typename?: 'Permission';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PipeSpec = {
  __typename?: 'PipeSpec';
  /** The material used in the construction of this pipe */
  material?: Maybe<Scalars['String']['output']>;
  /** Amount of corrosion allowed for the pipe (in mm) */
  nominalCorrosionAllowance?: Maybe<Scalars['Float']['output']>;
  /** Nominal thickness of the pipe wall (in mm) */
  nominalThickness?: Maybe<Scalars['Float']['output']>;
  /** Pipe schedule is how the wall thickness of a pipe is described */
  schedule?: Maybe<Scalars['String']['output']>;
  /** Standard pipe size - Nominal pipe size (NPS) for non-metric or Diametre nominal (DN) for metric) */
  size?: Maybe<Scalars['String']['output']>;
  /** Pipe specification code */
  spec?: Maybe<Scalars['String']['output']>;
};

export type PipeSpecInput = {
  /** The material used in the construction of this pipe */
  material?: InputMaybe<Scalars['String']['input']>;
  /** Amount of corrosion allowed for the pipe (in mm) */
  nominalCorrosionAllowance?: InputMaybe<Scalars['Float']['input']>;
  /** Nominal thickness of the pipe wall (in mm) */
  nominalThickness?: InputMaybe<Scalars['Float']['input']>;
  /** Pipe schedule is how the wall thickness of a pipe is described */
  schedule?: InputMaybe<Scalars['String']['input']>;
  /** Standard pipe size - Nominal pipe size (NPS) for non-metric or Diametre nominal (DN) for metric) */
  size: Scalars['String']['input'];
  /** Pipe specification code */
  spec: Scalars['String']['input'];
};

export type Platform = {
  __typename?: 'Platform';
  /** Path for cover image for this Platform */
  coverImagePath: Scalars['String']['output'];
  /** Unique platform ID */
  id: Scalars['ID']['output'];
  /** Name of this platform */
  name: Scalars['String']['output'];
  /** Card insight detail for a platform */
  platformCardInsights?: Maybe<Array<PlatformCardInsights>>;
  /** Card summary detail for a platform */
  platformSummary?: Maybe<Array<PlatformCardSummary>>;
  /** Region to which this platform belongs */
  region?: Maybe<Region>;
};

export type PlatformCardInsights = {
  __typename?: 'PlatformCardInsights';
  displayConfig?: Maybe<PlatformCardInsightsDisplayConfig>;
  group: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PlatformCardInsightsDisplayConfig = {
  __typename?: 'PlatformCardInsightsDisplayConfig';
  /** Where this insight should show up in the bar chart */
  barIndex?: Maybe<Scalars['Int']['output']>;
  /** Color indicator for the insight. Can be used in multiple contexts like bar chars or legends */
  color?: Maybe<Scalars['String']['output']>;
  /** Whether to display a divider after this Card's list entry or not */
  divider?: Maybe<Scalars['Boolean']['output']>;
  /** Where this insight should show up in the list */
  listIndex?: Maybe<Scalars['Int']['output']>;
  /** Display unit i.e ft2, m, mm */
  unit?: Maybe<Scalars['String']['output']>;
};

export type PlatformCardSummary = {
  __typename?: 'PlatformCardSummary';
  displayConfig?: Maybe<PlatformCardInsightsDisplayConfig>;
  group: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum PoiAccessibilityEnum {
  NotApplicable = 'NOT_APPLICABLE',
  NoScaffoldingRequired = 'NO_SCAFFOLDING_REQUIRED',
  ScaffoldingRequired = 'SCAFFOLDING_REQUIRED'
}

export type PoiCuboid = {
  __typename?: 'PoiCuboid';
  /** Unique ID for this cuboid */
  id: Scalars['ID']['output'];
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['output']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Abyss conventions. */
  rotation: Array<Scalars['Float']['output']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['output']>;
};

export type PoiImageCaptionInput = {
  caption: Scalars['String']['input'];
  lastModifiedFor: Scalars['String']['input'];
  poiAttachmentId: Scalars['String']['input'];
  pointOfInterestId: Scalars['ID']['input'];
  uuid: Scalars['String']['input'];
};

export type PoiLineMeasurement = {
  __typename?: 'PoiLineMeasurement';
  points?: Maybe<Array<Maybe<PoiMeasurementPoint>>>;
};

export type PoiLineMeasurementInput = {
  points?: InputMaybe<Array<InputMaybe<PoiMeasurementPointInput>>>;
};

export type PoiMeasurementPoint = {
  __typename?: 'PoiMeasurementPoint';
  coordinates: Array<Scalars['Float']['output']>;
  templateFieldId: Scalars['ID']['output'];
};

export type PoiMeasurementPointInput = {
  coordinates: Array<Scalars['Float']['input']>;
  templateFieldId: Scalars['ID']['input'];
};

export enum PoiPriority {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum PoiStatus {
  ChaseItemAdded = 'CHASE_ITEM_ADDED',
  Completed = 'COMPLETED',
  Inprogress = 'INPROGRESS',
  Inreview = 'INREVIEW',
  Remediated = 'REMEDIATED'
}

export type PoiTemplateCloneInput = {
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Point of interest template IDs */
  pointOfInterestTemplateIds: Array<Scalars['ID']['input']>;
  /** Structure relation for this Template */
  structureId: Scalars['ID']['input'];
};

export type Point = {
  __typename?: 'Point';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

/**
 * A point of interest (POI) marked in 3d space.
 * POI can be marked from a Location and for a specific Part optionally.
 */
export type PointOfInterest = {
  __typename?: 'PointOfInterest';
  /** Accessibility of this POI */
  accessibility?: Maybe<PoiAccessibilityEnum>;
  /** Assembly that this POI belongs to */
  assembly: Assembly;
  /**
   * Linked to a structure's assembly template, to create a distinction b/w
   * a structure's different offerings i.e structure, pressure, combined
   */
  assemblyTemplate?: Maybe<Template>;
  /** User whom this Point of interest is assigned to */
  assignee?: Maybe<Scalars['String']['output']>;
  /** Additional Blister metadata for this POI (if type is BLISTER) */
  blister?: Maybe<Blister>;
  /** Camera point in 3d space looking at this POI */
  cameraLocation?: Maybe<Vector3>;
  /**
   * Approximate center of where the POI was measured from in 3d space.
   * This is used to navigate to and display POIs.
   * Marking them as optional to allow for bulk upload of POIs
   * since bulk uploaded POIs wont have any 3D data associated with them
   */
  centerPoint3d?: Maybe<Vector3>;
  /**
   * A comment left by the creator of the POI. This comment is different
   * from the comments in the comment tab, in the sense that this one
   * appears in the POI table, is sortable and works just like any other field
   */
  comment?: Maybe<Scalars['String']['output']>;
  /** Date this Point of interest was created */
  createdAt: Scalars['String']['output'];
  /** User who created this Point of interest */
  createdByUser?: Maybe<User>;
  /** Cuboids of volume of interest */
  cuboids?: Maybe<Array<PoiCuboid>>;
  /** Height of this POI from nearest deck */
  deckRelativeHeight?: Maybe<Scalars['Float']['output']>;
  /** Due date of rectification for this Point of interest */
  dueDate?: Maybe<Scalars['String']['output']>;
  /** Image or PDF attached to POI */
  files?: Maybe<Array<File>>;
  /** Unique POI ID */
  id: Scalars['ID']['output'];
  /** POI is auto generated after the scans */
  isAutoGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to indicate if the POI fields should be evaluated */
  isFieldEvaluationSkipped?: Maybe<Scalars['Boolean']['output']>;
  isGoverning?: Maybe<Scalars['Boolean']['output']>;
  /** POI is created by a source other than the viewer or imported from a file */
  isManuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this POI has been verified by an inspector */
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Line measurements for this POI. This measurment is a list of points and an optional styles object. The measurement is recorded on the frontend using the **Measurement Tool** */
  lineMeasurement?: Maybe<PoiLineMeasurement>;
  /** Linked POIs to the cuboid */
  linkedPointOfInterestIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Location that this POI belongs to (if POI marked from a Location) */
  location?: Maybe<Location>;
  /** Location ID that this POI belongs to (if POI marked from a Location) */
  locationId?: Maybe<Scalars['ID']['output']>;
  /** Unstructured metadata about this POI */
  meta: Array<Meta>;
  /** Name of this POI */
  name?: Maybe<Scalars['String']['output']>;
  /** Paint Region that this POI belongs to (backward-compatible, maps to the first paint region in paintRegions) */
  paintRegion?: Maybe<PaintRegion>;
  /** List of Paint Regions that this POI belongs to */
  paintRegions?: Maybe<Array<PaintRegion>>;
  /** Part that this POI belongs to (if Part selected from UI before POI marked) */
  part?: Maybe<Part>;
  /** A user friendly ID in the format of {POI Type}-{Number} */
  poiId?: Maybe<Scalars['String']['output']>;
  /** Priority of this Point of interest */
  priority?: Maybe<PoiPriority>;
  /** Remediation Note with POI */
  remediationNote?: Maybe<Scalars['String']['output']>;
  /** Paths to saved screenshots for this POI */
  screenshotPaths?: Maybe<ScreenshotPaths>;
  /** Date this Point of interest was assigned */
  status?: Maybe<PoiStatus>;
  /** Tab from where poi status is updated */
  statusRemediatedThrough?: Maybe<StatusRemediatedThrough>;
  /** Teams that this POI is shared with */
  teams: Array<Team>;
  /** Template related to this POI for dynamic data */
  template?: Maybe<PointOfInterestTemplate>;
  /** Data values associated with Template for this POI */
  templateData?: Maybe<Array<TemplateData>>;
  /** Template data, but store as key value pairs */
  templateFieldData?: Maybe<Scalars['JSON']['output']>;
  /** Template ID related to this POI */
  templateId?: Maybe<Scalars['ID']['output']>;
  /** Type of this POI */
  type: Scalars['String']['output'];
  /** Unlinked POIs to the cuboid */
  unlinkedPointOfInterestIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** User who verified this Point of interest */
  verifiedByUser?: Maybe<User>;
  /** Height of the POI relative to the viewpoint it was created from */
  viewpointRelativeHeight?: Maybe<Scalars['Float']['output']>;
  /** Visibility settings for this POI (private, public, custom) */
  visibility?: Maybe<VisibilityEnum>;
  /** Workpack id of this poi */
  workpack?: Maybe<Workpack>;
  /** Workpack number of POI */
  workpackNumber?: Maybe<Scalars['String']['output']>;
};

export type PointOfInterestFindingAndName = {
  __typename?: 'PointOfInterestFindingAndName';
  name: Scalars['String']['output'];
  pointOfInterestFindings: Array<PointOfInterestFindings>;
  totalCount: Scalars['Float']['output'];
};

export type PointOfInterestFindings = {
  __typename?: 'PointOfInterestFindings';
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type PointOfInterestImages = {
  __typename?: 'PointOfInterestImages';
  pointOfInterestId: Scalars['ObjectId']['output'];
  selectedImages?: Maybe<Array<Maybe<File>>>;
};

export type PointOfInterestInput = {
  accessibility?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deckRelativeHeight?: InputMaybe<Array<InputMaybe<RangeInput>>>;
  excludePoisWithWorkpack?: InputMaybe<Scalars['Boolean']['input']>;
  includeManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionPriorityTemplateFieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isGoverning?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isManuallyCreated?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isVerified?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  mediaAttachment?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  paintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paintRegionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  poiIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedPoiFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  unAssignedPoi?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  workpackIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PointOfInterestMultiStructureInput = {
  accessibility?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deckRelativeHeight?: InputMaybe<Array<InputMaybe<RangeInput>>>;
  excludePoisWithWorkpack?: InputMaybe<Scalars['Boolean']['input']>;
  includeManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  inspectionPriorityTemplateFieldIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isGoverning?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isManuallyCreated?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isVerified?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  mediaAttachment?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  paintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  paintRegionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  poiIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedPoiFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureIds: Array<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unAssignedPoi?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  workpackIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type PointOfInterestPdfs = {
  __typename?: 'PointOfInterestPdfs';
  pointOfInterestId: Scalars['ObjectId']['output'];
  selectedPdfs?: Maybe<Array<FileWithStatus>>;
};

export type PointOfInterestTemplate = {
  __typename?: 'PointOfInterestTemplate';
  /** Color used for graph legends */
  accentColor?: Maybe<Scalars['String']['output']>;
  /** User who created this Template */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Field definitions for this Template */
  fields: Array<PointOfInterestTemplateField>;
  /** Icon for POI */
  icon?: Maybe<TemplateIcon>;
  /** Unique Template ID */
  id: Scalars['ID']['output'];
  /** Should this field be allowed to be uploaded via CSV bulk upload */
  isCsvUploadable?: Maybe<Scalars['Boolean']['output']>;
  /** Key to identify template in template data in kabab case */
  key?: Maybe<Scalars['String']['output']>;
  /** Auth0 ID of the user who last updated this POI Template */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Configuration for marker labels */
  markerLabelConfig?: Maybe<MarkerLabelConfig>;
  /** Name of this Template */
  name: Scalars['String']['output'];
  /** Permission the user should have to access this template. e.g generic engineer don't have read:defects permission so he cannot access those template if permission = read:defects */
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Identifier for the Structure that this  belongs to */
  structure: Structure;
  /** Type of this Template */
  type?: Maybe<PointOfInterestTemplateTypeEnum>;
};

export type PointOfInterestTemplateField = TemplateField & {
  __typename?: 'PointOfInterestTemplateField';
  /** Logic engine expression to evaluate the equation key used for calculating the field value */
  calculatedBy?: Maybe<LogicEvaluationRule>;
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: Maybe<Scalars['String']['output']>;
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  /** Identify if field should be shown in the poi filters */
  displayInQuery?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be hidden in report */
  displayInReports?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be visible in review */
  displayInReview?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field should be shown in the poi table */
  displayInTable?: Maybe<Scalars['Boolean']['output']>;
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Enable Measurement Tool */
  isMeasurementToolEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Key to identify field in template data */
  key?: Maybe<Scalars['String']['output']>;
  /** Logic engine expression to evaluate the field value */
  logicRule?: Maybe<LogicEvaluationRule>;
  /** Name of this Template Field */
  name: Scalars['String']['output'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['output']>;
  /** Details of valid options for this Template Field value */
  optionsData?: Maybe<Array<OptionData>>;
  /** Type of permission that a user have to read the template */
  permission?: Maybe<Scalars['String']['output']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Identify if field's value should be evaluated using the logic engine */
  shouldEvaluateLogic?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the logic engine after the math engine */
  shouldEvaluateLogicPostCalculation?: Maybe<Scalars['Boolean']['output']>;
  /** Identify if field's value should be evaluated using the math engine */
  shouldEvaluateMath?: Maybe<Scalars['Boolean']['output']>;
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: Maybe<UnitsEnum>;
};

export type PointOfInterestTemplateInput = {
  /** Color used for graph legends */
  accentColor?: InputMaybe<Scalars['String']['input']>;
  /** Field definitions for this Template */
  fields: Array<InputPointOfInterestTemplateField>;
  /** Icon for POI */
  icon?: InputMaybe<TemplateIconInput>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Configuration for annotations */
  markerLabelConfig?: InputMaybe<MarkerLabelConfigInput>;
  /** Name of this Template */
  name: Scalars['String']['input'];
  /** Permission the user should have to access this template. e.g generic engineer don't have read:defects permission so he cannot access those template if permission = read:defects */
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Structure relation for this POITemplate */
  structureId: Scalars['ID']['input'];
  /** Type of this Template */
  type?: InputMaybe<PointOfInterestTemplateTypeEnum>;
};

export enum PointOfInterestTemplateTypeEnum {
  PaintBlockVolumeOfInterest = 'PAINT_BLOCK_VOLUME_OF_INTEREST',
  PointOfInterest = 'POINT_OF_INTEREST',
  VolumeOfInterest = 'VOLUME_OF_INTEREST'
}

export type PointOfInterestsCountByType = {
  __typename?: 'PointOfInterestsCountByType';
  count?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PointOfInterestsFindingsByDeckAndPaintBlock = {
  __typename?: 'PointOfInterestsFindingsByDeckAndPaintBlock';
  findingsByDeck: Array<PointOfInterestFindingAndName>;
  findingsByPaintBlock: Array<PointOfInterestFindingAndName>;
  structureIds: Array<Scalars['ID']['output']>;
};

export type PointOfInterestsGroupedByWorkpack = {
  __typename?: 'PointOfInterestsGroupedByWorkpack';
  _id?: Maybe<Scalars['ID']['output']>;
  assembliesCount?: Maybe<Scalars['Float']['output']>;
  pointOfInterestsCount?: Maybe<Scalars['Float']['output']>;
  verifiedPointOfInterestsCount?: Maybe<Scalars['Float']['output']>;
  workpack?: Maybe<Workpack>;
};

export type PolarCoordinates = {
  __typename?: 'PolarCoordinates';
  /** Rotation of camera angle */
  bearing: Scalars['Float']['output'];
  /** Elevation of camera angle */
  elevation: Scalars['Float']['output'];
  /** Distance to camera */
  range: Scalars['Float']['output'];
};

export type PolarPoint = {
  __typename?: 'PolarPoint';
  bearing: Scalars['Float']['output'];
  elevation: Scalars['Float']['output'];
};

export type PolarPointInput = {
  bearing: Scalars['Float']['input'];
  elevation: Scalars['Float']['input'];
};

export type PolarPointMeasurementInput = {
  /** Rotation of camera angle */
  bearing: Scalars['Float']['input'];
  /** Elevation of camera angle */
  elevation: Scalars['Float']['input'];
};

export type Polygon = {
  __typename?: 'Polygon';
  area: Scalars['Float']['output'];
  centroid: Array<Scalars['Float']['output']>;
  points: Array<Array<Scalars['Float']['output']>>;
};

export type Polygon3d = {
  __typename?: 'Polygon3d';
  points: Array<Vector3>;
};

export type Polygon3dInput = {
  points: Array<Vector3Input>;
};

export type Pose = {
  pitch: Scalars['Float']['input'];
  roll: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  yaw: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

/** PreRegisteredUser is a user but not yet loggedin. */
export type PreRegisteredUser = {
  __typename?: 'PreRegisteredUser';
  /** Email of this PreRegisteredUser */
  email: Scalars['String']['output'];
  /** User Group Ids of this PreRegisteredUser */
  groups: Array<UserGroup>;
  /** Unique PreRegisteredUser ID */
  id: Scalars['ID']['output'];
  /** Roles of user */
  roleIds: Array<Maybe<Role>>;
  /** When a user logins it's object id will be stored here */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type PreRegisteredUserInput = {
  emails: Array<Scalars['String']['input']>;
  groups: Array<Scalars['String']['input']>;
  roleIds: Array<Scalars['String']['input']>;
};

export type PrismVolume = {
  __typename?: 'PrismVolume';
  /** Closed 2d polygon (points) */
  xy_polygon: Array<Array<Scalars['Float']['output']>>;
  /** Prism low and high level in z-dimention */
  z_range: Array<Scalars['Float']['output']>;
};

export type PrismVolumeInput = {
  /** Closed 2d polygon (points) */
  xy_polygon: Array<Array<Scalars['Float']['input']>>;
  /** Prism low and high level in z-dimention */
  z_range: Array<Scalars['Float']['input']>;
};

export type ProcessingReferences = {
  __typename?: 'ProcessingReferences';
  localAnnotationId: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  Annotations: Array<Annotation>;
  GetPointOfInterestGroupedByWorkpack: Array<PointOfInterestsGroupedByWorkpack>;
  GetPointOfInterestGroupedByWorkpackCount?: Maybe<Count>;
  UserGroupsByStructureId?: Maybe<Array<Maybe<UserGroup>>>;
  allAnnotations: Array<Annotation>;
  allAssemblies: Array<Assembly>;
  allAssemblyPaintRegions: Array<AssemblyPaintRegion>;
  allClients: Array<Client>;
  allComments?: Maybe<Array<Comment>>;
  allCuboids: Array<Maybe<Cuboid>>;
  allDecks: Array<Deck>;
  allDefects: Array<Defect>;
  allHistories: Array<History>;
  allImageSensors: Array<ImageSensor>;
  allLabelAnnotations: Array<Maybe<LabelAnnotation>>;
  allLocations: Array<Location>;
  allLocationsForAssembly?: Maybe<Array<Location>>;
  allPaintRegions: Array<PaintRegion>;
  allParts: Array<Part>;
  allPlatforms: Array<Platform>;
  /** Get all POITemplate */
  allPointOfInterestTemplate: Array<PointOfInterestTemplate>;
  /** Find all points of interest with optional filter arguments */
  allPointOfInterests: Array<PointOfInterest>;
  allRegions?: Maybe<Array<Region>>;
  allReportImages: Array<PointOfInterestImages>;
  allReports: Array<Maybe<Report>>;
  allRoles: Array<Maybe<Role>>;
  allStructures: Array<Structure>;
  allStructuresByRegion: Array<AllStructuresByRegion>;
  allTeams: Array<Team>;
  allTemplates: Array<Template>;
  allUserGroups: Array<UserGroup>;
  allUsers: Array<User>;
  allVersions: Array<Version>;
  allWorkpackItems: Array<WorkpackItem>;
  allWorkpacks: Array<Workpack>;
  /** Get analytics records with flexible filtering */
  analytics: Array<Analytics>;
  annotation?: Maybe<Annotation>;
  assembly?: Maybe<Assembly>;
  assemblyByTagName?: Maybe<Assembly>;
  client?: Maybe<Client>;
  cuboidsByClassId: Array<Maybe<Cuboid>>;
  cuboidsByZoneId: Array<Maybe<Cuboid>>;
  deck?: Maybe<Deck>;
  decksWithDefects: Array<DeckWithDefects>;
  defectsAreaByStructures: Array<DefectsAreaByStructuresResult>;
  defectsAreaForAssemblyPaintRegions: PaintBlocksCorrodedArea;
  /** Get paint region defects grouped by paint region group */
  defectsAreaForAssemblyPaintRegionsByGroup: PaintBlocksCorrodedAreaByGroup;
  /** Calculate dynamic block information for assembly paint regions */
  dynamicBlockCalculation: Scalars['JSON']['output'];
  /** Measure max height of a blister on the Location */
  fetchBlisterHeightMeasurement?: Maybe<BlisterHeightMeasurement>;
  fetchCropFromRectilinear?: Maybe<GenerateImageResult>;
  fetchDynamicSpatialBlockCalculation?: Maybe<Scalars['JSON']['output']>;
  fetchGenerateImage?: Maybe<GenerateImageResult>;
  fetchGetPaintRegionOfPoint?: Maybe<Scalars['Int']['output']>;
  /** Measure distance between two line points on the Location */
  fetchLineMeasurement?: Maybe<LineMeasurement>;
  fetchSpatialHeatmap?: Maybe<SpatialHeatmap>;
  filteredOptions: Array<FilteredOptions>;
  getAlarmLevelSummary?: Maybe<Array<Maybe<AlarmLevelSummaryResult>>>;
  /** Get all POI icons */
  getAllPoiIcons: Array<Maybe<Scalars['String']['output']>>;
  getAssembliesByRiskAssessmentFilters: Array<Assembly>;
  getAssembliesByTemplateFieldDataFilters: Array<Assembly>;
  getAssembliesByTemplateFieldsFilters: Array<Assembly>;
  getAssembliesByTemplateFieldsFiltersForChat: Array<Assembly>;
  getAssembliesCount?: Maybe<Count>;
  getAssembliesDecksSummary: Array<Maybe<DeckAreaSummary>>;
  getAssembliesRiskAssessmentSummary: Array<Maybe<RiskAssessmentSummary>>;
  getAssembliesSummary: Array<AssemblySummary>;
  getAuth0Connections: Array<ConnectionAuth0>;
  getAuth0Permissions: Array<Permission>;
  getDependentRiskAssessmentOptions?: Maybe<Array<Maybe<RiskAssessmentDependentOptions>>>;
  getDirectlyAssignedUserPermissions: Array<Permission>;
  getNominationCalculations?: Maybe<NominationCalculations>;
  getPreRegisteredUserRoles: Array<Role>;
  getRiskAssembliesCount?: Maybe<Count>;
  getRiskAssessmentSummaryCounts?: Maybe<RiskAssessmentSummaryCounts>;
  getRiskAssessmentSummaryData?: Maybe<Array<Maybe<RiskAssessmentSummaryData>>>;
  getRiskAssessmentSummaryTableData: Array<RiskAssessmentSummaryTableData>;
  getSummarySheetGraphsCount?: Maybe<Array<Maybe<SummarySheetGraphsCount>>>;
  getUserAbilities?: Maybe<Scalars['String']['output']>;
  getUserColumnPreferences?: Maybe<UserColumnPreferences>;
  getUserPermissionsByRoles: Array<Auth0UserRoles>;
  getUserPreferences?: Maybe<UserPreferences>;
  groupedReports: Array<Maybe<GroupedReports>>;
  groupsByPartIds: Array<PartGroup>;
  idmsTasks: IdmsTasksWithCount;
  idmsUploads: Array<IdmsUpload>;
  imageSensor?: Maybe<ImageSensor>;
  latestIdmsUploadsByType: Array<IdmsUpload>;
  location?: Maybe<Location>;
  me?: Maybe<CurrentUser>;
  myUserGroups: Array<UserGroup>;
  paintDamageCountByAlarmLevel?: Maybe<Array<Maybe<AnomalyCount>>>;
  paintRegion?: Maybe<PaintRegion>;
  paintRegionByName?: Maybe<PaintRegion>;
  /** Get all paint region groups */
  paintRegionGroups: Array<PaintRegionGroup>;
  part?: Maybe<Part>;
  permissionsByRole: Array<RolePermission>;
  platform?: Maybe<Platform>;
  /** Find one point of interest */
  pointOfInterest?: Maybe<PointOfInterest>;
  pointOfInterestCountByPaintRegions: PointOfInterestsFindingsByDeckAndPaintBlock;
  /** Find one point of interest template */
  pointOfInterestTemplate?: Maybe<PointOfInterestTemplate>;
  pointOfInterests: Array<PointOfInterest>;
  pointOfInterestsCount?: Maybe<Count>;
  pointOfInterestsCountByDueDate?: Maybe<Array<Maybe<AnomalyCount>>>;
  pointOfInterestsCountByInspectionPriority?: Maybe<Array<Maybe<AnomalyCount>>>;
  pointOfInterestsCountByStatus?: Maybe<Array<Maybe<AnomalyCount>>>;
  pointOfInterestsCountByType?: Maybe<Array<Maybe<PointOfInterestsCountByType>>>;
  pointOfInterestsCountForChat?: Maybe<Count>;
  pointOfInterestsForChat: Array<PointOfInterest>;
  preRegisteredUsers: Array<PreRegisteredUser>;
  preRegisteredUsersCount: Count;
  report: Report;
  scCategoryOptions: Array<Scalars['String']['output']>;
  setting?: Maybe<Setting>;
  sphericalsPerZone?: Maybe<Array<SphericalsPerZone>>;
  structure?: Maybe<Structure>;
  structuresByUserGroup: Array<Structure>;
  structuresCount?: Maybe<Count>;
  supervoxelsClassesForStructure: Array<SupervoxelClass>;
  supervoxelsForStructure: Array<Maybe<SuperVoxels>>;
  team: Team;
  /** Find one Template */
  template?: Maybe<Template>;
  user?: Maybe<User>;
  userDetails: UserProfile;
  userGroup?: Maybe<UserGroup>;
  userGroupsCount?: Maybe<Count>;
  usersByRoleId: Array<User>;
  usersByTeam: Array<User>;
  usersByUserGroup: Array<User>;
  usersCount?: Maybe<Count>;
  validateBulkPoiUpload: Scalars['String']['output'];
  validateIdmsTemplate?: Maybe<Scalars['String']['output']>;
  validateReportScope: ValidateReportScopeResult;
  workpack?: Maybe<Workpack>;
  workpackItem?: Maybe<WorkpackItem>;
  zonesAndHistoriesFor: Array<ZoneAndHistory>;
  zonesForStructure: Array<Zone>;
  zonesForStructureCSV: Scalars['String']['output'];
  zonesPerStage?: Maybe<Array<ZonesPerWorklowStage>>;
  zonesPerStatusCount: Array<ZoneStatusCount>;
};


export type QueryAnnotationsArgs = {
  imageId: Scalars['String']['input'];
};


export type QueryGetPointOfInterestGroupedByWorkpackArgs = {
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetPointOfInterestGroupedByWorkpackCountArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryUserGroupsByStructureIdArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllAnnotationsArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAssembliesArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllAssemblyPaintRegionsArgs = {
  input?: InputMaybe<PaintBlockFiltersInput>;
};


export type QueryAllCommentsArgs = {
  input?: InputMaybe<AllCommentsInput>;
};


export type QueryAllCuboidsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllDecksArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllDefectsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllHistoriesArgs = {
  collectionName?: InputMaybe<Scalars['String']['input']>;
  eventNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllImageSensorsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllLabelAnnotationsArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllLocationsArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllLocationsForAssemblyArgs = {
  input?: InputMaybe<LocationsForAssemblyInput>;
};


export type QueryAllPaintRegionsArgs = {
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllPartsArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllPlatformsArgs = {
  regionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllPointOfInterestTemplateArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllPointOfInterestsArgs = {
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  includeManuallyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  partId?: InputMaybe<Scalars['ID']['input']>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  workpackId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllReportImagesArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryAllReportsArgs = {
  input?: InputMaybe<ReportsInput>;
};


export type QueryAllStructuresArgs = {
  input?: InputMaybe<StructureFilters>;
};


export type QueryAllTemplatesArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
};


export type QueryAllUserGroupsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAllUsersArgs = {
  input?: InputMaybe<FilterForUsers>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryAllVersionsArgs = {
  input?: InputMaybe<VersionInput>;
};


export type QueryAllWorkpackItemsArgs = {
  workpackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllWorkpacksArgs = {
  hasPois?: InputMaybe<Scalars['Boolean']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsArgs = {
  input?: InputMaybe<AnalyticsFiltersInput>;
};


export type QueryAnnotationArgs = {
  annotationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssemblyArgs = {
  assemblyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssemblyByTagNameArgs = {
  structureId: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
};


export type QueryClientArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCuboidsByClassIdArgs = {
  cuboidClassId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCuboidsByZoneIdArgs = {
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeckArgs = {
  deckId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDecksWithDefectsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDefectsAreaByStructuresArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryDefectsAreaForAssemblyPaintRegionsArgs = {
  input: PaintBlockFiltersInput;
};


export type QueryDefectsAreaForAssemblyPaintRegionsByGroupArgs = {
  input: PaintBlockFiltersInput;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryDynamicBlockCalculationArgs = {
  input: DynamicBlockCalculationInput;
};


export type QueryFetchBlisterHeightMeasurementArgs = {
  blisterMeasurementPoints?: InputMaybe<BlisterMeasurementInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchCropFromRectilinearArgs = {
  input?: InputMaybe<GenerateCropFromRectilinearInput>;
};


export type QueryFetchDynamicSpatialBlockCalculationArgs = {
  input?: InputMaybe<DynamicSpatialHeatmapInput>;
};


export type QueryFetchGenerateImageArgs = {
  input?: InputMaybe<GenerateImageInput>;
};


export type QueryFetchGetPaintRegionOfPointArgs = {
  paintRegions?: InputMaybe<PaintRegionVolumesInput>;
  point?: InputMaybe<Array<Scalars['Float']['input']>>;
};


export type QueryFetchLineMeasurementArgs = {
  input?: InputMaybe<Array<InputMaybe<PolarPointMeasurementInput>>>;
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchSpatialHeatmapArgs = {
  heatmapParameters?: InputMaybe<SpatialHeatmapInput>;
};


export type QueryFilteredOptionsArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  fieldKey: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  templateId: Scalars['ID']['input'];
};


export type QueryGetAlarmLevelSummaryArgs = {
  input?: InputMaybe<AlarmLevelSummaryInput>;
};


export type QueryGetAssembliesByRiskAssessmentFiltersArgs = {
  input?: InputMaybe<RiskAssessmentFiltersInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAssembliesByTemplateFieldDataFiltersArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAssembliesByTemplateFieldsFiltersArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAssembliesByTemplateFieldsFiltersForChatArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryGetAssembliesCountArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
};


export type QueryGetAssembliesDecksSummaryArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
};


export type QueryGetAssembliesRiskAssessmentSummaryArgs = {
  input?: InputMaybe<RiskAssessmentSummaryInput>;
};


export type QueryGetAssembliesSummaryArgs = {
  input?: InputMaybe<AssembliesFilterInput>;
};


export type QueryGetAuth0ConnectionsArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDependentRiskAssessmentOptionsArgs = {
  input?: InputMaybe<RiskAssessmentFiltersInput>;
};


export type QueryGetDirectlyAssignedUserPermissionsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetNominationCalculationsArgs = {
  input?: InputMaybe<NominationCalculationsInput>;
};


export type QueryGetPreRegisteredUserRolesArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetRiskAssembliesCountArgs = {
  input?: InputMaybe<RiskAssessmentFiltersInput>;
};


export type QueryGetRiskAssessmentSummaryCountsArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRiskAssessmentSummaryDataArgs = {
  input?: InputMaybe<RiskAssessmentSummaryDataInput>;
};


export type QueryGetRiskAssessmentSummaryTableDataArgs = {
  input?: InputMaybe<RiskAssessmentSummaryTableDataInput>;
};


export type QueryGetSummarySheetGraphsCountArgs = {
  input?: InputMaybe<SummarySheetGraphsCountInput>;
};


export type QueryGetUserColumnPreferencesArgs = {
  input?: InputMaybe<UserColumnPreferencesInput>;
};


export type QueryGetUserPermissionsByRolesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGroupedReportsArgs = {
  input?: InputMaybe<ReportsInput>;
};


export type QueryGroupsByPartIdsArgs = {
  input?: InputMaybe<GroupsByPartIdsInput>;
};


export type QueryIdmsTasksArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  structureId: Scalars['ID']['input'];
};


export type QueryIdmsUploadsArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryImageSensorArgs = {
  imageSensorId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLatestIdmsUploadsByTypeArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLocationArgs = {
  locationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaintDamageCountByAlarmLevelArgs = {
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
};


export type QueryPaintRegionArgs = {
  paintRegionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaintRegionByNameArgs = {
  paintRegionName?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaintRegionGroupsArgs = {
  input: PaintRegionGroupFiltersInput;
};


export type QueryPartArgs = {
  partId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPermissionsByRoleArgs = {
  roleId: Scalars['String']['input'];
};


export type QueryPlatformArgs = {
  platformId: Scalars['ID']['input'];
};


export type QueryPointOfInterestArgs = {
  pointOfInterestId: Scalars['ID']['input'];
};


export type QueryPointOfInterestCountByPaintRegionsArgs = {
  input?: InputMaybe<PaintBlockFiltersInput>;
};


export type QueryPointOfInterestTemplateArgs = {
  pointOfInterestTemplateId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPointOfInterestsArgs = {
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryPointOfInterestsCountArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryPointOfInterestsCountByDueDateArgs = {
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
};


export type QueryPointOfInterestsCountByInspectionPriorityArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryPointOfInterestsCountByStatusArgs = {
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
};


export type QueryPointOfInterestsCountByTypeArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryPointOfInterestsCountForChatArgs = {
  input?: InputMaybe<PointOfInterestInput>;
};


export type QueryPointOfInterestsForChatArgs = {
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryPreRegisteredUsersArgs = {
  input?: InputMaybe<FiltersForPreRegisteredUsers>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryPreRegisteredUsersCountArgs = {
  input?: InputMaybe<FiltersForPreRegisteredUsers>;
};


export type QueryReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type QueryScCategoryOptionsArgs = {
  structureId: Scalars['ID']['input'];
};


export type QuerySettingArgs = {
  revision?: InputMaybe<Scalars['Float']['input']>;
  type: SettingTypesEnum;
};


export type QuerySphericalsPerZoneArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStructureArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStructuresByUserGroupArgs = {
  input?: InputMaybe<FiltersForStructureByUserGroup>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryStructuresCountArgs = {
  input?: InputMaybe<FilterForStructures>;
};


export type QuerySupervoxelsClassesForStructureArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupervoxelsForStructureArgs = {
  supervoxelsForStructureInput?: InputMaybe<SupervoxelsForStructureInput>;
};


export type QueryTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryTemplateArgs = {
  templateId: Scalars['ID']['input'];
  type?: InputMaybe<TemplateTypeEnum>;
};


export type QueryUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserDetailsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserGroupArgs = {
  userGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserGroupsCountArgs = {
  input?: InputMaybe<FilterForUserGroups>;
};


export type QueryUsersByRoleIdArgs = {
  input?: InputMaybe<UsersByRoleInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryUsersByTeamArgs = {
  pageInfo?: InputMaybe<PageInfo>;
  teamId: Scalars['ID']['input'];
};


export type QueryUsersByUserGroupArgs = {
  input?: InputMaybe<FilterForUsersByUserGroup>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryUsersCountArgs = {
  input?: InputMaybe<FiltersForUsersCount>;
};


export type QueryValidateBulkPoiUploadArgs = {
  input: BulkUploadPoisInput;
};


export type QueryValidateIdmsTemplateArgs = {
  input: ValidateIdmsTemplateQueryInput;
};


export type QueryValidateReportScopeArgs = {
  input?: InputMaybe<ValidateReportScopeInput>;
};


export type QueryWorkpackArgs = {
  workpackId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkpackItemArgs = {
  workpackItemId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZonesAndHistoriesForArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZonesForStructureArgs = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryZonesForStructureCsvArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZonesPerStageArgs = {
  input?: InputMaybe<ZonesPerStageInput>;
  pageInfo?: InputMaybe<PageInfo>;
};


export type QueryZonesPerStatusCountArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
};

export type QuerySummaryCloneInput = {
  /** Name of template */
  name: Scalars['String']['input'];
  /** Source structure for the template Fields */
  sourceStructureId: Scalars['ID']['input'];
  /** Target structure for the template Fields */
  targetStructureId: Scalars['ID']['input'];
  /** Type of template */
  type: TemplateTypeEnum;
};

export type QuerySummaryInput = {
  /** Name of the collection where the item is stored */
  collectionName: Scalars['String']['input'];
  /** Array of display settings for the item */
  displayConfig?: InputMaybe<Array<DisplaySettingInput>>;
  /** Enum type representing how the item should be displayed */
  displayType: DisplayType;
  id: Scalars['ID']['input'];
  /** Optional field to store the key associated with the item */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Match conditions, allowing complex filtering logic */
  matchCondition?: InputMaybe<Scalars['JSON']['input']>;
  /** Name of the query summary item */
  name: Scalars['String']['input'];
  /** Operation type for the item */
  operation: Scalars['String']['input'];
  /** Order of the item in the row */
  rowOrder: Scalars['Int']['input'];
  /** Direction of sort i.e. Ascending or Descending */
  sortDirection?: InputMaybe<Scalars['Int']['input']>;
  /** Sorting criteria for query summary items */
  sortType?: InputMaybe<SummaryItemSortType>;
};

export type QuerySummaryItem = {
  __typename?: 'QuerySummaryItem';
  /** Name of the collection where the item is stored */
  collectionName: Scalars['String']['output'];
  /** Array of display settings for the item */
  displayConfig?: Maybe<Array<DisplaySettings>>;
  /** Enum type representing how the item should be displayed */
  displayType: DisplayType;
  /** Unique identifier for each item */
  id: Scalars['ID']['output'];
  /** Optional field to store the key associated with the item */
  key?: Maybe<Scalars['String']['output']>;
  /** Match conditions, allowing complex filtering logic */
  matchCondition?: Maybe<Scalars['JSON']['output']>;
  /** Name of the query summary item */
  name: Scalars['String']['output'];
  /** Operation type for the item */
  operation: Scalars['String']['output'];
  /** Order of the item in the row */
  rowOrder: Scalars['Int']['output'];
  /** Direction of sort i.e. Ascending or Descending */
  sortDirection?: Maybe<Scalars['Int']['output']>;
  /** Sorting criteria for query summary items */
  sortType?: Maybe<SummaryItemSortType>;
};

export type RangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  maxIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minIncluded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecalculateRiskRemediationAnalyticsInput = {
  /** Structure ID to calculate analytics for */
  structureId: Scalars['ID']['input'];
};

export type RecalculateRiskRemediationAnalyticsResult = {
  __typename?: 'RecalculateRiskRemediationAnalyticsResult';
  /** Error message if recalculation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Success status of the recalculation */
  success: Scalars['Boolean']['output'];
};

export type Recommendation = {
  __typename?: 'Recommendation';
  /** Recommendation made during initial analysis of the assembly */
  analysisRecommendation?: Maybe<AlarmLevelRecommendation>;
  analysisStatus?: Maybe<RecommendationStatus>;
  blisters: Array<PointOfInterest>;
  /** Final recommendation */
  finalRecommendation?: Maybe<AlarmLevelRecommendation>;
  /**
   * Worst blister identified that would affect Abyss' recommendation for this assembly
   * (judgment of 'worst' may be subjective
   * e.g based on shape and position of blister and not just its height and corresponding wall loss)
   */
  governingValue?: Maybe<GoverningValueRecommendation>;
  /** Whether or not a final review is required after peer review, typically when analysis recommendation and review recommendation are conflicting */
  isFinalisationRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Recommendation made during peer review of the recommendation from initial analysis */
  reviewRecommendation?: Maybe<AlarmLevelRecommendation>;
};

export type RecommendationDetailField = {
  __typename?: 'RecommendationDetailField';
  /** Unique human-readable key of the RecomendationDetalsField */
  fieldKey: Scalars['String']['output'];
  /** Unique Id of the RecomendationDetalsField */
  id: Scalars['ID']['output'];
};

export type RecommendationField = {
  __typename?: 'RecommendationField';
  /** Details field describe the dynamic field to render in the UI */
  details: Array<Maybe<RecommendationDetailField>>;
  /** Header field describe the text to display on the header of the UI */
  header: Scalars['String']['output'];
};

export enum RecommendationStatus {
  /** Assembly analysis has been completed by Abyss and recommendation recorded */
  Complete = 'COMPLETE',
  /** Recommendation not yet made by Abyss */
  Incomplete = 'INCOMPLETE'
}

export type Region = {
  __typename?: 'Region';
  /** Unique region ID */
  id: Scalars['ID']['output'];
  /** Name of this region */
  name: Scalars['String']['output'];
};

export type RemediationScoreAreaField = {
  __typename?: 'RemediationScoreAreaField';
  /** Field key for the area field */
  fieldKey: Scalars['String']['output'];
  /** Score value for the area field (minimum 1) */
  score: Scalars['Float']['output'];
  /** Threshold value for the area field (minimum 0.001) */
  threshold: Scalars['Float']['output'];
};

export type RemediationScoreAreaFieldInput = {
  /** Field key for the area field */
  fieldKey: Scalars['String']['input'];
  /** Score value for the area field (minimum 1) */
  score: Scalars['Float']['input'];
  /** Threshold value for the area field (minimum 0.001) */
  threshold: Scalars['Float']['input'];
};

export type RemediationScoreAreaSection = {
  __typename?: 'RemediationScoreAreaSection';
  /** Array of area fields */
  fields?: Maybe<Array<RemediationScoreAreaField>>;
};

export type RemediationScoreAreaSectionInput = {
  /** Array of area fields */
  fields?: InputMaybe<Array<RemediationScoreAreaFieldInput>>;
};

export type RemediationScoreCofField = {
  __typename?: 'RemediationScoreCofField';
  /** Field key for the COF field */
  fieldKey: Scalars['String']['output'];
  /** Map of option scores (all values minimum 1) */
  optionScores: Scalars['JSON']['output'];
};

export type RemediationScoreCofFieldInput = {
  /** Field key for the COF field */
  fieldKey: Scalars['String']['input'];
  /** Map of option scores (all values minimum 1) */
  optionScores: Scalars['JSON']['input'];
};

export type RemediationScoreCofSection = {
  __typename?: 'RemediationScoreCofSection';
  /** Array of COF fields */
  fields?: Maybe<Array<RemediationScoreCofField>>;
};

export type RemediationScoreCofSectionInput = {
  /** Array of COF fields */
  fields?: InputMaybe<Array<RemediationScoreCofFieldInput>>;
};

export type RemediationScoreConfig = {
  __typename?: 'RemediationScoreConfig';
  /** Area section configuration */
  area?: Maybe<RemediationScoreAreaSection>;
  /** COF section configuration */
  cof?: Maybe<RemediationScoreCofSection>;
  /** POI section configuration */
  poi?: Maybe<RemediationScorePoiSection>;
};

export type RemediationScoreConfigInput = {
  /** Area section configuration (can be null) */
  area?: InputMaybe<RemediationScoreAreaSectionInput>;
  /** COF section configuration (can be null) */
  cof?: InputMaybe<RemediationScoreCofSectionInput>;
  /** POI section configuration (can be null) */
  poi?: InputMaybe<RemediationScorePoiSectionInput>;
};

export type RemediationScorePoiField = {
  __typename?: 'RemediationScorePoiField';
  /** POI score value (minimum 1) */
  poiScore: Scalars['Float']['output'];
  /** POI template key identifier */
  poiTemplateKey: Scalars['String']['output'];
  /** Optional subcategory configuration */
  subcategory?: Maybe<RemediationScoreSubcategory>;
};

export type RemediationScorePoiFieldInput = {
  /** POI score value (minimum 1) */
  poiScore: Scalars['Float']['input'];
  /** POI template key identifier */
  poiTemplateKey: Scalars['String']['input'];
  /** Optional subcategory configuration */
  subcategory?: InputMaybe<RemediationScoreSubcategoryInput>;
};

export type RemediationScorePoiSection = {
  __typename?: 'RemediationScorePoiSection';
  /** Array of POI fields */
  fields?: Maybe<Array<RemediationScorePoiField>>;
};

export type RemediationScorePoiSectionInput = {
  /** Array of POI fields */
  fields?: InputMaybe<Array<RemediationScorePoiFieldInput>>;
};

export type RemediationScoreSubcategory = {
  __typename?: 'RemediationScoreSubcategory';
  /** Field key for the subcategory */
  fieldKey: Scalars['String']['output'];
  /** Map of option scores (all values minimum 1) */
  optionScores: Scalars['JSON']['output'];
};

export type RemediationScoreSubcategoryInput = {
  /** Field key for the subcategory */
  fieldKey: Scalars['String']['input'];
  /** Map of option scores (all values minimum 1) */
  optionScores: Scalars['JSON']['input'];
};

export type RemoveAttachmentsInput = {
  fileIds: Array<Scalars['ID']['input']>;
  pointOfInterestId: Scalars['ID']['input'];
};

export type RemoveSplitCuboidOnPartInput = {
  /** Object Id of part to remove split cuboid from */
  partId: Scalars['ID']['input'];
  /** Object Id of cuboid to remove */
  splitCuboidId: Scalars['ID']['input'];
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveSplitCuboidOnPartNotification = {
  __typename?: 'RemoveSplitCuboidOnPartNotification';
  /** Object Id of part to add cuboid to */
  partId: Scalars['ID']['output'];
  /** Object Id for the cuboid to remove */
  splitCuboidId: Scalars['ID']['output'];
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['output'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export type Report = {
  __typename?: 'Report';
  /** Current status of the action on the report i.e Backlog, In progress or Complete */
  actionStatus?: Maybe<ReportActionStatus>;
  /** All images references for each point of interest for updating Selected images for add or delete case */
  allPointOfInterestImages?: Maybe<Array<Maybe<PointOfInterestImages>>>;
  /** All pdfs references for each point of interest for updating Selected pdfs for add or delete case */
  allPointOfInterestPdfs?: Maybe<Array<Maybe<PointOfInterestPdfs>>>;
  /** Component ID this report refers to */
  components?: Maybe<Array<Assembly>>;
  /** Date this Report was created */
  createdAt: Scalars['String']['output'];
  /** User Who created the report */
  createdByUser: User;
  /** CVI group of point of interests */
  cviPois?: Maybe<Array<PointOfInterest>>;
  /** Deadline Date for action on the report */
  dueDate?: Maybe<Scalars['String']['output']>;
  /** User uploaded files to the report */
  files?: Maybe<Array<File>>;
  /** Report group the report belongs to */
  group?: Maybe<ReportGroup>;
  /** GVI group of point of interests */
  gviPois?: Maybe<Array<PointOfInterest>>;
  /** Unique Report ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Internal status of the report i.e POINT_OF_INTEREST or PAINT_BLOCK */
  internalType: ReportInternalType;
  /** Name of the report decided by the user */
  name: Scalars['String']['output'];
  /** Paint region Document IDs this Reports refers to */
  paintRegion?: Maybe<PaintRegion>;
  /** Point of Interests Document IDs this Reports refers to */
  pointOfInterests?: Maybe<Array<PointOfInterest>>;
  /** Order of assemblies and point of interests */
  reportOrder?: Maybe<ReportOrder>;
  /** Selected images for point of interests */
  selectedPointOfInterestImages?: Maybe<Array<Maybe<PointOfInterestImages>>>;
  /** Current status of the report i.e Draft, Published or Closed */
  status: ReportStatus;
  structure: Structure;
  /** Only to Store Data values  dynamically for this Report. Template doesnot exist for Reports */
  templateFieldData?: Maybe<Scalars['JSON']['output']>;
  /** Type of report i.e FM Workpack or MI Workpack or Inspection or Maintainance */
  type?: Maybe<ReportType>;
  /** Workpack number of Report */
  workpackNumber?: Maybe<Scalars['String']['output']>;
};

export enum ReportActionStatus {
  Backlog = 'BACKLOG',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS'
}

export type ReportConfig = {
  __typename?: 'ReportConfig';
  configurations?: Maybe<Array<Configurations>>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ReportConfigInput = {
  configurations?: InputMaybe<Array<ConfigurationsInput>>;
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type ReportGroup = {
  __typename?: 'ReportGroup';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum ReportInternalType {
  Component = 'COMPONENT',
  PaintBlock = 'PAINT_BLOCK',
  PointOfInterest = 'POINT_OF_INTEREST'
}

export type ReportOrder = {
  __typename?: 'ReportOrder';
  assemblyOrder?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  poiOrder?: Maybe<Scalars['JSON']['output']>;
};

export type ReportOrderInput = {
  assemblyOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  poiOrder?: InputMaybe<Scalars['JSON']['input']>;
};

export enum ReportStatus {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export enum ReportType {
  FmWorkpack = 'FM_WORKPACK',
  Inspection = 'INSPECTION',
  InspectionWorkpack = 'INSPECTION_WORKPACK',
  Maintenance = 'MAINTENANCE',
  MiWorkpack = 'MI_WORKPACK'
}

export type ResetPasswordInput = {
  clientId: Scalars['String']['input'];
  connection: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type RevertBulkLineFixingInput = {
  structureId: Scalars['ID']['input'];
};

export type ReviewPanelConfig = {
  __typename?: 'ReviewPanelConfig';
  /** Unique identifier for the group */
  groupKey: Scalars['String']['output'];
  /** Name associated for the group in Review Panel */
  groupName: Scalars['String']['output'];
  /** Sections to be displayed within this group */
  groupSection: Array<Maybe<GroupSection>>;
  /** Unique Review Panel Configuration */
  id: Scalars['ID']['output'];
};

export type ReviewPanelConfigInput = {
  /** Unique identifier for the group */
  groupKey: Scalars['String']['input'];
  /** Name associated for the group in Review Panel */
  groupName: Scalars['String']['input'];
  /** Sections to be displayed within this group */
  groupSection: Array<GroupSectionInput>;
  /** Unique Review Panel Configuration ID */
  id: Scalars['ID']['input'];
};

export type RiskAssessment = {
  __typename?: 'RiskAssessment';
  /** TODO: Deprecated (RiskAssessment */
  age?: Maybe<Scalars['Int']['output']>;
  berthingCalculation?: Maybe<Scalars['Int']['output']>;
  corrosionCategory?: Maybe<Scalars['String']['output']>;
  hoursAtBerth?: Maybe<Scalars['Int']['output']>;
  mooringAnalysis?: Maybe<Scalars['Int']['output']>;
  percentDraftCondition?: Maybe<Scalars['Float']['output']>;
  percentOfHours?: Maybe<Scalars['Float']['output']>;
  shipsAtBerth?: Maybe<Scalars['Int']['output']>;
};

export type RiskAssessmentDependentOptions = {
  __typename?: 'RiskAssessmentDependentOptions';
  key?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RiskAssessmentFiltersInput = {
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  includeComments?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  selectedFilters?: InputMaybe<Array<RiskAssessmentSelectedFiltersInput>>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type RiskAssessmentSelectedFiltersInput = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RiskAssessmentSummary = {
  __typename?: 'RiskAssessmentSummary';
  key?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<RiskType>>>;
};

export type RiskAssessmentSummaryCounts = {
  __typename?: 'RiskAssessmentSummaryCounts';
  cofCalculated?: Maybe<Scalars['Float']['output']>;
  pofCalculated?: Maybe<Scalars['Float']['output']>;
  totalAssemblies?: Maybe<Scalars['Float']['output']>;
  transitionPeriodCalculated?: Maybe<Scalars['Float']['output']>;
};

export type RiskAssessmentSummaryData = {
  __typename?: 'RiskAssessmentSummaryData';
  _id?: Maybe<Scalars['ID']['output']>;
  completedCalculationsCount?: Maybe<Scalars['Float']['output']>;
  damageClassCount?: Maybe<Array<Maybe<DamageClassCountType>>>;
  level1Component?: Maybe<Scalars['String']['output']>;
  totalCalculationsCount?: Maybe<Scalars['Float']['output']>;
};

export type RiskAssessmentSummaryDataInput = {
  selectedFilters?: InputMaybe<Array<RiskAssessmentSelectedFiltersInput>>;
  structureId: Scalars['ID']['input'];
};

export type RiskAssessmentSummaryInput = {
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  structureId: Scalars['ID']['input'];
  templateFieldKeys: Array<Scalars['String']['input']>;
  templateId: Scalars['ID']['input'];
};

export type RiskAssessmentSummaryTableData = {
  __typename?: 'RiskAssessmentSummaryTableData';
  calculations: Calculations;
  risk_damage_class: Scalars['String']['output'];
  risk_level_1_component: Scalars['String']['output'];
  risk_level_2_component: Scalars['String']['output'];
  risk_structure: Scalars['String']['output'];
};

export type RiskAssessmentSummaryTableDataInput = {
  selectedFilters?: InputMaybe<Array<RiskAssessmentSelectedFiltersInput>>;
  selectedLevel1Component: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type RiskFields = {
  __typename?: 'RiskFields';
  /** Key to identify template field */
  fieldKey: Scalars['String']['output'];
  /** Unique Risk Field ID */
  id: Scalars['ID']['output'];
  /** Identify whether the field needs to be displayed */
  isHiddenColumn: Scalars['Boolean']['output'];
  /** Identify where the field needs to be shown */
  type: Array<Maybe<RiskFieldsTypeEnum>>;
};

export type RiskFieldsInput = {
  /** Key to identify template field */
  fieldKey: Scalars['String']['input'];
  /** Identify whether the field needs to be displayed */
  isHiddenColumn: Scalars['Boolean']['input'];
  /** Identify where the field needs to be shown */
  type: Array<InputMaybe<RiskFieldsTypeEnum>>;
};

export enum RiskFieldsTypeEnum {
  Cof = 'COF',
  Pof = 'POF',
  Review = 'REVIEW',
  TransitionPeriod = 'TRANSITION_PERIOD'
}

export type RiskRemediationAnalyticsInput = {
  /** Structure ID to calculate analytics for */
  structureId: Scalars['ID']['input'];
};

export type RiskRemediationScore = {
  __typename?: 'RiskRemediationScore';
  /** Area risk score */
  areaRiskScore?: Maybe<Scalars['Float']['output']>;
  /** COF risk score */
  cofRiskScore?: Maybe<Scalars['Float']['output']>;
  /** Combined risk score */
  combinedScore?: Maybe<Scalars['Float']['output']>;
  /** POI risk score */
  poiRiskScore?: Maybe<Scalars['Float']['output']>;
};

export type RiskType = {
  __typename?: 'RiskType';
  count?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Role = {
  __typename?: 'Role';
  /** Auth0 id of role */
  auth0Id: Scalars['String']['output'];
  /** Description of role */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique role ID */
  id: Scalars['ID']['output'];
  /** Name of this role */
  name: Scalars['String']['output'];
  /** Permissions of role */
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type RollbackVersionInput = {
  referenceId: Scalars['String']['input'];
  rollbackVersionId: Scalars['String']['input'];
  structureId: Scalars['String']['input'];
};

export type SavePointOfInterestScreenshotInput = {
  /** Base64-encoded string of screenshot image */
  image: Scalars['String']['input'];
  /** Reason for the last update */
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  /** POI for which to save screenshot */
  pointOfInterestId: Scalars['ID']['input'];
  /** Type of screenshot, i.e. VIEWPOINT */
  type: ScreenshotTypeEnum;
};

export type ScreenshotPaths = {
  __typename?: 'ScreenshotPaths';
  viewer?: Maybe<Scalars['String']['output']>;
  viewpoint?: Maybe<Scalars['String']['output']>;
};

export enum ScreenshotTypeEnum {
  Viewer = 'VIEWER',
  Viewpoint = 'VIEWPOINT'
}

export type SeenByViewpoint = {
  __typename?: 'SeenByViewpoint';
  /** Metadata about if a viewpoint has been analysed, with respect to the relavant assembly */
  analysed?: Maybe<Analysed>;
  /** Corrosion detected on the portion of the part or assembly that the viewpoint can see */
  corrosion?: Maybe<Corrosion>;
  /**
   * Mean distance from the viewpoint's location to the portion of the part or assembly it can see -
   * ie how far away was the camera/scanner from the part (in metres)
   */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Focal point for this assembly from this location */
  focalPoint?: Maybe<Vector3>;
  /** Viewpoint details including exact location and scan data */
  location: Location;
};

export type Service = {
  __typename?: 'Service';
  /** Code or acronym for the service an assembly provides e.g PG for Process Gas, can be empty when unknown */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * Name of the group this service belongs to
   * - services are currently grouped to help ease prioritisation of assemblies
   * e.g. Hydrocarbon Lines include services Process Gas, Fuel Gas, etc
   */
  group: Scalars['String']['output'];
};

export type ServiceInput = {
  /** Code or acronym for the service an assembly provides e.g PG for Process Gas, can be empty when unknown */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Name of the group this service belongs to */
  group: Scalars['String']['input'];
};

export type SetAlarmLevelInput = {
  alarmLevelRecommendation: AlarmLevelRecommendationInput;
  assemblyId: Scalars['ID']['input'];
};

export type Setting = {
  __typename?: 'Setting';
  /** Unique Setting ID */
  id: Scalars['ID']['output'];
  meta: Array<Meta>;
  /** Name of this Setting */
  name: Scalars['String']['output'];
  /** Revision of this Setting, i.e. 0 */
  revision: Scalars['Int']['output'];
  /** Type of this Setting, i.e. COLOUR_MAP_FOR_3D_VIEWER_PARTS */
  type: SettingTypesEnum;
};

export enum SettingTypesEnum {
  ColourMapForAbyssViewerDefects = 'COLOUR_MAP_FOR_ABYSS_VIEWER_DEFECTS',
  ColourMapForAbyssViewerParts = 'COLOUR_MAP_FOR_ABYSS_VIEWER_PARTS',
  ColourMapForDeckHeatmapApiModes = 'COLOUR_MAP_FOR_DECK_HEATMAP_API_MODES'
}

export type SheetData = {
  service: ServiceInput;
  tagName: Scalars['String']['input'];
  templateFieldData: Scalars['String']['input'];
};

export enum SortTypeEnum {
  Number = 'NUMBER',
  String = 'STRING'
}

export type SpatialHeatmap = {
  __typename?: 'SpatialHeatmap';
  svg: Scalars['String']['output'];
};

export type SpatialHeatmapInput = {
  deckId: Scalars['ID']['input'];
  modes: ModeInput;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  structureId: Scalars['ID']['input'];
};

export type SpatialHeatmapStep = {
  __typename?: 'SpatialHeatmapStep';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

export type SphericalsPerZone = {
  __typename?: 'SphericalsPerZone';
  totalSphericals: Scalars['Int']['output'];
  zoneId: Scalars['ID']['output'];
};

export type SplitCuboid = {
  __typename?: 'SplitCuboid';
  /** Assembly that this cuboid volume should belong to */
  assembly?: Maybe<Assembly>;
  assemblyId?: Maybe<Scalars['ID']['output']>;
  /** Cuboid colour (RGB) */
  color: Scalars['Int']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['output']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Three.js Euler conventions. */
  rotation: Array<Scalars['Float']['output']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['output']>;
};

export type SplitCuboidInput = {
  /** Assembly that this cuboid volume should belong to */
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  /** Cuboid colour (RGB) */
  color: Scalars['Int']['input'];
  /** Unique Cuboid ID */
  id: Scalars['ID']['input'];
  /** Position of the cuboid (x,y,z) */
  position: Array<Scalars['Float']['input']>;
  /** Rotation of the cuboid (roll,pitch,yaw). Euler angles using Abyss conventions. */
  rotation: Array<Scalars['Float']['input']>;
  /** Size of the cuboid in 3 axes (x,y,z) */
  scale: Array<Scalars['Float']['input']>;
};

export type SplitPartInput = {
  /** Object Ids of all the annotations to split from given part into a new part */
  annotationIdsForNewPart: Array<Scalars['ID']['input']>;
  /** Object Id of the part to split */
  partId: Scalars['ID']['input'];
  /** Object Id for the structure this part belongs to */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export enum StageType {
  Annotation = 'ANNOTATION',
  Review = 'REVIEW'
}

export enum StatusRemediatedThrough {
  PaintRegion = 'PAINT_REGION'
}

/** String array metadata */
export type StringArrayMeta = {
  __typename?: 'StringArrayMeta';
  key: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

/** String metadata */
export type StringMeta = {
  __typename?: 'StringMeta';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * A Structure whose condition is being inspected.
 *
 * A Structure exists on a Location where data is captured, processed, then analysed to assess the overall condition of the Structure.
 */
export type Structure = {
  __typename?: 'Structure';
  /** Base path for assembly CAD-model resources */
  assemblyCadModelsBasePath?: Maybe<Scalars['String']['output']>;
  /** Assembly types existing for each structure, valid values may vary from platform to platform */
  assemblyTypes: Array<Scalars['String']['output']>;
  /** URL for base image for this Structure */
  baseImage?: Maybe<Scalars['String']['output']>;
  /**
   * List of all base paths in CDN where static assets for this Structure have been deployed.
   * Used to determine access control for CDN assets.
   */
  basePaths: Array<Scalars['String']['output']>;
  /** Blister height type */
  blisterHeightType?: Maybe<BlisterHeightType>;
  /** Card insight detail for a structure */
  cardInsights?: Maybe<Array<CardInsights>>;
  /**
   * Coating Condition Category Mapping
   * In some platforms we use different terminology for the same thing, this is a mapping to help us translate between the two platforms
   */
  coatingCategoryMapping?: Maybe<Scalars['JSON']['output']>;
  /** Structure Config */
  config?: Maybe<StructureConfig>;
  /** URL for cover image for this Structure */
  coverImage?: Maybe<Scalars['String']['output']>;
  /** Path for cover image for this Structure */
  coverImagePath: Scalars['String']['output'];
  /** Date this Structure was created */
  createdAt: Scalars['String']['output'];
  /** Classes assigned to Cuboids for 3D Asset Labelling */
  cuboidClasses?: Maybe<Array<LabelClass>>;
  /** Default assembly id for the structure (When adding a poi without assembly this assembly id will be used) */
  defaultAssemblyId?: Maybe<Scalars['ID']['output']>;
  /** Defect Area for the structure */
  defectArea?: Maybe<Scalars['JSON']['output']>;
  /** List of legends and colors for the structure defects */
  defectLegends: Array<DefectLegend>;
  /** Deployment level of this Structure, i.e. COMPONENT LEVEL, FACILITY LEVEL */
  deploymentLevel?: Maybe<StructureDeploymentLevel>;
  /** Description of this Structure */
  description: Scalars['String']['output'];
  /** Equipment Classes defined on a particular structure */
  equipmentClasses: Array<EquipmentClasses>;
  /** Status of the ES Sheet for this structure */
  esSheetStatus?: Maybe<EsSheetStatus>;
  /** Features enabled for the structure */
  features?: Maybe<Scalars['JSON']['output']>;
  /** Octree data for this platform contains RGB colors */
  hasRGB?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If this structure can perform a risk assesment. If this structure has the data needed to
   * perform a risk assesment, then this field will be set to 'true'
   */
  hasRiskAssessment?: Maybe<Scalars['Boolean']['output']>;
  /** Structure Has find viewpoint by point data and feature enabled */
  hasVoxelLocations?: Maybe<Scalars['Boolean']['output']>;
  /** Unique Structure ID */
  id: Scalars['ID']['output'];
  /** It will check if the structure is an active deployment or not */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** To switch the Abyss Rating Equation and incorporate the wall loss calculations in it */
  isWallLossEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Input Classes for 3D Asset Labelling */
  labelClasses?: Maybe<Array<LabelClass>>;
  /** Large voxel size parameter of voxel locations data (deployed file per large voxel in s3 bucket) */
  largeVoxelSize?: Maybe<Scalars['Float']['output']>;
  /** Auth0 ID of the user who last updated this POI Template */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Name of this Structure */
  name: Scalars['String']['output'];
  /** Path to directory contatining JSON file per assembly with the list of octree nodes for the assembly */
  nodesPerAssemblyPath?: Maybe<Scalars['String']['output']>;
  /** Path to JSON file with octree files hierarchy */
  octreeResourcesPath: Scalars['String']['output'];
  /** List of and colors for each part */
  partLegends?: Maybe<Array<PartLegend>>;
  /** Path to photogrammetry 3d-tiles tileset.json */
  photogrammetryTilesPath?: Maybe<Scalars['String']['output']>;
  /** Platform this Structure belongs to */
  platform?: Maybe<Platform>;
  /** Region this Structure belongs to */
  region?: Maybe<Region>;
  /** POI report configuration */
  reportConfig?: Maybe<ReportConfig>;
  /** TODO: deprecated */
  riskAssessment?: Maybe<RiskAssessment>;
  /**
   * Subtract Condition Category Mapping
   * In some platforms we use different terminology for the same thing, this is a mapping to help us translate between the two platforms
   */
  scCategoryMapping?: Maybe<Scalars['JSON']['output']>;
  /** Date representing the last time the structure was scanned */
  scanDate?: Maybe<Scalars['String']['output']>;
  /**
   * List of service groups that assemblies in this rootAsset belong to,
   * stored here so we can easily get a list of service groups to filter
   * assemblies by
   */
  serviceGroups: Array<Scalars['String']['output']>;
  /** The current processing stage of the structure */
  status: StructureStatus;
  /** Path to JSON file with structure relationships */
  structureRelationshipPath?: Maybe<Scalars['String']['output']>;
  /** Template related to this structure for dynamic data */
  template?: Maybe<Template>;
  /** Data values associated with Template for this structure */
  templateData?: Maybe<Array<TemplateData>>;
  /** Type of this Structure, i.e. PLATFORM */
  type: StructureTypes;
  /** Date this Structure was last updated */
  updatedAt: Scalars['String']['output'];
  /** User who last updated this Structure */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** User groups with access to this Structure */
  userGroups: Array<UserGroup>;
  /** Path to voxel locations directory containing large voxel json files */
  voxelLocationsPath?: Maybe<Scalars['String']['output']>;
  /** Voxel size parameter of voxel locations data (voxel size for locations lookup) */
  voxelSize?: Maybe<Scalars['Float']['output']>;
  /** Value that will calculate wall loss for different deployments */
  wallLossFactor?: Maybe<Scalars['Float']['output']>;
  /** Details about the labelling workflow */
  workflowStages?: Maybe<Array<Maybe<WorkflowStages>>>;
};

export type StructureConfig = {
  __typename?: 'StructureConfig';
  /** Disables click on hidden points */
  disableClickOnHiddenPoints?: Maybe<Scalars['Boolean']['output']>;
  /** Neighbouring images options */
  neighbouringImagesOptions?: Maybe<NeighbouringImagesOptions>;
  /**
   * Used to set the initial north value of the Viewer compass.
   * The scale value is around 0-7, where 0 is the default north value.
   * Setting it to 7 will rotate the compass 360 degrees.
   */
  northRotation?: Maybe<Scalars['Float']['output']>;
  /**
   * For the cuboid editor feature, used in spacial query.
   * This value determines the 'step' size for the resizing of the workscope cuboid.
   * This should be in metres.
   * Normal value ranges from 0.1 to 1.0
   */
  spatialHeatmapStep?: Maybe<SpatialHeatmapStep>;
  /** Spherical Viewer Visibility Radius */
  sphereRadius?: Maybe<Scalars['Float']['output']>;
};

export enum StructureDeploymentLevel {
  ComponentLevel = 'COMPONENT_LEVEL',
  EsDeployment = 'ES_DEPLOYMENT',
  FacilityLevel = 'FACILITY_LEVEL'
}

export type StructureFilters = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  excludeByUserGroupId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export enum StructureStatus {
  /** All assests of a structure have been tagged and are ready for MI analysis */
  Analysis = 'ANALYSIS',
  /** For 3D asset labelling using Cuboids */
  AssetLabelling_3D = 'ASSET_LABELLING_3D',
  /** For labelling of a structure */
  Labelling = 'LABELLING',
  /** Structure tag data has been captured and processed and are ready for quality checks */
  Tagging = 'TAGGING'
}

export enum StructureTypes {
  ChainLink = 'CHAIN_LINK',
  Jacket = 'JACKET',
  Platform = 'PLATFORM'
}

export type StructureWithDefects = {
  __typename?: 'StructureWithDefects';
  defectArea: Array<DefectArea>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: StructureStatus;
};

export type StructuresAndGroups = {
  __typename?: 'StructuresAndGroups';
  structures: Array<Structure>;
  userGroups: Array<UserGroup>;
};

export type Subscription = {
  __typename?: 'Subscription';
  annotationUpdated?: Maybe<Annotation>;
  assemblyTagNameAdded?: Maybe<AssemblyTagNameAdded>;
  assemblyUpdated?: Maybe<AssemblyUpdatedEventResult>;
  commentAdded: Comment;
  commentDeleted: Comment;
  partSplit: PartSplitNotification;
  partsAddedToAssembly: Array<PartsAddedToAssemblyNotification>;
  partsHiddenFlagUpdated: Array<PartHiddenFlagUpdatedNotification>;
  partsReviewedFlagUpdated: Array<PartReviewFlagUpdatedNotification>;
  /** Event that is fired after the point of interest activity is updated */
  pointOfInterestActivity: PointOfInterest;
  /** Event that is fired after POI is created */
  pointOfInterestCreated?: Maybe<PointOfInterest>;
  /** Event that is fired after POI is deleted */
  pointOfInterestDeleted?: Maybe<PointOfInterest>;
  /** Event that is fired after POI screenshot is saved */
  pointOfInterestScreenshotSaved?: Maybe<PointOfInterest>;
  /** Event that is fired after POI is updated */
  pointOfInterestUpdated?: Maybe<PointOfInterest>;
  /** Event that is fired after POI Visibility is updated */
  pointOfInterestVisibilityUpdated: Array<PointOfInterest>;
  reportPointOfInterestVerified: VerifiedDetails;
  roleAssignedToUsers?: Maybe<Role>;
  roleRemovedFromUsers?: Maybe<Role>;
  /** Event that is fired after the selected POI is updated */
  selectedPointOfInterestUpdated: PointOfInterest;
  /** Removing notification for a Split Cuboid on the Part */
  splitCuboidOnPartRemoved: Array<RemoveSplitCuboidOnPartNotification>;
  /** Adding/Updating notification for a Split Cuboid on the Part */
  splitCuboidOnPartUpdated: Array<AddUpdateSplitCuboidOnPartNotification>;
  supervoxelsUpdated: Array<SuperVoxels>;
  /** Event that is fired after Template is created */
  templateCreated?: Maybe<Template>;
  /** Event that is fired after Template is deleted */
  templateDeleted?: Maybe<Template>;
  /** Event that is fired after Template is updated */
  templateUpdated?: Maybe<Template>;
  userAddedToUserGroup?: Maybe<UserGroup>;
  userGroupCreated?: Maybe<UserGroup>;
  userGroupDeleted?: Maybe<UserGroup>;
  userGroupRemovedFromStructure?: Maybe<Structure>;
  userGroupUpdated?: Maybe<UserGroup>;
  userGroupsAddedToStructure?: Maybe<StructuresAndGroups>;
  userGroupsRemovedFromStructure?: Maybe<StructuresAndGroups>;
  userRemovedFromUserGroup?: Maybe<UserGroup>;
  workFlowTimeUpdated: Zone;
  workpackCreated?: Maybe<Workpack>;
  workpackDeleted?: Maybe<Workpack>;
  workpackItemCreated?: Maybe<WorkpackItem>;
  workpackItemDeleted?: Maybe<WorkpackItem>;
  workpackItemUpdated?: Maybe<WorkpackItem>;
  workpackUpdated?: Maybe<Workpack>;
};


export type SubscriptionAssemblyTagNameAddedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionAssemblyUpdatedArgs = {
  assemblyId: Scalars['String']['input'];
  structureId: Scalars['String']['input'];
};


export type SubscriptionCommentAddedArgs = {
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionCommentDeletedArgs = {
  referenceId?: InputMaybe<Scalars['ID']['input']>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionPartSplitArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPartsAddedToAssemblyArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPartsHiddenFlagUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPartsReviewedFlagUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionPointOfInterestActivityArgs = {
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  structureId: Scalars['ID']['input'];
};


export type SubscriptionReportPointOfInterestVerifiedArgs = {
  reportId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionSelectedPointOfInterestUpdatedArgs = {
  poiId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionSplitCuboidOnPartRemovedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionSplitCuboidOnPartUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionSupervoxelsUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionTemplateCreatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionTemplateDeletedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionTemplateUpdatedArgs = {
  structureId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionWorkFlowTimeUpdatedArgs = {
  structureId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export enum SummaryItemSortType {
  Count = 'COUNT',
  Default = 'DEFAULT'
}

export type SummarySheetGraphsCount = {
  __typename?: 'SummarySheetGraphsCount';
  count?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type SummarySheetGraphsCountInput = {
  key: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type SuperVoxels = {
  __typename?: 'SuperVoxels';
  /** Unique SuperVoxel ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Structure of this super voxel */
  structureId: Scalars['ObjectId']['output'];
  /** 3D reference of super voxel */
  supervoxel3DReference: Scalars['Int']['output'];
  /** Super voxel class of the this super voxel */
  supervoxelClassId?: Maybe<Scalars['ID']['output']>;
  /** Zone of this super voxel */
  zoneId: Scalars['ObjectId']['output'];
};

export type SupervoxelClass = {
  __typename?: 'SupervoxelClass';
  /** Color of the supervoxel class */
  color: Scalars['String']['output'];
  /** SuperVoxel ID */
  id: Scalars['ID']['output'];
  /** Name of supervoxel class */
  name: Scalars['String']['output'];
  /** Structure of this supervoxel class */
  structureId: Scalars['ObjectId']['output'];
};

export enum TableCellStyleEnum {
  ArrowUpward = 'ARROW_UPWARD',
  Bullet = 'BULLET',
  Chip = 'CHIP',
  Link = 'LINK',
  Note = 'NOTE',
  Squircle = 'SQUIRCLE',
  Text = 'TEXT'
}

export type TaskRecommendation = {
  __typename?: 'TaskRecommendation';
  createdAt?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineNumber: Scalars['String']['output'];
  recommendationNumber: Scalars['String']['output'];
  recommendationType: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  statusUpdatedAt?: Maybe<Scalars['String']['output']>;
  workOrders: Array<WorkOrder>;
};

/**
 * Team is a groups of users that can have particular access.
 *
 * A Structure can have multiple Teams.
 */
export type Team = {
  __typename?: 'Team';
  /** Date this Team was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** User who created this User Team */
  createdByUser: User;
  /** Unique Team ID */
  id: Scalars['ID']['output'];
  /** Team name */
  name: Scalars['String']['output'];
  /** Date this Team was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** User who last updated this User Team */
  updatedByUser: User;
  /** Users belongs to the Team */
  users: Array<User>;
};

export type Template = {
  __typename?: 'Template';
  /** Assessment Details Configuration */
  assessmentDetails?: Maybe<Array<AssessmentDetails>>;
  baseImagePath?: Maybe<Scalars['String']['output']>;
  coverImagePath?: Maybe<Scalars['String']['output']>;
  /** User who created this Template */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Defects Array allow different defects to be visible based on the Assembly Type i.e Pipe, Structure etc */
  defectsArray: Array<Scalars['String']['output']>;
  /** List of equations associated with this template */
  equations?: Maybe<Array<Equation>>;
  /** Equipment Card definitions for this Template */
  equipmentCard: Array<EquipmentCardField>;
  /** Equipment Detail Field definitions for this Template */
  equipmentDetails: Array<EquipmentDetailField>;
  /** Field definitions for this Template */
  fields: Array<AssemblyTemplateField>;
  /** Add icon detail here */
  icon?: Maybe<TemplateIcon>;
  /** Unique Template ID */
  id: Scalars['ID']['output'];
  /** Used to 'combine' multiple templates for combined deployment, should only exist if the template type is 'combined' */
  includedTemplateIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Used to denote if the template is a combined template */
  isCombined?: Maybe<Scalars['Boolean']['output']>;
  /** Auth0 ID of the user who last updated this POI Template */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Material Type Item */
  materialType?: Maybe<Array<Maybe<MaterialType>>>;
  /** Name of this Template */
  name: Scalars['String']['output'];
  octreeResourcesPath?: Maybe<Scalars['String']['output']>;
  /** Permission the user should have to access this template. e.g generic engineer don't have read:defects permission so he cannot access those template if permission = read:defects */
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Fields for Query Summary */
  querySummary?: Maybe<Array<QuerySummaryItem>>;
  /** Recommendation Field Definition used to render alarm levels or damage class UI */
  recommendation?: Maybe<RecommendationField>;
  /** Remediation Score Configuration */
  remediationScoreConfig?: Maybe<RemediationScoreConfig>;
  /** Review Panel Configuration */
  reviewPanelConfig?: Maybe<Array<ReviewPanelConfig>>;
  /** Risk assessment fields definition */
  riskFields?: Maybe<Array<RiskFields>>;
  /** Identifier for the Structure that this  belongs to */
  structure: Structure;
  /** Path for the statically generated structure relationship on S3 */
  structureRelationshipPath?: Maybe<Scalars['String']['output']>;
  /** Type of this Template */
  type: TemplateTypeEnum;
};

export type TemplateData = {
  __typename?: 'TemplateData';
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  /** Data Value associated with the Template Field */
  templateFieldId?: Maybe<Scalars['ID']['output']>;
  /** Data Value associated with the Template Field */
  value?: Maybe<Scalars['StringFloatInt']['output']>;
  /** Verified value associated with the Template Field */
  verifiedValue?: Maybe<Scalars['StringFloatInt']['output']>;
};

export type TemplateDataInput = {
  /** Unique Template Field ID */
  id: Scalars['ID']['input'];
  /** Data Value associated with the Template Field */
  value: Scalars['String']['input'];
};

export type TemplateField = {
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Key of field which has additional data for this field */
  detailFieldKey?: Maybe<Scalars['String']['output']>;
  /** Table configuration */
  displayConfig?: Maybe<DisplayConfig>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be hidden in report */
  displayInReports?: Maybe<Scalars['Boolean']['output']>;
  /** Should this field be visible in review */
  displayInReview?: Maybe<Scalars['Boolean']['output']>;
  /** Unique Template Field ID */
  id: Scalars['ID']['output'];
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Is this Template Field read-only; i.e. value cannot be updated */
  isReadOnly: Scalars['Boolean']['output'];
  /** Is this Template Field always required */
  isRequired: Scalars['Boolean']['output'];
  /** Key to identify field in template data */
  key?: Maybe<Scalars['String']['output']>;
  /** Name of this Template Field */
  name: Scalars['String']['output'];
  /** Valid options for this Template Field value */
  options: Array<Scalars['String']['output']>;
  /** Details of valid options for this Template Field value */
  optionsData?: Maybe<Array<OptionData>>;
  /** Type of permission that a user have to read the template */
  permission?: Maybe<Scalars['String']['output']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['output'];
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: Maybe<UnitsEnum>;
};

export type TemplateFieldDataValues = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TemplateFieldInput = {
  /** Should this field be visible on first load inside a list or table */
  defaultVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dependent field keys */
  dependencyMapping?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Table configuration */
  displayConfig?: InputMaybe<DisplayConfigInput>;
  /** Identify if field should be shown in the query tab */
  displayInQuery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be displayed in report filters */
  displayInReportFilters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be hidden in report */
  displayInReports?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be visible in review */
  displayInReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identify if field should be shown in the risk assessment tab */
  displayInRisk?: InputMaybe<Scalars['Boolean']['input']>;
  displayInTable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unit to display te actual value in */
  displayUnit?: InputMaybe<UnitsEnum>;
  /** Roles that the user needs to have to edit template data */
  editRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Unique ID Template Field */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Specifies if field allows editing or not */
  isEditable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should this field be exportable */
  isExportable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should not be shown in the UI. Used for identifying certain fields */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field read-only; i.e. cannot be updated */
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is this Template Field always required */
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Should not be shown in the UI. Used for identifying risk assessment filters */
  isRiskAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Key to identify field in the risk fields */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Name of this Template Field */
  name: Scalars['String']['input'];
  /** Valid options for this Template Field value */
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Details of valid options for this Template Field value */
  optionsData?: InputMaybe<Array<OptionDataInput>>;
  /** Type of permission that a user have to read the template */
  permission?: InputMaybe<Scalars['String']['input']>;
  /** Identify fixed decimal place */
  roundToDecimal?: InputMaybe<Scalars['Int']['input']>;
  /** Should the template options be fetched from the server on runtime */
  serverSide: Scalars['Boolean']['input'];
  /** Type of this Template Field */
  type: TemplateFieldTypeEnum;
  /** Identity about the unit of the field */
  unit?: InputMaybe<UnitsEnum>;
};

export enum TemplateFieldTypeEnum {
  AutoAssemblyPressureService = 'AUTO_ASSEMBLY_PRESSURE_SERVICE',
  /** Auto Populated Fields that is rendered in Paint Damage */
  AutoAssemblyService = 'AUTO_ASSEMBLY_SERVICE',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Input = 'INPUT',
  MeasurementPaintArea = 'MEASUREMENT_PAINT_AREA',
  MeasurementPaintDiameter = 'MEASUREMENT_PAINT_DIAMETER',
  /** Measurement Enums is used to render calculated fields for paint-damage */
  MeasurementPaintLength = 'MEASUREMENT_PAINT_LENGTH',
  MultiSelect = 'MULTI_SELECT',
  Numeric = 'NUMERIC',
  RadioButton = 'RADIO_BUTTON',
  SingleSelect = 'SINGLE_SELECT',
  Textarea = 'TEXTAREA'
}

export type TemplateFieldsCloneInput = {
  /** Point of interest template IDs */
  fieldIds: Array<Scalars['ID']['input']>;
  /** Name of template */
  name: Scalars['String']['input'];
  /** Source structure for the template Fields */
  sourceStructureId: Scalars['ID']['input'];
  /** Target structure for the template Fields */
  targetStructureId: Scalars['ID']['input'];
  /** Type of template */
  type: TemplateTypeEnum;
};

export type TemplateIcon = {
  __typename?: 'TemplateIcon';
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type TemplateIconInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TemplateInput = {
  /** Field definitions for this Template */
  fields?: InputMaybe<Array<TemplateFieldInput>>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Name of this Template */
  name: Scalars['String']['input'];
  /** Fields for Query Summary */
  querySummary?: InputMaybe<Array<QuerySummaryInput>>;
  /** Remediation Score Configuration */
  remediationScoreConfig?: InputMaybe<RemediationScoreConfigInput>;
  /** Review Panel Configuration */
  reviewPanelConfig?: InputMaybe<Array<ReviewPanelConfigInput>>;
  /** Risk Fields definition for each risk assessment field */
  riskFields?: InputMaybe<Array<InputMaybe<RiskFieldsInput>>>;
  /** Structure relation for this Template */
  structureId: Scalars['ID']['input'];
  /** Type of this Template */
  type: TemplateTypeEnum;
};

export enum TemplateTypeEnum {
  Assembly = 'ASSEMBLY',
  PaintBlocks = 'PAINT_BLOCKS',
  PointOfInterest = 'POINT_OF_INTEREST',
  Structure = 'STRUCTURE'
}

export enum TextFormatEnum {
  LowerCase = 'LOWER_CASE',
  None = 'NONE',
  TitleCase = 'TITLE_CASE',
  UpperCase = 'UPPER_CASE'
}

export type TransitionPeriodType = {
  __typename?: 'TransitionPeriodType';
  futureDate: Scalars['String']['output'];
  nextDate: Scalars['String']['output'];
  transitionPeriod?: Maybe<Scalars['Int']['output']>;
};

export type TypeAndCount = {
  __typename?: 'TypeAndCount';
  count: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

/** Unit Types used in preferences */
export enum UnitSystemEnum {
  Imperial = 'IMPERIAL',
  Metric = 'METRIC'
}

export enum UnitsEnum {
  Meter = 'METER',
  Millimeter = 'MILLIMETER',
  SquareMeter = 'SQUARE_METER'
}

export type UpdateAssemblyInput = {
  assemblyId: Scalars['ID']['input'];
  /** Update Bounding Box of a Assembly */
  box?: InputMaybe<Scalars['JSON']['input']>;
  /** Update Focal Point of the assembly. */
  focalPoint?: InputMaybe<Vector3Input>;
  lastModifiedFor: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  /** Update data values associated with Template for this Assembly */
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
  /** Update Template related to this Assembly for dynamic data */
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCalculationMethodInput = {
  heightType: BlisterHeightType;
  isManuallyOverridden: Scalars['Boolean']['input'];
  lastModifiedBy?: InputMaybe<Scalars['String']['input']>;
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  pointOfInterestId: Scalars['ID']['input'];
  uncertainFieldId?: InputMaybe<Scalars['String']['input']>;
  uncertainReason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommentInput = {
  id: Scalars['ID']['input'];
  structureId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type UpdateCuiPriorityInput = {
  assemblyId: Scalars['ID']['input'];
  isManuallyUpdated: Scalars['Boolean']['input'];
  lastModifiedFor: Scalars['String']['input'];
  priority: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type UpdateFilesInput = {
  addFiles: Array<FileCreateInput>;
  collectionName: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
  removeFileIds: Array<Scalars['ID']['input']>;
};

export type UpdateFilesStatusInput = {
  collectionName: Scalars['String']['input'];
  fileUpdates: Array<FileUpdates>;
  referenceId: Scalars['String']['input'];
};

export type UpdateGoverningValueInput = {
  alarmLevel?: InputMaybe<AlarmLevels>;
  analysisStatus?: InputMaybe<RecommendationStatus>;
  assemblyId: Scalars['ID']['input'];
  governingValue: GoverningValueRecommendationInput;
};

export type UpdatePaintRegionIdInput = {
  poiIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaintRegionStatusInput = {
  paintRegionId: Scalars['ID']['input'];
  remediationDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaintRegionStatus>;
};

export type UpdatePartsHiddenFlagInput = {
  /** String part mongo ids from Part documents */
  ids: Array<Scalars['String']['input']>;
  /** Boolean flag for is out of scope */
  isHidden: Scalars['Boolean']['input'];
  /** Object Id for the structure the user is tagging in */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePartsReviewedFlagInput = {
  /** String part mongo ids from Part documents */
  ids: Array<Scalars['String']['input']>;
  /** Boolean flag for a part is reviewed or not */
  isReviewed: Scalars['Boolean']['input'];
  /** Object Id for the structure the user is tagging in */
  structureId: Scalars['ID']['input'];
  /** Object Id for the zone the user is tagging in to filter the subscriptions */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePointOfInterestImageTypeInput = {
  imageId: Scalars['ID']['input'];
  imageType: ImageType;
  pointOfInterestId: Scalars['ID']['input'];
};

export type UpdatePointOfInterestInput = {
  /** Accessibility of this POI */
  accessibility?: InputMaybe<PoiAccessibilityEnum>;
  /** Update Assembly relation for this POI */
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
  /** User who created this Point of interest */
  assignee?: InputMaybe<Scalars['String']['input']>;
  /** Update blister metadata for this POI (if type is BLISTER) */
  blister?: InputMaybe<BlisterInput>;
  /** Update camera location for this POI */
  cameraLocation?: InputMaybe<Vector3Input>;
  /** Update center point for this POI */
  centerPoint3d?: InputMaybe<Vector3Input>;
  /** Comment for this POI */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Cuboids of volume of interest */
  cuboids?: InputMaybe<Array<CuboidInput>>;
  /** Due date of rectification for this Point of interest */
  dueDate?: InputMaybe<Scalars['String']['input']>;
  /** Flag to indicate if the POI fields should be evaluated */
  isFieldEvaluationSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Uninitialized Auto POI being updated to be treated as being created */
  isUninitialized?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason for the update */
  lastModifiedFor: Scalars['String']['input'];
  /** Line measurements for this POI. */
  lineMeasurement?: InputMaybe<PoiLineMeasurementInput>;
  /** Linked POIs to the cuboid */
  linkedPointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Update Location relation for this POI */
  locationId?: InputMaybe<Scalars['ID']['input']>;
  /** Update metadata for this POI */
  meta?: InputMaybe<Scalars['JSON']['input']>;
  /** Update name for this POI */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Update Paint Region relation for this POI */
  paintRegionId?: InputMaybe<Scalars['ID']['input']>;
  /** Update Part relation for this POI */
  partId?: InputMaybe<Scalars['ID']['input']>;
  /** Unique ID for POI to update */
  pointOfInterestId: Scalars['ID']['input'];
  /** Priority of this Point of interest */
  priority?: InputMaybe<PoiPriority>;
  /** Current status of this Point of interest */
  status?: InputMaybe<PoiStatus>;
  /** Update Structure relation for this POI */
  structureId?: InputMaybe<Scalars['ID']['input']>;
  /** Teams that this POI is shared with */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Update data values associated with Template for this POI */
  templateData?: InputMaybe<Array<TemplateDataInput>>;
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
  /** Update Template related to this POI for dynamic data */
  templateId?: InputMaybe<Scalars['ID']['input']>;
  /** Update type for this POI */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Unlinked POIs to the cuboid */
  unlinkedPointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Height of the POI relative to the viewpoint it was created from */
  viewpointRelativeHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Visibility for this POI */
  visibility?: InputMaybe<VisibilityEnum>;
  /** Workpack id of this poi */
  workpackId?: InputMaybe<Scalars['ID']['input']>;
  /** Workpack number of POI */
  workpackNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePointOfInterestLocationInput = {
  cuboid?: InputMaybe<CuboidInput>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  point: Vector3Input;
  pointOfInterestId: Scalars['ID']['input'];
};

export type UpdatePointOfInterestTemplateInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  fields: Array<InputPointOfInterestTemplateField>;
  icon?: InputMaybe<TemplateIconInput>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Configuration for annotations */
  markerLabelConfig?: InputMaybe<MarkerLabelConfigInput>;
  /** Name of this template */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID for POITemplate for update */
  pointOfInterestTemplateId: Scalars['ID']['input'];
  /** Type of this Template */
  type?: InputMaybe<PointOfInterestTemplateTypeEnum>;
};

export type UpdatePointOfInterestVisibilityInput = {
  /** Bulk poi update */
  isBulkUpdate: Scalars['Boolean']['input'];
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Unique IDs for POIs to update */
  pointOfInterestIds: Array<Scalars['ID']['input']>;
  /** Teams that this POI is shared with */
  teamIds: Array<Scalars['ID']['input']>;
  /** Visibility for this POI */
  visibility: VisibilityEnum;
};

export type UpdatePointOfInterestsStatusFiltersInput = {
  paintRegionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  poiTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  workpackIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdatePointOfInterestsStatusInput = {
  filters?: InputMaybe<UpdatePointOfInterestsStatusFiltersInput>;
  pointOfInterestIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status: PoiStatus;
  statusRemediatedThrough?: InputMaybe<StatusRemediatedThrough>;
};

export type UpdateRemediationScoreConfigInput = {
  /** Remediation Score Configuration to update */
  remediationScoreConfig: RemediationScoreConfigInput;
  /** Structure ID for the template */
  structureId: Scalars['ID']['input'];
  /** Template ID to update */
  templateId: Scalars['ID']['input'];
};

export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriod = {
  __typename?: 'UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriod';
  assembly?: Maybe<Array<Maybe<Assembly>>>;
  calculatedTransitionPeriod?: Maybe<TransitionPeriodType>;
  invalidDamageClassCount?: Maybe<Scalars['Int']['output']>;
};

export type UpdateRiskAssessmentTemplateFieldDataForAssembliesInput = {
  assemblyIds: Array<Scalars['ID']['input']>;
  excludedAssemblyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastModifiedFor: Scalars['String']['input'];
  selectedFilters?: InputMaybe<Array<InputMaybe<RiskAssessmentSelectedFiltersInput>>>;
  selectedInputs: Array<RiskAssessmentSelectedFiltersInput>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  updateAllAssemblies: Scalars['Boolean']['input'];
};

export type UpdateScCategoryInput = {
  assemblyId: Scalars['ID']['input'];
  scCategory: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
};

export type UpdateSingleTemplateFieldDataInput = {
  assemblyId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  lastModifiedFor: Scalars['String']['input'];
  newValue: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};

export type UpdateStructureInput = {
  /** Blister height type */
  blisterHeightType?: InputMaybe<BlisterHeightType>;
  /** List of legends and colors for the structure defects */
  defectLegends?: InputMaybe<Array<InputMaybe<DefectLegendInput>>>;
  /** Structure features to be enabled/disabled */
  features?: InputMaybe<FeaturesInput>;
  /** Enable Risk Assessment */
  hasRiskAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Active of inactive deployment */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** To switch the Abyss Rating Equation and incorporate the wall loss calculations in it */
  isWallLossEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Platform this Structure belongs to */
  platformId?: InputMaybe<Scalars['ID']['input']>;
  /** Report Configurations */
  reportConfig?: InputMaybe<ReportConfigInput>;
  /** Scan Date for the structure */
  scanDate?: InputMaybe<Scalars['String']['input']>;
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
};

export type UpdateTeamInput = {
  teamId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type UpdateTemplateFieldDataInput = {
  assemblyTemplateFieldData: Array<AssemblyTemplateFieldDataInput>;
  lastModifiedFor?: InputMaybe<Scalars['String']['input']>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdateTemplateFieldDataPofInput = {
  assemblyIds: Array<Scalars['ID']['input']>;
  excludedAssemblyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  inputValues?: InputMaybe<Array<InputMaybe<RiskAssessmentSelectedFiltersInput>>>;
  lastModifiedFor: Scalars['String']['input'];
  selectedEquation: CalculationType;
  selectedFilters?: InputMaybe<Array<InputMaybe<RiskAssessmentSelectedFiltersInput>>>;
  selectedInputs: Array<RiskAssessmentSelectedFiltersInput>;
  structureId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  updateAllAssemblies: Scalars['Boolean']['input'];
};

export type UpdateUserColumnPreferencesInput = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  key: ColumnKeysEnum;
  structureId: Scalars['ID']['input'];
};

export type UpdateUserGroupInput = {
  name: Scalars['String']['input'];
  userGroupId: Scalars['ID']['input'];
};

export type UpdateUserInfoInput = {
  connection: Scalars['String']['input'];
  email: Scalars['String']['input'];
  loginType?: InputMaybe<LoginTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  picture: Scalars['String']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status: UserStatusEnum;
  userId: Scalars['ID']['input'];
};

export type UpdateUserPreferencesInput = {
  unit: UnitSystemEnum;
};

export type UpdateWorkflowStageInput = {
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
  workflowStageId: Scalars['ID']['input'];
  workflowStageName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkflowStatusInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  difficultyLevel?: InputMaybe<DifficultyLevel>;
  state?: InputMaybe<ZoneState>;
  structureId: Scalars['ID']['input'];
  workflowStageId?: InputMaybe<Scalars['ID']['input']>;
  zoneIds: Array<Scalars['ID']['input']>;
};

export type UpdateWorkflowTimeAndStateInput = {
  assignedToUser?: InputMaybe<Scalars['JSON']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  pausedBy?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ZoneState>;
  statusId?: InputMaybe<Scalars['ID']['input']>;
  structureId: Scalars['ID']['input'];
  timeInMs?: InputMaybe<Scalars['Float']['input']>;
  trackedTime?: InputMaybe<Scalars['Boolean']['input']>;
  trackedTimeInMs?: InputMaybe<Scalars['Float']['input']>;
  typeOfTimeLog?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['ID']['input'];
};

export type UpdateWorkpackInput = {
  name: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  workpackId: Scalars['ID']['input'];
};

export type UpdateWorkpackItemInput = {
  meta?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workpackId: Scalars['ID']['input'];
  workpackItemId: Scalars['ID']['input'];
};

export type UpdateZoneStatusInput = {
  status: ZoneStatus;
  zoneId: Scalars['ID']['input'];
};

export type UpdatedTemplateFieldDataResult = {
  __typename?: 'UpdatedTemplateFieldDataResult';
  isUpdated: Scalars['Boolean']['output'];
};

export type UploadAttachmentsInput = {
  /** Attachments list */
  files: Array<FileAttributes>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** POI for which to attach files */
  pointOfInterestId: Scalars['ID']['input'];
  /** Remediation note */
  remediationNote?: InputMaybe<Scalars['String']['input']>;
};

export type UploadEsSheetInput = {
  data: Array<SheetData>;
  headers: Array<Scalars['String']['input']>;
  structureId: Scalars['String']['input'];
};

export type UploadFileInput = {
  collectionName: Scalars['String']['input'];
  fileNameType: FileNameTypes;
  files: Array<FileAttributes>;
  referenceId: Scalars['String']['input'];
  structureId: Scalars['String']['input'];
};

export type UploadImageInput = {
  /** Base64-encoded string of cover image */
  image: Scalars['String']['input'];
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['input'];
  /** Unique Structure ID */
  structureId: Scalars['ID']['input'];
};

/** User profile info */
export type User = {
  __typename?: 'User';
  /** Auth0 connection name for this user */
  connection?: Maybe<Scalars['String']['output']>;
  /** Unique email (per Auth0 connection) for this User */
  email: Scalars['String']['output'];
  /** Unique User ID */
  id: Scalars['String']['output'];
  /** Last time the user logged in */
  lastLogin?: Maybe<Scalars['String']['output']>;
  /** Total number of counts the user logged in to the fabric */
  loginCount?: Maybe<Scalars['Int']['output']>;
  /** Last time the user logged in via which channel i.e. email, google, microsoft */
  loginType?: Maybe<LoginTypeEnum>;
  /** Full name of this user */
  name?: Maybe<Scalars['String']['output']>;
  /** Permissions the user synced from auth0 */
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  /** URL to profile picture for this User */
  picture?: Maybe<Scalars['String']['output']>;
  /** Preferences of the user */
  preferences?: Maybe<UserPreferences>;
  /** Roles of user */
  roleIds: Array<Maybe<Role>>;
  /** User Status if invite is sent or not and if user logged in or not */
  status?: Maybe<UserStatusEnum>;
};

export type UserColumnPreferences = {
  __typename?: 'UserColumnPreferences';
  columns?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserColumnPreferencesInput = {
  key: ColumnKeysEnum;
  structureId: Scalars['ID']['input'];
};

/**
 * User Group is a grouping of Users.
 *
 * Users who belong to a User Group have access to all Structures that belong to the User Group.
 */
export type UserGroup = {
  __typename?: 'UserGroup';
  /** Date this User Group was created */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** User who created this User Group */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Unique UserGroup ID */
  id: Scalars['ID']['output'];
  /** Name of this User Group */
  name: Scalars['String']['output'];
  /** Date this User Group was last updated */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** User who last updated this User Group */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Unique IDs of Users that belong to this User Group */
  userIds: Array<Scalars['String']['output']>;
};

export type UserInvite = {
  __typename?: 'UserInvite';
  createdUsers: Array<Maybe<User>>;
  failedUsers?: Maybe<Array<Maybe<FailedUserInfo>>>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  structure?: Maybe<Scalars['JSON']['output']>;
  unit?: Maybe<UnitSystemEnum>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  structures: Array<Structure>;
  user: User;
  userGroups: Array<UserGroup>;
};

/** Roles assigned to user by Auth0 authentication provider */
export enum UserRolesEnum {
  Admin = 'ADMIN',
  AitEngineer = 'AIT_ENGINEER',
  AssetTaggingUser = 'ASSET_TAGGING_USER',
  WorkpackManager = 'WORKPACK_MANAGER'
}

/** User Status assigned to user after creating */
export enum UserStatusEnum {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type UsersByRoleInput = {
  q?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};

export type ValidateIdmsTemplateQueryInput = {
  csvString: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
  template: IdmsUploadsTypeEnum;
};

export type ValidateReportScopeInput = {
  componentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  selectedAssemblyTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedPaintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  structureId: Scalars['ID']['input'];
};

export type ValidateReportScopeResult = {
  __typename?: 'ValidateReportScopeResult';
  countPerReport?: Maybe<Scalars['JSON']['output']>;
  isValid: Scalars['Boolean']['output'];
};

export type ValueAndPercentage = {
  __typename?: 'ValueAndPercentage';
  percentage: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type ValueAndPercentageInput = {
  percentage: Scalars['Float']['input'];
  value: Scalars['Float']['input'];
};

export type Variable = {
  __typename?: 'Variable';
  /** The key of the field in the template */
  fieldKey: Scalars['String']['output'];
  /** If the field exists in the POI blister object */
  isBlisterField?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the variable */
  name: Scalars['String']['output'];
  /** The type of the field */
  templateType: TemplateTypeEnum;
};

export type Vector3 = {
  __typename?: 'Vector3';
  /** X axis of this Point */
  x: Scalars['Float']['output'];
  /** Y axis of this Point */
  y: Scalars['Float']['output'];
  /** Z axis of this Point */
  z: Scalars['Float']['output'];
};

export type Vector3Input = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

export type VerifiedDetails = {
  __typename?: 'VerifiedDetails';
  pointOfInterest: PointOfInterest;
  reportId: Scalars['ID']['output'];
};

export type VerifiedTemplateDataInput = {
  /** Unique Template Field ID */
  id: Scalars['ID']['input'];
  /** Verified Data Value associated with the Template Field */
  verifiedValue: Scalars['String']['input'];
};

export type VerifyPointOfInterestInput = {
  /** Unique ID for POI to verify */
  pointOfInterestId: Scalars['ID']['input'];
  /** Used to verify or unverify a POI */
  verified: Scalars['Boolean']['input'];
  /** Array of verified data for this POI */
  verifiedData?: InputMaybe<Array<VerifiedTemplateDataInput>>;
  verifiedMaxHeight?: InputMaybe<Scalars['String']['input']>;
  verifiedResidualThickness?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Version Document
 *
 * A version document is a detailed snapshot of a MongoDB collection at a specicifc point in time for auditing or rollback purposes.
 */
export type Version = {
  __typename?: 'Version';
  /** Name of MongoDB Collection where Reference Document resides */
  collectionName: Scalars['String']['output'];
  /** Date this Version was created */
  createdAt: Scalars['String']['output'];
  /** Event ID for the version */
  eventId?: Maybe<Scalars['String']['output']>;
  /** Unique Version ID */
  id: Scalars['ID']['output'];
  /** Auth0 ID of user who triggered the version */
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor: Scalars['String']['output'];
  /** Previous data in this version */
  previousData?: Maybe<Scalars['JSON']['output']>;
  /** Reference Id for the Document */
  referenceId?: Maybe<Scalars['ID']['output']>;
  /** Structure that this Version belongs to  */
  structureId?: Maybe<Scalars['ID']['output']>;
  /** Changed fields in this version */
  updatedData?: Maybe<Scalars['JSON']['output']>;
};

export type VersionInput = {
  collectionName: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  structureId: Scalars['String']['input'];
};

export enum VisibilityEnum {
  Custom = 'CUSTOM',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type WorkOrder = {
  __typename?: 'WorkOrder';
  id: Scalars['ID']['output'];
  lineNumber: Scalars['String']['output'];
  poiName: Scalars['String']['output'];
  recommendationNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusUpdatedAt?: Maybe<Scalars['String']['output']>;
  workOrderNumber: Scalars['String']['output'];
};

export type WorkflowStages = {
  __typename?: 'WorkflowStages';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderInWorkflow: Scalars['Int']['output'];
  stageType: StageType;
};

export type WorkflowStatus = {
  __typename?: 'WorkflowStatus';
  /** User assigned to this zone */
  assignedToUser?: Maybe<User>;
  /** Difficulty level of the zone */
  difficultyLevel?: Maybe<DifficultyLevel>;
  /** Idle time tracked for this zone */
  idleTime?: Maybe<Scalars['JSON']['output']>;
  /** Track if the zone is paused by user or system due to inactivity */
  pausedBy?: Maybe<PausedBy>;
  /** State of the zone */
  state?: Maybe<ZoneState>;
  /** Idle time tracked for this zone */
  totalTime?: Maybe<Scalars['JSON']['output']>;
  /** Total time tracked without starting */
  trackedTime?: Maybe<Scalars['JSON']['output']>;
  /** Details of the workflow status of this zone */
  workflowStageId: Scalars['ID']['output'];
};

export type Workpack = {
  __typename?: 'Workpack';
  /** Created by User ID */
  createdBy: Scalars['String']['output'];
  /** Unique Workpack ID */
  id: Scalars['ID']['output'];
  /** Name of this Workpack */
  name: Scalars['String']['output'];
  /** Status of this Workpack */
  status?: Maybe<WorkpackStatus>;
  /** Structure this Workpack belongs to */
  structure: Structure;
};

export type WorkpackItem = {
  __typename?: 'WorkpackItem';
  /** Date this Workpack Item was created */
  createdAt: Scalars['String']['output'];
  /** User who created this Workpack Item */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** Unique Workpack Item ID */
  id: Scalars['ID']['output'];
  /** Name of this Workpack Item */
  name: Scalars['String']['output'];
  /** Parts of interest in this Workpack Item */
  parts: Array<WorkpackItemPart>;
  /** Date this Workpack Item was last updated */
  updatedAt: Scalars['String']['output'];
  /** User who last updated this Workpack Item */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Workpack this Workpack Item belongs to */
  workpack: Workpack;
};

export type WorkpackItemPart = {
  __typename?: 'WorkpackItemPart';
  /** Metadata associated with this related Part */
  meta: Array<Meta>;
  /** Part this Workpack Item relates to */
  part: Part;
  /** Views of this related Part from Location data */
  views: Array<WorkpackItemView>;
};

export type WorkpackItemView = {
  __typename?: 'WorkpackItemView';
  /** Coordinates in Location Data for this Workpack Item */
  coordinates: PolarCoordinates;
  /** Location data which this Workpack Item belongs to */
  location: Location;
  /** Metadata associated with this view */
  meta: Array<Meta>;
};

export type WorkpackItemViewInput = {
  bearing: Scalars['Float']['input'];
  elevation: Scalars['Float']['input'];
  locationId: Scalars['ID']['input'];
  range: Scalars['Float']['input'];
};

export enum WorkpackStatus {
  ChaseItemAdded = 'CHASE_ITEM_ADDED',
  Completed = 'COMPLETED',
  DesktopReviewComplete = 'DESKTOP_REVIEW_COMPLETE',
  DesktopReviewInProgress = 'DESKTOP_REVIEW_IN_PROGRESS',
  FieldVerificationComplete = 'FIELD_VERIFICATION_COMPLETE',
  FieldVerificationInProgress = 'FIELD_VERIFICATION_IN_PROGRESS',
  FinalReviewComplete = 'FINAL_REVIEW_COMPLETE',
  FinalReviewInProgress = 'FINAL_REVIEW_IN_PROGRESS',
  Inprogress = 'INPROGRESS',
  Inreview = 'INREVIEW',
  Remediated = 'REMEDIATED'
}

export type Zone = {
  __typename?: 'Zone';
  /** Visibility Box of this Zone */
  box: Box;
  /** Unique Zone ID */
  id: Scalars['ID']['output'];
  /** Timestamp for the last update made from the API */
  lastModifiedByAPI?: Maybe<Scalars['String']['output']>;
  /** User who made the last update */
  lastModifiedByUser?: Maybe<User>;
  /** Reason for the last update */
  lastModifiedFor?: Maybe<Scalars['String']['output']>;
  /** Name of this Zone */
  name: Scalars['String']['output'];
  /** Status of the this zone */
  status: ZoneStatus;
  /** Structure of this Zone */
  structure?: Maybe<Structure>;
  /** Unique Zone ID */
  structureId: Scalars['ID']['output'];
  /** Used as meta data for the Fabric V2 in workflow management so AIT can make informed decision on who to assign this zone based upon the number of parts present in a zone */
  totalParts?: Maybe<Scalars['Int']['output']>;
  /** Used to determine the density of the zone i.e low / medium / high depending upon total points present in the zone */
  totalPoints?: Maybe<Scalars['Int']['output']>;
  /** Used as meta data for the Fabric V2 in workflow management so AIT can make informed decision on who to assign this zone based upon the number of sphericals present in a zone */
  totalSphericals?: Maybe<Scalars['Int']['output']>;
  /** Details of the workflow status of this zone */
  workflowStatus?: Maybe<WorkflowStatus>;
};

export type ZoneAndHistory = {
  __typename?: 'ZoneAndHistory';
  _id: Scalars['ID']['output'];
  box: Box;
  histories?: Maybe<Array<Maybe<History>>>;
  name: Scalars['String']['output'];
  status?: Maybe<ZoneStatus>;
  structureId: Scalars['ID']['output'];
  totalParts?: Maybe<Scalars['Int']['output']>;
  totalPoints?: Maybe<Scalars['Int']['output']>;
  totalSphericals?: Maybe<Scalars['Int']['output']>;
  workflowStatus?: Maybe<WorkflowStatus>;
};

export enum ZoneState {
  Approve = 'APPROVE',
  Backlog = 'BACKLOG',
  Pause = 'PAUSE',
  Reject = 'REJECT',
  Review = 'REVIEW',
  Start = 'START'
}

export enum ZoneStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  NotStarted = 'NOT_STARTED',
  ReviewReady = 'REVIEW_READY'
}

export type ZoneStatusCount = {
  __typename?: 'ZoneStatusCount';
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type ZoneUpdate = {
  __typename?: 'ZoneUpdate';
  createdBy: Scalars['String']['output'];
  currentStatus: ZoneStatus;
  prevStatus: ZoneStatus;
  referenceId: Scalars['ID']['output'];
};

export type ZonesPerStageInput = {
  includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  structureId: Scalars['String']['input'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ZonesPerWorklowStage = {
  __typename?: 'ZonesPerWorklowStage';
  totalCount: Scalars['Int']['output'];
  workflowStageId: Scalars['String']['output'];
  zones: Array<Zone>;
};

export type CreateNewReportInput = {
  actionStatus?: InputMaybe<ReportActionStatus>;
  componentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  internalType: ReportInternalType;
  name: Scalars['String']['input'];
  paintRegionId?: InputMaybe<Scalars['ID']['input']>;
  pointOfInterestIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pointOfInterestType?: InputMaybe<Scalars['String']['input']>;
  selectedAssemblyTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedPaintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  structureId: Scalars['String']['input'];
  type?: InputMaybe<ReportType>;
  workpackNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAssemblyFromReportInput = {
  assemblyId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type DeleteDraftReportInput = {
  reportId: Scalars['ID']['input'];
};

export type DeletePointOfInterestFromReportInput = {
  pointOfInterestId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type PointOfInterestsCountByTypeFiltersInput = {
  paintRegionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ReportInput = {
  reportId: Scalars['ID']['input'];
};

export type ReportsInput = {
  componentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  internalType?: InputMaybe<ReportInternalType>;
  name?: InputMaybe<Scalars['String']['input']>;
  selectedAssemblyTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>>>;
  selectedDeckIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  selectedPaintRegionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<ReportStatus>;
  structureId: Scalars['ID']['input'];
};

export type SupervoxelsForStructureInput = {
  structureId: Scalars['String']['input'];
  supervoxelClassId?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportByPointOfInterestsInput = {
  pointOfInterestIds: Array<InputMaybe<Scalars['ID']['input']>>;
  reportId: Scalars['ID']['input'];
};

export type UpdateReportInput = {
  actionStatus?: InputMaybe<ReportActionStatus>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pointOfInterestsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  removedPointOfInterestsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reportId: Scalars['ID']['input'];
  reportOrder?: InputMaybe<ReportOrderInput>;
  status?: InputMaybe<ReportStatus>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
  templateFieldData?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateReportPointOfInterestImagesInput = {
  pointOfInterestId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  selectedImages: Array<InputMaybe<FileInput>>;
  selectedPdfs?: InputMaybe<Array<InputMaybe<FileInput>>>;
};

export type UpdateReportStatusInput = {
  reportId: Scalars['ID']['input'];
  status: ReportStatus;
};

export type UpdateSupervoxel = {
  structureId: Scalars['ID']['input'];
  supervoxel3DReference: Array<Scalars['Int']['input']>;
  supervoxelClassId: Scalars['ID']['input'];
};

export type AllDecksForDeckPlanExplorerQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllDecksForDeckPlanExplorerQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', id: string, name: string, resourcePath: string, heightRange: Array<number>, heightStep?: number | null }> };

export type FetchSpatialHeatmapQueryVariables = Exact<{
  heatmapParameters?: InputMaybe<SpatialHeatmapInput>;
}>;


export type FetchSpatialHeatmapQuery = { __typename?: 'Query', fetchSpatialHeatmap?: { __typename?: 'SpatialHeatmap', svg: string } | null };

export type AllDefectsInDeckQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllDefectsInDeckQuery = { __typename?: 'Query', allDefects: Array<{ __typename?: 'Defect', key: string, name: string }> };

export type AllLocationsForAssemblyForDeckPlanQueryVariables = Exact<{
  input?: InputMaybe<LocationsForAssemblyInput>;
}>;


export type AllLocationsForAssemblyForDeckPlanQuery = { __typename?: 'Query', allLocationsForAssembly?: Array<{ __typename?: 'Location', id: string, resource?: string | null, resourcePath?: string | null, depthResourcePath?: string | null, name: string, distance?: number | null, videoResourcePath?: string | null, videoTimestamp?: number | null, deckPlan?: { __typename?: 'LocationDeckPlan', id: string, coordinates: Array<number> } | null, deck: { __typename?: 'Deck', name: string }, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null, pose?: { __typename?: 'LocationPose', yaw: number, yawOffset: number, z: number, y: number, x: number, roll: number, pitch: number } | null }> | null };

export type AllPaintRegionsForDeckPlanQueryVariables = Exact<{
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AllPaintRegionsForDeckPlanQuery = { __typename?: 'Query', allPaintRegions: Array<{ __typename?: 'PaintRegion', id: string, name: string, polygons: Array<{ __typename?: 'PaintRegionPolygons', area: number, points: Array<Array<number>>, type?: string | null }> }> };

export type DefectLegendsDeckSummaryQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DefectLegendsDeckSummaryQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, name: string, color: string, groupName: string, groupKey: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }> } | null };

export type AssembliesDecksSummaryQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
}>;


export type AssembliesDecksSummaryQuery = { __typename?: 'Query', getAssembliesDecksSummary: Array<{ __typename?: 'DeckAreaSummary', deckId: string, totalArea: number } | null> };

export type AllPointOfInterestsForDecksQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  selectedTemplateFilters?: InputMaybe<Array<InputMaybe<FiltersInput>> | InputMaybe<FiltersInput>>;
}>;


export type AllPointOfInterestsForDecksQuery = { __typename?: 'Query', allPointOfInterestTemplate: Array<{ __typename?: 'PointOfInterestTemplate', id: string, name: string, type?: PointOfInterestTemplateTypeEnum | null }>, allPointOfInterests: Array<{ __typename?: 'PointOfInterest', template?: { __typename?: 'PointOfInterestTemplate', id: string } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number } | null, paintRegion?: { __typename?: 'PaintRegion', deck: { __typename?: 'Deck', id: string, cadTransform: Array<number> } } | null }> };

export type ValidateIdmsFileQueryVariables = Exact<{
  input: ValidateIdmsTemplateQueryInput;
}>;


export type ValidateIdmsFileQuery = { __typename?: 'Query', validateIdmsTemplate?: string | null };

export type IdmsFileUploadMutationVariables = Exact<{
  input: IdmsUploadMutationInput;
}>;


export type IdmsFileUploadMutation = { __typename?: 'Mutation', idmsFileUpload?: { __typename?: 'IdmsUpload', name: string, filePath: string } | null };

export type IdmsUploadsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type IdmsUploadsQuery = { __typename?: 'Query', idmsUploads: Array<{ __typename?: 'IdmsUpload', id: string, name: string, templateType: IdmsUploadsTypeEnum, createdAt: string, filePath: string }> };

export type IdmsTasksQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type IdmsTasksQuery = { __typename?: 'Query', idmsTasks: { __typename?: 'IdmsTasksWithCount', count: number, tasks: Array<{ __typename?: 'IdmsTask', id: string, idmsTaskNumber: string, taskDueDate?: string | null, createdAt?: string | null, lineNumber: string, status?: string | null, statusUpdatedAt?: string | null, recommendations: Array<{ __typename?: 'TaskRecommendation', id: string, lineNumber: string, recommendationNumber: string, recommendationType: string, status?: string | null, statusUpdatedAt?: string | null, workOrders: Array<{ __typename?: 'WorkOrder', id: string, lineNumber: string, poiName: string, recommendationNumber?: string | null, status?: string | null, statusUpdatedAt?: string | null, workOrderNumber: string }> }> }> } };

export type LatestIdmsUploadsByTypeQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LatestIdmsUploadsByTypeQuery = { __typename?: 'Query', latestIdmsUploadsByType: Array<{ __typename?: 'IdmsUpload', name: string, createdAt: string, templateType: IdmsUploadsTypeEnum, filePath: string }> };

export type BulkPipeSpecUploadMutationVariables = Exact<{
  input: BulkPipeSpecUploadInput;
}>;


export type BulkPipeSpecUploadMutation = { __typename?: 'Mutation', bulkPipeSpecUpload: { __typename?: 'BulkPipeSpecUploadResponse', message: string, onlyValidated: boolean, updatedCount: number } };

export type BulkUploadServiceGroupsMutationVariables = Exact<{
  input: BulkUploadServiceGroupsInput;
}>;


export type BulkUploadServiceGroupsMutation = { __typename?: 'Mutation', bulkUploadServiceGroups: { __typename?: 'BulkServiceGroupsResponse', message: string, updatedCount: number } };

export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null }> };

export type AllDecksQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllDecksQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', id: string, name: string }> };

export type DecksWithDefectsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DecksWithDefectsQuery = { __typename?: 'Query', allDefects: Array<{ __typename?: 'Defect', key: string, name: string }>, decksWithDefects: Array<{ __typename?: 'DeckWithDefects', id: string, name: string, defectArea: Array<{ __typename?: 'DefectArea', key: string, area: number }> }> };

export type UpdatePaintRegionStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdatePaintRegionStatusInput>;
}>;


export type UpdatePaintRegionStatusMutation = { __typename?: 'Mutation', updatePaintRegionStatus: { __typename?: 'PaintRegion', status?: PaintRegionStatus | null, remediationDate?: string | null } };

export type UpdatePointOfInterestsStatusMutationVariables = Exact<{
  input: UpdatePointOfInterestsStatusInput;
}>;


export type UpdatePointOfInterestsStatusMutation = { __typename?: 'Mutation', updatePointOfInterestsStatus?: string | null };

export type AllPaintRegionsForPaintBlockTableQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllPaintRegionsForPaintBlockTableQuery = { __typename?: 'Query', allPaintRegions: Array<{ __typename?: 'PaintRegion', id: string, name: string, status?: PaintRegionStatus | null, remediationDate?: string | null, paintRegionGroup?: { __typename?: 'PaintRegionGroup', id: string, name: string } | null }> };

export type DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables = Exact<{
  input: PaintBlockFiltersInput;
}>;


export type DefectsAreaAndPointOfInterestCountByPaintRegionsQuery = { __typename?: 'Query', defectsAreaForAssemblyPaintRegions: { __typename?: 'PaintBlocksCorrodedArea', structureIds: Array<string>, defectsByDeck: Array<{ __typename?: 'NameAndArea', name: string, deckIds?: Array<string | null> | null, totalArea?: Array<{ __typename?: 'AreaAndType', type: string, value: number } | null> | null }>, defectsByPaintBlock: Array<{ __typename?: 'NameAndArea', name: string, paintRegionIds?: Array<string | null> | null, totalArea?: Array<{ __typename?: 'AreaAndType', type: string, value: number } | null> | null }> }, pointOfInterestCountByPaintRegions: { __typename?: 'PointOfInterestsFindingsByDeckAndPaintBlock', structureIds: Array<string>, findingsByDeck: Array<{ __typename?: 'PointOfInterestFindingAndName', name: string, totalCount: number, pointOfInterestFindings: Array<{ __typename?: 'PointOfInterestFindings', type: string, count: number }> }>, findingsByPaintBlock: Array<{ __typename?: 'PointOfInterestFindingAndName', name: string, totalCount: number, pointOfInterestFindings: Array<{ __typename?: 'PointOfInterestFindings', type: string, count: number }> }> } };

export type DefectsAreaForCustomBlocksQueryVariables = Exact<{
  input: PaintBlockFiltersInput;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type DefectsAreaForCustomBlocksQuery = { __typename?: 'Query', defectsAreaForAssemblyPaintRegionsByGroup: { __typename?: 'PaintBlocksCorrodedAreaByGroup', structureId: string, totalCount: number, defectsByPaintBlock: Array<{ __typename?: 'NameAndAreaByGroup', name: string, paintRegionId: string, totalArea?: Array<{ __typename?: 'AreaAndType', value: number, type: string } | null> | null, totalCountByPoiType?: Array<{ __typename?: 'AreaAndType', type: string, value: number } | null> | null }> } };

export type RiskRemidiationTrendAnalyticsQueryVariables = Exact<{
  input?: InputMaybe<AnalyticsFiltersInput>;
}>;


export type RiskRemidiationTrendAnalyticsQuery = { __typename?: 'Query', analytics: Array<{ __typename?: 'Analytics', data: any, id: string, structureIds: Array<string>, displayConfig?: any | null }> };

export type PointOfInterestsCountByDueDateQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
}>;


export type PointOfInterestsCountByDueDateQuery = { __typename?: 'Query', pointOfInterestsCountByDueDate?: Array<{ __typename?: 'AnomalyCount', count?: number | null, key?: string | null } | null> | null };

export type PaintDamageCountByAlarmLevelQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
}>;


export type PaintDamageCountByAlarmLevelQuery = { __typename?: 'Query', paintDamageCountByAlarmLevel?: Array<{ __typename?: 'AnomalyCount', key?: string | null, count?: number | null } | null> | null };

export type PointOfInterestsCountByInspectionPriorityQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
}>;


export type PointOfInterestsCountByInspectionPriorityQuery = { __typename?: 'Query', pointOfInterestsCountByInspectionPriority?: Array<{ __typename?: 'AnomalyCount', count?: number | null, key?: string | null } | null> | null };

export type PointOfInterestsCountByStatusQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestMultiStructureInput>;
}>;


export type PointOfInterestsCountByStatusQuery = { __typename?: 'Query', pointOfInterestsCountByStatus?: Array<{ __typename?: 'AnomalyCount', key?: string | null, count?: number | null } | null> | null };

export type PoiWorkflowQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type PoiWorkflowQuery = { __typename?: 'Query', pointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, name?: string | null, status?: PoiStatus | null, assignee?: string | null, dueDate?: string | null, visibility?: VisibilityEnum | null, accessibility?: PoiAccessibilityEnum | null, comment?: string | null, isAutoGenerated?: boolean | null, linkedPointOfInterestIds?: Array<string> | null, poiId?: string | null, workpackNumber?: string | null }>, pointOfInterestsCount?: { __typename?: 'Count', count: number } | null };

export type AllWorkpacksQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  hasPois?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AllWorkpacksQuery = { __typename?: 'Query', allWorkpacks: Array<{ __typename?: 'Workpack', id: string, name: string }> };

export type DeleteWorkpackMutationVariables = Exact<{
  input?: InputMaybe<DeleteWorkpackInput>;
}>;


export type DeleteWorkpackMutation = { __typename?: 'Mutation', deleteWorkpack?: { __typename?: 'Workpack', id: string, name: string } | null };

export type RemoveWorkpackIdFromPointOfInterestsMutationVariables = Exact<{
  input?: InputMaybe<InputGroupByWorkpackId>;
}>;


export type RemoveWorkpackIdFromPointOfInterestsMutation = { __typename?: 'Mutation', RemoveWorkpackIdFromPointOfInterests?: Array<{ __typename?: 'PointOfInterest', name?: string | null } | null> | null };

export type CreateWorkpackMutationVariables = Exact<{
  input?: InputMaybe<CreateWorkpackInput>;
}>;


export type CreateWorkpackMutation = { __typename?: 'Mutation', createWorkpack?: { __typename?: 'Workpack', name: string, id: string } | null };

export type UpdateWorkpackMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkpackInput>;
}>;


export type UpdateWorkpackMutation = { __typename?: 'Mutation', updateWorkpack?: { __typename?: 'Workpack', id: string, name: string } | null };

export type UpdateWorkpackStatusMutationVariables = Exact<{
  workpackId: Scalars['ID']['input'];
  status: WorkpackStatus;
}>;


export type UpdateWorkpackStatusMutation = { __typename?: 'Mutation', updateWorkpackStatus?: { __typename?: 'Workpack', status?: WorkpackStatus | null } | null };

export type GroupPointOfInterestsByWorkpackIdMutationVariables = Exact<{
  input?: InputMaybe<InputGroupByWorkpackId>;
}>;


export type GroupPointOfInterestsByWorkpackIdMutation = { __typename?: 'Mutation', GroupPointOfInterestsByWorkpackId?: Array<{ __typename?: 'PointOfInterest', poiId?: string | null } | null> | null };

export type GetPointOfInterestGroupedByWorkpackQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetPointOfInterestGroupedByWorkpackQuery = { __typename?: 'Query', allWorkpacks: Array<{ __typename?: 'PointOfInterestsGroupedByWorkpack', _id?: string | null, verifiedPointOfInterestsCount?: number | null, pointOfInterestsCount?: number | null, assembliesCount?: number | null, workpack?: { __typename?: 'Workpack', name: string, status?: WorkpackStatus | null } | null }>, workpacksCount?: { __typename?: 'Count', count: number } | null };

export type AllPointOfInterestsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type AllPointOfInterestsQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, name?: string | null, assembly: { __typename?: 'Assembly', tagName: string, id: string }, template?: { __typename?: 'PointOfInterestTemplate', id: string } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null }> | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: WorkpackStatus | null } | null }> };

export type UpdateReportByPointOfInterestsMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportByPointOfInterestsInput>;
}>;


export type UpdateReportByPointOfInterestsMutation = { __typename?: 'Mutation', updateReportByPointOfInterests: { __typename?: 'Report', createdAt: string, id?: string | null, name: string, status: ReportStatus } };

export type UpdatePointOfInterestVisibilityMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestVisibilityInput>;
  filters?: InputMaybe<PointOfInterestInput>;
}>;


export type UpdatePointOfInterestVisibilityMutation = { __typename?: 'Mutation', updatePointOfInterestVisibility: Array<{ __typename?: 'PointOfInterest', id: string }> };

export type GetUserPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPreferencesQuery = { __typename?: 'Query', getUserPreferences?: { __typename?: 'UserPreferences', structure?: any | null } | null };

export type PointOfInterestsCountByTypeQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
}>;


export type PointOfInterestsCountByTypeQuery = { __typename?: 'Query', pointOfInterestsCountByType?: Array<{ __typename?: 'PointOfInterestsCountByType', count?: number | null, type?: string | null } | null> | null };

export type UpdateUserColumnPreferencesMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserColumnPreferencesInput>;
}>;


export type UpdateUserColumnPreferencesMutation = { __typename?: 'Mutation', updateUserColumnPreferences?: { __typename?: 'User', preferences?: { __typename?: 'UserPreferences', structure?: any | null } | null } | null };

export type CreateAssemblyMutationVariables = Exact<{
  input?: InputMaybe<CreateAssemblyInput>;
}>;


export type CreateAssemblyMutation = { __typename?: 'Mutation', createAssembly?: { __typename?: 'Template', name: string, id: string, defectsArray: Array<string>, recommendation?: { __typename?: 'RecommendationField', header: string, details: Array<{ __typename?: 'RecommendationDetailField', id: string, fieldKey: string } | null> } | null, equipmentCard: Array<{ __typename?: 'EquipmentCardField', id: string, name: string, type: EqiupmentCardFieldTypeEnum, position: EquipmentCardPositionEnum, fieldKey?: string | null, location: EquipmentCardLocationEnum }>, equipmentDetails: Array<{ __typename?: 'EquipmentDetailField', id: string, name: string, subType?: EquipmentDetailSubTypeEnum | null, type: EquipmentDetailTypeEnum, fieldKey: string, options: Array<{ __typename?: 'EquipmentDetailOptionField', id: string, name: string, type: OptionFieldTypeEnum, fieldKey?: string | null }> }>, querySummary?: Array<{ __typename?: 'QuerySummaryItem', name: string, key?: string | null, operation: string }> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', isEditable?: boolean | null, editRoles?: Array<string | null> | null, options: Array<string>, id: string, name: string, key?: string | null, type: TemplateFieldTypeEnum, serverSide: boolean, permission?: string | null, displayInQuery?: boolean | null, displayInRisk?: boolean | null, roundToDecimal?: number | null, unit?: UnitsEnum | null, displayUnit?: UnitsEnum | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null } | null }> } | null };

export type GetAllTemplatesByTypeQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetAllTemplatesByTypeQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, permissions?: Array<string | null> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string }> }> };

export type GetStructureDeploymentLevelQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStructureDeploymentLevelQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', deploymentLevel?: StructureDeploymentLevel | null } | null };

export type GetAssembliesSummaryQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
}>;


export type GetAssembliesSummaryQuery = { __typename?: 'Query', getAssembliesSummary: Array<{ __typename?: 'AssemblySummary', id: string, name: string, key?: string | null, operation: string, displayType: DisplayType, rowOrder: number, data?: any | null, displayConfig?: Array<{ __typename?: 'DisplaySettings', fieldValue: string, color: string }> | null }> };

export type DecksWithPaintRegionsDataQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DecksWithPaintRegionsDataQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', id: string, name: string, resourcePath: string, heightRange: Array<number>, heightStep?: number | null }>, allPaintRegions: Array<{ __typename?: 'PaintRegion', id: string, name: string, deck: { __typename?: 'Deck', id: string } }> };

export type GetPaintblockTemplateQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetPaintblockTemplateQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, isHidden?: boolean | null, isReadOnly: boolean, defaultVisible?: boolean | null }> }> };

export type DefectLegendsForPaintBlockTableQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DefectLegendsForPaintBlockTableQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', defectLegends: Array<{ __typename?: 'DefectLegend', id: number, name: string, groupKey: string, groupName: string, color: string }> } | null };

export type GetAnalysisStructureLocationsQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetAnalysisStructureLocationsQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, baseResourcePath?: string | null, scanKey?: string | null, videoResourcePath?: string | null, videoTimestamp?: number | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null, layers?: Array<{ __typename?: 'LocationLayer', fileExt?: string | null, type: string, displayName: string } | null> | null, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null, deck: { __typename?: 'Deck', name: string } }> };

export type GetStructureDataQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureDataQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', hasRiskAssessment?: boolean | null, blisterHeightType?: BlisterHeightType | null, isActive?: boolean | null, id: string, name: string, platform?: { __typename?: 'Platform', id: string } | null } | null };

export type GetAssemblyByTagNameQueryVariables = Exact<{
  tagName: Scalars['String']['input'];
  structureId: Scalars['ID']['input'];
}>;


export type GetAssemblyByTagNameQuery = { __typename?: 'Query', assemblyByTagName?: { __typename?: 'Assembly', id: string } | null };

export type UpdateWallLossFactorMutationVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  wallLossFactor?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateWallLossFactorMutation = { __typename?: 'Mutation', updateWallLossFactor?: string | null };

export type AssembliesFragment = { __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string }> }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null };

export type PointOfInterestsFragment = { __typename?: 'PointOfInterest', id: string, poiId?: string | null, name?: string | null, type: string, accessibility?: PoiAccessibilityEnum | null, workpackNumber?: string | null, isVerified?: boolean | null, status?: PoiStatus | null, deckRelativeHeight?: number | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: WorkpackStatus | null } | null, template?: { __typename?: 'PointOfInterestTemplate', createdBy?: string | null, id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, type: TemplateFieldTypeEnum }> } | null, templateData?: Array<{ __typename?: 'TemplateData', templateFieldId?: string | null, value?: any | null, verifiedValue?: any | null, id: string }> | null, assembly: { __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string }> }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }, paintRegion?: { __typename?: 'PaintRegion', name: string, deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, verifiedMaxHeight?: string | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, fittingRadius: number, manualSetHeight?: number | null, verifiedResidualThickness?: string | null, radius: number, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders: Array<{ __typename?: 'PolarPoint', bearing: number, elevation: number } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewpoint?: string | null, viewer?: string | null } | null, location?: { __typename?: 'Location', deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null };

export type AllReportsListQueryVariables = Exact<{
  input?: InputMaybe<ReportsInput>;
}>;


export type AllReportsListQuery = { __typename?: 'Query', allReports: Array<{ __typename?: 'Report', internalType: ReportInternalType, createdAt: string, id?: string | null, name: string, status: ReportStatus, actionStatus?: ReportActionStatus | null, dueDate?: string | null, workpackNumber?: string | null, type?: ReportType | null, createdByUser: { __typename?: 'User', name?: string | null }, pointOfInterests?: Array<{ __typename?: 'PointOfInterest', id: string, assembly: { __typename?: 'Assembly', id: string } }> | null } | null> };

export type UpdateReportDueDateMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportInput>;
}>;


export type UpdateReportDueDateMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', id?: string | null, dueDate?: string | null } };

export type UpdateReportActionStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportInput>;
}>;


export type UpdateReportActionStatusMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', id?: string | null, actionStatus?: ReportActionStatus | null } };

export type TemplatesFragment = { __typename?: 'PointOfInterestTemplate', createdBy?: string | null, id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, isReadOnly: boolean, isRequired: boolean, isHidden?: boolean | null, name: string, options: Array<string>, type: TemplateFieldTypeEnum }> };

export type AllReportImagesQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type AllReportImagesQuery = { __typename?: 'Query', allReportImages: Array<{ __typename?: 'PointOfInterestImages', pointOfInterestId: any, selectedImages?: Array<{ __typename?: 'File', name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, id?: string | null, imageType?: ImageType | null, uuid?: string | null } | null> | null }> };

export type ReportDetailsQueryVariables = Exact<{
  input?: InputMaybe<ReportInput>;
}>;


export type ReportDetailsQuery = { __typename?: 'Query', report: { __typename?: 'Report', createdAt: string, id?: string | null, name: string, status: ReportStatus, templateFieldData?: any | null, actionStatus?: ReportActionStatus | null, dueDate?: string | null, internalType: ReportInternalType, type?: ReportType | null, createdByUser: { __typename?: 'User', name?: string | null, picture?: string | null }, paintRegion?: { __typename?: 'PaintRegion', name: string, id: string } | null, pointOfInterests?: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, name?: string | null, type: string, accessibility?: PoiAccessibilityEnum | null, workpackNumber?: string | null, isVerified?: boolean | null, status?: PoiStatus | null, deckRelativeHeight?: number | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: WorkpackStatus | null } | null, template?: { __typename?: 'PointOfInterestTemplate', createdBy?: string | null, id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, type: TemplateFieldTypeEnum }> } | null, templateData?: Array<{ __typename?: 'TemplateData', templateFieldId?: string | null, value?: any | null, verifiedValue?: any | null, id: string }> | null, assembly: { __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string }> }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }, paintRegion?: { __typename?: 'PaintRegion', name: string, deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, verifiedMaxHeight?: string | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, fittingRadius: number, manualSetHeight?: number | null, verifiedResidualThickness?: string | null, radius: number, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders: Array<{ __typename?: 'PolarPoint', bearing: number, elevation: number } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewpoint?: string | null, viewer?: string | null } | null, location?: { __typename?: 'Location', deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }> | null, selectedPointOfInterestImages?: Array<{ __typename?: 'PointOfInterestImages', pointOfInterestId: any, selectedImages?: Array<{ __typename?: 'File', name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, id?: string | null, imageType?: ImageType | null, uuid?: string | null, caption?: string | null } | null> | null } | null> | null, allPointOfInterestPdfs?: Array<{ __typename?: 'PointOfInterestPdfs', pointOfInterestId: any, selectedPdfs?: Array<{ __typename?: 'FileWithStatus', selectedStatus: boolean, file: { __typename?: 'File', name: FileNameTypes, resourcePath: string, fileName: string, type: FileTypes, uploadStatus?: FileUploadStatus | null, id?: string | null } }> | null } | null> | null, files?: Array<{ __typename?: 'File', fileName: string, id?: string | null, name: FileNameTypes, resourcePath: string, size?: number | null, type: FileTypes, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null, reportOrder?: { __typename?: 'ReportOrder', assemblyOrder?: Array<string | null> | null, poiOrder?: any | null } | null, components?: Array<{ __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string }> }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }> | null, cviPois?: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, name?: string | null, type: string, accessibility?: PoiAccessibilityEnum | null, workpackNumber?: string | null, isVerified?: boolean | null, status?: PoiStatus | null, deckRelativeHeight?: number | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: WorkpackStatus | null } | null, template?: { __typename?: 'PointOfInterestTemplate', createdBy?: string | null, id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, type: TemplateFieldTypeEnum }> } | null, templateData?: Array<{ __typename?: 'TemplateData', templateFieldId?: string | null, value?: any | null, verifiedValue?: any | null, id: string }> | null, assembly: { __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string }> }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }, paintRegion?: { __typename?: 'PaintRegion', name: string, deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, verifiedMaxHeight?: string | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, fittingRadius: number, manualSetHeight?: number | null, verifiedResidualThickness?: string | null, radius: number, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders: Array<{ __typename?: 'PolarPoint', bearing: number, elevation: number } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewpoint?: string | null, viewer?: string | null } | null, location?: { __typename?: 'Location', deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }> | null, gviPois?: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, name?: string | null, type: string, accessibility?: PoiAccessibilityEnum | null, workpackNumber?: string | null, isVerified?: boolean | null, status?: PoiStatus | null, deckRelativeHeight?: number | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: WorkpackStatus | null } | null, template?: { __typename?: 'PointOfInterestTemplate', createdBy?: string | null, id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, type: TemplateFieldTypeEnum }> } | null, templateData?: Array<{ __typename?: 'TemplateData', templateFieldId?: string | null, value?: any | null, verifiedValue?: any | null, id: string }> | null, assembly: { __typename?: 'Assembly', templateFieldData?: any | null, id: string, tagName: string, area?: number | null, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null, template: { __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string }> }, service?: { __typename?: 'Service', group: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }, paintRegion?: { __typename?: 'PaintRegion', name: string, deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, verifiedMaxHeight?: string | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, fittingRadius: number, manualSetHeight?: number | null, verifiedResidualThickness?: string | null, radius: number, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders: Array<{ __typename?: 'PolarPoint', bearing: number, elevation: number } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewpoint?: string | null, viewer?: string | null } | null, location?: { __typename?: 'Location', deck: { __typename?: 'Deck', name: string, imageDimensions: Array<number>, resourcePath: string, cadTransform: Array<number> } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }> | null } };

export type ReportPointOfInterestVerifiedSubscriptionVariables = Exact<{
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReportPointOfInterestVerifiedSubscription = { __typename?: 'Subscription', reportPointOfInterestVerified: { __typename?: 'VerifiedDetails', reportId: string, pointOfInterest: { __typename?: 'PointOfInterest', id: string, isVerified?: boolean | null, templateData?: Array<{ __typename?: 'TemplateData', templateFieldId?: string | null, value?: any | null, verifiedValue?: any | null, id: string }> | null } } };

export type UpdateReportStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportStatusInput>;
}>;


export type UpdateReportStatusMutation = { __typename?: 'Mutation', updateReportStatus: { __typename?: 'Report', id?: string | null, status: ReportStatus } };

export type UpdateReportOrderMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportInput>;
}>;


export type UpdateReportOrderMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', id?: string | null, reportOrder?: { __typename?: 'ReportOrder', assemblyOrder?: Array<string | null> | null, poiOrder?: any | null } | null } };

export type DeleteReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport: boolean };

export type UpdatePoiImagesMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportPointOfInterestImagesInput>;
}>;


export type UpdatePoiImagesMutation = { __typename?: 'Mutation', updateReportPointOfInterestImages: { __typename?: 'Report', id?: string | null, selectedPointOfInterestImages?: Array<{ __typename?: 'PointOfInterestImages', pointOfInterestId: any, selectedImages?: Array<{ __typename?: 'File', name: FileNameTypes, fileName: string, type: FileTypes, resourcePath: string, id?: string | null, uuid?: string | null, imageType?: ImageType | null } | null> | null } | null> | null, allPointOfInterestPdfs?: Array<{ __typename?: 'PointOfInterestPdfs', pointOfInterestId: any, selectedPdfs?: Array<{ __typename?: 'FileWithStatus', selectedStatus: boolean, file: { __typename?: 'File', name: FileNameTypes, resourcePath: string, fileName: string, type: FileTypes, uploadStatus?: FileUploadStatus | null, id?: string | null } }> | null } | null> | null } };

export type PreSignedUrlToUploadFilesMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type PreSignedUrlToUploadFilesMutation = { __typename?: 'Mutation', preSignedUrlToUploadFiles: Array<{ __typename?: 'GeneratedPresignedURL', url: string, id: string, resourcePath: string, uuid: string }> };

export type UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables = Exact<{
  input: UpdateFilesStatusInput;
}>;


export type UpdateFileStatusForPaintBlockReportManualUploadsMutation = { __typename?: 'Mutation', updateFilesStatus?: boolean | null };

export type AddAndRemoveFilesMutationVariables = Exact<{
  input: UpdateFilesInput;
}>;


export type AddAndRemoveFilesMutation = { __typename?: 'Mutation', addAndRemoveFiles?: boolean | null };

export type UpdateReportMutationVariables = Exact<{
  input?: InputMaybe<UpdateReportInput>;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', templateFieldData?: any | null, id?: string | null, selectedPointOfInterestImages?: Array<{ __typename?: 'PointOfInterestImages', pointOfInterestId: any, selectedImages?: Array<{ __typename?: 'File', name: FileNameTypes, fileName: string, type: FileTypes, resourcePath: string, id?: string | null, uuid?: string | null, imageType?: ImageType | null } | null> | null } | null> | null, allPointOfInterestPdfs?: Array<{ __typename?: 'PointOfInterestPdfs', pointOfInterestId: any, selectedPdfs?: Array<{ __typename?: 'FileWithStatus', selectedStatus: boolean, file: { __typename?: 'File', name: FileNameTypes, resourcePath: string, fileName: string, type: FileTypes, uploadStatus?: FileUploadStatus | null, id?: string | null } }> | null } | null> | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, type: FileTypes, resourcePath: string, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null } };

export type DefectsAreaForAssemblyPaintRegionsQueryVariables = Exact<{
  input: PaintBlockFiltersInput;
}>;


export type DefectsAreaForAssemblyPaintRegionsQuery = { __typename?: 'Query', defectsAreaForAssemblyPaintRegions: { __typename?: 'PaintBlocksCorrodedArea', defectsByPaintBlock: Array<{ __typename?: 'NameAndArea', totalArea?: Array<{ __typename?: 'AreaAndType', type: string, value: number } | null> | null }> } };

export type ValidateReportScopeQueryVariables = Exact<{
  input?: InputMaybe<ValidateReportScopeInput>;
}>;


export type ValidateReportScopeQuery = { __typename?: 'Query', validateReportScope: { __typename?: 'ValidateReportScopeResult', isValid: boolean } };

export type StructureForReportQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureForReportQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', reportConfig?: { __typename?: 'ReportConfig', title: string, id: string, configurations?: Array<{ __typename?: 'Configurations', id: string, title: string, key: string }> | null } | null } | null };

export type GetAssemblyAttachmentsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyAttachmentsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, caption?: string | null, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null } | null };

export type UpdatePointOfInterestImageTypeMutationVariables = Exact<{
  input: UpdatePointOfInterestImageTypeInput;
}>;


export type UpdatePointOfInterestImageTypeMutation = { __typename?: 'Mutation', updatePointOfInterestImageType?: { __typename?: 'PointOfInterest', files?: Array<{ __typename?: 'File', id?: string | null, imageType?: ImageType | null }> | null } | null };

export type GetAssemblyForEvaluationQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyForEvaluationQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', templateFieldData?: any | null, area?: number | null } | null };

export type GetAssembliesForEvaluationQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesForEvaluationQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, templateFieldData?: any | null, area?: number | null }> };

export type GetAllAssembliesForEvaluationQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAllAssembliesForEvaluationQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null }> };

export type StructureDefectLegendsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureDefectLegendsQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', defectLegends: Array<{ __typename?: 'DefectLegend', id: number, groupName: string, groupKey: string, name: string, color: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }> } | null };

export type UpdateReportDataMutationVariables = Exact<{
  input?: InputMaybe<UpdateSingleTemplateFieldDataInput>;
}>;


export type UpdateReportDataMutation = { __typename?: 'Mutation', updateSingleTemplateFieldData?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type PointOfInterestActivitySubscriptionVariables = Exact<{
  structureId: Scalars['ID']['input'];
  assemblyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PointOfInterestActivitySubscription = { __typename?: 'Subscription', pointOfInterestActivity: { __typename?: 'PointOfInterest', name?: string | null } };

export type BulkUpdateReviewActionMutationVariables = Exact<{
  input?: InputMaybe<BulkUpdateReviewActionInput>;
}>;


export type BulkUpdateReviewActionMutation = { __typename?: 'Mutation', bulkUpdateReviewAction?: { __typename?: 'BulkUpdateReviewActionResponse', count?: number | null } | null };

export type AllCommentsForRiskAssessmentQueryVariables = Exact<{
  input?: InputMaybe<AllCommentsInput>;
}>;


export type AllCommentsForRiskAssessmentQuery = { __typename?: 'Query', allComments?: Array<{ __typename?: 'Comment', id: string, text: string, structureId: any, title?: string | null, updatedAt: string, collectionName: string, key?: string | null, createdByUser: { __typename?: 'User', picture?: string | null, name?: string | null } }> | null };

export type UpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'Comment', id: string, text: string, title?: string | null, updatedAt: string } };

export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables = Exact<{
  input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput;
}>;


export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation = { __typename?: 'Mutation', updateRiskAssessmentTemplateFieldDataForAssemblies?: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null } | null> | null };

export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables = Exact<{
  input: UpdateTemplateFieldDataPofInput;
}>;


export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutation = { __typename?: 'Mutation', updateAssembliesProbabilityOfFailureRiskFactors?: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null } | null> | null };

export type GetAssembliesRiskAssessmentSummaryQueryVariables = Exact<{
  input?: InputMaybe<RiskAssessmentSummaryInput>;
}>;


export type GetAssembliesRiskAssessmentSummaryQuery = { __typename?: 'Query', getAssembliesRiskAssessmentSummary: Array<{ __typename?: 'RiskAssessmentSummary', key?: string | null, values?: Array<{ __typename?: 'RiskType', count?: number | null, value?: string | null } | null> | null } | null> };

export type StructureForRiskAssessmentQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureForRiskAssessmentQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, type: StructureTypes, hasRiskAssessment?: boolean | null, esSheetStatus?: EsSheetStatus | null, template?: { __typename?: 'Template', id: string } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, templateFieldId?: string | null }> | null } | null };

export type AllAssemblyTemplatesForRiskAssessmentQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
}>;


export type AllAssemblyTemplatesForRiskAssessmentQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', name: string, id: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null, type: TemplateFieldTypeEnum, options: Array<string>, permission?: string | null, displayInQuery?: boolean | null, displayInTable?: boolean | null, displayInRisk?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, roundToDecimal?: number | null, unit?: UnitsEnum | null, displayUnit?: UnitsEnum | null, isExportable?: boolean | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textFormat?: TextFormatEnum | null, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null } | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, min?: number | null, max?: number | null }> | null }>, riskFields?: Array<{ __typename?: 'RiskFields', type: Array<RiskFieldsTypeEnum | null>, isHiddenColumn: boolean, id: string, fieldKey: string }> | null }> };

export type GetTemplateByTypeQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetTemplateByTypeQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, fields: Array<{ __typename?: 'AssemblyTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, key?: string | null, isHidden?: boolean | null, isReadOnly: boolean }> }> };

export type GetAssembliesByRiskAssessmentFiltersQueryVariables = Exact<{
  input: RiskAssessmentFiltersInput;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesByRiskAssessmentFiltersQuery = { __typename?: 'Query', getAssembliesByRiskAssessmentFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, isUncontextualized?: boolean | null, decks?: Array<{ __typename?: 'DecksDetails', deckId: { __typename?: 'Deck', id: string } } | null> | null }>, getRiskAssembliesCount?: { __typename?: 'Count', count: number } | null };

export type GetDependentRiskAssessmentOptionsQueryVariables = Exact<{
  input?: InputMaybe<RiskAssessmentFiltersInput>;
}>;


export type GetDependentRiskAssessmentOptionsQuery = { __typename?: 'Query', getDependentRiskAssessmentOptions?: Array<{ __typename?: 'RiskAssessmentDependentOptions', key?: string | null, options?: Array<string | null> | null } | null> | null };

export type CreateRiskAssessmentDetailsMutationVariables = Exact<{
  input?: InputMaybe<CreateRiskAssessmentDetailsInput>;
}>;


export type CreateRiskAssessmentDetailsMutation = { __typename?: 'Mutation', createRiskAssessmentDetails?: { __typename?: 'Structure', id: string, name: string, type: StructureTypes, hasRiskAssessment?: boolean | null, template?: { __typename?: 'Template', id: string } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, templateFieldId?: string | null }> | null } | null };

export type GetAssemblyForTaskModalQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyForTaskModalQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables = Exact<{
  input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput;
}>;


export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation = { __typename?: 'Mutation', updateRiskAssessmentTemplateFieldDataAndTransitionPeriod?: { __typename?: 'UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriod', invalidDamageClassCount?: number | null, calculatedTransitionPeriod?: { __typename?: 'TransitionPeriodType', transitionPeriod?: number | null, nextDate: string, futureDate: string } | null } | null };

export type GetMaterialTemplateByTypeQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetMaterialTemplateByTypeQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', materialType?: Array<{ __typename?: 'MaterialType', type: string, thickness?: Array<string | null> | null, corrosivityCategory?: Array<{ __typename?: 'CorrosivityCategoryItem', name: string, values: any }> | null, environmentalClassification?: Array<{ __typename?: 'EnvironmentalClassificationItem', name: string, values: any }> | null, environmentalExposure?: Array<{ __typename?: 'EnvironmentalExposureItem', name: string, code: string, timeToVisibility: number }> | null } | null> | null }> };

export type BulkCreateCommentsForAssembliesMutationVariables = Exact<{
  input?: InputMaybe<BulkCreateForAssembliesInput>;
}>;


export type BulkCreateCommentsForAssembliesMutation = { __typename?: 'Mutation', bulkCreateCommentsForAssemblies?: { __typename?: 'BulkCreateOrUpdateCommentsForAssemblies', modifiedCount: number, insertedCount: number, upsertedCount: number } | null };

export type GetUnpublishedSummarySheetCountsQueryVariables = Exact<{
  input?: InputMaybe<SummarySheetGraphsCountInput>;
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUnpublishedSummarySheetCountsQuery = { __typename?: 'Query', getSummarySheetGraphsCount?: Array<{ __typename?: 'SummarySheetGraphsCount', count?: number | null, key?: string | null } | null> | null, getRiskAssessmentSummaryCounts?: { __typename?: 'RiskAssessmentSummaryCounts', cofCalculated?: number | null, pofCalculated?: number | null, totalAssemblies?: number | null, transitionPeriodCalculated?: number | null } | null };

export type GetPublishedSummarySheetCountsQueryVariables = Exact<{
  SHEInput?: InputMaybe<SummarySheetGraphsCountInput>;
  financialsInput?: InputMaybe<SummarySheetGraphsCountInput>;
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPublishedSummarySheetCountsQuery = { __typename?: 'Query', governingSHEData?: Array<{ __typename?: 'SummarySheetGraphsCount', count?: number | null, key?: string | null } | null> | null, governingFinancialData?: Array<{ __typename?: 'SummarySheetGraphsCount', count?: number | null, key?: string | null } | null> | null, calculationCounts?: { __typename?: 'RiskAssessmentSummaryCounts', cofCalculated?: number | null, pofCalculated?: number | null, totalAssemblies?: number | null, transitionPeriodCalculated?: number | null } | null };

export type GetRiskAssessmentSummaryDataQueryVariables = Exact<{
  input?: InputMaybe<RiskAssessmentSummaryDataInput>;
}>;


export type GetRiskAssessmentSummaryDataQuery = { __typename?: 'Query', getRiskAssessmentSummaryData?: Array<{ __typename?: 'RiskAssessmentSummaryData', _id?: string | null, completedCalculationsCount?: number | null, level1Component?: string | null, totalCalculationsCount?: number | null, damageClassCount?: Array<{ __typename?: 'DamageClassCountType', count?: number | null, key?: string | null } | null> | null } | null> | null };

export type GetRiskAssessmentSummaryTableDataQueryVariables = Exact<{
  input?: InputMaybe<RiskAssessmentSummaryTableDataInput>;
}>;


export type GetRiskAssessmentSummaryTableDataQuery = { __typename?: 'Query', getRiskAssessmentSummaryTableData: Array<{ __typename?: 'RiskAssessmentSummaryTableData', risk_level_1_component: string, risk_level_2_component: string, risk_structure: string, risk_damage_class: string, calculations: { __typename?: 'Calculations', cof: number, pof: number, total: number, transitionPeriod: number } }> };

export type UpdateEsSheetStatusMutationVariables = Exact<{
  structureId: Scalars['String']['input'];
  status: EsSheetStatus;
}>;


export type UpdateEsSheetStatusMutation = { __typename?: 'Mutation', updateEsSheetStatus: { __typename?: 'Structure', id: string, name: string, esSheetStatus?: EsSheetStatus | null } };

export type GetAssemblyDataForInsightsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyDataForInsightsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, focalPoint?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', distance?: number | null, location: { __typename?: 'Location', id: string, name: string }, corrosion?: { __typename?: 'Corrosion', primaryCategory?: string | null } | null }> | null } | null };

export type GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
}>;


export type GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, corrosionLevel?: string | null, isUncontextualized?: boolean | null, recommendation?: { __typename?: 'Recommendation', analysisStatus?: RecommendationStatus | null, governingValue?: { __typename?: 'GoverningValueRecommendation', calculations?: { __typename?: 'GoverningValueBlister', residualCorrosionAllowancePercentage: number, residualCorrosionAllowance: number } | null } | null, analysisRecommendation?: { __typename?: 'AlarmLevelRecommendation', alarmLevel: AlarmLevels, recommendationByUserName?: string | null, wasAnalysisAlarmLevelManuallySet?: boolean | null } | null } | null, service?: { __typename?: 'Service', code?: string | null, group: string } | null }> };

export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables = Exact<{
  input?: InputMaybe<MarkViewPointAsAnalysedFromCurrentAssemblyInput>;
}>;


export type MarkViewPointAsAnalysedFromCurrentAssemblyMutation = { __typename?: 'Mutation', markViewPointAsAnalysedFromCurrentAssembly?: { __typename?: 'Assembly', id: string, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', location: { __typename?: 'Location', id: string }, analysed?: { __typename?: 'Analysed', analysedBy: string, updatedAt: string } | null }> | null } | null };

export type GetAllLocationInStructureQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAllLocationInStructureQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string }> };

export type AssemblyQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssemblyQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string } | null };

export type PaintRegionQueryVariables = Exact<{
  paintRegionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaintRegionQuery = { __typename?: 'Query', paintRegion?: { __typename?: 'PaintRegion', id: string, volume?: { __typename?: 'ComplexPrismVolume', exclusions?: Array<{ __typename?: 'PrismVolume', z_range: Array<number>, xy_polygon: Array<Array<number>> }> | null, inclusion: { __typename?: 'PrismVolume', xy_polygon: Array<Array<number>>, z_range: Array<number> } } | null } | null };

export type UpdatePointOfInterestLocationMutationVariables = Exact<{
  input: UpdatePointOfInterestLocationInput;
}>;


export type UpdatePointOfInterestLocationMutation = { __typename?: 'Mutation', updatePointOfInterestLocation?: { __typename?: 'PointOfInterest', id: string, type: string, status?: PoiStatus | null, isVerified?: boolean | null, createdAt: string, name?: string | null, poiId?: string | null, isManuallyCreated?: boolean | null, isAutoGenerated?: boolean | null, visibility?: VisibilityEnum | null, comment?: string | null, accessibility?: PoiAccessibilityEnum | null, paintRegion?: { __typename?: 'PaintRegion', id: string, name: string } | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, unit?: UnitsEnum | null, name: string, type: TemplateFieldTypeEnum }> } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string }, blister?: { __typename?: 'Blister', maxHeight?: number | null, heightType?: BlisterHeightType | null, pdrHeight?: number | null, estimatedHeight: number, isManuallyOverridden?: boolean | null, verifiedMaxHeight?: string | null, verifiedResidualThickness?: string | null, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }>, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, templateFieldId?: string | null }> | null } | null };

export type GetStructureForInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureForInspectionDataLoaderQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, octreeResourcesPath: string, nodesPerAssemblyPath?: string | null, hasRiskAssessment?: boolean | null, hasRGB?: boolean | null, structureRelationshipPath?: string | null, assemblyCadModelsBasePath?: string | null, photogrammetryTilesPath?: string | null, voxelLocationsPath?: string | null, voxelSize?: number | null, blisterHeightType?: BlisterHeightType | null, largeVoxelSize?: number | null, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, groupName: string, groupKey: string, name: string, color: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }>, partLegends?: Array<{ __typename?: 'PartLegend', name: string, color: string }> | null, config?: { __typename?: 'StructureConfig', northRotation?: number | null, disableClickOnHiddenPoints?: boolean | null, spatialHeatmapStep?: { __typename?: 'SpatialHeatmapStep', x: number, y: number, z: number } | null, neighbouringImagesOptions?: { __typename?: 'NeighbouringImagesOptions', showFrames?: boolean | null, showImages?: boolean | null, isEnabledByDefault?: boolean | null, maxImagesToShow?: number | null, defaultMeanDistance?: number | null } | null } | null } | null };

export type GetStructureLocationsForInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetStructureLocationsForInspectionDataLoaderQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, baseResourcePath?: string | null, angleResourcePath?: string | null, scanKey?: string | null, distance?: number | null, videoResourcePath?: string | null, videoTimestamp?: number | null, layers?: Array<{ __typename?: 'LocationLayer', fileExt?: string | null, type: string, displayName: string } | null> | null, paintRegion?: { __typename?: 'PaintRegion', name: string } | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null, deck: { __typename?: 'Deck', name: string } }> };

export type GetAllDecksQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAllDecksQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', cadFloorHeight?: number | null, id: string, name: string }> };

export type GetAllPointOfInterestTemplatesQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetAllPointOfInterestTemplatesQuery = { __typename?: 'Query', allPointOfInterestTemplate: Array<{ __typename?: 'PointOfInterestTemplate', id: string, name: string, type?: PointOfInterestTemplateTypeEnum | null, key?: string | null, isCsvUploadable?: boolean | null, accentColor?: string | null, permissions?: Array<string | null> | null, icon?: { __typename?: 'TemplateIcon', name: string, color?: string | null } | null, fields: Array<{ __typename?: 'PointOfInterestTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, displayInQuery?: boolean | null, displayInTable?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, serverSide: boolean, isRequired: boolean, key?: string | null, detailFieldKey?: string | null, isMeasurementToolEnabled?: boolean | null, unit?: UnitsEnum | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, weight?: number | null, min?: number | null, max?: number | null, minIncluded?: boolean | null, maxIncluded?: boolean | null }> | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null }>, markerLabelConfig?: { __typename?: 'MarkerLabelConfig', type: MarkerLabelConfigTypeEnum, hideName?: boolean | null, fields: Array<{ __typename?: 'MarkerLabelField', key: string, type?: MarkerLabelFieldTypeEnum | null }>, headerField?: { __typename?: 'MarkerLabelField', key: string, type?: MarkerLabelFieldTypeEnum | null } | null } | null }> };

export type GetAllTemplatesForReportDocumentQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetAllTemplatesForReportDocumentQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, permissions?: Array<string | null> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, unit?: UnitsEnum | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null }> }> };

export type AllPointsOfInterestForInspectionDataLoaderQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  assemblyIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type AllPointsOfInterestForInspectionDataLoaderQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, assignee?: string | null, dueDate?: string | null, status?: PoiStatus | null, isVerified?: boolean | null, deckRelativeHeight?: number | null, workpackNumber?: string | null, name?: string | null, createdAt: string, visibility?: VisibilityEnum | null, remediationNote?: string | null, comment?: string | null, accessibility?: PoiAccessibilityEnum | null, viewpointRelativeHeight?: number | null, paintRegion?: { __typename?: 'PaintRegion', name: string } | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, type: TemplateFieldTypeEnum }> } | null, location?: { __typename?: 'Location', id: string } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cameraLocation?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string }, blister?: { __typename?: 'Blister', maxHeight?: number | null, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, estimatedHeight: number, manualSetHeight?: number | null, radius: number, fittingRadius: number, scCategory?: string | null, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }> } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, verifiedValue?: any | null, templateFieldId?: string | null }> | null, createdByUser?: { __typename?: 'User', id: string, name?: string | null, picture?: string | null, email: string, connection?: string | null, roleIds: Array<{ __typename?: 'Role', name: string } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null, teams: Array<{ __typename?: 'Team', id: string, name: string }>, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }> };

export type AllPointOfInterestsForDataLoaderQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type AllPointOfInterestsForDataLoaderQuery = { __typename?: 'Query', pointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, type: string, name?: string | null, poiId?: string | null, status?: PoiStatus | null, isVerified?: boolean | null, isGoverning?: boolean | null, createdAt: string, accessibility?: PoiAccessibilityEnum | null, dueDate?: string | null, locationId?: string | null, templateId?: string | null, deckRelativeHeight?: number | null, workpackNumber?: string | null, visibility?: VisibilityEnum | null, viewpointRelativeHeight?: number | null, paintRegion?: { __typename?: 'PaintRegion', name: string, id: string } | null, paintRegions?: Array<{ __typename?: 'PaintRegion', id: string, name: string }> | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, heightType?: BlisterHeightType | null, estimatedHeight: number, pdrHeight?: number | null, isManuallyOverridden?: boolean | null, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }> } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string }, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null }> | null, workpack?: { __typename?: 'Workpack', id: string } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null, createdByUser?: { __typename?: 'User', id: string, name?: string | null, picture?: string | null, email: string, connection?: string | null, roleIds: Array<{ __typename?: 'Role', name: string } | null> } | null, location?: { __typename?: 'Location', id: string, name: string } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, caption?: string | null, imageType?: ImageType | null, uuid?: string | null }> | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null }> };

export type GetStructureRelationshipsForAnalysisDataLoaderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureRelationshipsForAnalysisDataLoaderQuery = { __typename?: 'Query', allAnnotations: Array<{ __typename?: 'Annotation', id: string, annotationId: number, partId?: string | null, locationId?: string | null }>, allParts: Array<{ __typename?: 'Part', id: string, assemblyId?: string | null, class: string }>, allAssemblies: Array<{ __typename?: 'Assembly', id: string, tagName: string, integerId?: number | null }> };

export type UpdateAssemblyMutationVariables = Exact<{
  input?: InputMaybe<UpdateAssemblyInput>;
}>;


export type UpdateAssemblyMutation = { __typename?: 'Mutation', updateAssembly?: { __typename?: 'Assembly', id: string, templateFieldData?: any | null } | null };

export type GetAssemblyPipeSpecQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyPipeSpecQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, pipeSpec?: { __typename?: 'PipeSpec', size?: string | null, material?: string | null, spec?: string | null, nominalCorrosionAllowance?: number | null, schedule?: string | null, nominalThickness?: number | null } | null } | null };

export type GetAssemblyAlarmLevelQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyAlarmLevelQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, recommendation?: { __typename?: 'Recommendation', analysisRecommendation?: { __typename?: 'AlarmLevelRecommendation', alarmLevel: AlarmLevels, wasAnalysisAlarmLevelManuallySet?: boolean | null } | null } | null } | null };

export type FindAssemblyForViewPointsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindAssemblyForViewPointsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', analysed?: { __typename?: 'Analysed', analysedBy: string } | null, location: { __typename?: 'Location', id: string }, focalPoint?: { __typename?: 'Vector3', x: number, y: number, z: number } | null }> | null } | null };

export type PaintBlockTemplateQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
}>;


export type PaintBlockTemplateQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> }> };

export type PaintBlockPointsQueryVariables = Exact<{
  paintRegionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaintBlockPointsQuery = { __typename?: 'Query', paintRegion?: { __typename?: 'PaintRegion', volume?: { __typename?: 'ComplexPrismVolume', exclusions?: Array<{ __typename?: 'PrismVolume', xy_polygon: Array<Array<number>>, z_range: Array<number> }> | null, inclusion: { __typename?: 'PrismVolume', z_range: Array<number>, xy_polygon: Array<Array<number>> } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null } | null };

export type PaintRegionGroupsQueryVariables = Exact<{
  input: PaintRegionGroupFiltersInput;
}>;


export type PaintRegionGroupsQuery = { __typename?: 'Query', paintRegionGroups: Array<{ __typename?: 'PaintRegionGroup', name: string, id: string, isDefault: boolean }> };

export type SavedBlockPoIsQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type SavedBlockPoIsQuery = { __typename?: 'Query', pointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, name?: string | null, workpackNumber?: string | null, paintRegion?: { __typename?: 'PaintRegion', id: string, deck: { __typename?: 'Deck', id: string, cadTransform: Array<number> } } | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, key?: string | null, type: TemplateFieldTypeEnum, unit?: UnitsEnum | null }> } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, templateFieldId?: string | null }> | null }>, pointOfInterestsCount?: { __typename?: 'Count', count: number } | null };

export type PointOfInterestCuboidsQueryVariables = Exact<{
  pointOfInterestId: Scalars['ID']['input'];
}>;


export type PointOfInterestCuboidsQuery = { __typename?: 'Query', pointOfInterest?: { __typename?: 'PointOfInterest', id: string, status?: PoiStatus | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null } | null };

export type GetAllAnnotationInLocationQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllAnnotationInLocationQuery = { __typename?: 'Query', allAnnotations: Array<{ __typename?: 'Annotation', annotationId: number, id: string }> };

export type GetAbyssViewerColoursForAnalysisQueryVariables = Exact<{
  type: SettingTypesEnum;
}>;


export type GetAbyssViewerColoursForAnalysisQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', id: string, name: string, type: SettingTypesEnum, revision: number, meta: Array<{ __typename: 'DefectColorMeta' } | { __typename: 'FloatMeta' } | { __typename: 'IntMeta' } | { __typename: 'StringArrayMeta', key: string, value: Array<string> } | { __typename: 'StringMeta', key: string, colour: string }> } | null };

export type GetDefectColoursQueryVariables = Exact<{
  type: SettingTypesEnum;
}>;


export type GetDefectColoursQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', id: string, name: string, type: SettingTypesEnum, revision: number, meta: Array<{ __typename: 'DefectColorMeta', key: string, value: Array<{ __typename?: 'DefectColorMetaValue', octreeIndex: number, name: string, colour: string }> } | { __typename: 'FloatMeta' } | { __typename: 'IntMeta' } | { __typename: 'StringArrayMeta' } | { __typename: 'StringMeta' }> } | null };

export type GetAssemblyContextualizedStatusQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyContextualizedStatusQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, isUncontextualized?: boolean | null } | null };

export type BulkUploadPoisMutationVariables = Exact<{
  input: BulkUploadPoisInput;
}>;


export type BulkUploadPoisMutation = { __typename?: 'Mutation', bulkUploadPois: Array<{ __typename?: 'PointOfInterest', poiId?: string | null }> };

export type ValidateBulkPoiUploadQueryVariables = Exact<{
  input: BulkUploadPoisInput;
}>;


export type ValidateBulkPoiUploadQuery = { __typename?: 'Query', validateBulkPoiUpload: string };

export type GetAllDraftReportsQueryVariables = Exact<{
  input?: InputMaybe<ReportsInput>;
}>;


export type GetAllDraftReportsQuery = { __typename?: 'Query', allReports: Array<{ __typename?: 'Report', id?: string | null, name: string } | null> };

export type CreatePointOfInterestMutationVariables = Exact<{
  input?: InputMaybe<CreatePointOfInterestInput>;
}>;


export type CreatePointOfInterestMutation = { __typename?: 'Mutation', createPointOfInterest?: { __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, name?: string | null, templateId?: string | null, locationId?: string | null, createdAt: string, assembly: { __typename?: 'Assembly', id: string, tagName: string }, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }> } | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null } | null };

export type AllAssembliesForCreatePoiQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type AllAssembliesForCreatePoiQuery = { __typename?: 'Query', allAssemblies: Array<{ __typename?: 'Assembly', id: string, tagName: string }> };

export type GetStructureDefaultAssemblyQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureDefaultAssemblyQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, defaultAssemblyId?: string | null } | null };

export type UpdatePoiGeneralFieldsMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestInput>;
}>;


export type UpdatePoiGeneralFieldsMutation = { __typename?: 'Mutation', updatePointOfInterest?: { __typename?: 'PointOfInterest', id: string, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null } | null };

export type UpdatePoiTemplateFieldsMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestInput>;
}>;


export type UpdatePoiTemplateFieldsMutation = { __typename?: 'Mutation', updatePointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null };

export type VerifyPointOfInterestMutationVariables = Exact<{
  input?: InputMaybe<VerifyPointOfInterestInput>;
}>;


export type VerifyPointOfInterestMutation = { __typename?: 'Mutation', verifyPointOfInterest?: { __typename?: 'PointOfInterest', templateData?: Array<{ __typename?: 'TemplateData', verifiedValue?: any | null, value?: any | null, id: string }> | null } | null };

export type ScCategoryOptionsQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type ScCategoryOptionsQuery = { __typename?: 'Query', scCategoryOptions: Array<string> };

export type UpdateBlisterHeightTypeMutationVariables = Exact<{
  input?: InputMaybe<PerformMechanicalIntegrityServicesInput>;
}>;


export type UpdateBlisterHeightTypeMutation = { __typename?: 'Mutation', performMechanicalIntegrityServices?: { __typename?: 'MechanicalIntegrityServicesResponse', status: string, message?: string | null } | null };

export type UpdateCalculationMethodMutationVariables = Exact<{
  input?: InputMaybe<UpdateCalculationMethodInput>;
}>;


export type UpdateCalculationMethodMutation = { __typename?: 'Mutation', updateCalculationMethod?: { __typename?: 'PointOfInterest', id: string } | null };

export type PoiImageCaptionMutationVariables = Exact<{
  input?: InputMaybe<PoiImageCaptionInput>;
}>;


export type PoiImageCaptionMutation = { __typename?: 'Mutation', poiImageCaption?: string | null };

export type DeletePointOfInterestMutationVariables = Exact<{
  input?: InputMaybe<DeletePointOfInterestInput>;
}>;


export type DeletePointOfInterestMutation = { __typename?: 'Mutation', deletePointOfInterest?: { __typename?: 'PointOfInterest', id: string, type: string } | null };

export type UpdatePointOfInterestMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestInput>;
}>;


export type UpdatePointOfInterestMutation = { __typename?: 'Mutation', updatePointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null };

export type StructureForBlisterQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureForBlisterQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, wallLossFactor?: number | null, scCategoryMapping?: any | null } | null };

export type UploadAttachmentsToPoiMutationVariables = Exact<{
  input?: InputMaybe<UploadAttachmentsInput>;
}>;


export type UploadAttachmentsToPoiMutation = { __typename?: 'Mutation', uploadAttachmentsToPoi: Array<{ __typename?: 'GeneratedPresignedURL', id: string, url: string, resourcePath: string, uuid: string }> };

export type RemoveAttachmentsFromPoiMutationVariables = Exact<{
  input?: InputMaybe<RemoveAttachmentsInput>;
}>;


export type RemoveAttachmentsFromPoiMutation = { __typename?: 'Mutation', removeAttachmentsFromPoi?: { __typename?: 'PointOfInterest', id: string } | null };

export type UpdatePaintRegionIdMutationVariables = Exact<{
  input?: InputMaybe<UpdatePaintRegionIdInput>;
}>;


export type UpdatePaintRegionIdMutation = { __typename?: 'Mutation', updatePaintRegionId?: Array<{ __typename?: 'PointOfInterest', paintRegion?: { __typename?: 'PaintRegion', id: string, name: string, volume?: { __typename?: 'ComplexPrismVolume', inclusion: { __typename?: 'PrismVolume', xy_polygon: Array<Array<number>>, z_range: Array<number> }, exclusions?: Array<{ __typename?: 'PrismVolume', xy_polygon: Array<Array<number>>, z_range: Array<number> }> | null } | null } | null } | null> | null };

export type SelectedPoiUpdatedSubscriptionVariables = Exact<{
  poiID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SelectedPoiUpdatedSubscription = { __typename?: 'Subscription', selectedPointOfInterestUpdated: { __typename?: 'PointOfInterest', id: string, paintRegion?: { __typename?: 'PaintRegion', id: string, name: string } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null } };

export type StructureWallLossFactorQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StructureWallLossFactorQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', wallLossFactor?: number | null } | null };

export type EvaluateTemplateFieldLogicRuleMutationVariables = Exact<{
  input: EvaluateTemplateFieldLogicRuleInput;
}>;


export type EvaluateTemplateFieldLogicRuleMutation = { __typename?: 'Mutation', evaluateTemplateFieldLogicRule?: { __typename?: 'EvaluateTemplateFieldLogicRuleResult', result: string } | null };

export type WorkscopeDynamicBlockCalculationQueryVariables = Exact<{
  input: DynamicBlockCalculationInput;
}>;


export type WorkscopeDynamicBlockCalculationQuery = { __typename?: 'Query', dynamicBlockCalculation: any };

export type SelectedPointOfInterestQueryVariables = Exact<{
  pointOfInterestId: Scalars['ID']['input'];
}>;


export type SelectedPointOfInterestQuery = { __typename?: 'Query', pointOfInterest?: { __typename?: 'PointOfInterest', id: string, templateId?: string | null, type: string, linkedPointOfInterestIds?: Array<string> | null, assignee?: string | null, dueDate?: string | null, status?: PoiStatus | null, isVerified?: boolean | null, deckRelativeHeight?: number | null, workpackNumber?: string | null, name?: string | null, poiId?: string | null, createdAt: string, visibility?: VisibilityEnum | null, remediationNote?: string | null, comment?: string | null, accessibility?: PoiAccessibilityEnum | null, viewpointRelativeHeight?: number | null, isAutoGenerated?: boolean | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: WorkpackStatus | null } | null, paintRegion?: { __typename?: 'PaintRegion', id: string, name: string } | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, type: TemplateFieldTypeEnum }> } | null, location?: { __typename?: 'Location', id: string } | null, lineMeasurement?: { __typename?: 'PoiLineMeasurement', points?: Array<{ __typename?: 'PoiMeasurementPoint', coordinates: Array<number>, templateFieldId: string } | null> | null } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cameraLocation?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string, pipeSpec?: { __typename?: 'PipeSpec', spec?: string | null, size?: string | null, material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null } | null, structure: { __typename?: 'Structure', id: string } }, blister?: { __typename?: 'Blister', maxHeight?: number | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, verifiedMaxHeight?: string | null, verifiedResidualThickness?: string | null, manualSetHeight?: number | null, radius: number, fittingRadius: number, scCategory?: string | null, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }> } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, verifiedValue?: any | null, templateFieldId?: string | null }> | null, createdByUser?: { __typename?: 'User', id: string, name?: string | null, picture?: string | null, email: string, connection?: string | null, roleIds: Array<{ __typename?: 'Role', name: string } | null> } | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null, teams: Array<{ __typename?: 'Team', id: string, name: string }>, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, caption?: string | null, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null, cuboids?: Array<{ __typename?: 'PoiCuboid', id: string, position: Array<number>, rotation: Array<number>, scale: Array<number> }> | null, verifiedByUser?: { __typename?: 'User', email: string } | null } | null };

export type PointOfInterestsQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type PointOfInterestsQuery = { __typename?: 'Query', pointOfInterests: Array<{ __typename?: 'PointOfInterest', isGoverning?: boolean | null, id: string, type: string, status?: PoiStatus | null, isVerified?: boolean | null, name?: string | null, poiId?: string | null, isManuallyCreated?: boolean | null, isAutoGenerated?: boolean | null, visibility?: VisibilityEnum | null, comment?: string | null, accessibility?: PoiAccessibilityEnum | null, createdAt: string, dueDate?: string | null, deckRelativeHeight?: number | null, workpackNumber?: string | null, createdByUser?: { __typename?: 'User', name?: string | null, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string } | null> } | null, paintRegion?: { __typename?: 'PaintRegion', id: string, name: string, deck: { __typename?: 'Deck', name: string } } | null, paintRegions?: Array<{ __typename?: 'PaintRegion', id: string, name: string, paintRegionGroup?: { __typename?: 'PaintRegionGroup', id: string, name: string, isDefault: boolean } | null }> | null, template?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, unit?: UnitsEnum | null, name: string, type: TemplateFieldTypeEnum }> } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string, tagName: string, structure: { __typename?: 'Structure', id: string } }, location?: { __typename?: 'Location', id: string, name: string } | null, blister?: { __typename?: 'Blister', maxHeight?: number | null, estimatedHeight: number, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, verifiedMaxHeight?: string | null, verifiedResidualThickness?: string | null, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, wallLoss?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualCorrosionAllowance?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null, residualThickness?: { __typename?: 'ValueAndPercentage', percentage: number, value: number } | null } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null, templateFieldId?: string | null }> | null, screenshotPaths?: { __typename?: 'ScreenshotPaths', viewer?: string | null, viewpoint?: string | null } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, caption?: string | null, imageType?: ImageType | null, uuid?: string | null }> | null, workpack?: { __typename?: 'Workpack', id: string, name: string, status?: WorkpackStatus | null } | null }>, pointOfInterestsCount?: { __typename?: 'Count', count: number } | null };

export type PointOfInterestsCountQueryVariables = Exact<{
  input?: InputMaybe<PointOfInterestInput>;
}>;


export type PointOfInterestsCountQuery = { __typename?: 'Query', pointOfInterestsCount?: { __typename?: 'Count', count: number } | null };

export type GetNominationCalculationsQueryVariables = Exact<{
  input?: InputMaybe<NominationCalculationsInput>;
}>;


export type GetNominationCalculationsQuery = { __typename?: 'Query', getNominationCalculations?: { __typename?: 'NominationCalculations', alarmLevel: string, governingValue?: { __typename?: 'GoverningValueBlister', height: number, estimatedWallLoss: number, estimatedWallLossPercentage: number, residualCorrosionAllowance: number, residualCorrosionAllowancePercentage: number, residualThickness: number, residualThicknessPercentage: number } | null } | null };

export type NominateGoverningPointOfInterestMutationVariables = Exact<{
  input?: InputMaybe<NominateGoverningPointOfInterestInput>;
}>;


export type NominateGoverningPointOfInterestMutation = { __typename?: 'Mutation', nominateGoverningPointOfInterest?: string | null };

export type GetRecommendationsForAssemblyQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetRecommendationsForAssemblyQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, recommendation?: { __typename?: 'Recommendation', governingValue?: { __typename?: 'GoverningValueRecommendation', pointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null, blister?: { __typename?: 'PointOfInterest', id: string, name?: string | null } | null, calculations?: { __typename?: 'GoverningValueBlister', estimatedWallLoss: number, estimatedWallLossPercentage: number, height: number, residualCorrosionAllowance: number, residualCorrosionAllowancePercentage: number, residualThickness: number, residualThicknessPercentage: number } | null } | null } | null, pipeSpec?: { __typename?: 'PipeSpec', size?: string | null, material?: string | null, spec?: string | null, nominalCorrosionAllowance?: number | null, schedule?: string | null, nominalThickness?: number | null } | null } | null };

export type GetOneAssemblyForBlistersQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOneAssemblyForBlistersQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, recommendation?: { __typename?: 'Recommendation', governingValue?: { __typename?: 'GoverningValueRecommendation', pointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null } | null } | null } | null };

export type GetOneAssemblyForDefectsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOneAssemblyForDefectsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, recommendation?: { __typename?: 'Recommendation', governingValue?: { __typename?: 'GoverningValueRecommendation', pointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null } | null } | null } | null };

export type MeasureBlisterQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
  blisterMeasurementPoints?: InputMaybe<BlisterMeasurementInput>;
}>;


export type MeasureBlisterQuery = { __typename?: 'Query', fetchBlisterHeightMeasurement?: { __typename?: 'BlisterHeightMeasurement', blister: { __typename?: 'BlisterHeightMeasurementResult', maxHeight: number, blisterProfilePlotPoints: Array<{ __typename?: 'BlisterProfilePlotPoint', x: number, y: number, z: number, height: number }>, fittedSurfacePoints: Array<{ __typename?: 'Point', x: number, y: number, z: number }>, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }>, centerPoint3d: { __typename?: 'Vector3', x: number, y: number, z: number } }, status: { __typename?: 'MeasurementStatus', cacheStatus: string, fittingRadius?: number | null, targetRadius?: number | null, windowSize: Array<number> } } | null };

export type GetAssemblyPipeSpecByIdQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyPipeSpecByIdQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, pipeSpec?: { __typename?: 'PipeSpec', material?: string | null, nominalCorrosionAllowance?: number | null, nominalThickness?: number | null, schedule?: string | null, size?: string | null, spec?: string | null } | null } | null };

export type GetAllTeamsForCreateOrEditPoiQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTeamsForCreateOrEditPoiQuery = { __typename?: 'Query', allTeams: Array<{ __typename?: 'Team', id: string, name: string }> };

export type SavePointOfInterestScreenshotMutationVariables = Exact<{
  input?: InputMaybe<SavePointOfInterestScreenshotInput>;
}>;


export type SavePointOfInterestScreenshotMutation = { __typename?: 'Mutation', savePointOfInterestScreenshot?: { __typename?: 'PointOfInterest', id: string } | null };

export type UpdatePointOfInterestFileMutationVariables = Exact<{
  input?: InputMaybe<InputUpdateFileForPointOfInterest>;
}>;


export type UpdatePointOfInterestFileMutation = { __typename?: 'Mutation', updatePointOfInterestFile: { __typename?: 'PointOfInterest', id: string } };

export type FetchGenerateImageQueryVariables = Exact<{
  input?: InputMaybe<GenerateImageInput>;
}>;


export type FetchGenerateImageQuery = { __typename?: 'Query', fetchGenerateImage?: { __typename?: 'GenerateImageResult', imageData: string } | null };

export type FetchCropFromRectilinearQueryVariables = Exact<{
  input?: InputMaybe<GenerateCropFromRectilinearInput>;
}>;


export type FetchCropFromRectilinearQuery = { __typename?: 'Query', fetchCropFromRectilinear?: { __typename?: 'GenerateImageResult', imageData: string } | null };

export type GetStructureFeaturesQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureFeaturesQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, features?: any | null } | null };

export type GetAllAssembliesQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetAllAssembliesQuery = { __typename?: 'Query', allAssemblies: Array<{ __typename?: 'Assembly', id: string, tagName: string, service?: { __typename?: 'Service', code?: string | null } | null, recommendation?: { __typename?: 'Recommendation', analysisStatus?: RecommendationStatus | null, analysisRecommendation?: { __typename?: 'AlarmLevelRecommendation', recommendationByUserName?: string | null, alarmLevel: AlarmLevels, supportingComment?: string | null, additionalComments?: string | null, internalTeamComments?: string | null } | null, governingValue?: { __typename?: 'GoverningValueRecommendation', calculations?: { __typename?: 'GoverningValueBlister', height: number, estimatedWallLoss: number, estimatedWallLossPercentage: number, residualCorrosionAllowance: number, residualCorrosionAllowancePercentage: number, residualThickness: number, residualThicknessPercentage: number } | null } | null } | null, pipeSpec?: { __typename?: 'PipeSpec', size?: string | null, spec?: string | null, material?: string | null, nominalCorrosionAllowance?: number | null, schedule?: string | null, nominalThickness?: number | null } | null }>, structure?: { __typename?: 'Structure', name: string } | null };

export type AllPointOfInterestsForStructureQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type AllPointOfInterestsForStructureQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', type: string, assembly: { __typename?: 'Assembly', id: string } }> };

export type GetAssemblyDetailsQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyDetailsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, area?: number | null, corrosionLevel?: string | null, templateFieldData?: any | null, cadModelPath?: string | null, isUncontextualized?: boolean | null, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', distance?: number | null, location: { __typename?: 'Location', id: string, name: string }, corrosion?: { __typename?: 'Corrosion', primaryCategory?: string | null } | null }> | null, recommendation?: { __typename?: 'Recommendation', analysisRecommendation?: { __typename?: 'AlarmLevelRecommendation', alarmLevel: AlarmLevels } | null } | null, template: { __typename?: 'Template', id: string, name: string, type: TemplateTypeEnum, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, type: TemplateFieldTypeEnum }>, equipmentDetails: Array<{ __typename?: 'EquipmentDetailField', id: string, name: string, subType?: EquipmentDetailSubTypeEnum | null, type: EquipmentDetailTypeEnum, fieldKey: string, options: Array<{ __typename?: 'EquipmentDetailOptionField', id: string, name: string, type: OptionFieldTypeEnum, fieldKey?: string | null }> }> }, focalPoint?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cameraPose?: { __typename?: 'AssemblyCameraPose', position: { __typename?: 'Vector3', x: number, y: number, z: number }, lookAt: { __typename?: 'Vector3', x: number, y: number, z: number } } | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, caption?: string | null, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null, pipeSpec?: { __typename?: 'PipeSpec', size?: string | null, material?: string | null, spec?: string | null, nominalCorrosionAllowance?: number | null, schedule?: string | null, nominalThickness?: number | null } | null } | null };

export type GetAssemblyViewpointsQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyViewpointsQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, seenByViewpoints?: Array<{ __typename?: 'SeenByViewpoint', location: { __typename?: 'Location', id: string, name: string } }> | null } | null };

export type InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables = Exact<{
  input?: InputMaybe<UpdateSingleTemplateFieldDataInput>;
}>;


export type InlineUpdateSingleAssemblyTemplateFieldDataMutation = { __typename?: 'Mutation', updateSingleTemplateFieldData?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type DefectLegendsForEquipmentQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DefectLegendsForEquipmentQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, name: string, groupKey: string, groupName: string, color: string }> } | null };

export type StructureTemplateByTypeQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
}>;


export type StructureTemplateByTypeQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, type: TemplateTypeEnum, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> }> };

export type ScCategoryMappingQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScCategoryMappingQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, scCategoryMapping?: any | null } | null };

export type AssemblyTemplateFieldDataQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type AssemblyTemplateFieldDataQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, templateFieldData?: any | null } | null };

export type UpdateScCategoryMutationVariables = Exact<{
  input: UpdateScCategoryInput;
}>;


export type UpdateScCategoryMutation = { __typename?: 'Mutation', updateScCategory?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type DefectPointOfInterestsQueryVariables = Exact<{
  assemblyIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type DefectPointOfInterestsQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, name?: string | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null }> | null }> };

export type AssemblyGoverningValueQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssemblyGoverningValueQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, recommendation?: { __typename?: 'Recommendation', governingValue?: { __typename?: 'GoverningValueRecommendation', pointOfInterest?: { __typename?: 'PointOfInterest', id: string } | null } | null } | null } | null };

export type GetAssemblyTemplateFieldDataQueryVariables = Exact<{
  assemblyId: Scalars['String']['input'];
}>;


export type GetAssemblyTemplateFieldDataQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null } | null };

export type GetAssemblyPointOfInterestsQueryVariables = Exact<{
  assemblyIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAssemblyPointOfInterestsQuery = { __typename?: 'Query', allPointOfInterests: Array<{ __typename?: 'PointOfInterest', id: string, poiId?: string | null, type: string, name?: string | null, remediationNote?: string | null, comment?: string | null, deckRelativeHeight?: number | null, accessibility?: PoiAccessibilityEnum | null, viewpointRelativeHeight?: number | null, location?: { __typename?: 'Location', id: string } | null, centerPoint3d?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, cameraLocation?: { __typename?: 'Vector3', x: number, y: number, z: number } | null, assembly: { __typename?: 'Assembly', id: string }, blister?: { __typename?: 'Blister', scCategory?: string | null, estimatedHeight: number, manualSetHeight?: number | null, pdrHeight?: number | null, heightType?: BlisterHeightType | null, isManuallyOverridden?: boolean | null, maxHeight?: number | null, radius: number, fittingRadius: number, centerPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, radiusPoint: { __typename?: 'PolarPoint', bearing: number, elevation: number }, borders3d: Array<{ __typename?: 'Polygon3d', points: Array<{ __typename?: 'Vector3', x: number, y: number, z: number }> }>, wallLoss?: { __typename?: 'ValueAndPercentage', value: number } | null } | null, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null }> | null, files?: Array<{ __typename?: 'File', id?: string | null, name: FileNameTypes, resourcePath: string, type: FileTypes, fileName: string, uploadStatus?: FileUploadStatus | null, imageType?: ImageType | null, uuid?: string | null }> | null }> };

export type UpdateCuiPriorityMutationVariables = Exact<{
  input: UpdateCuiPriorityInput;
}>;


export type UpdateCuiPriorityMutation = { __typename?: 'Mutation', updateCuiPriority?: { __typename?: 'Assembly', templateFieldData?: any | null } | null };

export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
}>;


export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, isUncontextualized?: boolean | null, box?: { __typename?: 'Box', max: { __typename?: 'Vector3', x: number, y: number, z: number }, min: { __typename?: 'Vector3', x: number, y: number, z: number } } | null }>, getAssembliesCount?: { __typename?: 'Count', count: number } | null };

export type GetAssembliesWithTemplateFieldDataQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesWithTemplateFieldDataQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, isUncontextualized?: boolean | null }>, getAssembliesCount?: { __typename?: 'Count', count: number } | null };

export type AllDecksForFilterSideBarQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllDecksForFilterSideBarQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', id: string, name: string }> };

export type AllPaintRegionsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AllPaintRegionsQuery = { __typename?: 'Query', allPaintRegions: Array<{ __typename?: 'PaintRegion', id: string, name: string, deck: { __typename?: 'Deck', id: string } }> };

export type AllAssemblyTemplatesForFilterSideBarQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TemplateTypeEnum>;
}>;


export type AllAssemblyTemplatesForFilterSideBarQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', name: string, octreeResourcesPath?: string | null, baseImagePath?: string | null, coverImagePath?: string | null, includedTemplateIds?: Array<string> | null, isCombined?: boolean | null, structureRelationshipPath?: string | null, id: string, defectsArray: Array<string>, recommendation?: { __typename?: 'RecommendationField', header: string, details: Array<{ __typename?: 'RecommendationDetailField', id: string, fieldKey: string } | null> } | null, equipmentCard: Array<{ __typename?: 'EquipmentCardField', id: string, name: string, type: EqiupmentCardFieldTypeEnum, position: EquipmentCardPositionEnum, fieldKey?: string | null, location: EquipmentCardLocationEnum }>, equipmentDetails: Array<{ __typename?: 'EquipmentDetailField', id: string, name: string, subType?: EquipmentDetailSubTypeEnum | null, type: EquipmentDetailTypeEnum, fieldKey: string, options: Array<{ __typename?: 'EquipmentDetailOptionField', id: string, name: string, type: OptionFieldTypeEnum, fieldKey?: string | null }> }>, assessmentDetails?: Array<{ __typename?: 'AssessmentDetails', id: string, name: string, type: string, position: number, isVisible: boolean, options: Array<{ __typename?: 'AssessmentDetailOptionFieldSchema', id: string, name: string, type: OptionFieldTypeEnum, fieldKey: string, isEditable: boolean, editRoles: Array<string | null> }> }> | null, reviewPanelConfig?: Array<{ __typename?: 'ReviewPanelConfig', groupKey: string, groupName: string, id: string, groupSection: Array<{ __typename?: 'GroupSection', id: string, title: string, sectionKey: string, fieldKeys: Array<string | null> } | null> }> | null, querySummary?: Array<{ __typename?: 'QuerySummaryItem', name: string, key?: string | null, operation: string }> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', isEditable?: boolean | null, editRoles?: Array<string | null> | null, options: Array<string>, id: string, name: string, key?: string | null, type: TemplateFieldTypeEnum, serverSide: boolean, permission?: string | null, displayInQuery?: boolean | null, isHidden?: boolean | null, displayInTable?: boolean | null, displayInRisk?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, displayInReportFilters?: boolean | null, roundToDecimal?: number | null, unit?: UnitsEnum | null, displayUnit?: UnitsEnum | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textFormat?: TextFormatEnum | null, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null } | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, min?: number | null, max?: number | null }> | null }> }> };

export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables = Exact<{
  input?: InputMaybe<AssembliesFilterInput>;
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery = { __typename?: 'Query', getAssembliesByTemplateFieldsFilters: Array<{ __typename?: 'Assembly', id: string, tagName: string, templateFieldData?: any | null, isUncontextualized?: boolean | null, decks?: Array<{ __typename?: 'DecksDetails', deckId: { __typename?: 'Deck', id: string } } | null> | null }>, getAssembliesCount?: { __typename?: 'Count', count: number } | null };

export type AllWorkpacksForFilterSideBarQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  hasPois?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AllWorkpacksForFilterSideBarQuery = { __typename?: 'Query', allWorkpacks: Array<{ __typename?: 'Workpack', id: string, name: string }> };

export type UpdateFileStatusMutationVariables = Exact<{
  input: UpdateFilesStatusInput;
}>;


export type UpdateFileStatusMutation = { __typename?: 'Mutation', updateFilesStatus?: boolean | null };

export type UploadFilesMutationVariables = Exact<{
  input: UploadFileInput;
}>;


export type UploadFilesMutation = { __typename?: 'Mutation', preSignedUrlToUploadFiles: Array<{ __typename?: 'GeneratedPresignedURL', url: string, id: string, resourcePath: string, uuid: string }> };

export type DeleteFilesMutationVariables = Exact<{
  input: DeleteFilesInput;
}>;


export type DeleteFilesMutation = { __typename?: 'Mutation', deleteFiles: { __typename?: 'DeleteFilesPayload', message: string, deletedFiles: Array<string> } };

export type AssemblyImageCaptionMutationVariables = Exact<{
  input: AssemblyImageCaptionInput;
}>;


export type AssemblyImageCaptionMutation = { __typename?: 'Mutation', addAssemblyImageCaption?: string | null };

export type AddUpdateCuboidMutationVariables = Exact<{
  input?: InputMaybe<AddUpdateCuboidInput>;
}>;


export type AddUpdateCuboidMutation = { __typename?: 'Mutation', addUpdateCuboid?: { __typename?: 'Cuboid', id: string, structureId: any, cuboidClassId?: string | null, zoneId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number> } | null };

export type DeleteCuboidMutationVariables = Exact<{
  input?: InputMaybe<DeleteCuboidInput>;
}>;


export type DeleteCuboidMutation = { __typename?: 'Mutation', deleteCuboid?: string | null };

export type GetStructureLocationsForAssetLabellingDataLoaderQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetStructureLocationsForAssetLabellingDataLoaderQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, videoResourcePath?: string | null, videoTimestamp?: number | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null }> };

export type GetAllLabelAnnotationsQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetAllLabelAnnotationsQuery = { __typename?: 'Query', allLabelAnnotations: Array<{ __typename?: 'LabelAnnotation', id: string, labelClassId: any, octreeId: number } | null> };

export type GetStructureForAssetLabellingQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureForAssetLabellingQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, octreeResourcesPath: string, hasRGB?: boolean | null, labelClasses?: Array<{ __typename?: 'LabelClass', id: string, name: string, color: string }> | null, cuboidClasses?: Array<{ __typename?: 'LabelClass', id: string, name: string, color: string }> | null } | null };

export type GetAllZonesForAssetLabellingQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetAllZonesForAssetLabellingQuery = { __typename?: 'Query', zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, pausedBy?: PausedBy | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null }> };

export type GetCuboidsByZoneIdQueryVariables = Exact<{
  zoneId: Scalars['String']['input'];
}>;


export type GetCuboidsByZoneIdQuery = { __typename?: 'Query', cuboidsByZoneId: Array<{ __typename?: 'Cuboid', id: string, structureId: any, cuboidClassId?: string | null, zoneId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number> } | null> };

export type BenchmarkUploadMutationVariables = Exact<{
  input?: InputMaybe<BenchmarkUploadInput>;
}>;


export type BenchmarkUploadMutation = { __typename?: 'Mutation', benchmarkUpload?: { __typename?: 'BenchmarkUploadOutput', size: number } | null };

export type BenchmarkDownloadMutationVariables = Exact<{
  input?: InputMaybe<BenchmarkDownloadInput>;
}>;


export type BenchmarkDownloadMutation = { __typename?: 'Mutation', benchmarkDownload?: { __typename?: 'BenchmarkDownloadOutput', data: string } | null };

export type ValidateEsSheetMutationVariables = Exact<{
  headers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ValidateEsSheetMutation = { __typename?: 'Mutation', validateEsSheet: string };

export type UploadEsSheetMutationVariables = Exact<{
  input: UploadEsSheetInput;
}>;


export type UploadEsSheetMutation = { __typename?: 'Mutation', uploadEsSheet: string };

export type GetStructureQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStructureQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', name: string, templateData?: Array<{ __typename?: 'TemplateData', id: string, value?: any | null }> | null } | null };

export type GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
  supervoxelsForStructureInput?: InputMaybe<SupervoxelsForStructureInput>;
}>;


export type GetStructureRelationshipsForLabellingInspectionDataLoaderQuery = { __typename?: 'Query', supervoxelsClassesForStructure: Array<{ __typename?: 'SupervoxelClass', color: string, id: string, name: string, structureId: any }>, supervoxelsForStructure: Array<{ __typename?: 'SuperVoxels', id?: string | null, zoneId: any, structureId: any, supervoxel3DReference: number, supervoxelClassId?: string | null } | null>, structure?: { __typename?: 'Structure', octreeResourcesPath: string } | null };

export type GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetStructureLocationsForLabellingInspectionDataLoaderQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, videoResourcePath?: string | null, videoTimestamp?: number | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null }> };

export type ZonesForStructureForLabellingQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesForStructureForLabellingQuery = { __typename?: 'Query', zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, structureId: string, status: ZoneStatus, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, pausedBy?: PausedBy | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null }> };

export type UpdateSupervoxelsMutationVariables = Exact<{
  input?: InputMaybe<UpdateSupervoxel>;
}>;


export type UpdateSupervoxelsMutation = { __typename?: 'Mutation', updateSupervoxels: Array<{ __typename?: 'SuperVoxels', id?: string | null, structureId: any, supervoxel3DReference: number, supervoxelClassId?: string | null, zoneId: any }> };

export type GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureRelationshipsForTaggingInspectionDataLoaderQuery = { __typename?: 'Query', allAnnotations: Array<{ __typename?: 'Annotation', id: string, annotationId: number, locationId?: string | null, partId?: string | null }>, allParts: Array<{ __typename?: 'Part', id: string, assemblyId?: string | null, class: string, isReviewed?: boolean | null, isHidden?: boolean | null, splitCuboids?: Array<{ __typename?: 'SplitCuboid', id: string, assemblyId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number>, color: number }> | null }>, allAssemblies: Array<{ __typename?: 'Assembly', id: string, tagName: string, originalTagname?: string | null, superCategory?: string | null, isNewlyAdded?: boolean | null }>, structure?: { __typename?: 'Structure', octreeResourcesPath: string, nodesPerAssemblyPath?: string | null } | null };

export type GetStructureLocationsForTaggingDataLoaderQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type GetStructureLocationsForTaggingDataLoaderQuery = { __typename?: 'Query', allLocations: Array<{ __typename?: 'Location', id: string, name: string, resourcePath?: string | null, distance?: number | null, videoResourcePath?: string | null, videoTimestamp?: number | null, imageSensor?: { __typename?: 'ImageSensor', width: number, height: number, cx: number, cy: number, focalLength: number } | null, paintRegion?: { __typename?: 'PaintRegion', name: string } | null, pose?: { __typename?: 'LocationPose', yaw: number, pitch: number, roll: number, z: number, y: number, x: number, yawOffset: number } | null }> };

export type PartsAddedToAssemblySubscriptionVariables = Exact<{
  structureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PartsAddedToAssemblySubscription = { __typename?: 'Subscription', partsAddedToAssembly: Array<{ __typename?: 'PartsAddedToAssemblyNotification', partId: string, assemblyId?: string | null, assemblyName?: string | null, isReviewed?: boolean | null, zoneId?: string | null, userId: string }> };

export type PartsHiddenFlagUpdatedSubscriptionVariables = Exact<{
  structureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PartsHiddenFlagUpdatedSubscription = { __typename?: 'Subscription', partsHiddenFlagUpdated: Array<{ __typename?: 'PartHiddenFlagUpdatedNotification', id: string, isHidden?: boolean | null, isReviewed?: boolean | null, zoneId?: string | null, userId: string }> };

export type PartsReviewedFlagUpdatedSubscriptionVariables = Exact<{
  structureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PartsReviewedFlagUpdatedSubscription = { __typename?: 'Subscription', partsReviewedFlagUpdated: Array<{ __typename?: 'PartReviewFlagUpdatedNotification', id: string, isReviewed?: boolean | null, assemblyName?: string | null, zoneId?: string | null, userId: string }> };

export type PartSplitSubscriptionVariables = Exact<{
  structureId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
}>;


export type PartSplitSubscription = { __typename?: 'Subscription', partSplit: { __typename?: 'PartSplitNotification', originalPartId: string, newPartId: string, updatedAnnotationIds: Array<string>, zoneId?: string | null } };

export type AssemblyTagNameAddedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssemblyTagNameAddedSubscription = { __typename?: 'Subscription', assemblyTagNameAdded?: { __typename?: 'AssemblyTagNameAdded', id: string, structureId: string, tagName: string, isNewlyAdded: boolean } | null };

export type SplitCuboidOnPartUpdatedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
}>;


export type SplitCuboidOnPartUpdatedSubscription = { __typename?: 'Subscription', splitCuboidOnPartUpdated: Array<{ __typename?: 'AddUpdateSplitCuboidOnPartNotification', partId: string, structureId: string, zoneId?: string | null, splitCuboid: { __typename?: 'SplitCuboid', id: string, assemblyId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number>, color: number } }> };

export type SplitCuboidOnPartRemovedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
}>;


export type SplitCuboidOnPartRemovedSubscription = { __typename?: 'Subscription', splitCuboidOnPartRemoved: Array<{ __typename?: 'RemoveSplitCuboidOnPartNotification', partId: string, splitCuboidId: string, structureId: string, zoneId?: string | null }> };

export type BulkLineFixingMutationVariables = Exact<{
  input: BulkLineFixingInput;
}>;


export type BulkLineFixingMutation = { __typename?: 'Mutation', bulkLineFixing: { __typename?: 'BulkLineFixingResult', message: string, updatedCount: number } };

export type RevertBulkLineFixingMutationVariables = Exact<{
  input: RevertBulkLineFixingInput;
}>;


export type RevertBulkLineFixingMutation = { __typename?: 'Mutation', revertBulkLineFixing: { __typename?: 'BulkLineFixingResult', message: string, updatedCount: number } };

export type AllPartsQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type AllPartsQuery = { __typename?: 'Query', allParts: Array<{ __typename?: 'Part', id: string, assembly?: { __typename?: 'Assembly', id: string, tagName: string } | null }>, structure?: { __typename?: 'Structure', name: string } | null };

export type GetAbyssViewerColoursForTaggingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAbyssViewerColoursForTaggingQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', id: string, name: string, type: SettingTypesEnum, revision: number, meta: Array<{ __typename: 'DefectColorMeta' } | { __typename: 'FloatMeta' } | { __typename: 'IntMeta' } | { __typename: 'StringArrayMeta', key: string, value: Array<string> } | { __typename: 'StringMeta', key: string, colour: string }> } | null };

export type AddUpdateSplitCuboidOnPartMutationVariables = Exact<{
  input?: InputMaybe<AddUpdateSplitCuboidOnPartInput>;
}>;


export type AddUpdateSplitCuboidOnPartMutation = { __typename?: 'Mutation', addUpdateSplitCuboidOnPart: { __typename?: 'AddUpdateSplitCuboidOnPartNotification', partId: string, splitCuboid: { __typename?: 'SplitCuboid', id: string, assemblyId?: string | null, position: Array<number>, scale: Array<number>, rotation: Array<number>, color: number } } };

export type RemoveSplitCuboidOnPartMutationVariables = Exact<{
  input?: InputMaybe<RemoveSplitCuboidOnPartInput>;
}>;


export type RemoveSplitCuboidOnPartMutation = { __typename?: 'Mutation', removeSplitCuboidOnPart: { __typename?: 'RemoveSplitCuboidOnPartNotification', partId: string, splitCuboidId: string } };

export type SplitAnnotationFromPartMutationVariables = Exact<{
  input?: InputMaybe<SplitPartInput>;
}>;


export type SplitAnnotationFromPartMutation = { __typename?: 'Mutation', splitPart: { __typename?: 'Part', id: string, updatedBy?: string | null, assemblyId?: string | null } };

export type GetLocalAnnotationIdQueryVariables = Exact<{
  annotationId: Scalars['String']['input'];
}>;


export type GetLocalAnnotationIdQuery = { __typename?: 'Query', annotation?: { __typename?: 'Annotation', processingReferences?: { __typename?: 'ProcessingReferences', localAnnotationId: number } | null } | null };

export type ZonesForStructureForTaggingQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesForStructureForTaggingQuery = { __typename?: 'Query', zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } } }> };

export type ZoneAndHistoriesForQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZoneAndHistoriesForQuery = { __typename?: 'Query', zonesAndHistoriesFor: Array<{ __typename?: 'ZoneAndHistory', _id: string, histories?: Array<{ __typename?: 'History', id: string, createdBy: string, eventName: string, document: any, createdByDetails?: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } | null } | null> | null }> };

export type GetGroupsByPartIdsQueryVariables = Exact<{
  input?: InputMaybe<GroupsByPartIdsInput>;
}>;


export type GetGroupsByPartIdsQuery = { __typename?: 'Query', groupsByPartIds: Array<{ __typename?: 'PartGroup', groupedParts: Array<string> }> };

export type SetHiddenFlagForPartsMutationVariables = Exact<{
  parts?: InputMaybe<UpdatePartsHiddenFlagInput>;
}>;


export type SetHiddenFlagForPartsMutation = { __typename?: 'Mutation', setHiddenForParts: Array<string> };

export type SetReviewedFlagForPartsMutationVariables = Exact<{
  parts?: InputMaybe<UpdatePartsReviewedFlagInput>;
}>;


export type SetReviewedFlagForPartsMutation = { __typename?: 'Mutation', setReviewedForParts: Array<string> };

export type AddPartsToAssemblyInputForDeletePartMutationVariables = Exact<{
  input?: InputMaybe<AddPartsToAssemblyInput>;
}>;


export type AddPartsToAssemblyInputForDeletePartMutation = { __typename?: 'Mutation', addPartsToAssembly: Array<{ __typename?: 'Part', id: string, class: string, updatedBy?: string | null, updatedAt: string, createdAt: string, assembly?: { __typename?: 'Assembly', id: string, tagName: string } | null }> };

export type AllHistoriesQueryVariables = Exact<{
  referenceId?: InputMaybe<Scalars['String']['input']>;
  eventNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AllHistoriesQuery = { __typename?: 'Query', allHistories: Array<{ __typename?: 'History', id: string, collectionName: string, eventName: string, document: any, createdAt: string, createdBy: string, createdByName: string }> };

export type PartQueryVariables = Exact<{
  partId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartQuery = { __typename?: 'Query', part?: { __typename?: 'Part', id: string, class: string, assembly?: { __typename?: 'Assembly', id: string, tagName: string } | null } | null };

export type AddNewAssemblyTagNameMutationVariables = Exact<{
  input?: InputMaybe<AddNewAssemblyTagNameInput>;
}>;


export type AddNewAssemblyTagNameMutation = { __typename?: 'Mutation', addNewAssemblyTagName?: { __typename?: 'Assembly', id: string, tagName: string } | null };

export type EquipmentClassesForStrunctureQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EquipmentClassesForStrunctureQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', equipmentClasses: Array<{ __typename?: 'EquipmentClasses', name: string, classes: Array<{ __typename?: 'Equipment', name: string, code: string }> }> } | null };

export type GetStructureStatusQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStructureStatusQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', status: StructureStatus } | null };

export type AllStructuresForPlatformsQueryVariables = Exact<{
  input?: InputMaybe<StructureFilters>;
}>;


export type AllStructuresForPlatformsQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, status: StructureStatus, coverImagePath: string, deploymentLevel?: StructureDeploymentLevel | null, description: string, octreeResourcesPath: string, cardInsights?: Array<{ __typename?: 'CardInsights', color?: string | null, name: string, value: any, type: string, visible?: boolean | null }> | null }> };

export type AllRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRegionsQuery = { __typename?: 'Query', allRegions?: Array<{ __typename?: 'Region', id: string, name: string }> | null };

export type AllStructuresByRegionQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStructuresByRegionQuery = { __typename?: 'Query', allStructuresByRegion: Array<{ __typename?: 'AllStructuresByRegion', id: string, name: string, structures: Array<{ __typename?: 'StructureWithDefects', id: string, name: string, status: StructureStatus, defectArea: Array<{ __typename?: 'DefectArea', key: string, area: number }> }>, defectArea: Array<{ __typename?: 'DefectArea', key: string, area: number }> }>, allDefects: Array<{ __typename?: 'Defect', key: string, name: string }> };

export type StructureDecksWithDefectsQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StructureDecksWithDefectsQuery = { __typename?: 'Query', decksWithDefects: Array<{ __typename?: 'DeckWithDefects', id: string, name: string, defectArea: Array<{ __typename?: 'DefectArea', key: string, area: number }> }> };

export type AllUserGroupsForPlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserGroupsForPlatformsQuery = { __typename?: 'Query', allUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null }> };

export type CreateStructureMutationVariables = Exact<{
  input: CreateStructureInput;
}>;


export type CreateStructureMutation = { __typename?: 'Mutation', createStructure?: { __typename?: 'Structure', id: string } | null };

export type AnalyticsQueryVariables = Exact<{
  input?: InputMaybe<AnalyticsFiltersInput>;
}>;


export type AnalyticsQuery = { __typename?: 'Query', analytics: Array<{ __typename?: 'Analytics', data: any, id: string, structureIds: Array<string>, type: string, displayConfig?: any | null }> };

export type AllPlatformsQueryVariables = Exact<{
  regionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllPlatformsQuery = { __typename?: 'Query', allPlatforms: Array<{ __typename?: 'Platform', id: string, name: string, coverImagePath: string, platformCardInsights?: Array<{ __typename?: 'PlatformCardInsights', name: string, value: string, group: string, displayConfig?: { __typename?: 'PlatformCardInsightsDisplayConfig', color?: string | null, divider?: boolean | null, listIndex?: number | null, barIndex?: number | null } | null }> | null, platformSummary?: Array<{ __typename?: 'PlatformCardSummary', name: string, value: string, group: string, displayConfig?: { __typename?: 'PlatformCardInsightsDisplayConfig', color?: string | null, divider?: boolean | null, listIndex?: number | null, barIndex?: number | null } | null }> | null, region?: { __typename?: 'Region', id: string, name: string } | null }> };

export type PlatformQueryVariables = Exact<{
  platformId: Scalars['ID']['input'];
}>;


export type PlatformQuery = { __typename?: 'Query', platform?: { __typename?: 'Platform', id: string, name: string, platformCardInsights?: Array<{ __typename?: 'PlatformCardInsights', name: string, value: string, group: string, displayConfig?: { __typename?: 'PlatformCardInsightsDisplayConfig', color?: string | null } | null }> | null, region?: { __typename?: 'Region', id: string, name: string } | null } | null };

export type AllStructuresForHomePageQueryVariables = Exact<{
  input?: InputMaybe<StructureFilters>;
}>;


export type AllStructuresForHomePageQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, isActive?: boolean | null, deploymentLevel?: StructureDeploymentLevel | null, octreeResourcesPath: string, coverImagePath: string, updatedAt: string, status: StructureStatus, scanDate?: string | null, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, name: string, groupKey: string, groupName: string, color: string, octreeKey: OctreeKey, octreeValue: number }> }> };

export type DefectsAreaByPlatformQueryVariables = Exact<{
  platformId: Scalars['ID']['input'];
}>;


export type DefectsAreaByPlatformQuery = { __typename?: 'Query', defectsAreaByStructures: Array<{ __typename?: 'DefectsAreaByStructuresResult', structureId: string, structureName: string, totalArea: Array<{ __typename?: 'AreaAndType', type: string, value: number }> }> };

export type GetAlarmLevelSummaryQueryVariables = Exact<{
  input?: InputMaybe<AlarmLevelSummaryInput>;
}>;


export type GetAlarmLevelSummaryQuery = { __typename?: 'Query', getAlarmLevelSummary?: Array<{ __typename?: 'AlarmLevelSummaryResult', structureId: string, structureName: string, total: Array<{ __typename?: 'TypeAndCount', type?: string | null, count: number }> } | null> | null };

export type GetAllStructuresForSystemRequirementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStructuresForSystemRequirementQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, octreeResourcesPath: string }> };

export type AllPointOfInterestTemplateQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllPointOfInterestTemplateQuery = { __typename?: 'Query', allPointOfInterestTemplate: Array<{ __typename?: 'PointOfInterestTemplate', id: string, name: string, type?: PointOfInterestTemplateTypeEnum | null, key?: string | null, accentColor?: string | null, permissions?: Array<string | null> | null, icon?: { __typename?: 'TemplateIcon', name: string, color?: string | null } | null, fields: Array<{ __typename?: 'PointOfInterestTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, key?: string | null, detailFieldKey?: string | null, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, serverSide: boolean, isRequired: boolean, isMeasurementToolEnabled?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, unit?: UnitsEnum | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, weight?: number | null, min?: number | null, max?: number | null, minIncluded?: boolean | null, maxIncluded?: boolean | null }> | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null }>, markerLabelConfig?: { __typename?: 'MarkerLabelConfig', type: MarkerLabelConfigTypeEnum, hideName?: boolean | null, fields: Array<{ __typename?: 'MarkerLabelField', key: string, type?: MarkerLabelFieldTypeEnum | null }>, headerField?: { __typename?: 'MarkerLabelField', key: string, type?: MarkerLabelFieldTypeEnum | null } | null } | null }> };

export type GetPaintBlockRemediationScoreQueryVariables = Exact<{
  structureId: Scalars['ID']['input'];
  type: TemplateTypeEnum;
}>;


export type GetPaintBlockRemediationScoreQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, remediationScoreConfig?: { __typename?: 'RemediationScoreConfig', area?: { __typename?: 'RemediationScoreAreaSection', fields?: Array<{ __typename?: 'RemediationScoreAreaField', fieldKey: string, score: number, threshold: number }> | null } | null, cof?: { __typename?: 'RemediationScoreCofSection', fields?: Array<{ __typename?: 'RemediationScoreCofField', fieldKey: string, optionScores: any }> | null } | null, poi?: { __typename?: 'RemediationScorePoiSection', fields?: Array<{ __typename?: 'RemediationScorePoiField', poiScore: number, poiTemplateKey: string, subcategory?: { __typename?: 'RemediationScoreSubcategory', fieldKey: string, optionScores: any } | null }> | null } | null } | null }> };

export type GetAllStructuresListForTemplateBuilderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStructuresListForTemplateBuilderQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, coverImagePath: string }> };

export type StructureForTemplateBuilderQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type StructureForTemplateBuilderQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, status: StructureStatus } | null };

export type GetStructureDefectsQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureDefectsQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, groupName: string, groupKey: string, name: string, color: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }> } | null };

export type GetStructureDetailsQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureDetailsQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string, scanDate?: string | null, coverImagePath: string, isActive?: boolean | null, isWallLossEnabled?: boolean | null, features?: any | null, hasRiskAssessment?: boolean | null, platform?: { __typename?: 'Platform', id: string, name: string } | null, reportConfig?: { __typename?: 'ReportConfig', title: string, id: string, configurations?: Array<{ __typename?: 'Configurations', id: string, title: string, key: string }> | null } | null } | null };

export type AllTemplatesForBuilderQueryVariables = Exact<{
  type?: InputMaybe<TemplateTypeEnum>;
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllTemplatesForBuilderQuery = { __typename?: 'Query', allTemplates: Array<{ __typename?: 'Template', id: string, name: string, type: TemplateTypeEnum, defectsArray: Array<string>, permissions?: Array<string | null> | null, reviewPanelConfig?: Array<{ __typename?: 'ReviewPanelConfig', groupKey: string, groupName: string, id: string, groupSection: Array<{ __typename?: 'GroupSection', id: string, title: string, sectionKey: string, fieldKeys: Array<string | null> } | null> }> | null, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, type: TemplateFieldTypeEnum, options: Array<string>, isRequired: boolean, isReadOnly: boolean, serverSide: boolean, isHidden?: boolean | null, permission?: string | null, isRiskAssessment?: boolean | null, key?: string | null, displayInQuery?: boolean | null, displayInTable?: boolean | null, displayInReview?: boolean | null, displayInReports?: boolean | null, displayInReportFilters?: boolean | null, displayInRisk?: boolean | null, defaultVisible?: boolean | null, unit?: UnitsEnum | null, roundToDecimal?: number | null, isEditable?: boolean | null, editRoles?: Array<string | null> | null, dependencyMapping?: Array<string | null> | null, displayUnit?: UnitsEnum | null, optionsData?: Array<{ __typename?: 'OptionData', value: string, weight?: number | null }> | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null }>, equipmentDetails: Array<{ __typename?: 'EquipmentDetailField', id: string, name: string, type: EquipmentDetailTypeEnum, subType?: EquipmentDetailSubTypeEnum | null, isRequired: boolean, isReadOnly: boolean, serverSide: boolean, isHidden?: boolean | null, fieldKey: string, options: Array<{ __typename?: 'EquipmentDetailOptionField', id: string, name: string, type: OptionFieldTypeEnum, fieldKey?: string | null }>, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, textFormat?: TextFormatEnum | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null }>, icon?: { __typename?: 'TemplateIcon', name: string, color?: string | null } | null, equipmentCard: Array<{ __typename?: 'EquipmentCardField', id: string, name: string, type: EqiupmentCardFieldTypeEnum, fieldKey?: string | null, position: EquipmentCardPositionEnum, location: EquipmentCardLocationEnum }>, riskFields?: Array<{ __typename?: 'RiskFields', id: string, fieldKey: string, type: Array<RiskFieldsTypeEnum | null>, isHiddenColumn: boolean }> | null, recommendation?: { __typename?: 'RecommendationField', header: string, details: Array<{ __typename?: 'RecommendationDetailField', id: string, fieldKey: string } | null> } | null, querySummary?: Array<{ __typename?: 'QuerySummaryItem', id: string, name: string, key?: string | null, operation: string, matchCondition?: any | null, displayType: DisplayType, rowOrder: number, collectionName: string, sortType?: SummaryItemSortType | null, sortDirection?: number | null, displayConfig?: Array<{ __typename?: 'DisplaySettings', fieldValue: string, color: string }> | null }> | null, materialType?: Array<{ __typename?: 'MaterialType', type: string, thickness?: Array<string | null> | null, environmentalClassification?: Array<{ __typename?: 'EnvironmentalClassificationItem', name: string, values: any }> | null, corrosivityCategory?: Array<{ __typename?: 'CorrosivityCategoryItem', name: string, values: any }> | null, environmentalExposure?: Array<{ __typename?: 'EnvironmentalExposureItem', name: string, timeToVisibility: number, code: string }> | null } | null> | null }> };

export type AllPlatformsForTemplateBuilderQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPlatformsForTemplateBuilderQuery = { __typename?: 'Query', allPlatforms: Array<{ __typename?: 'Platform', name: string, id: string }> };

export type GetAllPoiIconsForTemplateBuilderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPoiIconsForTemplateBuilderQuery = { __typename?: 'Query', getAllPoiIcons: Array<string | null> };

export type UpdatePointOfInterestTemplateMutationVariables = Exact<{
  input?: InputMaybe<UpdatePointOfInterestTemplateInput>;
}>;


export type UpdatePointOfInterestTemplateMutation = { __typename?: 'Mutation', updatePointOfInterestTemplate?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, serverSide: boolean, isRequired: boolean, displayInReview?: boolean | null, displayInReports?: boolean | null, unit?: UnitsEnum | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null }> } | null };

export type CreatePointOfInterestTemplateMutationVariables = Exact<{
  input?: InputMaybe<PointOfInterestTemplateInput>;
}>;


export type CreatePointOfInterestTemplateMutation = { __typename?: 'Mutation', createPointOfInterestTemplate?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, fields: Array<{ __typename?: 'PointOfInterestTemplateField', options: Array<string>, name: string, type: TemplateFieldTypeEnum, id: string, key?: string | null, isReadOnly: boolean, isHidden?: boolean | null, defaultVisible?: boolean | null, serverSide: boolean, isRequired: boolean, displayInReview?: boolean | null, displayInReports?: boolean | null, unit?: UnitsEnum | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, isSortable: boolean, sortType: SortTypeEnum, textAreaRows?: number | null, inputAdorment?: { __typename?: 'InputAdormentType', iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null, position?: InputAdormentPositionEnum | null } | null } | null }> } | null };

export type PointOfInterestTemplateQueryVariables = Exact<{
  pointOfInterestTemplateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PointOfInterestTemplateQuery = { __typename?: 'Query', pointOfInterestTemplate?: { __typename?: 'PointOfInterestTemplate', id: string, name: string, accentColor?: string | null, createdBy?: string | null, permissions?: Array<string | null> | null, icon?: { __typename?: 'TemplateIcon', color?: string | null, name: string } | null, fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, type: TemplateFieldTypeEnum, options: Array<string>, isRequired: boolean, isReadOnly: boolean, serverSide: boolean, displayInReview?: boolean | null, displayInReports?: boolean | null, isHidden?: boolean | null, permission?: string | null, defaultVisible?: boolean | null, unit?: UnitsEnum | null, key?: string | null, displayConfig?: { __typename?: 'DisplayConfig', id: string, type: TableCellStyleEnum, textAreaRows?: number | null, isSortable: boolean, sortType: SortTypeEnum, color?: Array<{ __typename?: 'DisplayColor', key: string, value: string } | null> | null, inputAdorment?: { __typename?: 'InputAdormentType', position?: InputAdormentPositionEnum | null, iconPath?: string | null, iconType?: InputAdormentIconTypeEnum | null } | null } | null }> } | null };

export type GetAllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRolesQuery = { __typename?: 'Query', allRoles: Array<{ __typename?: 'Role', id: string, name: string } | null> };

export type ClonePointOfInterestTemplateMutationVariables = Exact<{
  input?: InputMaybe<PoiTemplateCloneInput>;
}>;


export type ClonePointOfInterestTemplateMutation = { __typename?: 'Mutation', clonePointOfInterestTemplate?: Array<{ __typename?: 'PointOfInterestTemplate', id: string, name: string } | null> | null };

export type UpdateStructureMutationVariables = Exact<{
  input?: InputMaybe<UpdateStructureInput>;
}>;


export type UpdateStructureMutation = { __typename?: 'Mutation', updateStructure?: { __typename?: 'Structure', id: string, name: string, status: StructureStatus, isActive?: boolean | null, deploymentLevel?: StructureDeploymentLevel | null, scanDate?: string | null, isWallLossEnabled?: boolean | null, defectLegends: Array<{ __typename?: 'DefectLegend', id: number, groupName: string, groupKey: string, name: string, color: string, octreeKey: OctreeKey, octreeValue: number, legendText?: string | null }> } | null };

export type DeletePointOfInterestTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type DeletePointOfInterestTemplateMutation = { __typename?: 'Mutation', deletePointOfInterestTemplate?: { __typename?: 'PointOfInterestTemplate', id: string } | null };

export type UpdateTemplateMutationVariables = Exact<{
  input?: InputMaybe<TemplateInput>;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateTemplate?: { __typename?: 'Template', id: string, fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string }> } | null };

export type CloneTemplateFieldsMutationVariables = Exact<{
  input?: InputMaybe<TemplateFieldsCloneInput>;
}>;


export type CloneTemplateFieldsMutation = { __typename?: 'Mutation', cloneTemplateFields?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', name: string, id: string }> } | null };

export type CloneQuerySummaryMutationVariables = Exact<{
  input?: InputMaybe<QuerySummaryCloneInput>;
}>;


export type CloneQuerySummaryMutation = { __typename?: 'Mutation', cloneQuerySummary?: { __typename?: 'Template', querySummary?: Array<{ __typename?: 'QuerySummaryItem', id: string, name: string }> | null } | null };

export type AddMiServicesFieldsMutationVariables = Exact<{
  input?: InputMaybe<MiServicesInput>;
}>;


export type AddMiServicesFieldsMutation = { __typename?: 'Mutation', addMiServicesFields?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> } | null };

export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables = Exact<{
  input?: InputMaybe<MiServicesInput>;
}>;


export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutation = { __typename?: 'Mutation', addMiServicesOverhaulFields?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }> } | null };

export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables = Exact<{
  input?: InputMaybe<MiServicesPoiTemplateInput>;
}>;


export type AddMiServicesOverhaulFieldsToPoiTemplatesMutation = { __typename?: 'Mutation', addMiServicesOverhaulFieldsToPoiTemplates?: Array<{ __typename?: 'PointOfInterestTemplate', fields: Array<{ __typename?: 'PointOfInterestTemplateField', id: string, name: string, key?: string | null }> } | null> | null };

export type AddEditRolesToTemplateFieldMutationVariables = Exact<{
  input?: InputMaybe<EditRolesInput>;
}>;


export type AddEditRolesToTemplateFieldMutation = { __typename?: 'Mutation', addEditRolesToTemplateField?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', key?: string | null, isEditable?: boolean | null, editRoles?: Array<string | null> | null }> } | null };

export type EvaluateAllAssembliesForStructureMutationVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type EvaluateAllAssembliesForStructureMutation = { __typename?: 'Mutation', evaluateAllAssembliesForStructure?: { __typename?: 'Structure', name: string } | null };

export type AddAssessmentDetailsFieldsMutationVariables = Exact<{
  input?: InputMaybe<AssessmentDetailsInput>;
}>;


export type AddAssessmentDetailsFieldsMutation = { __typename?: 'Mutation', addAssessmentDetailsFields?: { __typename?: 'Template', fields: Array<{ __typename?: 'AssemblyTemplateField', id: string, name: string, key?: string | null }>, assessmentDetails?: Array<{ __typename?: 'AssessmentDetails', id: string, isVisible: boolean, name: string, position: number, type: string, options: Array<{ __typename?: 'AssessmentDetailOptionFieldSchema', fieldKey: string, id: string, name: string, type: OptionFieldTypeEnum }> }> | null, reviewPanelConfig?: Array<{ __typename?: 'ReviewPanelConfig', groupKey: string, groupName: string, id: string, groupSection: Array<{ __typename?: 'GroupSection', id: string, title: string, sectionKey: string, fieldKeys: Array<string | null> } | null> }> | null } | null };

export type UploadCoverImageMutationVariables = Exact<{
  input: UploadImageInput;
}>;


export type UploadCoverImageMutation = { __typename?: 'Mutation', uploadCoverImage?: { __typename?: 'Structure', coverImagePath: string } | null };

export type UpdateRemediationScoreConfigMutationVariables = Exact<{
  input: UpdateRemediationScoreConfigInput;
}>;


export type UpdateRemediationScoreConfigMutation = { __typename?: 'Mutation', updateRemediationScoreConfig?: { __typename?: 'Template', remediationScoreConfig?: { __typename?: 'RemediationScoreConfig', area?: { __typename?: 'RemediationScoreAreaSection', fields?: Array<{ __typename?: 'RemediationScoreAreaField', fieldKey: string, score: number, threshold: number }> | null } | null, cof?: { __typename?: 'RemediationScoreCofSection', fields?: Array<{ __typename?: 'RemediationScoreCofField', fieldKey: string, optionScores: any }> | null } | null, poi?: { __typename?: 'RemediationScorePoiSection', fields?: Array<{ __typename?: 'RemediationScorePoiField', poiScore: number, poiTemplateKey: string, subcategory?: { __typename?: 'RemediationScoreSubcategory', fieldKey: string, optionScores: any } | null }> | null } | null } | null } | null };

export type AddReportConfigurationMutationVariables = Exact<{
  structureId: Scalars['ID']['input'];
}>;


export type AddReportConfigurationMutation = { __typename?: 'Mutation', addReportConfiguration?: { __typename?: 'Structure', reportConfig?: { __typename?: 'ReportConfig', title: string, id: string, configurations?: Array<{ __typename?: 'Configurations', id: string, title: string, key: string }> | null } | null } | null };

export type RecalculateRiskRemediationAnalyticsMutationVariables = Exact<{
  input: RecalculateRiskRemediationAnalyticsInput;
}>;


export type RecalculateRiskRemediationAnalyticsMutation = { __typename?: 'Mutation', recalculateRiskRemediationAnalytics: { __typename?: 'RecalculateRiskRemediationAnalyticsResult', success: boolean, error?: string | null } };

export type AllUsersForUserManagementQueryVariables = Exact<{
  pageInfo?: InputMaybe<PageInfo>;
  input?: InputMaybe<FilterForUsers>;
  usersCountInput?: InputMaybe<FiltersForUsersCount>;
}>;


export type AllUsersForUserManagementQuery = { __typename?: 'Query', usersCount?: { __typename?: 'Count', count: number } | null, allUsers: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null, connection?: string | null, status?: UserStatusEnum | null, loginCount?: number | null, lastLogin?: string | null, loginType?: LoginTypeEnum | null, roleIds: Array<{ __typename?: 'Role', id: string, name: string, description?: string | null, auth0Id: string } | null> }> };

export type BlockOrUnblockUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type BlockOrUnblockUserMutation = { __typename?: 'Mutation', blockOrUnblockUser: { __typename?: 'User', id: string, status?: UserStatusEnum | null } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: string };

export type AllStructuresForAddPlatformDialogQueryVariables = Exact<{
  input?: InputMaybe<StructureFilters>;
}>;


export type AllStructuresForAddPlatformDialogQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', coverImagePath: string, id: string, name: string, description: string }> };

export type AllUsersForAddUserDialogQueryVariables = Exact<{
  input?: InputMaybe<FilterForUsers>;
}>;


export type AllUsersForAddUserDialogQuery = { __typename?: 'Query', allUsers: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null, connection?: string | null, status?: UserStatusEnum | null, loginCount?: number | null, lastLogin?: string | null, loginType?: LoginTypeEnum | null, roleIds: Array<{ __typename?: 'Role', id: string, name: string, description?: string | null, auth0Id: string } | null> }> };

export type PreRegisteredUsersQueryVariables = Exact<{
  pageInfo?: InputMaybe<PageInfo>;
  input?: InputMaybe<FiltersForPreRegisteredUsers>;
}>;


export type PreRegisteredUsersQuery = { __typename?: 'Query', preRegisteredUsers: Array<{ __typename?: 'PreRegisteredUser', id: string, email: string }>, preRegisteredUsersCount: { __typename?: 'Count', count: number } };

export type CreatePreRegisteredUsersMutationVariables = Exact<{
  input?: InputMaybe<PreRegisteredUserInput>;
}>;


export type CreatePreRegisteredUsersMutation = { __typename?: 'Mutation', createPreRegisteredUsers: { __typename?: 'UserInvite', createdUsers: Array<{ __typename?: 'User', email: string, status?: UserStatusEnum | null, id: string } | null>, failedUsers?: Array<{ __typename?: 'FailedUserInfo', email: string, errorMessage: string } | null> | null } };

export type DeletePreRegisteredUserMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeletePreRegisteredUserMutation = { __typename?: 'Mutation', deletePreRegisteredUser?: { __typename?: 'PreRegisteredUser', email: string } | null };

export type AddUsersToUserGroupMutationVariables = Exact<{
  input?: InputMaybe<AddRemoveUsersToFromUserGroupInput>;
}>;


export type AddUsersToUserGroupMutation = { __typename?: 'Mutation', addUsersToUserGroup?: { __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type GetAllTeamsForUserManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTeamsForUserManagementQuery = { __typename?: 'Query', allTeams: Array<{ __typename?: 'Team', id: string, name: string, users: Array<{ __typename?: 'User', id: string }> }> };

export type GetUsersByTeamQueryVariables = Exact<{
  teamId: Scalars['ID']['input'];
  pageInfo?: InputMaybe<PageInfo>;
}>;


export type GetUsersByTeamQuery = { __typename?: 'Query', usersByTeam: Array<{ __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null }> };

export type CreateTeamMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string } };

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: string };

export type AddUsersToTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type AddUsersToTeamMutation = { __typename?: 'Mutation', addUsersToTeam: { __typename?: 'Team', id: string } };

export type RemoveUsersFromTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type RemoveUsersFromTeamMutation = { __typename?: 'Mutation', removeUsersFromTeam: { __typename?: 'Team', id: string } };

export type AllUserGroupsForUserManagementQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllUserGroupsForUserManagementQuery = { __typename?: 'Query', allUserGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null }> };

export type AllRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllRolesQuery = { __typename?: 'Query', allRoles: Array<{ __typename?: 'Role', id: string, auth0Id: string, name: string, description?: string | null } | null> };

export type UsersCountQueryVariables = Exact<{
  input?: InputMaybe<FiltersForUsersCount>;
}>;


export type UsersCountQuery = { __typename?: 'Query', usersCount?: { __typename?: 'Count', count: number } | null };

export type UsersByUserGroupQueryVariables = Exact<{
  input?: InputMaybe<FilterForUsersByUserGroup>;
  pageInfo?: InputMaybe<PageInfo>;
  usersCountInput?: InputMaybe<FiltersForUsersCount>;
}>;


export type UsersByUserGroupQuery = { __typename?: 'Query', usersCount?: { __typename?: 'Count', count: number } | null, usersByUserGroup: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null, connection?: string | null, roleIds: Array<{ __typename?: 'Role', id: string, name: string, description?: string | null, auth0Id: string, permissions?: Array<string | null> | null } | null> }> };

export type GetAuth0ConnectionsQueryVariables = Exact<{
  applicationId: Scalars['String']['input'];
}>;


export type GetAuth0ConnectionsQuery = { __typename?: 'Query', auth0Connections: Array<{ __typename?: 'ConnectionAuth0', id: string, name: string }> };

export type RemoveUsersFromUserGroupMutationVariables = Exact<{
  input?: InputMaybe<AddRemoveUsersToFromUserGroupInput>;
}>;


export type RemoveUsersFromUserGroupMutation = { __typename?: 'Mutation', removeUsersFromUserGroup?: { __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type InviteUsersMutationVariables = Exact<{
  input?: InputMaybe<InviteUsersInput>;
}>;


export type InviteUsersMutation = { __typename?: 'Mutation', inviteUsers: { __typename?: 'UserInvite', createdUsers: Array<{ __typename?: 'User', email: string, status?: UserStatusEnum | null, id: string } | null>, failedUsers?: Array<{ __typename?: 'FailedUserInfo', email: string, errorMessage: string } | null> | null } };

export type CreateUserGroupMutationVariables = Exact<{
  input?: InputMaybe<CreateUserGroupInput>;
}>;


export type CreateUserGroupMutation = { __typename?: 'Mutation', createUserGroup?: { __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type AllStructuresForUserManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type AllStructuresForUserManagementQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, coverImagePath: string, userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string }> }> };

export type StructuresByUserGroupQueryVariables = Exact<{
  structuresInput?: InputMaybe<FiltersForStructureByUserGroup>;
  pageInfo?: InputMaybe<PageInfo>;
  input?: InputMaybe<FilterForStructures>;
}>;


export type StructuresByUserGroupQuery = { __typename?: 'Query', structuresByUserGroup: Array<{ __typename?: 'Structure', id: string, name: string, coverImagePath: string, description: string }>, structuresCount?: { __typename?: 'Count', count: number } | null };

export type RemoveUserGroupsFromStructureMutationVariables = Exact<{
  input?: InputMaybe<AddRemoveStructuresToFromUserGroupsInput>;
}>;


export type RemoveUserGroupsFromStructureMutation = { __typename?: 'Mutation', removeUserGroupsFromStructure?: { __typename?: 'StructuresAndGroups', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null }>, structures: Array<{ __typename?: 'Structure', id: string, name: string }> } | null };

export type AddUserGroupsToStructureMutationVariables = Exact<{
  input?: InputMaybe<AddRemoveStructuresToFromUserGroupsInput>;
}>;


export type AddUserGroupsToStructureMutation = { __typename?: 'Mutation', addUserGroupsToStructure?: { __typename?: 'StructuresAndGroups', userGroups: Array<{ __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null }>, structures: Array<{ __typename?: 'Structure', id: string, name: string }> } | null };

export type UsersByRoleIdQueryVariables = Exact<{
  input?: InputMaybe<UsersByRoleInput>;
  pageInfo?: InputMaybe<PageInfo>;
  usersCountInput?: InputMaybe<FiltersForUsersCount>;
}>;


export type UsersByRoleIdQuery = { __typename?: 'Query', usersCount?: { __typename?: 'Count', count: number } | null, usersByRoleId: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null }> };

export type RemoveRoleFromUsersMutationVariables = Exact<{
  input?: InputMaybe<AssignRemoveRoleToFromUsersInput>;
}>;


export type RemoveRoleFromUsersMutation = { __typename?: 'Mutation', removeRoleFromUsers: { __typename?: 'Role', id: string, name: string, auth0Id: string, description?: string | null } };

export type AssignRoleToUsersMutationVariables = Exact<{
  input?: InputMaybe<AssignRemoveRoleToFromUsersInput>;
}>;


export type AssignRoleToUsersMutation = { __typename?: 'Mutation', assignRoleToUsers: { __typename?: 'Role', id: string, name: string, auth0Id: string, description?: string | null } };

export type UserDetailsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserDetailsQuery = { __typename?: 'Query', userDetails: { __typename?: 'UserProfile', user: { __typename?: 'User', email: string, picture?: string | null, name?: string | null, permissions?: Array<string> | null, connection?: string | null, loginCount?: number | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, description?: string | null, permissions?: Array<string | null> | null } | null> }, userGroups: Array<{ __typename?: 'UserGroup', name: string }>, structures: Array<{ __typename?: 'Structure', id: string, name: string, coverImagePath: string, description: string }> } };

export type GetDirectlyAssignedUserPermissionsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetDirectlyAssignedUserPermissionsQuery = { __typename?: 'Query', getDirectlyAssignedUserPermissions: Array<{ __typename?: 'Permission', description?: string | null, name?: string | null }> };

export type GetAuth0PermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuth0PermissionsQuery = { __typename?: 'Query', getAuth0Permissions: Array<{ __typename?: 'Permission', name?: string | null, description?: string | null }> };

export type GetUserPermissionsByRolesQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetUserPermissionsByRolesQuery = { __typename?: 'Query', getUserPermissionsByRoles: Array<{ __typename?: 'Auth0UserRoles', name?: string | null, auth0Id?: string | null, description?: string | null, permissions?: Array<{ __typename?: 'Permission', name?: string | null, description?: string | null } | null> | null }> };

export type PermissionsByRoleQueryVariables = Exact<{
  roleId: Scalars['String']['input'];
}>;


export type PermissionsByRoleQuery = { __typename?: 'Query', permissionsByRole: Array<{ __typename?: 'RolePermission', key: string, description: string }> };

export type DeleteUserGroupMutationVariables = Exact<{
  input?: InputMaybe<DeleteUserGroupInput>;
}>;


export type DeleteUserGroupMutation = { __typename?: 'Mutation', deleteUserGroup?: { __typename?: 'UserGroup', id: string, name: string, userIds: Array<string>, createdBy?: string | null, updatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type GetUserAbilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAbilitiesQuery = { __typename?: 'Query', getUserAbilities?: string | null };

export type UpdateWorkflowStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowStatusInput>;
}>;


export type UpdateWorkflowStatusMutation = { __typename?: 'Mutation', updateWorkflowStatus?: Array<{ __typename?: 'Zone', id: string, name: string, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, difficultyLevel?: DifficultyLevel | null, totalTime?: any | null, idleTime?: any | null, trackedTime?: any | null, pausedBy?: PausedBy | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null } | null> | null };

export type WorkFlowTimeUpdatedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WorkFlowTimeUpdatedSubscription = { __typename?: 'Subscription', workFlowTimeUpdated: { __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, totalTime?: any | null, idleTime?: any | null, pausedBy?: PausedBy | null, trackedTime?: any | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null } };

export type WorkflowStagesQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type WorkflowStagesQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string, name: string, orderInWorkflow: number, stageType: StageType } | null> | null } | null };

export type DeleteWorkflowStageMutationVariables = Exact<{
  input?: InputMaybe<DeleteWorkflowStageInput>;
}>;


export type DeleteWorkflowStageMutation = { __typename?: 'Mutation', deleteWorkflowStage?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string } | null> | null } | null };

export type UpdateZoneWorkFlowStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowStatusInput>;
}>;


export type UpdateZoneWorkFlowStatusMutation = { __typename?: 'Mutation', updateWorkflowStatus?: Array<{ __typename?: 'Zone', name: string } | null> | null };

export type ZonesPerStatusCountQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesPerStatusCountQuery = { __typename?: 'Query', zonesPerStatusCount: Array<{ __typename?: 'ZoneStatusCount', status: string, count: number }> };

export type WorkflowStagesAndZonesQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type WorkflowStagesAndZonesQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string, name: string, orderInWorkflow: number, stageType: StageType } | null> | null } | null, zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, pausedBy?: PausedBy | null, state?: ZoneState | null, difficultyLevel?: DifficultyLevel | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null }> };

export type CreateWorkflowStageMutationVariables = Exact<{
  input?: InputMaybe<CreateWorkflowStageInput>;
}>;


export type CreateWorkflowStageMutation = { __typename?: 'Mutation', createWorkflowStage?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string, name: string, orderInWorkflow: number, stageType: StageType } | null> | null } | null };

export type UpdateWorkflowStageMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowStageInput>;
}>;


export type UpdateWorkflowStageMutation = { __typename?: 'Mutation', updateWorkflowStage?: { __typename?: 'Structure', workflowStages?: Array<{ __typename?: 'WorkflowStages', id: string, name: string, orderInWorkflow: number, stageType: StageType } | null> | null } | null };

export type ZonesForStructureQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesForStructureQuery = { __typename?: 'Query', zonesForStructure: Array<{ __typename?: 'Zone', id: string, name: string, status: ZoneStatus, structureId: string, totalParts?: number | null, totalPoints?: number | null, totalSphericals?: number | null, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null }> };

export type ZoneAndHistoriesForZoneManagementQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZoneAndHistoriesForZoneManagementQuery = { __typename?: 'Query', zonesAndHistoriesFor: Array<{ __typename?: 'ZoneAndHistory', _id: string, name: string, status?: ZoneStatus | null, structureId: string, totalParts?: number | null, totalPoints?: number | null, totalSphericals?: number | null, histories?: Array<{ __typename?: 'History', id: string, createdBy: string, eventName: string, document: any, collectionName: string, createdAt: string, createdByName: string, createdByDetails?: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } | null } | null> | null, box: { __typename?: 'Box', min: { __typename?: 'Vector3', x: number, y: number, z: number }, max: { __typename?: 'Vector3', x: number, y: number, z: number } }, workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, pausedBy?: PausedBy | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null }> };

export type UpdateZoneStatusMutationVariables = Exact<{
  input?: InputMaybe<UpdateZoneStatusInput>;
}>;


export type UpdateZoneStatusMutation = { __typename?: 'Mutation', updateZoneStatus: { __typename?: 'ZoneUpdate', createdBy: string, currentStatus: ZoneStatus, prevStatus: ZoneStatus, referenceId: string } };

export type UpdateWorkflowTimeAndStateMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowTimeAndStateInput>;
}>;


export type UpdateWorkflowTimeAndStateMutation = { __typename?: 'Mutation', updateWorkflowTimeAndState?: { __typename?: 'Zone', workflowStatus?: { __typename?: 'WorkflowStatus', workflowStageId: string, state?: ZoneState | null, difficultyLevel?: DifficultyLevel | null, totalTime?: any | null, idleTime?: any | null, trackedTime?: any | null, assignedToUser?: { __typename?: 'User', id: string, name?: string | null, email: string, picture?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null } | null } | null };

export type ZonesForStructureCsvQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ZonesForStructureCsvQuery = { __typename?: 'Query', zonesForStructureCSV: string };

export type SphericalsPerZoneQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SphericalsPerZoneQuery = { __typename?: 'Query', sphericalsPerZone?: Array<{ __typename?: 'SphericalsPerZone', totalSphericals: number, zoneId: string }> | null };

export type AllUsersForZonesQueryVariables = Exact<{
  pageInfo?: InputMaybe<PageInfo>;
  input?: InputMaybe<FilterForUsers>;
}>;


export type AllUsersForZonesQuery = { __typename?: 'Query', allUsers: Array<{ __typename?: 'User', id: string, email: string, picture?: string | null, name?: string | null, roleIds: Array<{ __typename?: 'Role', id: string, name: string } | null> }> };

export type AssignZoneToUserMutationVariables = Exact<{
  input?: InputMaybe<UpdateWorkflowStatusInput>;
}>;


export type AssignZoneToUserMutation = { __typename?: 'Mutation', updateWorkflowStatus?: Array<{ __typename?: 'Zone', id: string } | null> | null };

export type GetAssemblyServiceAndPipeSpecQueryVariables = Exact<{
  assemblyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAssemblyServiceAndPipeSpecQuery = { __typename?: 'Query', assembly?: { __typename?: 'Assembly', id: string, service?: { __typename?: 'Service', group: string, code?: string | null } | null, pipeSpec?: { __typename?: 'PipeSpec', spec?: string | null } | null } | null };

export type GetStructureNameQueryVariables = Exact<{
  structureId: Scalars['String']['input'];
}>;


export type GetStructureNameQuery = { __typename?: 'Query', structure?: { __typename?: 'Structure', id: string, name: string } | null };

export type GetAllStructuresListForBreadcrumbQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllStructuresListForBreadcrumbQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, status: StructureStatus }> };

export type AllCommentsGenericQueryVariables = Exact<{
  input?: InputMaybe<AllCommentsInput>;
}>;


export type AllCommentsGenericQuery = { __typename?: 'Query', allComments?: Array<{ __typename?: 'Comment', id: string, text: string, isEdited: boolean, status?: ZoneStatus | null, updatedAt: string, structureId: any, createdBy: string, createdAt: string, collectionName: string, createdByDetails: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } }> | null };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'Comment', text: string, structureId: any, createdByDetails: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } } };

export type DeleteCommentMutationVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  commentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'Comment', id: string } };

export type CommentAddedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CommentAddedSubscription = { __typename?: 'Subscription', commentAdded: { __typename?: 'Comment', id: string, text: string, isEdited: boolean, status?: ZoneStatus | null, updatedAt: string, structureId: any, createdBy: string, createdAt: string, collectionName: string, createdByDetails: { __typename?: 'CreatedByDetails', name: string, profilePicture: string } } };

export type CommentDeletedSubscriptionVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CommentDeletedSubscription = { __typename?: 'Subscription', commentDeleted: { __typename?: 'Comment', id: string } };

export type DecksForDeckListQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DecksForDeckListQuery = { __typename?: 'Query', allDecks: Array<{ __typename?: 'Deck', id: string, name: string, resourcePath: string, heightRange: Array<number>, heightStep?: number | null }> };

export type GetActiveDeploymentForPlatformQueryVariables = Exact<{
  input: StructureFilters;
}>;


export type GetActiveDeploymentForPlatformQuery = { __typename?: 'Query', allStructures: Array<{ __typename?: 'Structure', id: string, name: string, isActive?: boolean | null, platform?: { __typename?: 'Platform', id: string } | null }> };

export type GetUserPreferencesForUnitSelectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPreferencesForUnitSelectionQuery = { __typename?: 'Query', getUserPreferences?: { __typename?: 'UserPreferences', unit?: UnitSystemEnum | null } | null };

export type UpdatePreferencesMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserPreferencesInput>;
}>;


export type UpdatePreferencesMutation = { __typename?: 'Mutation', updateUserPreferences?: { __typename?: 'User', preferences?: { __typename?: 'UserPreferences', unit?: UnitSystemEnum | null } | null } | null };

export type LocationQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, name: string, depthResourcePath?: string | null, depthResource?: string | null, resourcePath?: string | null, resource?: string | null, deck: { __typename?: 'Deck', id: string, name: string, resourcePath: string }, deckPlan?: { __typename?: 'LocationDeckPlan', id: string, coordinates: Array<number> } | null } | null };

export type GroupedReportsQueryVariables = Exact<{
  input?: InputMaybe<ReportsInput>;
}>;


export type GroupedReportsQuery = { __typename?: 'Query', groupedReports: Array<{ __typename?: 'GroupedReports', groupName: string, groupId: string, count: number } | null> };

export type CreateNewReportMutationVariables = Exact<{
  input?: InputMaybe<CreateNewReportInput>;
}>;


export type CreateNewReportMutation = { __typename?: 'Mutation', createNewReport: { __typename?: 'Report', createdAt: string, id?: string | null, name: string, status: ReportStatus, dueDate?: string | null, actionStatus?: ReportActionStatus | null, type?: ReportType | null, workpackNumber?: string | null } };

export type CreateBulkReportsMutationVariables = Exact<{
  input?: InputMaybe<CreateNewReportInput>;
}>;


export type CreateBulkReportsMutation = { __typename?: 'Mutation', createBulkReports: Array<{ __typename?: 'Report', createdAt: string, id?: string | null, name: string, status: ReportStatus, dueDate?: string | null, actionStatus?: ReportActionStatus | null, type?: ReportType | null, workpackNumber?: string | null } | null> };

export type GeneratePoiPdfMutationVariables = Exact<{
  reportIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GeneratePoiPdfMutation = { __typename?: 'Mutation', generatePoiPdf: { __typename?: 'PdfGenerationResult', base64Data?: Array<string | null> | null } };

export type FilteredOptionsQueryVariables = Exact<{
  templateId: Scalars['ID']['input'];
  fieldKey: Scalars['String']['input'];
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FilteredOptionsQuery = { __typename?: 'Query', filteredOptions: Array<{ __typename?: 'FilteredOptions', options: Array<string> }> };

export type AllPaintRegionsForFilterAndSearchPanelQueryVariables = Exact<{
  structureId?: InputMaybe<Scalars['ID']['input']>;
  deckIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AllPaintRegionsForFilterAndSearchPanelQuery = { __typename?: 'Query', allPaintRegions: Array<{ __typename?: 'PaintRegion', id: string, name: string, paintRegionGroupId?: string | null }> };

export type GetVersionsQueryVariables = Exact<{
  input?: InputMaybe<VersionInput>;
}>;


export type GetVersionsQuery = { __typename?: 'Query', allVersions: Array<{ __typename?: 'Version', id: string, structureId?: string | null, referenceId?: string | null, updatedData?: any | null, previousData?: any | null, collectionName: string, lastModifiedFor: string, lastModifiedBy?: string | null, createdAt: string, lastModifiedByUser?: { __typename?: 'User', id: string, name?: string | null, picture?: string | null, email: string, connection?: string | null, roleIds: Array<{ __typename?: 'Role', name: string, auth0Id: string, id: string } | null> } | null }> };

export type RollbackVersionMutationVariables = Exact<{
  input?: InputMaybe<RollbackVersionInput>;
}>;


export type RollbackVersionMutation = { __typename?: 'Mutation', rollbackVersion: { __typename?: 'Version', id: string } };

export const AssembliesFragmentDoc = gql`
    fragment assemblies on Assembly {
  pipeSpec {
    material
    nominalCorrosionAllowance
    nominalThickness
    schedule
    size
    spec
  }
  template {
    id
    name
    fields {
      id
      name
    }
  }
  templateFieldData
  service {
    group
  }
  id
  tagName
  area
  files {
    id
    name
    resourcePath
    type
    fileName
    uploadStatus
    imageType
    uuid
  }
}
    `;
export const PointOfInterestsFragmentDoc = gql`
    fragment pointOfInterests on PointOfInterest {
  id
  poiId
  name
  type
  accessibility
  workpackNumber
  workpack {
    id
    name
    status
  }
  isVerified
  status
  template {
    createdBy
    id
    name
    fields {
      id
      type
    }
  }
  templateData {
    templateFieldId
    value
    verifiedValue
    id
  }
  assembly {
    ...assemblies
  }
  paintRegion {
    name
    deck {
      name
      imageDimensions
      resourcePath
      cadTransform
    }
  }
  centerPoint3d {
    x
    y
    z
  }
  blister {
    wallLoss {
      percentage
      value
    }
    residualCorrosionAllowance {
      percentage
      value
    }
    maxHeight
    verifiedMaxHeight
    estimatedHeight
    pdrHeight
    heightType
    isManuallyOverridden
    fittingRadius
    manualSetHeight
    residualThickness {
      percentage
      value
    }
    verifiedResidualThickness
    radius
    radiusPoint {
      bearing
      elevation
    }
    centerPoint {
      bearing
      elevation
    }
    borders {
      bearing
      elevation
    }
  }
  screenshotPaths {
    viewpoint
    viewer
  }
  location {
    deck {
      name
      imageDimensions
      resourcePath
      cadTransform
    }
  }
  files {
    id
    name
    resourcePath
    type
    fileName
    uploadStatus
    imageType
    uuid
  }
  deckRelativeHeight
}
    ${AssembliesFragmentDoc}`;
export const TemplatesFragmentDoc = gql`
    fragment templates on PointOfInterestTemplate {
  createdBy
  fields {
    id
    isReadOnly
    isRequired
    isHidden
    name
    options
    type
  }
  id
  name
}
    `;
export const AllDecksForDeckPlanExplorerDocument = gql`
    query AllDecksForDeckPlanExplorer($structureId: ID) {
  allDecks(structureId: $structureId) {
    id
    name
    resourcePath
    heightRange
    heightStep
  }
}
    `;

/**
 * __useAllDecksForDeckPlanExplorerQuery__
 *
 * To run a query within a React component, call `useAllDecksForDeckPlanExplorerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDecksForDeckPlanExplorerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDecksForDeckPlanExplorerQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllDecksForDeckPlanExplorerQuery(baseOptions?: Apollo.QueryHookOptions<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>(AllDecksForDeckPlanExplorerDocument, options);
      }
export function useAllDecksForDeckPlanExplorerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>(AllDecksForDeckPlanExplorerDocument, options);
        }
export function useAllDecksForDeckPlanExplorerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>(AllDecksForDeckPlanExplorerDocument, options);
        }
export type AllDecksForDeckPlanExplorerQueryHookResult = ReturnType<typeof useAllDecksForDeckPlanExplorerQuery>;
export type AllDecksForDeckPlanExplorerLazyQueryHookResult = ReturnType<typeof useAllDecksForDeckPlanExplorerLazyQuery>;
export type AllDecksForDeckPlanExplorerSuspenseQueryHookResult = ReturnType<typeof useAllDecksForDeckPlanExplorerSuspenseQuery>;
export type AllDecksForDeckPlanExplorerQueryResult = Apollo.QueryResult<AllDecksForDeckPlanExplorerQuery, AllDecksForDeckPlanExplorerQueryVariables>;
export const FetchSpatialHeatmapDocument = gql`
    query FetchSpatialHeatmap($heatmapParameters: SpatialHeatmapInput) {
  fetchSpatialHeatmap(heatmapParameters: $heatmapParameters) {
    svg
  }
}
    `;

/**
 * __useFetchSpatialHeatmapQuery__
 *
 * To run a query within a React component, call `useFetchSpatialHeatmapQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSpatialHeatmapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSpatialHeatmapQuery({
 *   variables: {
 *      heatmapParameters: // value for 'heatmapParameters'
 *   },
 * });
 */
export function useFetchSpatialHeatmapQuery(baseOptions?: Apollo.QueryHookOptions<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>(FetchSpatialHeatmapDocument, options);
      }
export function useFetchSpatialHeatmapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>(FetchSpatialHeatmapDocument, options);
        }
export function useFetchSpatialHeatmapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>(FetchSpatialHeatmapDocument, options);
        }
export type FetchSpatialHeatmapQueryHookResult = ReturnType<typeof useFetchSpatialHeatmapQuery>;
export type FetchSpatialHeatmapLazyQueryHookResult = ReturnType<typeof useFetchSpatialHeatmapLazyQuery>;
export type FetchSpatialHeatmapSuspenseQueryHookResult = ReturnType<typeof useFetchSpatialHeatmapSuspenseQuery>;
export type FetchSpatialHeatmapQueryResult = Apollo.QueryResult<FetchSpatialHeatmapQuery, FetchSpatialHeatmapQueryVariables>;
export const AllDefectsInDeckDocument = gql`
    query AllDefectsInDeck($structureId: ID) {
  allDefects(structureId: $structureId) {
    key
    name
  }
}
    `;

/**
 * __useAllDefectsInDeckQuery__
 *
 * To run a query within a React component, call `useAllDefectsInDeckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDefectsInDeckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDefectsInDeckQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllDefectsInDeckQuery(baseOptions?: Apollo.QueryHookOptions<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>(AllDefectsInDeckDocument, options);
      }
export function useAllDefectsInDeckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>(AllDefectsInDeckDocument, options);
        }
export function useAllDefectsInDeckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>(AllDefectsInDeckDocument, options);
        }
export type AllDefectsInDeckQueryHookResult = ReturnType<typeof useAllDefectsInDeckQuery>;
export type AllDefectsInDeckLazyQueryHookResult = ReturnType<typeof useAllDefectsInDeckLazyQuery>;
export type AllDefectsInDeckSuspenseQueryHookResult = ReturnType<typeof useAllDefectsInDeckSuspenseQuery>;
export type AllDefectsInDeckQueryResult = Apollo.QueryResult<AllDefectsInDeckQuery, AllDefectsInDeckQueryVariables>;
export const AllLocationsForAssemblyForDeckPlanDocument = gql`
    query AllLocationsForAssemblyForDeckPlan($input: LocationsForAssemblyInput) {
  allLocationsForAssembly(input: $input) {
    id
    resource
    resourcePath
    depthResourcePath
    name
    deckPlan {
      id
      coordinates
    }
    deck {
      name
    }
    distance
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
    videoResourcePath
    videoTimestamp
    pose {
      yaw
      yawOffset
      z
      y
      x
      roll
      pitch
    }
  }
}
    `;

/**
 * __useAllLocationsForAssemblyForDeckPlanQuery__
 *
 * To run a query within a React component, call `useAllLocationsForAssemblyForDeckPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllLocationsForAssemblyForDeckPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllLocationsForAssemblyForDeckPlanQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllLocationsForAssemblyForDeckPlanQuery(baseOptions?: Apollo.QueryHookOptions<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>(AllLocationsForAssemblyForDeckPlanDocument, options);
      }
export function useAllLocationsForAssemblyForDeckPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>(AllLocationsForAssemblyForDeckPlanDocument, options);
        }
export function useAllLocationsForAssemblyForDeckPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>(AllLocationsForAssemblyForDeckPlanDocument, options);
        }
export type AllLocationsForAssemblyForDeckPlanQueryHookResult = ReturnType<typeof useAllLocationsForAssemblyForDeckPlanQuery>;
export type AllLocationsForAssemblyForDeckPlanLazyQueryHookResult = ReturnType<typeof useAllLocationsForAssemblyForDeckPlanLazyQuery>;
export type AllLocationsForAssemblyForDeckPlanSuspenseQueryHookResult = ReturnType<typeof useAllLocationsForAssemblyForDeckPlanSuspenseQuery>;
export type AllLocationsForAssemblyForDeckPlanQueryResult = Apollo.QueryResult<AllLocationsForAssemblyForDeckPlanQuery, AllLocationsForAssemblyForDeckPlanQueryVariables>;
export const AllPaintRegionsForDeckPlanDocument = gql`
    query AllPaintRegionsForDeckPlan($deckIds: [String]) {
  allPaintRegions(deckIds: $deckIds) {
    id
    name
    polygons {
      area
      points
      type
    }
  }
}
    `;

/**
 * __useAllPaintRegionsForDeckPlanQuery__
 *
 * To run a query within a React component, call `useAllPaintRegionsForDeckPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaintRegionsForDeckPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaintRegionsForDeckPlanQuery({
 *   variables: {
 *      deckIds: // value for 'deckIds'
 *   },
 * });
 */
export function useAllPaintRegionsForDeckPlanQuery(baseOptions?: Apollo.QueryHookOptions<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>(AllPaintRegionsForDeckPlanDocument, options);
      }
export function useAllPaintRegionsForDeckPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>(AllPaintRegionsForDeckPlanDocument, options);
        }
export function useAllPaintRegionsForDeckPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>(AllPaintRegionsForDeckPlanDocument, options);
        }
export type AllPaintRegionsForDeckPlanQueryHookResult = ReturnType<typeof useAllPaintRegionsForDeckPlanQuery>;
export type AllPaintRegionsForDeckPlanLazyQueryHookResult = ReturnType<typeof useAllPaintRegionsForDeckPlanLazyQuery>;
export type AllPaintRegionsForDeckPlanSuspenseQueryHookResult = ReturnType<typeof useAllPaintRegionsForDeckPlanSuspenseQuery>;
export type AllPaintRegionsForDeckPlanQueryResult = Apollo.QueryResult<AllPaintRegionsForDeckPlanQuery, AllPaintRegionsForDeckPlanQueryVariables>;
export const DefectLegendsDeckSummaryDocument = gql`
    query DefectLegendsDeckSummary($structureId: String) {
  structure(structureId: $structureId) {
    defectLegends {
      id
      name
      color
      groupName
      groupKey
      octreeKey
      octreeValue
      legendText
    }
    id
    name
  }
}
    `;

/**
 * __useDefectLegendsDeckSummaryQuery__
 *
 * To run a query within a React component, call `useDefectLegendsDeckSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectLegendsDeckSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectLegendsDeckSummaryQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDefectLegendsDeckSummaryQuery(baseOptions?: Apollo.QueryHookOptions<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>(DefectLegendsDeckSummaryDocument, options);
      }
export function useDefectLegendsDeckSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>(DefectLegendsDeckSummaryDocument, options);
        }
export function useDefectLegendsDeckSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>(DefectLegendsDeckSummaryDocument, options);
        }
export type DefectLegendsDeckSummaryQueryHookResult = ReturnType<typeof useDefectLegendsDeckSummaryQuery>;
export type DefectLegendsDeckSummaryLazyQueryHookResult = ReturnType<typeof useDefectLegendsDeckSummaryLazyQuery>;
export type DefectLegendsDeckSummarySuspenseQueryHookResult = ReturnType<typeof useDefectLegendsDeckSummarySuspenseQuery>;
export type DefectLegendsDeckSummaryQueryResult = Apollo.QueryResult<DefectLegendsDeckSummaryQuery, DefectLegendsDeckSummaryQueryVariables>;
export const AssembliesDecksSummaryDocument = gql`
    query AssembliesDecksSummary($input: AssembliesFilterInput) {
  getAssembliesDecksSummary(input: $input) {
    deckId
    totalArea
  }
}
    `;

/**
 * __useAssembliesDecksSummaryQuery__
 *
 * To run a query within a React component, call `useAssembliesDecksSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssembliesDecksSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssembliesDecksSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssembliesDecksSummaryQuery(baseOptions?: Apollo.QueryHookOptions<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>(AssembliesDecksSummaryDocument, options);
      }
export function useAssembliesDecksSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>(AssembliesDecksSummaryDocument, options);
        }
export function useAssembliesDecksSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>(AssembliesDecksSummaryDocument, options);
        }
export type AssembliesDecksSummaryQueryHookResult = ReturnType<typeof useAssembliesDecksSummaryQuery>;
export type AssembliesDecksSummaryLazyQueryHookResult = ReturnType<typeof useAssembliesDecksSummaryLazyQuery>;
export type AssembliesDecksSummarySuspenseQueryHookResult = ReturnType<typeof useAssembliesDecksSummarySuspenseQuery>;
export type AssembliesDecksSummaryQueryResult = Apollo.QueryResult<AssembliesDecksSummaryQuery, AssembliesDecksSummaryQueryVariables>;
export const AllPointOfInterestsForDecksDocument = gql`
    query AllPointOfInterestsForDecks($structureId: ID, $selectedTemplateFilters: [FiltersInput]) {
  allPointOfInterestTemplate(structureId: $structureId) {
    id
    name
    type
  }
  allPointOfInterests(
    structureId: $structureId
    selectedTemplateFilters: $selectedTemplateFilters
  ) {
    template {
      id
    }
    centerPoint3d {
      x
      y
    }
    paintRegion {
      deck {
        id
        cadTransform
      }
    }
  }
}
    `;

/**
 * __useAllPointOfInterestsForDecksQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestsForDecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestsForDecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestsForDecksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      selectedTemplateFilters: // value for 'selectedTemplateFilters'
 *   },
 * });
 */
export function useAllPointOfInterestsForDecksQuery(baseOptions?: Apollo.QueryHookOptions<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>(AllPointOfInterestsForDecksDocument, options);
      }
export function useAllPointOfInterestsForDecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>(AllPointOfInterestsForDecksDocument, options);
        }
export function useAllPointOfInterestsForDecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>(AllPointOfInterestsForDecksDocument, options);
        }
export type AllPointOfInterestsForDecksQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDecksQuery>;
export type AllPointOfInterestsForDecksLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDecksLazyQuery>;
export type AllPointOfInterestsForDecksSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDecksSuspenseQuery>;
export type AllPointOfInterestsForDecksQueryResult = Apollo.QueryResult<AllPointOfInterestsForDecksQuery, AllPointOfInterestsForDecksQueryVariables>;
export const ValidateIdmsFileDocument = gql`
    query ValidateIdmsFile($input: ValidateIdmsTemplateQueryInput!) {
  validateIdmsTemplate(input: $input)
}
    `;

/**
 * __useValidateIdmsFileQuery__
 *
 * To run a query within a React component, call `useValidateIdmsFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateIdmsFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateIdmsFileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateIdmsFileQuery(baseOptions: Apollo.QueryHookOptions<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables> & ({ variables: ValidateIdmsFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>(ValidateIdmsFileDocument, options);
      }
export function useValidateIdmsFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>(ValidateIdmsFileDocument, options);
        }
export function useValidateIdmsFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>(ValidateIdmsFileDocument, options);
        }
export type ValidateIdmsFileQueryHookResult = ReturnType<typeof useValidateIdmsFileQuery>;
export type ValidateIdmsFileLazyQueryHookResult = ReturnType<typeof useValidateIdmsFileLazyQuery>;
export type ValidateIdmsFileSuspenseQueryHookResult = ReturnType<typeof useValidateIdmsFileSuspenseQuery>;
export type ValidateIdmsFileQueryResult = Apollo.QueryResult<ValidateIdmsFileQuery, ValidateIdmsFileQueryVariables>;
export const IdmsFileUploadDocument = gql`
    mutation IdmsFileUpload($input: IdmsUploadMutationInput!) {
  idmsFileUpload(input: $input) {
    name
    filePath
  }
}
    `;
export type IdmsFileUploadMutationFn = Apollo.MutationFunction<IdmsFileUploadMutation, IdmsFileUploadMutationVariables>;

/**
 * __useIdmsFileUploadMutation__
 *
 * To run a mutation, you first call `useIdmsFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIdmsFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [idmsFileUploadMutation, { data, loading, error }] = useIdmsFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIdmsFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<IdmsFileUploadMutation, IdmsFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IdmsFileUploadMutation, IdmsFileUploadMutationVariables>(IdmsFileUploadDocument, options);
      }
export type IdmsFileUploadMutationHookResult = ReturnType<typeof useIdmsFileUploadMutation>;
export type IdmsFileUploadMutationResult = Apollo.MutationResult<IdmsFileUploadMutation>;
export type IdmsFileUploadMutationOptions = Apollo.BaseMutationOptions<IdmsFileUploadMutation, IdmsFileUploadMutationVariables>;
export const IdmsUploadsDocument = gql`
    query IdmsUploads($structureId: ID) {
  idmsUploads(structureId: $structureId) {
    id
    name
    templateType
    createdAt
    filePath
  }
}
    `;

/**
 * __useIdmsUploadsQuery__
 *
 * To run a query within a React component, call `useIdmsUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdmsUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdmsUploadsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useIdmsUploadsQuery(baseOptions?: Apollo.QueryHookOptions<IdmsUploadsQuery, IdmsUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdmsUploadsQuery, IdmsUploadsQueryVariables>(IdmsUploadsDocument, options);
      }
export function useIdmsUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdmsUploadsQuery, IdmsUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdmsUploadsQuery, IdmsUploadsQueryVariables>(IdmsUploadsDocument, options);
        }
export function useIdmsUploadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdmsUploadsQuery, IdmsUploadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdmsUploadsQuery, IdmsUploadsQueryVariables>(IdmsUploadsDocument, options);
        }
export type IdmsUploadsQueryHookResult = ReturnType<typeof useIdmsUploadsQuery>;
export type IdmsUploadsLazyQueryHookResult = ReturnType<typeof useIdmsUploadsLazyQuery>;
export type IdmsUploadsSuspenseQueryHookResult = ReturnType<typeof useIdmsUploadsSuspenseQuery>;
export type IdmsUploadsQueryResult = Apollo.QueryResult<IdmsUploadsQuery, IdmsUploadsQueryVariables>;
export const IdmsTasksDocument = gql`
    query IdmsTasks($structureId: ID!, $pageInfo: PageInfo) {
  idmsTasks(structureId: $structureId, pageInfo: $pageInfo) {
    count
    tasks {
      id
      idmsTaskNumber
      taskDueDate
      createdAt
      lineNumber
      recommendations {
        id
        lineNumber
        recommendationNumber
        recommendationType
        status
        statusUpdatedAt
        workOrders {
          id
          lineNumber
          poiName
          recommendationNumber
          status
          statusUpdatedAt
          workOrderNumber
        }
      }
      status
      statusUpdatedAt
    }
  }
}
    `;

/**
 * __useIdmsTasksQuery__
 *
 * To run a query within a React component, call `useIdmsTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdmsTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdmsTasksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useIdmsTasksQuery(baseOptions: Apollo.QueryHookOptions<IdmsTasksQuery, IdmsTasksQueryVariables> & ({ variables: IdmsTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdmsTasksQuery, IdmsTasksQueryVariables>(IdmsTasksDocument, options);
      }
export function useIdmsTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdmsTasksQuery, IdmsTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdmsTasksQuery, IdmsTasksQueryVariables>(IdmsTasksDocument, options);
        }
export function useIdmsTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdmsTasksQuery, IdmsTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdmsTasksQuery, IdmsTasksQueryVariables>(IdmsTasksDocument, options);
        }
export type IdmsTasksQueryHookResult = ReturnType<typeof useIdmsTasksQuery>;
export type IdmsTasksLazyQueryHookResult = ReturnType<typeof useIdmsTasksLazyQuery>;
export type IdmsTasksSuspenseQueryHookResult = ReturnType<typeof useIdmsTasksSuspenseQuery>;
export type IdmsTasksQueryResult = Apollo.QueryResult<IdmsTasksQuery, IdmsTasksQueryVariables>;
export const LatestIdmsUploadsByTypeDocument = gql`
    query LatestIdmsUploadsByType($structureId: ID) {
  latestIdmsUploadsByType(structureId: $structureId) {
    name
    createdAt
    templateType
    filePath
  }
}
    `;

/**
 * __useLatestIdmsUploadsByTypeQuery__
 *
 * To run a query within a React component, call `useLatestIdmsUploadsByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestIdmsUploadsByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestIdmsUploadsByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useLatestIdmsUploadsByTypeQuery(baseOptions?: Apollo.QueryHookOptions<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>(LatestIdmsUploadsByTypeDocument, options);
      }
export function useLatestIdmsUploadsByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>(LatestIdmsUploadsByTypeDocument, options);
        }
export function useLatestIdmsUploadsByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>(LatestIdmsUploadsByTypeDocument, options);
        }
export type LatestIdmsUploadsByTypeQueryHookResult = ReturnType<typeof useLatestIdmsUploadsByTypeQuery>;
export type LatestIdmsUploadsByTypeLazyQueryHookResult = ReturnType<typeof useLatestIdmsUploadsByTypeLazyQuery>;
export type LatestIdmsUploadsByTypeSuspenseQueryHookResult = ReturnType<typeof useLatestIdmsUploadsByTypeSuspenseQuery>;
export type LatestIdmsUploadsByTypeQueryResult = Apollo.QueryResult<LatestIdmsUploadsByTypeQuery, LatestIdmsUploadsByTypeQueryVariables>;
export const BulkPipeSpecUploadDocument = gql`
    mutation BulkPipeSpecUpload($input: BulkPipeSpecUploadInput!) {
  bulkPipeSpecUpload(input: $input) {
    message
    onlyValidated
    updatedCount
  }
}
    `;
export type BulkPipeSpecUploadMutationFn = Apollo.MutationFunction<BulkPipeSpecUploadMutation, BulkPipeSpecUploadMutationVariables>;

/**
 * __useBulkPipeSpecUploadMutation__
 *
 * To run a mutation, you first call `useBulkPipeSpecUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkPipeSpecUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkPipeSpecUploadMutation, { data, loading, error }] = useBulkPipeSpecUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkPipeSpecUploadMutation(baseOptions?: Apollo.MutationHookOptions<BulkPipeSpecUploadMutation, BulkPipeSpecUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkPipeSpecUploadMutation, BulkPipeSpecUploadMutationVariables>(BulkPipeSpecUploadDocument, options);
      }
export type BulkPipeSpecUploadMutationHookResult = ReturnType<typeof useBulkPipeSpecUploadMutation>;
export type BulkPipeSpecUploadMutationResult = Apollo.MutationResult<BulkPipeSpecUploadMutation>;
export type BulkPipeSpecUploadMutationOptions = Apollo.BaseMutationOptions<BulkPipeSpecUploadMutation, BulkPipeSpecUploadMutationVariables>;
export const BulkUploadServiceGroupsDocument = gql`
    mutation BulkUploadServiceGroups($input: BulkUploadServiceGroupsInput!) {
  bulkUploadServiceGroups(input: $input) {
    message
    updatedCount
  }
}
    `;
export type BulkUploadServiceGroupsMutationFn = Apollo.MutationFunction<BulkUploadServiceGroupsMutation, BulkUploadServiceGroupsMutationVariables>;

/**
 * __useBulkUploadServiceGroupsMutation__
 *
 * To run a mutation, you first call `useBulkUploadServiceGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadServiceGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadServiceGroupsMutation, { data, loading, error }] = useBulkUploadServiceGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUploadServiceGroupsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadServiceGroupsMutation, BulkUploadServiceGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadServiceGroupsMutation, BulkUploadServiceGroupsMutationVariables>(BulkUploadServiceGroupsDocument, options);
      }
export type BulkUploadServiceGroupsMutationHookResult = ReturnType<typeof useBulkUploadServiceGroupsMutation>;
export type BulkUploadServiceGroupsMutationResult = Apollo.MutationResult<BulkUploadServiceGroupsMutation>;
export type BulkUploadServiceGroupsMutationOptions = Apollo.BaseMutationOptions<BulkUploadServiceGroupsMutation, BulkUploadServiceGroupsMutationVariables>;
export const GetAssembliesByTemplateFieldsFiltersForEquipmentExportDocument = gql`
    query GetAssembliesByTemplateFieldsFiltersForEquipmentExport($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
  }
}
    `;

/**
 * __useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentExportDocument, options);
      }
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentExportDocument, options);
        }
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentExportDocument, options);
        }
export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportLazyQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentExportLazyQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentExportSuspenseQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryResult = Apollo.QueryResult<GetAssembliesByTemplateFieldsFiltersForEquipmentExportQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentExportQueryVariables>;
export const AllDecksDocument = gql`
    query AllDecks($structureId: ID) {
  allDecks(structureId: $structureId) {
    id
    name
  }
}
    `;

/**
 * __useAllDecksQuery__
 *
 * To run a query within a React component, call `useAllDecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDecksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllDecksQuery(baseOptions?: Apollo.QueryHookOptions<AllDecksQuery, AllDecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDecksQuery, AllDecksQueryVariables>(AllDecksDocument, options);
      }
export function useAllDecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDecksQuery, AllDecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDecksQuery, AllDecksQueryVariables>(AllDecksDocument, options);
        }
export function useAllDecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDecksQuery, AllDecksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDecksQuery, AllDecksQueryVariables>(AllDecksDocument, options);
        }
export type AllDecksQueryHookResult = ReturnType<typeof useAllDecksQuery>;
export type AllDecksLazyQueryHookResult = ReturnType<typeof useAllDecksLazyQuery>;
export type AllDecksSuspenseQueryHookResult = ReturnType<typeof useAllDecksSuspenseQuery>;
export type AllDecksQueryResult = Apollo.QueryResult<AllDecksQuery, AllDecksQueryVariables>;
export const DecksWithDefectsDocument = gql`
    query DecksWithDefects($structureId: ID) {
  allDefects(structureId: $structureId) {
    key
    name
  }
  decksWithDefects(structureId: $structureId) {
    id
    name
    defectArea {
      key
      area
    }
  }
}
    `;

/**
 * __useDecksWithDefectsQuery__
 *
 * To run a query within a React component, call `useDecksWithDefectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecksWithDefectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecksWithDefectsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDecksWithDefectsQuery(baseOptions?: Apollo.QueryHookOptions<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>(DecksWithDefectsDocument, options);
      }
export function useDecksWithDefectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>(DecksWithDefectsDocument, options);
        }
export function useDecksWithDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>(DecksWithDefectsDocument, options);
        }
export type DecksWithDefectsQueryHookResult = ReturnType<typeof useDecksWithDefectsQuery>;
export type DecksWithDefectsLazyQueryHookResult = ReturnType<typeof useDecksWithDefectsLazyQuery>;
export type DecksWithDefectsSuspenseQueryHookResult = ReturnType<typeof useDecksWithDefectsSuspenseQuery>;
export type DecksWithDefectsQueryResult = Apollo.QueryResult<DecksWithDefectsQuery, DecksWithDefectsQueryVariables>;
export const UpdatePaintRegionStatusDocument = gql`
    mutation UpdatePaintRegionStatus($input: UpdatePaintRegionStatusInput) {
  updatePaintRegionStatus(input: $input) {
    status
    remediationDate
  }
}
    `;
export type UpdatePaintRegionStatusMutationFn = Apollo.MutationFunction<UpdatePaintRegionStatusMutation, UpdatePaintRegionStatusMutationVariables>;

/**
 * __useUpdatePaintRegionStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePaintRegionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaintRegionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaintRegionStatusMutation, { data, loading, error }] = useUpdatePaintRegionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaintRegionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaintRegionStatusMutation, UpdatePaintRegionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaintRegionStatusMutation, UpdatePaintRegionStatusMutationVariables>(UpdatePaintRegionStatusDocument, options);
      }
export type UpdatePaintRegionStatusMutationHookResult = ReturnType<typeof useUpdatePaintRegionStatusMutation>;
export type UpdatePaintRegionStatusMutationResult = Apollo.MutationResult<UpdatePaintRegionStatusMutation>;
export type UpdatePaintRegionStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePaintRegionStatusMutation, UpdatePaintRegionStatusMutationVariables>;
export const UpdatePointOfInterestsStatusDocument = gql`
    mutation UpdatePointOfInterestsStatus($input: UpdatePointOfInterestsStatusInput!) {
  updatePointOfInterestsStatus(input: $input)
}
    `;
export type UpdatePointOfInterestsStatusMutationFn = Apollo.MutationFunction<UpdatePointOfInterestsStatusMutation, UpdatePointOfInterestsStatusMutationVariables>;

/**
 * __useUpdatePointOfInterestsStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestsStatusMutation, { data, loading, error }] = useUpdatePointOfInterestsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestsStatusMutation, UpdatePointOfInterestsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestsStatusMutation, UpdatePointOfInterestsStatusMutationVariables>(UpdatePointOfInterestsStatusDocument, options);
      }
export type UpdatePointOfInterestsStatusMutationHookResult = ReturnType<typeof useUpdatePointOfInterestsStatusMutation>;
export type UpdatePointOfInterestsStatusMutationResult = Apollo.MutationResult<UpdatePointOfInterestsStatusMutation>;
export type UpdatePointOfInterestsStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestsStatusMutation, UpdatePointOfInterestsStatusMutationVariables>;
export const AllPaintRegionsForPaintBlockTableDocument = gql`
    query AllPaintRegionsForPaintBlockTable($structureId: ID) {
  allPaintRegions(structureId: $structureId) {
    id
    name
    status
    remediationDate
    paintRegionGroup {
      id
      name
    }
  }
}
    `;

/**
 * __useAllPaintRegionsForPaintBlockTableQuery__
 *
 * To run a query within a React component, call `useAllPaintRegionsForPaintBlockTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaintRegionsForPaintBlockTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaintRegionsForPaintBlockTableQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllPaintRegionsForPaintBlockTableQuery(baseOptions?: Apollo.QueryHookOptions<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>(AllPaintRegionsForPaintBlockTableDocument, options);
      }
export function useAllPaintRegionsForPaintBlockTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>(AllPaintRegionsForPaintBlockTableDocument, options);
        }
export function useAllPaintRegionsForPaintBlockTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>(AllPaintRegionsForPaintBlockTableDocument, options);
        }
export type AllPaintRegionsForPaintBlockTableQueryHookResult = ReturnType<typeof useAllPaintRegionsForPaintBlockTableQuery>;
export type AllPaintRegionsForPaintBlockTableLazyQueryHookResult = ReturnType<typeof useAllPaintRegionsForPaintBlockTableLazyQuery>;
export type AllPaintRegionsForPaintBlockTableSuspenseQueryHookResult = ReturnType<typeof useAllPaintRegionsForPaintBlockTableSuspenseQuery>;
export type AllPaintRegionsForPaintBlockTableQueryResult = Apollo.QueryResult<AllPaintRegionsForPaintBlockTableQuery, AllPaintRegionsForPaintBlockTableQueryVariables>;
export const DefectsAreaAndPointOfInterestCountByPaintRegionsDocument = gql`
    query DefectsAreaAndPointOfInterestCountByPaintRegions($input: PaintBlockFiltersInput!) {
  defectsAreaForAssemblyPaintRegions(input: $input) {
    structureIds
    defectsByDeck {
      name
      deckIds
      totalArea {
        type
        value
      }
    }
    defectsByPaintBlock {
      name
      paintRegionIds
      totalArea {
        type
        value
      }
    }
  }
  pointOfInterestCountByPaintRegions(input: $input) {
    structureIds
    findingsByDeck {
      name
      pointOfInterestFindings {
        type
        count
      }
      totalCount
    }
    findingsByPaintBlock {
      name
      pointOfInterestFindings {
        type
        count
      }
      totalCount
    }
  }
}
    `;

/**
 * __useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery__
 *
 * To run a query within a React component, call `useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery(baseOptions: Apollo.QueryHookOptions<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables> & ({ variables: DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>(DefectsAreaAndPointOfInterestCountByPaintRegionsDocument, options);
      }
export function useDefectsAreaAndPointOfInterestCountByPaintRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>(DefectsAreaAndPointOfInterestCountByPaintRegionsDocument, options);
        }
export function useDefectsAreaAndPointOfInterestCountByPaintRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>(DefectsAreaAndPointOfInterestCountByPaintRegionsDocument, options);
        }
export type DefectsAreaAndPointOfInterestCountByPaintRegionsQueryHookResult = ReturnType<typeof useDefectsAreaAndPointOfInterestCountByPaintRegionsQuery>;
export type DefectsAreaAndPointOfInterestCountByPaintRegionsLazyQueryHookResult = ReturnType<typeof useDefectsAreaAndPointOfInterestCountByPaintRegionsLazyQuery>;
export type DefectsAreaAndPointOfInterestCountByPaintRegionsSuspenseQueryHookResult = ReturnType<typeof useDefectsAreaAndPointOfInterestCountByPaintRegionsSuspenseQuery>;
export type DefectsAreaAndPointOfInterestCountByPaintRegionsQueryResult = Apollo.QueryResult<DefectsAreaAndPointOfInterestCountByPaintRegionsQuery, DefectsAreaAndPointOfInterestCountByPaintRegionsQueryVariables>;
export const DefectsAreaForCustomBlocksDocument = gql`
    query DefectsAreaForCustomBlocks($input: PaintBlockFiltersInput!, $pageInfo: PageInfo) {
  defectsAreaForAssemblyPaintRegionsByGroup(input: $input, pageInfo: $pageInfo) {
    structureId
    defectsByPaintBlock {
      name
      paintRegionId
      totalArea {
        value
        type
      }
      totalCountByPoiType {
        type
        value
      }
    }
    totalCount
  }
}
    `;

/**
 * __useDefectsAreaForCustomBlocksQuery__
 *
 * To run a query within a React component, call `useDefectsAreaForCustomBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectsAreaForCustomBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectsAreaForCustomBlocksQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useDefectsAreaForCustomBlocksQuery(baseOptions: Apollo.QueryHookOptions<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables> & ({ variables: DefectsAreaForCustomBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>(DefectsAreaForCustomBlocksDocument, options);
      }
export function useDefectsAreaForCustomBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>(DefectsAreaForCustomBlocksDocument, options);
        }
export function useDefectsAreaForCustomBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>(DefectsAreaForCustomBlocksDocument, options);
        }
export type DefectsAreaForCustomBlocksQueryHookResult = ReturnType<typeof useDefectsAreaForCustomBlocksQuery>;
export type DefectsAreaForCustomBlocksLazyQueryHookResult = ReturnType<typeof useDefectsAreaForCustomBlocksLazyQuery>;
export type DefectsAreaForCustomBlocksSuspenseQueryHookResult = ReturnType<typeof useDefectsAreaForCustomBlocksSuspenseQuery>;
export type DefectsAreaForCustomBlocksQueryResult = Apollo.QueryResult<DefectsAreaForCustomBlocksQuery, DefectsAreaForCustomBlocksQueryVariables>;
export const RiskRemidiationTrendAnalyticsDocument = gql`
    query RiskRemidiationTrendAnalytics($input: AnalyticsFiltersInput) {
  analytics(input: $input) {
    data
    id
    structureIds
    displayConfig
  }
}
    `;

/**
 * __useRiskRemidiationTrendAnalyticsQuery__
 *
 * To run a query within a React component, call `useRiskRemidiationTrendAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRiskRemidiationTrendAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRiskRemidiationTrendAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRiskRemidiationTrendAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<RiskRemidiationTrendAnalyticsQuery, RiskRemidiationTrendAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RiskRemidiationTrendAnalyticsQuery, RiskRemidiationTrendAnalyticsQueryVariables>(RiskRemidiationTrendAnalyticsDocument, options);
      }
export function useRiskRemidiationTrendAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RiskRemidiationTrendAnalyticsQuery, RiskRemidiationTrendAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RiskRemidiationTrendAnalyticsQuery, RiskRemidiationTrendAnalyticsQueryVariables>(RiskRemidiationTrendAnalyticsDocument, options);
        }
export function useRiskRemidiationTrendAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RiskRemidiationTrendAnalyticsQuery, RiskRemidiationTrendAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RiskRemidiationTrendAnalyticsQuery, RiskRemidiationTrendAnalyticsQueryVariables>(RiskRemidiationTrendAnalyticsDocument, options);
        }
export type RiskRemidiationTrendAnalyticsQueryHookResult = ReturnType<typeof useRiskRemidiationTrendAnalyticsQuery>;
export type RiskRemidiationTrendAnalyticsLazyQueryHookResult = ReturnType<typeof useRiskRemidiationTrendAnalyticsLazyQuery>;
export type RiskRemidiationTrendAnalyticsSuspenseQueryHookResult = ReturnType<typeof useRiskRemidiationTrendAnalyticsSuspenseQuery>;
export type RiskRemidiationTrendAnalyticsQueryResult = Apollo.QueryResult<RiskRemidiationTrendAnalyticsQuery, RiskRemidiationTrendAnalyticsQueryVariables>;
export const PointOfInterestsCountByDueDateDocument = gql`
    query PointOfInterestsCountByDueDate($input: PointOfInterestMultiStructureInput) {
  pointOfInterestsCountByDueDate(input: $input) {
    count
    key
  }
}
    `;

/**
 * __usePointOfInterestsCountByDueDateQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountByDueDateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountByDueDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountByDueDateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountByDueDateQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>(PointOfInterestsCountByDueDateDocument, options);
      }
export function usePointOfInterestsCountByDueDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>(PointOfInterestsCountByDueDateDocument, options);
        }
export function usePointOfInterestsCountByDueDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>(PointOfInterestsCountByDueDateDocument, options);
        }
export type PointOfInterestsCountByDueDateQueryHookResult = ReturnType<typeof usePointOfInterestsCountByDueDateQuery>;
export type PointOfInterestsCountByDueDateLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountByDueDateLazyQuery>;
export type PointOfInterestsCountByDueDateSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountByDueDateSuspenseQuery>;
export type PointOfInterestsCountByDueDateQueryResult = Apollo.QueryResult<PointOfInterestsCountByDueDateQuery, PointOfInterestsCountByDueDateQueryVariables>;
export const PaintDamageCountByAlarmLevelDocument = gql`
    query PaintDamageCountByAlarmLevel($input: PointOfInterestMultiStructureInput) {
  paintDamageCountByAlarmLevel(input: $input) {
    key
    count
  }
}
    `;

/**
 * __usePaintDamageCountByAlarmLevelQuery__
 *
 * To run a query within a React component, call `usePaintDamageCountByAlarmLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintDamageCountByAlarmLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintDamageCountByAlarmLevelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaintDamageCountByAlarmLevelQuery(baseOptions?: Apollo.QueryHookOptions<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>(PaintDamageCountByAlarmLevelDocument, options);
      }
export function usePaintDamageCountByAlarmLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>(PaintDamageCountByAlarmLevelDocument, options);
        }
export function usePaintDamageCountByAlarmLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>(PaintDamageCountByAlarmLevelDocument, options);
        }
export type PaintDamageCountByAlarmLevelQueryHookResult = ReturnType<typeof usePaintDamageCountByAlarmLevelQuery>;
export type PaintDamageCountByAlarmLevelLazyQueryHookResult = ReturnType<typeof usePaintDamageCountByAlarmLevelLazyQuery>;
export type PaintDamageCountByAlarmLevelSuspenseQueryHookResult = ReturnType<typeof usePaintDamageCountByAlarmLevelSuspenseQuery>;
export type PaintDamageCountByAlarmLevelQueryResult = Apollo.QueryResult<PaintDamageCountByAlarmLevelQuery, PaintDamageCountByAlarmLevelQueryVariables>;
export const PointOfInterestsCountByInspectionPriorityDocument = gql`
    query PointOfInterestsCountByInspectionPriority($input: PointOfInterestInput) {
  pointOfInterestsCountByInspectionPriority(input: $input) {
    count
    key
  }
}
    `;

/**
 * __usePointOfInterestsCountByInspectionPriorityQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountByInspectionPriorityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountByInspectionPriorityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountByInspectionPriorityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountByInspectionPriorityQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>(PointOfInterestsCountByInspectionPriorityDocument, options);
      }
export function usePointOfInterestsCountByInspectionPriorityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>(PointOfInterestsCountByInspectionPriorityDocument, options);
        }
export function usePointOfInterestsCountByInspectionPrioritySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>(PointOfInterestsCountByInspectionPriorityDocument, options);
        }
export type PointOfInterestsCountByInspectionPriorityQueryHookResult = ReturnType<typeof usePointOfInterestsCountByInspectionPriorityQuery>;
export type PointOfInterestsCountByInspectionPriorityLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountByInspectionPriorityLazyQuery>;
export type PointOfInterestsCountByInspectionPrioritySuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountByInspectionPrioritySuspenseQuery>;
export type PointOfInterestsCountByInspectionPriorityQueryResult = Apollo.QueryResult<PointOfInterestsCountByInspectionPriorityQuery, PointOfInterestsCountByInspectionPriorityQueryVariables>;
export const PointOfInterestsCountByStatusDocument = gql`
    query PointOfInterestsCountByStatus($input: PointOfInterestMultiStructureInput) {
  pointOfInterestsCountByStatus(input: $input) {
    key
    count
  }
}
    `;

/**
 * __usePointOfInterestsCountByStatusQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountByStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountByStatusQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>(PointOfInterestsCountByStatusDocument, options);
      }
export function usePointOfInterestsCountByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>(PointOfInterestsCountByStatusDocument, options);
        }
export function usePointOfInterestsCountByStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>(PointOfInterestsCountByStatusDocument, options);
        }
export type PointOfInterestsCountByStatusQueryHookResult = ReturnType<typeof usePointOfInterestsCountByStatusQuery>;
export type PointOfInterestsCountByStatusLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountByStatusLazyQuery>;
export type PointOfInterestsCountByStatusSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountByStatusSuspenseQuery>;
export type PointOfInterestsCountByStatusQueryResult = Apollo.QueryResult<PointOfInterestsCountByStatusQuery, PointOfInterestsCountByStatusQueryVariables>;
export const PoiWorkflowDocument = gql`
    query POIWorkflow($input: PointOfInterestInput, $pageInfo: PageInfo) {
  pointOfInterests(input: $input, pageInfo: $pageInfo) {
    id
    name
    status
    assignee
    dueDate
    visibility
    accessibility
    comment
    isAutoGenerated
    linkedPointOfInterestIds
    accessibility
    poiId
    workpackNumber
  }
  pointOfInterestsCount(input: $input) {
    count
  }
}
    `;

/**
 * __usePoiWorkflowQuery__
 *
 * To run a query within a React component, call `usePoiWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoiWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoiWorkflowQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function usePoiWorkflowQuery(baseOptions?: Apollo.QueryHookOptions<PoiWorkflowQuery, PoiWorkflowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PoiWorkflowQuery, PoiWorkflowQueryVariables>(PoiWorkflowDocument, options);
      }
export function usePoiWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoiWorkflowQuery, PoiWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PoiWorkflowQuery, PoiWorkflowQueryVariables>(PoiWorkflowDocument, options);
        }
export function usePoiWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PoiWorkflowQuery, PoiWorkflowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PoiWorkflowQuery, PoiWorkflowQueryVariables>(PoiWorkflowDocument, options);
        }
export type PoiWorkflowQueryHookResult = ReturnType<typeof usePoiWorkflowQuery>;
export type PoiWorkflowLazyQueryHookResult = ReturnType<typeof usePoiWorkflowLazyQuery>;
export type PoiWorkflowSuspenseQueryHookResult = ReturnType<typeof usePoiWorkflowSuspenseQuery>;
export type PoiWorkflowQueryResult = Apollo.QueryResult<PoiWorkflowQuery, PoiWorkflowQueryVariables>;
export const AllWorkpacksDocument = gql`
    query AllWorkpacks($structureId: String, $hasPois: Boolean) {
  allWorkpacks(structureId: $structureId, hasPois: $hasPois) {
    id
    name
  }
}
    `;

/**
 * __useAllWorkpacksQuery__
 *
 * To run a query within a React component, call `useAllWorkpacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWorkpacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWorkpacksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      hasPois: // value for 'hasPois'
 *   },
 * });
 */
export function useAllWorkpacksQuery(baseOptions?: Apollo.QueryHookOptions<AllWorkpacksQuery, AllWorkpacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllWorkpacksQuery, AllWorkpacksQueryVariables>(AllWorkpacksDocument, options);
      }
export function useAllWorkpacksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWorkpacksQuery, AllWorkpacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllWorkpacksQuery, AllWorkpacksQueryVariables>(AllWorkpacksDocument, options);
        }
export function useAllWorkpacksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorkpacksQuery, AllWorkpacksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllWorkpacksQuery, AllWorkpacksQueryVariables>(AllWorkpacksDocument, options);
        }
export type AllWorkpacksQueryHookResult = ReturnType<typeof useAllWorkpacksQuery>;
export type AllWorkpacksLazyQueryHookResult = ReturnType<typeof useAllWorkpacksLazyQuery>;
export type AllWorkpacksSuspenseQueryHookResult = ReturnType<typeof useAllWorkpacksSuspenseQuery>;
export type AllWorkpacksQueryResult = Apollo.QueryResult<AllWorkpacksQuery, AllWorkpacksQueryVariables>;
export const DeleteWorkpackDocument = gql`
    mutation DeleteWorkpack($input: DeleteWorkpackInput) {
  deleteWorkpack(input: $input) {
    id
    name
  }
}
    `;
export type DeleteWorkpackMutationFn = Apollo.MutationFunction<DeleteWorkpackMutation, DeleteWorkpackMutationVariables>;

/**
 * __useDeleteWorkpackMutation__
 *
 * To run a mutation, you first call `useDeleteWorkpackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkpackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkpackMutation, { data, loading, error }] = useDeleteWorkpackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkpackMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkpackMutation, DeleteWorkpackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkpackMutation, DeleteWorkpackMutationVariables>(DeleteWorkpackDocument, options);
      }
export type DeleteWorkpackMutationHookResult = ReturnType<typeof useDeleteWorkpackMutation>;
export type DeleteWorkpackMutationResult = Apollo.MutationResult<DeleteWorkpackMutation>;
export type DeleteWorkpackMutationOptions = Apollo.BaseMutationOptions<DeleteWorkpackMutation, DeleteWorkpackMutationVariables>;
export const RemoveWorkpackIdFromPointOfInterestsDocument = gql`
    mutation RemoveWorkpackIdFromPointOfInterests($input: InputGroupByWorkpackId) {
  RemoveWorkpackIdFromPointOfInterests(input: $input) {
    name
  }
}
    `;
export type RemoveWorkpackIdFromPointOfInterestsMutationFn = Apollo.MutationFunction<RemoveWorkpackIdFromPointOfInterestsMutation, RemoveWorkpackIdFromPointOfInterestsMutationVariables>;

/**
 * __useRemoveWorkpackIdFromPointOfInterestsMutation__
 *
 * To run a mutation, you first call `useRemoveWorkpackIdFromPointOfInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkpackIdFromPointOfInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkpackIdFromPointOfInterestsMutation, { data, loading, error }] = useRemoveWorkpackIdFromPointOfInterestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveWorkpackIdFromPointOfInterestsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWorkpackIdFromPointOfInterestsMutation, RemoveWorkpackIdFromPointOfInterestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWorkpackIdFromPointOfInterestsMutation, RemoveWorkpackIdFromPointOfInterestsMutationVariables>(RemoveWorkpackIdFromPointOfInterestsDocument, options);
      }
export type RemoveWorkpackIdFromPointOfInterestsMutationHookResult = ReturnType<typeof useRemoveWorkpackIdFromPointOfInterestsMutation>;
export type RemoveWorkpackIdFromPointOfInterestsMutationResult = Apollo.MutationResult<RemoveWorkpackIdFromPointOfInterestsMutation>;
export type RemoveWorkpackIdFromPointOfInterestsMutationOptions = Apollo.BaseMutationOptions<RemoveWorkpackIdFromPointOfInterestsMutation, RemoveWorkpackIdFromPointOfInterestsMutationVariables>;
export const CreateWorkpackDocument = gql`
    mutation CreateWorkpack($input: CreateWorkpackInput) {
  createWorkpack(input: $input) {
    name
    id
  }
}
    `;
export type CreateWorkpackMutationFn = Apollo.MutationFunction<CreateWorkpackMutation, CreateWorkpackMutationVariables>;

/**
 * __useCreateWorkpackMutation__
 *
 * To run a mutation, you first call `useCreateWorkpackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkpackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkpackMutation, { data, loading, error }] = useCreateWorkpackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkpackMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkpackMutation, CreateWorkpackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkpackMutation, CreateWorkpackMutationVariables>(CreateWorkpackDocument, options);
      }
export type CreateWorkpackMutationHookResult = ReturnType<typeof useCreateWorkpackMutation>;
export type CreateWorkpackMutationResult = Apollo.MutationResult<CreateWorkpackMutation>;
export type CreateWorkpackMutationOptions = Apollo.BaseMutationOptions<CreateWorkpackMutation, CreateWorkpackMutationVariables>;
export const UpdateWorkpackDocument = gql`
    mutation UpdateWorkpack($input: UpdateWorkpackInput) {
  updateWorkpack(input: $input) {
    id
    name
  }
}
    `;
export type UpdateWorkpackMutationFn = Apollo.MutationFunction<UpdateWorkpackMutation, UpdateWorkpackMutationVariables>;

/**
 * __useUpdateWorkpackMutation__
 *
 * To run a mutation, you first call `useUpdateWorkpackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkpackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkpackMutation, { data, loading, error }] = useUpdateWorkpackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkpackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkpackMutation, UpdateWorkpackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkpackMutation, UpdateWorkpackMutationVariables>(UpdateWorkpackDocument, options);
      }
export type UpdateWorkpackMutationHookResult = ReturnType<typeof useUpdateWorkpackMutation>;
export type UpdateWorkpackMutationResult = Apollo.MutationResult<UpdateWorkpackMutation>;
export type UpdateWorkpackMutationOptions = Apollo.BaseMutationOptions<UpdateWorkpackMutation, UpdateWorkpackMutationVariables>;
export const UpdateWorkpackStatusDocument = gql`
    mutation UpdateWorkpackStatus($workpackId: ID!, $status: WorkpackStatus!) {
  updateWorkpackStatus(workpackId: $workpackId, status: $status) {
    status
  }
}
    `;
export type UpdateWorkpackStatusMutationFn = Apollo.MutationFunction<UpdateWorkpackStatusMutation, UpdateWorkpackStatusMutationVariables>;

/**
 * __useUpdateWorkpackStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWorkpackStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkpackStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkpackStatusMutation, { data, loading, error }] = useUpdateWorkpackStatusMutation({
 *   variables: {
 *      workpackId: // value for 'workpackId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateWorkpackStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkpackStatusMutation, UpdateWorkpackStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkpackStatusMutation, UpdateWorkpackStatusMutationVariables>(UpdateWorkpackStatusDocument, options);
      }
export type UpdateWorkpackStatusMutationHookResult = ReturnType<typeof useUpdateWorkpackStatusMutation>;
export type UpdateWorkpackStatusMutationResult = Apollo.MutationResult<UpdateWorkpackStatusMutation>;
export type UpdateWorkpackStatusMutationOptions = Apollo.BaseMutationOptions<UpdateWorkpackStatusMutation, UpdateWorkpackStatusMutationVariables>;
export const GroupPointOfInterestsByWorkpackIdDocument = gql`
    mutation GroupPointOfInterestsByWorkpackId($input: InputGroupByWorkpackId) {
  GroupPointOfInterestsByWorkpackId(input: $input) {
    poiId
  }
}
    `;
export type GroupPointOfInterestsByWorkpackIdMutationFn = Apollo.MutationFunction<GroupPointOfInterestsByWorkpackIdMutation, GroupPointOfInterestsByWorkpackIdMutationVariables>;

/**
 * __useGroupPointOfInterestsByWorkpackIdMutation__
 *
 * To run a mutation, you first call `useGroupPointOfInterestsByWorkpackIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupPointOfInterestsByWorkpackIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupPointOfInterestsByWorkpackIdMutation, { data, loading, error }] = useGroupPointOfInterestsByWorkpackIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupPointOfInterestsByWorkpackIdMutation(baseOptions?: Apollo.MutationHookOptions<GroupPointOfInterestsByWorkpackIdMutation, GroupPointOfInterestsByWorkpackIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupPointOfInterestsByWorkpackIdMutation, GroupPointOfInterestsByWorkpackIdMutationVariables>(GroupPointOfInterestsByWorkpackIdDocument, options);
      }
export type GroupPointOfInterestsByWorkpackIdMutationHookResult = ReturnType<typeof useGroupPointOfInterestsByWorkpackIdMutation>;
export type GroupPointOfInterestsByWorkpackIdMutationResult = Apollo.MutationResult<GroupPointOfInterestsByWorkpackIdMutation>;
export type GroupPointOfInterestsByWorkpackIdMutationOptions = Apollo.BaseMutationOptions<GroupPointOfInterestsByWorkpackIdMutation, GroupPointOfInterestsByWorkpackIdMutationVariables>;
export const GetPointOfInterestGroupedByWorkpackDocument = gql`
    query GetPointOfInterestGroupedByWorkpack($input: PointOfInterestInput, $pageInfo: PageInfo) {
  allWorkpacks: GetPointOfInterestGroupedByWorkpack(
    input: $input
    pageInfo: $pageInfo
  ) {
    _id
    workpack {
      name
      status
    }
    verifiedPointOfInterestsCount
    pointOfInterestsCount
    assembliesCount
  }
  workpacksCount: GetPointOfInterestGroupedByWorkpackCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetPointOfInterestGroupedByWorkpackQuery__
 *
 * To run a query within a React component, call `useGetPointOfInterestGroupedByWorkpackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointOfInterestGroupedByWorkpackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointOfInterestGroupedByWorkpackQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetPointOfInterestGroupedByWorkpackQuery(baseOptions?: Apollo.QueryHookOptions<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>(GetPointOfInterestGroupedByWorkpackDocument, options);
      }
export function useGetPointOfInterestGroupedByWorkpackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>(GetPointOfInterestGroupedByWorkpackDocument, options);
        }
export function useGetPointOfInterestGroupedByWorkpackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>(GetPointOfInterestGroupedByWorkpackDocument, options);
        }
export type GetPointOfInterestGroupedByWorkpackQueryHookResult = ReturnType<typeof useGetPointOfInterestGroupedByWorkpackQuery>;
export type GetPointOfInterestGroupedByWorkpackLazyQueryHookResult = ReturnType<typeof useGetPointOfInterestGroupedByWorkpackLazyQuery>;
export type GetPointOfInterestGroupedByWorkpackSuspenseQueryHookResult = ReturnType<typeof useGetPointOfInterestGroupedByWorkpackSuspenseQuery>;
export type GetPointOfInterestGroupedByWorkpackQueryResult = Apollo.QueryResult<GetPointOfInterestGroupedByWorkpackQuery, GetPointOfInterestGroupedByWorkpackQueryVariables>;
export const AllPointOfInterestsDocument = gql`
    query AllPointOfInterests($structureId: ID, $assemblyIds: [ID]) {
  allPointOfInterests(structureId: $structureId, assemblyIds: $assemblyIds) {
    id
    name
    assembly {
      tagName
      id
    }
    template {
      id
    }
    templateData {
      id
      value
    }
    workpack {
      id
      name
      status
    }
  }
}
    `;

/**
 * __useAllPointOfInterestsQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      assemblyIds: // value for 'assemblyIds'
 *   },
 * });
 */
export function useAllPointOfInterestsQuery(baseOptions?: Apollo.QueryHookOptions<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>(AllPointOfInterestsDocument, options);
      }
export function useAllPointOfInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>(AllPointOfInterestsDocument, options);
        }
export function useAllPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>(AllPointOfInterestsDocument, options);
        }
export type AllPointOfInterestsQueryHookResult = ReturnType<typeof useAllPointOfInterestsQuery>;
export type AllPointOfInterestsLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestsLazyQuery>;
export type AllPointOfInterestsSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestsSuspenseQuery>;
export type AllPointOfInterestsQueryResult = Apollo.QueryResult<AllPointOfInterestsQuery, AllPointOfInterestsQueryVariables>;
export const UpdateReportByPointOfInterestsDocument = gql`
    mutation updateReportByPointOfInterests($input: updateReportByPointOfInterestsInput) {
  updateReportByPointOfInterests(input: $input) {
    createdAt
    id
    name
    status
  }
}
    `;
export type UpdateReportByPointOfInterestsMutationFn = Apollo.MutationFunction<UpdateReportByPointOfInterestsMutation, UpdateReportByPointOfInterestsMutationVariables>;

/**
 * __useUpdateReportByPointOfInterestsMutation__
 *
 * To run a mutation, you first call `useUpdateReportByPointOfInterestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportByPointOfInterestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportByPointOfInterestsMutation, { data, loading, error }] = useUpdateReportByPointOfInterestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportByPointOfInterestsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportByPointOfInterestsMutation, UpdateReportByPointOfInterestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportByPointOfInterestsMutation, UpdateReportByPointOfInterestsMutationVariables>(UpdateReportByPointOfInterestsDocument, options);
      }
export type UpdateReportByPointOfInterestsMutationHookResult = ReturnType<typeof useUpdateReportByPointOfInterestsMutation>;
export type UpdateReportByPointOfInterestsMutationResult = Apollo.MutationResult<UpdateReportByPointOfInterestsMutation>;
export type UpdateReportByPointOfInterestsMutationOptions = Apollo.BaseMutationOptions<UpdateReportByPointOfInterestsMutation, UpdateReportByPointOfInterestsMutationVariables>;
export const UpdatePointOfInterestVisibilityDocument = gql`
    mutation UpdatePointOfInterestVisibility($input: UpdatePointOfInterestVisibilityInput, $filters: PointOfInterestInput) {
  updatePointOfInterestVisibility(input: $input, filters: $filters) {
    id
  }
}
    `;
export type UpdatePointOfInterestVisibilityMutationFn = Apollo.MutationFunction<UpdatePointOfInterestVisibilityMutation, UpdatePointOfInterestVisibilityMutationVariables>;

/**
 * __useUpdatePointOfInterestVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestVisibilityMutation, { data, loading, error }] = useUpdatePointOfInterestVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useUpdatePointOfInterestVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestVisibilityMutation, UpdatePointOfInterestVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestVisibilityMutation, UpdatePointOfInterestVisibilityMutationVariables>(UpdatePointOfInterestVisibilityDocument, options);
      }
export type UpdatePointOfInterestVisibilityMutationHookResult = ReturnType<typeof useUpdatePointOfInterestVisibilityMutation>;
export type UpdatePointOfInterestVisibilityMutationResult = Apollo.MutationResult<UpdatePointOfInterestVisibilityMutation>;
export type UpdatePointOfInterestVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestVisibilityMutation, UpdatePointOfInterestVisibilityMutationVariables>;
export const GetUserPreferencesDocument = gql`
    query GetUserPreferences {
  getUserPreferences {
    structure
  }
}
    `;

/**
 * __useGetUserPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
      }
export function useGetUserPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
        }
export function useGetUserPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>(GetUserPreferencesDocument, options);
        }
export type GetUserPreferencesQueryHookResult = ReturnType<typeof useGetUserPreferencesQuery>;
export type GetUserPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserPreferencesLazyQuery>;
export type GetUserPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetUserPreferencesSuspenseQuery>;
export type GetUserPreferencesQueryResult = Apollo.QueryResult<GetUserPreferencesQuery, GetUserPreferencesQueryVariables>;
export const PointOfInterestsCountByTypeDocument = gql`
    query PointOfInterestsCountByType($input: PointOfInterestInput) {
  pointOfInterestsCountByType(input: $input) {
    count
    type
  }
}
    `;

/**
 * __usePointOfInterestsCountByTypeQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountByTypeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountByTypeQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>(PointOfInterestsCountByTypeDocument, options);
      }
export function usePointOfInterestsCountByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>(PointOfInterestsCountByTypeDocument, options);
        }
export function usePointOfInterestsCountByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>(PointOfInterestsCountByTypeDocument, options);
        }
export type PointOfInterestsCountByTypeQueryHookResult = ReturnType<typeof usePointOfInterestsCountByTypeQuery>;
export type PointOfInterestsCountByTypeLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountByTypeLazyQuery>;
export type PointOfInterestsCountByTypeSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountByTypeSuspenseQuery>;
export type PointOfInterestsCountByTypeQueryResult = Apollo.QueryResult<PointOfInterestsCountByTypeQuery, PointOfInterestsCountByTypeQueryVariables>;
export const UpdateUserColumnPreferencesDocument = gql`
    mutation UpdateUserColumnPreferences($input: UpdateUserColumnPreferencesInput) {
  updateUserColumnPreferences(input: $input) {
    preferences {
      structure
    }
  }
}
    `;
export type UpdateUserColumnPreferencesMutationFn = Apollo.MutationFunction<UpdateUserColumnPreferencesMutation, UpdateUserColumnPreferencesMutationVariables>;

/**
 * __useUpdateUserColumnPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserColumnPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserColumnPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserColumnPreferencesMutation, { data, loading, error }] = useUpdateUserColumnPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserColumnPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserColumnPreferencesMutation, UpdateUserColumnPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserColumnPreferencesMutation, UpdateUserColumnPreferencesMutationVariables>(UpdateUserColumnPreferencesDocument, options);
      }
export type UpdateUserColumnPreferencesMutationHookResult = ReturnType<typeof useUpdateUserColumnPreferencesMutation>;
export type UpdateUserColumnPreferencesMutationResult = Apollo.MutationResult<UpdateUserColumnPreferencesMutation>;
export type UpdateUserColumnPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserColumnPreferencesMutation, UpdateUserColumnPreferencesMutationVariables>;
export const CreateAssemblyDocument = gql`
    mutation createAssembly($input: CreateAssemblyInput) {
  createAssembly(input: $input) {
    name
    id
    defectsArray
    recommendation {
      header
      details {
        id
        fieldKey
      }
    }
    equipmentCard {
      id
      name
      type
      position
      fieldKey
      location
    }
    equipmentDetails {
      id
      name
      subType
      type
      fieldKey
      options {
        id
        name
        type
        fieldKey
      }
    }
    querySummary {
      name
      key
      operation
    }
    fields {
      isEditable
      editRoles
      options
      displayConfig {
        id
        type
        color {
          key
          value
        }
        isSortable
        sortType
      }
      id
      name
      key
      type
      serverSide
      permission
      displayInQuery
      displayInRisk
      roundToDecimal
      unit
      displayUnit
    }
  }
}
    `;
export type CreateAssemblyMutationFn = Apollo.MutationFunction<CreateAssemblyMutation, CreateAssemblyMutationVariables>;

/**
 * __useCreateAssemblyMutation__
 *
 * To run a mutation, you first call `useCreateAssemblyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssemblyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssemblyMutation, { data, loading, error }] = useCreateAssemblyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssemblyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssemblyMutation, CreateAssemblyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssemblyMutation, CreateAssemblyMutationVariables>(CreateAssemblyDocument, options);
      }
export type CreateAssemblyMutationHookResult = ReturnType<typeof useCreateAssemblyMutation>;
export type CreateAssemblyMutationResult = Apollo.MutationResult<CreateAssemblyMutation>;
export type CreateAssemblyMutationOptions = Apollo.BaseMutationOptions<CreateAssemblyMutation, CreateAssemblyMutationVariables>;
export const GetAllTemplatesByTypeDocument = gql`
    query getAllTemplatesByType($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    fields {
      options
      name
      type
      id
    }
    permissions
  }
}
    `;

/**
 * __useGetAllTemplatesByTypeQuery__
 *
 * To run a query within a React component, call `useGetAllTemplatesByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTemplatesByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTemplatesByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAllTemplatesByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables> & ({ variables: GetAllTemplatesByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>(GetAllTemplatesByTypeDocument, options);
      }
export function useGetAllTemplatesByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>(GetAllTemplatesByTypeDocument, options);
        }
export function useGetAllTemplatesByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>(GetAllTemplatesByTypeDocument, options);
        }
export type GetAllTemplatesByTypeQueryHookResult = ReturnType<typeof useGetAllTemplatesByTypeQuery>;
export type GetAllTemplatesByTypeLazyQueryHookResult = ReturnType<typeof useGetAllTemplatesByTypeLazyQuery>;
export type GetAllTemplatesByTypeSuspenseQueryHookResult = ReturnType<typeof useGetAllTemplatesByTypeSuspenseQuery>;
export type GetAllTemplatesByTypeQueryResult = Apollo.QueryResult<GetAllTemplatesByTypeQuery, GetAllTemplatesByTypeQueryVariables>;
export const GetStructureDeploymentLevelDocument = gql`
    query getStructureDeploymentLevel($structureId: String) {
  structure(structureId: $structureId) {
    deploymentLevel
  }
}
    `;

/**
 * __useGetStructureDeploymentLevelQuery__
 *
 * To run a query within a React component, call `useGetStructureDeploymentLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDeploymentLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDeploymentLevelQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDeploymentLevelQuery(baseOptions?: Apollo.QueryHookOptions<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>(GetStructureDeploymentLevelDocument, options);
      }
export function useGetStructureDeploymentLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>(GetStructureDeploymentLevelDocument, options);
        }
export function useGetStructureDeploymentLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>(GetStructureDeploymentLevelDocument, options);
        }
export type GetStructureDeploymentLevelQueryHookResult = ReturnType<typeof useGetStructureDeploymentLevelQuery>;
export type GetStructureDeploymentLevelLazyQueryHookResult = ReturnType<typeof useGetStructureDeploymentLevelLazyQuery>;
export type GetStructureDeploymentLevelSuspenseQueryHookResult = ReturnType<typeof useGetStructureDeploymentLevelSuspenseQuery>;
export type GetStructureDeploymentLevelQueryResult = Apollo.QueryResult<GetStructureDeploymentLevelQuery, GetStructureDeploymentLevelQueryVariables>;
export const GetAssembliesSummaryDocument = gql`
    query getAssembliesSummary($input: AssembliesFilterInput) {
  getAssembliesSummary(input: $input) {
    id
    name
    key
    operation
    displayType
    rowOrder
    displayConfig {
      fieldValue
      color
    }
    data
  }
}
    `;

/**
 * __useGetAssembliesSummaryQuery__
 *
 * To run a query within a React component, call `useGetAssembliesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssembliesSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>(GetAssembliesSummaryDocument, options);
      }
export function useGetAssembliesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>(GetAssembliesSummaryDocument, options);
        }
export function useGetAssembliesSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>(GetAssembliesSummaryDocument, options);
        }
export type GetAssembliesSummaryQueryHookResult = ReturnType<typeof useGetAssembliesSummaryQuery>;
export type GetAssembliesSummaryLazyQueryHookResult = ReturnType<typeof useGetAssembliesSummaryLazyQuery>;
export type GetAssembliesSummarySuspenseQueryHookResult = ReturnType<typeof useGetAssembliesSummarySuspenseQuery>;
export type GetAssembliesSummaryQueryResult = Apollo.QueryResult<GetAssembliesSummaryQuery, GetAssembliesSummaryQueryVariables>;
export const DecksWithPaintRegionsDataDocument = gql`
    query DecksWithPaintRegionsData($structureId: ID) {
  allDecks(structureId: $structureId) {
    id
    name
    resourcePath
    heightRange
    heightStep
  }
  allPaintRegions(structureId: $structureId) {
    id
    name
    deck {
      id
    }
  }
}
    `;

/**
 * __useDecksWithPaintRegionsDataQuery__
 *
 * To run a query within a React component, call `useDecksWithPaintRegionsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecksWithPaintRegionsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecksWithPaintRegionsDataQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDecksWithPaintRegionsDataQuery(baseOptions?: Apollo.QueryHookOptions<DecksWithPaintRegionsDataQuery, DecksWithPaintRegionsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecksWithPaintRegionsDataQuery, DecksWithPaintRegionsDataQueryVariables>(DecksWithPaintRegionsDataDocument, options);
      }
export function useDecksWithPaintRegionsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecksWithPaintRegionsDataQuery, DecksWithPaintRegionsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecksWithPaintRegionsDataQuery, DecksWithPaintRegionsDataQueryVariables>(DecksWithPaintRegionsDataDocument, options);
        }
export function useDecksWithPaintRegionsDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecksWithPaintRegionsDataQuery, DecksWithPaintRegionsDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecksWithPaintRegionsDataQuery, DecksWithPaintRegionsDataQueryVariables>(DecksWithPaintRegionsDataDocument, options);
        }
export type DecksWithPaintRegionsDataQueryHookResult = ReturnType<typeof useDecksWithPaintRegionsDataQuery>;
export type DecksWithPaintRegionsDataLazyQueryHookResult = ReturnType<typeof useDecksWithPaintRegionsDataLazyQuery>;
export type DecksWithPaintRegionsDataSuspenseQueryHookResult = ReturnType<typeof useDecksWithPaintRegionsDataSuspenseQuery>;
export type DecksWithPaintRegionsDataQueryResult = Apollo.QueryResult<DecksWithPaintRegionsDataQuery, DecksWithPaintRegionsDataQueryVariables>;
export const GetPaintblockTemplateDocument = gql`
    query getPaintblockTemplate($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    fields {
      options
      name
      type
      id
      isHidden
      isReadOnly
      defaultVisible
    }
  }
}
    `;

/**
 * __useGetPaintblockTemplateQuery__
 *
 * To run a query within a React component, call `useGetPaintblockTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaintblockTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaintblockTemplateQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPaintblockTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables> & ({ variables: GetPaintblockTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>(GetPaintblockTemplateDocument, options);
      }
export function useGetPaintblockTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>(GetPaintblockTemplateDocument, options);
        }
export function useGetPaintblockTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>(GetPaintblockTemplateDocument, options);
        }
export type GetPaintblockTemplateQueryHookResult = ReturnType<typeof useGetPaintblockTemplateQuery>;
export type GetPaintblockTemplateLazyQueryHookResult = ReturnType<typeof useGetPaintblockTemplateLazyQuery>;
export type GetPaintblockTemplateSuspenseQueryHookResult = ReturnType<typeof useGetPaintblockTemplateSuspenseQuery>;
export type GetPaintblockTemplateQueryResult = Apollo.QueryResult<GetPaintblockTemplateQuery, GetPaintblockTemplateQueryVariables>;
export const DefectLegendsForPaintBlockTableDocument = gql`
    query defectLegendsForPaintBlockTable($structureId: String) {
  structure(structureId: $structureId) {
    defectLegends {
      id
      name
      groupKey
      groupName
      color
    }
  }
}
    `;

/**
 * __useDefectLegendsForPaintBlockTableQuery__
 *
 * To run a query within a React component, call `useDefectLegendsForPaintBlockTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectLegendsForPaintBlockTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectLegendsForPaintBlockTableQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDefectLegendsForPaintBlockTableQuery(baseOptions?: Apollo.QueryHookOptions<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>(DefectLegendsForPaintBlockTableDocument, options);
      }
export function useDefectLegendsForPaintBlockTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>(DefectLegendsForPaintBlockTableDocument, options);
        }
export function useDefectLegendsForPaintBlockTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>(DefectLegendsForPaintBlockTableDocument, options);
        }
export type DefectLegendsForPaintBlockTableQueryHookResult = ReturnType<typeof useDefectLegendsForPaintBlockTableQuery>;
export type DefectLegendsForPaintBlockTableLazyQueryHookResult = ReturnType<typeof useDefectLegendsForPaintBlockTableLazyQuery>;
export type DefectLegendsForPaintBlockTableSuspenseQueryHookResult = ReturnType<typeof useDefectLegendsForPaintBlockTableSuspenseQuery>;
export type DefectLegendsForPaintBlockTableQueryResult = Apollo.QueryResult<DefectLegendsForPaintBlockTableQuery, DefectLegendsForPaintBlockTableQueryVariables>;
export const GetAnalysisStructureLocationsDocument = gql`
    query getAnalysisStructureLocations($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
    baseResourcePath
    scanKey
    layers {
      fileExt
      type
      displayName
    }
    videoResourcePath
    videoTimestamp
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
    deck {
      name
    }
  }
}
    `;

/**
 * __useGetAnalysisStructureLocationsQuery__
 *
 * To run a query within a React component, call `useGetAnalysisStructureLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysisStructureLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysisStructureLocationsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAnalysisStructureLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables> & ({ variables: GetAnalysisStructureLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>(GetAnalysisStructureLocationsDocument, options);
      }
export function useGetAnalysisStructureLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>(GetAnalysisStructureLocationsDocument, options);
        }
export function useGetAnalysisStructureLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>(GetAnalysisStructureLocationsDocument, options);
        }
export type GetAnalysisStructureLocationsQueryHookResult = ReturnType<typeof useGetAnalysisStructureLocationsQuery>;
export type GetAnalysisStructureLocationsLazyQueryHookResult = ReturnType<typeof useGetAnalysisStructureLocationsLazyQuery>;
export type GetAnalysisStructureLocationsSuspenseQueryHookResult = ReturnType<typeof useGetAnalysisStructureLocationsSuspenseQuery>;
export type GetAnalysisStructureLocationsQueryResult = Apollo.QueryResult<GetAnalysisStructureLocationsQuery, GetAnalysisStructureLocationsQueryVariables>;
export const GetStructureDataDocument = gql`
    query getStructureData($structureId: String!) {
  structure(structureId: $structureId) {
    hasRiskAssessment
    blisterHeightType
    isActive
    id
    name
    platform {
      id
    }
  }
}
    `;

/**
 * __useGetStructureDataQuery__
 *
 * To run a query within a React component, call `useGetStructureDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDataQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDataQuery(baseOptions: Apollo.QueryHookOptions<GetStructureDataQuery, GetStructureDataQueryVariables> & ({ variables: GetStructureDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDataQuery, GetStructureDataQueryVariables>(GetStructureDataDocument, options);
      }
export function useGetStructureDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDataQuery, GetStructureDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDataQuery, GetStructureDataQueryVariables>(GetStructureDataDocument, options);
        }
export function useGetStructureDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDataQuery, GetStructureDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDataQuery, GetStructureDataQueryVariables>(GetStructureDataDocument, options);
        }
export type GetStructureDataQueryHookResult = ReturnType<typeof useGetStructureDataQuery>;
export type GetStructureDataLazyQueryHookResult = ReturnType<typeof useGetStructureDataLazyQuery>;
export type GetStructureDataSuspenseQueryHookResult = ReturnType<typeof useGetStructureDataSuspenseQuery>;
export type GetStructureDataQueryResult = Apollo.QueryResult<GetStructureDataQuery, GetStructureDataQueryVariables>;
export const GetAssemblyByTagNameDocument = gql`
    query GetAssemblyByTagName($tagName: String!, $structureId: ID!) {
  assemblyByTagName(tagName: $tagName, structureId: $structureId) {
    id
  }
}
    `;

/**
 * __useGetAssemblyByTagNameQuery__
 *
 * To run a query within a React component, call `useGetAssemblyByTagNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyByTagNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyByTagNameQuery({
 *   variables: {
 *      tagName: // value for 'tagName'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAssemblyByTagNameQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables> & ({ variables: GetAssemblyByTagNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>(GetAssemblyByTagNameDocument, options);
      }
export function useGetAssemblyByTagNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>(GetAssemblyByTagNameDocument, options);
        }
export function useGetAssemblyByTagNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>(GetAssemblyByTagNameDocument, options);
        }
export type GetAssemblyByTagNameQueryHookResult = ReturnType<typeof useGetAssemblyByTagNameQuery>;
export type GetAssemblyByTagNameLazyQueryHookResult = ReturnType<typeof useGetAssemblyByTagNameLazyQuery>;
export type GetAssemblyByTagNameSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyByTagNameSuspenseQuery>;
export type GetAssemblyByTagNameQueryResult = Apollo.QueryResult<GetAssemblyByTagNameQuery, GetAssemblyByTagNameQueryVariables>;
export const UpdateWallLossFactorDocument = gql`
    mutation UpdateWallLossFactor($structureId: ID, $wallLossFactor: Int) {
  updateWallLossFactor(structureId: $structureId, wallLossFactor: $wallLossFactor)
}
    `;
export type UpdateWallLossFactorMutationFn = Apollo.MutationFunction<UpdateWallLossFactorMutation, UpdateWallLossFactorMutationVariables>;

/**
 * __useUpdateWallLossFactorMutation__
 *
 * To run a mutation, you first call `useUpdateWallLossFactorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWallLossFactorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWallLossFactorMutation, { data, loading, error }] = useUpdateWallLossFactorMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      wallLossFactor: // value for 'wallLossFactor'
 *   },
 * });
 */
export function useUpdateWallLossFactorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWallLossFactorMutation, UpdateWallLossFactorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWallLossFactorMutation, UpdateWallLossFactorMutationVariables>(UpdateWallLossFactorDocument, options);
      }
export type UpdateWallLossFactorMutationHookResult = ReturnType<typeof useUpdateWallLossFactorMutation>;
export type UpdateWallLossFactorMutationResult = Apollo.MutationResult<UpdateWallLossFactorMutation>;
export type UpdateWallLossFactorMutationOptions = Apollo.BaseMutationOptions<UpdateWallLossFactorMutation, UpdateWallLossFactorMutationVariables>;
export const AllReportsListDocument = gql`
    query AllReportsList($input: reportsInput) {
  allReports(input: $input) {
    internalType
    createdAt
    createdByUser {
      name
    }
    id
    name
    status
    actionStatus
    dueDate
    workpackNumber
    type
    pointOfInterests {
      id
      assembly {
        id
      }
    }
  }
}
    `;

/**
 * __useAllReportsListQuery__
 *
 * To run a query within a React component, call `useAllReportsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReportsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReportsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllReportsListQuery(baseOptions?: Apollo.QueryHookOptions<AllReportsListQuery, AllReportsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReportsListQuery, AllReportsListQueryVariables>(AllReportsListDocument, options);
      }
export function useAllReportsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReportsListQuery, AllReportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReportsListQuery, AllReportsListQueryVariables>(AllReportsListDocument, options);
        }
export function useAllReportsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllReportsListQuery, AllReportsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllReportsListQuery, AllReportsListQueryVariables>(AllReportsListDocument, options);
        }
export type AllReportsListQueryHookResult = ReturnType<typeof useAllReportsListQuery>;
export type AllReportsListLazyQueryHookResult = ReturnType<typeof useAllReportsListLazyQuery>;
export type AllReportsListSuspenseQueryHookResult = ReturnType<typeof useAllReportsListSuspenseQuery>;
export type AllReportsListQueryResult = Apollo.QueryResult<AllReportsListQuery, AllReportsListQueryVariables>;
export const UpdateReportDueDateDocument = gql`
    mutation UpdateReportDueDate($input: updateReportInput) {
  updateReport(input: $input) {
    id
    dueDate
  }
}
    `;
export type UpdateReportDueDateMutationFn = Apollo.MutationFunction<UpdateReportDueDateMutation, UpdateReportDueDateMutationVariables>;

/**
 * __useUpdateReportDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateReportDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportDueDateMutation, { data, loading, error }] = useUpdateReportDueDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportDueDateMutation, UpdateReportDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportDueDateMutation, UpdateReportDueDateMutationVariables>(UpdateReportDueDateDocument, options);
      }
export type UpdateReportDueDateMutationHookResult = ReturnType<typeof useUpdateReportDueDateMutation>;
export type UpdateReportDueDateMutationResult = Apollo.MutationResult<UpdateReportDueDateMutation>;
export type UpdateReportDueDateMutationOptions = Apollo.BaseMutationOptions<UpdateReportDueDateMutation, UpdateReportDueDateMutationVariables>;
export const UpdateReportActionStatusDocument = gql`
    mutation UpdateReportActionStatus($input: updateReportInput) {
  updateReport(input: $input) {
    id
    actionStatus
  }
}
    `;
export type UpdateReportActionStatusMutationFn = Apollo.MutationFunction<UpdateReportActionStatusMutation, UpdateReportActionStatusMutationVariables>;

/**
 * __useUpdateReportActionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateReportActionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportActionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportActionStatusMutation, { data, loading, error }] = useUpdateReportActionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportActionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportActionStatusMutation, UpdateReportActionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportActionStatusMutation, UpdateReportActionStatusMutationVariables>(UpdateReportActionStatusDocument, options);
      }
export type UpdateReportActionStatusMutationHookResult = ReturnType<typeof useUpdateReportActionStatusMutation>;
export type UpdateReportActionStatusMutationResult = Apollo.MutationResult<UpdateReportActionStatusMutation>;
export type UpdateReportActionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateReportActionStatusMutation, UpdateReportActionStatusMutationVariables>;
export const AllReportImagesDocument = gql`
    query AllReportImages($reportId: ID!) {
  allReportImages(reportId: $reportId) {
    pointOfInterestId
    selectedImages {
      name
      resourcePath
      type
      fileName
      id
      imageType
      uuid
    }
  }
}
    `;

/**
 * __useAllReportImagesQuery__
 *
 * To run a query within a React component, call `useAllReportImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReportImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReportImagesQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useAllReportImagesQuery(baseOptions: Apollo.QueryHookOptions<AllReportImagesQuery, AllReportImagesQueryVariables> & ({ variables: AllReportImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReportImagesQuery, AllReportImagesQueryVariables>(AllReportImagesDocument, options);
      }
export function useAllReportImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReportImagesQuery, AllReportImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReportImagesQuery, AllReportImagesQueryVariables>(AllReportImagesDocument, options);
        }
export function useAllReportImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllReportImagesQuery, AllReportImagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllReportImagesQuery, AllReportImagesQueryVariables>(AllReportImagesDocument, options);
        }
export type AllReportImagesQueryHookResult = ReturnType<typeof useAllReportImagesQuery>;
export type AllReportImagesLazyQueryHookResult = ReturnType<typeof useAllReportImagesLazyQuery>;
export type AllReportImagesSuspenseQueryHookResult = ReturnType<typeof useAllReportImagesSuspenseQuery>;
export type AllReportImagesQueryResult = Apollo.QueryResult<AllReportImagesQuery, AllReportImagesQueryVariables>;
export const ReportDetailsDocument = gql`
    query ReportDetails($input: reportInput) {
  report(input: $input) {
    createdAt
    createdByUser {
      name
      picture
    }
    id
    name
    status
    templateFieldData
    actionStatus
    dueDate
    internalType
    type
    paintRegion {
      name
      id
    }
    pointOfInterests {
      ...pointOfInterests
    }
    selectedPointOfInterestImages {
      pointOfInterestId
      selectedImages {
        name
        resourcePath
        type
        fileName
        id
        imageType
        uuid
        caption
      }
    }
    allPointOfInterestPdfs {
      pointOfInterestId
      selectedPdfs {
        file {
          name
          resourcePath
          fileName
          type
          uploadStatus
          id
        }
        selectedStatus
      }
    }
    files {
      fileName
      id
      name
      resourcePath
      size
      type
      uploadStatus
      imageType
      uuid
    }
    reportOrder {
      assemblyOrder
      poiOrder
    }
    components {
      ...assemblies
    }
    cviPois {
      ...pointOfInterests
    }
    gviPois {
      ...pointOfInterests
    }
  }
}
    ${PointOfInterestsFragmentDoc}
${AssembliesFragmentDoc}`;

/**
 * __useReportDetailsQuery__
 *
 * To run a query within a React component, call `useReportDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ReportDetailsQuery, ReportDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDetailsQuery, ReportDetailsQueryVariables>(ReportDetailsDocument, options);
      }
export function useReportDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDetailsQuery, ReportDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDetailsQuery, ReportDetailsQueryVariables>(ReportDetailsDocument, options);
        }
export function useReportDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDetailsQuery, ReportDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDetailsQuery, ReportDetailsQueryVariables>(ReportDetailsDocument, options);
        }
export type ReportDetailsQueryHookResult = ReturnType<typeof useReportDetailsQuery>;
export type ReportDetailsLazyQueryHookResult = ReturnType<typeof useReportDetailsLazyQuery>;
export type ReportDetailsSuspenseQueryHookResult = ReturnType<typeof useReportDetailsSuspenseQuery>;
export type ReportDetailsQueryResult = Apollo.QueryResult<ReportDetailsQuery, ReportDetailsQueryVariables>;
export const ReportPointOfInterestVerifiedDocument = gql`
    subscription ReportPointOfInterestVerified($reportId: ID) {
  reportPointOfInterestVerified(reportId: $reportId) {
    reportId
    pointOfInterest {
      id
      isVerified
      templateData {
        templateFieldId
        value
        verifiedValue
        id
      }
    }
  }
}
    `;

/**
 * __useReportPointOfInterestVerifiedSubscription__
 *
 * To run a query within a React component, call `useReportPointOfInterestVerifiedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReportPointOfInterestVerifiedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPointOfInterestVerifiedSubscription({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportPointOfInterestVerifiedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ReportPointOfInterestVerifiedSubscription, ReportPointOfInterestVerifiedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ReportPointOfInterestVerifiedSubscription, ReportPointOfInterestVerifiedSubscriptionVariables>(ReportPointOfInterestVerifiedDocument, options);
      }
export type ReportPointOfInterestVerifiedSubscriptionHookResult = ReturnType<typeof useReportPointOfInterestVerifiedSubscription>;
export type ReportPointOfInterestVerifiedSubscriptionResult = Apollo.SubscriptionResult<ReportPointOfInterestVerifiedSubscription>;
export const UpdateReportStatusDocument = gql`
    mutation UpdateReportStatus($input: updateReportStatusInput) {
  updateReportStatus(input: $input) {
    id
    status
  }
}
    `;
export type UpdateReportStatusMutationFn = Apollo.MutationFunction<UpdateReportStatusMutation, UpdateReportStatusMutationVariables>;

/**
 * __useUpdateReportStatusMutation__
 *
 * To run a mutation, you first call `useUpdateReportStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportStatusMutation, { data, loading, error }] = useUpdateReportStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportStatusMutation, UpdateReportStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportStatusMutation, UpdateReportStatusMutationVariables>(UpdateReportStatusDocument, options);
      }
export type UpdateReportStatusMutationHookResult = ReturnType<typeof useUpdateReportStatusMutation>;
export type UpdateReportStatusMutationResult = Apollo.MutationResult<UpdateReportStatusMutation>;
export type UpdateReportStatusMutationOptions = Apollo.BaseMutationOptions<UpdateReportStatusMutation, UpdateReportStatusMutationVariables>;
export const UpdateReportOrderDocument = gql`
    mutation UpdateReportOrder($input: updateReportInput) {
  updateReport(input: $input) {
    id
    reportOrder {
      assemblyOrder
      poiOrder
    }
  }
}
    `;
export type UpdateReportOrderMutationFn = Apollo.MutationFunction<UpdateReportOrderMutation, UpdateReportOrderMutationVariables>;

/**
 * __useUpdateReportOrderMutation__
 *
 * To run a mutation, you first call `useUpdateReportOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportOrderMutation, { data, loading, error }] = useUpdateReportOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportOrderMutation, UpdateReportOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportOrderMutation, UpdateReportOrderMutationVariables>(UpdateReportOrderDocument, options);
      }
export type UpdateReportOrderMutationHookResult = ReturnType<typeof useUpdateReportOrderMutation>;
export type UpdateReportOrderMutationResult = Apollo.MutationResult<UpdateReportOrderMutation>;
export type UpdateReportOrderMutationOptions = Apollo.BaseMutationOptions<UpdateReportOrderMutation, UpdateReportOrderMutationVariables>;
export const DeleteReportDocument = gql`
    mutation DeleteReport($reportId: ID!) {
  deleteReport(reportId: $reportId)
}
    `;
export type DeleteReportMutationFn = Apollo.MutationFunction<DeleteReportMutation, DeleteReportMutationVariables>;

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useDeleteReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportMutation, DeleteReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument, options);
      }
export type DeleteReportMutationHookResult = ReturnType<typeof useDeleteReportMutation>;
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReportMutation>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<DeleteReportMutation, DeleteReportMutationVariables>;
export const UpdatePoiImagesDocument = gql`
    mutation UpdatePOIImages($input: updateReportPointOfInterestImagesInput) {
  updateReportPointOfInterestImages(input: $input) {
    id
    selectedPointOfInterestImages {
      pointOfInterestId
      selectedImages {
        name
        fileName
        type
        resourcePath
        id
        uuid
        imageType
      }
    }
    allPointOfInterestPdfs {
      pointOfInterestId
      selectedPdfs {
        file {
          name
          resourcePath
          fileName
          type
          uploadStatus
          id
        }
        selectedStatus
      }
    }
  }
}
    `;
export type UpdatePoiImagesMutationFn = Apollo.MutationFunction<UpdatePoiImagesMutation, UpdatePoiImagesMutationVariables>;

/**
 * __useUpdatePoiImagesMutation__
 *
 * To run a mutation, you first call `useUpdatePoiImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePoiImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePoiImagesMutation, { data, loading, error }] = useUpdatePoiImagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePoiImagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePoiImagesMutation, UpdatePoiImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePoiImagesMutation, UpdatePoiImagesMutationVariables>(UpdatePoiImagesDocument, options);
      }
export type UpdatePoiImagesMutationHookResult = ReturnType<typeof useUpdatePoiImagesMutation>;
export type UpdatePoiImagesMutationResult = Apollo.MutationResult<UpdatePoiImagesMutation>;
export type UpdatePoiImagesMutationOptions = Apollo.BaseMutationOptions<UpdatePoiImagesMutation, UpdatePoiImagesMutationVariables>;
export const PreSignedUrlToUploadFilesDocument = gql`
    mutation PreSignedUrlToUploadFiles($input: UploadFileInput!) {
  preSignedUrlToUploadFiles(input: $input) {
    url
    id
    resourcePath
    uuid
  }
}
    `;
export type PreSignedUrlToUploadFilesMutationFn = Apollo.MutationFunction<PreSignedUrlToUploadFilesMutation, PreSignedUrlToUploadFilesMutationVariables>;

/**
 * __usePreSignedUrlToUploadFilesMutation__
 *
 * To run a mutation, you first call `usePreSignedUrlToUploadFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreSignedUrlToUploadFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preSignedUrlToUploadFilesMutation, { data, loading, error }] = usePreSignedUrlToUploadFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreSignedUrlToUploadFilesMutation(baseOptions?: Apollo.MutationHookOptions<PreSignedUrlToUploadFilesMutation, PreSignedUrlToUploadFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreSignedUrlToUploadFilesMutation, PreSignedUrlToUploadFilesMutationVariables>(PreSignedUrlToUploadFilesDocument, options);
      }
export type PreSignedUrlToUploadFilesMutationHookResult = ReturnType<typeof usePreSignedUrlToUploadFilesMutation>;
export type PreSignedUrlToUploadFilesMutationResult = Apollo.MutationResult<PreSignedUrlToUploadFilesMutation>;
export type PreSignedUrlToUploadFilesMutationOptions = Apollo.BaseMutationOptions<PreSignedUrlToUploadFilesMutation, PreSignedUrlToUploadFilesMutationVariables>;
export const UpdateFileStatusForPaintBlockReportManualUploadsDocument = gql`
    mutation UpdateFileStatusForPaintBlockReportManualUploads($input: UpdateFilesStatusInput!) {
  updateFilesStatus(input: $input)
}
    `;
export type UpdateFileStatusForPaintBlockReportManualUploadsMutationFn = Apollo.MutationFunction<UpdateFileStatusForPaintBlockReportManualUploadsMutation, UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables>;

/**
 * __useUpdateFileStatusForPaintBlockReportManualUploadsMutation__
 *
 * To run a mutation, you first call `useUpdateFileStatusForPaintBlockReportManualUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileStatusForPaintBlockReportManualUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileStatusForPaintBlockReportManualUploadsMutation, { data, loading, error }] = useUpdateFileStatusForPaintBlockReportManualUploadsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileStatusForPaintBlockReportManualUploadsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileStatusForPaintBlockReportManualUploadsMutation, UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileStatusForPaintBlockReportManualUploadsMutation, UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables>(UpdateFileStatusForPaintBlockReportManualUploadsDocument, options);
      }
export type UpdateFileStatusForPaintBlockReportManualUploadsMutationHookResult = ReturnType<typeof useUpdateFileStatusForPaintBlockReportManualUploadsMutation>;
export type UpdateFileStatusForPaintBlockReportManualUploadsMutationResult = Apollo.MutationResult<UpdateFileStatusForPaintBlockReportManualUploadsMutation>;
export type UpdateFileStatusForPaintBlockReportManualUploadsMutationOptions = Apollo.BaseMutationOptions<UpdateFileStatusForPaintBlockReportManualUploadsMutation, UpdateFileStatusForPaintBlockReportManualUploadsMutationVariables>;
export const AddAndRemoveFilesDocument = gql`
    mutation AddAndRemoveFiles($input: UpdateFilesInput!) {
  addAndRemoveFiles(input: $input)
}
    `;
export type AddAndRemoveFilesMutationFn = Apollo.MutationFunction<AddAndRemoveFilesMutation, AddAndRemoveFilesMutationVariables>;

/**
 * __useAddAndRemoveFilesMutation__
 *
 * To run a mutation, you first call `useAddAndRemoveFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAndRemoveFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAndRemoveFilesMutation, { data, loading, error }] = useAddAndRemoveFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAndRemoveFilesMutation(baseOptions?: Apollo.MutationHookOptions<AddAndRemoveFilesMutation, AddAndRemoveFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAndRemoveFilesMutation, AddAndRemoveFilesMutationVariables>(AddAndRemoveFilesDocument, options);
      }
export type AddAndRemoveFilesMutationHookResult = ReturnType<typeof useAddAndRemoveFilesMutation>;
export type AddAndRemoveFilesMutationResult = Apollo.MutationResult<AddAndRemoveFilesMutation>;
export type AddAndRemoveFilesMutationOptions = Apollo.BaseMutationOptions<AddAndRemoveFilesMutation, AddAndRemoveFilesMutationVariables>;
export const UpdateReportDocument = gql`
    mutation UpdateReport($input: updateReportInput) {
  updateReport(input: $input) {
    templateFieldData
    id
    selectedPointOfInterestImages {
      pointOfInterestId
      selectedImages {
        name
        fileName
        type
        resourcePath
        id
        uuid
        imageType
      }
    }
    allPointOfInterestPdfs {
      pointOfInterestId
      selectedPdfs {
        file {
          name
          resourcePath
          fileName
          type
          uploadStatus
          id
        }
        selectedStatus
      }
    }
    files {
      id
      name
      type
      resourcePath
      fileName
      uploadStatus
      imageType
      uuid
    }
  }
}
    `;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<UpdateReportMutation, UpdateReportMutationVariables>;
export const DefectsAreaForAssemblyPaintRegionsDocument = gql`
    query DefectsAreaForAssemblyPaintRegions($input: PaintBlockFiltersInput!) {
  defectsAreaForAssemblyPaintRegions(input: $input) {
    defectsByPaintBlock {
      totalArea {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useDefectsAreaForAssemblyPaintRegionsQuery__
 *
 * To run a query within a React component, call `useDefectsAreaForAssemblyPaintRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectsAreaForAssemblyPaintRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectsAreaForAssemblyPaintRegionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefectsAreaForAssemblyPaintRegionsQuery(baseOptions: Apollo.QueryHookOptions<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables> & ({ variables: DefectsAreaForAssemblyPaintRegionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>(DefectsAreaForAssemblyPaintRegionsDocument, options);
      }
export function useDefectsAreaForAssemblyPaintRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>(DefectsAreaForAssemblyPaintRegionsDocument, options);
        }
export function useDefectsAreaForAssemblyPaintRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>(DefectsAreaForAssemblyPaintRegionsDocument, options);
        }
export type DefectsAreaForAssemblyPaintRegionsQueryHookResult = ReturnType<typeof useDefectsAreaForAssemblyPaintRegionsQuery>;
export type DefectsAreaForAssemblyPaintRegionsLazyQueryHookResult = ReturnType<typeof useDefectsAreaForAssemblyPaintRegionsLazyQuery>;
export type DefectsAreaForAssemblyPaintRegionsSuspenseQueryHookResult = ReturnType<typeof useDefectsAreaForAssemblyPaintRegionsSuspenseQuery>;
export type DefectsAreaForAssemblyPaintRegionsQueryResult = Apollo.QueryResult<DefectsAreaForAssemblyPaintRegionsQuery, DefectsAreaForAssemblyPaintRegionsQueryVariables>;
export const ValidateReportScopeDocument = gql`
    query ValidateReportScope($input: ValidateReportScopeInput) {
  validateReportScope(input: $input) {
    isValid
  }
}
    `;

/**
 * __useValidateReportScopeQuery__
 *
 * To run a query within a React component, call `useValidateReportScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateReportScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateReportScopeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateReportScopeQuery(baseOptions?: Apollo.QueryHookOptions<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>(ValidateReportScopeDocument, options);
      }
export function useValidateReportScopeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>(ValidateReportScopeDocument, options);
        }
export function useValidateReportScopeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>(ValidateReportScopeDocument, options);
        }
export type ValidateReportScopeQueryHookResult = ReturnType<typeof useValidateReportScopeQuery>;
export type ValidateReportScopeLazyQueryHookResult = ReturnType<typeof useValidateReportScopeLazyQuery>;
export type ValidateReportScopeSuspenseQueryHookResult = ReturnType<typeof useValidateReportScopeSuspenseQuery>;
export type ValidateReportScopeQueryResult = Apollo.QueryResult<ValidateReportScopeQuery, ValidateReportScopeQueryVariables>;
export const StructureForReportDocument = gql`
    query StructureForReport($structureId: String) {
  structure(structureId: $structureId) {
    reportConfig {
      title
      id
      configurations {
        id
        title
        key
      }
    }
  }
}
    `;

/**
 * __useStructureForReportQuery__
 *
 * To run a query within a React component, call `useStructureForReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureForReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureForReportQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureForReportQuery(baseOptions?: Apollo.QueryHookOptions<StructureForReportQuery, StructureForReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureForReportQuery, StructureForReportQueryVariables>(StructureForReportDocument, options);
      }
export function useStructureForReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureForReportQuery, StructureForReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureForReportQuery, StructureForReportQueryVariables>(StructureForReportDocument, options);
        }
export function useStructureForReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForReportQuery, StructureForReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureForReportQuery, StructureForReportQueryVariables>(StructureForReportDocument, options);
        }
export type StructureForReportQueryHookResult = ReturnType<typeof useStructureForReportQuery>;
export type StructureForReportLazyQueryHookResult = ReturnType<typeof useStructureForReportLazyQuery>;
export type StructureForReportSuspenseQueryHookResult = ReturnType<typeof useStructureForReportSuspenseQuery>;
export type StructureForReportQueryResult = Apollo.QueryResult<StructureForReportQuery, StructureForReportQueryVariables>;
export const GetAssemblyAttachmentsDocument = gql`
    query GetAssemblyAttachments($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    files {
      id
      name
      resourcePath
      type
      caption
      fileName
      uploadStatus
      imageType
      uuid
    }
  }
}
    `;

/**
 * __useGetAssemblyAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyAttachmentsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyAttachmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>(GetAssemblyAttachmentsDocument, options);
      }
export function useGetAssemblyAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>(GetAssemblyAttachmentsDocument, options);
        }
export function useGetAssemblyAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>(GetAssemblyAttachmentsDocument, options);
        }
export type GetAssemblyAttachmentsQueryHookResult = ReturnType<typeof useGetAssemblyAttachmentsQuery>;
export type GetAssemblyAttachmentsLazyQueryHookResult = ReturnType<typeof useGetAssemblyAttachmentsLazyQuery>;
export type GetAssemblyAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyAttachmentsSuspenseQuery>;
export type GetAssemblyAttachmentsQueryResult = Apollo.QueryResult<GetAssemblyAttachmentsQuery, GetAssemblyAttachmentsQueryVariables>;
export const UpdatePointOfInterestImageTypeDocument = gql`
    mutation UpdatePointOfInterestImageType($input: UpdatePointOfInterestImageTypeInput!) {
  updatePointOfInterestImageType(input: $input) {
    files {
      id
      imageType
    }
  }
}
    `;
export type UpdatePointOfInterestImageTypeMutationFn = Apollo.MutationFunction<UpdatePointOfInterestImageTypeMutation, UpdatePointOfInterestImageTypeMutationVariables>;

/**
 * __useUpdatePointOfInterestImageTypeMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestImageTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestImageTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestImageTypeMutation, { data, loading, error }] = useUpdatePointOfInterestImageTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestImageTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestImageTypeMutation, UpdatePointOfInterestImageTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestImageTypeMutation, UpdatePointOfInterestImageTypeMutationVariables>(UpdatePointOfInterestImageTypeDocument, options);
      }
export type UpdatePointOfInterestImageTypeMutationHookResult = ReturnType<typeof useUpdatePointOfInterestImageTypeMutation>;
export type UpdatePointOfInterestImageTypeMutationResult = Apollo.MutationResult<UpdatePointOfInterestImageTypeMutation>;
export type UpdatePointOfInterestImageTypeMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestImageTypeMutation, UpdatePointOfInterestImageTypeMutationVariables>;
export const GetAssemblyForEvaluationDocument = gql`
    query GetAssemblyForEvaluation($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    templateFieldData
    area
  }
}
    `;

/**
 * __useGetAssemblyForEvaluationQuery__
 *
 * To run a query within a React component, call `useGetAssemblyForEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyForEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyForEvaluationQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyForEvaluationQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>(GetAssemblyForEvaluationDocument, options);
      }
export function useGetAssemblyForEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>(GetAssemblyForEvaluationDocument, options);
        }
export function useGetAssemblyForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>(GetAssemblyForEvaluationDocument, options);
        }
export type GetAssemblyForEvaluationQueryHookResult = ReturnType<typeof useGetAssemblyForEvaluationQuery>;
export type GetAssemblyForEvaluationLazyQueryHookResult = ReturnType<typeof useGetAssemblyForEvaluationLazyQuery>;
export type GetAssemblyForEvaluationSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyForEvaluationSuspenseQuery>;
export type GetAssemblyForEvaluationQueryResult = Apollo.QueryResult<GetAssemblyForEvaluationQuery, GetAssemblyForEvaluationQueryVariables>;
export const GetAssembliesForEvaluationDocument = gql`
    query GetAssembliesForEvaluation($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    templateFieldData
    area
  }
}
    `;

/**
 * __useGetAssembliesForEvaluationQuery__
 *
 * To run a query within a React component, call `useGetAssembliesForEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesForEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesForEvaluationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesForEvaluationQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>(GetAssembliesForEvaluationDocument, options);
      }
export function useGetAssembliesForEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>(GetAssembliesForEvaluationDocument, options);
        }
export function useGetAssembliesForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>(GetAssembliesForEvaluationDocument, options);
        }
export type GetAssembliesForEvaluationQueryHookResult = ReturnType<typeof useGetAssembliesForEvaluationQuery>;
export type GetAssembliesForEvaluationLazyQueryHookResult = ReturnType<typeof useGetAssembliesForEvaluationLazyQuery>;
export type GetAssembliesForEvaluationSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesForEvaluationSuspenseQuery>;
export type GetAssembliesForEvaluationQueryResult = Apollo.QueryResult<GetAssembliesForEvaluationQuery, GetAssembliesForEvaluationQueryVariables>;
export const GetAllAssembliesForEvaluationDocument = gql`
    query GetAllAssembliesForEvaluation($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
  }
}
    `;

/**
 * __useGetAllAssembliesForEvaluationQuery__
 *
 * To run a query within a React component, call `useGetAllAssembliesForEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssembliesForEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssembliesForEvaluationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAllAssembliesForEvaluationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>(GetAllAssembliesForEvaluationDocument, options);
      }
export function useGetAllAssembliesForEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>(GetAllAssembliesForEvaluationDocument, options);
        }
export function useGetAllAssembliesForEvaluationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>(GetAllAssembliesForEvaluationDocument, options);
        }
export type GetAllAssembliesForEvaluationQueryHookResult = ReturnType<typeof useGetAllAssembliesForEvaluationQuery>;
export type GetAllAssembliesForEvaluationLazyQueryHookResult = ReturnType<typeof useGetAllAssembliesForEvaluationLazyQuery>;
export type GetAllAssembliesForEvaluationSuspenseQueryHookResult = ReturnType<typeof useGetAllAssembliesForEvaluationSuspenseQuery>;
export type GetAllAssembliesForEvaluationQueryResult = Apollo.QueryResult<GetAllAssembliesForEvaluationQuery, GetAllAssembliesForEvaluationQueryVariables>;
export const StructureDefectLegendsDocument = gql`
    query StructureDefectLegends($structureId: String) {
  structure(structureId: $structureId) {
    defectLegends {
      id
      groupName
      groupKey
      name
      color
      octreeKey
      octreeValue
      legendText
    }
  }
}
    `;

/**
 * __useStructureDefectLegendsQuery__
 *
 * To run a query within a React component, call `useStructureDefectLegendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureDefectLegendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureDefectLegendsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureDefectLegendsQuery(baseOptions?: Apollo.QueryHookOptions<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>(StructureDefectLegendsDocument, options);
      }
export function useStructureDefectLegendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>(StructureDefectLegendsDocument, options);
        }
export function useStructureDefectLegendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>(StructureDefectLegendsDocument, options);
        }
export type StructureDefectLegendsQueryHookResult = ReturnType<typeof useStructureDefectLegendsQuery>;
export type StructureDefectLegendsLazyQueryHookResult = ReturnType<typeof useStructureDefectLegendsLazyQuery>;
export type StructureDefectLegendsSuspenseQueryHookResult = ReturnType<typeof useStructureDefectLegendsSuspenseQuery>;
export type StructureDefectLegendsQueryResult = Apollo.QueryResult<StructureDefectLegendsQuery, StructureDefectLegendsQueryVariables>;
export const UpdateReportDataDocument = gql`
    mutation UpdateReportData($input: UpdateSingleTemplateFieldDataInput) {
  updateSingleTemplateFieldData(input: $input) {
    templateFieldData
  }
}
    `;
export type UpdateReportDataMutationFn = Apollo.MutationFunction<UpdateReportDataMutation, UpdateReportDataMutationVariables>;

/**
 * __useUpdateReportDataMutation__
 *
 * To run a mutation, you first call `useUpdateReportDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportDataMutation, { data, loading, error }] = useUpdateReportDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportDataMutation, UpdateReportDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportDataMutation, UpdateReportDataMutationVariables>(UpdateReportDataDocument, options);
      }
export type UpdateReportDataMutationHookResult = ReturnType<typeof useUpdateReportDataMutation>;
export type UpdateReportDataMutationResult = Apollo.MutationResult<UpdateReportDataMutation>;
export type UpdateReportDataMutationOptions = Apollo.BaseMutationOptions<UpdateReportDataMutation, UpdateReportDataMutationVariables>;
export const PointOfInterestActivityDocument = gql`
    subscription PointOfInterestActivity($structureId: ID!, $assemblyId: ID) {
  pointOfInterestActivity(structureId: $structureId, assemblyId: $assemblyId) {
    name
  }
}
    `;

/**
 * __usePointOfInterestActivitySubscription__
 *
 * To run a query within a React component, call `usePointOfInterestActivitySubscription` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestActivitySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestActivitySubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function usePointOfInterestActivitySubscription(baseOptions: Apollo.SubscriptionHookOptions<PointOfInterestActivitySubscription, PointOfInterestActivitySubscriptionVariables> & ({ variables: PointOfInterestActivitySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PointOfInterestActivitySubscription, PointOfInterestActivitySubscriptionVariables>(PointOfInterestActivityDocument, options);
      }
export type PointOfInterestActivitySubscriptionHookResult = ReturnType<typeof usePointOfInterestActivitySubscription>;
export type PointOfInterestActivitySubscriptionResult = Apollo.SubscriptionResult<PointOfInterestActivitySubscription>;
export const BulkUpdateReviewActionDocument = gql`
    mutation BulkUpdateReviewAction($input: BulkUpdateReviewActionInput) {
  bulkUpdateReviewAction(input: $input) {
    count
  }
}
    `;
export type BulkUpdateReviewActionMutationFn = Apollo.MutationFunction<BulkUpdateReviewActionMutation, BulkUpdateReviewActionMutationVariables>;

/**
 * __useBulkUpdateReviewActionMutation__
 *
 * To run a mutation, you first call `useBulkUpdateReviewActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateReviewActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateReviewActionMutation, { data, loading, error }] = useBulkUpdateReviewActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateReviewActionMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateReviewActionMutation, BulkUpdateReviewActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateReviewActionMutation, BulkUpdateReviewActionMutationVariables>(BulkUpdateReviewActionDocument, options);
      }
export type BulkUpdateReviewActionMutationHookResult = ReturnType<typeof useBulkUpdateReviewActionMutation>;
export type BulkUpdateReviewActionMutationResult = Apollo.MutationResult<BulkUpdateReviewActionMutation>;
export type BulkUpdateReviewActionMutationOptions = Apollo.BaseMutationOptions<BulkUpdateReviewActionMutation, BulkUpdateReviewActionMutationVariables>;
export const AllCommentsForRiskAssessmentDocument = gql`
    query AllCommentsForRiskAssessment($input: AllCommentsInput) {
  allComments(input: $input) {
    id
    text
    structureId
    text
    title
    updatedAt
    collectionName
    createdByUser {
      picture
      name
    }
    key
  }
}
    `;

/**
 * __useAllCommentsForRiskAssessmentQuery__
 *
 * To run a query within a React component, call `useAllCommentsForRiskAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCommentsForRiskAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCommentsForRiskAssessmentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllCommentsForRiskAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>(AllCommentsForRiskAssessmentDocument, options);
      }
export function useAllCommentsForRiskAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>(AllCommentsForRiskAssessmentDocument, options);
        }
export function useAllCommentsForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>(AllCommentsForRiskAssessmentDocument, options);
        }
export type AllCommentsForRiskAssessmentQueryHookResult = ReturnType<typeof useAllCommentsForRiskAssessmentQuery>;
export type AllCommentsForRiskAssessmentLazyQueryHookResult = ReturnType<typeof useAllCommentsForRiskAssessmentLazyQuery>;
export type AllCommentsForRiskAssessmentSuspenseQueryHookResult = ReturnType<typeof useAllCommentsForRiskAssessmentSuspenseQuery>;
export type AllCommentsForRiskAssessmentQueryResult = Apollo.QueryResult<AllCommentsForRiskAssessmentQuery, AllCommentsForRiskAssessmentQueryVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    id
    text
    title
    updatedAt
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const UpdateRiskAssessmentTemplateFieldDataForAssembliesDocument = gql`
    mutation updateRiskAssessmentTemplateFieldDataForAssemblies($input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput!) {
  updateRiskAssessmentTemplateFieldDataForAssemblies(input: $input) {
    id
    tagName
    templateFieldData
  }
}
    `;
export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationFn = Apollo.MutationFunction<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation, UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables>;

/**
 * __useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation__
 *
 * To run a mutation, you first call `useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskAssessmentTemplateFieldDataForAssembliesMutation, { data, loading, error }] = useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation, UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation, UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables>(UpdateRiskAssessmentTemplateFieldDataForAssembliesDocument, options);
      }
export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationHookResult = ReturnType<typeof useUpdateRiskAssessmentTemplateFieldDataForAssembliesMutation>;
export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationResult = Apollo.MutationResult<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation>;
export type UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationOptions = Apollo.BaseMutationOptions<UpdateRiskAssessmentTemplateFieldDataForAssembliesMutation, UpdateRiskAssessmentTemplateFieldDataForAssembliesMutationVariables>;
export const UpdateAssembliesProbabilityOfFailureRiskFactorsDocument = gql`
    mutation UpdateAssembliesProbabilityOfFailureRiskFactors($input: UpdateTemplateFieldDataPofInput!) {
  updateAssembliesProbabilityOfFailureRiskFactors(input: $input) {
    id
    tagName
    templateFieldData
  }
}
    `;
export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationFn = Apollo.MutationFunction<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation, UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables>;

/**
 * __useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation__
 *
 * To run a mutation, you first call `useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssembliesProbabilityOfFailureRiskFactorsMutation, { data, loading, error }] = useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation, UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation, UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables>(UpdateAssembliesProbabilityOfFailureRiskFactorsDocument, options);
      }
export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationHookResult = ReturnType<typeof useUpdateAssembliesProbabilityOfFailureRiskFactorsMutation>;
export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationResult = Apollo.MutationResult<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation>;
export type UpdateAssembliesProbabilityOfFailureRiskFactorsMutationOptions = Apollo.BaseMutationOptions<UpdateAssembliesProbabilityOfFailureRiskFactorsMutation, UpdateAssembliesProbabilityOfFailureRiskFactorsMutationVariables>;
export const GetAssembliesRiskAssessmentSummaryDocument = gql`
    query GetAssembliesRiskAssessmentSummary($input: RiskAssessmentSummaryInput) {
  getAssembliesRiskAssessmentSummary(input: $input) {
    key
    values {
      count
      value
    }
  }
}
    `;

/**
 * __useGetAssembliesRiskAssessmentSummaryQuery__
 *
 * To run a query within a React component, call `useGetAssembliesRiskAssessmentSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesRiskAssessmentSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesRiskAssessmentSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssembliesRiskAssessmentSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>(GetAssembliesRiskAssessmentSummaryDocument, options);
      }
export function useGetAssembliesRiskAssessmentSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>(GetAssembliesRiskAssessmentSummaryDocument, options);
        }
export function useGetAssembliesRiskAssessmentSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>(GetAssembliesRiskAssessmentSummaryDocument, options);
        }
export type GetAssembliesRiskAssessmentSummaryQueryHookResult = ReturnType<typeof useGetAssembliesRiskAssessmentSummaryQuery>;
export type GetAssembliesRiskAssessmentSummaryLazyQueryHookResult = ReturnType<typeof useGetAssembliesRiskAssessmentSummaryLazyQuery>;
export type GetAssembliesRiskAssessmentSummarySuspenseQueryHookResult = ReturnType<typeof useGetAssembliesRiskAssessmentSummarySuspenseQuery>;
export type GetAssembliesRiskAssessmentSummaryQueryResult = Apollo.QueryResult<GetAssembliesRiskAssessmentSummaryQuery, GetAssembliesRiskAssessmentSummaryQueryVariables>;
export const StructureForRiskAssessmentDocument = gql`
    query StructureForRiskAssessment($structureId: String) {
  structure(structureId: $structureId) {
    id
    name
    type
    hasRiskAssessment
    template {
      id
    }
    templateData {
      id
      value
      templateFieldId
    }
    esSheetStatus
  }
}
    `;

/**
 * __useStructureForRiskAssessmentQuery__
 *
 * To run a query within a React component, call `useStructureForRiskAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureForRiskAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureForRiskAssessmentQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureForRiskAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>(StructureForRiskAssessmentDocument, options);
      }
export function useStructureForRiskAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>(StructureForRiskAssessmentDocument, options);
        }
export function useStructureForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>(StructureForRiskAssessmentDocument, options);
        }
export type StructureForRiskAssessmentQueryHookResult = ReturnType<typeof useStructureForRiskAssessmentQuery>;
export type StructureForRiskAssessmentLazyQueryHookResult = ReturnType<typeof useStructureForRiskAssessmentLazyQuery>;
export type StructureForRiskAssessmentSuspenseQueryHookResult = ReturnType<typeof useStructureForRiskAssessmentSuspenseQuery>;
export type StructureForRiskAssessmentQueryResult = Apollo.QueryResult<StructureForRiskAssessmentQuery, StructureForRiskAssessmentQueryVariables>;
export const AllAssemblyTemplatesForRiskAssessmentDocument = gql`
    query AllAssemblyTemplatesForRiskAssessment($structureId: ID, $type: TemplateTypeEnum) {
  allTemplates(structureId: $structureId, type: $type) {
    name
    id
    fields {
      displayConfig {
        id
        type
        color {
          key
          value
        }
        isSortable
        sortType
        textFormat
      }
      id
      name
      key
      type
      options
      permission
      displayInQuery
      displayInTable
      displayInRisk
      displayInReview
      displayInReports
      roundToDecimal
      unit
      displayUnit
      optionsData {
        value
        min
        max
      }
      isExportable
    }
    riskFields {
      type
      isHiddenColumn
      id
      fieldKey
    }
  }
}
    `;

/**
 * __useAllAssemblyTemplatesForRiskAssessmentQuery__
 *
 * To run a query within a React component, call `useAllAssemblyTemplatesForRiskAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssemblyTemplatesForRiskAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssemblyTemplatesForRiskAssessmentQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAllAssemblyTemplatesForRiskAssessmentQuery(baseOptions?: Apollo.QueryHookOptions<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>(AllAssemblyTemplatesForRiskAssessmentDocument, options);
      }
export function useAllAssemblyTemplatesForRiskAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>(AllAssemblyTemplatesForRiskAssessmentDocument, options);
        }
export function useAllAssemblyTemplatesForRiskAssessmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>(AllAssemblyTemplatesForRiskAssessmentDocument, options);
        }
export type AllAssemblyTemplatesForRiskAssessmentQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForRiskAssessmentQuery>;
export type AllAssemblyTemplatesForRiskAssessmentLazyQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForRiskAssessmentLazyQuery>;
export type AllAssemblyTemplatesForRiskAssessmentSuspenseQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForRiskAssessmentSuspenseQuery>;
export type AllAssemblyTemplatesForRiskAssessmentQueryResult = Apollo.QueryResult<AllAssemblyTemplatesForRiskAssessmentQuery, AllAssemblyTemplatesForRiskAssessmentQueryVariables>;
export const GetTemplateByTypeDocument = gql`
    query getTemplateByType($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    fields {
      options
      name
      type
      id
      key
      isHidden
      isReadOnly
    }
  }
}
    `;

/**
 * __useGetTemplateByTypeQuery__
 *
 * To run a query within a React component, call `useGetTemplateByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetTemplateByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables> & ({ variables: GetTemplateByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>(GetTemplateByTypeDocument, options);
      }
export function useGetTemplateByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>(GetTemplateByTypeDocument, options);
        }
export function useGetTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>(GetTemplateByTypeDocument, options);
        }
export type GetTemplateByTypeQueryHookResult = ReturnType<typeof useGetTemplateByTypeQuery>;
export type GetTemplateByTypeLazyQueryHookResult = ReturnType<typeof useGetTemplateByTypeLazyQuery>;
export type GetTemplateByTypeSuspenseQueryHookResult = ReturnType<typeof useGetTemplateByTypeSuspenseQuery>;
export type GetTemplateByTypeQueryResult = Apollo.QueryResult<GetTemplateByTypeQuery, GetTemplateByTypeQueryVariables>;
export const GetAssembliesByRiskAssessmentFiltersDocument = gql`
    query getAssembliesByRiskAssessmentFilters($input: RiskAssessmentFiltersInput!, $pageInfo: PageInfo) {
  getAssembliesByRiskAssessmentFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
    isUncontextualized
    decks {
      deckId {
        id
      }
    }
  }
  getRiskAssembliesCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetAssembliesByRiskAssessmentFiltersQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByRiskAssessmentFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByRiskAssessmentFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByRiskAssessmentFiltersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesByRiskAssessmentFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables> & ({ variables: GetAssembliesByRiskAssessmentFiltersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>(GetAssembliesByRiskAssessmentFiltersDocument, options);
      }
export function useGetAssembliesByRiskAssessmentFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>(GetAssembliesByRiskAssessmentFiltersDocument, options);
        }
export function useGetAssembliesByRiskAssessmentFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>(GetAssembliesByRiskAssessmentFiltersDocument, options);
        }
export type GetAssembliesByRiskAssessmentFiltersQueryHookResult = ReturnType<typeof useGetAssembliesByRiskAssessmentFiltersQuery>;
export type GetAssembliesByRiskAssessmentFiltersLazyQueryHookResult = ReturnType<typeof useGetAssembliesByRiskAssessmentFiltersLazyQuery>;
export type GetAssembliesByRiskAssessmentFiltersSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByRiskAssessmentFiltersSuspenseQuery>;
export type GetAssembliesByRiskAssessmentFiltersQueryResult = Apollo.QueryResult<GetAssembliesByRiskAssessmentFiltersQuery, GetAssembliesByRiskAssessmentFiltersQueryVariables>;
export const GetDependentRiskAssessmentOptionsDocument = gql`
    query GetDependentRiskAssessmentOptions($input: RiskAssessmentFiltersInput) {
  getDependentRiskAssessmentOptions(input: $input) {
    key
    options
  }
}
    `;

/**
 * __useGetDependentRiskAssessmentOptionsQuery__
 *
 * To run a query within a React component, call `useGetDependentRiskAssessmentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDependentRiskAssessmentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDependentRiskAssessmentOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDependentRiskAssessmentOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>(GetDependentRiskAssessmentOptionsDocument, options);
      }
export function useGetDependentRiskAssessmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>(GetDependentRiskAssessmentOptionsDocument, options);
        }
export function useGetDependentRiskAssessmentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>(GetDependentRiskAssessmentOptionsDocument, options);
        }
export type GetDependentRiskAssessmentOptionsQueryHookResult = ReturnType<typeof useGetDependentRiskAssessmentOptionsQuery>;
export type GetDependentRiskAssessmentOptionsLazyQueryHookResult = ReturnType<typeof useGetDependentRiskAssessmentOptionsLazyQuery>;
export type GetDependentRiskAssessmentOptionsSuspenseQueryHookResult = ReturnType<typeof useGetDependentRiskAssessmentOptionsSuspenseQuery>;
export type GetDependentRiskAssessmentOptionsQueryResult = Apollo.QueryResult<GetDependentRiskAssessmentOptionsQuery, GetDependentRiskAssessmentOptionsQueryVariables>;
export const CreateRiskAssessmentDetailsDocument = gql`
    mutation createRiskAssessmentDetails($input: CreateRiskAssessmentDetailsInput) {
  createRiskAssessmentDetails(input: $input) {
    id
    name
    type
    hasRiskAssessment
    template {
      id
    }
    templateData {
      id
      value
      templateFieldId
    }
  }
}
    `;
export type CreateRiskAssessmentDetailsMutationFn = Apollo.MutationFunction<CreateRiskAssessmentDetailsMutation, CreateRiskAssessmentDetailsMutationVariables>;

/**
 * __useCreateRiskAssessmentDetailsMutation__
 *
 * To run a mutation, you first call `useCreateRiskAssessmentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskAssessmentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskAssessmentDetailsMutation, { data, loading, error }] = useCreateRiskAssessmentDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRiskAssessmentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskAssessmentDetailsMutation, CreateRiskAssessmentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskAssessmentDetailsMutation, CreateRiskAssessmentDetailsMutationVariables>(CreateRiskAssessmentDetailsDocument, options);
      }
export type CreateRiskAssessmentDetailsMutationHookResult = ReturnType<typeof useCreateRiskAssessmentDetailsMutation>;
export type CreateRiskAssessmentDetailsMutationResult = Apollo.MutationResult<CreateRiskAssessmentDetailsMutation>;
export type CreateRiskAssessmentDetailsMutationOptions = Apollo.BaseMutationOptions<CreateRiskAssessmentDetailsMutation, CreateRiskAssessmentDetailsMutationVariables>;
export const GetAssemblyForTaskModalDocument = gql`
    query GetAssemblyForTaskModal($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    templateFieldData
  }
}
    `;

/**
 * __useGetAssemblyForTaskModalQuery__
 *
 * To run a query within a React component, call `useGetAssemblyForTaskModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyForTaskModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyForTaskModalQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyForTaskModalQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>(GetAssemblyForTaskModalDocument, options);
      }
export function useGetAssemblyForTaskModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>(GetAssemblyForTaskModalDocument, options);
        }
export function useGetAssemblyForTaskModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>(GetAssemblyForTaskModalDocument, options);
        }
export type GetAssemblyForTaskModalQueryHookResult = ReturnType<typeof useGetAssemblyForTaskModalQuery>;
export type GetAssemblyForTaskModalLazyQueryHookResult = ReturnType<typeof useGetAssemblyForTaskModalLazyQuery>;
export type GetAssemblyForTaskModalSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyForTaskModalSuspenseQuery>;
export type GetAssemblyForTaskModalQueryResult = Apollo.QueryResult<GetAssemblyForTaskModalQuery, GetAssemblyForTaskModalQueryVariables>;
export const UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodDocument = gql`
    mutation updateRiskAssessmentTemplateFieldDataAndTransitionPeriod($input: UpdateRiskAssessmentTemplateFieldDataForAssembliesInput!) {
  updateRiskAssessmentTemplateFieldDataAndTransitionPeriod(input: $input) {
    calculatedTransitionPeriod {
      transitionPeriod
      nextDate
      futureDate
    }
    invalidDamageClassCount
  }
}
    `;
export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationFn = Apollo.MutationFunction<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables>;

/**
 * __useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation__
 *
 * To run a mutation, you first call `useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, { data, loading, error }] = useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables>(UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodDocument, options);
      }
export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationHookResult = ReturnType<typeof useUpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation>;
export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationResult = Apollo.MutationResult<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation>;
export type UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationOptions = Apollo.BaseMutationOptions<UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutation, UpdateRiskAssessmentTemplateFieldDataAndTransitionPeriodMutationVariables>;
export const GetMaterialTemplateByTypeDocument = gql`
    query getMaterialTemplateByType($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    materialType {
      type
      thickness
      corrosivityCategory {
        name
        values
      }
      environmentalClassification {
        name
        values
      }
      environmentalExposure {
        name
        code
        timeToVisibility
      }
    }
  }
}
    `;

/**
 * __useGetMaterialTemplateByTypeQuery__
 *
 * To run a query within a React component, call `useGetMaterialTemplateByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialTemplateByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialTemplateByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMaterialTemplateByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables> & ({ variables: GetMaterialTemplateByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>(GetMaterialTemplateByTypeDocument, options);
      }
export function useGetMaterialTemplateByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>(GetMaterialTemplateByTypeDocument, options);
        }
export function useGetMaterialTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>(GetMaterialTemplateByTypeDocument, options);
        }
export type GetMaterialTemplateByTypeQueryHookResult = ReturnType<typeof useGetMaterialTemplateByTypeQuery>;
export type GetMaterialTemplateByTypeLazyQueryHookResult = ReturnType<typeof useGetMaterialTemplateByTypeLazyQuery>;
export type GetMaterialTemplateByTypeSuspenseQueryHookResult = ReturnType<typeof useGetMaterialTemplateByTypeSuspenseQuery>;
export type GetMaterialTemplateByTypeQueryResult = Apollo.QueryResult<GetMaterialTemplateByTypeQuery, GetMaterialTemplateByTypeQueryVariables>;
export const BulkCreateCommentsForAssembliesDocument = gql`
    mutation BulkCreateCommentsForAssemblies($input: BulkCreateForAssembliesInput) {
  bulkCreateCommentsForAssemblies(input: $input) {
    modifiedCount
    insertedCount
    upsertedCount
  }
}
    `;
export type BulkCreateCommentsForAssembliesMutationFn = Apollo.MutationFunction<BulkCreateCommentsForAssembliesMutation, BulkCreateCommentsForAssembliesMutationVariables>;

/**
 * __useBulkCreateCommentsForAssembliesMutation__
 *
 * To run a mutation, you first call `useBulkCreateCommentsForAssembliesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateCommentsForAssembliesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateCommentsForAssembliesMutation, { data, loading, error }] = useBulkCreateCommentsForAssembliesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateCommentsForAssembliesMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateCommentsForAssembliesMutation, BulkCreateCommentsForAssembliesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateCommentsForAssembliesMutation, BulkCreateCommentsForAssembliesMutationVariables>(BulkCreateCommentsForAssembliesDocument, options);
      }
export type BulkCreateCommentsForAssembliesMutationHookResult = ReturnType<typeof useBulkCreateCommentsForAssembliesMutation>;
export type BulkCreateCommentsForAssembliesMutationResult = Apollo.MutationResult<BulkCreateCommentsForAssembliesMutation>;
export type BulkCreateCommentsForAssembliesMutationOptions = Apollo.BaseMutationOptions<BulkCreateCommentsForAssembliesMutation, BulkCreateCommentsForAssembliesMutationVariables>;
export const GetUnpublishedSummarySheetCountsDocument = gql`
    query GetUnpublishedSummarySheetCounts($input: SummarySheetGraphsCountInput, $structureId: String) {
  getSummarySheetGraphsCount(input: $input) {
    count
    key
  }
  getRiskAssessmentSummaryCounts(structureId: $structureId) {
    cofCalculated
    pofCalculated
    totalAssemblies
    transitionPeriodCalculated
  }
}
    `;

/**
 * __useGetUnpublishedSummarySheetCountsQuery__
 *
 * To run a query within a React component, call `useGetUnpublishedSummarySheetCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnpublishedSummarySheetCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnpublishedSummarySheetCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetUnpublishedSummarySheetCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>(GetUnpublishedSummarySheetCountsDocument, options);
      }
export function useGetUnpublishedSummarySheetCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>(GetUnpublishedSummarySheetCountsDocument, options);
        }
export function useGetUnpublishedSummarySheetCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>(GetUnpublishedSummarySheetCountsDocument, options);
        }
export type GetUnpublishedSummarySheetCountsQueryHookResult = ReturnType<typeof useGetUnpublishedSummarySheetCountsQuery>;
export type GetUnpublishedSummarySheetCountsLazyQueryHookResult = ReturnType<typeof useGetUnpublishedSummarySheetCountsLazyQuery>;
export type GetUnpublishedSummarySheetCountsSuspenseQueryHookResult = ReturnType<typeof useGetUnpublishedSummarySheetCountsSuspenseQuery>;
export type GetUnpublishedSummarySheetCountsQueryResult = Apollo.QueryResult<GetUnpublishedSummarySheetCountsQuery, GetUnpublishedSummarySheetCountsQueryVariables>;
export const GetPublishedSummarySheetCountsDocument = gql`
    query GetPublishedSummarySheetCounts($SHEInput: SummarySheetGraphsCountInput, $financialsInput: SummarySheetGraphsCountInput, $structureId: String) {
  governingSHEData: getSummarySheetGraphsCount(input: $SHEInput) {
    count
    key
  }
  governingFinancialData: getSummarySheetGraphsCount(input: $financialsInput) {
    count
    key
  }
  calculationCounts: getRiskAssessmentSummaryCounts(structureId: $structureId) {
    cofCalculated
    pofCalculated
    totalAssemblies
    transitionPeriodCalculated
  }
}
    `;

/**
 * __useGetPublishedSummarySheetCountsQuery__
 *
 * To run a query within a React component, call `useGetPublishedSummarySheetCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedSummarySheetCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedSummarySheetCountsQuery({
 *   variables: {
 *      SHEInput: // value for 'SHEInput'
 *      financialsInput: // value for 'financialsInput'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetPublishedSummarySheetCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>(GetPublishedSummarySheetCountsDocument, options);
      }
export function useGetPublishedSummarySheetCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>(GetPublishedSummarySheetCountsDocument, options);
        }
export function useGetPublishedSummarySheetCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>(GetPublishedSummarySheetCountsDocument, options);
        }
export type GetPublishedSummarySheetCountsQueryHookResult = ReturnType<typeof useGetPublishedSummarySheetCountsQuery>;
export type GetPublishedSummarySheetCountsLazyQueryHookResult = ReturnType<typeof useGetPublishedSummarySheetCountsLazyQuery>;
export type GetPublishedSummarySheetCountsSuspenseQueryHookResult = ReturnType<typeof useGetPublishedSummarySheetCountsSuspenseQuery>;
export type GetPublishedSummarySheetCountsQueryResult = Apollo.QueryResult<GetPublishedSummarySheetCountsQuery, GetPublishedSummarySheetCountsQueryVariables>;
export const GetRiskAssessmentSummaryDataDocument = gql`
    query GetRiskAssessmentSummaryData($input: RiskAssessmentSummaryDataInput) {
  getRiskAssessmentSummaryData(input: $input) {
    _id
    completedCalculationsCount
    damageClassCount {
      count
      key
    }
    level1Component
    totalCalculationsCount
  }
}
    `;

/**
 * __useGetRiskAssessmentSummaryDataQuery__
 *
 * To run a query within a React component, call `useGetRiskAssessmentSummaryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskAssessmentSummaryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskAssessmentSummaryDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRiskAssessmentSummaryDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>(GetRiskAssessmentSummaryDataDocument, options);
      }
export function useGetRiskAssessmentSummaryDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>(GetRiskAssessmentSummaryDataDocument, options);
        }
export function useGetRiskAssessmentSummaryDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>(GetRiskAssessmentSummaryDataDocument, options);
        }
export type GetRiskAssessmentSummaryDataQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryDataQuery>;
export type GetRiskAssessmentSummaryDataLazyQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryDataLazyQuery>;
export type GetRiskAssessmentSummaryDataSuspenseQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryDataSuspenseQuery>;
export type GetRiskAssessmentSummaryDataQueryResult = Apollo.QueryResult<GetRiskAssessmentSummaryDataQuery, GetRiskAssessmentSummaryDataQueryVariables>;
export const GetRiskAssessmentSummaryTableDataDocument = gql`
    query GetRiskAssessmentSummaryTableData($input: RiskAssessmentSummaryTableDataInput) {
  getRiskAssessmentSummaryTableData(input: $input) {
    risk_level_1_component
    risk_level_2_component
    risk_structure
    risk_damage_class
    calculations {
      cof
      pof
      total
      transitionPeriod
    }
  }
}
    `;

/**
 * __useGetRiskAssessmentSummaryTableDataQuery__
 *
 * To run a query within a React component, call `useGetRiskAssessmentSummaryTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskAssessmentSummaryTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskAssessmentSummaryTableDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRiskAssessmentSummaryTableDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>(GetRiskAssessmentSummaryTableDataDocument, options);
      }
export function useGetRiskAssessmentSummaryTableDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>(GetRiskAssessmentSummaryTableDataDocument, options);
        }
export function useGetRiskAssessmentSummaryTableDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>(GetRiskAssessmentSummaryTableDataDocument, options);
        }
export type GetRiskAssessmentSummaryTableDataQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryTableDataQuery>;
export type GetRiskAssessmentSummaryTableDataLazyQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryTableDataLazyQuery>;
export type GetRiskAssessmentSummaryTableDataSuspenseQueryHookResult = ReturnType<typeof useGetRiskAssessmentSummaryTableDataSuspenseQuery>;
export type GetRiskAssessmentSummaryTableDataQueryResult = Apollo.QueryResult<GetRiskAssessmentSummaryTableDataQuery, GetRiskAssessmentSummaryTableDataQueryVariables>;
export const UpdateEsSheetStatusDocument = gql`
    mutation UpdateEsSheetStatus($structureId: String!, $status: EsSheetStatus!) {
  updateEsSheetStatus(structureId: $structureId, status: $status) {
    id
    name
    esSheetStatus
  }
}
    `;
export type UpdateEsSheetStatusMutationFn = Apollo.MutationFunction<UpdateEsSheetStatusMutation, UpdateEsSheetStatusMutationVariables>;

/**
 * __useUpdateEsSheetStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEsSheetStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsSheetStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsSheetStatusMutation, { data, loading, error }] = useUpdateEsSheetStatusMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateEsSheetStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsSheetStatusMutation, UpdateEsSheetStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsSheetStatusMutation, UpdateEsSheetStatusMutationVariables>(UpdateEsSheetStatusDocument, options);
      }
export type UpdateEsSheetStatusMutationHookResult = ReturnType<typeof useUpdateEsSheetStatusMutation>;
export type UpdateEsSheetStatusMutationResult = Apollo.MutationResult<UpdateEsSheetStatusMutation>;
export type UpdateEsSheetStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEsSheetStatusMutation, UpdateEsSheetStatusMutationVariables>;
export const GetAssemblyDataForInsightsDocument = gql`
    query getAssemblyDataForInsights($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    focalPoint {
      x
      y
      z
    }
    seenByViewpoints {
      location {
        id
        name
      }
      corrosion {
        primaryCategory
      }
      distance
    }
  }
}
    `;

/**
 * __useGetAssemblyDataForInsightsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyDataForInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyDataForInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyDataForInsightsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyDataForInsightsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>(GetAssemblyDataForInsightsDocument, options);
      }
export function useGetAssemblyDataForInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>(GetAssemblyDataForInsightsDocument, options);
        }
export function useGetAssemblyDataForInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>(GetAssemblyDataForInsightsDocument, options);
        }
export type GetAssemblyDataForInsightsQueryHookResult = ReturnType<typeof useGetAssemblyDataForInsightsQuery>;
export type GetAssemblyDataForInsightsLazyQueryHookResult = ReturnType<typeof useGetAssemblyDataForInsightsLazyQuery>;
export type GetAssemblyDataForInsightsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyDataForInsightsSuspenseQuery>;
export type GetAssemblyDataForInsightsQueryResult = Apollo.QueryResult<GetAssemblyDataForInsightsQuery, GetAssemblyDataForInsightsQueryVariables>;
export const GetAssembliesByTemplateFieldsFiltersForAitInsightsDocument = gql`
    query GetAssembliesByTemplateFieldsFiltersForAitInsights($input: AssembliesFilterInput) {
  getAssembliesByTemplateFieldsFilters(input: $input) {
    id
    tagName
    recommendation {
      analysisStatus
      governingValue {
        calculations {
          residualCorrosionAllowancePercentage
          residualCorrosionAllowance
        }
      }
      analysisRecommendation {
        alarmLevel
        recommendationByUserName
        wasAnalysisAlarmLevelManuallySet
      }
    }
    corrosionLevel
    service {
      code
      group
    }
    isUncontextualized
  }
}
    `;

/**
 * __useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>(GetAssembliesByTemplateFieldsFiltersForAitInsightsDocument, options);
      }
export function useGetAssembliesByTemplateFieldsFiltersForAitInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>(GetAssembliesByTemplateFieldsFiltersForAitInsightsDocument, options);
        }
export function useGetAssembliesByTemplateFieldsFiltersForAitInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>(GetAssembliesByTemplateFieldsFiltersForAitInsightsDocument, options);
        }
export type GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForAitInsightsQuery>;
export type GetAssembliesByTemplateFieldsFiltersForAitInsightsLazyQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForAitInsightsLazyQuery>;
export type GetAssembliesByTemplateFieldsFiltersForAitInsightsSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForAitInsightsSuspenseQuery>;
export type GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryResult = Apollo.QueryResult<GetAssembliesByTemplateFieldsFiltersForAitInsightsQuery, GetAssembliesByTemplateFieldsFiltersForAitInsightsQueryVariables>;
export const MarkViewPointAsAnalysedFromCurrentAssemblyDocument = gql`
    mutation MarkViewPointAsAnalysedFromCurrentAssembly($input: MarkViewPointAsAnalysedFromCurrentAssemblyInput) {
  markViewPointAsAnalysedFromCurrentAssembly(input: $input) {
    id
    seenByViewpoints {
      location {
        id
      }
      analysed {
        analysedBy
        updatedAt
      }
    }
  }
}
    `;
export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationFn = Apollo.MutationFunction<MarkViewPointAsAnalysedFromCurrentAssemblyMutation, MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables>;

/**
 * __useMarkViewPointAsAnalysedFromCurrentAssemblyMutation__
 *
 * To run a mutation, you first call `useMarkViewPointAsAnalysedFromCurrentAssemblyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkViewPointAsAnalysedFromCurrentAssemblyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markViewPointAsAnalysedFromCurrentAssemblyMutation, { data, loading, error }] = useMarkViewPointAsAnalysedFromCurrentAssemblyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkViewPointAsAnalysedFromCurrentAssemblyMutation(baseOptions?: Apollo.MutationHookOptions<MarkViewPointAsAnalysedFromCurrentAssemblyMutation, MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkViewPointAsAnalysedFromCurrentAssemblyMutation, MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables>(MarkViewPointAsAnalysedFromCurrentAssemblyDocument, options);
      }
export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationHookResult = ReturnType<typeof useMarkViewPointAsAnalysedFromCurrentAssemblyMutation>;
export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationResult = Apollo.MutationResult<MarkViewPointAsAnalysedFromCurrentAssemblyMutation>;
export type MarkViewPointAsAnalysedFromCurrentAssemblyMutationOptions = Apollo.BaseMutationOptions<MarkViewPointAsAnalysedFromCurrentAssemblyMutation, MarkViewPointAsAnalysedFromCurrentAssemblyMutationVariables>;
export const GetAllLocationInStructureDocument = gql`
    query getAllLocationInStructure($structureId: ID) {
  allLocations(structureId: $structureId) {
    id
    name
  }
}
    `;

/**
 * __useGetAllLocationInStructureQuery__
 *
 * To run a query within a React component, call `useGetAllLocationInStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationInStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationInStructureQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllLocationInStructureQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>(GetAllLocationInStructureDocument, options);
      }
export function useGetAllLocationInStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>(GetAllLocationInStructureDocument, options);
        }
export function useGetAllLocationInStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>(GetAllLocationInStructureDocument, options);
        }
export type GetAllLocationInStructureQueryHookResult = ReturnType<typeof useGetAllLocationInStructureQuery>;
export type GetAllLocationInStructureLazyQueryHookResult = ReturnType<typeof useGetAllLocationInStructureLazyQuery>;
export type GetAllLocationInStructureSuspenseQueryHookResult = ReturnType<typeof useGetAllLocationInStructureSuspenseQuery>;
export type GetAllLocationInStructureQueryResult = Apollo.QueryResult<GetAllLocationInStructureQuery, GetAllLocationInStructureQueryVariables>;
export const AssemblyDocument = gql`
    query Assembly($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
  }
}
    `;

/**
 * __useAssemblyQuery__
 *
 * To run a query within a React component, call `useAssemblyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssemblyQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useAssemblyQuery(baseOptions?: Apollo.QueryHookOptions<AssemblyQuery, AssemblyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssemblyQuery, AssemblyQueryVariables>(AssemblyDocument, options);
      }
export function useAssemblyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssemblyQuery, AssemblyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssemblyQuery, AssemblyQueryVariables>(AssemblyDocument, options);
        }
export function useAssemblySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyQuery, AssemblyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssemblyQuery, AssemblyQueryVariables>(AssemblyDocument, options);
        }
export type AssemblyQueryHookResult = ReturnType<typeof useAssemblyQuery>;
export type AssemblyLazyQueryHookResult = ReturnType<typeof useAssemblyLazyQuery>;
export type AssemblySuspenseQueryHookResult = ReturnType<typeof useAssemblySuspenseQuery>;
export type AssemblyQueryResult = Apollo.QueryResult<AssemblyQuery, AssemblyQueryVariables>;
export const PaintRegionDocument = gql`
    query PaintRegion($paintRegionId: String) {
  paintRegion(paintRegionId: $paintRegionId) {
    id
    volume {
      exclusions {
        z_range
        xy_polygon
      }
      inclusion {
        xy_polygon
        z_range
      }
    }
  }
}
    `;

/**
 * __usePaintRegionQuery__
 *
 * To run a query within a React component, call `usePaintRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintRegionQuery({
 *   variables: {
 *      paintRegionId: // value for 'paintRegionId'
 *   },
 * });
 */
export function usePaintRegionQuery(baseOptions?: Apollo.QueryHookOptions<PaintRegionQuery, PaintRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintRegionQuery, PaintRegionQueryVariables>(PaintRegionDocument, options);
      }
export function usePaintRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintRegionQuery, PaintRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintRegionQuery, PaintRegionQueryVariables>(PaintRegionDocument, options);
        }
export function usePaintRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintRegionQuery, PaintRegionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintRegionQuery, PaintRegionQueryVariables>(PaintRegionDocument, options);
        }
export type PaintRegionQueryHookResult = ReturnType<typeof usePaintRegionQuery>;
export type PaintRegionLazyQueryHookResult = ReturnType<typeof usePaintRegionLazyQuery>;
export type PaintRegionSuspenseQueryHookResult = ReturnType<typeof usePaintRegionSuspenseQuery>;
export type PaintRegionQueryResult = Apollo.QueryResult<PaintRegionQuery, PaintRegionQueryVariables>;
export const UpdatePointOfInterestLocationDocument = gql`
    mutation UpdatePointOfInterestLocation($input: UpdatePointOfInterestLocationInput!) {
  updatePointOfInterestLocation(input: $input) {
    id
    type
    status
    isVerified
    createdAt
    paintRegion {
      id
      name
    }
    template {
      id
      name
      fields {
        id
        unit
        name
        type
      }
    }
    centerPoint3d {
      x
      y
      z
    }
    name
    poiId
    isManuallyCreated
    isAutoGenerated
    assembly {
      id
      tagName
    }
    blister {
      borders3d {
        points {
          x
          y
          z
        }
      }
      maxHeight
      heightType
      pdrHeight
      estimatedHeight
      isManuallyOverridden
      verifiedMaxHeight
      verifiedResidualThickness
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
    }
    templateData {
      id
      value
      templateFieldId
    }
    visibility
    comment
    accessibility
  }
}
    `;
export type UpdatePointOfInterestLocationMutationFn = Apollo.MutationFunction<UpdatePointOfInterestLocationMutation, UpdatePointOfInterestLocationMutationVariables>;

/**
 * __useUpdatePointOfInterestLocationMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestLocationMutation, { data, loading, error }] = useUpdatePointOfInterestLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestLocationMutation, UpdatePointOfInterestLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestLocationMutation, UpdatePointOfInterestLocationMutationVariables>(UpdatePointOfInterestLocationDocument, options);
      }
export type UpdatePointOfInterestLocationMutationHookResult = ReturnType<typeof useUpdatePointOfInterestLocationMutation>;
export type UpdatePointOfInterestLocationMutationResult = Apollo.MutationResult<UpdatePointOfInterestLocationMutation>;
export type UpdatePointOfInterestLocationMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestLocationMutation, UpdatePointOfInterestLocationMutationVariables>;
export const GetStructureForInspectionDataLoaderDocument = gql`
    query getStructureForInspectionDataLoader($structureId: String!) {
  structure(structureId: $structureId) {
    id
    octreeResourcesPath
    nodesPerAssemblyPath
    defectLegends {
      id
      groupName
      groupKey
      name
      color
      octreeKey
      octreeValue
      legendText
    }
    partLegends {
      name
      color
    }
    hasRiskAssessment
    hasRGB
    structureRelationshipPath
    assemblyCadModelsBasePath
    photogrammetryTilesPath
    voxelLocationsPath
    voxelSize
    blisterHeightType
    largeVoxelSize
    config {
      northRotation
      spatialHeatmapStep {
        x
        y
        z
      }
      neighbouringImagesOptions {
        showFrames
        showImages
        isEnabledByDefault
        maxImagesToShow
        defaultMeanDistance
      }
      disableClickOnHiddenPoints
    }
  }
}
    `;

/**
 * __useGetStructureForInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureForInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureForInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureForInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureForInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables> & ({ variables: GetStructureForInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>(GetStructureForInspectionDataLoaderDocument, options);
      }
export function useGetStructureForInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>(GetStructureForInspectionDataLoaderDocument, options);
        }
export function useGetStructureForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>(GetStructureForInspectionDataLoaderDocument, options);
        }
export type GetStructureForInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureForInspectionDataLoaderQuery>;
export type GetStructureForInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureForInspectionDataLoaderLazyQuery>;
export type GetStructureForInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureForInspectionDataLoaderSuspenseQuery>;
export type GetStructureForInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureForInspectionDataLoaderQuery, GetStructureForInspectionDataLoaderQueryVariables>;
export const GetStructureLocationsForInspectionDataLoaderDocument = gql`
    query getStructureLocationsForInspectionDataLoader($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    baseResourcePath
    angleResourcePath
    scanKey
    layers {
      fileExt
      type
      displayName
    }
    paintRegion {
      name
    }
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
    distance
    videoResourcePath
    videoTimestamp
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
    deck {
      name
    }
  }
}
    `;

/**
 * __useGetStructureLocationsForInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureLocationsForInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureLocationsForInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureLocationsForInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureLocationsForInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables> & ({ variables: GetStructureLocationsForInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>(GetStructureLocationsForInspectionDataLoaderDocument, options);
      }
export function useGetStructureLocationsForInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>(GetStructureLocationsForInspectionDataLoaderDocument, options);
        }
export function useGetStructureLocationsForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>(GetStructureLocationsForInspectionDataLoaderDocument, options);
        }
export type GetStructureLocationsForInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureLocationsForInspectionDataLoaderQuery>;
export type GetStructureLocationsForInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureLocationsForInspectionDataLoaderLazyQuery>;
export type GetStructureLocationsForInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureLocationsForInspectionDataLoaderSuspenseQuery>;
export type GetStructureLocationsForInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureLocationsForInspectionDataLoaderQuery, GetStructureLocationsForInspectionDataLoaderQueryVariables>;
export const GetAllDecksDocument = gql`
    query getAllDecks($structureId: ID) {
  allDecks(structureId: $structureId) {
    cadFloorHeight
    id
    name
  }
}
    `;

/**
 * __useGetAllDecksQuery__
 *
 * To run a query within a React component, call `useGetAllDecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDecksQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllDecksQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDecksQuery, GetAllDecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDecksQuery, GetAllDecksQueryVariables>(GetAllDecksDocument, options);
      }
export function useGetAllDecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDecksQuery, GetAllDecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDecksQuery, GetAllDecksQueryVariables>(GetAllDecksDocument, options);
        }
export function useGetAllDecksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDecksQuery, GetAllDecksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDecksQuery, GetAllDecksQueryVariables>(GetAllDecksDocument, options);
        }
export type GetAllDecksQueryHookResult = ReturnType<typeof useGetAllDecksQuery>;
export type GetAllDecksLazyQueryHookResult = ReturnType<typeof useGetAllDecksLazyQuery>;
export type GetAllDecksSuspenseQueryHookResult = ReturnType<typeof useGetAllDecksSuspenseQuery>;
export type GetAllDecksQueryResult = Apollo.QueryResult<GetAllDecksQuery, GetAllDecksQueryVariables>;
export const GetAllPointOfInterestTemplatesDocument = gql`
    query getAllPointOfInterestTemplates($structureId: ID!) {
  allPointOfInterestTemplate(structureId: $structureId) {
    id
    name
    type
    key
    isCsvUploadable
    icon {
      name
      color
    }
    accentColor
    fields {
      options
      optionsData {
        value
        weight
        min
        max
        minIncluded
        maxIncluded
      }
      name
      type
      id
      isReadOnly
      isHidden
      defaultVisible
      displayInQuery
      displayInTable
      displayInReview
      displayInReports
      serverSide
      isRequired
      key
      detailFieldKey
      isMeasurementToolEnabled
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
      }
      unit
    }
    permissions
    markerLabelConfig {
      type
      hideName
      fields {
        key
        type
      }
      headerField {
        key
        type
      }
    }
  }
}
    `;

/**
 * __useGetAllPointOfInterestTemplatesQuery__
 *
 * To run a query within a React component, call `useGetAllPointOfInterestTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPointOfInterestTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPointOfInterestTemplatesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllPointOfInterestTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables> & ({ variables: GetAllPointOfInterestTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>(GetAllPointOfInterestTemplatesDocument, options);
      }
export function useGetAllPointOfInterestTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>(GetAllPointOfInterestTemplatesDocument, options);
        }
export function useGetAllPointOfInterestTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>(GetAllPointOfInterestTemplatesDocument, options);
        }
export type GetAllPointOfInterestTemplatesQueryHookResult = ReturnType<typeof useGetAllPointOfInterestTemplatesQuery>;
export type GetAllPointOfInterestTemplatesLazyQueryHookResult = ReturnType<typeof useGetAllPointOfInterestTemplatesLazyQuery>;
export type GetAllPointOfInterestTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetAllPointOfInterestTemplatesSuspenseQuery>;
export type GetAllPointOfInterestTemplatesQueryResult = Apollo.QueryResult<GetAllPointOfInterestTemplatesQuery, GetAllPointOfInterestTemplatesQueryVariables>;
export const GetAllTemplatesForReportDocumentDocument = gql`
    query getAllTemplatesForReportDocument($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    fields {
      options
      name
      type
      id
      isReadOnly
      isHidden
      defaultVisible
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
      }
      unit
    }
    permissions
  }
}
    `;

/**
 * __useGetAllTemplatesForReportDocumentQuery__
 *
 * To run a query within a React component, call `useGetAllTemplatesForReportDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTemplatesForReportDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTemplatesForReportDocumentQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAllTemplatesForReportDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables> & ({ variables: GetAllTemplatesForReportDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>(GetAllTemplatesForReportDocumentDocument, options);
      }
export function useGetAllTemplatesForReportDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>(GetAllTemplatesForReportDocumentDocument, options);
        }
export function useGetAllTemplatesForReportDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>(GetAllTemplatesForReportDocumentDocument, options);
        }
export type GetAllTemplatesForReportDocumentQueryHookResult = ReturnType<typeof useGetAllTemplatesForReportDocumentQuery>;
export type GetAllTemplatesForReportDocumentLazyQueryHookResult = ReturnType<typeof useGetAllTemplatesForReportDocumentLazyQuery>;
export type GetAllTemplatesForReportDocumentSuspenseQueryHookResult = ReturnType<typeof useGetAllTemplatesForReportDocumentSuspenseQuery>;
export type GetAllTemplatesForReportDocumentQueryResult = Apollo.QueryResult<GetAllTemplatesForReportDocumentQuery, GetAllTemplatesForReportDocumentQueryVariables>;
export const AllPointsOfInterestForInspectionDataLoaderDocument = gql`
    query AllPointsOfInterestForInspectionDataLoader($structureId: ID, $assemblyIds: [ID]) {
  allPointOfInterests(structureId: $structureId, assemblyIds: $assemblyIds) {
    id
    poiId
    type
    assignee
    dueDate
    status
    isVerified
    deckRelativeHeight
    workpackNumber
    paintRegion {
      name
    }
    template {
      id
      fields {
        id
        name
        type
      }
    }
    location {
      id
    }
    name
    centerPoint3d {
      x
      y
      z
    }
    cameraLocation {
      x
      y
      z
    }
    assembly {
      id
      tagName
    }
    blister {
      maxHeight
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
      centerPoint {
        bearing
        elevation
      }
      radiusPoint {
        bearing
        elevation
      }
      borders3d {
        points {
          x
          y
          z
        }
      }
      pdrHeight
      heightType
      isManuallyOverridden
      estimatedHeight
      manualSetHeight
      radius
      fittingRadius
      scCategory
    }
    templateData {
      id
      value
      verifiedValue
      templateFieldId
    }
    createdByUser {
      id
      name
      picture
      email
      connection
      roleIds {
        name
      }
    }
    createdAt
    screenshotPaths {
      viewer
      viewpoint
    }
    visibility
    teams {
      id
      name
    }
    remediationNote
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
    comment
    accessibility
    viewpointRelativeHeight
  }
}
    `;

/**
 * __useAllPointsOfInterestForInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useAllPointsOfInterestForInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointsOfInterestForInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointsOfInterestForInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      assemblyIds: // value for 'assemblyIds'
 *   },
 * });
 */
export function useAllPointsOfInterestForInspectionDataLoaderQuery(baseOptions?: Apollo.QueryHookOptions<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>(AllPointsOfInterestForInspectionDataLoaderDocument, options);
      }
export function useAllPointsOfInterestForInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>(AllPointsOfInterestForInspectionDataLoaderDocument, options);
        }
export function useAllPointsOfInterestForInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>(AllPointsOfInterestForInspectionDataLoaderDocument, options);
        }
export type AllPointsOfInterestForInspectionDataLoaderQueryHookResult = ReturnType<typeof useAllPointsOfInterestForInspectionDataLoaderQuery>;
export type AllPointsOfInterestForInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useAllPointsOfInterestForInspectionDataLoaderLazyQuery>;
export type AllPointsOfInterestForInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useAllPointsOfInterestForInspectionDataLoaderSuspenseQuery>;
export type AllPointsOfInterestForInspectionDataLoaderQueryResult = Apollo.QueryResult<AllPointsOfInterestForInspectionDataLoaderQuery, AllPointsOfInterestForInspectionDataLoaderQueryVariables>;
export const AllPointOfInterestsForDataLoaderDocument = gql`
    query allPointOfInterestsForDataLoader($input: PointOfInterestInput, $pageInfo: PageInfo) {
  pointOfInterests(input: $input, pageInfo: $pageInfo) {
    id
    type
    name
    poiId
    status
    isVerified
    isGoverning
    createdAt
    accessibility
    dueDate
    paintRegion {
      name
    }
    locationId
    paintRegion {
      id
    }
    paintRegions {
      id
      name
    }
    blister {
      maxHeight
      heightType
      estimatedHeight
      pdrHeight
      isManuallyOverridden
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
      borders3d {
        points {
          x
          y
          z
        }
      }
    }
    assembly {
      id
      tagName
    }
    templateId
    templateData {
      id
      value
    }
    deckRelativeHeight
    workpack {
      id
    }
    workpackNumber
    centerPoint3d {
      x
      y
      z
    }
    cuboids {
      id
      position
      rotation
      scale
    }
    templateData {
      id
      value
    }
    visibility
    createdByUser {
      id
      name
      picture
      email
      connection
      roleIds {
        name
      }
    }
    location {
      id
      name
    }
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      caption
      imageType
      uuid
    }
    screenshotPaths {
      viewer
      viewpoint
    }
    accessibility
    viewpointRelativeHeight
  }
}
    `;

/**
 * __useAllPointOfInterestsForDataLoaderQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestsForDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestsForDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestsForDataLoaderQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useAllPointOfInterestsForDataLoaderQuery(baseOptions?: Apollo.QueryHookOptions<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>(AllPointOfInterestsForDataLoaderDocument, options);
      }
export function useAllPointOfInterestsForDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>(AllPointOfInterestsForDataLoaderDocument, options);
        }
export function useAllPointOfInterestsForDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>(AllPointOfInterestsForDataLoaderDocument, options);
        }
export type AllPointOfInterestsForDataLoaderQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDataLoaderQuery>;
export type AllPointOfInterestsForDataLoaderLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDataLoaderLazyQuery>;
export type AllPointOfInterestsForDataLoaderSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestsForDataLoaderSuspenseQuery>;
export type AllPointOfInterestsForDataLoaderQueryResult = Apollo.QueryResult<AllPointOfInterestsForDataLoaderQuery, AllPointOfInterestsForDataLoaderQueryVariables>;
export const GetStructureRelationshipsForAnalysisDataLoaderDocument = gql`
    query getStructureRelationshipsForAnalysisDataLoader($structureId: String!) {
  allAnnotations(structureId: $structureId) {
    id
    annotationId
    partId
    locationId
  }
  allParts(structureId: $structureId) {
    id
    assemblyId
    class
  }
  allAssemblies(structureId: $structureId) {
    id
    tagName
    integerId
  }
}
    `;

/**
 * __useGetStructureRelationshipsForAnalysisDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureRelationshipsForAnalysisDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureRelationshipsForAnalysisDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureRelationshipsForAnalysisDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureRelationshipsForAnalysisDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables> & ({ variables: GetStructureRelationshipsForAnalysisDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>(GetStructureRelationshipsForAnalysisDataLoaderDocument, options);
      }
export function useGetStructureRelationshipsForAnalysisDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>(GetStructureRelationshipsForAnalysisDataLoaderDocument, options);
        }
export function useGetStructureRelationshipsForAnalysisDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>(GetStructureRelationshipsForAnalysisDataLoaderDocument, options);
        }
export type GetStructureRelationshipsForAnalysisDataLoaderQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForAnalysisDataLoaderQuery>;
export type GetStructureRelationshipsForAnalysisDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForAnalysisDataLoaderLazyQuery>;
export type GetStructureRelationshipsForAnalysisDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForAnalysisDataLoaderSuspenseQuery>;
export type GetStructureRelationshipsForAnalysisDataLoaderQueryResult = Apollo.QueryResult<GetStructureRelationshipsForAnalysisDataLoaderQuery, GetStructureRelationshipsForAnalysisDataLoaderQueryVariables>;
export const UpdateAssemblyDocument = gql`
    mutation updateAssembly($input: UpdateAssemblyInput) {
  updateAssembly(input: $input) {
    id
    templateFieldData
  }
}
    `;
export type UpdateAssemblyMutationFn = Apollo.MutationFunction<UpdateAssemblyMutation, UpdateAssemblyMutationVariables>;

/**
 * __useUpdateAssemblyMutation__
 *
 * To run a mutation, you first call `useUpdateAssemblyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssemblyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssemblyMutation, { data, loading, error }] = useUpdateAssemblyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssemblyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssemblyMutation, UpdateAssemblyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssemblyMutation, UpdateAssemblyMutationVariables>(UpdateAssemblyDocument, options);
      }
export type UpdateAssemblyMutationHookResult = ReturnType<typeof useUpdateAssemblyMutation>;
export type UpdateAssemblyMutationResult = Apollo.MutationResult<UpdateAssemblyMutation>;
export type UpdateAssemblyMutationOptions = Apollo.BaseMutationOptions<UpdateAssemblyMutation, UpdateAssemblyMutationVariables>;
export const GetAssemblyPipeSpecDocument = gql`
    query getAssemblyPipeSpec($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    pipeSpec {
      size
      material
      spec
      nominalCorrosionAllowance
      schedule
      nominalThickness
    }
  }
}
    `;

/**
 * __useGetAssemblyPipeSpecQuery__
 *
 * To run a query within a React component, call `useGetAssemblyPipeSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyPipeSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyPipeSpecQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyPipeSpecQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables> & ({ variables: GetAssemblyPipeSpecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>(GetAssemblyPipeSpecDocument, options);
      }
export function useGetAssemblyPipeSpecLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>(GetAssemblyPipeSpecDocument, options);
        }
export function useGetAssemblyPipeSpecSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>(GetAssemblyPipeSpecDocument, options);
        }
export type GetAssemblyPipeSpecQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecQuery>;
export type GetAssemblyPipeSpecLazyQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecLazyQuery>;
export type GetAssemblyPipeSpecSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecSuspenseQuery>;
export type GetAssemblyPipeSpecQueryResult = Apollo.QueryResult<GetAssemblyPipeSpecQuery, GetAssemblyPipeSpecQueryVariables>;
export const GetAssemblyAlarmLevelDocument = gql`
    query getAssemblyAlarmLevel($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    recommendation {
      analysisRecommendation {
        alarmLevel
        wasAnalysisAlarmLevelManuallySet
      }
    }
  }
}
    `;

/**
 * __useGetAssemblyAlarmLevelQuery__
 *
 * To run a query within a React component, call `useGetAssemblyAlarmLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyAlarmLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyAlarmLevelQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyAlarmLevelQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables> & ({ variables: GetAssemblyAlarmLevelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>(GetAssemblyAlarmLevelDocument, options);
      }
export function useGetAssemblyAlarmLevelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>(GetAssemblyAlarmLevelDocument, options);
        }
export function useGetAssemblyAlarmLevelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>(GetAssemblyAlarmLevelDocument, options);
        }
export type GetAssemblyAlarmLevelQueryHookResult = ReturnType<typeof useGetAssemblyAlarmLevelQuery>;
export type GetAssemblyAlarmLevelLazyQueryHookResult = ReturnType<typeof useGetAssemblyAlarmLevelLazyQuery>;
export type GetAssemblyAlarmLevelSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyAlarmLevelSuspenseQuery>;
export type GetAssemblyAlarmLevelQueryResult = Apollo.QueryResult<GetAssemblyAlarmLevelQuery, GetAssemblyAlarmLevelQueryVariables>;
export const FindAssemblyForViewPointsDocument = gql`
    query FindAssemblyForViewPoints($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    seenByViewpoints {
      analysed {
        analysedBy
      }
      location {
        id
      }
      focalPoint {
        x
        y
        z
      }
    }
  }
}
    `;

/**
 * __useFindAssemblyForViewPointsQuery__
 *
 * To run a query within a React component, call `useFindAssemblyForViewPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAssemblyForViewPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAssemblyForViewPointsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useFindAssemblyForViewPointsQuery(baseOptions?: Apollo.QueryHookOptions<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>(FindAssemblyForViewPointsDocument, options);
      }
export function useFindAssemblyForViewPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>(FindAssemblyForViewPointsDocument, options);
        }
export function useFindAssemblyForViewPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>(FindAssemblyForViewPointsDocument, options);
        }
export type FindAssemblyForViewPointsQueryHookResult = ReturnType<typeof useFindAssemblyForViewPointsQuery>;
export type FindAssemblyForViewPointsLazyQueryHookResult = ReturnType<typeof useFindAssemblyForViewPointsLazyQuery>;
export type FindAssemblyForViewPointsSuspenseQueryHookResult = ReturnType<typeof useFindAssemblyForViewPointsSuspenseQuery>;
export type FindAssemblyForViewPointsQueryResult = Apollo.QueryResult<FindAssemblyForViewPointsQuery, FindAssemblyForViewPointsQueryVariables>;
export const PaintBlockTemplateDocument = gql`
    query PaintBlockTemplate($structureId: ID, $type: TemplateTypeEnum) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    fields {
      id
      name
      key
    }
  }
}
    `;

/**
 * __usePaintBlockTemplateQuery__
 *
 * To run a query within a React component, call `usePaintBlockTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintBlockTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintBlockTemplateQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePaintBlockTemplateQuery(baseOptions?: Apollo.QueryHookOptions<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>(PaintBlockTemplateDocument, options);
      }
export function usePaintBlockTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>(PaintBlockTemplateDocument, options);
        }
export function usePaintBlockTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>(PaintBlockTemplateDocument, options);
        }
export type PaintBlockTemplateQueryHookResult = ReturnType<typeof usePaintBlockTemplateQuery>;
export type PaintBlockTemplateLazyQueryHookResult = ReturnType<typeof usePaintBlockTemplateLazyQuery>;
export type PaintBlockTemplateSuspenseQueryHookResult = ReturnType<typeof usePaintBlockTemplateSuspenseQuery>;
export type PaintBlockTemplateQueryResult = Apollo.QueryResult<PaintBlockTemplateQuery, PaintBlockTemplateQueryVariables>;
export const PaintBlockPointsDocument = gql`
    query PaintBlockPoints($paintRegionId: String) {
  paintRegion(paintRegionId: $paintRegionId) {
    volume {
      exclusions {
        xy_polygon
        z_range
      }
      inclusion {
        z_range
        xy_polygon
      }
    }
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
  }
}
    `;

/**
 * __usePaintBlockPointsQuery__
 *
 * To run a query within a React component, call `usePaintBlockPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintBlockPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintBlockPointsQuery({
 *   variables: {
 *      paintRegionId: // value for 'paintRegionId'
 *   },
 * });
 */
export function usePaintBlockPointsQuery(baseOptions?: Apollo.QueryHookOptions<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>(PaintBlockPointsDocument, options);
      }
export function usePaintBlockPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>(PaintBlockPointsDocument, options);
        }
export function usePaintBlockPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>(PaintBlockPointsDocument, options);
        }
export type PaintBlockPointsQueryHookResult = ReturnType<typeof usePaintBlockPointsQuery>;
export type PaintBlockPointsLazyQueryHookResult = ReturnType<typeof usePaintBlockPointsLazyQuery>;
export type PaintBlockPointsSuspenseQueryHookResult = ReturnType<typeof usePaintBlockPointsSuspenseQuery>;
export type PaintBlockPointsQueryResult = Apollo.QueryResult<PaintBlockPointsQuery, PaintBlockPointsQueryVariables>;
export const PaintRegionGroupsDocument = gql`
    query PaintRegionGroups($input: PaintRegionGroupFiltersInput!) {
  paintRegionGroups(input: $input) {
    name
    id
    isDefault
  }
}
    `;

/**
 * __usePaintRegionGroupsQuery__
 *
 * To run a query within a React component, call `usePaintRegionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaintRegionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaintRegionGroupsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaintRegionGroupsQuery(baseOptions: Apollo.QueryHookOptions<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables> & ({ variables: PaintRegionGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>(PaintRegionGroupsDocument, options);
      }
export function usePaintRegionGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>(PaintRegionGroupsDocument, options);
        }
export function usePaintRegionGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>(PaintRegionGroupsDocument, options);
        }
export type PaintRegionGroupsQueryHookResult = ReturnType<typeof usePaintRegionGroupsQuery>;
export type PaintRegionGroupsLazyQueryHookResult = ReturnType<typeof usePaintRegionGroupsLazyQuery>;
export type PaintRegionGroupsSuspenseQueryHookResult = ReturnType<typeof usePaintRegionGroupsSuspenseQuery>;
export type PaintRegionGroupsQueryResult = Apollo.QueryResult<PaintRegionGroupsQuery, PaintRegionGroupsQueryVariables>;
export const SavedBlockPoIsDocument = gql`
    query SavedBlockPOIs($input: PointOfInterestInput, $pageInfo: PageInfo) {
  pointOfInterests(input: $input, pageInfo: $pageInfo) {
    id
    poiId
    type
    name
    paintRegion {
      id
      deck {
        id
        cadTransform
      }
    }
    template {
      id
      fields {
        id
        name
        key
        type
        unit
      }
    }
    templateData {
      id
      value
      templateFieldId
    }
    workpackNumber
  }
  pointOfInterestsCount(input: $input) {
    count
  }
}
    `;

/**
 * __useSavedBlockPoIsQuery__
 *
 * To run a query within a React component, call `useSavedBlockPoIsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedBlockPoIsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedBlockPoIsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useSavedBlockPoIsQuery(baseOptions?: Apollo.QueryHookOptions<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>(SavedBlockPoIsDocument, options);
      }
export function useSavedBlockPoIsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>(SavedBlockPoIsDocument, options);
        }
export function useSavedBlockPoIsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>(SavedBlockPoIsDocument, options);
        }
export type SavedBlockPoIsQueryHookResult = ReturnType<typeof useSavedBlockPoIsQuery>;
export type SavedBlockPoIsLazyQueryHookResult = ReturnType<typeof useSavedBlockPoIsLazyQuery>;
export type SavedBlockPoIsSuspenseQueryHookResult = ReturnType<typeof useSavedBlockPoIsSuspenseQuery>;
export type SavedBlockPoIsQueryResult = Apollo.QueryResult<SavedBlockPoIsQuery, SavedBlockPoIsQueryVariables>;
export const PointOfInterestCuboidsDocument = gql`
    query PointOfInterestCuboids($pointOfInterestId: ID!) {
  pointOfInterest(pointOfInterestId: $pointOfInterestId) {
    id
    status
    cuboids {
      id
      position
      rotation
      scale
    }
  }
}
    `;

/**
 * __usePointOfInterestCuboidsQuery__
 *
 * To run a query within a React component, call `usePointOfInterestCuboidsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestCuboidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestCuboidsQuery({
 *   variables: {
 *      pointOfInterestId: // value for 'pointOfInterestId'
 *   },
 * });
 */
export function usePointOfInterestCuboidsQuery(baseOptions: Apollo.QueryHookOptions<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables> & ({ variables: PointOfInterestCuboidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>(PointOfInterestCuboidsDocument, options);
      }
export function usePointOfInterestCuboidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>(PointOfInterestCuboidsDocument, options);
        }
export function usePointOfInterestCuboidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>(PointOfInterestCuboidsDocument, options);
        }
export type PointOfInterestCuboidsQueryHookResult = ReturnType<typeof usePointOfInterestCuboidsQuery>;
export type PointOfInterestCuboidsLazyQueryHookResult = ReturnType<typeof usePointOfInterestCuboidsLazyQuery>;
export type PointOfInterestCuboidsSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestCuboidsSuspenseQuery>;
export type PointOfInterestCuboidsQueryResult = Apollo.QueryResult<PointOfInterestCuboidsQuery, PointOfInterestCuboidsQueryVariables>;
export const GetAllAnnotationInLocationDocument = gql`
    query getAllAnnotationInLocation($locationId: String, $structureId: String) {
  allAnnotations(locationId: $locationId, structureId: $structureId) {
    annotationId
    id
  }
}
    `;

/**
 * __useGetAllAnnotationInLocationQuery__
 *
 * To run a query within a React component, call `useGetAllAnnotationInLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAnnotationInLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAnnotationInLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllAnnotationInLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>(GetAllAnnotationInLocationDocument, options);
      }
export function useGetAllAnnotationInLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>(GetAllAnnotationInLocationDocument, options);
        }
export function useGetAllAnnotationInLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>(GetAllAnnotationInLocationDocument, options);
        }
export type GetAllAnnotationInLocationQueryHookResult = ReturnType<typeof useGetAllAnnotationInLocationQuery>;
export type GetAllAnnotationInLocationLazyQueryHookResult = ReturnType<typeof useGetAllAnnotationInLocationLazyQuery>;
export type GetAllAnnotationInLocationSuspenseQueryHookResult = ReturnType<typeof useGetAllAnnotationInLocationSuspenseQuery>;
export type GetAllAnnotationInLocationQueryResult = Apollo.QueryResult<GetAllAnnotationInLocationQuery, GetAllAnnotationInLocationQueryVariables>;
export const GetAbyssViewerColoursForAnalysisDocument = gql`
    query getAbyssViewerColoursForAnalysis($type: SettingTypesEnum!) {
  setting(type: $type) {
    id
    name
    type
    revision
    meta {
      __typename
      ... on StringMeta {
        key
        colour: value
      }
      ... on StringArrayMeta {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetAbyssViewerColoursForAnalysisQuery__
 *
 * To run a query within a React component, call `useGetAbyssViewerColoursForAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAbyssViewerColoursForAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAbyssViewerColoursForAnalysisQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAbyssViewerColoursForAnalysisQuery(baseOptions: Apollo.QueryHookOptions<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables> & ({ variables: GetAbyssViewerColoursForAnalysisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>(GetAbyssViewerColoursForAnalysisDocument, options);
      }
export function useGetAbyssViewerColoursForAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>(GetAbyssViewerColoursForAnalysisDocument, options);
        }
export function useGetAbyssViewerColoursForAnalysisSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>(GetAbyssViewerColoursForAnalysisDocument, options);
        }
export type GetAbyssViewerColoursForAnalysisQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForAnalysisQuery>;
export type GetAbyssViewerColoursForAnalysisLazyQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForAnalysisLazyQuery>;
export type GetAbyssViewerColoursForAnalysisSuspenseQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForAnalysisSuspenseQuery>;
export type GetAbyssViewerColoursForAnalysisQueryResult = Apollo.QueryResult<GetAbyssViewerColoursForAnalysisQuery, GetAbyssViewerColoursForAnalysisQueryVariables>;
export const GetDefectColoursDocument = gql`
    query getDefectColours($type: SettingTypesEnum!) {
  setting(type: $type) {
    id
    name
    type
    revision
    meta {
      __typename
      ... on DefectColorMeta {
        key
        value {
          octreeIndex
          name
          colour
        }
      }
    }
  }
}
    `;

/**
 * __useGetDefectColoursQuery__
 *
 * To run a query within a React component, call `useGetDefectColoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefectColoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefectColoursQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDefectColoursQuery(baseOptions: Apollo.QueryHookOptions<GetDefectColoursQuery, GetDefectColoursQueryVariables> & ({ variables: GetDefectColoursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefectColoursQuery, GetDefectColoursQueryVariables>(GetDefectColoursDocument, options);
      }
export function useGetDefectColoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefectColoursQuery, GetDefectColoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefectColoursQuery, GetDefectColoursQueryVariables>(GetDefectColoursDocument, options);
        }
export function useGetDefectColoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefectColoursQuery, GetDefectColoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefectColoursQuery, GetDefectColoursQueryVariables>(GetDefectColoursDocument, options);
        }
export type GetDefectColoursQueryHookResult = ReturnType<typeof useGetDefectColoursQuery>;
export type GetDefectColoursLazyQueryHookResult = ReturnType<typeof useGetDefectColoursLazyQuery>;
export type GetDefectColoursSuspenseQueryHookResult = ReturnType<typeof useGetDefectColoursSuspenseQuery>;
export type GetDefectColoursQueryResult = Apollo.QueryResult<GetDefectColoursQuery, GetDefectColoursQueryVariables>;
export const GetAssemblyContextualizedStatusDocument = gql`
    query getAssemblyContextualizedStatus($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    isUncontextualized
  }
}
    `;

/**
 * __useGetAssemblyContextualizedStatusQuery__
 *
 * To run a query within a React component, call `useGetAssemblyContextualizedStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyContextualizedStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyContextualizedStatusQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyContextualizedStatusQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables> & ({ variables: GetAssemblyContextualizedStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>(GetAssemblyContextualizedStatusDocument, options);
      }
export function useGetAssemblyContextualizedStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>(GetAssemblyContextualizedStatusDocument, options);
        }
export function useGetAssemblyContextualizedStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>(GetAssemblyContextualizedStatusDocument, options);
        }
export type GetAssemblyContextualizedStatusQueryHookResult = ReturnType<typeof useGetAssemblyContextualizedStatusQuery>;
export type GetAssemblyContextualizedStatusLazyQueryHookResult = ReturnType<typeof useGetAssemblyContextualizedStatusLazyQuery>;
export type GetAssemblyContextualizedStatusSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyContextualizedStatusSuspenseQuery>;
export type GetAssemblyContextualizedStatusQueryResult = Apollo.QueryResult<GetAssemblyContextualizedStatusQuery, GetAssemblyContextualizedStatusQueryVariables>;
export const BulkUploadPoisDocument = gql`
    mutation BulkUploadPois($input: BulkUploadPoisInput!) {
  bulkUploadPois(input: $input) {
    poiId
  }
}
    `;
export type BulkUploadPoisMutationFn = Apollo.MutationFunction<BulkUploadPoisMutation, BulkUploadPoisMutationVariables>;

/**
 * __useBulkUploadPoisMutation__
 *
 * To run a mutation, you first call `useBulkUploadPoisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUploadPoisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUploadPoisMutation, { data, loading, error }] = useBulkUploadPoisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUploadPoisMutation(baseOptions?: Apollo.MutationHookOptions<BulkUploadPoisMutation, BulkUploadPoisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUploadPoisMutation, BulkUploadPoisMutationVariables>(BulkUploadPoisDocument, options);
      }
export type BulkUploadPoisMutationHookResult = ReturnType<typeof useBulkUploadPoisMutation>;
export type BulkUploadPoisMutationResult = Apollo.MutationResult<BulkUploadPoisMutation>;
export type BulkUploadPoisMutationOptions = Apollo.BaseMutationOptions<BulkUploadPoisMutation, BulkUploadPoisMutationVariables>;
export const ValidateBulkPoiUploadDocument = gql`
    query ValidateBulkPoiUpload($input: BulkUploadPoisInput!) {
  validateBulkPoiUpload(input: $input)
}
    `;

/**
 * __useValidateBulkPoiUploadQuery__
 *
 * To run a query within a React component, call `useValidateBulkPoiUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateBulkPoiUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateBulkPoiUploadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateBulkPoiUploadQuery(baseOptions: Apollo.QueryHookOptions<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables> & ({ variables: ValidateBulkPoiUploadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>(ValidateBulkPoiUploadDocument, options);
      }
export function useValidateBulkPoiUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>(ValidateBulkPoiUploadDocument, options);
        }
export function useValidateBulkPoiUploadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>(ValidateBulkPoiUploadDocument, options);
        }
export type ValidateBulkPoiUploadQueryHookResult = ReturnType<typeof useValidateBulkPoiUploadQuery>;
export type ValidateBulkPoiUploadLazyQueryHookResult = ReturnType<typeof useValidateBulkPoiUploadLazyQuery>;
export type ValidateBulkPoiUploadSuspenseQueryHookResult = ReturnType<typeof useValidateBulkPoiUploadSuspenseQuery>;
export type ValidateBulkPoiUploadQueryResult = Apollo.QueryResult<ValidateBulkPoiUploadQuery, ValidateBulkPoiUploadQueryVariables>;
export const GetAllDraftReportsDocument = gql`
    query getAllDraftReports($input: reportsInput) {
  allReports(input: $input) {
    id
    name
  }
}
    `;

/**
 * __useGetAllDraftReportsQuery__
 *
 * To run a query within a React component, call `useGetAllDraftReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDraftReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDraftReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllDraftReportsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>(GetAllDraftReportsDocument, options);
      }
export function useGetAllDraftReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>(GetAllDraftReportsDocument, options);
        }
export function useGetAllDraftReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>(GetAllDraftReportsDocument, options);
        }
export type GetAllDraftReportsQueryHookResult = ReturnType<typeof useGetAllDraftReportsQuery>;
export type GetAllDraftReportsLazyQueryHookResult = ReturnType<typeof useGetAllDraftReportsLazyQuery>;
export type GetAllDraftReportsSuspenseQueryHookResult = ReturnType<typeof useGetAllDraftReportsSuspenseQuery>;
export type GetAllDraftReportsQueryResult = Apollo.QueryResult<GetAllDraftReportsQuery, GetAllDraftReportsQueryVariables>;
export const CreatePointOfInterestDocument = gql`
    mutation CreatePointOfInterest($input: CreatePointOfInterestInput) {
  createPointOfInterest(input: $input) {
    id
    poiId
    type
    name
    templateId
    locationId
    createdAt
    assembly {
      id
      tagName
    }
    centerPoint3d {
      x
      y
      z
    }
    blister {
      maxHeight
      estimatedHeight
      pdrHeight
      heightType
      isManuallyOverridden
      borders3d {
        points {
          x
          y
          z
        }
      }
    }
    cuboids {
      id
      position
      rotation
      scale
    }
  }
}
    `;
export type CreatePointOfInterestMutationFn = Apollo.MutationFunction<CreatePointOfInterestMutation, CreatePointOfInterestMutationVariables>;

/**
 * __useCreatePointOfInterestMutation__
 *
 * To run a mutation, you first call `useCreatePointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointOfInterestMutation, { data, loading, error }] = useCreatePointOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<CreatePointOfInterestMutation, CreatePointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePointOfInterestMutation, CreatePointOfInterestMutationVariables>(CreatePointOfInterestDocument, options);
      }
export type CreatePointOfInterestMutationHookResult = ReturnType<typeof useCreatePointOfInterestMutation>;
export type CreatePointOfInterestMutationResult = Apollo.MutationResult<CreatePointOfInterestMutation>;
export type CreatePointOfInterestMutationOptions = Apollo.BaseMutationOptions<CreatePointOfInterestMutation, CreatePointOfInterestMutationVariables>;
export const AllAssembliesForCreatePoiDocument = gql`
    query AllAssembliesForCreatePoi($structureId: String!) {
  allAssemblies(structureId: $structureId) {
    id
    tagName
  }
}
    `;

/**
 * __useAllAssembliesForCreatePoiQuery__
 *
 * To run a query within a React component, call `useAllAssembliesForCreatePoiQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssembliesForCreatePoiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssembliesForCreatePoiQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllAssembliesForCreatePoiQuery(baseOptions: Apollo.QueryHookOptions<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables> & ({ variables: AllAssembliesForCreatePoiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>(AllAssembliesForCreatePoiDocument, options);
      }
export function useAllAssembliesForCreatePoiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>(AllAssembliesForCreatePoiDocument, options);
        }
export function useAllAssembliesForCreatePoiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>(AllAssembliesForCreatePoiDocument, options);
        }
export type AllAssembliesForCreatePoiQueryHookResult = ReturnType<typeof useAllAssembliesForCreatePoiQuery>;
export type AllAssembliesForCreatePoiLazyQueryHookResult = ReturnType<typeof useAllAssembliesForCreatePoiLazyQuery>;
export type AllAssembliesForCreatePoiSuspenseQueryHookResult = ReturnType<typeof useAllAssembliesForCreatePoiSuspenseQuery>;
export type AllAssembliesForCreatePoiQueryResult = Apollo.QueryResult<AllAssembliesForCreatePoiQuery, AllAssembliesForCreatePoiQueryVariables>;
export const GetStructureDefaultAssemblyDocument = gql`
    query getStructureDefaultAssembly($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
    defaultAssemblyId
  }
}
    `;

/**
 * __useGetStructureDefaultAssemblyQuery__
 *
 * To run a query within a React component, call `useGetStructureDefaultAssemblyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDefaultAssemblyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDefaultAssemblyQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDefaultAssemblyQuery(baseOptions: Apollo.QueryHookOptions<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables> & ({ variables: GetStructureDefaultAssemblyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>(GetStructureDefaultAssemblyDocument, options);
      }
export function useGetStructureDefaultAssemblyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>(GetStructureDefaultAssemblyDocument, options);
        }
export function useGetStructureDefaultAssemblySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>(GetStructureDefaultAssemblyDocument, options);
        }
export type GetStructureDefaultAssemblyQueryHookResult = ReturnType<typeof useGetStructureDefaultAssemblyQuery>;
export type GetStructureDefaultAssemblyLazyQueryHookResult = ReturnType<typeof useGetStructureDefaultAssemblyLazyQuery>;
export type GetStructureDefaultAssemblySuspenseQueryHookResult = ReturnType<typeof useGetStructureDefaultAssemblySuspenseQuery>;
export type GetStructureDefaultAssemblyQueryResult = Apollo.QueryResult<GetStructureDefaultAssemblyQuery, GetStructureDefaultAssemblyQueryVariables>;
export const UpdatePoiGeneralFieldsDocument = gql`
    mutation UpdatePoiGeneralFields($input: UpdatePointOfInterestInput) {
  updatePointOfInterest(input: $input) {
    id
    cuboids {
      id
      position
      rotation
      scale
    }
  }
}
    `;
export type UpdatePoiGeneralFieldsMutationFn = Apollo.MutationFunction<UpdatePoiGeneralFieldsMutation, UpdatePoiGeneralFieldsMutationVariables>;

/**
 * __useUpdatePoiGeneralFieldsMutation__
 *
 * To run a mutation, you first call `useUpdatePoiGeneralFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePoiGeneralFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePoiGeneralFieldsMutation, { data, loading, error }] = useUpdatePoiGeneralFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePoiGeneralFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePoiGeneralFieldsMutation, UpdatePoiGeneralFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePoiGeneralFieldsMutation, UpdatePoiGeneralFieldsMutationVariables>(UpdatePoiGeneralFieldsDocument, options);
      }
export type UpdatePoiGeneralFieldsMutationHookResult = ReturnType<typeof useUpdatePoiGeneralFieldsMutation>;
export type UpdatePoiGeneralFieldsMutationResult = Apollo.MutationResult<UpdatePoiGeneralFieldsMutation>;
export type UpdatePoiGeneralFieldsMutationOptions = Apollo.BaseMutationOptions<UpdatePoiGeneralFieldsMutation, UpdatePoiGeneralFieldsMutationVariables>;
export const UpdatePoiTemplateFieldsDocument = gql`
    mutation UpdatePoiTemplateFields($input: UpdatePointOfInterestInput) {
  updatePointOfInterest(input: $input) {
    id
  }
}
    `;
export type UpdatePoiTemplateFieldsMutationFn = Apollo.MutationFunction<UpdatePoiTemplateFieldsMutation, UpdatePoiTemplateFieldsMutationVariables>;

/**
 * __useUpdatePoiTemplateFieldsMutation__
 *
 * To run a mutation, you first call `useUpdatePoiTemplateFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePoiTemplateFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePoiTemplateFieldsMutation, { data, loading, error }] = useUpdatePoiTemplateFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePoiTemplateFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePoiTemplateFieldsMutation, UpdatePoiTemplateFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePoiTemplateFieldsMutation, UpdatePoiTemplateFieldsMutationVariables>(UpdatePoiTemplateFieldsDocument, options);
      }
export type UpdatePoiTemplateFieldsMutationHookResult = ReturnType<typeof useUpdatePoiTemplateFieldsMutation>;
export type UpdatePoiTemplateFieldsMutationResult = Apollo.MutationResult<UpdatePoiTemplateFieldsMutation>;
export type UpdatePoiTemplateFieldsMutationOptions = Apollo.BaseMutationOptions<UpdatePoiTemplateFieldsMutation, UpdatePoiTemplateFieldsMutationVariables>;
export const VerifyPointOfInterestDocument = gql`
    mutation VerifyPointOfInterest($input: VerifyPointOfInterestInput) {
  verifyPointOfInterest(input: $input) {
    templateData {
      verifiedValue
      value
      id
    }
  }
}
    `;
export type VerifyPointOfInterestMutationFn = Apollo.MutationFunction<VerifyPointOfInterestMutation, VerifyPointOfInterestMutationVariables>;

/**
 * __useVerifyPointOfInterestMutation__
 *
 * To run a mutation, you first call `useVerifyPointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPointOfInterestMutation, { data, loading, error }] = useVerifyPointOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyPointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPointOfInterestMutation, VerifyPointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPointOfInterestMutation, VerifyPointOfInterestMutationVariables>(VerifyPointOfInterestDocument, options);
      }
export type VerifyPointOfInterestMutationHookResult = ReturnType<typeof useVerifyPointOfInterestMutation>;
export type VerifyPointOfInterestMutationResult = Apollo.MutationResult<VerifyPointOfInterestMutation>;
export type VerifyPointOfInterestMutationOptions = Apollo.BaseMutationOptions<VerifyPointOfInterestMutation, VerifyPointOfInterestMutationVariables>;
export const ScCategoryOptionsDocument = gql`
    query ScCategoryOptions($structureId: ID!) {
  scCategoryOptions(structureId: $structureId)
}
    `;

/**
 * __useScCategoryOptionsQuery__
 *
 * To run a query within a React component, call `useScCategoryOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScCategoryOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScCategoryOptionsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useScCategoryOptionsQuery(baseOptions: Apollo.QueryHookOptions<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables> & ({ variables: ScCategoryOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>(ScCategoryOptionsDocument, options);
      }
export function useScCategoryOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>(ScCategoryOptionsDocument, options);
        }
export function useScCategoryOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>(ScCategoryOptionsDocument, options);
        }
export type ScCategoryOptionsQueryHookResult = ReturnType<typeof useScCategoryOptionsQuery>;
export type ScCategoryOptionsLazyQueryHookResult = ReturnType<typeof useScCategoryOptionsLazyQuery>;
export type ScCategoryOptionsSuspenseQueryHookResult = ReturnType<typeof useScCategoryOptionsSuspenseQuery>;
export type ScCategoryOptionsQueryResult = Apollo.QueryResult<ScCategoryOptionsQuery, ScCategoryOptionsQueryVariables>;
export const UpdateBlisterHeightTypeDocument = gql`
    mutation updateBlisterHeightType($input: PerformMechanicalIntegrityServicesInput) {
  performMechanicalIntegrityServices(input: $input) {
    status
    message
  }
}
    `;
export type UpdateBlisterHeightTypeMutationFn = Apollo.MutationFunction<UpdateBlisterHeightTypeMutation, UpdateBlisterHeightTypeMutationVariables>;

/**
 * __useUpdateBlisterHeightTypeMutation__
 *
 * To run a mutation, you first call `useUpdateBlisterHeightTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlisterHeightTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlisterHeightTypeMutation, { data, loading, error }] = useUpdateBlisterHeightTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlisterHeightTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlisterHeightTypeMutation, UpdateBlisterHeightTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlisterHeightTypeMutation, UpdateBlisterHeightTypeMutationVariables>(UpdateBlisterHeightTypeDocument, options);
      }
export type UpdateBlisterHeightTypeMutationHookResult = ReturnType<typeof useUpdateBlisterHeightTypeMutation>;
export type UpdateBlisterHeightTypeMutationResult = Apollo.MutationResult<UpdateBlisterHeightTypeMutation>;
export type UpdateBlisterHeightTypeMutationOptions = Apollo.BaseMutationOptions<UpdateBlisterHeightTypeMutation, UpdateBlisterHeightTypeMutationVariables>;
export const UpdateCalculationMethodDocument = gql`
    mutation updateCalculationMethod($input: UpdateCalculationMethodInput) {
  updateCalculationMethod(input: $input) {
    id
  }
}
    `;
export type UpdateCalculationMethodMutationFn = Apollo.MutationFunction<UpdateCalculationMethodMutation, UpdateCalculationMethodMutationVariables>;

/**
 * __useUpdateCalculationMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCalculationMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalculationMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalculationMethodMutation, { data, loading, error }] = useUpdateCalculationMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCalculationMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalculationMethodMutation, UpdateCalculationMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalculationMethodMutation, UpdateCalculationMethodMutationVariables>(UpdateCalculationMethodDocument, options);
      }
export type UpdateCalculationMethodMutationHookResult = ReturnType<typeof useUpdateCalculationMethodMutation>;
export type UpdateCalculationMethodMutationResult = Apollo.MutationResult<UpdateCalculationMethodMutation>;
export type UpdateCalculationMethodMutationOptions = Apollo.BaseMutationOptions<UpdateCalculationMethodMutation, UpdateCalculationMethodMutationVariables>;
export const PoiImageCaptionDocument = gql`
    mutation PoiImageCaption($input: PoiImageCaptionInput) {
  poiImageCaption(input: $input)
}
    `;
export type PoiImageCaptionMutationFn = Apollo.MutationFunction<PoiImageCaptionMutation, PoiImageCaptionMutationVariables>;

/**
 * __usePoiImageCaptionMutation__
 *
 * To run a mutation, you first call `usePoiImageCaptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePoiImageCaptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [poiImageCaptionMutation, { data, loading, error }] = usePoiImageCaptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePoiImageCaptionMutation(baseOptions?: Apollo.MutationHookOptions<PoiImageCaptionMutation, PoiImageCaptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PoiImageCaptionMutation, PoiImageCaptionMutationVariables>(PoiImageCaptionDocument, options);
      }
export type PoiImageCaptionMutationHookResult = ReturnType<typeof usePoiImageCaptionMutation>;
export type PoiImageCaptionMutationResult = Apollo.MutationResult<PoiImageCaptionMutation>;
export type PoiImageCaptionMutationOptions = Apollo.BaseMutationOptions<PoiImageCaptionMutation, PoiImageCaptionMutationVariables>;
export const DeletePointOfInterestDocument = gql`
    mutation DeletePointOfInterest($input: DeletePointOfInterestInput) {
  deletePointOfInterest(input: $input) {
    id
    type
  }
}
    `;
export type DeletePointOfInterestMutationFn = Apollo.MutationFunction<DeletePointOfInterestMutation, DeletePointOfInterestMutationVariables>;

/**
 * __useDeletePointOfInterestMutation__
 *
 * To run a mutation, you first call `useDeletePointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePointOfInterestMutation, { data, loading, error }] = useDeletePointOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<DeletePointOfInterestMutation, DeletePointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePointOfInterestMutation, DeletePointOfInterestMutationVariables>(DeletePointOfInterestDocument, options);
      }
export type DeletePointOfInterestMutationHookResult = ReturnType<typeof useDeletePointOfInterestMutation>;
export type DeletePointOfInterestMutationResult = Apollo.MutationResult<DeletePointOfInterestMutation>;
export type DeletePointOfInterestMutationOptions = Apollo.BaseMutationOptions<DeletePointOfInterestMutation, DeletePointOfInterestMutationVariables>;
export const UpdatePointOfInterestDocument = gql`
    mutation UpdatePointOfInterest($input: UpdatePointOfInterestInput) {
  updatePointOfInterest(input: $input) {
    id
  }
}
    `;
export type UpdatePointOfInterestMutationFn = Apollo.MutationFunction<UpdatePointOfInterestMutation, UpdatePointOfInterestMutationVariables>;

/**
 * __useUpdatePointOfInterestMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestMutation, { data, loading, error }] = useUpdatePointOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestMutation, UpdatePointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestMutation, UpdatePointOfInterestMutationVariables>(UpdatePointOfInterestDocument, options);
      }
export type UpdatePointOfInterestMutationHookResult = ReturnType<typeof useUpdatePointOfInterestMutation>;
export type UpdatePointOfInterestMutationResult = Apollo.MutationResult<UpdatePointOfInterestMutation>;
export type UpdatePointOfInterestMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestMutation, UpdatePointOfInterestMutationVariables>;
export const StructureForBlisterDocument = gql`
    query StructureForBlister($structureId: String) {
  structure(structureId: $structureId) {
    id
    wallLossFactor
    scCategoryMapping
  }
}
    `;

/**
 * __useStructureForBlisterQuery__
 *
 * To run a query within a React component, call `useStructureForBlisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureForBlisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureForBlisterQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureForBlisterQuery(baseOptions?: Apollo.QueryHookOptions<StructureForBlisterQuery, StructureForBlisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureForBlisterQuery, StructureForBlisterQueryVariables>(StructureForBlisterDocument, options);
      }
export function useStructureForBlisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureForBlisterQuery, StructureForBlisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureForBlisterQuery, StructureForBlisterQueryVariables>(StructureForBlisterDocument, options);
        }
export function useStructureForBlisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForBlisterQuery, StructureForBlisterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureForBlisterQuery, StructureForBlisterQueryVariables>(StructureForBlisterDocument, options);
        }
export type StructureForBlisterQueryHookResult = ReturnType<typeof useStructureForBlisterQuery>;
export type StructureForBlisterLazyQueryHookResult = ReturnType<typeof useStructureForBlisterLazyQuery>;
export type StructureForBlisterSuspenseQueryHookResult = ReturnType<typeof useStructureForBlisterSuspenseQuery>;
export type StructureForBlisterQueryResult = Apollo.QueryResult<StructureForBlisterQuery, StructureForBlisterQueryVariables>;
export const UploadAttachmentsToPoiDocument = gql`
    mutation UploadAttachmentsToPOI($input: UploadAttachmentsInput) {
  uploadAttachmentsToPoi(input: $input) {
    id
    url
    resourcePath
    uuid
  }
}
    `;
export type UploadAttachmentsToPoiMutationFn = Apollo.MutationFunction<UploadAttachmentsToPoiMutation, UploadAttachmentsToPoiMutationVariables>;

/**
 * __useUploadAttachmentsToPoiMutation__
 *
 * To run a mutation, you first call `useUploadAttachmentsToPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAttachmentsToPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAttachmentsToPoiMutation, { data, loading, error }] = useUploadAttachmentsToPoiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadAttachmentsToPoiMutation(baseOptions?: Apollo.MutationHookOptions<UploadAttachmentsToPoiMutation, UploadAttachmentsToPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAttachmentsToPoiMutation, UploadAttachmentsToPoiMutationVariables>(UploadAttachmentsToPoiDocument, options);
      }
export type UploadAttachmentsToPoiMutationHookResult = ReturnType<typeof useUploadAttachmentsToPoiMutation>;
export type UploadAttachmentsToPoiMutationResult = Apollo.MutationResult<UploadAttachmentsToPoiMutation>;
export type UploadAttachmentsToPoiMutationOptions = Apollo.BaseMutationOptions<UploadAttachmentsToPoiMutation, UploadAttachmentsToPoiMutationVariables>;
export const RemoveAttachmentsFromPoiDocument = gql`
    mutation RemoveAttachmentsFromPoi($input: RemoveAttachmentsInput) {
  removeAttachmentsFromPoi(input: $input) {
    id
  }
}
    `;
export type RemoveAttachmentsFromPoiMutationFn = Apollo.MutationFunction<RemoveAttachmentsFromPoiMutation, RemoveAttachmentsFromPoiMutationVariables>;

/**
 * __useRemoveAttachmentsFromPoiMutation__
 *
 * To run a mutation, you first call `useRemoveAttachmentsFromPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttachmentsFromPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttachmentsFromPoiMutation, { data, loading, error }] = useRemoveAttachmentsFromPoiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAttachmentsFromPoiMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAttachmentsFromPoiMutation, RemoveAttachmentsFromPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAttachmentsFromPoiMutation, RemoveAttachmentsFromPoiMutationVariables>(RemoveAttachmentsFromPoiDocument, options);
      }
export type RemoveAttachmentsFromPoiMutationHookResult = ReturnType<typeof useRemoveAttachmentsFromPoiMutation>;
export type RemoveAttachmentsFromPoiMutationResult = Apollo.MutationResult<RemoveAttachmentsFromPoiMutation>;
export type RemoveAttachmentsFromPoiMutationOptions = Apollo.BaseMutationOptions<RemoveAttachmentsFromPoiMutation, RemoveAttachmentsFromPoiMutationVariables>;
export const UpdatePaintRegionIdDocument = gql`
    mutation UpdatePaintRegionId($input: UpdatePaintRegionIdInput) {
  updatePaintRegionId(input: $input) {
    paintRegion {
      id
      name
      volume {
        inclusion {
          xy_polygon
          z_range
        }
        exclusions {
          xy_polygon
          z_range
        }
      }
    }
  }
}
    `;
export type UpdatePaintRegionIdMutationFn = Apollo.MutationFunction<UpdatePaintRegionIdMutation, UpdatePaintRegionIdMutationVariables>;

/**
 * __useUpdatePaintRegionIdMutation__
 *
 * To run a mutation, you first call `useUpdatePaintRegionIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaintRegionIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaintRegionIdMutation, { data, loading, error }] = useUpdatePaintRegionIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaintRegionIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaintRegionIdMutation, UpdatePaintRegionIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaintRegionIdMutation, UpdatePaintRegionIdMutationVariables>(UpdatePaintRegionIdDocument, options);
      }
export type UpdatePaintRegionIdMutationHookResult = ReturnType<typeof useUpdatePaintRegionIdMutation>;
export type UpdatePaintRegionIdMutationResult = Apollo.MutationResult<UpdatePaintRegionIdMutation>;
export type UpdatePaintRegionIdMutationOptions = Apollo.BaseMutationOptions<UpdatePaintRegionIdMutation, UpdatePaintRegionIdMutationVariables>;
export const SelectedPoiUpdatedDocument = gql`
    subscription SelectedPOIUpdated($poiID: ID) {
  selectedPointOfInterestUpdated(poiId: $poiID) {
    id
    paintRegion {
      id
      name
    }
    screenshotPaths {
      viewer
      viewpoint
    }
  }
}
    `;

/**
 * __useSelectedPoiUpdatedSubscription__
 *
 * To run a query within a React component, call `useSelectedPoiUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSelectedPoiUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedPoiUpdatedSubscription({
 *   variables: {
 *      poiID: // value for 'poiID'
 *   },
 * });
 */
export function useSelectedPoiUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SelectedPoiUpdatedSubscription, SelectedPoiUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SelectedPoiUpdatedSubscription, SelectedPoiUpdatedSubscriptionVariables>(SelectedPoiUpdatedDocument, options);
      }
export type SelectedPoiUpdatedSubscriptionHookResult = ReturnType<typeof useSelectedPoiUpdatedSubscription>;
export type SelectedPoiUpdatedSubscriptionResult = Apollo.SubscriptionResult<SelectedPoiUpdatedSubscription>;
export const StructureWallLossFactorDocument = gql`
    query StructureWallLossFactor($structureId: String) {
  structure(structureId: $structureId) {
    wallLossFactor
  }
}
    `;

/**
 * __useStructureWallLossFactorQuery__
 *
 * To run a query within a React component, call `useStructureWallLossFactorQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureWallLossFactorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureWallLossFactorQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureWallLossFactorQuery(baseOptions?: Apollo.QueryHookOptions<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>(StructureWallLossFactorDocument, options);
      }
export function useStructureWallLossFactorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>(StructureWallLossFactorDocument, options);
        }
export function useStructureWallLossFactorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>(StructureWallLossFactorDocument, options);
        }
export type StructureWallLossFactorQueryHookResult = ReturnType<typeof useStructureWallLossFactorQuery>;
export type StructureWallLossFactorLazyQueryHookResult = ReturnType<typeof useStructureWallLossFactorLazyQuery>;
export type StructureWallLossFactorSuspenseQueryHookResult = ReturnType<typeof useStructureWallLossFactorSuspenseQuery>;
export type StructureWallLossFactorQueryResult = Apollo.QueryResult<StructureWallLossFactorQuery, StructureWallLossFactorQueryVariables>;
export const EvaluateTemplateFieldLogicRuleDocument = gql`
    mutation EvaluateTemplateFieldLogicRule($input: EvaluateTemplateFieldLogicRuleInput!) {
  evaluateTemplateFieldLogicRule(input: $input) {
    result
  }
}
    `;
export type EvaluateTemplateFieldLogicRuleMutationFn = Apollo.MutationFunction<EvaluateTemplateFieldLogicRuleMutation, EvaluateTemplateFieldLogicRuleMutationVariables>;

/**
 * __useEvaluateTemplateFieldLogicRuleMutation__
 *
 * To run a mutation, you first call `useEvaluateTemplateFieldLogicRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateTemplateFieldLogicRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateTemplateFieldLogicRuleMutation, { data, loading, error }] = useEvaluateTemplateFieldLogicRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEvaluateTemplateFieldLogicRuleMutation(baseOptions?: Apollo.MutationHookOptions<EvaluateTemplateFieldLogicRuleMutation, EvaluateTemplateFieldLogicRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaluateTemplateFieldLogicRuleMutation, EvaluateTemplateFieldLogicRuleMutationVariables>(EvaluateTemplateFieldLogicRuleDocument, options);
      }
export type EvaluateTemplateFieldLogicRuleMutationHookResult = ReturnType<typeof useEvaluateTemplateFieldLogicRuleMutation>;
export type EvaluateTemplateFieldLogicRuleMutationResult = Apollo.MutationResult<EvaluateTemplateFieldLogicRuleMutation>;
export type EvaluateTemplateFieldLogicRuleMutationOptions = Apollo.BaseMutationOptions<EvaluateTemplateFieldLogicRuleMutation, EvaluateTemplateFieldLogicRuleMutationVariables>;
export const WorkscopeDynamicBlockCalculationDocument = gql`
    query WorkscopeDynamicBlockCalculation($input: DynamicBlockCalculationInput!) {
  dynamicBlockCalculation(input: $input)
}
    `;

/**
 * __useWorkscopeDynamicBlockCalculationQuery__
 *
 * To run a query within a React component, call `useWorkscopeDynamicBlockCalculationQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkscopeDynamicBlockCalculationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkscopeDynamicBlockCalculationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkscopeDynamicBlockCalculationQuery(baseOptions: Apollo.QueryHookOptions<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables> & ({ variables: WorkscopeDynamicBlockCalculationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>(WorkscopeDynamicBlockCalculationDocument, options);
      }
export function useWorkscopeDynamicBlockCalculationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>(WorkscopeDynamicBlockCalculationDocument, options);
        }
export function useWorkscopeDynamicBlockCalculationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>(WorkscopeDynamicBlockCalculationDocument, options);
        }
export type WorkscopeDynamicBlockCalculationQueryHookResult = ReturnType<typeof useWorkscopeDynamicBlockCalculationQuery>;
export type WorkscopeDynamicBlockCalculationLazyQueryHookResult = ReturnType<typeof useWorkscopeDynamicBlockCalculationLazyQuery>;
export type WorkscopeDynamicBlockCalculationSuspenseQueryHookResult = ReturnType<typeof useWorkscopeDynamicBlockCalculationSuspenseQuery>;
export type WorkscopeDynamicBlockCalculationQueryResult = Apollo.QueryResult<WorkscopeDynamicBlockCalculationQuery, WorkscopeDynamicBlockCalculationQueryVariables>;
export const SelectedPointOfInterestDocument = gql`
    query SelectedPointOfInterest($pointOfInterestId: ID!) {
  pointOfInterest(pointOfInterestId: $pointOfInterestId) {
    id
    templateId
    type
    linkedPointOfInterestIds
    assignee
    dueDate
    status
    isVerified
    deckRelativeHeight
    workpackNumber
    workpack {
      id
      name
      status
    }
    paintRegion {
      id
      name
    }
    template {
      id
      fields {
        id
        name
        type
      }
    }
    location {
      id
    }
    name
    lineMeasurement {
      points {
        coordinates
        templateFieldId
      }
    }
    poiId
    centerPoint3d {
      x
      y
      z
    }
    cameraLocation {
      x
      y
      z
    }
    assembly {
      id
      tagName
      pipeSpec {
        spec
        size
        material
        nominalCorrosionAllowance
        nominalThickness
      }
      structure {
        id
      }
    }
    blister {
      maxHeight
      estimatedHeight
      pdrHeight
      heightType
      isManuallyOverridden
      verifiedMaxHeight
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
      verifiedResidualThickness
      centerPoint {
        bearing
        elevation
      }
      radiusPoint {
        bearing
        elevation
      }
      borders3d {
        points {
          x
          y
          z
        }
      }
      estimatedHeight
      manualSetHeight
      radius
      fittingRadius
      scCategory
    }
    templateData {
      id
      value
      verifiedValue
      templateFieldId
    }
    createdByUser {
      id
      name
      picture
      email
      connection
      roleIds {
        name
      }
    }
    createdAt
    screenshotPaths {
      viewer
      viewpoint
    }
    visibility
    deckRelativeHeight
    teams {
      id
      name
    }
    remediationNote
    files {
      id
      name
      caption
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
    comment
    accessibility
    viewpointRelativeHeight
    remediationNote
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
    cuboids {
      id
      position
      rotation
      scale
    }
    isAutoGenerated
    verifiedByUser {
      email
    }
  }
}
    `;

/**
 * __useSelectedPointOfInterestQuery__
 *
 * To run a query within a React component, call `useSelectedPointOfInterestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedPointOfInterestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedPointOfInterestQuery({
 *   variables: {
 *      pointOfInterestId: // value for 'pointOfInterestId'
 *   },
 * });
 */
export function useSelectedPointOfInterestQuery(baseOptions: Apollo.QueryHookOptions<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables> & ({ variables: SelectedPointOfInterestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>(SelectedPointOfInterestDocument, options);
      }
export function useSelectedPointOfInterestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>(SelectedPointOfInterestDocument, options);
        }
export function useSelectedPointOfInterestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>(SelectedPointOfInterestDocument, options);
        }
export type SelectedPointOfInterestQueryHookResult = ReturnType<typeof useSelectedPointOfInterestQuery>;
export type SelectedPointOfInterestLazyQueryHookResult = ReturnType<typeof useSelectedPointOfInterestLazyQuery>;
export type SelectedPointOfInterestSuspenseQueryHookResult = ReturnType<typeof useSelectedPointOfInterestSuspenseQuery>;
export type SelectedPointOfInterestQueryResult = Apollo.QueryResult<SelectedPointOfInterestQuery, SelectedPointOfInterestQueryVariables>;
export const PointOfInterestsDocument = gql`
    query PointOfInterests($input: PointOfInterestInput, $pageInfo: PageInfo) {
  pointOfInterests(input: $input, pageInfo: $pageInfo) {
    isGoverning
    id
    type
    status
    isVerified
    createdByUser {
      name
      picture
      roleIds {
        name
      }
    }
    paintRegion {
      id
      name
      deck {
        name
      }
    }
    paintRegions {
      id
      name
      paintRegionGroup {
        id
        name
        isDefault
      }
    }
    template {
      id
      name
      fields {
        id
        unit
        name
        type
      }
    }
    centerPoint3d {
      x
      y
      z
    }
    name
    poiId
    isManuallyCreated
    isAutoGenerated
    assembly {
      id
      tagName
      structure {
        id
      }
    }
    location {
      id
      name
    }
    blister {
      maxHeight
      estimatedHeight
      pdrHeight
      heightType
      isManuallyOverridden
      verifiedMaxHeight
      verifiedResidualThickness
      centerPoint {
        bearing
        elevation
      }
      radiusPoint {
        bearing
        elevation
      }
      wallLoss {
        percentage
        value
      }
      residualCorrosionAllowance {
        percentage
        value
      }
      residualThickness {
        percentage
        value
      }
    }
    templateData {
      id
      value
      templateFieldId
    }
    screenshotPaths {
      viewer
      viewpoint
    }
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      caption
      imageType
      uuid
    }
    visibility
    comment
    accessibility
    createdAt
    dueDate
    deckRelativeHeight
    workpackNumber
    workpack {
      id
      name
      status
    }
  }
  pointOfInterestsCount(input: $input) {
    count
  }
}
    `;

/**
 * __usePointOfInterestsQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function usePointOfInterestsQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsQuery, PointOfInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsQuery, PointOfInterestsQueryVariables>(PointOfInterestsDocument, options);
      }
export function usePointOfInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsQuery, PointOfInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsQuery, PointOfInterestsQueryVariables>(PointOfInterestsDocument, options);
        }
export function usePointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsQuery, PointOfInterestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsQuery, PointOfInterestsQueryVariables>(PointOfInterestsDocument, options);
        }
export type PointOfInterestsQueryHookResult = ReturnType<typeof usePointOfInterestsQuery>;
export type PointOfInterestsLazyQueryHookResult = ReturnType<typeof usePointOfInterestsLazyQuery>;
export type PointOfInterestsSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsSuspenseQuery>;
export type PointOfInterestsQueryResult = Apollo.QueryResult<PointOfInterestsQuery, PointOfInterestsQueryVariables>;
export const PointOfInterestsCountDocument = gql`
    query pointOfInterestsCount($input: PointOfInterestInput) {
  pointOfInterestsCount(input: $input) {
    count
  }
}
    `;

/**
 * __usePointOfInterestsCountQuery__
 *
 * To run a query within a React component, call `usePointOfInterestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestsCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePointOfInterestsCountQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>(PointOfInterestsCountDocument, options);
      }
export function usePointOfInterestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>(PointOfInterestsCountDocument, options);
        }
export function usePointOfInterestsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>(PointOfInterestsCountDocument, options);
        }
export type PointOfInterestsCountQueryHookResult = ReturnType<typeof usePointOfInterestsCountQuery>;
export type PointOfInterestsCountLazyQueryHookResult = ReturnType<typeof usePointOfInterestsCountLazyQuery>;
export type PointOfInterestsCountSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestsCountSuspenseQuery>;
export type PointOfInterestsCountQueryResult = Apollo.QueryResult<PointOfInterestsCountQuery, PointOfInterestsCountQueryVariables>;
export const GetNominationCalculationsDocument = gql`
    query getNominationCalculations($input: NominationCalculationsInput) {
  getNominationCalculations(input: $input) {
    governingValue {
      height
      estimatedWallLoss
      estimatedWallLossPercentage
      residualCorrosionAllowance
      residualCorrosionAllowancePercentage
      residualThickness
      residualThicknessPercentage
    }
    alarmLevel
  }
}
    `;

/**
 * __useGetNominationCalculationsQuery__
 *
 * To run a query within a React component, call `useGetNominationCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNominationCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNominationCalculationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNominationCalculationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>(GetNominationCalculationsDocument, options);
      }
export function useGetNominationCalculationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>(GetNominationCalculationsDocument, options);
        }
export function useGetNominationCalculationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>(GetNominationCalculationsDocument, options);
        }
export type GetNominationCalculationsQueryHookResult = ReturnType<typeof useGetNominationCalculationsQuery>;
export type GetNominationCalculationsLazyQueryHookResult = ReturnType<typeof useGetNominationCalculationsLazyQuery>;
export type GetNominationCalculationsSuspenseQueryHookResult = ReturnType<typeof useGetNominationCalculationsSuspenseQuery>;
export type GetNominationCalculationsQueryResult = Apollo.QueryResult<GetNominationCalculationsQuery, GetNominationCalculationsQueryVariables>;
export const NominateGoverningPointOfInterestDocument = gql`
    mutation NominateGoverningPointOfInterest($input: NominateGoverningPointOfInterestInput) {
  nominateGoverningPointOfInterest(input: $input)
}
    `;
export type NominateGoverningPointOfInterestMutationFn = Apollo.MutationFunction<NominateGoverningPointOfInterestMutation, NominateGoverningPointOfInterestMutationVariables>;

/**
 * __useNominateGoverningPointOfInterestMutation__
 *
 * To run a mutation, you first call `useNominateGoverningPointOfInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNominateGoverningPointOfInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nominateGoverningPointOfInterestMutation, { data, loading, error }] = useNominateGoverningPointOfInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNominateGoverningPointOfInterestMutation(baseOptions?: Apollo.MutationHookOptions<NominateGoverningPointOfInterestMutation, NominateGoverningPointOfInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NominateGoverningPointOfInterestMutation, NominateGoverningPointOfInterestMutationVariables>(NominateGoverningPointOfInterestDocument, options);
      }
export type NominateGoverningPointOfInterestMutationHookResult = ReturnType<typeof useNominateGoverningPointOfInterestMutation>;
export type NominateGoverningPointOfInterestMutationResult = Apollo.MutationResult<NominateGoverningPointOfInterestMutation>;
export type NominateGoverningPointOfInterestMutationOptions = Apollo.BaseMutationOptions<NominateGoverningPointOfInterestMutation, NominateGoverningPointOfInterestMutationVariables>;
export const GetRecommendationsForAssemblyDocument = gql`
    query getRecommendationsForAssembly($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    recommendation {
      governingValue {
        pointOfInterest {
          id
        }
        blister {
          id
          name
        }
        calculations {
          estimatedWallLoss
          estimatedWallLossPercentage
          height
          residualCorrosionAllowance
          residualCorrosionAllowancePercentage
          residualThickness
          residualThicknessPercentage
        }
      }
    }
    pipeSpec {
      size
      material
      spec
      nominalCorrosionAllowance
      schedule
      nominalThickness
    }
  }
}
    `;

/**
 * __useGetRecommendationsForAssemblyQuery__
 *
 * To run a query within a React component, call `useGetRecommendationsForAssemblyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendationsForAssemblyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendationsForAssemblyQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetRecommendationsForAssemblyQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables> & ({ variables: GetRecommendationsForAssemblyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>(GetRecommendationsForAssemblyDocument, options);
      }
export function useGetRecommendationsForAssemblyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>(GetRecommendationsForAssemblyDocument, options);
        }
export function useGetRecommendationsForAssemblySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>(GetRecommendationsForAssemblyDocument, options);
        }
export type GetRecommendationsForAssemblyQueryHookResult = ReturnType<typeof useGetRecommendationsForAssemblyQuery>;
export type GetRecommendationsForAssemblyLazyQueryHookResult = ReturnType<typeof useGetRecommendationsForAssemblyLazyQuery>;
export type GetRecommendationsForAssemblySuspenseQueryHookResult = ReturnType<typeof useGetRecommendationsForAssemblySuspenseQuery>;
export type GetRecommendationsForAssemblyQueryResult = Apollo.QueryResult<GetRecommendationsForAssemblyQuery, GetRecommendationsForAssemblyQueryVariables>;
export const GetOneAssemblyForBlistersDocument = gql`
    query GetOneAssemblyForBlisters($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    recommendation {
      governingValue {
        pointOfInterest {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetOneAssemblyForBlistersQuery__
 *
 * To run a query within a React component, call `useGetOneAssemblyForBlistersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneAssemblyForBlistersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneAssemblyForBlistersQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetOneAssemblyForBlistersQuery(baseOptions?: Apollo.QueryHookOptions<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>(GetOneAssemblyForBlistersDocument, options);
      }
export function useGetOneAssemblyForBlistersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>(GetOneAssemblyForBlistersDocument, options);
        }
export function useGetOneAssemblyForBlistersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>(GetOneAssemblyForBlistersDocument, options);
        }
export type GetOneAssemblyForBlistersQueryHookResult = ReturnType<typeof useGetOneAssemblyForBlistersQuery>;
export type GetOneAssemblyForBlistersLazyQueryHookResult = ReturnType<typeof useGetOneAssemblyForBlistersLazyQuery>;
export type GetOneAssemblyForBlistersSuspenseQueryHookResult = ReturnType<typeof useGetOneAssemblyForBlistersSuspenseQuery>;
export type GetOneAssemblyForBlistersQueryResult = Apollo.QueryResult<GetOneAssemblyForBlistersQuery, GetOneAssemblyForBlistersQueryVariables>;
export const GetOneAssemblyForDefectsDocument = gql`
    query GetOneAssemblyForDefects($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    recommendation {
      governingValue {
        pointOfInterest {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetOneAssemblyForDefectsQuery__
 *
 * To run a query within a React component, call `useGetOneAssemblyForDefectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneAssemblyForDefectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneAssemblyForDefectsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetOneAssemblyForDefectsQuery(baseOptions?: Apollo.QueryHookOptions<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>(GetOneAssemblyForDefectsDocument, options);
      }
export function useGetOneAssemblyForDefectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>(GetOneAssemblyForDefectsDocument, options);
        }
export function useGetOneAssemblyForDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>(GetOneAssemblyForDefectsDocument, options);
        }
export type GetOneAssemblyForDefectsQueryHookResult = ReturnType<typeof useGetOneAssemblyForDefectsQuery>;
export type GetOneAssemblyForDefectsLazyQueryHookResult = ReturnType<typeof useGetOneAssemblyForDefectsLazyQuery>;
export type GetOneAssemblyForDefectsSuspenseQueryHookResult = ReturnType<typeof useGetOneAssemblyForDefectsSuspenseQuery>;
export type GetOneAssemblyForDefectsQueryResult = Apollo.QueryResult<GetOneAssemblyForDefectsQuery, GetOneAssemblyForDefectsQueryVariables>;
export const MeasureBlisterDocument = gql`
    query MeasureBlister($locationId: String, $blisterMeasurementPoints: BlisterMeasurementInput) {
  fetchBlisterHeightMeasurement(
    locationId: $locationId
    blisterMeasurementPoints: $blisterMeasurementPoints
  ) {
    blister {
      blisterProfilePlotPoints {
        x
        y
        z
        height
      }
      fittedSurfacePoints {
        x
        y
        z
      }
      maxHeight
      borders3d {
        points {
          x
          y
          z
        }
      }
      centerPoint3d {
        x
        y
        z
      }
    }
    status {
      cacheStatus
      fittingRadius
      targetRadius
      windowSize
    }
  }
}
    `;

/**
 * __useMeasureBlisterQuery__
 *
 * To run a query within a React component, call `useMeasureBlisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeasureBlisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeasureBlisterQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      blisterMeasurementPoints: // value for 'blisterMeasurementPoints'
 *   },
 * });
 */
export function useMeasureBlisterQuery(baseOptions?: Apollo.QueryHookOptions<MeasureBlisterQuery, MeasureBlisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeasureBlisterQuery, MeasureBlisterQueryVariables>(MeasureBlisterDocument, options);
      }
export function useMeasureBlisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeasureBlisterQuery, MeasureBlisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeasureBlisterQuery, MeasureBlisterQueryVariables>(MeasureBlisterDocument, options);
        }
export function useMeasureBlisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeasureBlisterQuery, MeasureBlisterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeasureBlisterQuery, MeasureBlisterQueryVariables>(MeasureBlisterDocument, options);
        }
export type MeasureBlisterQueryHookResult = ReturnType<typeof useMeasureBlisterQuery>;
export type MeasureBlisterLazyQueryHookResult = ReturnType<typeof useMeasureBlisterLazyQuery>;
export type MeasureBlisterSuspenseQueryHookResult = ReturnType<typeof useMeasureBlisterSuspenseQuery>;
export type MeasureBlisterQueryResult = Apollo.QueryResult<MeasureBlisterQuery, MeasureBlisterQueryVariables>;
export const GetAssemblyPipeSpecByIdDocument = gql`
    query getAssemblyPipeSpecByID($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    pipeSpec {
      material
      nominalCorrosionAllowance
      nominalThickness
      schedule
      size
      spec
    }
  }
}
    `;

/**
 * __useGetAssemblyPipeSpecByIdQuery__
 *
 * To run a query within a React component, call `useGetAssemblyPipeSpecByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyPipeSpecByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyPipeSpecByIdQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyPipeSpecByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>(GetAssemblyPipeSpecByIdDocument, options);
      }
export function useGetAssemblyPipeSpecByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>(GetAssemblyPipeSpecByIdDocument, options);
        }
export function useGetAssemblyPipeSpecByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>(GetAssemblyPipeSpecByIdDocument, options);
        }
export type GetAssemblyPipeSpecByIdQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecByIdQuery>;
export type GetAssemblyPipeSpecByIdLazyQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecByIdLazyQuery>;
export type GetAssemblyPipeSpecByIdSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyPipeSpecByIdSuspenseQuery>;
export type GetAssemblyPipeSpecByIdQueryResult = Apollo.QueryResult<GetAssemblyPipeSpecByIdQuery, GetAssemblyPipeSpecByIdQueryVariables>;
export const GetAllTeamsForCreateOrEditPoiDocument = gql`
    query GetAllTeamsForCreateOrEditPoi {
  allTeams {
    id
    name
  }
}
    `;

/**
 * __useGetAllTeamsForCreateOrEditPoiQuery__
 *
 * To run a query within a React component, call `useGetAllTeamsForCreateOrEditPoiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTeamsForCreateOrEditPoiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTeamsForCreateOrEditPoiQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTeamsForCreateOrEditPoiQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>(GetAllTeamsForCreateOrEditPoiDocument, options);
      }
export function useGetAllTeamsForCreateOrEditPoiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>(GetAllTeamsForCreateOrEditPoiDocument, options);
        }
export function useGetAllTeamsForCreateOrEditPoiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>(GetAllTeamsForCreateOrEditPoiDocument, options);
        }
export type GetAllTeamsForCreateOrEditPoiQueryHookResult = ReturnType<typeof useGetAllTeamsForCreateOrEditPoiQuery>;
export type GetAllTeamsForCreateOrEditPoiLazyQueryHookResult = ReturnType<typeof useGetAllTeamsForCreateOrEditPoiLazyQuery>;
export type GetAllTeamsForCreateOrEditPoiSuspenseQueryHookResult = ReturnType<typeof useGetAllTeamsForCreateOrEditPoiSuspenseQuery>;
export type GetAllTeamsForCreateOrEditPoiQueryResult = Apollo.QueryResult<GetAllTeamsForCreateOrEditPoiQuery, GetAllTeamsForCreateOrEditPoiQueryVariables>;
export const SavePointOfInterestScreenshotDocument = gql`
    mutation SavePointOfInterestScreenshot($input: SavePointOfInterestScreenshotInput) {
  savePointOfInterestScreenshot(input: $input) {
    id
  }
}
    `;
export type SavePointOfInterestScreenshotMutationFn = Apollo.MutationFunction<SavePointOfInterestScreenshotMutation, SavePointOfInterestScreenshotMutationVariables>;

/**
 * __useSavePointOfInterestScreenshotMutation__
 *
 * To run a mutation, you first call `useSavePointOfInterestScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePointOfInterestScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePointOfInterestScreenshotMutation, { data, loading, error }] = useSavePointOfInterestScreenshotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePointOfInterestScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<SavePointOfInterestScreenshotMutation, SavePointOfInterestScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePointOfInterestScreenshotMutation, SavePointOfInterestScreenshotMutationVariables>(SavePointOfInterestScreenshotDocument, options);
      }
export type SavePointOfInterestScreenshotMutationHookResult = ReturnType<typeof useSavePointOfInterestScreenshotMutation>;
export type SavePointOfInterestScreenshotMutationResult = Apollo.MutationResult<SavePointOfInterestScreenshotMutation>;
export type SavePointOfInterestScreenshotMutationOptions = Apollo.BaseMutationOptions<SavePointOfInterestScreenshotMutation, SavePointOfInterestScreenshotMutationVariables>;
export const UpdatePointOfInterestFileDocument = gql`
    mutation UpdatePointOfInterestFile($input: InputUpdateFileForPointOfInterest) {
  updatePointOfInterestFile(input: $input) {
    id
  }
}
    `;
export type UpdatePointOfInterestFileMutationFn = Apollo.MutationFunction<UpdatePointOfInterestFileMutation, UpdatePointOfInterestFileMutationVariables>;

/**
 * __useUpdatePointOfInterestFileMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestFileMutation, { data, loading, error }] = useUpdatePointOfInterestFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestFileMutation, UpdatePointOfInterestFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestFileMutation, UpdatePointOfInterestFileMutationVariables>(UpdatePointOfInterestFileDocument, options);
      }
export type UpdatePointOfInterestFileMutationHookResult = ReturnType<typeof useUpdatePointOfInterestFileMutation>;
export type UpdatePointOfInterestFileMutationResult = Apollo.MutationResult<UpdatePointOfInterestFileMutation>;
export type UpdatePointOfInterestFileMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestFileMutation, UpdatePointOfInterestFileMutationVariables>;
export const FetchGenerateImageDocument = gql`
    query FetchGenerateImage($input: GenerateImageInput) {
  fetchGenerateImage(input: $input) {
    imageData
  }
}
    `;

/**
 * __useFetchGenerateImageQuery__
 *
 * To run a query within a React component, call `useFetchGenerateImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGenerateImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchGenerateImageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchGenerateImageQuery(baseOptions?: Apollo.QueryHookOptions<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>(FetchGenerateImageDocument, options);
      }
export function useFetchGenerateImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>(FetchGenerateImageDocument, options);
        }
export function useFetchGenerateImageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>(FetchGenerateImageDocument, options);
        }
export type FetchGenerateImageQueryHookResult = ReturnType<typeof useFetchGenerateImageQuery>;
export type FetchGenerateImageLazyQueryHookResult = ReturnType<typeof useFetchGenerateImageLazyQuery>;
export type FetchGenerateImageSuspenseQueryHookResult = ReturnType<typeof useFetchGenerateImageSuspenseQuery>;
export type FetchGenerateImageQueryResult = Apollo.QueryResult<FetchGenerateImageQuery, FetchGenerateImageQueryVariables>;
export const FetchCropFromRectilinearDocument = gql`
    query FetchCropFromRectilinear($input: GenerateCropFromRectilinearInput) {
  fetchCropFromRectilinear(input: $input) {
    imageData
  }
}
    `;

/**
 * __useFetchCropFromRectilinearQuery__
 *
 * To run a query within a React component, call `useFetchCropFromRectilinearQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCropFromRectilinearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCropFromRectilinearQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchCropFromRectilinearQuery(baseOptions?: Apollo.QueryHookOptions<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>(FetchCropFromRectilinearDocument, options);
      }
export function useFetchCropFromRectilinearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>(FetchCropFromRectilinearDocument, options);
        }
export function useFetchCropFromRectilinearSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>(FetchCropFromRectilinearDocument, options);
        }
export type FetchCropFromRectilinearQueryHookResult = ReturnType<typeof useFetchCropFromRectilinearQuery>;
export type FetchCropFromRectilinearLazyQueryHookResult = ReturnType<typeof useFetchCropFromRectilinearLazyQuery>;
export type FetchCropFromRectilinearSuspenseQueryHookResult = ReturnType<typeof useFetchCropFromRectilinearSuspenseQuery>;
export type FetchCropFromRectilinearQueryResult = Apollo.QueryResult<FetchCropFromRectilinearQuery, FetchCropFromRectilinearQueryVariables>;
export const GetStructureFeaturesDocument = gql`
    query getStructureFeatures($structureId: String!) {
  structure(structureId: $structureId) {
    id
    features
  }
}
    `;

/**
 * __useGetStructureFeaturesQuery__
 *
 * To run a query within a React component, call `useGetStructureFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureFeaturesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables> & ({ variables: GetStructureFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>(GetStructureFeaturesDocument, options);
      }
export function useGetStructureFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>(GetStructureFeaturesDocument, options);
        }
export function useGetStructureFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>(GetStructureFeaturesDocument, options);
        }
export type GetStructureFeaturesQueryHookResult = ReturnType<typeof useGetStructureFeaturesQuery>;
export type GetStructureFeaturesLazyQueryHookResult = ReturnType<typeof useGetStructureFeaturesLazyQuery>;
export type GetStructureFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetStructureFeaturesSuspenseQuery>;
export type GetStructureFeaturesQueryResult = Apollo.QueryResult<GetStructureFeaturesQuery, GetStructureFeaturesQueryVariables>;
export const GetAllAssembliesDocument = gql`
    query getAllAssemblies($structureId: String!) {
  allAssemblies(structureId: $structureId) {
    id
    service {
      code
    }
    tagName
    recommendation {
      analysisStatus
      analysisRecommendation {
        recommendationByUserName
        alarmLevel
        supportingComment
        additionalComments
        internalTeamComments
      }
      governingValue {
        calculations {
          height
          estimatedWallLoss
          estimatedWallLossPercentage
          residualCorrosionAllowance
          residualCorrosionAllowancePercentage
          residualThickness
          residualThicknessPercentage
        }
      }
    }
    pipeSpec {
      size
      spec
      material
      nominalCorrosionAllowance
      schedule
      nominalThickness
    }
  }
  structure(structureId: $structureId) {
    name
  }
}
    `;

/**
 * __useGetAllAssembliesQuery__
 *
 * To run a query within a React component, call `useGetAllAssembliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssembliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssembliesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllAssembliesQuery(baseOptions: Apollo.QueryHookOptions<GetAllAssembliesQuery, GetAllAssembliesQueryVariables> & ({ variables: GetAllAssembliesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>(GetAllAssembliesDocument, options);
      }
export function useGetAllAssembliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>(GetAllAssembliesDocument, options);
        }
export function useGetAllAssembliesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>(GetAllAssembliesDocument, options);
        }
export type GetAllAssembliesQueryHookResult = ReturnType<typeof useGetAllAssembliesQuery>;
export type GetAllAssembliesLazyQueryHookResult = ReturnType<typeof useGetAllAssembliesLazyQuery>;
export type GetAllAssembliesSuspenseQueryHookResult = ReturnType<typeof useGetAllAssembliesSuspenseQuery>;
export type GetAllAssembliesQueryResult = Apollo.QueryResult<GetAllAssembliesQuery, GetAllAssembliesQueryVariables>;
export const AllPointOfInterestsForStructureDocument = gql`
    query allPointOfInterestsForStructure($structureId: ID!) {
  allPointOfInterests(structureId: $structureId) {
    type
    assembly {
      id
    }
  }
}
    `;

/**
 * __useAllPointOfInterestsForStructureQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestsForStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestsForStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestsForStructureQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllPointOfInterestsForStructureQuery(baseOptions: Apollo.QueryHookOptions<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables> & ({ variables: AllPointOfInterestsForStructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>(AllPointOfInterestsForStructureDocument, options);
      }
export function useAllPointOfInterestsForStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>(AllPointOfInterestsForStructureDocument, options);
        }
export function useAllPointOfInterestsForStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>(AllPointOfInterestsForStructureDocument, options);
        }
export type AllPointOfInterestsForStructureQueryHookResult = ReturnType<typeof useAllPointOfInterestsForStructureQuery>;
export type AllPointOfInterestsForStructureLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestsForStructureLazyQuery>;
export type AllPointOfInterestsForStructureSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestsForStructureSuspenseQuery>;
export type AllPointOfInterestsForStructureQueryResult = Apollo.QueryResult<AllPointOfInterestsForStructureQuery, AllPointOfInterestsForStructureQueryVariables>;
export const GetAssemblyDetailsDocument = gql`
    query getAssemblyDetails($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    area
    seenByViewpoints {
      location {
        id
        name
      }
      corrosion {
        primaryCategory
      }
      distance
    }
    recommendation {
      analysisRecommendation {
        alarmLevel
      }
    }
    corrosionLevel
    template {
      id
      name
      type
      fields {
        id
        name
        type
      }
      equipmentDetails {
        id
        name
        subType
        type
        options {
          id
          name
          type
          fieldKey
        }
        fieldKey
      }
    }
    templateFieldData
    focalPoint {
      x
      y
      z
    }
    cameraPose {
      position {
        x
        y
        z
      }
      lookAt {
        x
        y
        z
      }
    }
    cadModelPath
    files {
      id
      name
      resourcePath
      type
      caption
      fileName
      uploadStatus
      imageType
      uuid
    }
    isUncontextualized
    pipeSpec {
      size
      material
      spec
      nominalCorrosionAllowance
      schedule
      nominalThickness
    }
  }
}
    `;

/**
 * __useGetAssemblyDetailsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyDetailsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>(GetAssemblyDetailsDocument, options);
      }
export function useGetAssemblyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>(GetAssemblyDetailsDocument, options);
        }
export function useGetAssemblyDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>(GetAssemblyDetailsDocument, options);
        }
export type GetAssemblyDetailsQueryHookResult = ReturnType<typeof useGetAssemblyDetailsQuery>;
export type GetAssemblyDetailsLazyQueryHookResult = ReturnType<typeof useGetAssemblyDetailsLazyQuery>;
export type GetAssemblyDetailsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyDetailsSuspenseQuery>;
export type GetAssemblyDetailsQueryResult = Apollo.QueryResult<GetAssemblyDetailsQuery, GetAssemblyDetailsQueryVariables>;
export const GetAssemblyViewpointsDocument = gql`
    query getAssemblyViewpoints($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    seenByViewpoints {
      location {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetAssemblyViewpointsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyViewpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyViewpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyViewpointsQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyViewpointsQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables> & ({ variables: GetAssemblyViewpointsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>(GetAssemblyViewpointsDocument, options);
      }
export function useGetAssemblyViewpointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>(GetAssemblyViewpointsDocument, options);
        }
export function useGetAssemblyViewpointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>(GetAssemblyViewpointsDocument, options);
        }
export type GetAssemblyViewpointsQueryHookResult = ReturnType<typeof useGetAssemblyViewpointsQuery>;
export type GetAssemblyViewpointsLazyQueryHookResult = ReturnType<typeof useGetAssemblyViewpointsLazyQuery>;
export type GetAssemblyViewpointsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyViewpointsSuspenseQuery>;
export type GetAssemblyViewpointsQueryResult = Apollo.QueryResult<GetAssemblyViewpointsQuery, GetAssemblyViewpointsQueryVariables>;
export const InlineUpdateSingleAssemblyTemplateFieldDataDocument = gql`
    mutation InlineUpdateSingleAssemblyTemplateFieldData($input: UpdateSingleTemplateFieldDataInput) {
  updateSingleTemplateFieldData(input: $input) {
    templateFieldData
  }
}
    `;
export type InlineUpdateSingleAssemblyTemplateFieldDataMutationFn = Apollo.MutationFunction<InlineUpdateSingleAssemblyTemplateFieldDataMutation, InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables>;

/**
 * __useInlineUpdateSingleAssemblyTemplateFieldDataMutation__
 *
 * To run a mutation, you first call `useInlineUpdateSingleAssemblyTemplateFieldDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInlineUpdateSingleAssemblyTemplateFieldDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inlineUpdateSingleAssemblyTemplateFieldDataMutation, { data, loading, error }] = useInlineUpdateSingleAssemblyTemplateFieldDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInlineUpdateSingleAssemblyTemplateFieldDataMutation(baseOptions?: Apollo.MutationHookOptions<InlineUpdateSingleAssemblyTemplateFieldDataMutation, InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InlineUpdateSingleAssemblyTemplateFieldDataMutation, InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables>(InlineUpdateSingleAssemblyTemplateFieldDataDocument, options);
      }
export type InlineUpdateSingleAssemblyTemplateFieldDataMutationHookResult = ReturnType<typeof useInlineUpdateSingleAssemblyTemplateFieldDataMutation>;
export type InlineUpdateSingleAssemblyTemplateFieldDataMutationResult = Apollo.MutationResult<InlineUpdateSingleAssemblyTemplateFieldDataMutation>;
export type InlineUpdateSingleAssemblyTemplateFieldDataMutationOptions = Apollo.BaseMutationOptions<InlineUpdateSingleAssemblyTemplateFieldDataMutation, InlineUpdateSingleAssemblyTemplateFieldDataMutationVariables>;
export const DefectLegendsForEquipmentDocument = gql`
    query DefectLegendsForEquipment($structureId: String) {
  structure(structureId: $structureId) {
    id
    defectLegends {
      id
      name
      groupKey
      groupName
      color
    }
  }
}
    `;

/**
 * __useDefectLegendsForEquipmentQuery__
 *
 * To run a query within a React component, call `useDefectLegendsForEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectLegendsForEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectLegendsForEquipmentQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDefectLegendsForEquipmentQuery(baseOptions?: Apollo.QueryHookOptions<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>(DefectLegendsForEquipmentDocument, options);
      }
export function useDefectLegendsForEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>(DefectLegendsForEquipmentDocument, options);
        }
export function useDefectLegendsForEquipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>(DefectLegendsForEquipmentDocument, options);
        }
export type DefectLegendsForEquipmentQueryHookResult = ReturnType<typeof useDefectLegendsForEquipmentQuery>;
export type DefectLegendsForEquipmentLazyQueryHookResult = ReturnType<typeof useDefectLegendsForEquipmentLazyQuery>;
export type DefectLegendsForEquipmentSuspenseQueryHookResult = ReturnType<typeof useDefectLegendsForEquipmentSuspenseQuery>;
export type DefectLegendsForEquipmentQueryResult = Apollo.QueryResult<DefectLegendsForEquipmentQuery, DefectLegendsForEquipmentQueryVariables>;
export const StructureTemplateByTypeDocument = gql`
    query StructureTemplateByType($structureId: ID, $type: TemplateTypeEnum) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    name
    type
    fields {
      id
      name
      key
    }
  }
}
    `;

/**
 * __useStructureTemplateByTypeQuery__
 *
 * To run a query within a React component, call `useStructureTemplateByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureTemplateByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureTemplateByTypeQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useStructureTemplateByTypeQuery(baseOptions?: Apollo.QueryHookOptions<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>(StructureTemplateByTypeDocument, options);
      }
export function useStructureTemplateByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>(StructureTemplateByTypeDocument, options);
        }
export function useStructureTemplateByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>(StructureTemplateByTypeDocument, options);
        }
export type StructureTemplateByTypeQueryHookResult = ReturnType<typeof useStructureTemplateByTypeQuery>;
export type StructureTemplateByTypeLazyQueryHookResult = ReturnType<typeof useStructureTemplateByTypeLazyQuery>;
export type StructureTemplateByTypeSuspenseQueryHookResult = ReturnType<typeof useStructureTemplateByTypeSuspenseQuery>;
export type StructureTemplateByTypeQueryResult = Apollo.QueryResult<StructureTemplateByTypeQuery, StructureTemplateByTypeQueryVariables>;
export const ScCategoryMappingDocument = gql`
    query ScCategoryMapping($structureId: String) {
  structure(structureId: $structureId) {
    id
    scCategoryMapping
  }
}
    `;

/**
 * __useScCategoryMappingQuery__
 *
 * To run a query within a React component, call `useScCategoryMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useScCategoryMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScCategoryMappingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useScCategoryMappingQuery(baseOptions?: Apollo.QueryHookOptions<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>(ScCategoryMappingDocument, options);
      }
export function useScCategoryMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>(ScCategoryMappingDocument, options);
        }
export function useScCategoryMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>(ScCategoryMappingDocument, options);
        }
export type ScCategoryMappingQueryHookResult = ReturnType<typeof useScCategoryMappingQuery>;
export type ScCategoryMappingLazyQueryHookResult = ReturnType<typeof useScCategoryMappingLazyQuery>;
export type ScCategoryMappingSuspenseQueryHookResult = ReturnType<typeof useScCategoryMappingSuspenseQuery>;
export type ScCategoryMappingQueryResult = Apollo.QueryResult<ScCategoryMappingQuery, ScCategoryMappingQueryVariables>;
export const AssemblyTemplateFieldDataDocument = gql`
    query AssemblyTemplateFieldData($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    templateFieldData
  }
}
    `;

/**
 * __useAssemblyTemplateFieldDataQuery__
 *
 * To run a query within a React component, call `useAssemblyTemplateFieldDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyTemplateFieldDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssemblyTemplateFieldDataQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useAssemblyTemplateFieldDataQuery(baseOptions: Apollo.QueryHookOptions<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables> & ({ variables: AssemblyTemplateFieldDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>(AssemblyTemplateFieldDataDocument, options);
      }
export function useAssemblyTemplateFieldDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>(AssemblyTemplateFieldDataDocument, options);
        }
export function useAssemblyTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>(AssemblyTemplateFieldDataDocument, options);
        }
export type AssemblyTemplateFieldDataQueryHookResult = ReturnType<typeof useAssemblyTemplateFieldDataQuery>;
export type AssemblyTemplateFieldDataLazyQueryHookResult = ReturnType<typeof useAssemblyTemplateFieldDataLazyQuery>;
export type AssemblyTemplateFieldDataSuspenseQueryHookResult = ReturnType<typeof useAssemblyTemplateFieldDataSuspenseQuery>;
export type AssemblyTemplateFieldDataQueryResult = Apollo.QueryResult<AssemblyTemplateFieldDataQuery, AssemblyTemplateFieldDataQueryVariables>;
export const UpdateScCategoryDocument = gql`
    mutation UpdateScCategory($input: UpdateScCategoryInput!) {
  updateScCategory(input: $input) {
    templateFieldData
  }
}
    `;
export type UpdateScCategoryMutationFn = Apollo.MutationFunction<UpdateScCategoryMutation, UpdateScCategoryMutationVariables>;

/**
 * __useUpdateScCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateScCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScCategoryMutation, { data, loading, error }] = useUpdateScCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScCategoryMutation, UpdateScCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScCategoryMutation, UpdateScCategoryMutationVariables>(UpdateScCategoryDocument, options);
      }
export type UpdateScCategoryMutationHookResult = ReturnType<typeof useUpdateScCategoryMutation>;
export type UpdateScCategoryMutationResult = Apollo.MutationResult<UpdateScCategoryMutation>;
export type UpdateScCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateScCategoryMutation, UpdateScCategoryMutationVariables>;
export const DefectPointOfInterestsDocument = gql`
    query DefectPointOfInterests($assemblyIds: [ID]!, $type: String) {
  allPointOfInterests(assemblyIds: $assemblyIds, type: $type) {
    id
    poiId
    type
    name
    templateData {
      id
      value
    }
  }
}
    `;

/**
 * __useDefectPointOfInterestsQuery__
 *
 * To run a query within a React component, call `useDefectPointOfInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectPointOfInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectPointOfInterestsQuery({
 *   variables: {
 *      assemblyIds: // value for 'assemblyIds'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDefectPointOfInterestsQuery(baseOptions: Apollo.QueryHookOptions<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables> & ({ variables: DefectPointOfInterestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>(DefectPointOfInterestsDocument, options);
      }
export function useDefectPointOfInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>(DefectPointOfInterestsDocument, options);
        }
export function useDefectPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>(DefectPointOfInterestsDocument, options);
        }
export type DefectPointOfInterestsQueryHookResult = ReturnType<typeof useDefectPointOfInterestsQuery>;
export type DefectPointOfInterestsLazyQueryHookResult = ReturnType<typeof useDefectPointOfInterestsLazyQuery>;
export type DefectPointOfInterestsSuspenseQueryHookResult = ReturnType<typeof useDefectPointOfInterestsSuspenseQuery>;
export type DefectPointOfInterestsQueryResult = Apollo.QueryResult<DefectPointOfInterestsQuery, DefectPointOfInterestsQueryVariables>;
export const AssemblyGoverningValueDocument = gql`
    query AssemblyGoverningValue($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    recommendation {
      governingValue {
        pointOfInterest {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAssemblyGoverningValueQuery__
 *
 * To run a query within a React component, call `useAssemblyGoverningValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyGoverningValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssemblyGoverningValueQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useAssemblyGoverningValueQuery(baseOptions?: Apollo.QueryHookOptions<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>(AssemblyGoverningValueDocument, options);
      }
export function useAssemblyGoverningValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>(AssemblyGoverningValueDocument, options);
        }
export function useAssemblyGoverningValueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>(AssemblyGoverningValueDocument, options);
        }
export type AssemblyGoverningValueQueryHookResult = ReturnType<typeof useAssemblyGoverningValueQuery>;
export type AssemblyGoverningValueLazyQueryHookResult = ReturnType<typeof useAssemblyGoverningValueLazyQuery>;
export type AssemblyGoverningValueSuspenseQueryHookResult = ReturnType<typeof useAssemblyGoverningValueSuspenseQuery>;
export type AssemblyGoverningValueQueryResult = Apollo.QueryResult<AssemblyGoverningValueQuery, AssemblyGoverningValueQueryVariables>;
export const GetAssemblyTemplateFieldDataDocument = gql`
    query getAssemblyTemplateFieldData($assemblyId: String!) {
  assembly(assemblyId: $assemblyId) {
    id
    tagName
    templateFieldData
  }
}
    `;

/**
 * __useGetAssemblyTemplateFieldDataQuery__
 *
 * To run a query within a React component, call `useGetAssemblyTemplateFieldDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyTemplateFieldDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyTemplateFieldDataQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyTemplateFieldDataQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables> & ({ variables: GetAssemblyTemplateFieldDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>(GetAssemblyTemplateFieldDataDocument, options);
      }
export function useGetAssemblyTemplateFieldDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>(GetAssemblyTemplateFieldDataDocument, options);
        }
export function useGetAssemblyTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>(GetAssemblyTemplateFieldDataDocument, options);
        }
export type GetAssemblyTemplateFieldDataQueryHookResult = ReturnType<typeof useGetAssemblyTemplateFieldDataQuery>;
export type GetAssemblyTemplateFieldDataLazyQueryHookResult = ReturnType<typeof useGetAssemblyTemplateFieldDataLazyQuery>;
export type GetAssemblyTemplateFieldDataSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyTemplateFieldDataSuspenseQuery>;
export type GetAssemblyTemplateFieldDataQueryResult = Apollo.QueryResult<GetAssemblyTemplateFieldDataQuery, GetAssemblyTemplateFieldDataQueryVariables>;
export const GetAssemblyPointOfInterestsDocument = gql`
    query getAssemblyPointOfInterests($assemblyIds: [ID]!) {
  allPointOfInterests(assemblyIds: $assemblyIds) {
    id
    poiId
    type
    location {
      id
    }
    name
    centerPoint3d {
      x
      y
      z
    }
    cameraLocation {
      x
      y
      z
    }
    assembly {
      id
    }
    blister {
      centerPoint {
        bearing
        elevation
      }
      radiusPoint {
        bearing
        elevation
      }
      borders3d {
        points {
          x
          y
          z
        }
      }
      scCategory
      estimatedHeight
      manualSetHeight
      pdrHeight
      heightType
      isManuallyOverridden
      maxHeight
      radius
      fittingRadius
      wallLoss {
        value
      }
    }
    templateData {
      id
      value
    }
    remediationNote
    files {
      id
      name
      resourcePath
      type
      fileName
      uploadStatus
      imageType
      uuid
    }
    comment
    deckRelativeHeight
    accessibility
    viewpointRelativeHeight
  }
}
    `;

/**
 * __useGetAssemblyPointOfInterestsQuery__
 *
 * To run a query within a React component, call `useGetAssemblyPointOfInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyPointOfInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyPointOfInterestsQuery({
 *   variables: {
 *      assemblyIds: // value for 'assemblyIds'
 *   },
 * });
 */
export function useGetAssemblyPointOfInterestsQuery(baseOptions: Apollo.QueryHookOptions<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables> & ({ variables: GetAssemblyPointOfInterestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>(GetAssemblyPointOfInterestsDocument, options);
      }
export function useGetAssemblyPointOfInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>(GetAssemblyPointOfInterestsDocument, options);
        }
export function useGetAssemblyPointOfInterestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>(GetAssemblyPointOfInterestsDocument, options);
        }
export type GetAssemblyPointOfInterestsQueryHookResult = ReturnType<typeof useGetAssemblyPointOfInterestsQuery>;
export type GetAssemblyPointOfInterestsLazyQueryHookResult = ReturnType<typeof useGetAssemblyPointOfInterestsLazyQuery>;
export type GetAssemblyPointOfInterestsSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyPointOfInterestsSuspenseQuery>;
export type GetAssemblyPointOfInterestsQueryResult = Apollo.QueryResult<GetAssemblyPointOfInterestsQuery, GetAssemblyPointOfInterestsQueryVariables>;
export const UpdateCuiPriorityDocument = gql`
    mutation UpdateCuiPriority($input: UpdateCuiPriorityInput!) {
  updateCuiPriority(input: $input) {
    templateFieldData
  }
}
    `;
export type UpdateCuiPriorityMutationFn = Apollo.MutationFunction<UpdateCuiPriorityMutation, UpdateCuiPriorityMutationVariables>;

/**
 * __useUpdateCuiPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateCuiPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCuiPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCuiPriorityMutation, { data, loading, error }] = useUpdateCuiPriorityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCuiPriorityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCuiPriorityMutation, UpdateCuiPriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCuiPriorityMutation, UpdateCuiPriorityMutationVariables>(UpdateCuiPriorityDocument, options);
      }
export type UpdateCuiPriorityMutationHookResult = ReturnType<typeof useUpdateCuiPriorityMutation>;
export type UpdateCuiPriorityMutationResult = Apollo.MutationResult<UpdateCuiPriorityMutation>;
export type UpdateCuiPriorityMutationOptions = Apollo.BaseMutationOptions<UpdateCuiPriorityMutation, UpdateCuiPriorityMutationVariables>;
export const GetAssembliesByTemplateFieldsFiltersForEquipmentsTabDocument = gql`
    query GetAssembliesByTemplateFieldsFiltersForEquipmentsTab($input: AssembliesFilterInput) {
  getAssembliesByTemplateFieldsFilters(input: $input) {
    id
    tagName
    templateFieldData
    isUncontextualized
    box {
      max {
        x
        y
        z
      }
      min {
        x
        y
        z
      }
    }
  }
  getAssembliesCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentsTabDocument, options);
      }
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentsTabDocument, options);
        }
export function useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>(GetAssembliesByTemplateFieldsFiltersForEquipmentsTabDocument, options);
        }
export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabLazyQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabLazyQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForEquipmentsTabSuspenseQuery>;
export type GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryResult = Apollo.QueryResult<GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQuery, GetAssembliesByTemplateFieldsFiltersForEquipmentsTabQueryVariables>;
export const GetAssembliesWithTemplateFieldDataDocument = gql`
    query GetAssembliesWithTemplateFieldData($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
    isUncontextualized
  }
  getAssembliesCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetAssembliesWithTemplateFieldDataQuery__
 *
 * To run a query within a React component, call `useGetAssembliesWithTemplateFieldDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesWithTemplateFieldDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesWithTemplateFieldDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesWithTemplateFieldDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>(GetAssembliesWithTemplateFieldDataDocument, options);
      }
export function useGetAssembliesWithTemplateFieldDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>(GetAssembliesWithTemplateFieldDataDocument, options);
        }
export function useGetAssembliesWithTemplateFieldDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>(GetAssembliesWithTemplateFieldDataDocument, options);
        }
export type GetAssembliesWithTemplateFieldDataQueryHookResult = ReturnType<typeof useGetAssembliesWithTemplateFieldDataQuery>;
export type GetAssembliesWithTemplateFieldDataLazyQueryHookResult = ReturnType<typeof useGetAssembliesWithTemplateFieldDataLazyQuery>;
export type GetAssembliesWithTemplateFieldDataSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesWithTemplateFieldDataSuspenseQuery>;
export type GetAssembliesWithTemplateFieldDataQueryResult = Apollo.QueryResult<GetAssembliesWithTemplateFieldDataQuery, GetAssembliesWithTemplateFieldDataQueryVariables>;
export const AllDecksForFilterSideBarDocument = gql`
    query AllDecksForFilterSideBar($structureId: ID) {
  allDecks(structureId: $structureId) {
    id
    name
  }
}
    `;

/**
 * __useAllDecksForFilterSideBarQuery__
 *
 * To run a query within a React component, call `useAllDecksForFilterSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllDecksForFilterSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllDecksForFilterSideBarQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllDecksForFilterSideBarQuery(baseOptions?: Apollo.QueryHookOptions<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>(AllDecksForFilterSideBarDocument, options);
      }
export function useAllDecksForFilterSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>(AllDecksForFilterSideBarDocument, options);
        }
export function useAllDecksForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>(AllDecksForFilterSideBarDocument, options);
        }
export type AllDecksForFilterSideBarQueryHookResult = ReturnType<typeof useAllDecksForFilterSideBarQuery>;
export type AllDecksForFilterSideBarLazyQueryHookResult = ReturnType<typeof useAllDecksForFilterSideBarLazyQuery>;
export type AllDecksForFilterSideBarSuspenseQueryHookResult = ReturnType<typeof useAllDecksForFilterSideBarSuspenseQuery>;
export type AllDecksForFilterSideBarQueryResult = Apollo.QueryResult<AllDecksForFilterSideBarQuery, AllDecksForFilterSideBarQueryVariables>;
export const AllPaintRegionsDocument = gql`
    query AllPaintRegions($structureId: ID, $deckIds: [String]) {
  allPaintRegions(structureId: $structureId, deckIds: $deckIds) {
    id
    name
    deck {
      id
    }
  }
}
    `;

/**
 * __useAllPaintRegionsQuery__
 *
 * To run a query within a React component, call `useAllPaintRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaintRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaintRegionsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      deckIds: // value for 'deckIds'
 *   },
 * });
 */
export function useAllPaintRegionsQuery(baseOptions?: Apollo.QueryHookOptions<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>(AllPaintRegionsDocument, options);
      }
export function useAllPaintRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>(AllPaintRegionsDocument, options);
        }
export function useAllPaintRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>(AllPaintRegionsDocument, options);
        }
export type AllPaintRegionsQueryHookResult = ReturnType<typeof useAllPaintRegionsQuery>;
export type AllPaintRegionsLazyQueryHookResult = ReturnType<typeof useAllPaintRegionsLazyQuery>;
export type AllPaintRegionsSuspenseQueryHookResult = ReturnType<typeof useAllPaintRegionsSuspenseQuery>;
export type AllPaintRegionsQueryResult = Apollo.QueryResult<AllPaintRegionsQuery, AllPaintRegionsQueryVariables>;
export const AllAssemblyTemplatesForFilterSideBarDocument = gql`
    query AllAssemblyTemplatesForFilterSideBar($structureId: ID, $type: TemplateTypeEnum) {
  allTemplates(structureId: $structureId, type: $type) {
    name
    octreeResourcesPath
    baseImagePath
    coverImagePath
    includedTemplateIds
    isCombined
    structureRelationshipPath
    id
    defectsArray
    recommendation {
      header
      details {
        id
        fieldKey
      }
    }
    equipmentCard {
      id
      name
      type
      position
      fieldKey
      location
    }
    equipmentDetails {
      id
      name
      subType
      type
      fieldKey
      options {
        id
        name
        type
        fieldKey
      }
    }
    assessmentDetails {
      id
      name
      type
      position
      isVisible
      options {
        id
        name
        type
        fieldKey
        isEditable
        editRoles
      }
    }
    reviewPanelConfig {
      groupKey
      groupName
      id
      groupSection {
        id
        title
        sectionKey
        fieldKeys
      }
    }
    querySummary {
      name
      key
      operation
    }
    fields {
      isEditable
      editRoles
      options
      displayConfig {
        id
        type
        color {
          key
          value
        }
        isSortable
        sortType
        textFormat
      }
      id
      name
      key
      type
      serverSide
      permission
      displayInQuery
      isHidden
      displayInTable
      displayInRisk
      displayInReview
      displayInReports
      displayInReportFilters
      roundToDecimal
      unit
      displayUnit
      optionsData {
        value
        min
        max
      }
    }
  }
}
    `;

/**
 * __useAllAssemblyTemplatesForFilterSideBarQuery__
 *
 * To run a query within a React component, call `useAllAssemblyTemplatesForFilterSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssemblyTemplatesForFilterSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssemblyTemplatesForFilterSideBarQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAllAssemblyTemplatesForFilterSideBarQuery(baseOptions?: Apollo.QueryHookOptions<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>(AllAssemblyTemplatesForFilterSideBarDocument, options);
      }
export function useAllAssemblyTemplatesForFilterSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>(AllAssemblyTemplatesForFilterSideBarDocument, options);
        }
export function useAllAssemblyTemplatesForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>(AllAssemblyTemplatesForFilterSideBarDocument, options);
        }
export type AllAssemblyTemplatesForFilterSideBarQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForFilterSideBarQuery>;
export type AllAssemblyTemplatesForFilterSideBarLazyQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForFilterSideBarLazyQuery>;
export type AllAssemblyTemplatesForFilterSideBarSuspenseQueryHookResult = ReturnType<typeof useAllAssemblyTemplatesForFilterSideBarSuspenseQuery>;
export type AllAssemblyTemplatesForFilterSideBarQueryResult = Apollo.QueryResult<AllAssemblyTemplatesForFilterSideBarQuery, AllAssemblyTemplatesForFilterSideBarQueryVariables>;
export const GetAssembliesByTemplateFieldsFiltersForFilterSideBarDocument = gql`
    query GetAssembliesByTemplateFieldsFiltersForFilterSideBar($input: AssembliesFilterInput, $pageInfo: PageInfo) {
  getAssembliesByTemplateFieldsFilters(input: $input, pageInfo: $pageInfo) {
    id
    tagName
    templateFieldData
    isUncontextualized
    decks {
      deckId {
        id
      }
    }
  }
  getAssembliesCount(input: $input) {
    count
  }
}
    `;

/**
 * __useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery__
 *
 * To run a query within a React component, call `useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery(baseOptions?: Apollo.QueryHookOptions<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>(GetAssembliesByTemplateFieldsFiltersForFilterSideBarDocument, options);
      }
export function useGetAssembliesByTemplateFieldsFiltersForFilterSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>(GetAssembliesByTemplateFieldsFiltersForFilterSideBarDocument, options);
        }
export function useGetAssembliesByTemplateFieldsFiltersForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>(GetAssembliesByTemplateFieldsFiltersForFilterSideBarDocument, options);
        }
export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery>;
export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarLazyQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForFilterSideBarLazyQuery>;
export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarSuspenseQueryHookResult = ReturnType<typeof useGetAssembliesByTemplateFieldsFiltersForFilterSideBarSuspenseQuery>;
export type GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryResult = Apollo.QueryResult<GetAssembliesByTemplateFieldsFiltersForFilterSideBarQuery, GetAssembliesByTemplateFieldsFiltersForFilterSideBarQueryVariables>;
export const AllWorkpacksForFilterSideBarDocument = gql`
    query AllWorkpacksForFilterSideBar($structureId: String, $hasPois: Boolean) {
  allWorkpacks(structureId: $structureId, hasPois: $hasPois) {
    id
    name
  }
}
    `;

/**
 * __useAllWorkpacksForFilterSideBarQuery__
 *
 * To run a query within a React component, call `useAllWorkpacksForFilterSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllWorkpacksForFilterSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllWorkpacksForFilterSideBarQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      hasPois: // value for 'hasPois'
 *   },
 * });
 */
export function useAllWorkpacksForFilterSideBarQuery(baseOptions?: Apollo.QueryHookOptions<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>(AllWorkpacksForFilterSideBarDocument, options);
      }
export function useAllWorkpacksForFilterSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>(AllWorkpacksForFilterSideBarDocument, options);
        }
export function useAllWorkpacksForFilterSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>(AllWorkpacksForFilterSideBarDocument, options);
        }
export type AllWorkpacksForFilterSideBarQueryHookResult = ReturnType<typeof useAllWorkpacksForFilterSideBarQuery>;
export type AllWorkpacksForFilterSideBarLazyQueryHookResult = ReturnType<typeof useAllWorkpacksForFilterSideBarLazyQuery>;
export type AllWorkpacksForFilterSideBarSuspenseQueryHookResult = ReturnType<typeof useAllWorkpacksForFilterSideBarSuspenseQuery>;
export type AllWorkpacksForFilterSideBarQueryResult = Apollo.QueryResult<AllWorkpacksForFilterSideBarQuery, AllWorkpacksForFilterSideBarQueryVariables>;
export const UpdateFileStatusDocument = gql`
    mutation UpdateFileStatus($input: UpdateFilesStatusInput!) {
  updateFilesStatus(input: $input)
}
    `;
export type UpdateFileStatusMutationFn = Apollo.MutationFunction<UpdateFileStatusMutation, UpdateFileStatusMutationVariables>;

/**
 * __useUpdateFileStatusMutation__
 *
 * To run a mutation, you first call `useUpdateFileStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileStatusMutation, { data, loading, error }] = useUpdateFileStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileStatusMutation, UpdateFileStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileStatusMutation, UpdateFileStatusMutationVariables>(UpdateFileStatusDocument, options);
      }
export type UpdateFileStatusMutationHookResult = ReturnType<typeof useUpdateFileStatusMutation>;
export type UpdateFileStatusMutationResult = Apollo.MutationResult<UpdateFileStatusMutation>;
export type UpdateFileStatusMutationOptions = Apollo.BaseMutationOptions<UpdateFileStatusMutation, UpdateFileStatusMutationVariables>;
export const UploadFilesDocument = gql`
    mutation UploadFiles($input: UploadFileInput!) {
  preSignedUrlToUploadFiles(input: $input) {
    url
    id
    resourcePath
    uuid
  }
}
    `;
export type UploadFilesMutationFn = Apollo.MutationFunction<UploadFilesMutation, UploadFilesMutationVariables>;

/**
 * __useUploadFilesMutation__
 *
 * To run a mutation, you first call `useUploadFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFilesMutation, { data, loading, error }] = useUploadFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadFilesMutation(baseOptions?: Apollo.MutationHookOptions<UploadFilesMutation, UploadFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFilesMutation, UploadFilesMutationVariables>(UploadFilesDocument, options);
      }
export type UploadFilesMutationHookResult = ReturnType<typeof useUploadFilesMutation>;
export type UploadFilesMutationResult = Apollo.MutationResult<UploadFilesMutation>;
export type UploadFilesMutationOptions = Apollo.BaseMutationOptions<UploadFilesMutation, UploadFilesMutationVariables>;
export const DeleteFilesDocument = gql`
    mutation DeleteFiles($input: DeleteFilesInput!) {
  deleteFiles(input: $input) {
    message
    deletedFiles
  }
}
    `;
export type DeleteFilesMutationFn = Apollo.MutationFunction<DeleteFilesMutation, DeleteFilesMutationVariables>;

/**
 * __useDeleteFilesMutation__
 *
 * To run a mutation, you first call `useDeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesMutation, { data, loading, error }] = useDeleteFilesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFilesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFilesMutation, DeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFilesMutation, DeleteFilesMutationVariables>(DeleteFilesDocument, options);
      }
export type DeleteFilesMutationHookResult = ReturnType<typeof useDeleteFilesMutation>;
export type DeleteFilesMutationResult = Apollo.MutationResult<DeleteFilesMutation>;
export type DeleteFilesMutationOptions = Apollo.BaseMutationOptions<DeleteFilesMutation, DeleteFilesMutationVariables>;
export const AssemblyImageCaptionDocument = gql`
    mutation AssemblyImageCaption($input: AssemblyImageCaptionInput!) {
  addAssemblyImageCaption(input: $input)
}
    `;
export type AssemblyImageCaptionMutationFn = Apollo.MutationFunction<AssemblyImageCaptionMutation, AssemblyImageCaptionMutationVariables>;

/**
 * __useAssemblyImageCaptionMutation__
 *
 * To run a mutation, you first call `useAssemblyImageCaptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssemblyImageCaptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assemblyImageCaptionMutation, { data, loading, error }] = useAssemblyImageCaptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssemblyImageCaptionMutation(baseOptions?: Apollo.MutationHookOptions<AssemblyImageCaptionMutation, AssemblyImageCaptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssemblyImageCaptionMutation, AssemblyImageCaptionMutationVariables>(AssemblyImageCaptionDocument, options);
      }
export type AssemblyImageCaptionMutationHookResult = ReturnType<typeof useAssemblyImageCaptionMutation>;
export type AssemblyImageCaptionMutationResult = Apollo.MutationResult<AssemblyImageCaptionMutation>;
export type AssemblyImageCaptionMutationOptions = Apollo.BaseMutationOptions<AssemblyImageCaptionMutation, AssemblyImageCaptionMutationVariables>;
export const AddUpdateCuboidDocument = gql`
    mutation AddUpdateCuboid($input: AddUpdateCuboidInput) {
  addUpdateCuboid(input: $input) {
    id
    structureId
    cuboidClassId
    zoneId
    position
    scale
    rotation
  }
}
    `;
export type AddUpdateCuboidMutationFn = Apollo.MutationFunction<AddUpdateCuboidMutation, AddUpdateCuboidMutationVariables>;

/**
 * __useAddUpdateCuboidMutation__
 *
 * To run a mutation, you first call `useAddUpdateCuboidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateCuboidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateCuboidMutation, { data, loading, error }] = useAddUpdateCuboidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateCuboidMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateCuboidMutation, AddUpdateCuboidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateCuboidMutation, AddUpdateCuboidMutationVariables>(AddUpdateCuboidDocument, options);
      }
export type AddUpdateCuboidMutationHookResult = ReturnType<typeof useAddUpdateCuboidMutation>;
export type AddUpdateCuboidMutationResult = Apollo.MutationResult<AddUpdateCuboidMutation>;
export type AddUpdateCuboidMutationOptions = Apollo.BaseMutationOptions<AddUpdateCuboidMutation, AddUpdateCuboidMutationVariables>;
export const DeleteCuboidDocument = gql`
    mutation DeleteCuboid($input: DeleteCuboidInput) {
  deleteCuboid(input: $input)
}
    `;
export type DeleteCuboidMutationFn = Apollo.MutationFunction<DeleteCuboidMutation, DeleteCuboidMutationVariables>;

/**
 * __useDeleteCuboidMutation__
 *
 * To run a mutation, you first call `useDeleteCuboidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCuboidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCuboidMutation, { data, loading, error }] = useDeleteCuboidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCuboidMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCuboidMutation, DeleteCuboidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCuboidMutation, DeleteCuboidMutationVariables>(DeleteCuboidDocument, options);
      }
export type DeleteCuboidMutationHookResult = ReturnType<typeof useDeleteCuboidMutation>;
export type DeleteCuboidMutationResult = Apollo.MutationResult<DeleteCuboidMutation>;
export type DeleteCuboidMutationOptions = Apollo.BaseMutationOptions<DeleteCuboidMutation, DeleteCuboidMutationVariables>;
export const GetStructureLocationsForAssetLabellingDataLoaderDocument = gql`
    query getStructureLocationsForAssetLabellingDataLoader($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
    videoResourcePath
    videoTimestamp
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
  }
}
    `;

/**
 * __useGetStructureLocationsForAssetLabellingDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureLocationsForAssetLabellingDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureLocationsForAssetLabellingDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureLocationsForAssetLabellingDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureLocationsForAssetLabellingDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables> & ({ variables: GetStructureLocationsForAssetLabellingDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>(GetStructureLocationsForAssetLabellingDataLoaderDocument, options);
      }
export function useGetStructureLocationsForAssetLabellingDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>(GetStructureLocationsForAssetLabellingDataLoaderDocument, options);
        }
export function useGetStructureLocationsForAssetLabellingDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>(GetStructureLocationsForAssetLabellingDataLoaderDocument, options);
        }
export type GetStructureLocationsForAssetLabellingDataLoaderQueryHookResult = ReturnType<typeof useGetStructureLocationsForAssetLabellingDataLoaderQuery>;
export type GetStructureLocationsForAssetLabellingDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureLocationsForAssetLabellingDataLoaderLazyQuery>;
export type GetStructureLocationsForAssetLabellingDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureLocationsForAssetLabellingDataLoaderSuspenseQuery>;
export type GetStructureLocationsForAssetLabellingDataLoaderQueryResult = Apollo.QueryResult<GetStructureLocationsForAssetLabellingDataLoaderQuery, GetStructureLocationsForAssetLabellingDataLoaderQueryVariables>;
export const GetAllLabelAnnotationsDocument = gql`
    query getAllLabelAnnotations($structureId: String!) {
  allLabelAnnotations(structureId: $structureId) {
    id
    labelClassId
    octreeId
  }
}
    `;

/**
 * __useGetAllLabelAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetAllLabelAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLabelAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLabelAnnotationsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllLabelAnnotationsQuery(baseOptions: Apollo.QueryHookOptions<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables> & ({ variables: GetAllLabelAnnotationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>(GetAllLabelAnnotationsDocument, options);
      }
export function useGetAllLabelAnnotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>(GetAllLabelAnnotationsDocument, options);
        }
export function useGetAllLabelAnnotationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>(GetAllLabelAnnotationsDocument, options);
        }
export type GetAllLabelAnnotationsQueryHookResult = ReturnType<typeof useGetAllLabelAnnotationsQuery>;
export type GetAllLabelAnnotationsLazyQueryHookResult = ReturnType<typeof useGetAllLabelAnnotationsLazyQuery>;
export type GetAllLabelAnnotationsSuspenseQueryHookResult = ReturnType<typeof useGetAllLabelAnnotationsSuspenseQuery>;
export type GetAllLabelAnnotationsQueryResult = Apollo.QueryResult<GetAllLabelAnnotationsQuery, GetAllLabelAnnotationsQueryVariables>;
export const GetStructureForAssetLabellingDocument = gql`
    query getStructureForAssetLabelling($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
    octreeResourcesPath
    hasRGB
    labelClasses {
      id
      name
      color
    }
    cuboidClasses {
      id
      name
      color
    }
  }
}
    `;

/**
 * __useGetStructureForAssetLabellingQuery__
 *
 * To run a query within a React component, call `useGetStructureForAssetLabellingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureForAssetLabellingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureForAssetLabellingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureForAssetLabellingQuery(baseOptions: Apollo.QueryHookOptions<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables> & ({ variables: GetStructureForAssetLabellingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>(GetStructureForAssetLabellingDocument, options);
      }
export function useGetStructureForAssetLabellingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>(GetStructureForAssetLabellingDocument, options);
        }
export function useGetStructureForAssetLabellingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>(GetStructureForAssetLabellingDocument, options);
        }
export type GetStructureForAssetLabellingQueryHookResult = ReturnType<typeof useGetStructureForAssetLabellingQuery>;
export type GetStructureForAssetLabellingLazyQueryHookResult = ReturnType<typeof useGetStructureForAssetLabellingLazyQuery>;
export type GetStructureForAssetLabellingSuspenseQueryHookResult = ReturnType<typeof useGetStructureForAssetLabellingSuspenseQuery>;
export type GetStructureForAssetLabellingQueryResult = Apollo.QueryResult<GetStructureForAssetLabellingQuery, GetStructureForAssetLabellingQueryVariables>;
export const GetAllZonesForAssetLabellingDocument = gql`
    query GetAllZonesForAssetLabelling($structureId: String!) {
  zonesForStructure(structureId: $structureId) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    status
    structureId
    workflowStatus {
      workflowStageId
      state
      pausedBy
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllZonesForAssetLabellingQuery__
 *
 * To run a query within a React component, call `useGetAllZonesForAssetLabellingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllZonesForAssetLabellingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllZonesForAssetLabellingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetAllZonesForAssetLabellingQuery(baseOptions: Apollo.QueryHookOptions<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables> & ({ variables: GetAllZonesForAssetLabellingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>(GetAllZonesForAssetLabellingDocument, options);
      }
export function useGetAllZonesForAssetLabellingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>(GetAllZonesForAssetLabellingDocument, options);
        }
export function useGetAllZonesForAssetLabellingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>(GetAllZonesForAssetLabellingDocument, options);
        }
export type GetAllZonesForAssetLabellingQueryHookResult = ReturnType<typeof useGetAllZonesForAssetLabellingQuery>;
export type GetAllZonesForAssetLabellingLazyQueryHookResult = ReturnType<typeof useGetAllZonesForAssetLabellingLazyQuery>;
export type GetAllZonesForAssetLabellingSuspenseQueryHookResult = ReturnType<typeof useGetAllZonesForAssetLabellingSuspenseQuery>;
export type GetAllZonesForAssetLabellingQueryResult = Apollo.QueryResult<GetAllZonesForAssetLabellingQuery, GetAllZonesForAssetLabellingQueryVariables>;
export const GetCuboidsByZoneIdDocument = gql`
    query getCuboidsByZoneId($zoneId: String!) {
  cuboidsByZoneId(zoneId: $zoneId) {
    id
    structureId
    cuboidClassId
    zoneId
    position
    scale
    rotation
  }
}
    `;

/**
 * __useGetCuboidsByZoneIdQuery__
 *
 * To run a query within a React component, call `useGetCuboidsByZoneIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCuboidsByZoneIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCuboidsByZoneIdQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useGetCuboidsByZoneIdQuery(baseOptions: Apollo.QueryHookOptions<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables> & ({ variables: GetCuboidsByZoneIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>(GetCuboidsByZoneIdDocument, options);
      }
export function useGetCuboidsByZoneIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>(GetCuboidsByZoneIdDocument, options);
        }
export function useGetCuboidsByZoneIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>(GetCuboidsByZoneIdDocument, options);
        }
export type GetCuboidsByZoneIdQueryHookResult = ReturnType<typeof useGetCuboidsByZoneIdQuery>;
export type GetCuboidsByZoneIdLazyQueryHookResult = ReturnType<typeof useGetCuboidsByZoneIdLazyQuery>;
export type GetCuboidsByZoneIdSuspenseQueryHookResult = ReturnType<typeof useGetCuboidsByZoneIdSuspenseQuery>;
export type GetCuboidsByZoneIdQueryResult = Apollo.QueryResult<GetCuboidsByZoneIdQuery, GetCuboidsByZoneIdQueryVariables>;
export const BenchmarkUploadDocument = gql`
    mutation benchmarkUpload($input: BenchmarkUploadInput) {
  benchmarkUpload(input: $input) {
    size
  }
}
    `;
export type BenchmarkUploadMutationFn = Apollo.MutationFunction<BenchmarkUploadMutation, BenchmarkUploadMutationVariables>;

/**
 * __useBenchmarkUploadMutation__
 *
 * To run a mutation, you first call `useBenchmarkUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenchmarkUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benchmarkUploadMutation, { data, loading, error }] = useBenchmarkUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBenchmarkUploadMutation(baseOptions?: Apollo.MutationHookOptions<BenchmarkUploadMutation, BenchmarkUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BenchmarkUploadMutation, BenchmarkUploadMutationVariables>(BenchmarkUploadDocument, options);
      }
export type BenchmarkUploadMutationHookResult = ReturnType<typeof useBenchmarkUploadMutation>;
export type BenchmarkUploadMutationResult = Apollo.MutationResult<BenchmarkUploadMutation>;
export type BenchmarkUploadMutationOptions = Apollo.BaseMutationOptions<BenchmarkUploadMutation, BenchmarkUploadMutationVariables>;
export const BenchmarkDownloadDocument = gql`
    mutation benchmarkDownload($input: BenchmarkDownloadInput) {
  benchmarkDownload(input: $input) {
    data
  }
}
    `;
export type BenchmarkDownloadMutationFn = Apollo.MutationFunction<BenchmarkDownloadMutation, BenchmarkDownloadMutationVariables>;

/**
 * __useBenchmarkDownloadMutation__
 *
 * To run a mutation, you first call `useBenchmarkDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBenchmarkDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [benchmarkDownloadMutation, { data, loading, error }] = useBenchmarkDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBenchmarkDownloadMutation(baseOptions?: Apollo.MutationHookOptions<BenchmarkDownloadMutation, BenchmarkDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BenchmarkDownloadMutation, BenchmarkDownloadMutationVariables>(BenchmarkDownloadDocument, options);
      }
export type BenchmarkDownloadMutationHookResult = ReturnType<typeof useBenchmarkDownloadMutation>;
export type BenchmarkDownloadMutationResult = Apollo.MutationResult<BenchmarkDownloadMutation>;
export type BenchmarkDownloadMutationOptions = Apollo.BaseMutationOptions<BenchmarkDownloadMutation, BenchmarkDownloadMutationVariables>;
export const ValidateEsSheetDocument = gql`
    mutation ValidateEsSheet($headers: [String!]!) {
  validateEsSheet(headers: $headers)
}
    `;
export type ValidateEsSheetMutationFn = Apollo.MutationFunction<ValidateEsSheetMutation, ValidateEsSheetMutationVariables>;

/**
 * __useValidateEsSheetMutation__
 *
 * To run a mutation, you first call `useValidateEsSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateEsSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateEsSheetMutation, { data, loading, error }] = useValidateEsSheetMutation({
 *   variables: {
 *      headers: // value for 'headers'
 *   },
 * });
 */
export function useValidateEsSheetMutation(baseOptions?: Apollo.MutationHookOptions<ValidateEsSheetMutation, ValidateEsSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateEsSheetMutation, ValidateEsSheetMutationVariables>(ValidateEsSheetDocument, options);
      }
export type ValidateEsSheetMutationHookResult = ReturnType<typeof useValidateEsSheetMutation>;
export type ValidateEsSheetMutationResult = Apollo.MutationResult<ValidateEsSheetMutation>;
export type ValidateEsSheetMutationOptions = Apollo.BaseMutationOptions<ValidateEsSheetMutation, ValidateEsSheetMutationVariables>;
export const UploadEsSheetDocument = gql`
    mutation UploadEsSheet($input: UploadEsSheetInput!) {
  uploadEsSheet(input: $input)
}
    `;
export type UploadEsSheetMutationFn = Apollo.MutationFunction<UploadEsSheetMutation, UploadEsSheetMutationVariables>;

/**
 * __useUploadEsSheetMutation__
 *
 * To run a mutation, you first call `useUploadEsSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEsSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEsSheetMutation, { data, loading, error }] = useUploadEsSheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadEsSheetMutation(baseOptions?: Apollo.MutationHookOptions<UploadEsSheetMutation, UploadEsSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEsSheetMutation, UploadEsSheetMutationVariables>(UploadEsSheetDocument, options);
      }
export type UploadEsSheetMutationHookResult = ReturnType<typeof useUploadEsSheetMutation>;
export type UploadEsSheetMutationResult = Apollo.MutationResult<UploadEsSheetMutation>;
export type UploadEsSheetMutationOptions = Apollo.BaseMutationOptions<UploadEsSheetMutation, UploadEsSheetMutationVariables>;
export const GetStructureDocument = gql`
    query GetStructure($structureId: String) {
  structure(structureId: $structureId) {
    name
    templateData {
      id
      value
    }
  }
}
    `;

/**
 * __useGetStructureQuery__
 *
 * To run a query within a React component, call `useGetStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureQuery(baseOptions?: Apollo.QueryHookOptions<GetStructureQuery, GetStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureQuery, GetStructureQueryVariables>(GetStructureDocument, options);
      }
export function useGetStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureQuery, GetStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureQuery, GetStructureQueryVariables>(GetStructureDocument, options);
        }
export function useGetStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureQuery, GetStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureQuery, GetStructureQueryVariables>(GetStructureDocument, options);
        }
export type GetStructureQueryHookResult = ReturnType<typeof useGetStructureQuery>;
export type GetStructureLazyQueryHookResult = ReturnType<typeof useGetStructureLazyQuery>;
export type GetStructureSuspenseQueryHookResult = ReturnType<typeof useGetStructureSuspenseQuery>;
export type GetStructureQueryResult = Apollo.QueryResult<GetStructureQuery, GetStructureQueryVariables>;
export const GetStructureRelationshipsForLabellingInspectionDataLoaderDocument = gql`
    query getStructureRelationshipsForLabellingInspectionDataLoader($structureId: String!, $supervoxelsForStructureInput: supervoxelsForStructureInput) {
  supervoxelsClassesForStructure(structureId: $structureId) {
    color
    id
    name
    structureId
  }
  supervoxelsForStructure(
    supervoxelsForStructureInput: $supervoxelsForStructureInput
  ) {
    id
    zoneId
    structureId
    supervoxel3DReference
    supervoxelClassId
  }
  structure(structureId: $structureId) {
    octreeResourcesPath
  }
}
    `;

/**
 * __useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      supervoxelsForStructureInput: // value for 'supervoxelsForStructureInput'
 *   },
 * });
 */
export function useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables> & ({ variables: GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForLabellingInspectionDataLoaderDocument, options);
      }
export function useGetStructureRelationshipsForLabellingInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForLabellingInspectionDataLoaderDocument, options);
        }
export function useGetStructureRelationshipsForLabellingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForLabellingInspectionDataLoaderDocument, options);
        }
export type GetStructureRelationshipsForLabellingInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForLabellingInspectionDataLoaderQuery>;
export type GetStructureRelationshipsForLabellingInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForLabellingInspectionDataLoaderLazyQuery>;
export type GetStructureRelationshipsForLabellingInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForLabellingInspectionDataLoaderSuspenseQuery>;
export type GetStructureRelationshipsForLabellingInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureRelationshipsForLabellingInspectionDataLoaderQuery, GetStructureRelationshipsForLabellingInspectionDataLoaderQueryVariables>;
export const GetStructureLocationsForLabellingInspectionDataLoaderDocument = gql`
    query getStructureLocationsForLabellingInspectionDataLoader($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    videoResourcePath
    videoTimestamp
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
  }
}
    `;

/**
 * __useGetStructureLocationsForLabellingInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureLocationsForLabellingInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureLocationsForLabellingInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureLocationsForLabellingInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureLocationsForLabellingInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables> & ({ variables: GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>(GetStructureLocationsForLabellingInspectionDataLoaderDocument, options);
      }
export function useGetStructureLocationsForLabellingInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>(GetStructureLocationsForLabellingInspectionDataLoaderDocument, options);
        }
export function useGetStructureLocationsForLabellingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>(GetStructureLocationsForLabellingInspectionDataLoaderDocument, options);
        }
export type GetStructureLocationsForLabellingInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureLocationsForLabellingInspectionDataLoaderQuery>;
export type GetStructureLocationsForLabellingInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureLocationsForLabellingInspectionDataLoaderLazyQuery>;
export type GetStructureLocationsForLabellingInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureLocationsForLabellingInspectionDataLoaderSuspenseQuery>;
export type GetStructureLocationsForLabellingInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureLocationsForLabellingInspectionDataLoaderQuery, GetStructureLocationsForLabellingInspectionDataLoaderQueryVariables>;
export const ZonesForStructureForLabellingDocument = gql`
    query zonesForStructureForLabelling($structureId: String) {
  zonesForStructure(structureId: $structureId) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    structureId
    status
    workflowStatus {
      workflowStageId
      state
      pausedBy
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useZonesForStructureForLabellingQuery__
 *
 * To run a query within a React component, call `useZonesForStructureForLabellingQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesForStructureForLabellingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesForStructureForLabellingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZonesForStructureForLabellingQuery(baseOptions?: Apollo.QueryHookOptions<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>(ZonesForStructureForLabellingDocument, options);
      }
export function useZonesForStructureForLabellingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>(ZonesForStructureForLabellingDocument, options);
        }
export function useZonesForStructureForLabellingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>(ZonesForStructureForLabellingDocument, options);
        }
export type ZonesForStructureForLabellingQueryHookResult = ReturnType<typeof useZonesForStructureForLabellingQuery>;
export type ZonesForStructureForLabellingLazyQueryHookResult = ReturnType<typeof useZonesForStructureForLabellingLazyQuery>;
export type ZonesForStructureForLabellingSuspenseQueryHookResult = ReturnType<typeof useZonesForStructureForLabellingSuspenseQuery>;
export type ZonesForStructureForLabellingQueryResult = Apollo.QueryResult<ZonesForStructureForLabellingQuery, ZonesForStructureForLabellingQueryVariables>;
export const UpdateSupervoxelsDocument = gql`
    mutation UpdateSupervoxels($input: updateSupervoxel) {
  updateSupervoxels(input: $input) {
    id
    structureId
    supervoxel3DReference
    supervoxelClassId
    zoneId
  }
}
    `;
export type UpdateSupervoxelsMutationFn = Apollo.MutationFunction<UpdateSupervoxelsMutation, UpdateSupervoxelsMutationVariables>;

/**
 * __useUpdateSupervoxelsMutation__
 *
 * To run a mutation, you first call `useUpdateSupervoxelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupervoxelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupervoxelsMutation, { data, loading, error }] = useUpdateSupervoxelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupervoxelsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupervoxelsMutation, UpdateSupervoxelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupervoxelsMutation, UpdateSupervoxelsMutationVariables>(UpdateSupervoxelsDocument, options);
      }
export type UpdateSupervoxelsMutationHookResult = ReturnType<typeof useUpdateSupervoxelsMutation>;
export type UpdateSupervoxelsMutationResult = Apollo.MutationResult<UpdateSupervoxelsMutation>;
export type UpdateSupervoxelsMutationOptions = Apollo.BaseMutationOptions<UpdateSupervoxelsMutation, UpdateSupervoxelsMutationVariables>;
export const GetStructureRelationshipsForTaggingInspectionDataLoaderDocument = gql`
    query getStructureRelationshipsForTaggingInspectionDataLoader($structureId: String!) {
  allAnnotations(structureId: $structureId) {
    id
    annotationId
    locationId
    partId
  }
  allParts(structureId: $structureId) {
    id
    assemblyId
    class
    isReviewed
    isHidden
    splitCuboids {
      id
      assemblyId
      position
      scale
      rotation
      color
    }
  }
  allAssemblies(structureId: $structureId) {
    id
    tagName
    originalTagname
    superCategory
    isNewlyAdded
  }
  structure(structureId: $structureId) {
    octreeResourcesPath
    nodesPerAssemblyPath
  }
}
    `;

/**
 * __useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables> & ({ variables: GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForTaggingInspectionDataLoaderDocument, options);
      }
export function useGetStructureRelationshipsForTaggingInspectionDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForTaggingInspectionDataLoaderDocument, options);
        }
export function useGetStructureRelationshipsForTaggingInspectionDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>(GetStructureRelationshipsForTaggingInspectionDataLoaderDocument, options);
        }
export type GetStructureRelationshipsForTaggingInspectionDataLoaderQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForTaggingInspectionDataLoaderQuery>;
export type GetStructureRelationshipsForTaggingInspectionDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForTaggingInspectionDataLoaderLazyQuery>;
export type GetStructureRelationshipsForTaggingInspectionDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureRelationshipsForTaggingInspectionDataLoaderSuspenseQuery>;
export type GetStructureRelationshipsForTaggingInspectionDataLoaderQueryResult = Apollo.QueryResult<GetStructureRelationshipsForTaggingInspectionDataLoaderQuery, GetStructureRelationshipsForTaggingInspectionDataLoaderQueryVariables>;
export const GetStructureLocationsForTaggingDataLoaderDocument = gql`
    query getStructureLocationsForTaggingDataLoader($structureId: ID!) {
  allLocations(structureId: $structureId) {
    id
    name
    resourcePath
    imageSensor {
      width
      height
      cx
      cy
      focalLength
    }
    paintRegion {
      name
    }
    distance
    videoResourcePath
    videoTimestamp
    pose {
      yaw
      pitch
      roll
      z
      y
      x
      yawOffset
    }
  }
}
    `;

/**
 * __useGetStructureLocationsForTaggingDataLoaderQuery__
 *
 * To run a query within a React component, call `useGetStructureLocationsForTaggingDataLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureLocationsForTaggingDataLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureLocationsForTaggingDataLoaderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureLocationsForTaggingDataLoaderQuery(baseOptions: Apollo.QueryHookOptions<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables> & ({ variables: GetStructureLocationsForTaggingDataLoaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>(GetStructureLocationsForTaggingDataLoaderDocument, options);
      }
export function useGetStructureLocationsForTaggingDataLoaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>(GetStructureLocationsForTaggingDataLoaderDocument, options);
        }
export function useGetStructureLocationsForTaggingDataLoaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>(GetStructureLocationsForTaggingDataLoaderDocument, options);
        }
export type GetStructureLocationsForTaggingDataLoaderQueryHookResult = ReturnType<typeof useGetStructureLocationsForTaggingDataLoaderQuery>;
export type GetStructureLocationsForTaggingDataLoaderLazyQueryHookResult = ReturnType<typeof useGetStructureLocationsForTaggingDataLoaderLazyQuery>;
export type GetStructureLocationsForTaggingDataLoaderSuspenseQueryHookResult = ReturnType<typeof useGetStructureLocationsForTaggingDataLoaderSuspenseQuery>;
export type GetStructureLocationsForTaggingDataLoaderQueryResult = Apollo.QueryResult<GetStructureLocationsForTaggingDataLoaderQuery, GetStructureLocationsForTaggingDataLoaderQueryVariables>;
export const PartsAddedToAssemblyDocument = gql`
    subscription PartsAddedToAssembly($structureId: String!, $userId: String!) {
  partsAddedToAssembly(structureId: $structureId, userId: $userId) {
    partId
    assemblyId
    assemblyName
    isReviewed
    zoneId
    userId
  }
}
    `;

/**
 * __usePartsAddedToAssemblySubscription__
 *
 * To run a query within a React component, call `usePartsAddedToAssemblySubscription` and pass it any options that fit your needs.
 * When your component renders, `usePartsAddedToAssemblySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartsAddedToAssemblySubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePartsAddedToAssemblySubscription(baseOptions: Apollo.SubscriptionHookOptions<PartsAddedToAssemblySubscription, PartsAddedToAssemblySubscriptionVariables> & ({ variables: PartsAddedToAssemblySubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PartsAddedToAssemblySubscription, PartsAddedToAssemblySubscriptionVariables>(PartsAddedToAssemblyDocument, options);
      }
export type PartsAddedToAssemblySubscriptionHookResult = ReturnType<typeof usePartsAddedToAssemblySubscription>;
export type PartsAddedToAssemblySubscriptionResult = Apollo.SubscriptionResult<PartsAddedToAssemblySubscription>;
export const PartsHiddenFlagUpdatedDocument = gql`
    subscription partsHiddenFlagUpdated($structureId: String!, $userId: String!) {
  partsHiddenFlagUpdated(structureId: $structureId, userId: $userId) {
    id
    isHidden
    isReviewed
    zoneId
    userId
  }
}
    `;

/**
 * __usePartsHiddenFlagUpdatedSubscription__
 *
 * To run a query within a React component, call `usePartsHiddenFlagUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePartsHiddenFlagUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartsHiddenFlagUpdatedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePartsHiddenFlagUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PartsHiddenFlagUpdatedSubscription, PartsHiddenFlagUpdatedSubscriptionVariables> & ({ variables: PartsHiddenFlagUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PartsHiddenFlagUpdatedSubscription, PartsHiddenFlagUpdatedSubscriptionVariables>(PartsHiddenFlagUpdatedDocument, options);
      }
export type PartsHiddenFlagUpdatedSubscriptionHookResult = ReturnType<typeof usePartsHiddenFlagUpdatedSubscription>;
export type PartsHiddenFlagUpdatedSubscriptionResult = Apollo.SubscriptionResult<PartsHiddenFlagUpdatedSubscription>;
export const PartsReviewedFlagUpdatedDocument = gql`
    subscription partsReviewedFlagUpdated($structureId: String!, $userId: String!) {
  partsReviewedFlagUpdated(structureId: $structureId, userId: $userId) {
    id
    isReviewed
    assemblyName
    zoneId
    userId
  }
}
    `;

/**
 * __usePartsReviewedFlagUpdatedSubscription__
 *
 * To run a query within a React component, call `usePartsReviewedFlagUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePartsReviewedFlagUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartsReviewedFlagUpdatedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePartsReviewedFlagUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PartsReviewedFlagUpdatedSubscription, PartsReviewedFlagUpdatedSubscriptionVariables> & ({ variables: PartsReviewedFlagUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PartsReviewedFlagUpdatedSubscription, PartsReviewedFlagUpdatedSubscriptionVariables>(PartsReviewedFlagUpdatedDocument, options);
      }
export type PartsReviewedFlagUpdatedSubscriptionHookResult = ReturnType<typeof usePartsReviewedFlagUpdatedSubscription>;
export type PartsReviewedFlagUpdatedSubscriptionResult = Apollo.SubscriptionResult<PartsReviewedFlagUpdatedSubscription>;
export const PartSplitDocument = gql`
    subscription partSplit($structureId: String!, $userId: String!) {
  partSplit(structureId: $structureId, userId: $userId) {
    originalPartId
    newPartId
    updatedAnnotationIds
    zoneId
  }
}
    `;

/**
 * __usePartSplitSubscription__
 *
 * To run a query within a React component, call `usePartSplitSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePartSplitSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartSplitSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePartSplitSubscription(baseOptions: Apollo.SubscriptionHookOptions<PartSplitSubscription, PartSplitSubscriptionVariables> & ({ variables: PartSplitSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PartSplitSubscription, PartSplitSubscriptionVariables>(PartSplitDocument, options);
      }
export type PartSplitSubscriptionHookResult = ReturnType<typeof usePartSplitSubscription>;
export type PartSplitSubscriptionResult = Apollo.SubscriptionResult<PartSplitSubscription>;
export const AssemblyTagNameAddedDocument = gql`
    subscription AssemblyTagNameAdded($structureId: String) {
  assemblyTagNameAdded(structureId: $structureId) {
    id
    structureId
    tagName
    isNewlyAdded
  }
}
    `;

/**
 * __useAssemblyTagNameAddedSubscription__
 *
 * To run a query within a React component, call `useAssemblyTagNameAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAssemblyTagNameAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssemblyTagNameAddedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAssemblyTagNameAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AssemblyTagNameAddedSubscription, AssemblyTagNameAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AssemblyTagNameAddedSubscription, AssemblyTagNameAddedSubscriptionVariables>(AssemblyTagNameAddedDocument, options);
      }
export type AssemblyTagNameAddedSubscriptionHookResult = ReturnType<typeof useAssemblyTagNameAddedSubscription>;
export type AssemblyTagNameAddedSubscriptionResult = Apollo.SubscriptionResult<AssemblyTagNameAddedSubscription>;
export const SplitCuboidOnPartUpdatedDocument = gql`
    subscription SplitCuboidOnPartUpdated($structureId: String, $userId: String!) {
  splitCuboidOnPartUpdated(structureId: $structureId, userId: $userId) {
    partId
    splitCuboid {
      id
      assemblyId
      position
      scale
      rotation
      color
    }
    structureId
    zoneId
  }
}
    `;

/**
 * __useSplitCuboidOnPartUpdatedSubscription__
 *
 * To run a query within a React component, call `useSplitCuboidOnPartUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSplitCuboidOnPartUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSplitCuboidOnPartUpdatedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSplitCuboidOnPartUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SplitCuboidOnPartUpdatedSubscription, SplitCuboidOnPartUpdatedSubscriptionVariables> & ({ variables: SplitCuboidOnPartUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SplitCuboidOnPartUpdatedSubscription, SplitCuboidOnPartUpdatedSubscriptionVariables>(SplitCuboidOnPartUpdatedDocument, options);
      }
export type SplitCuboidOnPartUpdatedSubscriptionHookResult = ReturnType<typeof useSplitCuboidOnPartUpdatedSubscription>;
export type SplitCuboidOnPartUpdatedSubscriptionResult = Apollo.SubscriptionResult<SplitCuboidOnPartUpdatedSubscription>;
export const SplitCuboidOnPartRemovedDocument = gql`
    subscription SplitCuboidOnPartRemoved($structureId: String, $userId: String!) {
  splitCuboidOnPartRemoved(structureId: $structureId, userId: $userId) {
    partId
    splitCuboidId
    structureId
    zoneId
  }
}
    `;

/**
 * __useSplitCuboidOnPartRemovedSubscription__
 *
 * To run a query within a React component, call `useSplitCuboidOnPartRemovedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSplitCuboidOnPartRemovedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSplitCuboidOnPartRemovedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSplitCuboidOnPartRemovedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SplitCuboidOnPartRemovedSubscription, SplitCuboidOnPartRemovedSubscriptionVariables> & ({ variables: SplitCuboidOnPartRemovedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SplitCuboidOnPartRemovedSubscription, SplitCuboidOnPartRemovedSubscriptionVariables>(SplitCuboidOnPartRemovedDocument, options);
      }
export type SplitCuboidOnPartRemovedSubscriptionHookResult = ReturnType<typeof useSplitCuboidOnPartRemovedSubscription>;
export type SplitCuboidOnPartRemovedSubscriptionResult = Apollo.SubscriptionResult<SplitCuboidOnPartRemovedSubscription>;
export const BulkLineFixingDocument = gql`
    mutation BulkLineFixing($input: BulkLineFixingInput!) {
  bulkLineFixing(input: $input) {
    message
    updatedCount
  }
}
    `;
export type BulkLineFixingMutationFn = Apollo.MutationFunction<BulkLineFixingMutation, BulkLineFixingMutationVariables>;

/**
 * __useBulkLineFixingMutation__
 *
 * To run a mutation, you first call `useBulkLineFixingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkLineFixingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkLineFixingMutation, { data, loading, error }] = useBulkLineFixingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkLineFixingMutation(baseOptions?: Apollo.MutationHookOptions<BulkLineFixingMutation, BulkLineFixingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkLineFixingMutation, BulkLineFixingMutationVariables>(BulkLineFixingDocument, options);
      }
export type BulkLineFixingMutationHookResult = ReturnType<typeof useBulkLineFixingMutation>;
export type BulkLineFixingMutationResult = Apollo.MutationResult<BulkLineFixingMutation>;
export type BulkLineFixingMutationOptions = Apollo.BaseMutationOptions<BulkLineFixingMutation, BulkLineFixingMutationVariables>;
export const RevertBulkLineFixingDocument = gql`
    mutation RevertBulkLineFixing($input: RevertBulkLineFixingInput!) {
  revertBulkLineFixing(input: $input) {
    message
    updatedCount
  }
}
    `;
export type RevertBulkLineFixingMutationFn = Apollo.MutationFunction<RevertBulkLineFixingMutation, RevertBulkLineFixingMutationVariables>;

/**
 * __useRevertBulkLineFixingMutation__
 *
 * To run a mutation, you first call `useRevertBulkLineFixingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertBulkLineFixingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertBulkLineFixingMutation, { data, loading, error }] = useRevertBulkLineFixingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertBulkLineFixingMutation(baseOptions?: Apollo.MutationHookOptions<RevertBulkLineFixingMutation, RevertBulkLineFixingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertBulkLineFixingMutation, RevertBulkLineFixingMutationVariables>(RevertBulkLineFixingDocument, options);
      }
export type RevertBulkLineFixingMutationHookResult = ReturnType<typeof useRevertBulkLineFixingMutation>;
export type RevertBulkLineFixingMutationResult = Apollo.MutationResult<RevertBulkLineFixingMutation>;
export type RevertBulkLineFixingMutationOptions = Apollo.BaseMutationOptions<RevertBulkLineFixingMutation, RevertBulkLineFixingMutationVariables>;
export const AllPartsDocument = gql`
    query AllParts($structureId: String!) {
  allParts(structureId: $structureId) {
    id
    assembly {
      id
      tagName
    }
  }
  structure(structureId: $structureId) {
    name
  }
}
    `;

/**
 * __useAllPartsQuery__
 *
 * To run a query within a React component, call `useAllPartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPartsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllPartsQuery(baseOptions: Apollo.QueryHookOptions<AllPartsQuery, AllPartsQueryVariables> & ({ variables: AllPartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPartsQuery, AllPartsQueryVariables>(AllPartsDocument, options);
      }
export function useAllPartsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPartsQuery, AllPartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPartsQuery, AllPartsQueryVariables>(AllPartsDocument, options);
        }
export function useAllPartsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPartsQuery, AllPartsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPartsQuery, AllPartsQueryVariables>(AllPartsDocument, options);
        }
export type AllPartsQueryHookResult = ReturnType<typeof useAllPartsQuery>;
export type AllPartsLazyQueryHookResult = ReturnType<typeof useAllPartsLazyQuery>;
export type AllPartsSuspenseQueryHookResult = ReturnType<typeof useAllPartsSuspenseQuery>;
export type AllPartsQueryResult = Apollo.QueryResult<AllPartsQuery, AllPartsQueryVariables>;
export const GetAbyssViewerColoursForTaggingDocument = gql`
    query getAbyssViewerColoursForTagging {
  setting(type: COLOUR_MAP_FOR_ABYSS_VIEWER_PARTS) {
    id
    name
    type
    revision
    meta {
      __typename
      ... on StringMeta {
        key
        colour: value
      }
      ... on StringArrayMeta {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetAbyssViewerColoursForTaggingQuery__
 *
 * To run a query within a React component, call `useGetAbyssViewerColoursForTaggingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAbyssViewerColoursForTaggingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAbyssViewerColoursForTaggingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAbyssViewerColoursForTaggingQuery(baseOptions?: Apollo.QueryHookOptions<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>(GetAbyssViewerColoursForTaggingDocument, options);
      }
export function useGetAbyssViewerColoursForTaggingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>(GetAbyssViewerColoursForTaggingDocument, options);
        }
export function useGetAbyssViewerColoursForTaggingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>(GetAbyssViewerColoursForTaggingDocument, options);
        }
export type GetAbyssViewerColoursForTaggingQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForTaggingQuery>;
export type GetAbyssViewerColoursForTaggingLazyQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForTaggingLazyQuery>;
export type GetAbyssViewerColoursForTaggingSuspenseQueryHookResult = ReturnType<typeof useGetAbyssViewerColoursForTaggingSuspenseQuery>;
export type GetAbyssViewerColoursForTaggingQueryResult = Apollo.QueryResult<GetAbyssViewerColoursForTaggingQuery, GetAbyssViewerColoursForTaggingQueryVariables>;
export const AddUpdateSplitCuboidOnPartDocument = gql`
    mutation AddUpdateSplitCuboidOnPart($input: AddUpdateSplitCuboidOnPartInput) {
  addUpdateSplitCuboidOnPart(input: $input) {
    partId
    splitCuboid {
      id
      assemblyId
      position
      scale
      rotation
      color
    }
  }
}
    `;
export type AddUpdateSplitCuboidOnPartMutationFn = Apollo.MutationFunction<AddUpdateSplitCuboidOnPartMutation, AddUpdateSplitCuboidOnPartMutationVariables>;

/**
 * __useAddUpdateSplitCuboidOnPartMutation__
 *
 * To run a mutation, you first call `useAddUpdateSplitCuboidOnPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpdateSplitCuboidOnPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpdateSplitCuboidOnPartMutation, { data, loading, error }] = useAddUpdateSplitCuboidOnPartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUpdateSplitCuboidOnPartMutation(baseOptions?: Apollo.MutationHookOptions<AddUpdateSplitCuboidOnPartMutation, AddUpdateSplitCuboidOnPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpdateSplitCuboidOnPartMutation, AddUpdateSplitCuboidOnPartMutationVariables>(AddUpdateSplitCuboidOnPartDocument, options);
      }
export type AddUpdateSplitCuboidOnPartMutationHookResult = ReturnType<typeof useAddUpdateSplitCuboidOnPartMutation>;
export type AddUpdateSplitCuboidOnPartMutationResult = Apollo.MutationResult<AddUpdateSplitCuboidOnPartMutation>;
export type AddUpdateSplitCuboidOnPartMutationOptions = Apollo.BaseMutationOptions<AddUpdateSplitCuboidOnPartMutation, AddUpdateSplitCuboidOnPartMutationVariables>;
export const RemoveSplitCuboidOnPartDocument = gql`
    mutation RemoveSplitCuboidOnPart($input: RemoveSplitCuboidOnPartInput) {
  removeSplitCuboidOnPart(input: $input) {
    partId
    splitCuboidId
  }
}
    `;
export type RemoveSplitCuboidOnPartMutationFn = Apollo.MutationFunction<RemoveSplitCuboidOnPartMutation, RemoveSplitCuboidOnPartMutationVariables>;

/**
 * __useRemoveSplitCuboidOnPartMutation__
 *
 * To run a mutation, you first call `useRemoveSplitCuboidOnPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSplitCuboidOnPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSplitCuboidOnPartMutation, { data, loading, error }] = useRemoveSplitCuboidOnPartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSplitCuboidOnPartMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSplitCuboidOnPartMutation, RemoveSplitCuboidOnPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSplitCuboidOnPartMutation, RemoveSplitCuboidOnPartMutationVariables>(RemoveSplitCuboidOnPartDocument, options);
      }
export type RemoveSplitCuboidOnPartMutationHookResult = ReturnType<typeof useRemoveSplitCuboidOnPartMutation>;
export type RemoveSplitCuboidOnPartMutationResult = Apollo.MutationResult<RemoveSplitCuboidOnPartMutation>;
export type RemoveSplitCuboidOnPartMutationOptions = Apollo.BaseMutationOptions<RemoveSplitCuboidOnPartMutation, RemoveSplitCuboidOnPartMutationVariables>;
export const SplitAnnotationFromPartDocument = gql`
    mutation SplitAnnotationFromPart($input: SplitPartInput) {
  splitPart(input: $input) {
    id
    updatedBy
    assemblyId
  }
}
    `;
export type SplitAnnotationFromPartMutationFn = Apollo.MutationFunction<SplitAnnotationFromPartMutation, SplitAnnotationFromPartMutationVariables>;

/**
 * __useSplitAnnotationFromPartMutation__
 *
 * To run a mutation, you first call `useSplitAnnotationFromPartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitAnnotationFromPartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitAnnotationFromPartMutation, { data, loading, error }] = useSplitAnnotationFromPartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSplitAnnotationFromPartMutation(baseOptions?: Apollo.MutationHookOptions<SplitAnnotationFromPartMutation, SplitAnnotationFromPartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitAnnotationFromPartMutation, SplitAnnotationFromPartMutationVariables>(SplitAnnotationFromPartDocument, options);
      }
export type SplitAnnotationFromPartMutationHookResult = ReturnType<typeof useSplitAnnotationFromPartMutation>;
export type SplitAnnotationFromPartMutationResult = Apollo.MutationResult<SplitAnnotationFromPartMutation>;
export type SplitAnnotationFromPartMutationOptions = Apollo.BaseMutationOptions<SplitAnnotationFromPartMutation, SplitAnnotationFromPartMutationVariables>;
export const GetLocalAnnotationIdDocument = gql`
    query getLocalAnnotationId($annotationId: String!) {
  annotation(annotationId: $annotationId) {
    processingReferences {
      localAnnotationId
    }
  }
}
    `;

/**
 * __useGetLocalAnnotationIdQuery__
 *
 * To run a query within a React component, call `useGetLocalAnnotationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalAnnotationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalAnnotationIdQuery({
 *   variables: {
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useGetLocalAnnotationIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables> & ({ variables: GetLocalAnnotationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>(GetLocalAnnotationIdDocument, options);
      }
export function useGetLocalAnnotationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>(GetLocalAnnotationIdDocument, options);
        }
export function useGetLocalAnnotationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>(GetLocalAnnotationIdDocument, options);
        }
export type GetLocalAnnotationIdQueryHookResult = ReturnType<typeof useGetLocalAnnotationIdQuery>;
export type GetLocalAnnotationIdLazyQueryHookResult = ReturnType<typeof useGetLocalAnnotationIdLazyQuery>;
export type GetLocalAnnotationIdSuspenseQueryHookResult = ReturnType<typeof useGetLocalAnnotationIdSuspenseQuery>;
export type GetLocalAnnotationIdQueryResult = Apollo.QueryResult<GetLocalAnnotationIdQuery, GetLocalAnnotationIdQueryVariables>;
export const ZonesForStructureForTaggingDocument = gql`
    query zonesForStructureForTagging($structureId: String) {
  zonesForStructure(structureId: $structureId) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    status
    structureId
  }
}
    `;

/**
 * __useZonesForStructureForTaggingQuery__
 *
 * To run a query within a React component, call `useZonesForStructureForTaggingQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesForStructureForTaggingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesForStructureForTaggingQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZonesForStructureForTaggingQuery(baseOptions?: Apollo.QueryHookOptions<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>(ZonesForStructureForTaggingDocument, options);
      }
export function useZonesForStructureForTaggingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>(ZonesForStructureForTaggingDocument, options);
        }
export function useZonesForStructureForTaggingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>(ZonesForStructureForTaggingDocument, options);
        }
export type ZonesForStructureForTaggingQueryHookResult = ReturnType<typeof useZonesForStructureForTaggingQuery>;
export type ZonesForStructureForTaggingLazyQueryHookResult = ReturnType<typeof useZonesForStructureForTaggingLazyQuery>;
export type ZonesForStructureForTaggingSuspenseQueryHookResult = ReturnType<typeof useZonesForStructureForTaggingSuspenseQuery>;
export type ZonesForStructureForTaggingQueryResult = Apollo.QueryResult<ZonesForStructureForTaggingQuery, ZonesForStructureForTaggingQueryVariables>;
export const ZoneAndHistoriesForDocument = gql`
    query zoneAndHistoriesFor($structureId: String) {
  zonesAndHistoriesFor(structureId: $structureId) {
    _id
    histories {
      id
      createdBy
      eventName
      document
      createdByDetails {
        name
        profilePicture
      }
    }
  }
}
    `;

/**
 * __useZoneAndHistoriesForQuery__
 *
 * To run a query within a React component, call `useZoneAndHistoriesForQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneAndHistoriesForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneAndHistoriesForQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZoneAndHistoriesForQuery(baseOptions?: Apollo.QueryHookOptions<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>(ZoneAndHistoriesForDocument, options);
      }
export function useZoneAndHistoriesForLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>(ZoneAndHistoriesForDocument, options);
        }
export function useZoneAndHistoriesForSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>(ZoneAndHistoriesForDocument, options);
        }
export type ZoneAndHistoriesForQueryHookResult = ReturnType<typeof useZoneAndHistoriesForQuery>;
export type ZoneAndHistoriesForLazyQueryHookResult = ReturnType<typeof useZoneAndHistoriesForLazyQuery>;
export type ZoneAndHistoriesForSuspenseQueryHookResult = ReturnType<typeof useZoneAndHistoriesForSuspenseQuery>;
export type ZoneAndHistoriesForQueryResult = Apollo.QueryResult<ZoneAndHistoriesForQuery, ZoneAndHistoriesForQueryVariables>;
export const GetGroupsByPartIdsDocument = gql`
    query getGroupsByPartIds($input: GroupsByPartIdsInput) {
  groupsByPartIds(input: $input) {
    groupedParts
  }
}
    `;

/**
 * __useGetGroupsByPartIdsQuery__
 *
 * To run a query within a React component, call `useGetGroupsByPartIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsByPartIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsByPartIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGroupsByPartIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>(GetGroupsByPartIdsDocument, options);
      }
export function useGetGroupsByPartIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>(GetGroupsByPartIdsDocument, options);
        }
export function useGetGroupsByPartIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>(GetGroupsByPartIdsDocument, options);
        }
export type GetGroupsByPartIdsQueryHookResult = ReturnType<typeof useGetGroupsByPartIdsQuery>;
export type GetGroupsByPartIdsLazyQueryHookResult = ReturnType<typeof useGetGroupsByPartIdsLazyQuery>;
export type GetGroupsByPartIdsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsByPartIdsSuspenseQuery>;
export type GetGroupsByPartIdsQueryResult = Apollo.QueryResult<GetGroupsByPartIdsQuery, GetGroupsByPartIdsQueryVariables>;
export const SetHiddenFlagForPartsDocument = gql`
    mutation SetHiddenFlagForParts($parts: UpdatePartsHiddenFlagInput) {
  setHiddenForParts(input: $parts)
}
    `;
export type SetHiddenFlagForPartsMutationFn = Apollo.MutationFunction<SetHiddenFlagForPartsMutation, SetHiddenFlagForPartsMutationVariables>;

/**
 * __useSetHiddenFlagForPartsMutation__
 *
 * To run a mutation, you first call `useSetHiddenFlagForPartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHiddenFlagForPartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHiddenFlagForPartsMutation, { data, loading, error }] = useSetHiddenFlagForPartsMutation({
 *   variables: {
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useSetHiddenFlagForPartsMutation(baseOptions?: Apollo.MutationHookOptions<SetHiddenFlagForPartsMutation, SetHiddenFlagForPartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHiddenFlagForPartsMutation, SetHiddenFlagForPartsMutationVariables>(SetHiddenFlagForPartsDocument, options);
      }
export type SetHiddenFlagForPartsMutationHookResult = ReturnType<typeof useSetHiddenFlagForPartsMutation>;
export type SetHiddenFlagForPartsMutationResult = Apollo.MutationResult<SetHiddenFlagForPartsMutation>;
export type SetHiddenFlagForPartsMutationOptions = Apollo.BaseMutationOptions<SetHiddenFlagForPartsMutation, SetHiddenFlagForPartsMutationVariables>;
export const SetReviewedFlagForPartsDocument = gql`
    mutation SetReviewedFlagForParts($parts: UpdatePartsReviewedFlagInput) {
  setReviewedForParts(input: $parts)
}
    `;
export type SetReviewedFlagForPartsMutationFn = Apollo.MutationFunction<SetReviewedFlagForPartsMutation, SetReviewedFlagForPartsMutationVariables>;

/**
 * __useSetReviewedFlagForPartsMutation__
 *
 * To run a mutation, you first call `useSetReviewedFlagForPartsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReviewedFlagForPartsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReviewedFlagForPartsMutation, { data, loading, error }] = useSetReviewedFlagForPartsMutation({
 *   variables: {
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useSetReviewedFlagForPartsMutation(baseOptions?: Apollo.MutationHookOptions<SetReviewedFlagForPartsMutation, SetReviewedFlagForPartsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReviewedFlagForPartsMutation, SetReviewedFlagForPartsMutationVariables>(SetReviewedFlagForPartsDocument, options);
      }
export type SetReviewedFlagForPartsMutationHookResult = ReturnType<typeof useSetReviewedFlagForPartsMutation>;
export type SetReviewedFlagForPartsMutationResult = Apollo.MutationResult<SetReviewedFlagForPartsMutation>;
export type SetReviewedFlagForPartsMutationOptions = Apollo.BaseMutationOptions<SetReviewedFlagForPartsMutation, SetReviewedFlagForPartsMutationVariables>;
export const AddPartsToAssemblyInputForDeletePartDocument = gql`
    mutation AddPartsToAssemblyInputForDeletePart($input: AddPartsToAssemblyInput) {
  addPartsToAssembly(input: $input) {
    id
    class
    updatedBy
    updatedAt
    createdAt
    assembly {
      id
      tagName
    }
  }
}
    `;
export type AddPartsToAssemblyInputForDeletePartMutationFn = Apollo.MutationFunction<AddPartsToAssemblyInputForDeletePartMutation, AddPartsToAssemblyInputForDeletePartMutationVariables>;

/**
 * __useAddPartsToAssemblyInputForDeletePartMutation__
 *
 * To run a mutation, you first call `useAddPartsToAssemblyInputForDeletePartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPartsToAssemblyInputForDeletePartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPartsToAssemblyInputForDeletePartMutation, { data, loading, error }] = useAddPartsToAssemblyInputForDeletePartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPartsToAssemblyInputForDeletePartMutation(baseOptions?: Apollo.MutationHookOptions<AddPartsToAssemblyInputForDeletePartMutation, AddPartsToAssemblyInputForDeletePartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPartsToAssemblyInputForDeletePartMutation, AddPartsToAssemblyInputForDeletePartMutationVariables>(AddPartsToAssemblyInputForDeletePartDocument, options);
      }
export type AddPartsToAssemblyInputForDeletePartMutationHookResult = ReturnType<typeof useAddPartsToAssemblyInputForDeletePartMutation>;
export type AddPartsToAssemblyInputForDeletePartMutationResult = Apollo.MutationResult<AddPartsToAssemblyInputForDeletePartMutation>;
export type AddPartsToAssemblyInputForDeletePartMutationOptions = Apollo.BaseMutationOptions<AddPartsToAssemblyInputForDeletePartMutation, AddPartsToAssemblyInputForDeletePartMutationVariables>;
export const AllHistoriesDocument = gql`
    query AllHistories($referenceId: String, $eventNames: [String]) {
  allHistories(referenceId: $referenceId, eventNames: $eventNames) {
    id
    collectionName
    eventName
    document
    createdAt
    createdBy
    createdByName
  }
}
    `;

/**
 * __useAllHistoriesQuery__
 *
 * To run a query within a React component, call `useAllHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHistoriesQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      eventNames: // value for 'eventNames'
 *   },
 * });
 */
export function useAllHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<AllHistoriesQuery, AllHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllHistoriesQuery, AllHistoriesQueryVariables>(AllHistoriesDocument, options);
      }
export function useAllHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllHistoriesQuery, AllHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllHistoriesQuery, AllHistoriesQueryVariables>(AllHistoriesDocument, options);
        }
export function useAllHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllHistoriesQuery, AllHistoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllHistoriesQuery, AllHistoriesQueryVariables>(AllHistoriesDocument, options);
        }
export type AllHistoriesQueryHookResult = ReturnType<typeof useAllHistoriesQuery>;
export type AllHistoriesLazyQueryHookResult = ReturnType<typeof useAllHistoriesLazyQuery>;
export type AllHistoriesSuspenseQueryHookResult = ReturnType<typeof useAllHistoriesSuspenseQuery>;
export type AllHistoriesQueryResult = Apollo.QueryResult<AllHistoriesQuery, AllHistoriesQueryVariables>;
export const PartDocument = gql`
    query Part($partId: String) {
  part(partId: $partId) {
    id
    class
    assembly {
      id
      tagName
    }
  }
}
    `;

/**
 * __usePartQuery__
 *
 * To run a query within a React component, call `usePartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartQuery({
 *   variables: {
 *      partId: // value for 'partId'
 *   },
 * });
 */
export function usePartQuery(baseOptions?: Apollo.QueryHookOptions<PartQuery, PartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartQuery, PartQueryVariables>(PartDocument, options);
      }
export function usePartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartQuery, PartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartQuery, PartQueryVariables>(PartDocument, options);
        }
export function usePartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartQuery, PartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartQuery, PartQueryVariables>(PartDocument, options);
        }
export type PartQueryHookResult = ReturnType<typeof usePartQuery>;
export type PartLazyQueryHookResult = ReturnType<typeof usePartLazyQuery>;
export type PartSuspenseQueryHookResult = ReturnType<typeof usePartSuspenseQuery>;
export type PartQueryResult = Apollo.QueryResult<PartQuery, PartQueryVariables>;
export const AddNewAssemblyTagNameDocument = gql`
    mutation AddNewAssemblyTagName($input: AddNewAssemblyTagNameInput) {
  addNewAssemblyTagName(input: $input) {
    id
    tagName
  }
}
    `;
export type AddNewAssemblyTagNameMutationFn = Apollo.MutationFunction<AddNewAssemblyTagNameMutation, AddNewAssemblyTagNameMutationVariables>;

/**
 * __useAddNewAssemblyTagNameMutation__
 *
 * To run a mutation, you first call `useAddNewAssemblyTagNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewAssemblyTagNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewAssemblyTagNameMutation, { data, loading, error }] = useAddNewAssemblyTagNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddNewAssemblyTagNameMutation(baseOptions?: Apollo.MutationHookOptions<AddNewAssemblyTagNameMutation, AddNewAssemblyTagNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewAssemblyTagNameMutation, AddNewAssemblyTagNameMutationVariables>(AddNewAssemblyTagNameDocument, options);
      }
export type AddNewAssemblyTagNameMutationHookResult = ReturnType<typeof useAddNewAssemblyTagNameMutation>;
export type AddNewAssemblyTagNameMutationResult = Apollo.MutationResult<AddNewAssemblyTagNameMutation>;
export type AddNewAssemblyTagNameMutationOptions = Apollo.BaseMutationOptions<AddNewAssemblyTagNameMutation, AddNewAssemblyTagNameMutationVariables>;
export const EquipmentClassesForStrunctureDocument = gql`
    query equipmentClassesForStruncture($structureId: String) {
  structure(structureId: $structureId) {
    equipmentClasses {
      classes {
        name
        code
      }
      name
    }
  }
}
    `;

/**
 * __useEquipmentClassesForStrunctureQuery__
 *
 * To run a query within a React component, call `useEquipmentClassesForStrunctureQuery` and pass it any options that fit your needs.
 * When your component renders, `useEquipmentClassesForStrunctureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEquipmentClassesForStrunctureQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useEquipmentClassesForStrunctureQuery(baseOptions?: Apollo.QueryHookOptions<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>(EquipmentClassesForStrunctureDocument, options);
      }
export function useEquipmentClassesForStrunctureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>(EquipmentClassesForStrunctureDocument, options);
        }
export function useEquipmentClassesForStrunctureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>(EquipmentClassesForStrunctureDocument, options);
        }
export type EquipmentClassesForStrunctureQueryHookResult = ReturnType<typeof useEquipmentClassesForStrunctureQuery>;
export type EquipmentClassesForStrunctureLazyQueryHookResult = ReturnType<typeof useEquipmentClassesForStrunctureLazyQuery>;
export type EquipmentClassesForStrunctureSuspenseQueryHookResult = ReturnType<typeof useEquipmentClassesForStrunctureSuspenseQuery>;
export type EquipmentClassesForStrunctureQueryResult = Apollo.QueryResult<EquipmentClassesForStrunctureQuery, EquipmentClassesForStrunctureQueryVariables>;
export const GetStructureStatusDocument = gql`
    query GetStructureStatus($structureId: String) {
  structure(structureId: $structureId) {
    status
  }
}
    `;

/**
 * __useGetStructureStatusQuery__
 *
 * To run a query within a React component, call `useGetStructureStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureStatusQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetStructureStatusQuery, GetStructureStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureStatusQuery, GetStructureStatusQueryVariables>(GetStructureStatusDocument, options);
      }
export function useGetStructureStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureStatusQuery, GetStructureStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureStatusQuery, GetStructureStatusQueryVariables>(GetStructureStatusDocument, options);
        }
export function useGetStructureStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureStatusQuery, GetStructureStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureStatusQuery, GetStructureStatusQueryVariables>(GetStructureStatusDocument, options);
        }
export type GetStructureStatusQueryHookResult = ReturnType<typeof useGetStructureStatusQuery>;
export type GetStructureStatusLazyQueryHookResult = ReturnType<typeof useGetStructureStatusLazyQuery>;
export type GetStructureStatusSuspenseQueryHookResult = ReturnType<typeof useGetStructureStatusSuspenseQuery>;
export type GetStructureStatusQueryResult = Apollo.QueryResult<GetStructureStatusQuery, GetStructureStatusQueryVariables>;
export const AllStructuresForPlatformsDocument = gql`
    query AllStructuresForPlatforms($input: StructureFilters) {
  allStructures(input: $input) {
    id
    name
    status
    coverImagePath
    deploymentLevel
    description
    octreeResourcesPath
    cardInsights {
      color
      name
      value
      type
      visible
    }
  }
}
    `;

/**
 * __useAllStructuresForPlatformsQuery__
 *
 * To run a query within a React component, call `useAllStructuresForPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresForPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresForPlatformsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllStructuresForPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>(AllStructuresForPlatformsDocument, options);
      }
export function useAllStructuresForPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>(AllStructuresForPlatformsDocument, options);
        }
export function useAllStructuresForPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>(AllStructuresForPlatformsDocument, options);
        }
export type AllStructuresForPlatformsQueryHookResult = ReturnType<typeof useAllStructuresForPlatformsQuery>;
export type AllStructuresForPlatformsLazyQueryHookResult = ReturnType<typeof useAllStructuresForPlatformsLazyQuery>;
export type AllStructuresForPlatformsSuspenseQueryHookResult = ReturnType<typeof useAllStructuresForPlatformsSuspenseQuery>;
export type AllStructuresForPlatformsQueryResult = Apollo.QueryResult<AllStructuresForPlatformsQuery, AllStructuresForPlatformsQueryVariables>;
export const AllRegionsDocument = gql`
    query AllRegions {
  allRegions {
    id
    name
  }
}
    `;

/**
 * __useAllRegionsQuery__
 *
 * To run a query within a React component, call `useAllRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRegionsQuery(baseOptions?: Apollo.QueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRegionsQuery, AllRegionsQueryVariables>(AllRegionsDocument, options);
      }
export function useAllRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRegionsQuery, AllRegionsQueryVariables>(AllRegionsDocument, options);
        }
export function useAllRegionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllRegionsQuery, AllRegionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllRegionsQuery, AllRegionsQueryVariables>(AllRegionsDocument, options);
        }
export type AllRegionsQueryHookResult = ReturnType<typeof useAllRegionsQuery>;
export type AllRegionsLazyQueryHookResult = ReturnType<typeof useAllRegionsLazyQuery>;
export type AllRegionsSuspenseQueryHookResult = ReturnType<typeof useAllRegionsSuspenseQuery>;
export type AllRegionsQueryResult = Apollo.QueryResult<AllRegionsQuery, AllRegionsQueryVariables>;
export const AllStructuresByRegionDocument = gql`
    query AllStructuresByRegion {
  allStructuresByRegion {
    id
    name
    structures {
      id
      name
      status
      defectArea {
        key
        area
      }
    }
    defectArea {
      key
      area
    }
  }
  allDefects {
    key
    name
  }
}
    `;

/**
 * __useAllStructuresByRegionQuery__
 *
 * To run a query within a React component, call `useAllStructuresByRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresByRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresByRegionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllStructuresByRegionQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>(AllStructuresByRegionDocument, options);
      }
export function useAllStructuresByRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>(AllStructuresByRegionDocument, options);
        }
export function useAllStructuresByRegionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>(AllStructuresByRegionDocument, options);
        }
export type AllStructuresByRegionQueryHookResult = ReturnType<typeof useAllStructuresByRegionQuery>;
export type AllStructuresByRegionLazyQueryHookResult = ReturnType<typeof useAllStructuresByRegionLazyQuery>;
export type AllStructuresByRegionSuspenseQueryHookResult = ReturnType<typeof useAllStructuresByRegionSuspenseQuery>;
export type AllStructuresByRegionQueryResult = Apollo.QueryResult<AllStructuresByRegionQuery, AllStructuresByRegionQueryVariables>;
export const StructureDecksWithDefectsDocument = gql`
    query StructureDecksWithDefects($structureId: ID) {
  decksWithDefects(structureId: $structureId) {
    id
    name
    defectArea {
      key
      area
    }
  }
}
    `;

/**
 * __useStructureDecksWithDefectsQuery__
 *
 * To run a query within a React component, call `useStructureDecksWithDefectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureDecksWithDefectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureDecksWithDefectsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureDecksWithDefectsQuery(baseOptions?: Apollo.QueryHookOptions<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>(StructureDecksWithDefectsDocument, options);
      }
export function useStructureDecksWithDefectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>(StructureDecksWithDefectsDocument, options);
        }
export function useStructureDecksWithDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>(StructureDecksWithDefectsDocument, options);
        }
export type StructureDecksWithDefectsQueryHookResult = ReturnType<typeof useStructureDecksWithDefectsQuery>;
export type StructureDecksWithDefectsLazyQueryHookResult = ReturnType<typeof useStructureDecksWithDefectsLazyQuery>;
export type StructureDecksWithDefectsSuspenseQueryHookResult = ReturnType<typeof useStructureDecksWithDefectsSuspenseQuery>;
export type StructureDecksWithDefectsQueryResult = Apollo.QueryResult<StructureDecksWithDefectsQuery, StructureDecksWithDefectsQueryVariables>;
export const AllUserGroupsForPlatformsDocument = gql`
    query AllUserGroupsForPlatforms {
  allUserGroups {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAllUserGroupsForPlatformsQuery__
 *
 * To run a query within a React component, call `useAllUserGroupsForPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserGroupsForPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserGroupsForPlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserGroupsForPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>(AllUserGroupsForPlatformsDocument, options);
      }
export function useAllUserGroupsForPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>(AllUserGroupsForPlatformsDocument, options);
        }
export function useAllUserGroupsForPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>(AllUserGroupsForPlatformsDocument, options);
        }
export type AllUserGroupsForPlatformsQueryHookResult = ReturnType<typeof useAllUserGroupsForPlatformsQuery>;
export type AllUserGroupsForPlatformsLazyQueryHookResult = ReturnType<typeof useAllUserGroupsForPlatformsLazyQuery>;
export type AllUserGroupsForPlatformsSuspenseQueryHookResult = ReturnType<typeof useAllUserGroupsForPlatformsSuspenseQuery>;
export type AllUserGroupsForPlatformsQueryResult = Apollo.QueryResult<AllUserGroupsForPlatformsQuery, AllUserGroupsForPlatformsQueryVariables>;
export const CreateStructureDocument = gql`
    mutation CreateStructure($input: CreateStructureInput!) {
  createStructure(input: $input) {
    id
  }
}
    `;
export type CreateStructureMutationFn = Apollo.MutationFunction<CreateStructureMutation, CreateStructureMutationVariables>;

/**
 * __useCreateStructureMutation__
 *
 * To run a mutation, you first call `useCreateStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStructureMutation, { data, loading, error }] = useCreateStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStructureMutation(baseOptions?: Apollo.MutationHookOptions<CreateStructureMutation, CreateStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStructureMutation, CreateStructureMutationVariables>(CreateStructureDocument, options);
      }
export type CreateStructureMutationHookResult = ReturnType<typeof useCreateStructureMutation>;
export type CreateStructureMutationResult = Apollo.MutationResult<CreateStructureMutation>;
export type CreateStructureMutationOptions = Apollo.BaseMutationOptions<CreateStructureMutation, CreateStructureMutationVariables>;
export const AnalyticsDocument = gql`
    query Analytics($input: AnalyticsFiltersInput) {
  analytics(input: $input) {
    data
    id
    structureIds
    type
    displayConfig
  }
}
    `;

/**
 * __useAnalyticsQuery__
 *
 * To run a query within a React component, call `useAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
      }
export function useAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
export function useAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyticsQuery, AnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyticsQuery, AnalyticsQueryVariables>(AnalyticsDocument, options);
        }
export type AnalyticsQueryHookResult = ReturnType<typeof useAnalyticsQuery>;
export type AnalyticsLazyQueryHookResult = ReturnType<typeof useAnalyticsLazyQuery>;
export type AnalyticsSuspenseQueryHookResult = ReturnType<typeof useAnalyticsSuspenseQuery>;
export type AnalyticsQueryResult = Apollo.QueryResult<AnalyticsQuery, AnalyticsQueryVariables>;
export const AllPlatformsDocument = gql`
    query AllPlatforms($regionId: ID) {
  allPlatforms(regionId: $regionId) {
    id
    name
    platformCardInsights {
      name
      value
      group
      displayConfig {
        color
        divider
        listIndex
        barIndex
      }
    }
    platformSummary {
      name
      value
      group
      displayConfig {
        color
        divider
        listIndex
        barIndex
      }
    }
    region {
      id
      name
    }
    coverImagePath
  }
}
    `;

/**
 * __useAllPlatformsQuery__
 *
 * To run a query within a React component, call `useAllPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlatformsQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useAllPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<AllPlatformsQuery, AllPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlatformsQuery, AllPlatformsQueryVariables>(AllPlatformsDocument, options);
      }
export function useAllPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlatformsQuery, AllPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlatformsQuery, AllPlatformsQueryVariables>(AllPlatformsDocument, options);
        }
export function useAllPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPlatformsQuery, AllPlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPlatformsQuery, AllPlatformsQueryVariables>(AllPlatformsDocument, options);
        }
export type AllPlatformsQueryHookResult = ReturnType<typeof useAllPlatformsQuery>;
export type AllPlatformsLazyQueryHookResult = ReturnType<typeof useAllPlatformsLazyQuery>;
export type AllPlatformsSuspenseQueryHookResult = ReturnType<typeof useAllPlatformsSuspenseQuery>;
export type AllPlatformsQueryResult = Apollo.QueryResult<AllPlatformsQuery, AllPlatformsQueryVariables>;
export const PlatformDocument = gql`
    query Platform($platformId: ID!) {
  platform(platformId: $platformId) {
    id
    name
    platformCardInsights {
      name
      value
      group
      displayConfig {
        color
      }
    }
    region {
      id
      name
    }
  }
}
    `;

/**
 * __usePlatformQuery__
 *
 * To run a query within a React component, call `usePlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformQuery({
 *   variables: {
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function usePlatformQuery(baseOptions: Apollo.QueryHookOptions<PlatformQuery, PlatformQueryVariables> & ({ variables: PlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
      }
export function usePlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformQuery, PlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
        }
export function usePlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformQuery, PlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformQuery, PlatformQueryVariables>(PlatformDocument, options);
        }
export type PlatformQueryHookResult = ReturnType<typeof usePlatformQuery>;
export type PlatformLazyQueryHookResult = ReturnType<typeof usePlatformLazyQuery>;
export type PlatformSuspenseQueryHookResult = ReturnType<typeof usePlatformSuspenseQuery>;
export type PlatformQueryResult = Apollo.QueryResult<PlatformQuery, PlatformQueryVariables>;
export const AllStructuresForHomePageDocument = gql`
    query AllStructuresForHomePage($input: StructureFilters) {
  allStructures(input: $input) {
    id
    name
    isActive
    deploymentLevel
    octreeResourcesPath
    coverImagePath
    updatedAt
    status
    scanDate
    defectLegends {
      id
      name
      groupKey
      groupName
      color
      octreeKey
      octreeValue
    }
  }
}
    `;

/**
 * __useAllStructuresForHomePageQuery__
 *
 * To run a query within a React component, call `useAllStructuresForHomePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresForHomePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresForHomePageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllStructuresForHomePageQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>(AllStructuresForHomePageDocument, options);
      }
export function useAllStructuresForHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>(AllStructuresForHomePageDocument, options);
        }
export function useAllStructuresForHomePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>(AllStructuresForHomePageDocument, options);
        }
export type AllStructuresForHomePageQueryHookResult = ReturnType<typeof useAllStructuresForHomePageQuery>;
export type AllStructuresForHomePageLazyQueryHookResult = ReturnType<typeof useAllStructuresForHomePageLazyQuery>;
export type AllStructuresForHomePageSuspenseQueryHookResult = ReturnType<typeof useAllStructuresForHomePageSuspenseQuery>;
export type AllStructuresForHomePageQueryResult = Apollo.QueryResult<AllStructuresForHomePageQuery, AllStructuresForHomePageQueryVariables>;
export const DefectsAreaByPlatformDocument = gql`
    query defectsAreaByPlatform($platformId: ID!) {
  defectsAreaByStructures(platformId: $platformId) {
    structureId
    structureName
    totalArea {
      type
      value
    }
  }
}
    `;

/**
 * __useDefectsAreaByPlatformQuery__
 *
 * To run a query within a React component, call `useDefectsAreaByPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefectsAreaByPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefectsAreaByPlatformQuery({
 *   variables: {
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function useDefectsAreaByPlatformQuery(baseOptions: Apollo.QueryHookOptions<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables> & ({ variables: DefectsAreaByPlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>(DefectsAreaByPlatformDocument, options);
      }
export function useDefectsAreaByPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>(DefectsAreaByPlatformDocument, options);
        }
export function useDefectsAreaByPlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>(DefectsAreaByPlatformDocument, options);
        }
export type DefectsAreaByPlatformQueryHookResult = ReturnType<typeof useDefectsAreaByPlatformQuery>;
export type DefectsAreaByPlatformLazyQueryHookResult = ReturnType<typeof useDefectsAreaByPlatformLazyQuery>;
export type DefectsAreaByPlatformSuspenseQueryHookResult = ReturnType<typeof useDefectsAreaByPlatformSuspenseQuery>;
export type DefectsAreaByPlatformQueryResult = Apollo.QueryResult<DefectsAreaByPlatformQuery, DefectsAreaByPlatformQueryVariables>;
export const GetAlarmLevelSummaryDocument = gql`
    query GetAlarmLevelSummary($input: AlarmLevelSummaryInput) {
  getAlarmLevelSummary(input: $input) {
    total {
      type
      count
    }
    structureId
    structureName
  }
}
    `;

/**
 * __useGetAlarmLevelSummaryQuery__
 *
 * To run a query within a React component, call `useGetAlarmLevelSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmLevelSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmLevelSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAlarmLevelSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>(GetAlarmLevelSummaryDocument, options);
      }
export function useGetAlarmLevelSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>(GetAlarmLevelSummaryDocument, options);
        }
export function useGetAlarmLevelSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>(GetAlarmLevelSummaryDocument, options);
        }
export type GetAlarmLevelSummaryQueryHookResult = ReturnType<typeof useGetAlarmLevelSummaryQuery>;
export type GetAlarmLevelSummaryLazyQueryHookResult = ReturnType<typeof useGetAlarmLevelSummaryLazyQuery>;
export type GetAlarmLevelSummarySuspenseQueryHookResult = ReturnType<typeof useGetAlarmLevelSummarySuspenseQuery>;
export type GetAlarmLevelSummaryQueryResult = Apollo.QueryResult<GetAlarmLevelSummaryQuery, GetAlarmLevelSummaryQueryVariables>;
export const GetAllStructuresForSystemRequirementDocument = gql`
    query GetAllStructuresForSystemRequirement {
  allStructures {
    id
    name
    octreeResourcesPath
  }
}
    `;

/**
 * __useGetAllStructuresForSystemRequirementQuery__
 *
 * To run a query within a React component, call `useGetAllStructuresForSystemRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStructuresForSystemRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStructuresForSystemRequirementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStructuresForSystemRequirementQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>(GetAllStructuresForSystemRequirementDocument, options);
      }
export function useGetAllStructuresForSystemRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>(GetAllStructuresForSystemRequirementDocument, options);
        }
export function useGetAllStructuresForSystemRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>(GetAllStructuresForSystemRequirementDocument, options);
        }
export type GetAllStructuresForSystemRequirementQueryHookResult = ReturnType<typeof useGetAllStructuresForSystemRequirementQuery>;
export type GetAllStructuresForSystemRequirementLazyQueryHookResult = ReturnType<typeof useGetAllStructuresForSystemRequirementLazyQuery>;
export type GetAllStructuresForSystemRequirementSuspenseQueryHookResult = ReturnType<typeof useGetAllStructuresForSystemRequirementSuspenseQuery>;
export type GetAllStructuresForSystemRequirementQueryResult = Apollo.QueryResult<GetAllStructuresForSystemRequirementQuery, GetAllStructuresForSystemRequirementQueryVariables>;
export const AllPointOfInterestTemplateDocument = gql`
    query AllPointOfInterestTemplate($structureId: ID) {
  allPointOfInterestTemplate(structureId: $structureId) {
    id
    name
    type
    key
    icon {
      name
      color
    }
    accentColor
    fields {
      options
      optionsData {
        value
        weight
        min
        max
        minIncluded
        maxIncluded
      }
      name
      type
      id
      key
      detailFieldKey
      isReadOnly
      isHidden
      defaultVisible
      serverSide
      isRequired
      isMeasurementToolEnabled
      displayInReview
      displayInReports
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
      }
      unit
    }
    permissions
    markerLabelConfig {
      type
      hideName
      fields {
        key
        type
      }
      headerField {
        key
        type
      }
    }
  }
}
    `;

/**
 * __useAllPointOfInterestTemplateQuery__
 *
 * To run a query within a React component, call `useAllPointOfInterestTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPointOfInterestTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPointOfInterestTemplateQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllPointOfInterestTemplateQuery(baseOptions?: Apollo.QueryHookOptions<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>(AllPointOfInterestTemplateDocument, options);
      }
export function useAllPointOfInterestTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>(AllPointOfInterestTemplateDocument, options);
        }
export function useAllPointOfInterestTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>(AllPointOfInterestTemplateDocument, options);
        }
export type AllPointOfInterestTemplateQueryHookResult = ReturnType<typeof useAllPointOfInterestTemplateQuery>;
export type AllPointOfInterestTemplateLazyQueryHookResult = ReturnType<typeof useAllPointOfInterestTemplateLazyQuery>;
export type AllPointOfInterestTemplateSuspenseQueryHookResult = ReturnType<typeof useAllPointOfInterestTemplateSuspenseQuery>;
export type AllPointOfInterestTemplateQueryResult = Apollo.QueryResult<AllPointOfInterestTemplateQuery, AllPointOfInterestTemplateQueryVariables>;
export const GetPaintBlockRemediationScoreDocument = gql`
    query getPaintBlockRemediationScore($structureId: ID!, $type: TemplateTypeEnum!) {
  allTemplates(structureId: $structureId, type: $type) {
    id
    remediationScoreConfig {
      area {
        fields {
          fieldKey
          score
          threshold
        }
      }
      cof {
        fields {
          fieldKey
          optionScores
        }
      }
      poi {
        fields {
          poiScore
          poiTemplateKey
          subcategory {
            fieldKey
            optionScores
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaintBlockRemediationScoreQuery__
 *
 * To run a query within a React component, call `useGetPaintBlockRemediationScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaintBlockRemediationScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaintBlockRemediationScoreQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPaintBlockRemediationScoreQuery(baseOptions: Apollo.QueryHookOptions<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables> & ({ variables: GetPaintBlockRemediationScoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>(GetPaintBlockRemediationScoreDocument, options);
      }
export function useGetPaintBlockRemediationScoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>(GetPaintBlockRemediationScoreDocument, options);
        }
export function useGetPaintBlockRemediationScoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>(GetPaintBlockRemediationScoreDocument, options);
        }
export type GetPaintBlockRemediationScoreQueryHookResult = ReturnType<typeof useGetPaintBlockRemediationScoreQuery>;
export type GetPaintBlockRemediationScoreLazyQueryHookResult = ReturnType<typeof useGetPaintBlockRemediationScoreLazyQuery>;
export type GetPaintBlockRemediationScoreSuspenseQueryHookResult = ReturnType<typeof useGetPaintBlockRemediationScoreSuspenseQuery>;
export type GetPaintBlockRemediationScoreQueryResult = Apollo.QueryResult<GetPaintBlockRemediationScoreQuery, GetPaintBlockRemediationScoreQueryVariables>;
export const GetAllStructuresListForTemplateBuilderDocument = gql`
    query getAllStructuresListForTemplateBuilder {
  allStructures {
    id
    name
    coverImagePath
  }
}
    `;

/**
 * __useGetAllStructuresListForTemplateBuilderQuery__
 *
 * To run a query within a React component, call `useGetAllStructuresListForTemplateBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStructuresListForTemplateBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStructuresListForTemplateBuilderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStructuresListForTemplateBuilderQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>(GetAllStructuresListForTemplateBuilderDocument, options);
      }
export function useGetAllStructuresListForTemplateBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>(GetAllStructuresListForTemplateBuilderDocument, options);
        }
export function useGetAllStructuresListForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>(GetAllStructuresListForTemplateBuilderDocument, options);
        }
export type GetAllStructuresListForTemplateBuilderQueryHookResult = ReturnType<typeof useGetAllStructuresListForTemplateBuilderQuery>;
export type GetAllStructuresListForTemplateBuilderLazyQueryHookResult = ReturnType<typeof useGetAllStructuresListForTemplateBuilderLazyQuery>;
export type GetAllStructuresListForTemplateBuilderSuspenseQueryHookResult = ReturnType<typeof useGetAllStructuresListForTemplateBuilderSuspenseQuery>;
export type GetAllStructuresListForTemplateBuilderQueryResult = Apollo.QueryResult<GetAllStructuresListForTemplateBuilderQuery, GetAllStructuresListForTemplateBuilderQueryVariables>;
export const StructureForTemplateBuilderDocument = gql`
    query StructureForTemplateBuilder($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
    status
  }
}
    `;

/**
 * __useStructureForTemplateBuilderQuery__
 *
 * To run a query within a React component, call `useStructureForTemplateBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureForTemplateBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureForTemplateBuilderQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useStructureForTemplateBuilderQuery(baseOptions: Apollo.QueryHookOptions<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables> & ({ variables: StructureForTemplateBuilderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>(StructureForTemplateBuilderDocument, options);
      }
export function useStructureForTemplateBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>(StructureForTemplateBuilderDocument, options);
        }
export function useStructureForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>(StructureForTemplateBuilderDocument, options);
        }
export type StructureForTemplateBuilderQueryHookResult = ReturnType<typeof useStructureForTemplateBuilderQuery>;
export type StructureForTemplateBuilderLazyQueryHookResult = ReturnType<typeof useStructureForTemplateBuilderLazyQuery>;
export type StructureForTemplateBuilderSuspenseQueryHookResult = ReturnType<typeof useStructureForTemplateBuilderSuspenseQuery>;
export type StructureForTemplateBuilderQueryResult = Apollo.QueryResult<StructureForTemplateBuilderQuery, StructureForTemplateBuilderQueryVariables>;
export const GetStructureDefectsDocument = gql`
    query getStructureDefects($structureId: String!) {
  structure(structureId: $structureId) {
    id
    defectLegends {
      id
      groupName
      groupKey
      name
      color
      octreeKey
      octreeValue
      legendText
    }
  }
}
    `;

/**
 * __useGetStructureDefectsQuery__
 *
 * To run a query within a React component, call `useGetStructureDefectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDefectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDefectsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDefectsQuery(baseOptions: Apollo.QueryHookOptions<GetStructureDefectsQuery, GetStructureDefectsQueryVariables> & ({ variables: GetStructureDefectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>(GetStructureDefectsDocument, options);
      }
export function useGetStructureDefectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>(GetStructureDefectsDocument, options);
        }
export function useGetStructureDefectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>(GetStructureDefectsDocument, options);
        }
export type GetStructureDefectsQueryHookResult = ReturnType<typeof useGetStructureDefectsQuery>;
export type GetStructureDefectsLazyQueryHookResult = ReturnType<typeof useGetStructureDefectsLazyQuery>;
export type GetStructureDefectsSuspenseQueryHookResult = ReturnType<typeof useGetStructureDefectsSuspenseQuery>;
export type GetStructureDefectsQueryResult = Apollo.QueryResult<GetStructureDefectsQuery, GetStructureDefectsQueryVariables>;
export const GetStructureDetailsDocument = gql`
    query getStructureDetails($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
    scanDate
    coverImagePath
    isActive
    isWallLossEnabled
    platform {
      id
      name
    }
    features
    hasRiskAssessment
    reportConfig {
      title
      id
      configurations {
        id
        title
        key
      }
    }
  }
}
    `;

/**
 * __useGetStructureDetailsQuery__
 *
 * To run a query within a React component, call `useGetStructureDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureDetailsQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetStructureDetailsQuery, GetStructureDetailsQueryVariables> & ({ variables: GetStructureDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>(GetStructureDetailsDocument, options);
      }
export function useGetStructureDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>(GetStructureDetailsDocument, options);
        }
export function useGetStructureDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>(GetStructureDetailsDocument, options);
        }
export type GetStructureDetailsQueryHookResult = ReturnType<typeof useGetStructureDetailsQuery>;
export type GetStructureDetailsLazyQueryHookResult = ReturnType<typeof useGetStructureDetailsLazyQuery>;
export type GetStructureDetailsSuspenseQueryHookResult = ReturnType<typeof useGetStructureDetailsSuspenseQuery>;
export type GetStructureDetailsQueryResult = Apollo.QueryResult<GetStructureDetailsQuery, GetStructureDetailsQueryVariables>;
export const AllTemplatesForBuilderDocument = gql`
    query AllTemplatesForBuilder($type: TemplateTypeEnum, $structureId: ID) {
  allTemplates(type: $type, structureId: $structureId) {
    id
    name
    type
    reviewPanelConfig {
      groupKey
      groupName
      id
      groupSection {
        id
        title
        sectionKey
        fieldKeys
      }
    }
    fields {
      id
      name
      type
      options
      optionsData {
        value
        weight
      }
      isRequired
      isReadOnly
      serverSide
      displayConfig {
        id
        type
        isSortable
        sortType
        color {
          key
          value
        }
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
      }
      isHidden
      permission
      isRiskAssessment
      key
      displayInQuery
      displayInTable
      displayInReview
      displayInReports
      displayInReportFilters
      displayInRisk
      defaultVisible
      unit
      roundToDecimal
      isEditable
      editRoles
      dependencyMapping
      displayUnit
    }
    equipmentDetails {
      id
      name
      type
      subType
      options {
        id
        name
        type
        fieldKey
      }
      isRequired
      isReadOnly
      serverSide
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
        textFormat
      }
      isHidden
      fieldKey
    }
    icon {
      name
      color
    }
    defectsArray
    equipmentCard {
      id
      name
      type
      fieldKey
      position
      location
    }
    permissions
    riskFields {
      id
      fieldKey
      type
      isHiddenColumn
    }
    recommendation {
      header
      details {
        id
        fieldKey
      }
    }
    querySummary {
      id
      name
      key
      operation
      matchCondition
      displayType
      rowOrder
      displayConfig {
        fieldValue
        color
      }
      collectionName
      sortType
      sortDirection
    }
    materialType {
      type
      thickness
      environmentalClassification {
        name
        values
      }
      corrosivityCategory {
        name
        values
      }
      environmentalExposure {
        name
        timeToVisibility
        code
      }
    }
  }
}
    `;

/**
 * __useAllTemplatesForBuilderQuery__
 *
 * To run a query within a React component, call `useAllTemplatesForBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTemplatesForBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTemplatesForBuilderQuery({
 *   variables: {
 *      type: // value for 'type'
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAllTemplatesForBuilderQuery(baseOptions?: Apollo.QueryHookOptions<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>(AllTemplatesForBuilderDocument, options);
      }
export function useAllTemplatesForBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>(AllTemplatesForBuilderDocument, options);
        }
export function useAllTemplatesForBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>(AllTemplatesForBuilderDocument, options);
        }
export type AllTemplatesForBuilderQueryHookResult = ReturnType<typeof useAllTemplatesForBuilderQuery>;
export type AllTemplatesForBuilderLazyQueryHookResult = ReturnType<typeof useAllTemplatesForBuilderLazyQuery>;
export type AllTemplatesForBuilderSuspenseQueryHookResult = ReturnType<typeof useAllTemplatesForBuilderSuspenseQuery>;
export type AllTemplatesForBuilderQueryResult = Apollo.QueryResult<AllTemplatesForBuilderQuery, AllTemplatesForBuilderQueryVariables>;
export const AllPlatformsForTemplateBuilderDocument = gql`
    query AllPlatformsForTemplateBuilder {
  allPlatforms {
    name
    id
  }
}
    `;

/**
 * __useAllPlatformsForTemplateBuilderQuery__
 *
 * To run a query within a React component, call `useAllPlatformsForTemplateBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlatformsForTemplateBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlatformsForTemplateBuilderQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllPlatformsForTemplateBuilderQuery(baseOptions?: Apollo.QueryHookOptions<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>(AllPlatformsForTemplateBuilderDocument, options);
      }
export function useAllPlatformsForTemplateBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>(AllPlatformsForTemplateBuilderDocument, options);
        }
export function useAllPlatformsForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>(AllPlatformsForTemplateBuilderDocument, options);
        }
export type AllPlatformsForTemplateBuilderQueryHookResult = ReturnType<typeof useAllPlatformsForTemplateBuilderQuery>;
export type AllPlatformsForTemplateBuilderLazyQueryHookResult = ReturnType<typeof useAllPlatformsForTemplateBuilderLazyQuery>;
export type AllPlatformsForTemplateBuilderSuspenseQueryHookResult = ReturnType<typeof useAllPlatformsForTemplateBuilderSuspenseQuery>;
export type AllPlatformsForTemplateBuilderQueryResult = Apollo.QueryResult<AllPlatformsForTemplateBuilderQuery, AllPlatformsForTemplateBuilderQueryVariables>;
export const GetAllPoiIconsForTemplateBuilderDocument = gql`
    query GetAllPoiIconsForTemplateBuilder {
  getAllPoiIcons
}
    `;

/**
 * __useGetAllPoiIconsForTemplateBuilderQuery__
 *
 * To run a query within a React component, call `useGetAllPoiIconsForTemplateBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPoiIconsForTemplateBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPoiIconsForTemplateBuilderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPoiIconsForTemplateBuilderQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>(GetAllPoiIconsForTemplateBuilderDocument, options);
      }
export function useGetAllPoiIconsForTemplateBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>(GetAllPoiIconsForTemplateBuilderDocument, options);
        }
export function useGetAllPoiIconsForTemplateBuilderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>(GetAllPoiIconsForTemplateBuilderDocument, options);
        }
export type GetAllPoiIconsForTemplateBuilderQueryHookResult = ReturnType<typeof useGetAllPoiIconsForTemplateBuilderQuery>;
export type GetAllPoiIconsForTemplateBuilderLazyQueryHookResult = ReturnType<typeof useGetAllPoiIconsForTemplateBuilderLazyQuery>;
export type GetAllPoiIconsForTemplateBuilderSuspenseQueryHookResult = ReturnType<typeof useGetAllPoiIconsForTemplateBuilderSuspenseQuery>;
export type GetAllPoiIconsForTemplateBuilderQueryResult = Apollo.QueryResult<GetAllPoiIconsForTemplateBuilderQuery, GetAllPoiIconsForTemplateBuilderQueryVariables>;
export const UpdatePointOfInterestTemplateDocument = gql`
    mutation UpdatePointOfInterestTemplate($input: UpdatePointOfInterestTemplateInput) {
  updatePointOfInterestTemplate(input: $input) {
    id
    name
    fields {
      options
      name
      type
      id
      isReadOnly
      isHidden
      defaultVisible
      serverSide
      isRequired
      displayInReview
      displayInReports
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
      }
      unit
    }
  }
}
    `;
export type UpdatePointOfInterestTemplateMutationFn = Apollo.MutationFunction<UpdatePointOfInterestTemplateMutation, UpdatePointOfInterestTemplateMutationVariables>;

/**
 * __useUpdatePointOfInterestTemplateMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfInterestTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfInterestTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfInterestTemplateMutation, { data, loading, error }] = useUpdatePointOfInterestTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePointOfInterestTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfInterestTemplateMutation, UpdatePointOfInterestTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfInterestTemplateMutation, UpdatePointOfInterestTemplateMutationVariables>(UpdatePointOfInterestTemplateDocument, options);
      }
export type UpdatePointOfInterestTemplateMutationHookResult = ReturnType<typeof useUpdatePointOfInterestTemplateMutation>;
export type UpdatePointOfInterestTemplateMutationResult = Apollo.MutationResult<UpdatePointOfInterestTemplateMutation>;
export type UpdatePointOfInterestTemplateMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfInterestTemplateMutation, UpdatePointOfInterestTemplateMutationVariables>;
export const CreatePointOfInterestTemplateDocument = gql`
    mutation CreatePointOfInterestTemplate($input: PointOfInterestTemplateInput) {
  createPointOfInterestTemplate(input: $input) {
    id
    name
    fields {
      options
      name
      type
      id
      key
      isReadOnly
      isHidden
      defaultVisible
      serverSide
      isRequired
      displayInReview
      displayInReports
      displayConfig {
        id
        type
        isSortable
        sortType
        inputAdorment {
          iconPath
          iconType
          position
        }
        textAreaRows
      }
      unit
    }
  }
}
    `;
export type CreatePointOfInterestTemplateMutationFn = Apollo.MutationFunction<CreatePointOfInterestTemplateMutation, CreatePointOfInterestTemplateMutationVariables>;

/**
 * __useCreatePointOfInterestTemplateMutation__
 *
 * To run a mutation, you first call `useCreatePointOfInterestTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointOfInterestTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointOfInterestTemplateMutation, { data, loading, error }] = useCreatePointOfInterestTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePointOfInterestTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreatePointOfInterestTemplateMutation, CreatePointOfInterestTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePointOfInterestTemplateMutation, CreatePointOfInterestTemplateMutationVariables>(CreatePointOfInterestTemplateDocument, options);
      }
export type CreatePointOfInterestTemplateMutationHookResult = ReturnType<typeof useCreatePointOfInterestTemplateMutation>;
export type CreatePointOfInterestTemplateMutationResult = Apollo.MutationResult<CreatePointOfInterestTemplateMutation>;
export type CreatePointOfInterestTemplateMutationOptions = Apollo.BaseMutationOptions<CreatePointOfInterestTemplateMutation, CreatePointOfInterestTemplateMutationVariables>;
export const PointOfInterestTemplateDocument = gql`
    query PointOfInterestTemplate($pointOfInterestTemplateId: ID) {
  pointOfInterestTemplate(pointOfInterestTemplateId: $pointOfInterestTemplateId) {
    id
    name
    accentColor
    createdBy
    icon {
      color
      name
    }
    fields {
      id
      name
      type
      options
      isRequired
      isReadOnly
      serverSide
      displayInReview
      displayInReports
      displayConfig {
        id
        type
        color {
          key
          value
        }
        inputAdorment {
          position
          iconPath
          iconType
        }
        textAreaRows
        isSortable
        sortType
      }
      isHidden
      permission
      defaultVisible
      unit
      key
    }
    permissions
    accentColor
  }
}
    `;

/**
 * __usePointOfInterestTemplateQuery__
 *
 * To run a query within a React component, call `usePointOfInterestTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfInterestTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfInterestTemplateQuery({
 *   variables: {
 *      pointOfInterestTemplateId: // value for 'pointOfInterestTemplateId'
 *   },
 * });
 */
export function usePointOfInterestTemplateQuery(baseOptions?: Apollo.QueryHookOptions<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>(PointOfInterestTemplateDocument, options);
      }
export function usePointOfInterestTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>(PointOfInterestTemplateDocument, options);
        }
export function usePointOfInterestTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>(PointOfInterestTemplateDocument, options);
        }
export type PointOfInterestTemplateQueryHookResult = ReturnType<typeof usePointOfInterestTemplateQuery>;
export type PointOfInterestTemplateLazyQueryHookResult = ReturnType<typeof usePointOfInterestTemplateLazyQuery>;
export type PointOfInterestTemplateSuspenseQueryHookResult = ReturnType<typeof usePointOfInterestTemplateSuspenseQuery>;
export type PointOfInterestTemplateQueryResult = Apollo.QueryResult<PointOfInterestTemplateQuery, PointOfInterestTemplateQueryVariables>;
export const GetAllRolesDocument = gql`
    query GetAllRoles {
  allRoles {
    id
    name
  }
}
    `;

/**
 * __useGetAllRolesQuery__
 *
 * To run a query within a React component, call `useGetAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRolesQuery, GetAllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRolesQuery, GetAllRolesQueryVariables>(GetAllRolesDocument, options);
      }
export function useGetAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRolesQuery, GetAllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRolesQuery, GetAllRolesQueryVariables>(GetAllRolesDocument, options);
        }
export function useGetAllRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRolesQuery, GetAllRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRolesQuery, GetAllRolesQueryVariables>(GetAllRolesDocument, options);
        }
export type GetAllRolesQueryHookResult = ReturnType<typeof useGetAllRolesQuery>;
export type GetAllRolesLazyQueryHookResult = ReturnType<typeof useGetAllRolesLazyQuery>;
export type GetAllRolesSuspenseQueryHookResult = ReturnType<typeof useGetAllRolesSuspenseQuery>;
export type GetAllRolesQueryResult = Apollo.QueryResult<GetAllRolesQuery, GetAllRolesQueryVariables>;
export const ClonePointOfInterestTemplateDocument = gql`
    mutation ClonePointOfInterestTemplate($input: PoiTemplateCloneInput) {
  clonePointOfInterestTemplate(input: $input) {
    id
    name
  }
}
    `;
export type ClonePointOfInterestTemplateMutationFn = Apollo.MutationFunction<ClonePointOfInterestTemplateMutation, ClonePointOfInterestTemplateMutationVariables>;

/**
 * __useClonePointOfInterestTemplateMutation__
 *
 * To run a mutation, you first call `useClonePointOfInterestTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClonePointOfInterestTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clonePointOfInterestTemplateMutation, { data, loading, error }] = useClonePointOfInterestTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClonePointOfInterestTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ClonePointOfInterestTemplateMutation, ClonePointOfInterestTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClonePointOfInterestTemplateMutation, ClonePointOfInterestTemplateMutationVariables>(ClonePointOfInterestTemplateDocument, options);
      }
export type ClonePointOfInterestTemplateMutationHookResult = ReturnType<typeof useClonePointOfInterestTemplateMutation>;
export type ClonePointOfInterestTemplateMutationResult = Apollo.MutationResult<ClonePointOfInterestTemplateMutation>;
export type ClonePointOfInterestTemplateMutationOptions = Apollo.BaseMutationOptions<ClonePointOfInterestTemplateMutation, ClonePointOfInterestTemplateMutationVariables>;
export const UpdateStructureDocument = gql`
    mutation UpdateStructure($input: UpdateStructureInput) {
  updateStructure(input: $input) {
    id
    name
    status
    isActive
    deploymentLevel
    scanDate
    isWallLossEnabled
    defectLegends {
      id
      groupName
      groupKey
      name
      color
      octreeKey
      octreeValue
      legendText
    }
  }
}
    `;
export type UpdateStructureMutationFn = Apollo.MutationFunction<UpdateStructureMutation, UpdateStructureMutationVariables>;

/**
 * __useUpdateStructureMutation__
 *
 * To run a mutation, you first call `useUpdateStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStructureMutation, { data, loading, error }] = useUpdateStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStructureMutation, UpdateStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStructureMutation, UpdateStructureMutationVariables>(UpdateStructureDocument, options);
      }
export type UpdateStructureMutationHookResult = ReturnType<typeof useUpdateStructureMutation>;
export type UpdateStructureMutationResult = Apollo.MutationResult<UpdateStructureMutation>;
export type UpdateStructureMutationOptions = Apollo.BaseMutationOptions<UpdateStructureMutation, UpdateStructureMutationVariables>;
export const DeletePointOfInterestTemplateDocument = gql`
    mutation DeletePointOfInterestTemplate($templateId: String!) {
  deletePointOfInterestTemplate(templateId: $templateId) {
    id
  }
}
    `;
export type DeletePointOfInterestTemplateMutationFn = Apollo.MutationFunction<DeletePointOfInterestTemplateMutation, DeletePointOfInterestTemplateMutationVariables>;

/**
 * __useDeletePointOfInterestTemplateMutation__
 *
 * To run a mutation, you first call `useDeletePointOfInterestTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePointOfInterestTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePointOfInterestTemplateMutation, { data, loading, error }] = useDeletePointOfInterestTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeletePointOfInterestTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeletePointOfInterestTemplateMutation, DeletePointOfInterestTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePointOfInterestTemplateMutation, DeletePointOfInterestTemplateMutationVariables>(DeletePointOfInterestTemplateDocument, options);
      }
export type DeletePointOfInterestTemplateMutationHookResult = ReturnType<typeof useDeletePointOfInterestTemplateMutation>;
export type DeletePointOfInterestTemplateMutationResult = Apollo.MutationResult<DeletePointOfInterestTemplateMutation>;
export type DeletePointOfInterestTemplateMutationOptions = Apollo.BaseMutationOptions<DeletePointOfInterestTemplateMutation, DeletePointOfInterestTemplateMutationVariables>;
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($input: TemplateInput) {
  updateTemplate(input: $input) {
    id
    fields {
      id
      name
    }
  }
}
    `;
export type UpdateTemplateMutationFn = Apollo.MutationFunction<UpdateTemplateMutation, UpdateTemplateMutationVariables>;

/**
 * __useUpdateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateMutation, { data, loading, error }] = useUpdateTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument, options);
      }
export type UpdateTemplateMutationHookResult = ReturnType<typeof useUpdateTemplateMutation>;
export type UpdateTemplateMutationResult = Apollo.MutationResult<UpdateTemplateMutation>;
export type UpdateTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const CloneTemplateFieldsDocument = gql`
    mutation CloneTemplateFields($input: TemplateFieldsCloneInput) {
  cloneTemplateFields(input: $input) {
    fields {
      name
      id
    }
  }
}
    `;
export type CloneTemplateFieldsMutationFn = Apollo.MutationFunction<CloneTemplateFieldsMutation, CloneTemplateFieldsMutationVariables>;

/**
 * __useCloneTemplateFieldsMutation__
 *
 * To run a mutation, you first call `useCloneTemplateFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneTemplateFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneTemplateFieldsMutation, { data, loading, error }] = useCloneTemplateFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneTemplateFieldsMutation(baseOptions?: Apollo.MutationHookOptions<CloneTemplateFieldsMutation, CloneTemplateFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneTemplateFieldsMutation, CloneTemplateFieldsMutationVariables>(CloneTemplateFieldsDocument, options);
      }
export type CloneTemplateFieldsMutationHookResult = ReturnType<typeof useCloneTemplateFieldsMutation>;
export type CloneTemplateFieldsMutationResult = Apollo.MutationResult<CloneTemplateFieldsMutation>;
export type CloneTemplateFieldsMutationOptions = Apollo.BaseMutationOptions<CloneTemplateFieldsMutation, CloneTemplateFieldsMutationVariables>;
export const CloneQuerySummaryDocument = gql`
    mutation CloneQuerySummary($input: QuerySummaryCloneInput) {
  cloneQuerySummary(input: $input) {
    querySummary {
      id
      name
    }
  }
}
    `;
export type CloneQuerySummaryMutationFn = Apollo.MutationFunction<CloneQuerySummaryMutation, CloneQuerySummaryMutationVariables>;

/**
 * __useCloneQuerySummaryMutation__
 *
 * To run a mutation, you first call `useCloneQuerySummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneQuerySummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneQuerySummaryMutation, { data, loading, error }] = useCloneQuerySummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloneQuerySummaryMutation(baseOptions?: Apollo.MutationHookOptions<CloneQuerySummaryMutation, CloneQuerySummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneQuerySummaryMutation, CloneQuerySummaryMutationVariables>(CloneQuerySummaryDocument, options);
      }
export type CloneQuerySummaryMutationHookResult = ReturnType<typeof useCloneQuerySummaryMutation>;
export type CloneQuerySummaryMutationResult = Apollo.MutationResult<CloneQuerySummaryMutation>;
export type CloneQuerySummaryMutationOptions = Apollo.BaseMutationOptions<CloneQuerySummaryMutation, CloneQuerySummaryMutationVariables>;
export const AddMiServicesFieldsDocument = gql`
    mutation AddMiServicesFields($input: MiServicesInput) {
  addMiServicesFields(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddMiServicesFieldsMutationFn = Apollo.MutationFunction<AddMiServicesFieldsMutation, AddMiServicesFieldsMutationVariables>;

/**
 * __useAddMiServicesFieldsMutation__
 *
 * To run a mutation, you first call `useAddMiServicesFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMiServicesFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMiServicesFieldsMutation, { data, loading, error }] = useAddMiServicesFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMiServicesFieldsMutation(baseOptions?: Apollo.MutationHookOptions<AddMiServicesFieldsMutation, AddMiServicesFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMiServicesFieldsMutation, AddMiServicesFieldsMutationVariables>(AddMiServicesFieldsDocument, options);
      }
export type AddMiServicesFieldsMutationHookResult = ReturnType<typeof useAddMiServicesFieldsMutation>;
export type AddMiServicesFieldsMutationResult = Apollo.MutationResult<AddMiServicesFieldsMutation>;
export type AddMiServicesFieldsMutationOptions = Apollo.BaseMutationOptions<AddMiServicesFieldsMutation, AddMiServicesFieldsMutationVariables>;
export const AddMiServicesOverhaulFieldsForAssemblyTemplateDocument = gql`
    mutation AddMiServicesOverhaulFieldsForAssemblyTemplate($input: MiServicesInput) {
  addMiServicesOverhaulFields(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationFn = Apollo.MutationFunction<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation, AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables>;

/**
 * __useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation__
 *
 * To run a mutation, you first call `useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMiServicesOverhaulFieldsForAssemblyTemplateMutation, { data, loading, error }] = useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation, AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation, AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables>(AddMiServicesOverhaulFieldsForAssemblyTemplateDocument, options);
      }
export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationHookResult = ReturnType<typeof useAddMiServicesOverhaulFieldsForAssemblyTemplateMutation>;
export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationResult = Apollo.MutationResult<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation>;
export type AddMiServicesOverhaulFieldsForAssemblyTemplateMutationOptions = Apollo.BaseMutationOptions<AddMiServicesOverhaulFieldsForAssemblyTemplateMutation, AddMiServicesOverhaulFieldsForAssemblyTemplateMutationVariables>;
export const AddMiServicesOverhaulFieldsToPoiTemplatesDocument = gql`
    mutation AddMiServicesOverhaulFieldsToPoiTemplates($input: MiServicesPoiTemplateInput) {
  addMiServicesOverhaulFieldsToPoiTemplates(input: $input) {
    fields {
      id
      name
      key
    }
  }
}
    `;
export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationFn = Apollo.MutationFunction<AddMiServicesOverhaulFieldsToPoiTemplatesMutation, AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>;

/**
 * __useAddMiServicesOverhaulFieldsToPoiTemplatesMutation__
 *
 * To run a mutation, you first call `useAddMiServicesOverhaulFieldsToPoiTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMiServicesOverhaulFieldsToPoiTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMiServicesOverhaulFieldsToPoiTemplatesMutation, { data, loading, error }] = useAddMiServicesOverhaulFieldsToPoiTemplatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMiServicesOverhaulFieldsToPoiTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<AddMiServicesOverhaulFieldsToPoiTemplatesMutation, AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMiServicesOverhaulFieldsToPoiTemplatesMutation, AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>(AddMiServicesOverhaulFieldsToPoiTemplatesDocument, options);
      }
export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationHookResult = ReturnType<typeof useAddMiServicesOverhaulFieldsToPoiTemplatesMutation>;
export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationResult = Apollo.MutationResult<AddMiServicesOverhaulFieldsToPoiTemplatesMutation>;
export type AddMiServicesOverhaulFieldsToPoiTemplatesMutationOptions = Apollo.BaseMutationOptions<AddMiServicesOverhaulFieldsToPoiTemplatesMutation, AddMiServicesOverhaulFieldsToPoiTemplatesMutationVariables>;
export const AddEditRolesToTemplateFieldDocument = gql`
    mutation AddEditRolesToTemplateField($input: EditRolesInput) {
  addEditRolesToTemplateField(input: $input) {
    fields {
      key
      isEditable
      editRoles
    }
  }
}
    `;
export type AddEditRolesToTemplateFieldMutationFn = Apollo.MutationFunction<AddEditRolesToTemplateFieldMutation, AddEditRolesToTemplateFieldMutationVariables>;

/**
 * __useAddEditRolesToTemplateFieldMutation__
 *
 * To run a mutation, you first call `useAddEditRolesToTemplateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEditRolesToTemplateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEditRolesToTemplateFieldMutation, { data, loading, error }] = useAddEditRolesToTemplateFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEditRolesToTemplateFieldMutation(baseOptions?: Apollo.MutationHookOptions<AddEditRolesToTemplateFieldMutation, AddEditRolesToTemplateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEditRolesToTemplateFieldMutation, AddEditRolesToTemplateFieldMutationVariables>(AddEditRolesToTemplateFieldDocument, options);
      }
export type AddEditRolesToTemplateFieldMutationHookResult = ReturnType<typeof useAddEditRolesToTemplateFieldMutation>;
export type AddEditRolesToTemplateFieldMutationResult = Apollo.MutationResult<AddEditRolesToTemplateFieldMutation>;
export type AddEditRolesToTemplateFieldMutationOptions = Apollo.BaseMutationOptions<AddEditRolesToTemplateFieldMutation, AddEditRolesToTemplateFieldMutationVariables>;
export const EvaluateAllAssembliesForStructureDocument = gql`
    mutation EvaluateAllAssembliesForStructure($structureId: String!) {
  evaluateAllAssembliesForStructure(structureId: $structureId) {
    name
  }
}
    `;
export type EvaluateAllAssembliesForStructureMutationFn = Apollo.MutationFunction<EvaluateAllAssembliesForStructureMutation, EvaluateAllAssembliesForStructureMutationVariables>;

/**
 * __useEvaluateAllAssembliesForStructureMutation__
 *
 * To run a mutation, you first call `useEvaluateAllAssembliesForStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateAllAssembliesForStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateAllAssembliesForStructureMutation, { data, loading, error }] = useEvaluateAllAssembliesForStructureMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useEvaluateAllAssembliesForStructureMutation(baseOptions?: Apollo.MutationHookOptions<EvaluateAllAssembliesForStructureMutation, EvaluateAllAssembliesForStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EvaluateAllAssembliesForStructureMutation, EvaluateAllAssembliesForStructureMutationVariables>(EvaluateAllAssembliesForStructureDocument, options);
      }
export type EvaluateAllAssembliesForStructureMutationHookResult = ReturnType<typeof useEvaluateAllAssembliesForStructureMutation>;
export type EvaluateAllAssembliesForStructureMutationResult = Apollo.MutationResult<EvaluateAllAssembliesForStructureMutation>;
export type EvaluateAllAssembliesForStructureMutationOptions = Apollo.BaseMutationOptions<EvaluateAllAssembliesForStructureMutation, EvaluateAllAssembliesForStructureMutationVariables>;
export const AddAssessmentDetailsFieldsDocument = gql`
    mutation AddAssessmentDetailsFields($input: AssessmentDetailsInput) {
  addAssessmentDetailsFields(input: $input) {
    fields {
      id
      name
      key
    }
    assessmentDetails {
      id
      isVisible
      name
      position
      type
      options {
        fieldKey
        id
        name
        type
      }
    }
    reviewPanelConfig {
      groupKey
      groupName
      id
      groupSection {
        id
        title
        sectionKey
        fieldKeys
      }
    }
  }
}
    `;
export type AddAssessmentDetailsFieldsMutationFn = Apollo.MutationFunction<AddAssessmentDetailsFieldsMutation, AddAssessmentDetailsFieldsMutationVariables>;

/**
 * __useAddAssessmentDetailsFieldsMutation__
 *
 * To run a mutation, you first call `useAddAssessmentDetailsFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssessmentDetailsFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssessmentDetailsFieldsMutation, { data, loading, error }] = useAddAssessmentDetailsFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAssessmentDetailsFieldsMutation(baseOptions?: Apollo.MutationHookOptions<AddAssessmentDetailsFieldsMutation, AddAssessmentDetailsFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAssessmentDetailsFieldsMutation, AddAssessmentDetailsFieldsMutationVariables>(AddAssessmentDetailsFieldsDocument, options);
      }
export type AddAssessmentDetailsFieldsMutationHookResult = ReturnType<typeof useAddAssessmentDetailsFieldsMutation>;
export type AddAssessmentDetailsFieldsMutationResult = Apollo.MutationResult<AddAssessmentDetailsFieldsMutation>;
export type AddAssessmentDetailsFieldsMutationOptions = Apollo.BaseMutationOptions<AddAssessmentDetailsFieldsMutation, AddAssessmentDetailsFieldsMutationVariables>;
export const UploadCoverImageDocument = gql`
    mutation UploadCoverImage($input: UploadImageInput!) {
  uploadCoverImage(input: $input) {
    coverImagePath
  }
}
    `;
export type UploadCoverImageMutationFn = Apollo.MutationFunction<UploadCoverImageMutation, UploadCoverImageMutationVariables>;

/**
 * __useUploadCoverImageMutation__
 *
 * To run a mutation, you first call `useUploadCoverImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCoverImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCoverImageMutation, { data, loading, error }] = useUploadCoverImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCoverImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadCoverImageMutation, UploadCoverImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCoverImageMutation, UploadCoverImageMutationVariables>(UploadCoverImageDocument, options);
      }
export type UploadCoverImageMutationHookResult = ReturnType<typeof useUploadCoverImageMutation>;
export type UploadCoverImageMutationResult = Apollo.MutationResult<UploadCoverImageMutation>;
export type UploadCoverImageMutationOptions = Apollo.BaseMutationOptions<UploadCoverImageMutation, UploadCoverImageMutationVariables>;
export const UpdateRemediationScoreConfigDocument = gql`
    mutation updateRemediationScoreConfig($input: UpdateRemediationScoreConfigInput!) {
  updateRemediationScoreConfig(input: $input) {
    remediationScoreConfig {
      area {
        fields {
          fieldKey
          score
          threshold
        }
      }
      cof {
        fields {
          fieldKey
          optionScores
        }
      }
      poi {
        fields {
          poiScore
          poiTemplateKey
          subcategory {
            fieldKey
            optionScores
          }
        }
      }
    }
  }
}
    `;
export type UpdateRemediationScoreConfigMutationFn = Apollo.MutationFunction<UpdateRemediationScoreConfigMutation, UpdateRemediationScoreConfigMutationVariables>;

/**
 * __useUpdateRemediationScoreConfigMutation__
 *
 * To run a mutation, you first call `useUpdateRemediationScoreConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRemediationScoreConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRemediationScoreConfigMutation, { data, loading, error }] = useUpdateRemediationScoreConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRemediationScoreConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRemediationScoreConfigMutation, UpdateRemediationScoreConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRemediationScoreConfigMutation, UpdateRemediationScoreConfigMutationVariables>(UpdateRemediationScoreConfigDocument, options);
      }
export type UpdateRemediationScoreConfigMutationHookResult = ReturnType<typeof useUpdateRemediationScoreConfigMutation>;
export type UpdateRemediationScoreConfigMutationResult = Apollo.MutationResult<UpdateRemediationScoreConfigMutation>;
export type UpdateRemediationScoreConfigMutationOptions = Apollo.BaseMutationOptions<UpdateRemediationScoreConfigMutation, UpdateRemediationScoreConfigMutationVariables>;
export const AddReportConfigurationDocument = gql`
    mutation AddReportConfiguration($structureId: ID!) {
  addReportConfiguration(structureId: $structureId) {
    reportConfig {
      title
      id
      configurations {
        id
        title
        key
      }
    }
  }
}
    `;
export type AddReportConfigurationMutationFn = Apollo.MutationFunction<AddReportConfigurationMutation, AddReportConfigurationMutationVariables>;

/**
 * __useAddReportConfigurationMutation__
 *
 * To run a mutation, you first call `useAddReportConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReportConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReportConfigurationMutation, { data, loading, error }] = useAddReportConfigurationMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useAddReportConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<AddReportConfigurationMutation, AddReportConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddReportConfigurationMutation, AddReportConfigurationMutationVariables>(AddReportConfigurationDocument, options);
      }
export type AddReportConfigurationMutationHookResult = ReturnType<typeof useAddReportConfigurationMutation>;
export type AddReportConfigurationMutationResult = Apollo.MutationResult<AddReportConfigurationMutation>;
export type AddReportConfigurationMutationOptions = Apollo.BaseMutationOptions<AddReportConfigurationMutation, AddReportConfigurationMutationVariables>;
export const RecalculateRiskRemediationAnalyticsDocument = gql`
    mutation RecalculateRiskRemediationAnalytics($input: RecalculateRiskRemediationAnalyticsInput!) {
  recalculateRiskRemediationAnalytics(input: $input) {
    success
    error
  }
}
    `;
export type RecalculateRiskRemediationAnalyticsMutationFn = Apollo.MutationFunction<RecalculateRiskRemediationAnalyticsMutation, RecalculateRiskRemediationAnalyticsMutationVariables>;

/**
 * __useRecalculateRiskRemediationAnalyticsMutation__
 *
 * To run a mutation, you first call `useRecalculateRiskRemediationAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateRiskRemediationAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateRiskRemediationAnalyticsMutation, { data, loading, error }] = useRecalculateRiskRemediationAnalyticsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecalculateRiskRemediationAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<RecalculateRiskRemediationAnalyticsMutation, RecalculateRiskRemediationAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecalculateRiskRemediationAnalyticsMutation, RecalculateRiskRemediationAnalyticsMutationVariables>(RecalculateRiskRemediationAnalyticsDocument, options);
      }
export type RecalculateRiskRemediationAnalyticsMutationHookResult = ReturnType<typeof useRecalculateRiskRemediationAnalyticsMutation>;
export type RecalculateRiskRemediationAnalyticsMutationResult = Apollo.MutationResult<RecalculateRiskRemediationAnalyticsMutation>;
export type RecalculateRiskRemediationAnalyticsMutationOptions = Apollo.BaseMutationOptions<RecalculateRiskRemediationAnalyticsMutation, RecalculateRiskRemediationAnalyticsMutationVariables>;
export const AllUsersForUserManagementDocument = gql`
    query AllUsersForUserManagement($pageInfo: PageInfo, $input: FilterForUsers, $usersCountInput: FiltersForUsersCount) {
  usersCount(input: $usersCountInput) {
    count
  }
  allUsers(pageInfo: $pageInfo, input: $input) {
    id
    email
    picture
    name
    roleIds {
      id
      name
      description
      auth0Id
    }
    connection
    status
    loginCount
    lastLogin
    loginType
  }
}
    `;

/**
 * __useAllUsersForUserManagementQuery__
 *
 * To run a query within a React component, call `useAllUsersForUserManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersForUserManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersForUserManagementQuery({
 *   variables: {
 *      pageInfo: // value for 'pageInfo'
 *      input: // value for 'input'
 *      usersCountInput: // value for 'usersCountInput'
 *   },
 * });
 */
export function useAllUsersForUserManagementQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>(AllUsersForUserManagementDocument, options);
      }
export function useAllUsersForUserManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>(AllUsersForUserManagementDocument, options);
        }
export function useAllUsersForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>(AllUsersForUserManagementDocument, options);
        }
export type AllUsersForUserManagementQueryHookResult = ReturnType<typeof useAllUsersForUserManagementQuery>;
export type AllUsersForUserManagementLazyQueryHookResult = ReturnType<typeof useAllUsersForUserManagementLazyQuery>;
export type AllUsersForUserManagementSuspenseQueryHookResult = ReturnType<typeof useAllUsersForUserManagementSuspenseQuery>;
export type AllUsersForUserManagementQueryResult = Apollo.QueryResult<AllUsersForUserManagementQuery, AllUsersForUserManagementQueryVariables>;
export const BlockOrUnblockUserDocument = gql`
    mutation BlockOrUnblockUser($userId: ID!) {
  blockOrUnblockUser(userId: $userId) {
    id
    status
  }
}
    `;
export type BlockOrUnblockUserMutationFn = Apollo.MutationFunction<BlockOrUnblockUserMutation, BlockOrUnblockUserMutationVariables>;

/**
 * __useBlockOrUnblockUserMutation__
 *
 * To run a mutation, you first call `useBlockOrUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockOrUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockOrUnblockUserMutation, { data, loading, error }] = useBlockOrUnblockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockOrUnblockUserMutation(baseOptions?: Apollo.MutationHookOptions<BlockOrUnblockUserMutation, BlockOrUnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BlockOrUnblockUserMutation, BlockOrUnblockUserMutationVariables>(BlockOrUnblockUserDocument, options);
      }
export type BlockOrUnblockUserMutationHookResult = ReturnType<typeof useBlockOrUnblockUserMutation>;
export type BlockOrUnblockUserMutationResult = Apollo.MutationResult<BlockOrUnblockUserMutation>;
export type BlockOrUnblockUserMutationOptions = Apollo.BaseMutationOptions<BlockOrUnblockUserMutation, BlockOrUnblockUserMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const AllStructuresForAddPlatformDialogDocument = gql`
    query AllStructuresForAddPlatformDialog($input: StructureFilters) {
  allStructures(input: $input) {
    coverImagePath
    id
    name
    description
  }
}
    `;

/**
 * __useAllStructuresForAddPlatformDialogQuery__
 *
 * To run a query within a React component, call `useAllStructuresForAddPlatformDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresForAddPlatformDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresForAddPlatformDialogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllStructuresForAddPlatformDialogQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>(AllStructuresForAddPlatformDialogDocument, options);
      }
export function useAllStructuresForAddPlatformDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>(AllStructuresForAddPlatformDialogDocument, options);
        }
export function useAllStructuresForAddPlatformDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>(AllStructuresForAddPlatformDialogDocument, options);
        }
export type AllStructuresForAddPlatformDialogQueryHookResult = ReturnType<typeof useAllStructuresForAddPlatformDialogQuery>;
export type AllStructuresForAddPlatformDialogLazyQueryHookResult = ReturnType<typeof useAllStructuresForAddPlatformDialogLazyQuery>;
export type AllStructuresForAddPlatformDialogSuspenseQueryHookResult = ReturnType<typeof useAllStructuresForAddPlatformDialogSuspenseQuery>;
export type AllStructuresForAddPlatformDialogQueryResult = Apollo.QueryResult<AllStructuresForAddPlatformDialogQuery, AllStructuresForAddPlatformDialogQueryVariables>;
export const AllUsersForAddUserDialogDocument = gql`
    query AllUsersForAddUserDialog($input: FilterForUsers) {
  allUsers(input: $input) {
    id
    email
    picture
    name
    roleIds {
      id
      name
      description
      auth0Id
    }
    connection
    status
    loginCount
    lastLogin
    loginType
  }
}
    `;

/**
 * __useAllUsersForAddUserDialogQuery__
 *
 * To run a query within a React component, call `useAllUsersForAddUserDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersForAddUserDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersForAddUserDialogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllUsersForAddUserDialogQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>(AllUsersForAddUserDialogDocument, options);
      }
export function useAllUsersForAddUserDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>(AllUsersForAddUserDialogDocument, options);
        }
export function useAllUsersForAddUserDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>(AllUsersForAddUserDialogDocument, options);
        }
export type AllUsersForAddUserDialogQueryHookResult = ReturnType<typeof useAllUsersForAddUserDialogQuery>;
export type AllUsersForAddUserDialogLazyQueryHookResult = ReturnType<typeof useAllUsersForAddUserDialogLazyQuery>;
export type AllUsersForAddUserDialogSuspenseQueryHookResult = ReturnType<typeof useAllUsersForAddUserDialogSuspenseQuery>;
export type AllUsersForAddUserDialogQueryResult = Apollo.QueryResult<AllUsersForAddUserDialogQuery, AllUsersForAddUserDialogQueryVariables>;
export const PreRegisteredUsersDocument = gql`
    query PreRegisteredUsers($pageInfo: PageInfo, $input: FiltersForPreRegisteredUsers) {
  preRegisteredUsers(pageInfo: $pageInfo, input: $input) {
    id
    email
  }
  preRegisteredUsersCount(input: $input) {
    count
  }
}
    `;

/**
 * __usePreRegisteredUsersQuery__
 *
 * To run a query within a React component, call `usePreRegisteredUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreRegisteredUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreRegisteredUsersQuery({
 *   variables: {
 *      pageInfo: // value for 'pageInfo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreRegisteredUsersQuery(baseOptions?: Apollo.QueryHookOptions<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>(PreRegisteredUsersDocument, options);
      }
export function usePreRegisteredUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>(PreRegisteredUsersDocument, options);
        }
export function usePreRegisteredUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>(PreRegisteredUsersDocument, options);
        }
export type PreRegisteredUsersQueryHookResult = ReturnType<typeof usePreRegisteredUsersQuery>;
export type PreRegisteredUsersLazyQueryHookResult = ReturnType<typeof usePreRegisteredUsersLazyQuery>;
export type PreRegisteredUsersSuspenseQueryHookResult = ReturnType<typeof usePreRegisteredUsersSuspenseQuery>;
export type PreRegisteredUsersQueryResult = Apollo.QueryResult<PreRegisteredUsersQuery, PreRegisteredUsersQueryVariables>;
export const CreatePreRegisteredUsersDocument = gql`
    mutation CreatePreRegisteredUsers($input: PreRegisteredUserInput) {
  createPreRegisteredUsers(input: $input) {
    createdUsers {
      email
      status
      id
    }
    failedUsers {
      email
      errorMessage
    }
  }
}
    `;
export type CreatePreRegisteredUsersMutationFn = Apollo.MutationFunction<CreatePreRegisteredUsersMutation, CreatePreRegisteredUsersMutationVariables>;

/**
 * __useCreatePreRegisteredUsersMutation__
 *
 * To run a mutation, you first call `useCreatePreRegisteredUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreRegisteredUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreRegisteredUsersMutation, { data, loading, error }] = useCreatePreRegisteredUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePreRegisteredUsersMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreRegisteredUsersMutation, CreatePreRegisteredUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreRegisteredUsersMutation, CreatePreRegisteredUsersMutationVariables>(CreatePreRegisteredUsersDocument, options);
      }
export type CreatePreRegisteredUsersMutationHookResult = ReturnType<typeof useCreatePreRegisteredUsersMutation>;
export type CreatePreRegisteredUsersMutationResult = Apollo.MutationResult<CreatePreRegisteredUsersMutation>;
export type CreatePreRegisteredUsersMutationOptions = Apollo.BaseMutationOptions<CreatePreRegisteredUsersMutation, CreatePreRegisteredUsersMutationVariables>;
export const DeletePreRegisteredUserDocument = gql`
    mutation DeletePreRegisteredUser($userId: ID) {
  deletePreRegisteredUser(userId: $userId) {
    email
  }
}
    `;
export type DeletePreRegisteredUserMutationFn = Apollo.MutationFunction<DeletePreRegisteredUserMutation, DeletePreRegisteredUserMutationVariables>;

/**
 * __useDeletePreRegisteredUserMutation__
 *
 * To run a mutation, you first call `useDeletePreRegisteredUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePreRegisteredUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePreRegisteredUserMutation, { data, loading, error }] = useDeletePreRegisteredUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeletePreRegisteredUserMutation(baseOptions?: Apollo.MutationHookOptions<DeletePreRegisteredUserMutation, DeletePreRegisteredUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePreRegisteredUserMutation, DeletePreRegisteredUserMutationVariables>(DeletePreRegisteredUserDocument, options);
      }
export type DeletePreRegisteredUserMutationHookResult = ReturnType<typeof useDeletePreRegisteredUserMutation>;
export type DeletePreRegisteredUserMutationResult = Apollo.MutationResult<DeletePreRegisteredUserMutation>;
export type DeletePreRegisteredUserMutationOptions = Apollo.BaseMutationOptions<DeletePreRegisteredUserMutation, DeletePreRegisteredUserMutationVariables>;
export const AddUsersToUserGroupDocument = gql`
    mutation AddUsersToUserGroup($input: AddRemoveUsersToFromUserGroupInput) {
  addUsersToUserGroup(input: $input) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type AddUsersToUserGroupMutationFn = Apollo.MutationFunction<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>;

/**
 * __useAddUsersToUserGroupMutation__
 *
 * To run a mutation, you first call `useAddUsersToUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToUserGroupMutation, { data, loading, error }] = useAddUsersToUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUsersToUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>(AddUsersToUserGroupDocument, options);
      }
export type AddUsersToUserGroupMutationHookResult = ReturnType<typeof useAddUsersToUserGroupMutation>;
export type AddUsersToUserGroupMutationResult = Apollo.MutationResult<AddUsersToUserGroupMutation>;
export type AddUsersToUserGroupMutationOptions = Apollo.BaseMutationOptions<AddUsersToUserGroupMutation, AddUsersToUserGroupMutationVariables>;
export const GetAllTeamsForUserManagementDocument = gql`
    query GetAllTeamsForUserManagement {
  allTeams {
    id
    name
    users {
      id
    }
  }
}
    `;

/**
 * __useGetAllTeamsForUserManagementQuery__
 *
 * To run a query within a React component, call `useGetAllTeamsForUserManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTeamsForUserManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTeamsForUserManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTeamsForUserManagementQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>(GetAllTeamsForUserManagementDocument, options);
      }
export function useGetAllTeamsForUserManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>(GetAllTeamsForUserManagementDocument, options);
        }
export function useGetAllTeamsForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>(GetAllTeamsForUserManagementDocument, options);
        }
export type GetAllTeamsForUserManagementQueryHookResult = ReturnType<typeof useGetAllTeamsForUserManagementQuery>;
export type GetAllTeamsForUserManagementLazyQueryHookResult = ReturnType<typeof useGetAllTeamsForUserManagementLazyQuery>;
export type GetAllTeamsForUserManagementSuspenseQueryHookResult = ReturnType<typeof useGetAllTeamsForUserManagementSuspenseQuery>;
export type GetAllTeamsForUserManagementQueryResult = Apollo.QueryResult<GetAllTeamsForUserManagementQuery, GetAllTeamsForUserManagementQueryVariables>;
export const GetUsersByTeamDocument = gql`
    query GetUsersByTeam($teamId: ID!, $pageInfo: PageInfo) {
  usersByTeam(teamId: $teamId, pageInfo: $pageInfo) {
    id
    name
    email
    picture
  }
}
    `;

/**
 * __useGetUsersByTeamQuery__
 *
 * To run a query within a React component, call `useGetUsersByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      pageInfo: // value for 'pageInfo'
 *   },
 * });
 */
export function useGetUsersByTeamQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByTeamQuery, GetUsersByTeamQueryVariables> & ({ variables: GetUsersByTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>(GetUsersByTeamDocument, options);
      }
export function useGetUsersByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>(GetUsersByTeamDocument, options);
        }
export function useGetUsersByTeamSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>(GetUsersByTeamDocument, options);
        }
export type GetUsersByTeamQueryHookResult = ReturnType<typeof useGetUsersByTeamQuery>;
export type GetUsersByTeamLazyQueryHookResult = ReturnType<typeof useGetUsersByTeamLazyQuery>;
export type GetUsersByTeamSuspenseQueryHookResult = ReturnType<typeof useGetUsersByTeamSuspenseQuery>;
export type GetUsersByTeamQueryResult = Apollo.QueryResult<GetUsersByTeamQuery, GetUsersByTeamQueryVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($name: String!) {
  createTeam(name: $name) {
    id
    name
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($teamId: ID!) {
  deleteTeam(teamId: $teamId)
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const AddUsersToTeamDocument = gql`
    mutation AddUsersToTeam($input: UpdateTeamInput!) {
  addUsersToTeam(input: $input) {
    id
  }
}
    `;
export type AddUsersToTeamMutationFn = Apollo.MutationFunction<AddUsersToTeamMutation, AddUsersToTeamMutationVariables>;

/**
 * __useAddUsersToTeamMutation__
 *
 * To run a mutation, you first call `useAddUsersToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToTeamMutation, { data, loading, error }] = useAddUsersToTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUsersToTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToTeamMutation, AddUsersToTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToTeamMutation, AddUsersToTeamMutationVariables>(AddUsersToTeamDocument, options);
      }
export type AddUsersToTeamMutationHookResult = ReturnType<typeof useAddUsersToTeamMutation>;
export type AddUsersToTeamMutationResult = Apollo.MutationResult<AddUsersToTeamMutation>;
export type AddUsersToTeamMutationOptions = Apollo.BaseMutationOptions<AddUsersToTeamMutation, AddUsersToTeamMutationVariables>;
export const RemoveUsersFromTeamDocument = gql`
    mutation RemoveUsersFromTeam($input: UpdateTeamInput!) {
  removeUsersFromTeam(input: $input) {
    id
  }
}
    `;
export type RemoveUsersFromTeamMutationFn = Apollo.MutationFunction<RemoveUsersFromTeamMutation, RemoveUsersFromTeamMutationVariables>;

/**
 * __useRemoveUsersFromTeamMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromTeamMutation, { data, loading, error }] = useRemoveUsersFromTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUsersFromTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersFromTeamMutation, RemoveUsersFromTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersFromTeamMutation, RemoveUsersFromTeamMutationVariables>(RemoveUsersFromTeamDocument, options);
      }
export type RemoveUsersFromTeamMutationHookResult = ReturnType<typeof useRemoveUsersFromTeamMutation>;
export type RemoveUsersFromTeamMutationResult = Apollo.MutationResult<RemoveUsersFromTeamMutation>;
export type RemoveUsersFromTeamMutationOptions = Apollo.BaseMutationOptions<RemoveUsersFromTeamMutation, RemoveUsersFromTeamMutationVariables>;
export const AllUserGroupsForUserManagementDocument = gql`
    query AllUserGroupsForUserManagement($userId: ID) {
  allUserGroups(userId: $userId) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useAllUserGroupsForUserManagementQuery__
 *
 * To run a query within a React component, call `useAllUserGroupsForUserManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserGroupsForUserManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserGroupsForUserManagementQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAllUserGroupsForUserManagementQuery(baseOptions?: Apollo.QueryHookOptions<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>(AllUserGroupsForUserManagementDocument, options);
      }
export function useAllUserGroupsForUserManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>(AllUserGroupsForUserManagementDocument, options);
        }
export function useAllUserGroupsForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>(AllUserGroupsForUserManagementDocument, options);
        }
export type AllUserGroupsForUserManagementQueryHookResult = ReturnType<typeof useAllUserGroupsForUserManagementQuery>;
export type AllUserGroupsForUserManagementLazyQueryHookResult = ReturnType<typeof useAllUserGroupsForUserManagementLazyQuery>;
export type AllUserGroupsForUserManagementSuspenseQueryHookResult = ReturnType<typeof useAllUserGroupsForUserManagementSuspenseQuery>;
export type AllUserGroupsForUserManagementQueryResult = Apollo.QueryResult<AllUserGroupsForUserManagementQuery, AllUserGroupsForUserManagementQueryVariables>;
export const AllRolesDocument = gql`
    query AllRoles {
  allRoles {
    id
    auth0Id
    name
    description
  }
}
    `;

/**
 * __useAllRolesQuery__
 *
 * To run a query within a React component, call `useAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllRolesQuery(baseOptions?: Apollo.QueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
      }
export function useAllRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
        }
export function useAllRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllRolesQuery, AllRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllRolesQuery, AllRolesQueryVariables>(AllRolesDocument, options);
        }
export type AllRolesQueryHookResult = ReturnType<typeof useAllRolesQuery>;
export type AllRolesLazyQueryHookResult = ReturnType<typeof useAllRolesLazyQuery>;
export type AllRolesSuspenseQueryHookResult = ReturnType<typeof useAllRolesSuspenseQuery>;
export type AllRolesQueryResult = Apollo.QueryResult<AllRolesQuery, AllRolesQueryVariables>;
export const UsersCountDocument = gql`
    query UsersCount($input: FiltersForUsersCount) {
  usersCount(input: $input) {
    count
  }
}
    `;

/**
 * __useUsersCountQuery__
 *
 * To run a query within a React component, call `useUsersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsersCountQuery(baseOptions?: Apollo.QueryHookOptions<UsersCountQuery, UsersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersCountQuery, UsersCountQueryVariables>(UsersCountDocument, options);
      }
export function useUsersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersCountQuery, UsersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersCountQuery, UsersCountQueryVariables>(UsersCountDocument, options);
        }
export function useUsersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersCountQuery, UsersCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersCountQuery, UsersCountQueryVariables>(UsersCountDocument, options);
        }
export type UsersCountQueryHookResult = ReturnType<typeof useUsersCountQuery>;
export type UsersCountLazyQueryHookResult = ReturnType<typeof useUsersCountLazyQuery>;
export type UsersCountSuspenseQueryHookResult = ReturnType<typeof useUsersCountSuspenseQuery>;
export type UsersCountQueryResult = Apollo.QueryResult<UsersCountQuery, UsersCountQueryVariables>;
export const UsersByUserGroupDocument = gql`
    query UsersByUserGroup($input: FilterForUsersByUserGroup, $pageInfo: PageInfo, $usersCountInput: FiltersForUsersCount) {
  usersCount(input: $usersCountInput) {
    count
  }
  usersByUserGroup(input: $input, pageInfo: $pageInfo) {
    id
    email
    picture
    name
    connection
    roleIds {
      id
      name
      description
      auth0Id
      permissions
    }
  }
}
    `;

/**
 * __useUsersByUserGroupQuery__
 *
 * To run a query within a React component, call `useUsersByUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersByUserGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersByUserGroupQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *      usersCountInput: // value for 'usersCountInput'
 *   },
 * });
 */
export function useUsersByUserGroupQuery(baseOptions?: Apollo.QueryHookOptions<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>(UsersByUserGroupDocument, options);
      }
export function useUsersByUserGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>(UsersByUserGroupDocument, options);
        }
export function useUsersByUserGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>(UsersByUserGroupDocument, options);
        }
export type UsersByUserGroupQueryHookResult = ReturnType<typeof useUsersByUserGroupQuery>;
export type UsersByUserGroupLazyQueryHookResult = ReturnType<typeof useUsersByUserGroupLazyQuery>;
export type UsersByUserGroupSuspenseQueryHookResult = ReturnType<typeof useUsersByUserGroupSuspenseQuery>;
export type UsersByUserGroupQueryResult = Apollo.QueryResult<UsersByUserGroupQuery, UsersByUserGroupQueryVariables>;
export const GetAuth0ConnectionsDocument = gql`
    query GetAuth0Connections($applicationId: String!) {
  auth0Connections: getAuth0Connections(applicationId: $applicationId) {
    id
    name
  }
}
    `;

/**
 * __useGetAuth0ConnectionsQuery__
 *
 * To run a query within a React component, call `useGetAuth0ConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuth0ConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuth0ConnectionsQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useGetAuth0ConnectionsQuery(baseOptions: Apollo.QueryHookOptions<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables> & ({ variables: GetAuth0ConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>(GetAuth0ConnectionsDocument, options);
      }
export function useGetAuth0ConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>(GetAuth0ConnectionsDocument, options);
        }
export function useGetAuth0ConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>(GetAuth0ConnectionsDocument, options);
        }
export type GetAuth0ConnectionsQueryHookResult = ReturnType<typeof useGetAuth0ConnectionsQuery>;
export type GetAuth0ConnectionsLazyQueryHookResult = ReturnType<typeof useGetAuth0ConnectionsLazyQuery>;
export type GetAuth0ConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetAuth0ConnectionsSuspenseQuery>;
export type GetAuth0ConnectionsQueryResult = Apollo.QueryResult<GetAuth0ConnectionsQuery, GetAuth0ConnectionsQueryVariables>;
export const RemoveUsersFromUserGroupDocument = gql`
    mutation RemoveUsersFromUserGroup($input: AddRemoveUsersToFromUserGroupInput) {
  removeUsersFromUserGroup(input: $input) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type RemoveUsersFromUserGroupMutationFn = Apollo.MutationFunction<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>;

/**
 * __useRemoveUsersFromUserGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromUserGroupMutation, { data, loading, error }] = useRemoveUsersFromUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUsersFromUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>(RemoveUsersFromUserGroupDocument, options);
      }
export type RemoveUsersFromUserGroupMutationHookResult = ReturnType<typeof useRemoveUsersFromUserGroupMutation>;
export type RemoveUsersFromUserGroupMutationResult = Apollo.MutationResult<RemoveUsersFromUserGroupMutation>;
export type RemoveUsersFromUserGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUsersFromUserGroupMutation, RemoveUsersFromUserGroupMutationVariables>;
export const InviteUsersDocument = gql`
    mutation InviteUsers($input: InviteUsersInput) {
  inviteUsers(input: $input) {
    createdUsers {
      email
      status
      id
    }
    failedUsers {
      email
      errorMessage
    }
  }
}
    `;
export type InviteUsersMutationFn = Apollo.MutationFunction<InviteUsersMutation, InviteUsersMutationVariables>;

/**
 * __useInviteUsersMutation__
 *
 * To run a mutation, you first call `useInviteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersMutation, { data, loading, error }] = useInviteUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUsersMutation(baseOptions?: Apollo.MutationHookOptions<InviteUsersMutation, InviteUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUsersMutation, InviteUsersMutationVariables>(InviteUsersDocument, options);
      }
export type InviteUsersMutationHookResult = ReturnType<typeof useInviteUsersMutation>;
export type InviteUsersMutationResult = Apollo.MutationResult<InviteUsersMutation>;
export type InviteUsersMutationOptions = Apollo.BaseMutationOptions<InviteUsersMutation, InviteUsersMutationVariables>;
export const CreateUserGroupDocument = gql`
    mutation CreateUserGroup($input: CreateUserGroupInput) {
  createUserGroup(input: $input) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type CreateUserGroupMutationFn = Apollo.MutationFunction<CreateUserGroupMutation, CreateUserGroupMutationVariables>;

/**
 * __useCreateUserGroupMutation__
 *
 * To run a mutation, you first call `useCreateUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserGroupMutation, { data, loading, error }] = useCreateUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserGroupMutation, CreateUserGroupMutationVariables>(CreateUserGroupDocument, options);
      }
export type CreateUserGroupMutationHookResult = ReturnType<typeof useCreateUserGroupMutation>;
export type CreateUserGroupMutationResult = Apollo.MutationResult<CreateUserGroupMutation>;
export type CreateUserGroupMutationOptions = Apollo.BaseMutationOptions<CreateUserGroupMutation, CreateUserGroupMutationVariables>;
export const AllStructuresForUserManagementDocument = gql`
    query AllStructuresForUserManagement {
  allStructures {
    id
    name
    coverImagePath
    userGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useAllStructuresForUserManagementQuery__
 *
 * To run a query within a React component, call `useAllStructuresForUserManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStructuresForUserManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStructuresForUserManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllStructuresForUserManagementQuery(baseOptions?: Apollo.QueryHookOptions<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>(AllStructuresForUserManagementDocument, options);
      }
export function useAllStructuresForUserManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>(AllStructuresForUserManagementDocument, options);
        }
export function useAllStructuresForUserManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>(AllStructuresForUserManagementDocument, options);
        }
export type AllStructuresForUserManagementQueryHookResult = ReturnType<typeof useAllStructuresForUserManagementQuery>;
export type AllStructuresForUserManagementLazyQueryHookResult = ReturnType<typeof useAllStructuresForUserManagementLazyQuery>;
export type AllStructuresForUserManagementSuspenseQueryHookResult = ReturnType<typeof useAllStructuresForUserManagementSuspenseQuery>;
export type AllStructuresForUserManagementQueryResult = Apollo.QueryResult<AllStructuresForUserManagementQuery, AllStructuresForUserManagementQueryVariables>;
export const StructuresByUserGroupDocument = gql`
    query StructuresByUserGroup($structuresInput: FiltersForStructureByUserGroup, $pageInfo: PageInfo, $input: FilterForStructures) {
  structuresByUserGroup(input: $structuresInput, pageInfo: $pageInfo) {
    id
    name
    coverImagePath
    description
  }
  structuresCount(input: $input) {
    count
  }
}
    `;

/**
 * __useStructuresByUserGroupQuery__
 *
 * To run a query within a React component, call `useStructuresByUserGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructuresByUserGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructuresByUserGroupQuery({
 *   variables: {
 *      structuresInput: // value for 'structuresInput'
 *      pageInfo: // value for 'pageInfo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStructuresByUserGroupQuery(baseOptions?: Apollo.QueryHookOptions<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>(StructuresByUserGroupDocument, options);
      }
export function useStructuresByUserGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>(StructuresByUserGroupDocument, options);
        }
export function useStructuresByUserGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>(StructuresByUserGroupDocument, options);
        }
export type StructuresByUserGroupQueryHookResult = ReturnType<typeof useStructuresByUserGroupQuery>;
export type StructuresByUserGroupLazyQueryHookResult = ReturnType<typeof useStructuresByUserGroupLazyQuery>;
export type StructuresByUserGroupSuspenseQueryHookResult = ReturnType<typeof useStructuresByUserGroupSuspenseQuery>;
export type StructuresByUserGroupQueryResult = Apollo.QueryResult<StructuresByUserGroupQuery, StructuresByUserGroupQueryVariables>;
export const RemoveUserGroupsFromStructureDocument = gql`
    mutation RemoveUserGroupsFromStructure($input: AddRemoveStructuresToFromUserGroupsInput) {
  removeUserGroupsFromStructure(input: $input) {
    userGroups {
      id
      name
      userIds
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
    structures {
      id
      name
    }
  }
}
    `;
export type RemoveUserGroupsFromStructureMutationFn = Apollo.MutationFunction<RemoveUserGroupsFromStructureMutation, RemoveUserGroupsFromStructureMutationVariables>;

/**
 * __useRemoveUserGroupsFromStructureMutation__
 *
 * To run a mutation, you first call `useRemoveUserGroupsFromStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserGroupsFromStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserGroupsFromStructureMutation, { data, loading, error }] = useRemoveUserGroupsFromStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserGroupsFromStructureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserGroupsFromStructureMutation, RemoveUserGroupsFromStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserGroupsFromStructureMutation, RemoveUserGroupsFromStructureMutationVariables>(RemoveUserGroupsFromStructureDocument, options);
      }
export type RemoveUserGroupsFromStructureMutationHookResult = ReturnType<typeof useRemoveUserGroupsFromStructureMutation>;
export type RemoveUserGroupsFromStructureMutationResult = Apollo.MutationResult<RemoveUserGroupsFromStructureMutation>;
export type RemoveUserGroupsFromStructureMutationOptions = Apollo.BaseMutationOptions<RemoveUserGroupsFromStructureMutation, RemoveUserGroupsFromStructureMutationVariables>;
export const AddUserGroupsToStructureDocument = gql`
    mutation AddUserGroupsToStructure($input: AddRemoveStructuresToFromUserGroupsInput) {
  addUserGroupsToStructure(input: $input) {
    userGroups {
      id
      name
      userIds
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
    structures {
      id
      name
    }
  }
}
    `;
export type AddUserGroupsToStructureMutationFn = Apollo.MutationFunction<AddUserGroupsToStructureMutation, AddUserGroupsToStructureMutationVariables>;

/**
 * __useAddUserGroupsToStructureMutation__
 *
 * To run a mutation, you first call `useAddUserGroupsToStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserGroupsToStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserGroupsToStructureMutation, { data, loading, error }] = useAddUserGroupsToStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserGroupsToStructureMutation(baseOptions?: Apollo.MutationHookOptions<AddUserGroupsToStructureMutation, AddUserGroupsToStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserGroupsToStructureMutation, AddUserGroupsToStructureMutationVariables>(AddUserGroupsToStructureDocument, options);
      }
export type AddUserGroupsToStructureMutationHookResult = ReturnType<typeof useAddUserGroupsToStructureMutation>;
export type AddUserGroupsToStructureMutationResult = Apollo.MutationResult<AddUserGroupsToStructureMutation>;
export type AddUserGroupsToStructureMutationOptions = Apollo.BaseMutationOptions<AddUserGroupsToStructureMutation, AddUserGroupsToStructureMutationVariables>;
export const UsersByRoleIdDocument = gql`
    query UsersByRoleId($input: UsersByRoleInput, $pageInfo: PageInfo, $usersCountInput: FiltersForUsersCount) {
  usersCount(input: $usersCountInput) {
    count
  }
  usersByRoleId(input: $input, pageInfo: $pageInfo) {
    id
    email
    picture
    name
  }
}
    `;

/**
 * __useUsersByRoleIdQuery__
 *
 * To run a query within a React component, call `useUsersByRoleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersByRoleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersByRoleIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pageInfo: // value for 'pageInfo'
 *      usersCountInput: // value for 'usersCountInput'
 *   },
 * });
 */
export function useUsersByRoleIdQuery(baseOptions?: Apollo.QueryHookOptions<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>(UsersByRoleIdDocument, options);
      }
export function useUsersByRoleIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>(UsersByRoleIdDocument, options);
        }
export function useUsersByRoleIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>(UsersByRoleIdDocument, options);
        }
export type UsersByRoleIdQueryHookResult = ReturnType<typeof useUsersByRoleIdQuery>;
export type UsersByRoleIdLazyQueryHookResult = ReturnType<typeof useUsersByRoleIdLazyQuery>;
export type UsersByRoleIdSuspenseQueryHookResult = ReturnType<typeof useUsersByRoleIdSuspenseQuery>;
export type UsersByRoleIdQueryResult = Apollo.QueryResult<UsersByRoleIdQuery, UsersByRoleIdQueryVariables>;
export const RemoveRoleFromUsersDocument = gql`
    mutation RemoveRoleFromUsers($input: AssignRemoveRoleToFromUsersInput) {
  removeRoleFromUsers(input: $input) {
    id
    name
    auth0Id
    description
  }
}
    `;
export type RemoveRoleFromUsersMutationFn = Apollo.MutationFunction<RemoveRoleFromUsersMutation, RemoveRoleFromUsersMutationVariables>;

/**
 * __useRemoveRoleFromUsersMutation__
 *
 * To run a mutation, you first call `useRemoveRoleFromUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleFromUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleFromUsersMutation, { data, loading, error }] = useRemoveRoleFromUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveRoleFromUsersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoleFromUsersMutation, RemoveRoleFromUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoleFromUsersMutation, RemoveRoleFromUsersMutationVariables>(RemoveRoleFromUsersDocument, options);
      }
export type RemoveRoleFromUsersMutationHookResult = ReturnType<typeof useRemoveRoleFromUsersMutation>;
export type RemoveRoleFromUsersMutationResult = Apollo.MutationResult<RemoveRoleFromUsersMutation>;
export type RemoveRoleFromUsersMutationOptions = Apollo.BaseMutationOptions<RemoveRoleFromUsersMutation, RemoveRoleFromUsersMutationVariables>;
export const AssignRoleToUsersDocument = gql`
    mutation AssignRoleToUsers($input: AssignRemoveRoleToFromUsersInput) {
  assignRoleToUsers(input: $input) {
    id
    name
    auth0Id
    description
  }
}
    `;
export type AssignRoleToUsersMutationFn = Apollo.MutationFunction<AssignRoleToUsersMutation, AssignRoleToUsersMutationVariables>;

/**
 * __useAssignRoleToUsersMutation__
 *
 * To run a mutation, you first call `useAssignRoleToUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRoleToUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRoleToUsersMutation, { data, loading, error }] = useAssignRoleToUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRoleToUsersMutation(baseOptions?: Apollo.MutationHookOptions<AssignRoleToUsersMutation, AssignRoleToUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignRoleToUsersMutation, AssignRoleToUsersMutationVariables>(AssignRoleToUsersDocument, options);
      }
export type AssignRoleToUsersMutationHookResult = ReturnType<typeof useAssignRoleToUsersMutation>;
export type AssignRoleToUsersMutationResult = Apollo.MutationResult<AssignRoleToUsersMutation>;
export type AssignRoleToUsersMutationOptions = Apollo.BaseMutationOptions<AssignRoleToUsersMutation, AssignRoleToUsersMutationVariables>;
export const UserDetailsDocument = gql`
    query UserDetails($userId: ID) {
  userDetails(userId: $userId) {
    user {
      email
      picture
      name
      permissions
      connection
      loginCount
      roleIds {
        name
        auth0Id
        description
        permissions
      }
    }
    userGroups {
      name
    }
    structures {
      id
      name
      coverImagePath
      description
    }
  }
}
    `;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDetailsQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
      }
export function useUserDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export function useUserDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDetailsQuery, UserDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQueryHookResult = ReturnType<typeof useUserDetailsLazyQuery>;
export type UserDetailsSuspenseQueryHookResult = ReturnType<typeof useUserDetailsSuspenseQuery>;
export type UserDetailsQueryResult = Apollo.QueryResult<UserDetailsQuery, UserDetailsQueryVariables>;
export const GetDirectlyAssignedUserPermissionsDocument = gql`
    query GetDirectlyAssignedUserPermissions($userId: String!) {
  getDirectlyAssignedUserPermissions(userId: $userId) {
    description
    name
  }
}
    `;

/**
 * __useGetDirectlyAssignedUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetDirectlyAssignedUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectlyAssignedUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectlyAssignedUserPermissionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDirectlyAssignedUserPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables> & ({ variables: GetDirectlyAssignedUserPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>(GetDirectlyAssignedUserPermissionsDocument, options);
      }
export function useGetDirectlyAssignedUserPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>(GetDirectlyAssignedUserPermissionsDocument, options);
        }
export function useGetDirectlyAssignedUserPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>(GetDirectlyAssignedUserPermissionsDocument, options);
        }
export type GetDirectlyAssignedUserPermissionsQueryHookResult = ReturnType<typeof useGetDirectlyAssignedUserPermissionsQuery>;
export type GetDirectlyAssignedUserPermissionsLazyQueryHookResult = ReturnType<typeof useGetDirectlyAssignedUserPermissionsLazyQuery>;
export type GetDirectlyAssignedUserPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetDirectlyAssignedUserPermissionsSuspenseQuery>;
export type GetDirectlyAssignedUserPermissionsQueryResult = Apollo.QueryResult<GetDirectlyAssignedUserPermissionsQuery, GetDirectlyAssignedUserPermissionsQueryVariables>;
export const GetAuth0PermissionsDocument = gql`
    query GetAuth0Permissions {
  getAuth0Permissions {
    name
    description
  }
}
    `;

/**
 * __useGetAuth0PermissionsQuery__
 *
 * To run a query within a React component, call `useGetAuth0PermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuth0PermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuth0PermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuth0PermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>(GetAuth0PermissionsDocument, options);
      }
export function useGetAuth0PermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>(GetAuth0PermissionsDocument, options);
        }
export function useGetAuth0PermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>(GetAuth0PermissionsDocument, options);
        }
export type GetAuth0PermissionsQueryHookResult = ReturnType<typeof useGetAuth0PermissionsQuery>;
export type GetAuth0PermissionsLazyQueryHookResult = ReturnType<typeof useGetAuth0PermissionsLazyQuery>;
export type GetAuth0PermissionsSuspenseQueryHookResult = ReturnType<typeof useGetAuth0PermissionsSuspenseQuery>;
export type GetAuth0PermissionsQueryResult = Apollo.QueryResult<GetAuth0PermissionsQuery, GetAuth0PermissionsQueryVariables>;
export const GetUserPermissionsByRolesDocument = gql`
    query GetUserPermissionsByRoles($userId: String!) {
  getUserPermissionsByRoles(userId: $userId) {
    name
    permissions {
      name
      description
    }
    auth0Id
    description
  }
}
    `;

/**
 * __useGetUserPermissionsByRolesQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsByRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsByRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsByRolesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserPermissionsByRolesQuery(baseOptions: Apollo.QueryHookOptions<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables> & ({ variables: GetUserPermissionsByRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>(GetUserPermissionsByRolesDocument, options);
      }
export function useGetUserPermissionsByRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>(GetUserPermissionsByRolesDocument, options);
        }
export function useGetUserPermissionsByRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>(GetUserPermissionsByRolesDocument, options);
        }
export type GetUserPermissionsByRolesQueryHookResult = ReturnType<typeof useGetUserPermissionsByRolesQuery>;
export type GetUserPermissionsByRolesLazyQueryHookResult = ReturnType<typeof useGetUserPermissionsByRolesLazyQuery>;
export type GetUserPermissionsByRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserPermissionsByRolesSuspenseQuery>;
export type GetUserPermissionsByRolesQueryResult = Apollo.QueryResult<GetUserPermissionsByRolesQuery, GetUserPermissionsByRolesQueryVariables>;
export const PermissionsByRoleDocument = gql`
    query PermissionsByRole($roleId: String!) {
  permissionsByRole(roleId: $roleId) {
    key
    description
  }
}
    `;

/**
 * __usePermissionsByRoleQuery__
 *
 * To run a query within a React component, call `usePermissionsByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsByRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsByRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function usePermissionsByRoleQuery(baseOptions: Apollo.QueryHookOptions<PermissionsByRoleQuery, PermissionsByRoleQueryVariables> & ({ variables: PermissionsByRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>(PermissionsByRoleDocument, options);
      }
export function usePermissionsByRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>(PermissionsByRoleDocument, options);
        }
export function usePermissionsByRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>(PermissionsByRoleDocument, options);
        }
export type PermissionsByRoleQueryHookResult = ReturnType<typeof usePermissionsByRoleQuery>;
export type PermissionsByRoleLazyQueryHookResult = ReturnType<typeof usePermissionsByRoleLazyQuery>;
export type PermissionsByRoleSuspenseQueryHookResult = ReturnType<typeof usePermissionsByRoleSuspenseQuery>;
export type PermissionsByRoleQueryResult = Apollo.QueryResult<PermissionsByRoleQuery, PermissionsByRoleQueryVariables>;
export const DeleteUserGroupDocument = gql`
    mutation DeleteUserGroup($input: DeleteUserGroupInput) {
  deleteUserGroup(input: $input) {
    id
    name
    userIds
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type DeleteUserGroupMutationFn = Apollo.MutationFunction<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;

/**
 * __useDeleteUserGroupMutation__
 *
 * To run a mutation, you first call `useDeleteUserGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserGroupMutation, { data, loading, error }] = useDeleteUserGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>(DeleteUserGroupDocument, options);
      }
export type DeleteUserGroupMutationHookResult = ReturnType<typeof useDeleteUserGroupMutation>;
export type DeleteUserGroupMutationResult = Apollo.MutationResult<DeleteUserGroupMutation>;
export type DeleteUserGroupMutationOptions = Apollo.BaseMutationOptions<DeleteUserGroupMutation, DeleteUserGroupMutationVariables>;
export const GetUserAbilitiesDocument = gql`
    query GetUserAbilities {
  getUserAbilities
}
    `;

/**
 * __useGetUserAbilitiesQuery__
 *
 * To run a query within a React component, call `useGetUserAbilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAbilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAbilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserAbilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>(GetUserAbilitiesDocument, options);
      }
export function useGetUserAbilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>(GetUserAbilitiesDocument, options);
        }
export function useGetUserAbilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>(GetUserAbilitiesDocument, options);
        }
export type GetUserAbilitiesQueryHookResult = ReturnType<typeof useGetUserAbilitiesQuery>;
export type GetUserAbilitiesLazyQueryHookResult = ReturnType<typeof useGetUserAbilitiesLazyQuery>;
export type GetUserAbilitiesSuspenseQueryHookResult = ReturnType<typeof useGetUserAbilitiesSuspenseQuery>;
export type GetUserAbilitiesQueryResult = Apollo.QueryResult<GetUserAbilitiesQuery, GetUserAbilitiesQueryVariables>;
export const UpdateWorkflowStatusDocument = gql`
    mutation UpdateWorkflowStatus($input: UpdateWorkflowStatusInput) {
  updateWorkflowStatus(input: $input) {
    workflowStatus {
      workflowStageId
      state
      difficultyLevel
      totalTime
      idleTime
      trackedTime
      pausedBy
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
    id
    name
  }
}
    `;
export type UpdateWorkflowStatusMutationFn = Apollo.MutationFunction<UpdateWorkflowStatusMutation, UpdateWorkflowStatusMutationVariables>;

/**
 * __useUpdateWorkflowStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowStatusMutation, { data, loading, error }] = useUpdateWorkflowStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowStatusMutation, UpdateWorkflowStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowStatusMutation, UpdateWorkflowStatusMutationVariables>(UpdateWorkflowStatusDocument, options);
      }
export type UpdateWorkflowStatusMutationHookResult = ReturnType<typeof useUpdateWorkflowStatusMutation>;
export type UpdateWorkflowStatusMutationResult = Apollo.MutationResult<UpdateWorkflowStatusMutation>;
export type UpdateWorkflowStatusMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowStatusMutation, UpdateWorkflowStatusMutationVariables>;
export const WorkFlowTimeUpdatedDocument = gql`
    subscription WorkFlowTimeUpdated($structureId: ID, $zoneId: ID) {
  workFlowTimeUpdated(structureId: $structureId, zoneId: $zoneId) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    status
    structureId
    workflowStatus {
      workflowStageId
      state
      totalTime
      idleTime
      pausedBy
      trackedTime
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useWorkFlowTimeUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorkFlowTimeUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkFlowTimeUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkFlowTimeUpdatedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useWorkFlowTimeUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WorkFlowTimeUpdatedSubscription, WorkFlowTimeUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkFlowTimeUpdatedSubscription, WorkFlowTimeUpdatedSubscriptionVariables>(WorkFlowTimeUpdatedDocument, options);
      }
export type WorkFlowTimeUpdatedSubscriptionHookResult = ReturnType<typeof useWorkFlowTimeUpdatedSubscription>;
export type WorkFlowTimeUpdatedSubscriptionResult = Apollo.SubscriptionResult<WorkFlowTimeUpdatedSubscription>;
export const WorkflowStagesDocument = gql`
    query WorkflowStages($structureId: String) {
  structure(structureId: $structureId) {
    workflowStages {
      id
      name
      orderInWorkflow
      stageType
    }
  }
}
    `;

/**
 * __useWorkflowStagesQuery__
 *
 * To run a query within a React component, call `useWorkflowStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowStagesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useWorkflowStagesQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowStagesQuery, WorkflowStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowStagesQuery, WorkflowStagesQueryVariables>(WorkflowStagesDocument, options);
      }
export function useWorkflowStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowStagesQuery, WorkflowStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowStagesQuery, WorkflowStagesQueryVariables>(WorkflowStagesDocument, options);
        }
export function useWorkflowStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowStagesQuery, WorkflowStagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowStagesQuery, WorkflowStagesQueryVariables>(WorkflowStagesDocument, options);
        }
export type WorkflowStagesQueryHookResult = ReturnType<typeof useWorkflowStagesQuery>;
export type WorkflowStagesLazyQueryHookResult = ReturnType<typeof useWorkflowStagesLazyQuery>;
export type WorkflowStagesSuspenseQueryHookResult = ReturnType<typeof useWorkflowStagesSuspenseQuery>;
export type WorkflowStagesQueryResult = Apollo.QueryResult<WorkflowStagesQuery, WorkflowStagesQueryVariables>;
export const DeleteWorkflowStageDocument = gql`
    mutation DeleteWorkflowStage($input: DeleteWorkflowStageInput) {
  deleteWorkflowStage(input: $input) {
    workflowStages {
      id
    }
  }
}
    `;
export type DeleteWorkflowStageMutationFn = Apollo.MutationFunction<DeleteWorkflowStageMutation, DeleteWorkflowStageMutationVariables>;

/**
 * __useDeleteWorkflowStageMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowStageMutation, { data, loading, error }] = useDeleteWorkflowStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWorkflowStageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkflowStageMutation, DeleteWorkflowStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkflowStageMutation, DeleteWorkflowStageMutationVariables>(DeleteWorkflowStageDocument, options);
      }
export type DeleteWorkflowStageMutationHookResult = ReturnType<typeof useDeleteWorkflowStageMutation>;
export type DeleteWorkflowStageMutationResult = Apollo.MutationResult<DeleteWorkflowStageMutation>;
export type DeleteWorkflowStageMutationOptions = Apollo.BaseMutationOptions<DeleteWorkflowStageMutation, DeleteWorkflowStageMutationVariables>;
export const UpdateZoneWorkFlowStatusDocument = gql`
    mutation UpdateZoneWorkFlowStatus($input: UpdateWorkflowStatusInput) {
  updateWorkflowStatus(input: $input) {
    name
  }
}
    `;
export type UpdateZoneWorkFlowStatusMutationFn = Apollo.MutationFunction<UpdateZoneWorkFlowStatusMutation, UpdateZoneWorkFlowStatusMutationVariables>;

/**
 * __useUpdateZoneWorkFlowStatusMutation__
 *
 * To run a mutation, you first call `useUpdateZoneWorkFlowStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneWorkFlowStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneWorkFlowStatusMutation, { data, loading, error }] = useUpdateZoneWorkFlowStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateZoneWorkFlowStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZoneWorkFlowStatusMutation, UpdateZoneWorkFlowStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZoneWorkFlowStatusMutation, UpdateZoneWorkFlowStatusMutationVariables>(UpdateZoneWorkFlowStatusDocument, options);
      }
export type UpdateZoneWorkFlowStatusMutationHookResult = ReturnType<typeof useUpdateZoneWorkFlowStatusMutation>;
export type UpdateZoneWorkFlowStatusMutationResult = Apollo.MutationResult<UpdateZoneWorkFlowStatusMutation>;
export type UpdateZoneWorkFlowStatusMutationOptions = Apollo.BaseMutationOptions<UpdateZoneWorkFlowStatusMutation, UpdateZoneWorkFlowStatusMutationVariables>;
export const ZonesPerStatusCountDocument = gql`
    query ZonesPerStatusCount($structureId: String, $searchTerm: String) {
  zonesPerStatusCount(structureId: $structureId, searchTerm: $searchTerm) {
    status
    count
  }
}
    `;

/**
 * __useZonesPerStatusCountQuery__
 *
 * To run a query within a React component, call `useZonesPerStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesPerStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesPerStatusCountQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useZonesPerStatusCountQuery(baseOptions?: Apollo.QueryHookOptions<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>(ZonesPerStatusCountDocument, options);
      }
export function useZonesPerStatusCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>(ZonesPerStatusCountDocument, options);
        }
export function useZonesPerStatusCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>(ZonesPerStatusCountDocument, options);
        }
export type ZonesPerStatusCountQueryHookResult = ReturnType<typeof useZonesPerStatusCountQuery>;
export type ZonesPerStatusCountLazyQueryHookResult = ReturnType<typeof useZonesPerStatusCountLazyQuery>;
export type ZonesPerStatusCountSuspenseQueryHookResult = ReturnType<typeof useZonesPerStatusCountSuspenseQuery>;
export type ZonesPerStatusCountQueryResult = Apollo.QueryResult<ZonesPerStatusCountQuery, ZonesPerStatusCountQueryVariables>;
export const WorkflowStagesAndZonesDocument = gql`
    query WorkflowStagesAndZones($structureId: String, $searchTerm: String) {
  structure(structureId: $structureId) {
    workflowStages {
      id
      name
      orderInWorkflow
      stageType
    }
  }
  zonesForStructure(structureId: $structureId, searchTerm: $searchTerm) {
    id
    name
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    status
    structureId
    workflowStatus {
      workflowStageId
      pausedBy
      state
      difficultyLevel
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useWorkflowStagesAndZonesQuery__
 *
 * To run a query within a React component, call `useWorkflowStagesAndZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowStagesAndZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowStagesAndZonesQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useWorkflowStagesAndZonesQuery(baseOptions?: Apollo.QueryHookOptions<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>(WorkflowStagesAndZonesDocument, options);
      }
export function useWorkflowStagesAndZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>(WorkflowStagesAndZonesDocument, options);
        }
export function useWorkflowStagesAndZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>(WorkflowStagesAndZonesDocument, options);
        }
export type WorkflowStagesAndZonesQueryHookResult = ReturnType<typeof useWorkflowStagesAndZonesQuery>;
export type WorkflowStagesAndZonesLazyQueryHookResult = ReturnType<typeof useWorkflowStagesAndZonesLazyQuery>;
export type WorkflowStagesAndZonesSuspenseQueryHookResult = ReturnType<typeof useWorkflowStagesAndZonesSuspenseQuery>;
export type WorkflowStagesAndZonesQueryResult = Apollo.QueryResult<WorkflowStagesAndZonesQuery, WorkflowStagesAndZonesQueryVariables>;
export const CreateWorkflowStageDocument = gql`
    mutation CreateWorkflowStage($input: CreateWorkflowStageInput) {
  createWorkflowStage(input: $input) {
    workflowStages {
      id
      name
      orderInWorkflow
      stageType
    }
  }
}
    `;
export type CreateWorkflowStageMutationFn = Apollo.MutationFunction<CreateWorkflowStageMutation, CreateWorkflowStageMutationVariables>;

/**
 * __useCreateWorkflowStageMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowStageMutation, { data, loading, error }] = useCreateWorkflowStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowStageMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowStageMutation, CreateWorkflowStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowStageMutation, CreateWorkflowStageMutationVariables>(CreateWorkflowStageDocument, options);
      }
export type CreateWorkflowStageMutationHookResult = ReturnType<typeof useCreateWorkflowStageMutation>;
export type CreateWorkflowStageMutationResult = Apollo.MutationResult<CreateWorkflowStageMutation>;
export type CreateWorkflowStageMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowStageMutation, CreateWorkflowStageMutationVariables>;
export const UpdateWorkflowStageDocument = gql`
    mutation UpdateWorkflowStage($input: UpdateWorkflowStageInput) {
  updateWorkflowStage(input: $input) {
    workflowStages {
      id
      name
      orderInWorkflow
      stageType
    }
  }
}
    `;
export type UpdateWorkflowStageMutationFn = Apollo.MutationFunction<UpdateWorkflowStageMutation, UpdateWorkflowStageMutationVariables>;

/**
 * __useUpdateWorkflowStageMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowStageMutation, { data, loading, error }] = useUpdateWorkflowStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowStageMutation, UpdateWorkflowStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowStageMutation, UpdateWorkflowStageMutationVariables>(UpdateWorkflowStageDocument, options);
      }
export type UpdateWorkflowStageMutationHookResult = ReturnType<typeof useUpdateWorkflowStageMutation>;
export type UpdateWorkflowStageMutationResult = Apollo.MutationResult<UpdateWorkflowStageMutation>;
export type UpdateWorkflowStageMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowStageMutation, UpdateWorkflowStageMutationVariables>;
export const ZonesForStructureDocument = gql`
    query zonesForStructure($structureId: String) {
  zonesForStructure(structureId: $structureId) {
    id
    name
    status
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    structureId
    totalParts
    totalPoints
    totalSphericals
    workflowStatus {
      workflowStageId
      state
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useZonesForStructureQuery__
 *
 * To run a query within a React component, call `useZonesForStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesForStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesForStructureQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZonesForStructureQuery(baseOptions?: Apollo.QueryHookOptions<ZonesForStructureQuery, ZonesForStructureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesForStructureQuery, ZonesForStructureQueryVariables>(ZonesForStructureDocument, options);
      }
export function useZonesForStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesForStructureQuery, ZonesForStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesForStructureQuery, ZonesForStructureQueryVariables>(ZonesForStructureDocument, options);
        }
export function useZonesForStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureQuery, ZonesForStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesForStructureQuery, ZonesForStructureQueryVariables>(ZonesForStructureDocument, options);
        }
export type ZonesForStructureQueryHookResult = ReturnType<typeof useZonesForStructureQuery>;
export type ZonesForStructureLazyQueryHookResult = ReturnType<typeof useZonesForStructureLazyQuery>;
export type ZonesForStructureSuspenseQueryHookResult = ReturnType<typeof useZonesForStructureSuspenseQuery>;
export type ZonesForStructureQueryResult = Apollo.QueryResult<ZonesForStructureQuery, ZonesForStructureQueryVariables>;
export const ZoneAndHistoriesForZoneManagementDocument = gql`
    query zoneAndHistoriesForZoneManagement($structureId: String) {
  zonesAndHistoriesFor(structureId: $structureId) {
    _id
    name
    status
    histories {
      id
      createdBy
      eventName
      document
      collectionName
      createdAt
      createdByName
      createdByDetails {
        name
        profilePicture
      }
    }
    box {
      min {
        x
        y
        z
      }
      max {
        x
        y
        z
      }
    }
    structureId
    totalParts
    totalPoints
    totalSphericals
    workflowStatus {
      workflowStageId
      state
      pausedBy
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;

/**
 * __useZoneAndHistoriesForZoneManagementQuery__
 *
 * To run a query within a React component, call `useZoneAndHistoriesForZoneManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoneAndHistoriesForZoneManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoneAndHistoriesForZoneManagementQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZoneAndHistoriesForZoneManagementQuery(baseOptions?: Apollo.QueryHookOptions<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>(ZoneAndHistoriesForZoneManagementDocument, options);
      }
export function useZoneAndHistoriesForZoneManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>(ZoneAndHistoriesForZoneManagementDocument, options);
        }
export function useZoneAndHistoriesForZoneManagementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>(ZoneAndHistoriesForZoneManagementDocument, options);
        }
export type ZoneAndHistoriesForZoneManagementQueryHookResult = ReturnType<typeof useZoneAndHistoriesForZoneManagementQuery>;
export type ZoneAndHistoriesForZoneManagementLazyQueryHookResult = ReturnType<typeof useZoneAndHistoriesForZoneManagementLazyQuery>;
export type ZoneAndHistoriesForZoneManagementSuspenseQueryHookResult = ReturnType<typeof useZoneAndHistoriesForZoneManagementSuspenseQuery>;
export type ZoneAndHistoriesForZoneManagementQueryResult = Apollo.QueryResult<ZoneAndHistoriesForZoneManagementQuery, ZoneAndHistoriesForZoneManagementQueryVariables>;
export const UpdateZoneStatusDocument = gql`
    mutation UpdateZoneStatus($input: UpdateZoneStatusInput) {
  updateZoneStatus(input: $input) {
    createdBy
    currentStatus
    prevStatus
    referenceId
  }
}
    `;
export type UpdateZoneStatusMutationFn = Apollo.MutationFunction<UpdateZoneStatusMutation, UpdateZoneStatusMutationVariables>;

/**
 * __useUpdateZoneStatusMutation__
 *
 * To run a mutation, you first call `useUpdateZoneStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateZoneStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateZoneStatusMutation, { data, loading, error }] = useUpdateZoneStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateZoneStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateZoneStatusMutation, UpdateZoneStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateZoneStatusMutation, UpdateZoneStatusMutationVariables>(UpdateZoneStatusDocument, options);
      }
export type UpdateZoneStatusMutationHookResult = ReturnType<typeof useUpdateZoneStatusMutation>;
export type UpdateZoneStatusMutationResult = Apollo.MutationResult<UpdateZoneStatusMutation>;
export type UpdateZoneStatusMutationOptions = Apollo.BaseMutationOptions<UpdateZoneStatusMutation, UpdateZoneStatusMutationVariables>;
export const UpdateWorkflowTimeAndStateDocument = gql`
    mutation UpdateWorkflowTimeAndState($input: UpdateWorkflowTimeAndStateInput) {
  updateWorkflowTimeAndState(input: $input) {
    workflowStatus {
      workflowStageId
      state
      difficultyLevel
      totalTime
      idleTime
      trackedTime
      assignedToUser {
        id
        name
        email
        picture
        roleIds {
          name
          auth0Id
          id
        }
      }
    }
  }
}
    `;
export type UpdateWorkflowTimeAndStateMutationFn = Apollo.MutationFunction<UpdateWorkflowTimeAndStateMutation, UpdateWorkflowTimeAndStateMutationVariables>;

/**
 * __useUpdateWorkflowTimeAndStateMutation__
 *
 * To run a mutation, you first call `useUpdateWorkflowTimeAndStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowTimeAndStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowTimeAndStateMutation, { data, loading, error }] = useUpdateWorkflowTimeAndStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkflowTimeAndStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowTimeAndStateMutation, UpdateWorkflowTimeAndStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowTimeAndStateMutation, UpdateWorkflowTimeAndStateMutationVariables>(UpdateWorkflowTimeAndStateDocument, options);
      }
export type UpdateWorkflowTimeAndStateMutationHookResult = ReturnType<typeof useUpdateWorkflowTimeAndStateMutation>;
export type UpdateWorkflowTimeAndStateMutationResult = Apollo.MutationResult<UpdateWorkflowTimeAndStateMutation>;
export type UpdateWorkflowTimeAndStateMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowTimeAndStateMutation, UpdateWorkflowTimeAndStateMutationVariables>;
export const ZonesForStructureCsvDocument = gql`
    query ZonesForStructureCSV($structureId: String) {
  zonesForStructureCSV(structureId: $structureId)
}
    `;

/**
 * __useZonesForStructureCsvQuery__
 *
 * To run a query within a React component, call `useZonesForStructureCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useZonesForStructureCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZonesForStructureCsvQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useZonesForStructureCsvQuery(baseOptions?: Apollo.QueryHookOptions<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>(ZonesForStructureCsvDocument, options);
      }
export function useZonesForStructureCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>(ZonesForStructureCsvDocument, options);
        }
export function useZonesForStructureCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>(ZonesForStructureCsvDocument, options);
        }
export type ZonesForStructureCsvQueryHookResult = ReturnType<typeof useZonesForStructureCsvQuery>;
export type ZonesForStructureCsvLazyQueryHookResult = ReturnType<typeof useZonesForStructureCsvLazyQuery>;
export type ZonesForStructureCsvSuspenseQueryHookResult = ReturnType<typeof useZonesForStructureCsvSuspenseQuery>;
export type ZonesForStructureCsvQueryResult = Apollo.QueryResult<ZonesForStructureCsvQuery, ZonesForStructureCsvQueryVariables>;
export const SphericalsPerZoneDocument = gql`
    query SphericalsPerZone($structureId: String) {
  sphericalsPerZone(structureId: $structureId) {
    totalSphericals
    zoneId
  }
}
    `;

/**
 * __useSphericalsPerZoneQuery__
 *
 * To run a query within a React component, call `useSphericalsPerZoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSphericalsPerZoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSphericalsPerZoneQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useSphericalsPerZoneQuery(baseOptions?: Apollo.QueryHookOptions<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>(SphericalsPerZoneDocument, options);
      }
export function useSphericalsPerZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>(SphericalsPerZoneDocument, options);
        }
export function useSphericalsPerZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>(SphericalsPerZoneDocument, options);
        }
export type SphericalsPerZoneQueryHookResult = ReturnType<typeof useSphericalsPerZoneQuery>;
export type SphericalsPerZoneLazyQueryHookResult = ReturnType<typeof useSphericalsPerZoneLazyQuery>;
export type SphericalsPerZoneSuspenseQueryHookResult = ReturnType<typeof useSphericalsPerZoneSuspenseQuery>;
export type SphericalsPerZoneQueryResult = Apollo.QueryResult<SphericalsPerZoneQuery, SphericalsPerZoneQueryVariables>;
export const AllUsersForZonesDocument = gql`
    query AllUsersForZones($pageInfo: PageInfo, $input: FilterForUsers) {
  allUsers(pageInfo: $pageInfo, input: $input) {
    id
    email
    picture
    name
    roleIds {
      id
      name
    }
  }
}
    `;

/**
 * __useAllUsersForZonesQuery__
 *
 * To run a query within a React component, call `useAllUsersForZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersForZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersForZonesQuery({
 *   variables: {
 *      pageInfo: // value for 'pageInfo'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllUsersForZonesQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>(AllUsersForZonesDocument, options);
      }
export function useAllUsersForZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>(AllUsersForZonesDocument, options);
        }
export function useAllUsersForZonesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>(AllUsersForZonesDocument, options);
        }
export type AllUsersForZonesQueryHookResult = ReturnType<typeof useAllUsersForZonesQuery>;
export type AllUsersForZonesLazyQueryHookResult = ReturnType<typeof useAllUsersForZonesLazyQuery>;
export type AllUsersForZonesSuspenseQueryHookResult = ReturnType<typeof useAllUsersForZonesSuspenseQuery>;
export type AllUsersForZonesQueryResult = Apollo.QueryResult<AllUsersForZonesQuery, AllUsersForZonesQueryVariables>;
export const AssignZoneToUserDocument = gql`
    mutation AssignZoneToUser($input: UpdateWorkflowStatusInput) {
  updateWorkflowStatus(input: $input) {
    id
  }
}
    `;
export type AssignZoneToUserMutationFn = Apollo.MutationFunction<AssignZoneToUserMutation, AssignZoneToUserMutationVariables>;

/**
 * __useAssignZoneToUserMutation__
 *
 * To run a mutation, you first call `useAssignZoneToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignZoneToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignZoneToUserMutation, { data, loading, error }] = useAssignZoneToUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignZoneToUserMutation(baseOptions?: Apollo.MutationHookOptions<AssignZoneToUserMutation, AssignZoneToUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignZoneToUserMutation, AssignZoneToUserMutationVariables>(AssignZoneToUserDocument, options);
      }
export type AssignZoneToUserMutationHookResult = ReturnType<typeof useAssignZoneToUserMutation>;
export type AssignZoneToUserMutationResult = Apollo.MutationResult<AssignZoneToUserMutation>;
export type AssignZoneToUserMutationOptions = Apollo.BaseMutationOptions<AssignZoneToUserMutation, AssignZoneToUserMutationVariables>;
export const GetAssemblyServiceAndPipeSpecDocument = gql`
    query getAssemblyServiceAndPipeSpec($assemblyId: String) {
  assembly(assemblyId: $assemblyId) {
    id
    service {
      group
      code
    }
    pipeSpec {
      spec
    }
  }
}
    `;

/**
 * __useGetAssemblyServiceAndPipeSpecQuery__
 *
 * To run a query within a React component, call `useGetAssemblyServiceAndPipeSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyServiceAndPipeSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssemblyServiceAndPipeSpecQuery({
 *   variables: {
 *      assemblyId: // value for 'assemblyId'
 *   },
 * });
 */
export function useGetAssemblyServiceAndPipeSpecQuery(baseOptions?: Apollo.QueryHookOptions<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>(GetAssemblyServiceAndPipeSpecDocument, options);
      }
export function useGetAssemblyServiceAndPipeSpecLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>(GetAssemblyServiceAndPipeSpecDocument, options);
        }
export function useGetAssemblyServiceAndPipeSpecSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>(GetAssemblyServiceAndPipeSpecDocument, options);
        }
export type GetAssemblyServiceAndPipeSpecQueryHookResult = ReturnType<typeof useGetAssemblyServiceAndPipeSpecQuery>;
export type GetAssemblyServiceAndPipeSpecLazyQueryHookResult = ReturnType<typeof useGetAssemblyServiceAndPipeSpecLazyQuery>;
export type GetAssemblyServiceAndPipeSpecSuspenseQueryHookResult = ReturnType<typeof useGetAssemblyServiceAndPipeSpecSuspenseQuery>;
export type GetAssemblyServiceAndPipeSpecQueryResult = Apollo.QueryResult<GetAssemblyServiceAndPipeSpecQuery, GetAssemblyServiceAndPipeSpecQueryVariables>;
export const GetStructureNameDocument = gql`
    query getStructureName($structureId: String!) {
  structure(structureId: $structureId) {
    id
    name
  }
}
    `;

/**
 * __useGetStructureNameQuery__
 *
 * To run a query within a React component, call `useGetStructureNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStructureNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStructureNameQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useGetStructureNameQuery(baseOptions: Apollo.QueryHookOptions<GetStructureNameQuery, GetStructureNameQueryVariables> & ({ variables: GetStructureNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStructureNameQuery, GetStructureNameQueryVariables>(GetStructureNameDocument, options);
      }
export function useGetStructureNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStructureNameQuery, GetStructureNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStructureNameQuery, GetStructureNameQueryVariables>(GetStructureNameDocument, options);
        }
export function useGetStructureNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStructureNameQuery, GetStructureNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStructureNameQuery, GetStructureNameQueryVariables>(GetStructureNameDocument, options);
        }
export type GetStructureNameQueryHookResult = ReturnType<typeof useGetStructureNameQuery>;
export type GetStructureNameLazyQueryHookResult = ReturnType<typeof useGetStructureNameLazyQuery>;
export type GetStructureNameSuspenseQueryHookResult = ReturnType<typeof useGetStructureNameSuspenseQuery>;
export type GetStructureNameQueryResult = Apollo.QueryResult<GetStructureNameQuery, GetStructureNameQueryVariables>;
export const GetAllStructuresListForBreadcrumbDocument = gql`
    query getAllStructuresListForBreadcrumb {
  allStructures {
    id
    name
    status
  }
}
    `;

/**
 * __useGetAllStructuresListForBreadcrumbQuery__
 *
 * To run a query within a React component, call `useGetAllStructuresListForBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStructuresListForBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStructuresListForBreadcrumbQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStructuresListForBreadcrumbQuery(baseOptions?: Apollo.QueryHookOptions<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>(GetAllStructuresListForBreadcrumbDocument, options);
      }
export function useGetAllStructuresListForBreadcrumbLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>(GetAllStructuresListForBreadcrumbDocument, options);
        }
export function useGetAllStructuresListForBreadcrumbSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>(GetAllStructuresListForBreadcrumbDocument, options);
        }
export type GetAllStructuresListForBreadcrumbQueryHookResult = ReturnType<typeof useGetAllStructuresListForBreadcrumbQuery>;
export type GetAllStructuresListForBreadcrumbLazyQueryHookResult = ReturnType<typeof useGetAllStructuresListForBreadcrumbLazyQuery>;
export type GetAllStructuresListForBreadcrumbSuspenseQueryHookResult = ReturnType<typeof useGetAllStructuresListForBreadcrumbSuspenseQuery>;
export type GetAllStructuresListForBreadcrumbQueryResult = Apollo.QueryResult<GetAllStructuresListForBreadcrumbQuery, GetAllStructuresListForBreadcrumbQueryVariables>;
export const AllCommentsGenericDocument = gql`
    query AllCommentsGeneric($input: AllCommentsInput) {
  allComments(input: $input) {
    id
    text
    isEdited
    status
    updatedAt
    structureId
    createdByDetails {
      name
      profilePicture
    }
    createdBy
    createdAt
    collectionName
  }
}
    `;

/**
 * __useAllCommentsGenericQuery__
 *
 * To run a query within a React component, call `useAllCommentsGenericQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCommentsGenericQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCommentsGenericQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllCommentsGenericQuery(baseOptions?: Apollo.QueryHookOptions<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>(AllCommentsGenericDocument, options);
      }
export function useAllCommentsGenericLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>(AllCommentsGenericDocument, options);
        }
export function useAllCommentsGenericSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>(AllCommentsGenericDocument, options);
        }
export type AllCommentsGenericQueryHookResult = ReturnType<typeof useAllCommentsGenericQuery>;
export type AllCommentsGenericLazyQueryHookResult = ReturnType<typeof useAllCommentsGenericLazyQuery>;
export type AllCommentsGenericSuspenseQueryHookResult = ReturnType<typeof useAllCommentsGenericSuspenseQuery>;
export type AllCommentsGenericQueryResult = Apollo.QueryResult<AllCommentsGenericQuery, AllCommentsGenericQueryVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    text
    structureId
    createdByDetails {
      name
      profilePicture
    }
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($structureId: ID, $commentId: ID) {
  deleteComment(structureId: $structureId, commentId: $commentId) {
    id
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const CommentAddedDocument = gql`
    subscription CommentAdded($structureId: ID, $referenceId: ID) {
  commentAdded(structureId: $structureId, referenceId: $referenceId) {
    id
    text
    isEdited
    status
    updatedAt
    structureId
    createdByDetails {
      name
      profilePicture
    }
    createdBy
    createdAt
    collectionName
  }
}
    `;

/**
 * __useCommentAddedSubscription__
 *
 * To run a query within a React component, call `useCommentAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentAddedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useCommentAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CommentAddedSubscription, CommentAddedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommentAddedSubscription, CommentAddedSubscriptionVariables>(CommentAddedDocument, options);
      }
export type CommentAddedSubscriptionHookResult = ReturnType<typeof useCommentAddedSubscription>;
export type CommentAddedSubscriptionResult = Apollo.SubscriptionResult<CommentAddedSubscription>;
export const CommentDeletedDocument = gql`
    subscription CommentDeleted($structureId: ID, $referenceId: ID) {
  commentDeleted(structureId: $structureId, referenceId: $referenceId) {
    id
  }
}
    `;

/**
 * __useCommentDeletedSubscription__
 *
 * To run a query within a React component, call `useCommentDeletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCommentDeletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentDeletedSubscription({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useCommentDeletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CommentDeletedSubscription, CommentDeletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CommentDeletedSubscription, CommentDeletedSubscriptionVariables>(CommentDeletedDocument, options);
      }
export type CommentDeletedSubscriptionHookResult = ReturnType<typeof useCommentDeletedSubscription>;
export type CommentDeletedSubscriptionResult = Apollo.SubscriptionResult<CommentDeletedSubscription>;
export const DecksForDeckListDocument = gql`
    query DecksForDeckList($structureId: ID) {
  allDecks(structureId: $structureId) {
    id
    name
    resourcePath
    heightRange
    heightStep
  }
}
    `;

/**
 * __useDecksForDeckListQuery__
 *
 * To run a query within a React component, call `useDecksForDeckListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDecksForDeckListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDecksForDeckListQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useDecksForDeckListQuery(baseOptions?: Apollo.QueryHookOptions<DecksForDeckListQuery, DecksForDeckListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DecksForDeckListQuery, DecksForDeckListQueryVariables>(DecksForDeckListDocument, options);
      }
export function useDecksForDeckListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DecksForDeckListQuery, DecksForDeckListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DecksForDeckListQuery, DecksForDeckListQueryVariables>(DecksForDeckListDocument, options);
        }
export function useDecksForDeckListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DecksForDeckListQuery, DecksForDeckListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DecksForDeckListQuery, DecksForDeckListQueryVariables>(DecksForDeckListDocument, options);
        }
export type DecksForDeckListQueryHookResult = ReturnType<typeof useDecksForDeckListQuery>;
export type DecksForDeckListLazyQueryHookResult = ReturnType<typeof useDecksForDeckListLazyQuery>;
export type DecksForDeckListSuspenseQueryHookResult = ReturnType<typeof useDecksForDeckListSuspenseQuery>;
export type DecksForDeckListQueryResult = Apollo.QueryResult<DecksForDeckListQuery, DecksForDeckListQueryVariables>;
export const GetActiveDeploymentForPlatformDocument = gql`
    query getActiveDeploymentForPlatform($input: StructureFilters!) {
  allStructures(input: $input) {
    id
    name
    isActive
    platform {
      id
    }
  }
}
    `;

/**
 * __useGetActiveDeploymentForPlatformQuery__
 *
 * To run a query within a React component, call `useGetActiveDeploymentForPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveDeploymentForPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveDeploymentForPlatformQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetActiveDeploymentForPlatformQuery(baseOptions: Apollo.QueryHookOptions<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables> & ({ variables: GetActiveDeploymentForPlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>(GetActiveDeploymentForPlatformDocument, options);
      }
export function useGetActiveDeploymentForPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>(GetActiveDeploymentForPlatformDocument, options);
        }
export function useGetActiveDeploymentForPlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>(GetActiveDeploymentForPlatformDocument, options);
        }
export type GetActiveDeploymentForPlatformQueryHookResult = ReturnType<typeof useGetActiveDeploymentForPlatformQuery>;
export type GetActiveDeploymentForPlatformLazyQueryHookResult = ReturnType<typeof useGetActiveDeploymentForPlatformLazyQuery>;
export type GetActiveDeploymentForPlatformSuspenseQueryHookResult = ReturnType<typeof useGetActiveDeploymentForPlatformSuspenseQuery>;
export type GetActiveDeploymentForPlatformQueryResult = Apollo.QueryResult<GetActiveDeploymentForPlatformQuery, GetActiveDeploymentForPlatformQueryVariables>;
export const GetUserPreferencesForUnitSelectionDocument = gql`
    query GetUserPreferencesForUnitSelection {
  getUserPreferences {
    unit
  }
}
    `;

/**
 * __useGetUserPreferencesForUnitSelectionQuery__
 *
 * To run a query within a React component, call `useGetUserPreferencesForUnitSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferencesForUnitSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferencesForUnitSelectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPreferencesForUnitSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>(GetUserPreferencesForUnitSelectionDocument, options);
      }
export function useGetUserPreferencesForUnitSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>(GetUserPreferencesForUnitSelectionDocument, options);
        }
export function useGetUserPreferencesForUnitSelectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>(GetUserPreferencesForUnitSelectionDocument, options);
        }
export type GetUserPreferencesForUnitSelectionQueryHookResult = ReturnType<typeof useGetUserPreferencesForUnitSelectionQuery>;
export type GetUserPreferencesForUnitSelectionLazyQueryHookResult = ReturnType<typeof useGetUserPreferencesForUnitSelectionLazyQuery>;
export type GetUserPreferencesForUnitSelectionSuspenseQueryHookResult = ReturnType<typeof useGetUserPreferencesForUnitSelectionSuspenseQuery>;
export type GetUserPreferencesForUnitSelectionQueryResult = Apollo.QueryResult<GetUserPreferencesForUnitSelectionQuery, GetUserPreferencesForUnitSelectionQueryVariables>;
export const UpdatePreferencesDocument = gql`
    mutation UpdatePreferences($input: UpdateUserPreferencesInput) {
  updateUserPreferences(input: $input) {
    preferences {
      unit
    }
  }
}
    `;
export type UpdatePreferencesMutationFn = Apollo.MutationFunction<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>;

/**
 * __useUpdatePreferencesMutation__
 *
 * To run a mutation, you first call `useUpdatePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePreferencesMutation, { data, loading, error }] = useUpdatePreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>(UpdatePreferencesDocument, options);
      }
export type UpdatePreferencesMutationHookResult = ReturnType<typeof useUpdatePreferencesMutation>;
export type UpdatePreferencesMutationResult = Apollo.MutationResult<UpdatePreferencesMutation>;
export type UpdatePreferencesMutationOptions = Apollo.BaseMutationOptions<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>;
export const LocationDocument = gql`
    query location($locationId: String) {
  location(locationId: $locationId) {
    id
    deck {
      id
      name
      resourcePath
    }
    name
    depthResourcePath
    depthResource
    resourcePath
    resource
    deckPlan {
      id
      coordinates
    }
  }
}
    `;

/**
 * __useLocationQuery__
 *
 * To run a query within a React component, call `useLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useLocationQuery(baseOptions?: Apollo.QueryHookOptions<LocationQuery, LocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
      }
export function useLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export function useLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export type LocationQueryHookResult = ReturnType<typeof useLocationQuery>;
export type LocationLazyQueryHookResult = ReturnType<typeof useLocationLazyQuery>;
export type LocationSuspenseQueryHookResult = ReturnType<typeof useLocationSuspenseQuery>;
export type LocationQueryResult = Apollo.QueryResult<LocationQuery, LocationQueryVariables>;
export const GroupedReportsDocument = gql`
    query GroupedReports($input: reportsInput) {
  groupedReports(input: $input) {
    groupName
    groupId
    count
  }
}
    `;

/**
 * __useGroupedReportsQuery__
 *
 * To run a query within a React component, call `useGroupedReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupedReportsQuery(baseOptions?: Apollo.QueryHookOptions<GroupedReportsQuery, GroupedReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedReportsQuery, GroupedReportsQueryVariables>(GroupedReportsDocument, options);
      }
export function useGroupedReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedReportsQuery, GroupedReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedReportsQuery, GroupedReportsQueryVariables>(GroupedReportsDocument, options);
        }
export function useGroupedReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupedReportsQuery, GroupedReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupedReportsQuery, GroupedReportsQueryVariables>(GroupedReportsDocument, options);
        }
export type GroupedReportsQueryHookResult = ReturnType<typeof useGroupedReportsQuery>;
export type GroupedReportsLazyQueryHookResult = ReturnType<typeof useGroupedReportsLazyQuery>;
export type GroupedReportsSuspenseQueryHookResult = ReturnType<typeof useGroupedReportsSuspenseQuery>;
export type GroupedReportsQueryResult = Apollo.QueryResult<GroupedReportsQuery, GroupedReportsQueryVariables>;
export const CreateNewReportDocument = gql`
    mutation createNewReport($input: createNewReportInput) {
  createNewReport(input: $input) {
    createdAt
    id
    name
    status
    dueDate
    actionStatus
    type
    workpackNumber
  }
}
    `;
export type CreateNewReportMutationFn = Apollo.MutationFunction<CreateNewReportMutation, CreateNewReportMutationVariables>;

/**
 * __useCreateNewReportMutation__
 *
 * To run a mutation, you first call `useCreateNewReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewReportMutation, { data, loading, error }] = useCreateNewReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewReportMutation, CreateNewReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewReportMutation, CreateNewReportMutationVariables>(CreateNewReportDocument, options);
      }
export type CreateNewReportMutationHookResult = ReturnType<typeof useCreateNewReportMutation>;
export type CreateNewReportMutationResult = Apollo.MutationResult<CreateNewReportMutation>;
export type CreateNewReportMutationOptions = Apollo.BaseMutationOptions<CreateNewReportMutation, CreateNewReportMutationVariables>;
export const CreateBulkReportsDocument = gql`
    mutation CreateBulkReports($input: createNewReportInput) {
  createBulkReports(input: $input) {
    createdAt
    id
    name
    status
    dueDate
    actionStatus
    type
    workpackNumber
  }
}
    `;
export type CreateBulkReportsMutationFn = Apollo.MutationFunction<CreateBulkReportsMutation, CreateBulkReportsMutationVariables>;

/**
 * __useCreateBulkReportsMutation__
 *
 * To run a mutation, you first call `useCreateBulkReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkReportsMutation, { data, loading, error }] = useCreateBulkReportsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBulkReportsMutation(baseOptions?: Apollo.MutationHookOptions<CreateBulkReportsMutation, CreateBulkReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBulkReportsMutation, CreateBulkReportsMutationVariables>(CreateBulkReportsDocument, options);
      }
export type CreateBulkReportsMutationHookResult = ReturnType<typeof useCreateBulkReportsMutation>;
export type CreateBulkReportsMutationResult = Apollo.MutationResult<CreateBulkReportsMutation>;
export type CreateBulkReportsMutationOptions = Apollo.BaseMutationOptions<CreateBulkReportsMutation, CreateBulkReportsMutationVariables>;
export const GeneratePoiPdfDocument = gql`
    mutation generatePoiPdf($reportIds: [ID!]) {
  generatePoiPdf(reportIds: $reportIds) {
    base64Data
  }
}
    `;
export type GeneratePoiPdfMutationFn = Apollo.MutationFunction<GeneratePoiPdfMutation, GeneratePoiPdfMutationVariables>;

/**
 * __useGeneratePoiPdfMutation__
 *
 * To run a mutation, you first call `useGeneratePoiPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePoiPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePoiPdfMutation, { data, loading, error }] = useGeneratePoiPdfMutation({
 *   variables: {
 *      reportIds: // value for 'reportIds'
 *   },
 * });
 */
export function useGeneratePoiPdfMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePoiPdfMutation, GeneratePoiPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePoiPdfMutation, GeneratePoiPdfMutationVariables>(GeneratePoiPdfDocument, options);
      }
export type GeneratePoiPdfMutationHookResult = ReturnType<typeof useGeneratePoiPdfMutation>;
export type GeneratePoiPdfMutationResult = Apollo.MutationResult<GeneratePoiPdfMutation>;
export type GeneratePoiPdfMutationOptions = Apollo.BaseMutationOptions<GeneratePoiPdfMutation, GeneratePoiPdfMutationVariables>;
export const FilteredOptionsDocument = gql`
    query FilteredOptions($templateId: ID!, $fieldKey: String!, $fieldId: ID, $q: String, $count: Int, $skip: Int, $limit: Int) {
  filteredOptions(
    templateId: $templateId
    fieldKey: $fieldKey
    fieldId: $fieldId
    q: $q
    count: $count
    skip: $skip
    limit: $limit
  ) {
    options
  }
}
    `;

/**
 * __useFilteredOptionsQuery__
 *
 * To run a query within a React component, call `useFilteredOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredOptionsQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      fieldKey: // value for 'fieldKey'
 *      fieldId: // value for 'fieldId'
 *      q: // value for 'q'
 *      count: // value for 'count'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFilteredOptionsQuery(baseOptions: Apollo.QueryHookOptions<FilteredOptionsQuery, FilteredOptionsQueryVariables> & ({ variables: FilteredOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredOptionsQuery, FilteredOptionsQueryVariables>(FilteredOptionsDocument, options);
      }
export function useFilteredOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredOptionsQuery, FilteredOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredOptionsQuery, FilteredOptionsQueryVariables>(FilteredOptionsDocument, options);
        }
export function useFilteredOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilteredOptionsQuery, FilteredOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilteredOptionsQuery, FilteredOptionsQueryVariables>(FilteredOptionsDocument, options);
        }
export type FilteredOptionsQueryHookResult = ReturnType<typeof useFilteredOptionsQuery>;
export type FilteredOptionsLazyQueryHookResult = ReturnType<typeof useFilteredOptionsLazyQuery>;
export type FilteredOptionsSuspenseQueryHookResult = ReturnType<typeof useFilteredOptionsSuspenseQuery>;
export type FilteredOptionsQueryResult = Apollo.QueryResult<FilteredOptionsQuery, FilteredOptionsQueryVariables>;
export const AllPaintRegionsForFilterAndSearchPanelDocument = gql`
    query AllPaintRegionsForFilterAndSearchPanel($structureId: ID, $deckIds: [String]) {
  allPaintRegions(structureId: $structureId, deckIds: $deckIds) {
    id
    name
    paintRegionGroupId
  }
}
    `;

/**
 * __useAllPaintRegionsForFilterAndSearchPanelQuery__
 *
 * To run a query within a React component, call `useAllPaintRegionsForFilterAndSearchPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPaintRegionsForFilterAndSearchPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaintRegionsForFilterAndSearchPanelQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      deckIds: // value for 'deckIds'
 *   },
 * });
 */
export function useAllPaintRegionsForFilterAndSearchPanelQuery(baseOptions?: Apollo.QueryHookOptions<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>(AllPaintRegionsForFilterAndSearchPanelDocument, options);
      }
export function useAllPaintRegionsForFilterAndSearchPanelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>(AllPaintRegionsForFilterAndSearchPanelDocument, options);
        }
export function useAllPaintRegionsForFilterAndSearchPanelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>(AllPaintRegionsForFilterAndSearchPanelDocument, options);
        }
export type AllPaintRegionsForFilterAndSearchPanelQueryHookResult = ReturnType<typeof useAllPaintRegionsForFilterAndSearchPanelQuery>;
export type AllPaintRegionsForFilterAndSearchPanelLazyQueryHookResult = ReturnType<typeof useAllPaintRegionsForFilterAndSearchPanelLazyQuery>;
export type AllPaintRegionsForFilterAndSearchPanelSuspenseQueryHookResult = ReturnType<typeof useAllPaintRegionsForFilterAndSearchPanelSuspenseQuery>;
export type AllPaintRegionsForFilterAndSearchPanelQueryResult = Apollo.QueryResult<AllPaintRegionsForFilterAndSearchPanelQuery, AllPaintRegionsForFilterAndSearchPanelQueryVariables>;
export const GetVersionsDocument = gql`
    query GetVersions($input: VersionInput) {
  allVersions(input: $input) {
    id
    structureId
    referenceId
    updatedData
    previousData
    collectionName
    lastModifiedFor
    lastModifiedBy
    lastModifiedByUser {
      id
      name
      picture
      email
      connection
      roleIds {
        name
        auth0Id
        id
      }
    }
    createdAt
  }
}
    `;

/**
 * __useGetVersionsQuery__
 *
 * To run a query within a React component, call `useGetVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVersionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVersionsQuery(baseOptions?: Apollo.QueryHookOptions<GetVersionsQuery, GetVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVersionsQuery, GetVersionsQueryVariables>(GetVersionsDocument, options);
      }
export function useGetVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVersionsQuery, GetVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVersionsQuery, GetVersionsQueryVariables>(GetVersionsDocument, options);
        }
export function useGetVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVersionsQuery, GetVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVersionsQuery, GetVersionsQueryVariables>(GetVersionsDocument, options);
        }
export type GetVersionsQueryHookResult = ReturnType<typeof useGetVersionsQuery>;
export type GetVersionsLazyQueryHookResult = ReturnType<typeof useGetVersionsLazyQuery>;
export type GetVersionsSuspenseQueryHookResult = ReturnType<typeof useGetVersionsSuspenseQuery>;
export type GetVersionsQueryResult = Apollo.QueryResult<GetVersionsQuery, GetVersionsQueryVariables>;
export const RollbackVersionDocument = gql`
    mutation RollbackVersion($input: RollbackVersionInput) {
  rollbackVersion(input: $input) {
    id
  }
}
    `;
export type RollbackVersionMutationFn = Apollo.MutationFunction<RollbackVersionMutation, RollbackVersionMutationVariables>;

/**
 * __useRollbackVersionMutation__
 *
 * To run a mutation, you first call `useRollbackVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollbackVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollbackVersionMutation, { data, loading, error }] = useRollbackVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRollbackVersionMutation(baseOptions?: Apollo.MutationHookOptions<RollbackVersionMutation, RollbackVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RollbackVersionMutation, RollbackVersionMutationVariables>(RollbackVersionDocument, options);
      }
export type RollbackVersionMutationHookResult = ReturnType<typeof useRollbackVersionMutation>;
export type RollbackVersionMutationResult = Apollo.MutationResult<RollbackVersionMutation>;
export type RollbackVersionMutationOptions = Apollo.BaseMutationOptions<RollbackVersionMutation, RollbackVersionMutationVariables>;